const area_city = ["台北市", "基隆市", "新北市", "桃園市", "新竹市", "新竹縣", "苗栗縣", "台中市", "台中縣", "彰化縣", "南投縣", "雲林縣", "嘉義市", "嘉義縣", "台南市", "台南縣", "高雄市", "高雄縣", "屏東縣", "宜蘭縣", "花蓮縣", "台東縣", "澎湖縣", "連江縣", "金門縣", ];
const area_district = [["松山區", "信義區", "大安區", "中山區", "中正區", "大同區", "萬華區", "文山區", "南港區", "內湖區", "士林區", "北投區", ], ["中正區", "七堵區", "暖暖區", "安樂區", "中山區", "仁愛區", "信義區", ], ["板橋區", "三重區", "中和區", "永和區", "新莊區", "新店區", "樹林區", "土城區", "蘆洲區", "汐止區", "鶯歌區", "三峽區", "淡水區", "瑞芳區", "五股區", "泰山區", "林口區", "深坑區", "石碇區", "坪林區", "三芝區", "石門區", "八里區", "平溪區", "雙溪區", "貢寮區", "金山區", "萬里區", "烏來區", ], ["桃園區", "中壢區", "八德區", "平鎮區", "龜山區", "大溪區", "楊梅區", "蘆竹區", "大園區", "龍潭區", "新屋區", "觀音區", ], ["東區", "北區", "香山區", ], ["竹北市", "竹東鎮", "新埔鎮", "關西鎮", "湖口鄉", "新豐鄉", "芎林鄉", "橫山鄉", "北埔鄉", "寶山鄉", ], ["苗栗市", "竹南鎮", "後龍鎮", "頭份市", "造橋鄉", "三灣鄉", "頭屋鄉", "南庄鄉", "公館鄉", "通霄鎮", "苑裡鎮", "銅鑼鄉", "大湖鄉", "三義鄉", "卓蘭鎮", ], ["豐原區", "中區", "大里區", "東區", "南區", "太平區", "和平區", "西區", "北區", "東勢區", "后里區", "西屯區", "外埔區", "南屯區", "北屯區", "大甲區", "大安區", "清水區", "神岡區", "石岡區", "新社區", "梧棲區", "沙鹿區", "大雅區", "潭子區", "龍井區", "大肚區", "烏日區", "霧峰區", ], [], ["彰化市", "鹿港鎮", "伸港鄉", "線西鄉", "秀水鄉", "花壇鄉", "芬園鄉", "福興鄉", "埔鹽鄉", "大村鄉", "員林市", "埔心鄉", "溪湖鎮", "芳苑鄉", "二林鎮", "埤頭鄉", "田尾鄉", "永靖鄉", "社頭鄉", "田中鎮", "北斗鎮", "二水鄉", "溪州鄉", "竹塘鄉", "大城鄉", "和美鎮", ], ["南投市", "埔里鎮", "草屯鎮", "竹山鎮", "集集鎮", "名間鄉", "鹿谷鄉", "魚池鄉", "國姓鄉", "水里鄉", "信義鄉", "仁愛鄉", ], ["斗六市", "斗南鎮", "虎尾鎮", "西螺鎮", "土庫鎮", "北港鎮", "口湖鄉", "麥寮鄉", "崙背鄉", "二崙鄉", "莿桐鄉", "林內鄉", "古坑鄉", "大埤鄉", "褒忠鄉", "元長鄉", "東勢鄉", "台西鄉", "四湖鄉", "水林鄉", ], ["東區", "西區", ], ["太保市", "朴子市", "布袋鎮", "大林鎮", "民雄鄉", "溪口鄉", "新港鄉", "六腳鄉", "東石鄉", "義竹鄉", "鹿草鄉", "水上鄉", "中埔鄉", "竹崎鄉", "梅山鄉", "番路鄉", "大埔鄉", "阿里山鄉", ], ["新營區", "安南區", "安平區", "永康區", "北區", "白河區", "中西區", "鹽水區", "南區", "柳營區", "東區", "後壁區", "東山區", "北門區", "學甲區", "下營區", "六甲區", "楠西區", "將軍區", "佳里區", "麻豆區", "官田區", "大內區", "玉井區", "南化區", "七股區", "西港區", "安定區", "善化區", "新市區", "山上區", "新化區", "關廟區", "歸仁區", "仁德區", ], [], ["鳳山區", "鹽埕區", "鼓山區", "林園區", "大寮區", "左營區", "大樹區", "楠梓區", "三民區", "大社區", "新興區", "仁武區", "鳥松區", "前金區", "岡山區", "苓雅區", "橋頭區", "前鎮區", "燕巢區", "旗津區", "小港區", "阿蓮區", "路竹區", "湖內區", "茄萣區", "永安區", "彌陀區", "梓官區", "旗山區", "美濃區", "六龜區", "甲仙區", "杉林區", "內門區", ], [], ["屏東市", "潮州鎮", "東港鎮", "恆春鎮", "萬丹鄉", "長治鄉", "麟洛鄉", "九如鄉", "里港鄉", "鹽埔鄉", "高樹鄉", "萬巒鄉", "內埔鄉", "竹田鄉", "新埤鄉", "枋寮鄉", "新園鄉", "林邊鄉", "南州鄉", "佳冬鄉", "琉球鄉", "車城鄉", "滿州鄉", "枋山鄉", "三地門鄉", "春日鄉", ], ["宜蘭市", "羅東鎮", "蘇澳鎮", "頭城鎮", "礁溪鄉", "壯圍鄉", "員山鄉", "冬山鄉", "五結鄉", "三星鄉", "南澳鄉", ], ["花蓮市", "鳳林鎮", "玉里鎮", "新城鄉", "吉安鄉", "壽豐鄉", "光復鄉", "豐濱鄉", "瑞穗鄉", "富里鄉", "秀林鄉", ], ["台東市", "成功鎮", "關山鎮", "卑南鄉", "鹿野鄉", "池上鄉", "東河鄉", "長濱鄉", "太麻里鄉", "大武鄉", "綠島鄉", "達仁鄉", "蘭嶼鄉", ], ["馬公市", "湖西鄉", "白沙鄉", "西嶼鄉", "七美鄉", ], ["南竿鄉", "北竿鄉", "東引鄉", ], ["金湖鎮", "金沙鎮", "金城鎮", "金寧鄉", "烈嶼鄉", ], ];
const area_store = [[[{
    "POIID": "170945",
    "POIName": "上弘",
    "Telno": "(02)25472928",
    "Address": "台北市松山區敦化北路168號B2"
}, {
    "POIID": "167352",
    "POIName": "小巨蛋",
    "Telno": "(02)25774236",
    "Address": "台北市松山區南京東路四段2號"
}, {
    "POIID": "960661",
    "POIName": "中崙",
    "Telno": "(02)25774806",
    "Address": "台北市松山區八德路3段27號"
}, {
    "POIID": "158923",
    "POIName": "北體",
    "Telno": "(02)25771113",
    "Address": "台北市松山區北寧路66號"
}, {
    "POIID": "159340",
    "POIName": "台場",
    "Telno": "(02)25794824",
    "Address": "台北市松山區八德路三段20-2號"
}, {
    "POIID": "138583",
    "POIName": "市大",
    "Telno": "(02)87710481",
    "Address": "台北市松山區市民大道路四段105號"
}, {
    "POIID": "961295",
    "POIName": "民有",
    "Telno": "(02)27154294",
    "Address": "台北市松山區民權東路3段108號"
}, {
    "POIID": "185707",
    "POIName": "民復",
    "Telno": "(02)25140673",
    "Address": "台北市松山區民生東路四段130號"
}, {
    "POIID": "166832",
    "POIName": "吉仁",
    "Telno": "(02)25793557",
    "Address": "台北市松山區延吉街27-1號1樓"
}, {
    "POIID": "185682",
    "POIName": "吉盛",
    "Telno": "(02)27479591",
    "Address": "台北市松山區南京東路5段66巷3弄1號1樓"
}, {
    "POIID": "166706",
    "POIName": "京育",
    "Telno": "(02)25794292",
    "Address": "台北市松山區南京東路四段52巷1號1樓"
}, {
    "POIID": "167477",
    "POIName": "京東",
    "Telno": "(02)27656132",
    "Address": "台北市松山區南京東路五段16號1樓"
}, {
    "POIID": "183011",
    "POIName": "京城",
    "Telno": "(02)25474817",
    "Address": "台北市松山區南京東路四段75之2號1樓"
}, {
    "POIID": "190064",
    "POIName": "京復",
    "Telno": "(02)27425644",
    "Address": "台北市松山區光復北路11巷44號"
}, {
    "POIID": "991551",
    "POIName": "京發",
    "Telno": "(02)37652632",
    "Address": "台北市松山區南京東路五段139之4及139之8號"
}, {
    "POIID": "161402",
    "POIName": "延新",
    "Telno": "(02)87873357",
    "Address": "台北市松山區延壽街99號1樓"
}, {
    "POIID": "173988",
    "POIName": "延壽",
    "Telno": "(02)27622884",
    "Address": "台北市松山區延壽街422號"
}, {
    "POIID": "140276",
    "POIName": "征東",
    "Telno": "(02)27534174",
    "Address": "台北市松山區新東街15巷1號"
}, {
    "POIID": "187806",
    "POIName": "征唐",
    "Telno": "(02)27616499",
    "Address": "台北市松山區新東街41-7號"
}, {
    "POIID": "135089",
    "POIName": "明塑",
    "Telno": "(02)27187590",
    "Address": "台北市松山區民生東路4段54號之2一樓"
}, {
    "POIID": "174006",
    "POIName": "東光",
    "Telno": "(02)37651082",
    "Address": "台北市松山區南京東路5段15號1樓"
}, {
    "POIID": "148579",
    "POIName": "東吉",
    "Telno": "(02)27622908",
    "Address": "台北市松山區民生東路五段100號"
}, {
    "POIID": "165068",
    "POIName": "東復",
    "Telno": "(02)25472325",
    "Address": "台北市松山區復興北路313巷25號"
}, {
    "POIID": "160074",
    "POIName": "東勢",
    "Telno": "(02)25456294",
    "Address": "台北市松山區南京東路4段133巷6弄1號"
}, {
    "POIID": "896241",
    "POIName": "東榮",
    "Telno": "(02)27622216",
    "Address": "台北市松山區民生東路5段65號"
}, {
    "POIID": "164803",
    "POIName": "東鑫",
    "Telno": "(02)27196327",
    "Address": "台北市松山區民生東路4段55巷10號"
}, {
    "POIID": "188681",
    "POIName": "松民",
    "Telno": "(02)27480323",
    "Address": "台北市松山區三民路10號"
}, {
    "POIID": "990352",
    "POIName": "松禾",
    "Telno": "(02)37651361",
    "Address": "台北市松山區塔悠路31號33號"
}, {
    "POIID": "135643",
    "POIName": "松航",
    "Telno": "(02)25454821",
    "Address": "台北市松山區敦化北路340-9號"
}, {
    "POIID": "181680",
    "POIName": "松慶",
    "Telno": "(02)25450149",
    "Address": "台北市松山區慶城街1號1樓"
}, {
    "POIID": "181185",
    "POIName": "松機",
    "Telno": "(02)25461584",
    "Address": "台北市松山區敦化北路340之10號1樓"
}, {
    "POIID": "883223",
    "POIName": "松饒",
    "Telno": "(02)27475146",
    "Address": "台北市松山區慈祐里八德路4段767號769號"
}, {
    "POIID": "170152",
    "POIName": "松鑽",
    "Telno": "(02)27457876",
    "Address": "台北市松山區八德路四段686號"
}, {
    "POIID": "189710",
    "POIName": "長塑",
    "Telno": "(02)25148851",
    "Address": "台北市松山區敦化北路199巷2弄9號1樓"
}, {
    "POIID": "961055",
    "POIName": "南京",
    "Telno": "(02)25466532",
    "Address": "台北市松山區南京東路3段303巷5號"
}, {
    "POIID": "975906",
    "POIName": "威京",
    "Telno": "(02)27564116",
    "Address": "台北市松山區八德路四段151號"
}, {
    "POIID": "902908",
    "POIName": "風復",
    "Telno": "(02)27110868",
    "Address": "台北市松山區復興南路1段43號"
}, {
    "POIID": "164179",
    "POIName": "首都",
    "Telno": "(02)25453085",
    "Address": "台北市松山區南京東路4段51號之2"
}, {
    "POIID": "175043",
    "POIName": "庫德",
    "Telno": "(02)87719076",
    "Address": "台北市松山區八德路2段366巷7號1樓"
}, {
    "POIID": "141992",
    "POIName": "健一",
    "Telno": "(02)25149369",
    "Address": "台北市松山區健康路11號"
}, {
    "POIID": "173531",
    "POIName": "婦聯",
    "Telno": "(02)27609484",
    "Address": "台北市松山區健康路224號"
}, {
    "POIID": "916527",
    "POIName": "清愿",
    "Telno": "(02)27729274",
    "Address": "台北市松山區八德路2段439號"
}, {
    "POIID": "171421",
    "POIName": "統威",
    "Telno": "(02)27481762",
    "Address": "台北市松山區東興路13之1號"
}, {
    "POIID": "186168",
    "POIName": "通盈",
    "Telno": "(02)27604390",
    "Address": "台北市松山區南京東路五段315號"
}, {
    "POIID": "915270",
    "POIName": "復旦",
    "Telno": "(02)25777873",
    "Address": "台北市松山區敦化南路1段5號"
}, {
    "POIID": "170657",
    "POIName": "復安",
    "Telno": "(02)27127923",
    "Address": "台北市松山區民生東路三段130巷2之1號1樓"
}, {
    "POIID": "184782",
    "POIName": "復春",
    "Telno": "(02)27151190",
    "Address": "台北市松山區復興北路179號"
}, {
    "POIID": "142755",
    "POIName": "敦化",
    "Telno": "(02)87129627",
    "Address": "台北市松山區民權東路三段160巷9號1樓"
}, {
    "POIID": "114554",
    "POIName": "敦北",
    "Telno": "(02)25472052",
    "Address": "台北市松山區敦化北路149號1樓"
}, {
    "POIID": "164445",
    "POIName": "朝福",
    "Telno": "(02)37652976",
    "Address": "台北市松山區三民路115號"
}, {
    "POIID": "112684",
    "POIName": "塔優",
    "Telno": "(02)27648499",
    "Address": "台北市松山區撫遠街197號199號"
}, {
    "POIID": "165976",
    "POIName": "新育商",
    "Telno": "(02)25774269",
    "Address": "台北市松山區寧安街3巷11號1樓"
}, {
    "POIID": "990673",
    "POIName": "新復勢",
    "Telno": "(02)25785350",
    "Address": "台北市松山區八德路三段200號202號1樓"
}, {
    "POIID": "171638",
    "POIName": "新寶清",
    "Telno": "(02)27624852",
    "Address": "台北市松山區南京東路五段334號336號1樓"
}, {
    "POIID": "185165",
    "POIName": "新饒河",
    "Telno": "(02)27632434",
    "Address": "台北市松山區八德路四段697號1樓"
}, {
    "POIID": "135610",
    "POIName": "福源",
    "Telno": "(02)27649672",
    "Address": "台北市松山區新東街60巷16號18號1樓"
}, {
    "POIID": "164618",
    "POIName": "影城",
    "Telno": "(02)27634585",
    "Address": "台北市松山區八德路四段245巷35號"
}, {
    "POIID": "906209",
    "POIName": "樂得",
    "Telno": "(02)27401886",
    "Address": "台北市松山區復興北路35號"
}, {
    "POIID": "131593",
    "POIName": "錢京",
    "Telno": "(02)27177520",
    "Address": "台北市松山區敦化北路100號1樓"
}, {
    "POIID": "151542",
    "POIName": "聰明",
    "Telno": "(02)87874670",
    "Address": "台北市松山區寶清街34號1樓"
}, {
    "POIID": "190363",
    "POIName": "寶德",
    "Telno": "(02)27476621",
    "Address": "台北市松山區八德路四段321號"
}, {
    "POIID": "190145",
    "POIName": "鑫壽",
    "Telno": "(02)27694858",
    "Address": "台北市松山區延壽街323號"
}, ], [{
    "POIID": "167651",
    "POIName": "一零一",
    "Telno": "(02)27222342",
    "Address": "台北市信義區信義路五段7號35樓"
}, {
    "POIID": "149697",
    "POIName": "三興",
    "Telno": "(02)27335027",
    "Address": "台北市信義區吳興街156巷2弄2號4號1樓"
}, {
    "POIID": "128542",
    "POIName": "中興",
    "Telno": "(02)27586997",
    "Address": "台北市信義區基隆路2段22號"
}, {
    "POIID": "151335",
    "POIName": "仁和",
    "Telno": "(02)87891891",
    "Address": "台北市信義區正和里光復南路419巷41號"
}, {
    "POIID": "170738",
    "POIName": "北府",
    "Telno": "(02)27586295",
    "Address": "台北市信義區松仁路162號164號1樓"
}, {
    "POIID": "978798",
    "POIName": "北醫",
    "Telno": "(02)27325119",
    "Address": "台北市信義區吳興街252號"
}, {
    "POIID": "153216",
    "POIName": "北醫大",
    "Telno": "(02)27393090",
    "Address": "台北市信義區吳興街250號1樓"
}, {
    "POIID": "153294",
    "POIName": "台金",
    "Telno": "(02)81018195",
    "Address": "台北市信義區市府路45號B1之53"
}, {
    "POIID": "990721",
    "POIName": "市捷",
    "Telno": "(02)23453310",
    "Address": "台北市信義區忠孝東路五段6號1樓"
}, {
    "POIID": "190330",
    "POIName": "必成",
    "Telno": "(02)27640912",
    "Address": "台北市信義區基隆路1段178號180號1樓"
}, {
    "POIID": "135241",
    "POIName": "永信",
    "Telno": "(02)27469874",
    "Address": "台北市信義區永吉路30巷103號"
}, {
    "POIID": "930637",
    "POIName": "光東",
    "Telno": "(02)23467948",
    "Address": "台北市信義區忠孝東路五段524巷1弄1號"
}, {
    "POIID": "136716",
    "POIName": "光復",
    "Telno": "(02)27290723",
    "Address": "台北市信義區光復南路471號"
}, {
    "POIID": "164490",
    "POIName": "吳興",
    "Telno": "(02)27388391",
    "Address": "台北市信義區吳興街284巷18弄2號"
}, {
    "POIID": "981901",
    "POIName": "宏泰",
    "Telno": "(02)87804531",
    "Address": "台北市信義區松仁路91-1號1樓"
}, {
    "POIID": "144315",
    "POIName": "忠林",
    "Telno": "(02)87893751",
    "Address": "台北市信義區忠孝東路五段470號1樓"
}, {
    "POIID": "185143",
    "POIName": "昌隆",
    "Telno": "(02)87323266",
    "Address": "台北市信義區基隆路二段131-4號"
}, {
    "POIID": "127723",
    "POIName": "東暉",
    "Telno": "(02)27205019",
    "Address": "台北市信義區忠孝東路4段514號"
}, {
    "POIID": "118970",
    "POIName": "松山",
    "Telno": "(02)27229915",
    "Address": "台北市信義區忠孝東路5段386號"
}, {
    "POIID": "906564",
    "POIName": "松仁",
    "Telno": "(02)27299057",
    "Address": "台北市信義區松仁路213號"
}, {
    "POIID": "155061",
    "POIName": "松信",
    "Telno": "(02)27656147",
    "Address": "台北市信義區松信路148號1樓"
}, {
    "POIID": "991702",
    "POIName": "松家",
    "Telno": "(02)27263426",
    "Address": "台北市信義區松山路608號610號"
}, {
    "POIID": "136783",
    "POIName": "松泰",
    "Telno": "(02)27475337",
    "Address": "台北市信義區松山路11號1樓"
}, {
    "POIID": "993041",
    "POIName": "松高",
    "Telno": "(02)27670810",
    "Address": "台北市信義區基隆路1段141號1樓"
}, {
    "POIID": "135425",
    "POIName": "松捷",
    "Telno": "(02)27638813",
    "Address": "台北市信義區忠孝東路五段1之6號"
}, {
    "POIID": "174970",
    "POIName": "松智",
    "Telno": "(02)27206585",
    "Address": "台北市信義區莊敬路325巷43號"
}, {
    "POIID": "147299",
    "POIName": "松義",
    "Telno": "(02)27274474",
    "Address": "台北市信義區松德路271號"
}, {
    "POIID": "159269",
    "POIName": "松錢",
    "Telno": "(02)27658380",
    "Address": "台北市信義區松隆路192號194號1樓"
}, {
    "POIID": "188094",
    "POIName": "信吉",
    "Telno": "(02)27569832",
    "Address": "台北市信義區永吉路278巷58弄2號"
}, {
    "POIID": "158738",
    "POIName": "信林",
    "Telno": "(02)27278220",
    "Address": "台北市信義區虎林街222巷7號9號1樓"
}, {
    "POIID": "119054",
    "POIName": "信運",
    "Telno": "(02)27206815",
    "Address": "台北市信義區松勤街100號1樓"
}, {
    "POIID": "965194",
    "POIName": "信嘉",
    "Telno": "(02)27325703",
    "Address": "台北市信義區嘉興街181巷21號"
}, {
    "POIID": "186065",
    "POIName": "信福",
    "Telno": "(02)27273047",
    "Address": "台北市信義區福德街308號310巷1號"
}, {
    "POIID": "190259",
    "POIName": "信德",
    "Telno": "(02)23455160",
    "Address": "台北市信義區松德路200巷10號"
}, {
    "POIID": "970901",
    "POIName": "信醫",
    "Telno": "(02)27229305",
    "Address": "台北市信義區吳興街346號348號"
}, {
    "POIID": "961974",
    "POIName": "革新",
    "Telno": "(02)27688917",
    "Address": "台北市信義區永吉路32號"
}, {
    "POIID": "854580",
    "POIName": "留公",
    "Telno": "(02)27591442",
    "Address": "台北市信義區福德街249號"
}, {
    "POIID": "165987",
    "POIName": "國貿",
    "Telno": "(02)27576752",
    "Address": "台北市信義區基隆路一段333號B3"
}, {
    "POIID": "122212",
    "POIName": "崇德",
    "Telno": "(02)87324275",
    "Address": "台北市信義區崇德街104號106號1樓"
}, {
    "POIID": "161376",
    "POIName": "捷忠",
    "Telno": "(02)87856027",
    "Address": "台北市信義區忠孝東路5段617號"
}, {
    "POIID": "135012",
    "POIName": "統誠",
    "Telno": "(02)27226519",
    "Address": "台北市信義區松高路11號B2樓"
}, {
    "POIID": "164216",
    "POIName": "凱悅",
    "Telno": "(02)87864836",
    "Address": "台北市信義區基隆路一段398號1樓"
}, {
    "POIID": "120515",
    "POIName": "喬治",
    "Telno": "(02)27329619",
    "Address": "台北市信義區基隆路二段155號1樓"
}, {
    "POIID": "961000",
    "POIName": "惠安",
    "Telno": "(02)27582394",
    "Address": "台北市信義區惠安里吳興街520號"
}, {
    "POIID": "130132",
    "POIName": "敦厚",
    "Telno": "(02)27677884",
    "Address": "台北市信義區永吉路30巷168弄1號1樓"
}, {
    "POIID": "135942",
    "POIName": "萊福",
    "Telno": "(02)27279541",
    "Address": "台北市信義區林口街48號"
}, {
    "POIID": "170141",
    "POIName": "開源",
    "Telno": "(02)27627486",
    "Address": "台北市信義區松山路136號138號"
}, {
    "POIID": "121079",
    "POIName": "新三連",
    "Telno": "(02)87891461",
    "Address": "台北市信義區逸仙路42巷25號1樓"
}, {
    "POIID": "128036",
    "POIName": "新工農",
    "Telno": "(02)23456634",
    "Address": "台北市信義區忠孝東路5段236巷6-3號8號1樓"
}, {
    "POIID": "144636",
    "POIName": "新光",
    "Telno": "(02)27225705",
    "Address": "台北市信義區松高路12號B1樓"
}, {
    "POIID": "975607",
    "POIName": "新東宮",
    "Telno": "(02)23466878",
    "Address": "台北市信義區松山路455號"
}, {
    "POIID": "870504",
    "POIName": "道生",
    "Telno": "(02)87682914",
    "Address": "台北市信義區新仁里東興路57號"
}, {
    "POIID": "988016",
    "POIName": "嘉馥",
    "Telno": "(02)27592619",
    "Address": "台北市信義區信義路6段11號"
}, {
    "POIID": "120353",
    "POIName": "福中",
    "Telno": "(02)27266631",
    "Address": "台北市信義區福德街159號161號1樓"
}, {
    "POIID": "144669",
    "POIName": "德鄰",
    "Telno": "(02)27272819",
    "Address": "台北市信義區松德路127號129號1樓"
}, {
    "POIID": "963556",
    "POIName": "興貿",
    "Telno": "(02)87867692",
    "Address": "台北市信義區景新里莊敬路178巷2號"
}, {
    "POIID": "162483",
    "POIName": "總站",
    "Telno": "(02)27585386",
    "Address": "台北市信義區吳興街486號488號1樓"
}, {
    "POIID": "122186",
    "POIName": "總部",
    "Telno": "(02)87874502",
    "Address": "台北市信義區東興路67號1樓"
}, {
    "POIID": "184575",
    "POIName": "聯合",
    "Telno": "(02)27663728",
    "Address": "台北市信義區忠孝東路四段559巷6號"
}, {
    "POIID": "119478",
    "POIName": "醫學",
    "Telno": "(02)87803729",
    "Address": "台北市信義區吳興街257號259號"
}, {
    "POIID": "135562",
    "POIName": "麟運",
    "Telno": "(02)87327894",
    "Address": "台北市信義區和平東路3段461號1樓"
}, {
    "POIID": "174534",
    "POIName": "鑫吉",
    "Telno": "(02)87874152",
    "Address": "台北市信義區虎林街85號"
}, {
    "POIID": "181912",
    "POIName": "鑫國泰",
    "Telno": "(02)27227334",
    "Address": "台北市信義區忠孝東路5段68號24樓"
}, ], [{
    "POIID": "153319",
    "POIName": "大台",
    "Telno": "(02)23636229",
    "Address": "台北市大安區羅斯福路3段283巷14弄16號1樓"
}, {
    "POIID": "921633",
    "POIName": "大信",
    "Telno": "(02)27096471",
    "Address": "台北市大安區信義路三段33號"
}, {
    "POIID": "184586",
    "POIName": "大敦",
    "Telno": "(02)27045633",
    "Address": "台北市大安區敦化南路二段63巷7號1樓"
}, {
    "POIID": "175032",
    "POIName": "中廣",
    "Telno": "(02)27526751",
    "Address": "台北市大安區仁愛路三段25-1號27號"
}, {
    "POIID": "975962",
    "POIName": "仁安",
    "Telno": "(02)87732749",
    "Address": "台北市大安區仁愛路四段27巷1號"
}, {
    "POIID": "977359",
    "POIName": "仕吉",
    "Telno": "(02)87730907",
    "Address": "台北市大安區忠孝東路4段223巷42號"
}, {
    "POIID": "946883",
    "POIName": "北科大",
    "Telno": "(02)87733142",
    "Address": "台北市大安區忠孝東路3段1號(台北科技大學大川堂)"
}, {
    "POIID": "190503",
    "POIName": "台科一",
    "Telno": "(02)27386727",
    "Address": "台北市大安區基隆路4段43號1樓"
}, {
    "POIID": "170037",
    "POIName": "台科三",
    "Telno": "(02)27366134",
    "Address": "台北市大安區基隆路四段43號第三餐廳"
}, {
    "POIID": "189271",
    "POIName": "永康",
    "Telno": "(02)23216948",
    "Address": "台北市大安區永康街43號"
}, {
    "POIID": "975973",
    "POIName": "禾光",
    "Telno": "(02)27027770",
    "Address": "台北市大安區和平東路2段63號1樓"
}, {
    "POIID": "901293",
    "POIName": "立仁",
    "Telno": "(02)27066660",
    "Address": "台北市大安區安和路二段74巷1號"
}, {
    "POIID": "182269",
    "POIName": "光忠",
    "Telno": "(02)27319254",
    "Address": "台北市大安區復興南路一段107巷5弄1號1樓"
}, {
    "POIID": "957285",
    "POIName": "吉忠",
    "Telno": "(02)87725413",
    "Address": "台北市大安區延吉街72號"
}, {
    "POIID": "187921",
    "POIName": "合旺",
    "Telno": "(02)27026159",
    "Address": "台北市大安區復興南路2段151巷41號"
}, {
    "POIID": "111441",
    "POIName": "合維",
    "Telno": "(02)27077030",
    "Address": "台北市大安區四維路170巷8號1樓"
}, {
    "POIID": "127631",
    "POIName": "安居",
    "Telno": "(02)27332560",
    "Address": "台北市大安區安居街33號"
}, {
    "POIID": "167581",
    "POIName": "安松",
    "Telno": "(02)27118647",
    "Address": "台北市大安區安東街50之2號50之3號50之4號"
}, {
    "POIID": "110334",
    "POIName": "安信",
    "Telno": "(02)27050827",
    "Address": "台北市大安區信義路四段74號1樓"
}, {
    "POIID": "970428",
    "POIName": "佑安",
    "Telno": "(02)27752136",
    "Address": "台北市大安區忠孝東路三段217巷1弄2號"
}, {
    "POIID": "128058",
    "POIName": "技安",
    "Telno": "(02)27375613",
    "Address": "台北市大安區和平東路3段97號"
}, {
    "POIID": "894359",
    "POIName": "辛亥",
    "Telno": "(02)23630291",
    "Address": "台北市大安區辛亥路2段57號"
}, {
    "POIID": "855572",
    "POIName": "和安",
    "Telno": "(02)27355311",
    "Address": "台北市大安區和平東路三段230號"
}, {
    "POIID": "171063",
    "POIName": "和金",
    "Telno": "(02)23414965",
    "Address": "台北市大安區和平東路1段91號"
}, {
    "POIID": "944795",
    "POIName": "和泰",
    "Telno": "(02)23915933",
    "Address": "台北市大安區和平東路一段169號"
}, {
    "POIID": "148834",
    "POIName": "延吉",
    "Telno": "(02)27087348",
    "Address": "台北市大安區延吉街237號"
}, {
    "POIID": "115959",
    "POIName": "昇隆",
    "Telno": "(02)27328454",
    "Address": "台北市大安區敦化南路2段238號"
}, {
    "POIID": "167950",
    "POIName": "東門",
    "Telno": "(02)33224717",
    "Address": "台北市大安區信義路二段198巷6號1樓"
}, {
    "POIID": "985246",
    "POIName": "欣安和",
    "Telno": "(02)87730039",
    "Address": "台北市大安區安和路一段47號"
}, {
    "POIID": "170934",
    "POIName": "欣隆昌",
    "Telno": "(02)23782716",
    "Address": "台北市大安區基隆路2段142之1號及142之2號"
}, {
    "POIID": "170772",
    "POIName": "芙蓉",
    "Telno": "(02)27007482",
    "Address": "台北市大安區仁愛路三段74號1樓"
}, {
    "POIID": "962601",
    "POIName": "花市",
    "Telno": "(02)27552540",
    "Address": "台北市大安區建國南路一段274號"
}, {
    "POIID": "127837",
    "POIName": "金信",
    "Telno": "(02)23215183",
    "Address": "台北市大安區金山南路2段18號1樓"
}, {
    "POIID": "166739",
    "POIName": "金華",
    "Telno": "(02)23914326",
    "Address": "台北市大安區金華街140號1樓"
}, {
    "POIID": "972594",
    "POIName": "長星",
    "Telno": "(02)27395493",
    "Address": "台北市大安區基隆路3段85號"
}, {
    "POIID": "959155",
    "POIName": "信中",
    "Telno": "(02)27033810",
    "Address": "台北市大安區信義路三段101號"
}, {
    "POIID": "135492",
    "POIName": "信安",
    "Telno": "(02)27048829",
    "Address": "台北市大安區大安路一段218號"
}, {
    "POIID": "158509",
    "POIName": "信義",
    "Telno": "(02)27005388",
    "Address": "台北市大安區信義路4段265巷12弄1號"
}, {
    "POIID": "961217",
    "POIName": "信興",
    "Telno": "(02)27018486",
    "Address": "台北市大安區信義路四段32號"
}, {
    "POIID": "127620",
    "POIName": "建安",
    "Telno": "(02)87730985",
    "Address": "台北市大安區敦化南路一段187巷29號"
}, {
    "POIID": "975869",
    "POIName": "建忠",
    "Telno": "(02)27416501",
    "Address": "台北市大安區忠孝東路三段249號"
}, {
    "POIID": "895020",
    "POIName": "建南",
    "Telno": "(02)27549832",
    "Address": "台北市大安區建國南路二段151巷6之8號"
}, {
    "POIID": "190031",
    "POIName": "建綸",
    "Telno": "(02)87717103",
    "Address": "台北市大安區仁愛路4段151巷27號"
}, {
    "POIID": "180366",
    "POIName": "恆安",
    "Telno": "(02)23952535",
    "Address": "台北市大安區永康街2巷12號1樓"
}, {
    "POIID": "185268",
    "POIName": "科技站",
    "Telno": "(02)27059323",
    "Address": "台北市大安區復興南路2段203號"
}, {
    "POIID": "882482",
    "POIName": "科建",
    "Telno": "(02)87721391",
    "Address": "台北市大安區建國南路一段28號30號"
}, {
    "POIID": "865362",
    "POIName": "師大",
    "Telno": "(02)23693200",
    "Address": "台北市大安區師大路87號"
}, {
    "POIID": "158956",
    "POIName": "泰利",
    "Telno": "(02)27058645",
    "Address": "台北市大安區仁愛路四段266巷15弄22號"
}, {
    "POIID": "121770",
    "POIName": "國館",
    "Telno": "(02)27761700",
    "Address": "台北市大安區光復南路240巷25號"
}, {
    "POIID": "946919",
    "POIName": "崇光",
    "Telno": "(02)27218292",
    "Address": "台北市大安區復興南路一段135巷5號"
}, {
    "POIID": "970288",
    "POIName": "教育大學",
    "Telno": "(02)27359529",
    "Address": "台北市大安區敦南街38號"
}, {
    "POIID": "113676",
    "POIName": "統家",
    "Telno": "(02)27212029",
    "Address": "台北市大安區忠孝東路4段216巷27弄1號1樓"
}, {
    "POIID": "121161",
    "POIName": "統領",
    "Telno": "(02)27319841",
    "Address": "台北市大安區忠孝東路四段205巷7弄5號1樓"
}, {
    "POIID": "975630",
    "POIName": "通化",
    "Telno": "(02)27083071",
    "Address": "台北市大安區通化街26之8號"
}, {
    "POIID": "143253",
    "POIName": "頂好",
    "Telno": "(02)87714781",
    "Address": "台北市大安區仁愛路4段79號1號"
}, {
    "POIID": "956248",
    "POIName": "頂東",
    "Telno": "(02)27521297",
    "Address": "台北市大安區大安路一段43號"
}, {
    "POIID": "186319",
    "POIName": "喜悅",
    "Telno": "(02)27067601",
    "Address": "台北市大安區復興南路2段82-1及82-2號"
}, {
    "POIID": "144290",
    "POIName": "富陽",
    "Telno": "(02)27373519",
    "Address": "台北市大安區和平東路3段298號300號1樓"
}, {
    "POIID": "170392",
    "POIName": "復昌",
    "Telno": "(02)27076154",
    "Address": "台北市大安區通化里光復南路616號"
}, {
    "POIID": "136705",
    "POIName": "復維",
    "Telno": "(02)27070732",
    "Address": "台北市大安區復興南路二段17號"
}, {
    "POIID": "114668",
    "POIName": "敦禾",
    "Telno": "(02)27322654",
    "Address": "台北市大安區敦化南路二段265巷6號1樓"
}, {
    "POIID": "916712",
    "POIName": "敦安",
    "Telno": "(02)27081857",
    "Address": "台北市大安區安和路一段86號"
}, {
    "POIID": "147141",
    "POIName": "敦信",
    "Telno": "(02)27556047",
    "Address": "台北市大安區仁愛路4段122巷50號1樓"
}, {
    "POIID": "975087",
    "POIName": "敦南",
    "Telno": "(02)27728928",
    "Address": "台北市大安區敦化南路一段236巷13號"
}, {
    "POIID": "883304",
    "POIName": "敦頂",
    "Telno": "(02)87716011",
    "Address": "台北市大安區忠孝東路4段101巷7號"
}, {
    "POIID": "190570",
    "POIName": "敦隆",
    "Telno": "(02)27329700",
    "Address": "台北市大安區敦化南路2段182號"
}, {
    "POIID": "110242",
    "POIName": "敦維",
    "Telno": "(02)23255362",
    "Address": "台北市大安區東豐街43號45號1樓"
}, {
    "POIID": "186009",
    "POIName": "敦親",
    "Telno": "(02)27366095",
    "Address": "台北市大安區辛亥路二段171巷8號"
}, {
    "POIID": "149125",
    "POIName": "華電",
    "Telno": "(02)27329694",
    "Address": "台北市大安區通化街177號"
}, {
    "POIID": "122289",
    "POIName": "新東帝",
    "Telno": "(02)27540987",
    "Address": "台北市大安區敦化南路二段97號1樓"
}, {
    "POIID": "137029",
    "POIName": "新泰順",
    "Telno": "(02)23643011",
    "Address": "台北市大安區泰順街13號"
}, {
    "POIID": "962184",
    "POIName": "新國聯",
    "Telno": "(02)27752026",
    "Address": "台北市大安區光復南路180巷12號"
}, {
    "POIID": "121356",
    "POIName": "溫州",
    "Telno": "(02)23626249",
    "Address": "台北市大安區羅斯福路3段245號"
}, {
    "POIID": "170819",
    "POIName": "溫東",
    "Telno": "(02)23623019",
    "Address": "台北市大安區和平東路一段266號"
}, {
    "POIID": "977441",
    "POIName": "瑞升",
    "Telno": "(02)23435837",
    "Address": "台北市大安區杭州南路二段91號"
}, {
    "POIID": "936336",
    "POIName": "瑞安",
    "Telno": "(02)27021483",
    "Address": "台北市大安區瑞安街182號"
}, {
    "POIID": "963305",
    "POIName": "義村",
    "Telno": "(02)27312912",
    "Address": "台北市大安區忠孝東路三段160號"
}, {
    "POIID": "167190",
    "POIName": "誠安",
    "Telno": "(02)27112781",
    "Address": "台北市大安區敦化南路1段247巷12號1樓"
}, {
    "POIID": "996154",
    "POIName": "鳳翔",
    "Telno": "(02)87710411",
    "Address": "台北市大安區忠孝東路4段216巷68號"
}, {
    "POIID": "965079",
    "POIName": "樂安",
    "Telno": "(02)87325204",
    "Address": "台北市大安區樂業街71號73號"
}, {
    "POIID": "189983",
    "POIName": "樂利",
    "Telno": "(02)27332646",
    "Address": "台北市大安區樂利路76號78號1樓"
}, {
    "POIID": "170691",
    "POIName": "樂和",
    "Telno": "(02)87323391",
    "Address": "台北市大安區樂利路29號29-1號"
}, {
    "POIID": "121275",
    "POIName": "樂隆",
    "Telno": "(02)87321701",
    "Address": "台北市大安區敦化南路二段331巷14號"
}, {
    "POIID": "129350",
    "POIName": "黎元",
    "Telno": "(02)23778253",
    "Address": "台北市大安區臥龍街188巷1號"
}, {
    "POIID": "863698",
    "POIName": "豫銘",
    "Telno": "(02)27540615",
    "Address": "台北市大安區大安路2段102號"
}, {
    "POIID": "140689",
    "POIName": "錢忠",
    "Telno": "(02)27526260",
    "Address": "台北市大安區忠孝東路四段26巷5號"
}, {
    "POIID": "929110",
    "POIName": "靜安",
    "Telno": "(02)27739618",
    "Address": "台北市大安區光復南路262號"
}, {
    "POIID": "915568",
    "POIName": "龍延",
    "Telno": "(02)23648913",
    "Address": "台北市大安區師大路59巷13號"
}, {
    "POIID": "125602",
    "POIName": "龍門",
    "Telno": "(02)23625327",
    "Address": "台北市大安區和平東路2段18號"
}, {
    "POIID": "180920",
    "POIName": "龍泉",
    "Telno": "(02)23682936",
    "Address": "台北市大安區羅斯福路三段193號1樓"
}, {
    "POIID": "174796",
    "POIName": "龍淵",
    "Telno": "(02)27336247",
    "Address": "台北市大安區和平東路二段118巷33號"
}, {
    "POIID": "957241",
    "POIName": "龍普",
    "Telno": "(02)27751069",
    "Address": "台北市大安區敦化南路一段233巷25號"
}, {
    "POIID": "146931",
    "POIName": "濟南",
    "Telno": "(02)27409693",
    "Address": "台北市大安區濟南路三段12號1樓"
}, {
    "POIID": "151911",
    "POIName": "臨江",
    "Telno": "(02)27844961",
    "Address": "台北市大安區安和路二段67號"
}, {
    "POIID": "959122",
    "POIName": "豐安",
    "Telno": "(02)27542996",
    "Address": "台北市大安區東豐街9號"
}, {
    "POIID": "810926",
    "POIName": "懷生",
    "Telno": "(02)27811473",
    "Address": "台北市大安區忠孝東路3段248巷9號"
}, {
    "POIID": "121600",
    "POIName": "麟光",
    "Telno": "(02)27339761",
    "Address": "台北市大安區臥龍街252號及252-1號"
}, {
    "POIID": "171731",
    "POIName": "鑫泰",
    "Telno": "(02)23623520",
    "Address": "台北市大安區古風里泰順街64號1樓"
}, {
    "POIID": "167259",
    "POIName": "鑫通",
    "Telno": "(02)27018472",
    "Address": "台北市大安區信義路四段294巷7號1樓"
}, {
    "POIID": "183756",
    "POIName": "鑫富民",
    "Telno": "(02)27754172",
    "Address": "台北市大安區忠孝東路四段181巷40弄22號1樓"
}, {
    "POIID": "155083",
    "POIName": "鑫復",
    "Telno": "(02)27085803",
    "Address": "台北市大安區信義路三段178號1樓"
}, ], [{
    "POIID": "160247",
    "POIName": "大永",
    "Telno": "(02)85098737",
    "Address": "台北市中山區明水路581巷15號1樓"
}, {
    "POIID": "985305",
    "POIName": "大吉",
    "Telno": "(02)25114007",
    "Address": "台北市中山區吉林路101號"
}, {
    "POIID": "865834",
    "POIName": "中福",
    "Telno": "(02)25434337",
    "Address": "台北市中山區民生東路2段113號"
}, {
    "POIID": "185110",
    "POIName": "中錦",
    "Telno": "(02)25616582",
    "Address": "台北市中山區中山北路二段98號"
}, {
    "POIID": "996741",
    "POIName": "元大",
    "Telno": "(02)25148676",
    "Address": "台北市中山區遼寧街110號1樓"
}, {
    "POIID": "131995",
    "POIName": "六條通",
    "Telno": "(02)25239327",
    "Address": "台北市中山區林森北路107巷15號1樓"
}, {
    "POIID": "170989",
    "POIName": "天津",
    "Telno": "(02)25434306",
    "Address": "台北市中山區天津街65號"
}, {
    "POIID": "185604",
    "POIName": "民美",
    "Telno": "(02)25957805",
    "Address": "台北市中山區圓山里中山北路3段57號"
}, {
    "POIID": "171683",
    "POIName": "永明",
    "Telno": "(02)25329027",
    "Address": "台北市中山區明水路397巷7弄25號1樓"
}, {
    "POIID": "999751",
    "POIName": "伊東",
    "Telno": "(02)25092665",
    "Address": "台北市中山區伊通街30號1樓"
}, {
    "POIID": "928357",
    "POIName": "吉安",
    "Telno": "(02)25943806",
    "Address": "台北市中山區吉林路365號367號"
}, {
    "POIID": "130394",
    "POIName": "吉林",
    "Telno": "(02)25312934",
    "Address": "台北市中山區吉林路209號1樓2樓"
}, {
    "POIID": "167260",
    "POIName": "吉鑫",
    "Telno": "(02)25420316",
    "Address": "台北市中山區南京東路二段11號1樓"
}, {
    "POIID": "166175",
    "POIName": "合江",
    "Telno": "(02)25054339",
    "Address": "台北市中山區合江街60號"
}, {
    "POIID": "170543",
    "POIName": "朱崙",
    "Telno": "(02)27788824",
    "Address": "台北市中山區朱崙街60號1樓"
}, {
    "POIID": "111636",
    "POIName": "江東",
    "Telno": "(02)25223791",
    "Address": "台北市中山區長安東路2段43號45-1號1樓"
}, {
    "POIID": "136129",
    "POIName": "江陵",
    "Telno": "(02)25815356",
    "Address": "台北市中山區一江街23號1樓"
}, {
    "POIID": "184771",
    "POIName": "行天",
    "Telno": "(02)25050197",
    "Address": "台北市中山區農安街178號"
}, {
    "POIID": "946230",
    "POIName": "京都",
    "Telno": "(02)25636575",
    "Address": "台北市中山區林森北路411號"
}, {
    "POIID": "141051",
    "POIName": "佳佳",
    "Telno": "(02)25164363",
    "Address": "台北市中山區民生東路二段157號"
}, {
    "POIID": "190455",
    "POIName": "明水",
    "Telno": "(02)85027760",
    "Address": "台北市中山區明水路636號樂群三路1號"
}, {
    "POIID": "183125",
    "POIName": "明美",
    "Telno": "(02)85011701",
    "Address": "台北市中山區敬業一路130號1樓"
}, {
    "POIID": "886059",
    "POIName": "東崙",
    "Telno": "(02)27754769",
    "Address": "台北市中山區八德路二段282號"
}, {
    "POIID": "159236",
    "POIName": "林北",
    "Telno": "(02)25216905",
    "Address": "台北市中山區民生東路1段46號46-1號1樓"
}, {
    "POIID": "171100",
    "POIName": "林安",
    "Telno": "(02)25931799",
    "Address": "台北市中山區林森北路572號"
}, {
    "POIID": "874230",
    "POIName": "林森",
    "Telno": "(02)25111563",
    "Address": "台北市中山區林森北路500號"
}, {
    "POIID": "170510",
    "POIName": "林森北",
    "Telno": "(02)25362285",
    "Address": "台北市中山區林森北路380之1號1樓"
}, {
    "POIID": "181613",
    "POIName": "松京",
    "Telno": "(02)25069601",
    "Address": "台北市中山區南京東路2段144號1樓"
}, {
    "POIID": "148144",
    "POIName": "松盛",
    "Telno": "(02)25022910",
    "Address": "台北市中山區南京東路二段115巷1號"
}, {
    "POIID": "972778",
    "POIName": "松運",
    "Telno": "(02)25179248",
    "Address": "台北市中山區松江路101號"
}, {
    "POIID": "114510",
    "POIName": "松錦",
    "Telno": "(02)25170793",
    "Address": "台北市中山區松江路295號295-1號1樓"
}, {
    "POIID": "985279",
    "POIName": "松鑫",
    "Telno": "(02)25412232",
    "Address": "台北市中山區松江路208號"
}, {
    "POIID": "929006",
    "POIName": "欣旺",
    "Telno": "(02)25321290",
    "Address": "台北市中山區北安路604號606號"
}, {
    "POIID": "165183",
    "POIName": "直安",
    "Telno": "(02)25330894",
    "Address": "台北市中山區北安路649號"
}, {
    "POIID": "167433",
    "POIName": "直福",
    "Telno": "(02)85023114",
    "Address": "台北市中山區樂群三路218號1樓"
}, {
    "POIID": "163659",
    "POIName": "金宴",
    "Telno": "(02)25168142",
    "Address": "台北市中山區建國北路二段151巷8號1樓"
}, {
    "POIID": "862086",
    "POIName": "金鑽",
    "Telno": "(02)25116854",
    "Address": "台北市中山區民權西路66號"
}, {
    "POIID": "185408",
    "POIName": "長中",
    "Telno": "(02)25676232",
    "Address": "台北市中山區中山北路2段40-1號"
}, {
    "POIID": "865890",
    "POIName": "長北",
    "Telno": "(02)25112677",
    "Address": "台北市中山區長春路11號"
}, {
    "POIID": "916572",
    "POIName": "長松",
    "Telno": "(02)25045817",
    "Address": "台北市中山區松江路65號"
}, {
    "POIID": "183697",
    "POIName": "長城",
    "Telno": "(02)25233982",
    "Address": "台北市中山區中山北路二段56號1樓"
}, {
    "POIID": "960096",
    "POIName": "長津",
    "Telno": "(02)25812531",
    "Address": "台北市中山區長安東路1段12號"
}, {
    "POIID": "170325",
    "POIName": "長通",
    "Telno": "(02)25157845",
    "Address": "台北市中山區長安東路二段101號"
}, {
    "POIID": "136842",
    "POIName": "長新",
    "Telno": "(02)25676401",
    "Address": "台北市中山區長安東路1段75號1樓"
}, {
    "POIID": "991584",
    "POIName": "威克",
    "Telno": "(02)87738717",
    "Address": "台北市中山區南京東路3段208號1樓"
}, {
    "POIID": "185659",
    "POIName": "建欣",
    "Telno": "(02)25177302",
    "Address": "台北市中山區建國北路2段13號1樓"
}, {
    "POIID": "146850",
    "POIName": "建錦",
    "Telno": "(02)25080523",
    "Address": "台北市中山區建國北路2段127號1樓B1樓"
}, {
    "POIID": "140955",
    "POIName": "建龍",
    "Telno": "(02)25167713",
    "Address": "台北市中山區龍江路239號1樓"
}, {
    "POIID": "906782",
    "POIName": "春城",
    "Telno": "(02)25316181",
    "Address": "台北市中山區長春路135號135之1號"
}, {
    "POIID": "956156",
    "POIName": "春森",
    "Telno": "(02)25641630",
    "Address": "台北市中山區長春路67號"
}, {
    "POIID": "164777",
    "POIName": "春龍",
    "Telno": "(02)25021405",
    "Address": "台北市中山區長春路257號"
}, {
    "POIID": "123260",
    "POIName": "柯鑫",
    "Telno": "(02)25819363",
    "Address": "台北市中山區中山北路2段11巷3號1樓"
}, {
    "POIID": "185154",
    "POIName": "美麗華",
    "Telno": "(02)85093170",
    "Address": "台北市中山區北安路839-1號"
}, {
    "POIID": "833077",
    "POIName": "原中",
    "Telno": "(02)25919553",
    "Address": "台北市中山區中原街121號"
}, {
    "POIID": "185316",
    "POIName": "國京",
    "Telno": "(02)25075809",
    "Address": "台北市中山區南京東路三段21號1樓"
}, {
    "POIID": "138206",
    "POIName": "國旺",
    "Telno": "(02)25425330",
    "Address": "台北市中山區南京東路一段132巷8號"
}, {
    "POIID": "188717",
    "POIName": "國賓",
    "Telno": "(02)25677004",
    "Address": "台北市中山區中山北路2段77巷3號5號1樓"
}, {
    "POIID": "148188",
    "POIName": "國學",
    "Telno": "(02)25068651",
    "Address": "台北市中山區長春路182號"
}, {
    "POIID": "185718",
    "POIName": "基河",
    "Telno": "(02)85029131",
    "Address": "台北市中山區樂群二路206號1樓"
}, {
    "POIID": "960074",
    "POIName": "崑崙",
    "Telno": "(02)25604745",
    "Address": "台北市中山區中山北路一段105巷13號"
}, {
    "POIID": "183055",
    "POIName": "統佳",
    "Telno": "(02)25175930",
    "Address": "台北市中山區松江路237號1樓"
}, {
    "POIID": "931607",
    "POIName": "莊福",
    "Telno": "(02)25045845",
    "Address": "台北市中山區長春路168號"
}, {
    "POIID": "137144",
    "POIName": "麥田",
    "Telno": "(02)25854392",
    "Address": "台北市中山區晴光里中山北路3段47號"
}, {
    "POIID": "165172",
    "POIName": "勝權",
    "Telno": "(02)21001511",
    "Address": "台北市中山區民權東路二段26號"
}, {
    "POIID": "132493",
    "POIName": "復北",
    "Telno": "(02)27184351",
    "Address": "台北市中山區復興北路164號1樓"
}, {
    "POIID": "975685",
    "POIName": "復錦",
    "Telno": "(02)25070083",
    "Address": "台北市中山區復興北路352號"
}, {
    "POIID": "865694",
    "POIName": "晶華",
    "Telno": "(02)25217133",
    "Address": "台北市中山區林森北路262號"
}, {
    "POIID": "181392",
    "POIName": "晶鑽",
    "Telno": "(02)25115092",
    "Address": "台北市中山區中山北路2段39巷8號1樓"
}, {
    "POIID": "874388",
    "POIName": "曾德",
    "Telno": "(02)25819250",
    "Address": "台北市中山區錦州街21-2號"
}, {
    "POIID": "149789",
    "POIName": "森北",
    "Telno": "(02)25372282",
    "Address": "台北市中山區林森北路108號1樓2樓"
}, {
    "POIID": "181864",
    "POIName": "森鑽",
    "Telno": "(02)25236349",
    "Address": "台北市中山區林森北路101號1樓"
}, {
    "POIID": "136118",
    "POIName": "翔運",
    "Telno": "(02)25819619",
    "Address": "台北市中山區中山北路2段44巷2號1樓"
}, {
    "POIID": "188588",
    "POIName": "圓武",
    "Telno": "(02)25314574",
    "Address": "台北市中山區吉林路28號"
}, {
    "POIID": "112374",
    "POIName": "敬群",
    "Telno": "(02)85012964",
    "Address": "台北市中山區樂群二路154號1樓"
}, {
    "POIID": "185051",
    "POIName": "新大直",
    "Telno": "(02)25329890",
    "Address": "台北市中山區北安路621巷48號"
}, {
    "POIID": "148580",
    "POIName": "新西華",
    "Telno": "(02)25036845",
    "Address": "台北市中山區民生東路3段31號"
}, {
    "POIID": "163464",
    "POIName": "新晴光",
    "Telno": "(02)25951416",
    "Address": "台北市中山區雙城街30號1樓"
}, {
    "POIID": "185796",
    "POIName": "新錦祥",
    "Telno": "(02)25311037",
    "Address": "台北市中山區錦西街16號"
}, {
    "POIID": "883865",
    "POIName": "新寶",
    "Telno": "(02)25079128",
    "Address": "台北市中山區建國北路一段136號"
}, {
    "POIID": "833468",
    "POIName": "農安",
    "Telno": "(02)25954401",
    "Address": "台北市中山區農安街28-2號"
}, {
    "POIID": "950550",
    "POIName": "實踐大學",
    "Telno": "(02)85091737",
    "Address": "台北市中山區大直街70號1樓"
}, {
    "POIID": "956673",
    "POIName": "榮金",
    "Telno": "(02)25013144",
    "Address": "台北市中山區龍江路384巷1號"
}, {
    "POIID": "170794",
    "POIName": "榮星",
    "Telno": "(02)25094506",
    "Address": "台北市中山區龍江路322號"
}, {
    "POIID": "951195",
    "POIName": "榮鑫",
    "Telno": "(02)25069116",
    "Address": "台北市中山區建國北路三段91號"
}, {
    "POIID": "121655",
    "POIName": "福權",
    "Telno": "(02)25679782",
    "Address": "台北市中山區民權東路2段96號98號1樓"
}, {
    "POIID": "958107",
    "POIName": "撫順",
    "Telno": "(02)25978663",
    "Address": "台北市中山區中山北路三段23-6號"
}, {
    "POIID": "996534",
    "POIName": "潤泰",
    "Telno": "(02)27765865",
    "Address": "台北市中山區八德路二段314號"
}, {
    "POIID": "865926",
    "POIName": "稻江",
    "Telno": "(02)25850268",
    "Address": "台北市中山區新生北路3段35號"
}, {
    "POIID": "190318",
    "POIName": "興復",
    "Telno": "(02)25026965",
    "Address": "台北市中山區興安街112號一樓"
}, {
    "POIID": "956732",
    "POIName": "錦北",
    "Telno": "(02)25418586",
    "Address": "台北市中山區錦州街8號"
}, {
    "POIID": "189259",
    "POIName": "錦合",
    "Telno": "(02)25040526",
    "Address": "台北市中山區合江街117號"
}, {
    "POIID": "171258",
    "POIName": "錦捷",
    "Telno": "(02)25628396",
    "Address": "台北市中山區錦州街229號1樓"
}, {
    "POIID": "864864",
    "POIName": "錦龍",
    "Telno": "(02)25080595",
    "Address": "台北市中山區龍江路281-1號"
}, {
    "POIID": "142814",
    "POIName": "龍京",
    "Telno": "(02)25079295",
    "Address": "台北市中山區龍江路104號1樓"
}, {
    "POIID": "131674",
    "POIName": "濱江",
    "Telno": "(02)25171393",
    "Address": "台北市中山區龍江路356巷39及41號1樓"
}, {
    "POIID": "153249",
    "POIName": "薇美",
    "Telno": "(02)85015681",
    "Address": "台北市中山區敬業三路11號1樓"
}, {
    "POIID": "119445",
    "POIName": "權東",
    "Telno": "(02)25159982",
    "Address": "台北市中山區民權東路3段73號"
}, {
    "POIID": "148292",
    "POIName": "權松",
    "Telno": "(02)25184764",
    "Address": "台北市中山區松江路363號"
}, {
    "POIID": "128069",
    "POIName": "歡唱",
    "Telno": "(02)25719203",
    "Address": "台北市中山區林森北路310巷10號1樓"
}, {
    "POIID": "148133",
    "POIName": "鑫安江",
    "Telno": "(02)27774809",
    "Address": "台北市中山區長安東路二段178號178-1號1樓"
}, {
    "POIID": "971867",
    "POIName": "鑫東一",
    "Telno": "(02)25815255",
    "Address": "台北市中山區一江街11號13號"
}, {
    "POIID": "970749",
    "POIName": "鑫長安",
    "Telno": "(02)25813841",
    "Address": "台北市中山區長安東路一段53巷1之3號"
}, {
    "POIID": "128025",
    "POIName": "鑫越",
    "Telno": "(02)25219360",
    "Address": "台北市中山區南京西路12巷9號1樓"
}, {
    "POIID": "972789",
    "POIName": "鑫德惠",
    "Telno": "(02)25995347",
    "Address": "台北市中山區德惠街15號1樓"
}, {
    "POIID": "184999",
    "POIName": "鑫錦州",
    "Telno": "(02)25122462",
    "Address": "台北市中山區錦州街263號"
}, {
    "POIID": "170196",
    "POIName": "鑫櫃",
    "Telno": "(02)25153336",
    "Address": "台北市中山區松江路183號183-1號1樓"
}, ], [{
    "POIID": "158864",
    "POIName": "千成",
    "Telno": "(02)23577481",
    "Address": "台北市中正區林森南路4號之3"
}, {
    "POIID": "110817",
    "POIName": "千翔",
    "Telno": "(02)23123025",
    "Address": "台北市中正區許昌街17號1樓"
}, {
    "POIID": "186157",
    "POIName": "大永博",
    "Telno": "(02)23826912",
    "Address": "台北市中正區博愛路97號1樓"
}, {
    "POIID": "167972",
    "POIName": "大埔",
    "Telno": "(02)23024530",
    "Address": "台北市中正區和平西路二段152號152之1號154號154之1號"
}, {
    "POIID": "170978",
    "POIName": "中航",
    "Telno": "(02)23278931",
    "Address": "台北市中正區林森南路12號"
}, {
    "POIID": "991562",
    "POIName": "中華電",
    "Telno": "(02)33433607",
    "Address": "台北市中正區信義路一段21-3號B1樓"
}, {
    "POIID": "185280",
    "POIName": "中愛",
    "Telno": "(02)23415461",
    "Address": "台北市中正區寧波東街17號1樓"
}, {
    "POIID": "932910",
    "POIName": "中樂",
    "Telno": "(02)23122424",
    "Address": "台北市中正區延平南路47號"
}, {
    "POIID": "128302",
    "POIName": "丹陽",
    "Telno": "(02)23516914",
    "Address": "台北市中正區杭州南路一段83號"
}, {
    "POIID": "135296",
    "POIName": "仁金",
    "Telno": "(02)23583428",
    "Address": "台北市中正區仁愛路二段39號39-1號"
}, {
    "POIID": "186238",
    "POIName": "北車",
    "Telno": "(02)23880571",
    "Address": "台北市中正區忠孝西路一段49號B1樓"
}, {
    "POIID": "127860",
    "POIName": "北高鐵",
    "Telno": "(02)23149940",
    "Address": "台北市中正區北平西路3號B1樓"
}, {
    "POIID": "169565",
    "POIName": "北捷",
    "Telno": "(02)23123981",
    "Address": "台北市中正區忠孝西路1段49號B3樓"
}, {
    "POIID": "110448",
    "POIName": "古亭",
    "Telno": "(02)23646532",
    "Address": "台北市中正區汀州路二段210號"
}, {
    "POIID": "975788",
    "POIName": "台大",
    "Telno": "(02)23928922",
    "Address": "台北市中正區林森南路53號55號"
}, {
    "POIID": "184966",
    "POIName": "台北1",
    "Telno": "(02)23892260",
    "Address": "台北市中正區北平西路3號(東南站)"
}, {
    "POIID": "985235",
    "POIName": "台北2",
    "Telno": "(02)23892306",
    "Address": "台北市中正區北平西路3號(西南站)"
}, {
    "POIID": "127941",
    "POIName": "台北3",
    "Telno": "(02)23115743",
    "Address": "台北市中正區北平西路3號(西北站)"
}, {
    "POIID": "960454",
    "POIName": "台北4",
    "Telno": "(02)23892297",
    "Address": "台北市中正區北平西路3號(東北站)"
}, {
    "POIID": "137018",
    "POIName": "台北五",
    "Telno": "(02)23894079",
    "Address": "台北市中正區北平西路3號"
}, {
    "POIID": "964906",
    "POIName": "台北六",
    "Telno": "(02)23897990",
    "Address": "台北市中正區北平西路3號"
}, {
    "POIID": "141752",
    "POIName": "台醫",
    "Telno": "(02)23210446",
    "Address": "台北市中正區中山南路7號B1 樓"
}, {
    "POIID": "165323",
    "POIName": "汀州",
    "Telno": "(02)23098147",
    "Address": "台北市中正區汀州路一段129號"
}, {
    "POIID": "956134",
    "POIName": "同昌",
    "Telno": "(02)23679923",
    "Address": "台北市中正區南昌路2段173號"
}, {
    "POIID": "155577",
    "POIName": "兒醫",
    "Telno": "(02)23813972",
    "Address": "台北市中正區青島西路7號1樓"
}, {
    "POIID": "113551",
    "POIName": "忠聯",
    "Telno": "(02)23215793",
    "Address": "台北市中正區忠孝東路二段100號1樓"
}, {
    "POIID": "130796",
    "POIName": "杭信",
    "Telno": "(02)23584603",
    "Address": "台北市中正區信義路2段15號1樓"
}, {
    "POIID": "148764",
    "POIName": "欣漢華",
    "Telno": "(02)23613686",
    "Address": "台北市中正區中華路一段41號1樓"
}, {
    "POIID": "833239",
    "POIName": "金山",
    "Telno": "(02)23560002",
    "Address": "台北市中正區金山南路1段108號"
}, {
    "POIID": "129110",
    "POIName": "青島",
    "Telno": "(02)23516965",
    "Address": "台北市中正區青島東路4號"
}, {
    "POIID": "140759",
    "POIName": "南昌",
    "Telno": "(02)23933036",
    "Address": "台北市中正區南昌路一段72號"
}, {
    "POIID": "158587",
    "POIName": "南海",
    "Telno": "(02)23962768",
    "Address": "台北市中正區南海路50號"
}, {
    "POIID": "121987",
    "POIName": "牯嶺",
    "Telno": "(02)23686248",
    "Address": "台北市中正區廈門街99巷19-2號1樓"
}, {
    "POIID": "143655",
    "POIName": "秋葉原",
    "Telno": "(02)23411823",
    "Address": "台北市中正區市民大道3段2號B2樓"
}, {
    "POIID": "119607",
    "POIName": "英雄館",
    "Telno": "(02)23888493",
    "Address": "台北市中正區長沙街一段20號1樓"
}, {
    "POIID": "177429",
    "POIName": "軍總",
    "Telno": "(02)23653720",
    "Address": "台北市中正區汀州路三段129號"
}, {
    "POIID": "127790",
    "POIName": "重南",
    "Telno": "(02)23884895",
    "Address": "台北市中正區武昌街一段1-2號1樓"
}, {
    "POIID": "844860",
    "POIName": "晉江",
    "Telno": "(02)23654771",
    "Address": "台北市中正區和平西路一段26號"
}, {
    "POIID": "171269",
    "POIName": "國圖",
    "Telno": "(02)23141506",
    "Address": "台北市中正區中山南路20號B1樓"
}, {
    "POIID": "960339",
    "POIName": "捷戰",
    "Telno": "(02)23826275",
    "Address": "台北市中正區忠孝西路一段50-1號(捷運地下街)"
}, {
    "POIID": "118899",
    "POIName": "掬華",
    "Telno": "(02)23375810",
    "Address": "台北市中正區中華路2段407號"
}, {
    "POIID": "874872",
    "POIName": "統全",
    "Telno": "(02)23658638",
    "Address": "台北市中正區汀州路三段249號"
}, {
    "POIID": "184139",
    "POIName": "統新",
    "Telno": "(02)23944861",
    "Address": "台北市中正區臨沂街27巷10號1樓"
}, {
    "POIID": "896067",
    "POIName": "統聯",
    "Telno": "(02)23579051",
    "Address": "台北市中正區忠孝東路二段130-2號130-3號"
}, {
    "POIID": "128070",
    "POIName": "紹興",
    "Telno": "(02)23224595",
    "Address": "台北市中正區紹興北街37號1樓"
}, {
    "POIID": "184416",
    "POIName": "凱富",
    "Telno": "(02)23024836",
    "Address": "台北市中正區西園路一段278號1樓"
}, {
    "POIID": "122522",
    "POIName": "博美",
    "Telno": "(02)23712385",
    "Address": "台北市中正區武昌街一段45號1樓"
}, {
    "POIID": "184933",
    "POIName": "博源",
    "Telno": "(02)23684419",
    "Address": "台北市中正區思源街16號"
}, {
    "POIID": "874252",
    "POIName": "華山",
    "Telno": "(02)23214407",
    "Address": "台北市中正區忠孝東路1段138號"
}, {
    "POIID": "184955",
    "POIName": "華慶",
    "Telno": "(02)23886735",
    "Address": "台北市中正區中華路一段59之16號"
}, {
    "POIID": "170299",
    "POIName": "開博",
    "Telno": "(02)23119208",
    "Address": "台北市中正區開封街一段40號42號1樓"
}, {
    "POIID": "148236",
    "POIName": "新南",
    "Telno": "(02)23435207",
    "Address": "台北市中正區新生南路1段126-7號"
}, {
    "POIID": "119582",
    "POIName": "新格蘭",
    "Telno": "(02)23705929",
    "Address": "台北市中正區衡陽路27號"
}, {
    "POIID": "952040",
    "POIName": "新紹南",
    "Telno": "(02)23219916",
    "Address": "台北市中正區信義路一段13-1號"
}, {
    "POIID": "985280",
    "POIName": "新雲",
    "Telno": "(02)23939186",
    "Address": "台北市中正區三愛里連雲街81號"
}, {
    "POIID": "148591",
    "POIName": "新廈門",
    "Telno": "(02)23677374",
    "Address": "台北市中正區廈門街42號46號"
}, {
    "POIID": "185279",
    "POIName": "新愛國",
    "Telno": "(02)23710027",
    "Address": "台北市中正區延平南路177號"
}, {
    "POIID": "942722",
    "POIName": "新羅福",
    "Telno": "(02)23686283",
    "Address": "台北市中正區羅斯福路3段82號"
}, {
    "POIID": "164939",
    "POIName": "萬光",
    "Telno": "(02)23021224",
    "Address": "台北市中正區中華路二段157號"
}, {
    "POIID": "900474",
    "POIName": "萬翔",
    "Telno": "(02)23757275",
    "Address": "台北市中正區公園路13號"
}, {
    "POIID": "956260",
    "POIName": "寧波",
    "Telno": "(02)23221617",
    "Address": "台北市中正區寧波西街3號"
}, {
    "POIID": "135872",
    "POIName": "漢慶",
    "Telno": "(02)23122948",
    "Address": "台北市中正區漢口街一段82號1樓"
}, {
    "POIID": "166359",
    "POIName": "興信鑫",
    "Telno": "(02)23821642",
    "Address": "台北市中正區館前路59號1樓"
}, {
    "POIID": "136565",
    "POIName": "濟新",
    "Telno": "(02)33224217",
    "Address": "台北市中正區濟南路2段50號"
}, {
    "POIID": "190628",
    "POIName": "臨沂",
    "Telno": "(02)23938772",
    "Address": "台北市中正區文祥里臨沂街74號76號"
}, {
    "POIID": "921965",
    "POIName": "羅亭",
    "Telno": "(02)23929446",
    "Address": "台北市中正區羅斯福路二段68號"
}, {
    "POIID": "154482",
    "POIName": "羅館",
    "Telno": "(02)23672814",
    "Address": "台北市中正區羅斯福路3段316巷16號1樓"
}, {
    "POIID": "184793",
    "POIName": "警廣",
    "Telno": "(02)23717603",
    "Address": "台北市中正區廣州街10-2號10-3號10-4部分號1樓"
}, {
    "POIID": "996110",
    "POIName": "鑫大孝",
    "Telno": "(02)23719010",
    "Address": "台北市中正區黎明里重慶南路一段1-1號一樓"
}, {
    "POIID": "971890",
    "POIName": "鑫公信",
    "Telno": "(02)23898704",
    "Address": "台北市中正區信陽街2-1號"
}, {
    "POIID": "149583",
    "POIName": "鑫台北",
    "Telno": "(02)23312768",
    "Address": "台北市中正區黎明里忠孝西路一段35號一樓"
}, {
    "POIID": "972321",
    "POIName": "鑫杭",
    "Telno": "(02)23579224",
    "Address": "台北市中正區杭州南路1段23號"
}, {
    "POIID": "187057",
    "POIName": "鑫泉州",
    "Telno": "(02)23054054",
    "Address": "台北市中正區汀州路一段285號一樓"
}, {
    "POIID": "118420",
    "POIName": "鑫重寧",
    "Telno": "(02)33225836",
    "Address": "台北市中正區寧波西街86號1樓"
}, {
    "POIID": "971395",
    "POIName": "鑫國語",
    "Telno": "(02)23964338",
    "Address": "台北市中正區福州街11-3號11-4號"
}, {
    "POIID": "149413",
    "POIName": "鑫華福",
    "Telno": "(02)23707435",
    "Address": "台北市中正區懷寧街30號32號1樓"
}, {
    "POIID": "170277",
    "POIName": "鑫衡陽",
    "Telno": "(02)23316456",
    "Address": "台北市中正區衡陽路6號1樓"
}, {
    "POIID": "162276",
    "POIName": "鑫館",
    "Telno": "(02)23679745",
    "Address": "台北市中正區汀州路3段269號1樓2樓"
}, ], [{
    "POIID": "122463",
    "POIName": "三德",
    "Telno": "(02)25955432",
    "Address": "台北市大同區承德路三段55號57號1樓"
}, {
    "POIID": "962542",
    "POIName": "大龍",
    "Telno": "(02)25947220",
    "Address": "台北市大同區昌吉街72號74號76號"
}, {
    "POIID": "966164",
    "POIName": "中興醫",
    "Telno": "(02)25501134",
    "Address": "台北市大同區鄭州路145號B1"
}, {
    "POIID": "936196",
    "POIName": "仟發",
    "Telno": "(02)25570749",
    "Address": "台北市大同區民生西路95號97號"
}, {
    "POIID": "183848",
    "POIName": "仟瑞",
    "Telno": "(02)25590648",
    "Address": "台北市大同區民生西路84號1樓"
}, {
    "POIID": "180056",
    "POIName": "京站",
    "Telno": "(02)25554526",
    "Address": "台北市大同區華陰街91號"
}, {
    "POIID": "143965",
    "POIName": "延民",
    "Telno": "(02)25952932",
    "Address": "台北市大同區民族西路246號248號1樓"
}, {
    "POIID": "137052",
    "POIName": "延年",
    "Telno": "(02)25978111",
    "Address": "台北市大同區延平北路3段61-5號"
}, {
    "POIID": "190938",
    "POIName": "延埕",
    "Telno": "(02)25520267",
    "Address": "台北市大同區延平北路2段159號161號"
}, {
    "POIID": "155418",
    "POIName": "延華",
    "Telno": "(02)25506316",
    "Address": "台北市大同區延平北路一段89號91號93號1樓"
}, {
    "POIID": "113908",
    "POIName": "延龍",
    "Telno": "(02)25969446",
    "Address": "台北市大同區延平北路四段16號18號1樓"
}, {
    "POIID": "963486",
    "POIName": "承華",
    "Telno": "(02)25562955",
    "Address": "台北市大同區承德路一段22號"
}, {
    "POIID": "993742",
    "POIName": "昌吉",
    "Telno": "(02)25927056",
    "Address": "台北市大同區承德路三段60號60-1號"
}, {
    "POIID": "143677",
    "POIName": "長峰",
    "Telno": "(02)25556859",
    "Address": "台北市大同區長安西路45之2號47號1樓"
}, {
    "POIID": "185327",
    "POIName": "保聖",
    "Telno": "(02)25992807",
    "Address": "台北市大同區酒泉街58號60號"
}, {
    "POIID": "188636",
    "POIName": "南西",
    "Telno": "(02)25522065",
    "Address": "台北市大同區南京西路296號298號1樓"
}, {
    "POIID": "185501",
    "POIName": "哈蜜",
    "Telno": "(02)25970450",
    "Address": "台北市大同區重慶北路3段309號"
}, {
    "POIID": "934891",
    "POIName": "迪化",
    "Telno": "(02)25529032",
    "Address": "台北市大同區民生西路343號345號"
}, {
    "POIID": "992967",
    "POIName": "酒泉",
    "Telno": "(02)25959849",
    "Address": "台北市大同區重慶北路三段260號1-2樓"
}, {
    "POIID": "121149",
    "POIName": "涼州",
    "Telno": "(02)25538157",
    "Address": "台北市大同區延平北路二段232號234號1樓"
}, {
    "POIID": "180687",
    "POIName": "景星",
    "Telno": "(02)25957826",
    "Address": "台北市大同區延平北路3段19之5號21號1樓"
}, {
    "POIID": "950930",
    "POIName": "湧久",
    "Telno": "(02)25982186",
    "Address": "台北市大同區延平北路4段157號159號"
}, {
    "POIID": "148339",
    "POIName": "詠樂",
    "Telno": "(02)25569749",
    "Address": "台北市大同區南京西路233巷15號17號1.2樓"
}, {
    "POIID": "120526",
    "POIName": "圓泉",
    "Telno": "(02)25997457",
    "Address": "台北市大同區酒泉街25號27號1樓"
}, {
    "POIID": "977290",
    "POIName": "圓慶",
    "Telno": "(02)25567571",
    "Address": "台北市大同區南京西路127號"
}, {
    "POIID": "184988",
    "POIName": "塔城",
    "Telno": "(02)25584706",
    "Address": "台北市大同區長安西路271號1樓及273巷2號1樓"
}, {
    "POIID": "966474",
    "POIName": "新慶陽",
    "Telno": "(02)25565584",
    "Address": "台北市大同區重慶北路2段60號"
}, {
    "POIID": "992336",
    "POIName": "德倫",
    "Telno": "(02)25875361",
    "Address": "台北市大同區承德路3段240號242號1樓"
}, {
    "POIID": "166049",
    "POIName": "慶吉",
    "Telno": "(02)25954240",
    "Address": "台北市大同區重慶北路三段47號49號1樓"
}, {
    "POIID": "128494",
    "POIName": "稻埕",
    "Telno": "(02)25525790",
    "Address": "台北市大同區南京西路436號1F"
}, {
    "POIID": "891176",
    "POIName": "靜中",
    "Telno": "(02)25529387",
    "Address": "台北市大同區寧夏路71號"
}, {
    "POIID": "996523",
    "POIName": "篷萊",
    "Telno": "(02)25539665",
    "Address": "台北市大同區寧夏路131-1號"
}, {
    "POIID": "136831",
    "POIName": "雙連",
    "Telno": "(02)25558245",
    "Address": "台北市大同區民生西路176號"
}, {
    "POIID": "982661",
    "POIName": "權鑫",
    "Telno": "(02)25995942",
    "Address": "台北市大同區民權西路157之1號1樓"
}, {
    "POIID": "971672",
    "POIName": "鑫太原",
    "Telno": "(02)25591974",
    "Address": "台北市大同區太原路40號42號44號"
}, {
    "POIID": "162438",
    "POIName": "鑫寧",
    "Telno": "(02)25508002",
    "Address": "台北市大同區民生西路214號216號1樓"
}, ], [{
    "POIID": "184737",
    "POIName": "大華",
    "Telno": "(02)23390762",
    "Address": "台北市萬華區萬大路495號497號"
}, {
    "POIID": "149446",
    "POIName": "中寧",
    "Telno": "(02)23014902",
    "Address": "台北市萬華區中華路2段602-1-2號一樓"
}, {
    "POIID": "136406",
    "POIName": "六福",
    "Telno": "(02)23311176",
    "Address": "台北市萬華區漢口街二段73號1樓"
}, {
    "POIID": "975663",
    "POIName": "世運",
    "Telno": "(02)23753064",
    "Address": "台北市萬華區昆明街81號83號"
}, {
    "POIID": "131799",
    "POIName": "成都",
    "Telno": "(02)23882392",
    "Address": "台北市萬華區成都路96號1樓"
}, {
    "POIID": "180540",
    "POIName": "西寧南",
    "Telno": "(02)23831295",
    "Address": "台北市萬華區西寧南路141號1樓2樓"
}, {
    "POIID": "149022",
    "POIName": "克難",
    "Telno": "(02)23379081",
    "Address": "台北市萬華區萬青街168號"
}, {
    "POIID": "177072",
    "POIName": "宏旭",
    "Telno": "(02)23025905",
    "Address": "台北市萬華區西園路一段238號1之2樓"
}, {
    "POIID": "185833",
    "POIName": "昆寧",
    "Telno": "(02)23709656",
    "Address": "台北市萬華區西寧南路50巷3號5號"
}, {
    "POIID": "130361",
    "POIName": "昆福",
    "Telno": "(02)23717744",
    "Address": "台北市萬華區昆明街30-1號30-2號1樓"
}, {
    "POIID": "143666",
    "POIName": "明日",
    "Telno": "(02)23149156",
    "Address": "台北市萬華區成都路27巷1號1樓"
}, {
    "POIID": "148052",
    "POIName": "青園",
    "Telno": "(02)23012464",
    "Address": "台北市萬華區青年路18號1樓"
}, {
    "POIID": "189776",
    "POIName": "桂明",
    "Telno": "(02)23892844",
    "Address": "台北市萬華區桂林路55號"
}, {
    "POIID": "886222",
    "POIName": "桂林",
    "Telno": "(02)23040689",
    "Address": "台北市萬華區桂林路160號"
}, {
    "POIID": "151117",
    "POIName": "國雙",
    "Telno": "(02)23390812",
    "Address": "台北市萬華區新忠里西藏路125巷17號"
}, {
    "POIID": "790813",
    "POIName": "捷盟",
    "Telno": "(02)23895672",
    "Address": "台北市萬華區漢中街51號"
}, {
    "POIID": "117748",
    "POIName": "富帆",
    "Telno": "(02)23012146",
    "Address": "台北市萬華區華中里萬大路464號一樓"
}, {
    "POIID": "187781",
    "POIName": "華江",
    "Telno": "(02)23088154",
    "Address": "台北市萬華區華江里20鄰環河南路2段200號"
}, {
    "POIID": "144337",
    "POIName": "華藏",
    "Telno": "(02)23034547",
    "Address": "台北市萬華區西藏路107號107之1號1樓"
}, {
    "POIID": "975951",
    "POIName": "華雙",
    "Telno": "(02)23065408",
    "Address": "台北市萬華區環河南路二段252號"
}, {
    "POIID": "922197",
    "POIName": "開寧",
    "Telno": "(02)23884024",
    "Address": "台北市萬華區西寧南路16號"
}, {
    "POIID": "149675",
    "POIName": "園舺",
    "Telno": "(02)23086420",
    "Address": "台北市萬華區西園路二段140巷52號"
}, {
    "POIID": "957827",
    "POIName": "新峨嵋",
    "Telno": "(02)23704539",
    "Address": "台北市萬華區峨嵋街111之2號之3號"
}, {
    "POIID": "149321",
    "POIName": "新起",
    "Telno": "(02)23147269",
    "Address": "台北市萬華區長沙街2段87號1樓"
}, {
    "POIID": "960340",
    "POIName": "新寧南",
    "Telno": "(02)23708471",
    "Address": "台北市萬華區西寧南路80號"
}, {
    "POIID": "140586",
    "POIName": "新艋舺",
    "Telno": "(02)23046585",
    "Address": "台北市萬華區萬大路292號"
}, {
    "POIID": "162977",
    "POIName": "萬大",
    "Telno": "(02)23057808",
    "Address": "台北市萬華區萬大路245號247號1樓"
}, {
    "POIID": "160270",
    "POIName": "萬和",
    "Telno": "(02)23055379",
    "Address": "台北市萬華區萬大路184號"
}, {
    "POIID": "957229",
    "POIName": "萬忠",
    "Telno": "(02)23034250",
    "Address": "台北市萬華區東園街28巷58號"
}, {
    "POIID": "166876",
    "POIName": "萬東",
    "Telno": "(02)23379121",
    "Address": "台北市萬華區萬大路486巷61號63號1樓"
}, {
    "POIID": "153308",
    "POIName": "萬長",
    "Telno": "(02)23039076",
    "Address": "台北市萬華區東園街78號1樓"
}, {
    "POIID": "120559",
    "POIName": "萬華",
    "Telno": "(02)23041593",
    "Address": "台北市萬華區莒光路216號萬大路57號1樓"
}, {
    "POIID": "186249",
    "POIName": "萬華站",
    "Telno": "(02)23046036",
    "Address": "台北市萬華區康定路382號"
}, {
    "POIID": "181808",
    "POIName": "萬運",
    "Telno": "(02)23088704",
    "Address": "台北市萬華區西園硌一段153號地下室"
}, {
    "POIID": "992130",
    "POIName": "漢中",
    "Telno": "(02)23120633",
    "Address": "台北市萬華區漢中街185號187號"
}, {
    "POIID": "190927",
    "POIName": "漢陽",
    "Telno": "(02)23310744",
    "Address": "台北市萬華區昆明街197號199號1樓"
}, {
    "POIID": "119146",
    "POIName": "漢寧",
    "Telno": "(02)23899050",
    "Address": "台北市萬華區西寧南路85號"
}, {
    "POIID": "187389",
    "POIName": "廣明",
    "Telno": "(02)23023362",
    "Address": "台北市萬華區昆明街285號之3之4"
}, {
    "POIID": "143998",
    "POIName": "興義",
    "Telno": "(02)23034630",
    "Address": "台北市萬華區興義街6號8號1樓"
}, {
    "POIID": "158853",
    "POIName": "龍山",
    "Telno": "(02)23068368",
    "Address": "台北市萬華區康定路203號205號1樓"
}, {
    "POIID": "125967",
    "POIName": "龍廣",
    "Telno": "(02)23362548",
    "Address": "台北市萬華區廣州街148號"
}, {
    "POIID": "846604",
    "POIName": "雙環",
    "Telno": "(02)23361021",
    "Address": "台北市萬華區環河南路二段207號"
}, {
    "POIID": "129095",
    "POIName": "寶昌",
    "Telno": "(02)23045536",
    "Address": "台北市萬華區寶興街186號"
}, {
    "POIID": "183192",
    "POIName": "鑫日新",
    "Telno": "(02)23712502",
    "Address": "台北市萬華區武昌街二段122之1號"
}, {
    "POIID": "996372",
    "POIName": "鑫武昌",
    "Telno": "(02)23314737",
    "Address": "台北市萬華區武昌街二段57號1樓"
}, {
    "POIID": "188599",
    "POIName": "鑫青天",
    "Telno": "(02)23378341",
    "Address": "台北市萬華區青年路144號"
}, {
    "POIID": "171306",
    "POIName": "鑫樂昇",
    "Telno": "(02)23754357",
    "Address": "台北市萬華區武昌街二段114之3號"
}, {
    "POIID": "153250",
    "POIName": "鑫寶",
    "Telno": "(02)23057962",
    "Address": "台北市萬華區寶興街 43號45號1樓"
}, ], [{
    "POIID": "177359",
    "POIName": "文一",
    "Telno": "(02)29383654",
    "Address": "台北市文山區木新路三段327號"
}, {
    "POIID": "119711",
    "POIName": "文山",
    "Telno": "(02)29368284",
    "Address": "台北市文山區永安街22巷23號25號1樓"
}, {
    "POIID": "189695",
    "POIName": "文忠",
    "Telno": "(02)29379722",
    "Address": "台北市文山區忠順街二段10號1樓"
}, {
    "POIID": "189363",
    "POIName": "文新",
    "Telno": "(02)22349624",
    "Address": "台北市文山區樟新里木新路三段276號"
}, {
    "POIID": "968388",
    "POIName": "文儀",
    "Telno": "(02)86618765",
    "Address": "台北市文山區木新路三段54號56號"
}, {
    "POIID": "855398",
    "POIName": "木柵",
    "Telno": "(02)29371739",
    "Address": "台北市文山區木柵路2段157號"
}, {
    "POIID": "185394",
    "POIName": "木盛",
    "Telno": "(02)86611837",
    "Address": "台北市文山區木柵路三段88號"
}, {
    "POIID": "875200",
    "POIName": "木新",
    "Telno": "(02)29385892",
    "Address": "台北市文山區木新路2段255號"
}, {
    "POIID": "190123",
    "POIName": "世新大",
    "Telno": "(02)22361484",
    "Address": "台北市文山區木柵路1段17巷1號1樓"
}, {
    "POIID": "962346",
    "POIName": "仙岩",
    "Telno": "(02)29335139",
    "Address": "台北市文山區仙岩路18號"
}, {
    "POIID": "960993",
    "POIName": "北福興",
    "Telno": "(02)29350416",
    "Address": "台北市文山區興旺里福興路20號"
}, {
    "POIID": "991894",
    "POIName": "台師大",
    "Telno": "(02)86635162",
    "Address": "台北市文山區汀州路4段88號行政大樓1樓"
}, {
    "POIID": "127550",
    "POIName": "辛亥站",
    "Telno": "(02)86639792",
    "Address": "台北市文山區辛亥路四段132號"
}, {
    "POIID": "138446",
    "POIName": "忠順",
    "Telno": "(02)22345721",
    "Address": "台北市文山區忠順街1段26巷15號"
}, {
    "POIID": "883544",
    "POIName": "金恩",
    "Telno": "(02)86617034",
    "Address": "台北市文山區指南路二段149號"
}, {
    "POIID": "113160",
    "POIName": "指南",
    "Telno": "(02)29363203",
    "Address": "台北市文山區指南路1段34號36號1樓"
}, {
    "POIID": "170668",
    "POIName": "政大",
    "Telno": "(02)29362025",
    "Address": "台北市文山區指南路2段99號101號"
}, {
    "POIID": "190189",
    "POIName": "動物園",
    "Telno": "(02)86618147",
    "Address": "台北市文山區新光路2段30號1樓"
}, {
    "POIID": "184690",
    "POIName": "康喜",
    "Telno": "(02)29332978",
    "Address": "台北市文山區興隆路三段42號"
}, {
    "POIID": "855354",
    "POIName": "添恩",
    "Telno": "(02)22343580",
    "Address": "台北市文山區指南路3段8號10號"
}, {
    "POIID": "180595",
    "POIName": "博嘉",
    "Telno": "(02)82300388",
    "Address": "台北市文山區木柵路四段117號119號1樓"
}, {
    "POIID": "905815",
    "POIName": "景中",
    "Telno": "(02)86637537",
    "Address": "台北市文山區景文里景文街96號98號"
}, {
    "POIID": "174888",
    "POIName": "景高",
    "Telno": "(02)89316863",
    "Address": "台北市文山區景華里景興路14號"
}, {
    "POIID": "985718",
    "POIName": "景捷",
    "Telno": "(02)29316909",
    "Address": "台北市文山區景福街252號"
}, {
    "POIID": "190282",
    "POIName": "景華",
    "Telno": "(02)29314829",
    "Address": "台北市文山區興東里景華街130號"
}, {
    "POIID": "975847",
    "POIName": "景興",
    "Telno": "(02)29341840",
    "Address": "台北市文山區景興路113號115號"
}, {
    "POIID": "801276",
    "POIName": "華興",
    "Telno": "(02)22367947",
    "Address": "台北市文山區木柵路一段168號170號"
}, {
    "POIID": "990053",
    "POIName": "新安康",
    "Telno": "(02)29361151",
    "Address": "台北市文山區木柵路二段88號90號1樓"
}, {
    "POIID": "121068",
    "POIName": "新秀",
    "Telno": "(02)29398096",
    "Address": "台北市文山區秀明路二段8號10號"
}, {
    "POIID": "128287",
    "POIName": "新景美",
    "Telno": "(02)29388317",
    "Address": "台北市文山區木新路三段179號181號"
}, {
    "POIID": "149594",
    "POIName": "新萬盛",
    "Telno": "(02)86635872",
    "Address": "台北市文山區羅斯福路5段21號1樓"
}, {
    "POIID": "190156",
    "POIName": "新萬隆",
    "Telno": "(02)29353483",
    "Address": "台北市文山區羅斯福路六段20號22號"
}, {
    "POIID": "885609",
    "POIName": "萬芳",
    "Telno": "(02)22390910",
    "Address": "台北市文山區萬安街23號25號"
}, {
    "POIID": "158772",
    "POIName": "萬芳醫",
    "Telno": "(02)29341971",
    "Address": "台北市文山區興隆路三段111號"
}, {
    "POIID": "165943",
    "POIName": "萬美",
    "Telno": "(02)22398986",
    "Address": "台北市文山區萬和街6號2樓之1"
}, {
    "POIID": "148683",
    "POIName": "萬隆站",
    "Telno": "(02)86632730",
    "Address": "台北市文山區羅斯福路5段249號1樓"
}, {
    "POIID": "187817",
    "POIName": "萬福",
    "Telno": "(02)29307076",
    "Address": "台北市文山區萬年里羅斯福路5段170巷33及35號"
}, {
    "POIID": "996143",
    "POIName": "試院",
    "Telno": "(02)22360262",
    "Address": "台北市文山區木柵路1段139號"
}, {
    "POIID": "135229",
    "POIName": "漢神",
    "Telno": "(02)29338701",
    "Address": "台北市文山區景中街45號1樓"
}, {
    "POIID": "187909",
    "POIName": "滬江",
    "Telno": "(02)29358120",
    "Address": "台北市文山區羅斯福路六段308號310號"
}, {
    "POIID": "135528",
    "POIName": "興北",
    "Telno": "(02)29356514",
    "Address": "台北市文山區興隆路三段108號"
}, {
    "POIID": "119489",
    "POIName": "興岩",
    "Telno": "(02)29335405",
    "Address": "台北市文山區興隆路2段244巷20號1樓"
}, {
    "POIID": "975054",
    "POIName": "興芳",
    "Telno": "(02)22399843",
    "Address": "台北市文山區興光里興隆路3段173-175號"
}, {
    "POIID": "170381",
    "POIName": "興隆",
    "Telno": "(02)29309249",
    "Address": "台北市文山區興隆路2段219號"
}, {
    "POIID": "961424",
    "POIName": "羅捷",
    "Telno": "(02)86638381",
    "Address": "台北市文山區景行里羅斯福路6段391號"
}, {
    "POIID": "190042",
    "POIName": "羅斯福",
    "Telno": "(02)29342178",
    "Address": "台北市文山區羅斯福路五段216號"
}, ], [{
    "POIID": "140210",
    "POIName": "中坡",
    "Telno": "(02)27864543",
    "Address": "台北市南港區中坡南路47號1樓"
}, {
    "POIID": "144795",
    "POIName": "中貿",
    "Telno": "(02)27839835",
    "Address": "台北市南港區經貿二路186號2樓"
}, {
    "POIID": "141947",
    "POIName": "玉成",
    "Telno": "(02)26548061",
    "Address": "台北市南港區南港路3段9號1樓"
}, {
    "POIID": "121622",
    "POIName": "玉德",
    "Telno": "(02)27863772",
    "Address": "台北市南港區玉成街150號1樓"
}, {
    "POIID": "148100",
    "POIName": "向揚",
    "Telno": "(02)27831061",
    "Address": "台北市南港區向陽路166號1樓"
}, {
    "POIID": "961527",
    "POIName": "庄研",
    "Telno": "(02)26539357",
    "Address": "台北市南港區研究院路二段152號"
}, {
    "POIID": "185017",
    "POIName": "佳樂",
    "Telno": "(02)26533511",
    "Address": "台北市南港區南港路一段305號"
}, {
    "POIID": "185213",
    "POIName": "忠陽",
    "Telno": "(02)27885107",
    "Address": "台北市南港區忠孝東路六段465號1樓"
}, {
    "POIID": "896539",
    "POIName": "昆陽",
    "Telno": "(02)27865732",
    "Address": "台北市南港區忠孝東路6段448號"
}, {
    "POIID": "978628",
    "POIName": "林坊",
    "Telno": "(02)27893961",
    "Address": "台北市南港區東新街80巷1號"
}, {
    "POIID": "185822",
    "POIName": "研究",
    "Telno": "(02)26511171",
    "Address": "台北市南港區研究院路2段14號"
}, {
    "POIID": "132998",
    "POIName": "胡適",
    "Telno": "(02)26512201",
    "Address": "台北市南港區研究院路二段94號96號98巷1號"
}, {
    "POIID": "186353",
    "POIName": "香城",
    "Telno": "(02)26515362",
    "Address": "台北市南港區南港路一段167號1樓"
}, {
    "POIID": "135078",
    "POIName": "凱松",
    "Telno": "(02)27886050",
    "Address": "台北市南港區八德路四段778號780號"
}, {
    "POIID": "144326",
    "POIName": "港泰",
    "Telno": "(02)26512992",
    "Address": "台北市南港區忠孝東路七段359號1樓"
}, {
    "POIID": "166843",
    "POIName": "港高鐵",
    "Telno": "(02)26517743",
    "Address": "台北市南港區南港路一段313號B2"
}, {
    "POIID": "182856",
    "POIName": "港捷",
    "Telno": "(02)26519408",
    "Address": "台北市南港區經貿二路1號"
}, {
    "POIID": "169864",
    "POIName": "港運",
    "Telno": "(02)27859920",
    "Address": "台北市南港區玉成街69號1樓"
}, {
    "POIID": "186076",
    "POIName": "港德",
    "Telno": "(02)27857774",
    "Address": "台北市南港區福德街373巷25號"
}, {
    "POIID": "159384",
    "POIName": "港興",
    "Telno": "(02)26516380",
    "Address": "台北市南港區興華路119號121號123號125號"
}, {
    "POIID": "166865",
    "POIName": "港環球",
    "Telno": "(02)27839784",
    "Address": "台北市南港區忠孝東路七段371號B2"
}, {
    "POIID": "142870",
    "POIName": "華技",
    "Telno": "(02)27835010",
    "Address": "台北市南港區研究院路三段72號74號1樓"
}, {
    "POIID": "912813",
    "POIName": "華院",
    "Telno": "(02)27851509",
    "Address": "台北市南港區研究院路三段234號"
}, {
    "POIID": "188326",
    "POIName": "雄強",
    "Telno": "(02)26516017",
    "Address": "台北市南港區忠孝東路六段276號"
}, {
    "POIID": "902805",
    "POIName": "慈愛",
    "Telno": "(02)26513567",
    "Address": "台北市南港區重陽路164號"
}, {
    "POIID": "164641",
    "POIName": "新福玉",
    "Telno": "(02)27853061",
    "Address": "台北市南港區成福路145號147號"
}, {
    "POIID": "127516",
    "POIName": "經貿",
    "Telno": "(02)27820489",
    "Address": "台北市南港區三重路19號1樓"
}, {
    "POIID": "138815",
    "POIName": "聯成",
    "Telno": "(02)27893542",
    "Address": "台北市南港區聯成里昆陽街150-1號150-3號"
}, {
    "POIID": "976633",
    "POIName": "聯坊",
    "Telno": "(02)27893915",
    "Address": "台北市南港區東新街118巷1號"
}, {
    "POIID": "991182",
    "POIName": "馥樺",
    "Telno": "(02)26521390",
    "Address": "台北市南港區三重路23號1樓"
}, {
    "POIID": "170864",
    "POIName": "鵬馳",
    "Telno": "(02)27833783",
    "Address": "台北市南港區南港路三段49-1號"
}, {
    "POIID": "896458",
    "POIName": "耀港",
    "Telno": "(02)27881332",
    "Address": "台北市南港區研究院路一段99號1樓之14"
}, {
    "POIID": "142917",
    "POIName": "鑫貿",
    "Telno": "(02)27837329",
    "Address": "台北市南港區經貿二路168號4樓"
}, ], [{
    "POIID": "186401",
    "POIName": "大眾",
    "Telno": "(02)26586048",
    "Address": "台北市內湖區港墘路221巷41號1樓"
}, {
    "POIID": "147462",
    "POIName": "大潤發",
    "Telno": "(02)27967031",
    "Address": "台北市內湖區舊宗路一段128號"
}, {
    "POIID": "982915",
    "POIName": "日內瓦",
    "Telno": "(02)87912964",
    "Address": "台北市內湖區瑞光路76巷59號1樓"
}, {
    "POIID": "154507",
    "POIName": "民東",
    "Telno": "(02)27949878",
    "Address": "台北市內湖區民權東路6段82號1樓"
}, {
    "POIID": "187862",
    "POIName": "全球",
    "Telno": "(02)87927149",
    "Address": "台北市內湖區新湖二路329號1樓"
}, {
    "POIID": "158303",
    "POIName": "名寶",
    "Telno": "(02)87914208",
    "Address": "台北市內湖區民權東路6段180巷17號19號"
}, {
    "POIID": "183435",
    "POIName": "安保",
    "Telno": "(02)27953964",
    "Address": "台北市內湖區安康路28號1樓"
}, {
    "POIID": "860770",
    "POIName": "成功",
    "Telno": "(02)27929460",
    "Address": "台北市內湖區成功路二段252號"
}, {
    "POIID": "159513",
    "POIName": "成美",
    "Telno": "(02)27911006",
    "Address": "台北市內湖區新明路317號"
}, {
    "POIID": "961848",
    "POIName": "成湖",
    "Telno": "(02)87910570",
    "Address": "台北市內湖區成功路四段346號"
}, {
    "POIID": "188452",
    "POIName": "行龍",
    "Telno": "(02)27917850",
    "Address": "台北市內湖區行愛路128號"
}, {
    "POIID": "171085",
    "POIName": "西武",
    "Telno": "(02)26279171",
    "Address": "台北市內湖區內湖路一段285巷65弄3號5號1樓"
}, {
    "POIID": "962391",
    "POIName": "西湖",
    "Telno": "(02)27988882",
    "Address": "台北市內湖區內湖路一段321號"
}, {
    "POIID": "122452",
    "POIName": "克里斯",
    "Telno": "(02)26327140",
    "Address": "台北市內湖區五分街33號35號1樓"
}, {
    "POIID": "113089",
    "POIName": "秀湖",
    "Telno": "(02)27960399",
    "Address": "台北市內湖區成功路4段359號1樓"
}, {
    "POIID": "148708",
    "POIName": "見晴",
    "Telno": "(02)26599918",
    "Address": "台北市內湖區瑞光路196號"
}, {
    "POIID": "158912",
    "POIName": "里昂",
    "Telno": "(02)87514839",
    "Address": "台北市內湖區瑞光路406號1樓"
}, {
    "POIID": "177485",
    "POIName": "明湖",
    "Telno": "(02)26323734",
    "Address": "台北市內湖區東湖路45號"
}, {
    "POIID": "171720",
    "POIName": "欣福",
    "Telno": "(02)27916033",
    "Address": "台北市內湖區民權東路6段120巷7弄8號"
}, {
    "POIID": "136222",
    "POIName": "金湖",
    "Telno": "(02)26583308",
    "Address": "台北市內湖區文湖街83號1樓"
}, {
    "POIID": "962139",
    "POIName": "金雲",
    "Telno": "(02)27945804",
    "Address": "台北市內湖區星雲街136號"
}, {
    "POIID": "177289",
    "POIName": "金碧",
    "Telno": "(02)27921145",
    "Address": "台北市內湖區金龍路215號1樓"
}, {
    "POIID": "962416",
    "POIName": "金德",
    "Telno": "(02)87923496",
    "Address": "台北市內湖區金龍路5號1F"
}, {
    "POIID": "122430",
    "POIName": "金龍",
    "Telno": "(02)87917475",
    "Address": "台北市內湖區內湖路二段407號409號1樓"
}, {
    "POIID": "137111",
    "POIName": "金聯發",
    "Telno": "(02)87922259",
    "Address": "台北市內湖區內湖路三段141巷7號"
}, {
    "POIID": "991850",
    "POIName": "長鴻",
    "Telno": "(02)87910970",
    "Address": "台北市內湖區大湖山莊街219巷6號8號1樓"
}, {
    "POIID": "189400",
    "POIName": "星成",
    "Telno": "(02)27942674",
    "Address": "台北市內湖區星雲街17號"
}, {
    "POIID": "170314",
    "POIName": "洲子",
    "Telno": "(02)26586174",
    "Address": "台北市內湖區瑞光路517號1樓"
}, {
    "POIID": "186179",
    "POIName": "悅來",
    "Telno": "(02)26338912",
    "Address": "台北市內湖區五分街9號11號1樓"
}, {
    "POIID": "882792",
    "POIName": "晏揚",
    "Telno": "(02)26345565",
    "Address": "台北市內湖區康寧路三段99巷14號"
}, {
    "POIID": "186124",
    "POIName": "參龍",
    "Telno": "(02)27939884",
    "Address": "台北市內湖區行善路64號"
}, {
    "POIID": "158118",
    "POIName": "國醫",
    "Telno": "(02)87929421",
    "Address": "台北市內湖區成功路2段325號1樓"
}, {
    "POIID": "975434",
    "POIName": "康明",
    "Telno": "(02)26309123",
    "Address": "台北市內湖區康寧路三段165巷23弄1號"
}, {
    "POIID": "165334",
    "POIName": "康雲",
    "Telno": "(02)27922754",
    "Address": "台北市內湖區康寧路一段160號"
}, {
    "POIID": "148281",
    "POIName": "康葫",
    "Telno": "(02)26317093",
    "Address": "台北市內湖區民權東路六段296巷3號1樓"
}, {
    "POIID": "948502",
    "POIName": "康寧",
    "Telno": "(02)26328942",
    "Address": "台北市內湖區康寧路三段26巷1號"
}, {
    "POIID": "900913",
    "POIName": "康醫",
    "Telno": "(02)26347094",
    "Address": "台北市內湖區成功路5段420巷30號"
}, {
    "POIID": "185888",
    "POIName": "彩龍",
    "Telno": "(02)87902990",
    "Address": "台北市內湖區行善路35號1F"
}, {
    "POIID": "123123",
    "POIName": "清圳",
    "Telno": "(02)26329402",
    "Address": "台北市內湖區東湖路113巷88號"
}, {
    "POIID": "968643",
    "POIName": "清湖",
    "Telno": "(02)27901341",
    "Address": "台北市內湖區金湖路49號1樓"
}, {
    "POIID": "181200",
    "POIName": "堤頂",
    "Telno": "(02)26597738",
    "Address": "台北市內湖區堤頂大道二段411號1樓"
}, {
    "POIID": "185338",
    "POIName": "富港",
    "Telno": "(02)87512984",
    "Address": "台北市內湖區港墘路46號48號1樓"
}, {
    "POIID": "110828",
    "POIName": "港華",
    "Telno": "(02)27986183",
    "Address": "台北市內湖區港華街40號1樓"
}, {
    "POIID": "960638",
    "POIName": "港鑫",
    "Telno": "(02)26270994",
    "Address": "台北市內湖區內湖路1段737巷35號"
}, {
    "POIID": "181451",
    "POIName": "湖光",
    "Telno": "(02)87513447",
    "Address": "台北市內湖區基湖路35巷13號1樓"
}, {
    "POIID": "189411",
    "POIName": "紫陽",
    "Telno": "(02)87512875",
    "Address": "台北市內湖區紫陽里陽光街159號"
}, {
    "POIID": "964869",
    "POIName": "紫新",
    "Telno": "(02)87920524",
    "Address": "台北市內湖區成功路三段201號1樓"
}, {
    "POIID": "956743",
    "POIName": "華經",
    "Telno": "(02)27906651",
    "Address": "台北市內湖區行忠路30號"
}, {
    "POIID": "999083",
    "POIName": "匯陽",
    "Telno": "(02)87977391",
    "Address": "台北市內湖區陽光街383號"
}, {
    "POIID": "952615",
    "POIName": "新潭美",
    "Telno": "(02)27942796",
    "Address": "台北市內湖區新明路425號427號"
}, {
    "POIID": "137100",
    "POIName": "瑞江",
    "Telno": "(02)26587055",
    "Address": "台北市內湖區瑞陽里江南街71巷16弄76號"
}, {
    "POIID": "171199",
    "POIName": "瑞和",
    "Telno": "(02)26584041",
    "Address": "台北市內湖區瑞光路316巷56號1樓"
}, {
    "POIID": "159454",
    "POIName": "瑞東",
    "Telno": "(02)87514830",
    "Address": "台北市內湖區洲子街102號1樓"
}, {
    "POIID": "166094",
    "POIName": "瑞富",
    "Telno": "(02)26589047",
    "Address": "台北市內湖區瑞光路188巷51號1樓"
}, {
    "POIID": "183996",
    "POIName": "瑞景",
    "Telno": "(02)87513436",
    "Address": "台北市內湖區瑞光路583巷30號1樓"
}, {
    "POIID": "163822",
    "POIName": "瑞湖",
    "Telno": "(02)26588016",
    "Address": "台北市內湖區江南街128號"
}, {
    "POIID": "903244",
    "POIName": "瑞寶",
    "Telno": "(02)87512228",
    "Address": "台北市內湖區瑞光路583巷27號1樓"
}, {
    "POIID": "985707",
    "POIName": "瑞鑫",
    "Telno": "(02)26579574",
    "Address": "台北市內湖區瑞光路580號"
}, {
    "POIID": "159292",
    "POIName": "達人",
    "Telno": "(02)27945695",
    "Address": "台北市內湖區內湖路2段249號251號"
}, {
    "POIID": "135104",
    "POIName": "碧綠",
    "Telno": "(02)87917023",
    "Address": "台北市內湖區內湖路三段59巷1號61號63號"
}, {
    "POIID": "127505",
    "POIName": "福湖",
    "Telno": "(02)26274816",
    "Address": "台北市內湖區內湖路一段411巷17號19弄1號"
}, {
    "POIID": "190226",
    "POIName": "墘都",
    "Telno": "(02)87977260",
    "Address": "台北市內湖區內湖路一段669號"
}, {
    "POIID": "864325",
    "POIName": "德成",
    "Telno": "(02)27954608",
    "Address": "台北市內湖區內湖路2段366號"
}, {
    "POIID": "900636",
    "POIName": "德福",
    "Telno": "(02)27943371",
    "Address": "台北市內湖區成功路4段30巷27號29號31號"
}, {
    "POIID": "902861",
    "POIName": "德馨",
    "Telno": "(02)87511020",
    "Address": "台北市內湖區洲子街46號"
}, {
    "POIID": "166614",
    "POIName": "樂湖",
    "Telno": "(02)26306567",
    "Address": "台北市內湖區東湖路120號1樓"
}, {
    "POIID": "166474",
    "POIName": "樂陽",
    "Telno": "(02)26597352",
    "Address": "台北市內湖區陽光街349號1樓"
}, {
    "POIID": "114772",
    "POIName": "環金",
    "Telno": "(02)27997036",
    "Address": "台北市內湖區環山路二段81號83號1樓"
}, {
    "POIID": "143172",
    "POIName": "環湖",
    "Telno": "(02)87974566",
    "Address": "台北市內湖區環山路一段70號"
}, {
    "POIID": "190477",
    "POIName": "麗安",
    "Telno": "(02)26274284",
    "Address": "台北市內湖區內湖路一段445號1樓"
}, {
    "POIID": "148823",
    "POIName": "瓏山林",
    "Telno": "(02)26329723",
    "Address": "台北市內湖區康樂街125巷2號"
}, {
    "POIID": "164733",
    "POIName": "瓏馬",
    "Telno": "(02)26342774",
    "Address": "台北市內湖區康樂街213號"
}, {
    "POIID": "913621",
    "POIName": "馨瑩",
    "Telno": "(02)26574995",
    "Address": "台北市內湖區內湖路一段91巷2號"
}, {
    "POIID": "173874",
    "POIName": "權金",
    "Telno": "(02)26324440",
    "Address": "台北市內湖區金湖路405號1樓"
}, {
    "POIID": "119261",
    "POIName": "鑫文德",
    "Telno": "(02)87977622",
    "Address": "台北市內湖區文德路99號1樓"
}, {
    "POIID": "980355",
    "POIName": "鑫江南",
    "Telno": "(02)26589241",
    "Address": "台北市內湖區文德路6號1樓"
}, {
    "POIID": "972893",
    "POIName": "鑫碁泰",
    "Telno": "(02)26347648",
    "Address": "台北市內湖區康寧路三段63號65號67號"
}, {
    "POIID": "158657",
    "POIName": "鑫輝煌",
    "Telno": "(02)26311820",
    "Address": "台北市內湖區東湖路119巷49弄2號1樓"
}, ], [{
    "POIID": "174028",
    "POIName": "三玉",
    "Telno": "(02)28744580",
    "Address": "台北市士林區天母東路88之1號1樓"
}, {
    "POIID": "131984",
    "POIName": "三樂",
    "Telno": "(02)28832921",
    "Address": "台北市士林區劍潭路21號1樓"
}, {
    "POIID": "131401",
    "POIName": "士正",
    "Telno": "(02)28813350",
    "Address": "台北市士林區中正路301號1樓"
}, {
    "POIID": "955348",
    "POIName": "士東",
    "Telno": "(02)28359152",
    "Address": "台北市士林區士東路48號"
}, {
    "POIID": "146355",
    "POIName": "士鑽",
    "Telno": "(02)28820935",
    "Address": "台北市士林區文林路102號B1"
}, {
    "POIID": "148524",
    "POIName": "丹樺",
    "Telno": "(02)28314649",
    "Address": "台北市士林區文林路530號"
}, {
    "POIID": "139003",
    "POIName": "友成",
    "Telno": "(02)88112514",
    "Address": "台北市士林區社中街211號1樓"
}, {
    "POIID": "170587",
    "POIName": "天北",
    "Telno": "(02)28760659",
    "Address": "台北市士林區天母里天母西路39-1號1樓"
}, {
    "POIID": "935850",
    "POIName": "天東",
    "Telno": "(02)28734093",
    "Address": "台北市士林區中山北路7段14巷2-1號"
}, {
    "POIID": "129372",
    "POIName": "天美",
    "Telno": "(02)28762701",
    "Address": "台北市士林區天母東路8巷98號"
}, {
    "POIID": "154286",
    "POIName": "天真",
    "Telno": "(02)28728894",
    "Address": "台北市士林區中山北路7段141巷6之1號1樓"
}, {
    "POIID": "976286",
    "POIName": "天越",
    "Telno": "(02)28724484",
    "Address": "台北市士林區天母東路50巷25號"
}, {
    "POIID": "164559",
    "POIName": "天裕",
    "Telno": "(02)28724419",
    "Address": "台北市士林區中山北路七段156號1樓"
}, {
    "POIID": "177463",
    "POIName": "天福",
    "Telno": "(02)28762502",
    "Address": "台北市士林區天母東路8巷39號1樓"
}, {
    "POIID": "190075",
    "POIName": "天鑫",
    "Telno": "(02)28754546",
    "Address": "台北市士林區天玉街8號"
}, {
    "POIID": "132909",
    "POIName": "太學",
    "Telno": "(02)28627655",
    "Address": "台北市士林區華岡路45之1號1樓"
}, {
    "POIID": "928427",
    "POIName": "文大",
    "Telno": "(02)28623443",
    "Address": "台北市士林區格致路57號"
}, {
    "POIID": "127826",
    "POIName": "文林",
    "Telno": "(02)28810417",
    "Address": "台北市士林區大北路14號16號1樓"
}, {
    "POIID": "170473",
    "POIName": "文學",
    "Telno": "(02)28613776",
    "Address": "台北市士林區光華路26巷10號1樓"
}, {
    "POIID": "190293",
    "POIName": "冬樂",
    "Telno": "(02)28345642",
    "Address": "台北市士林區美崙街112號一樓"
}, {
    "POIID": "960513",
    "POIName": "至善天下",
    "Telno": "(02)28830232",
    "Address": "台北市士林區至善路二段264號"
}, {
    "POIID": "960948",
    "POIName": "至誠",
    "Telno": "(02)28359740",
    "Address": "台北市士林區至誠路二段31號"
}, {
    "POIID": "185567",
    "POIName": "兒樂",
    "Telno": "(02)28348349",
    "Address": "台北市士林區承德路五段55號"
}, {
    "POIID": "121127",
    "POIName": "承河",
    "Telno": "(02)28817180",
    "Address": "台北市士林區基河路132號1樓"
}, {
    "POIID": "135414",
    "POIName": "承富",
    "Telno": "(02)28862627",
    "Address": "台北市士林區承德路四段39號"
}, {
    "POIID": "187758",
    "POIName": "東洋",
    "Telno": "(02)28753409",
    "Address": "台北市士林區中山北路7段14巷19號Ｂ1"
}, {
    "POIID": "992945",
    "POIName": "社中",
    "Telno": "(02)28119270",
    "Address": "台北市士林區社中街320號322號1樓"
}, {
    "POIID": "187460",
    "POIName": "社鑽",
    "Telno": "(02)28137115",
    "Address": "台北市士林區中正路639號1樓"
}, {
    "POIID": "153238",
    "POIName": "芝山",
    "Telno": "(02)28316143",
    "Address": "台北市士林區福華路126號1樓"
}, {
    "POIID": "163707",
    "POIName": "芝玉",
    "Telno": "(02)28350887",
    "Address": "台北市士林區忠義街121號"
}, {
    "POIID": "111278",
    "POIName": "前港",
    "Telno": "(02)28818943",
    "Address": "台北市士林區後港街98之1號2號1樓"
}, {
    "POIID": "184726",
    "POIName": "洲美",
    "Telno": "(02)28162633",
    "Address": "台北市士林區延平北路六段505號"
}, {
    "POIID": "960775",
    "POIName": "草山",
    "Telno": "(02)28626422",
    "Address": "台北市士林區格致路28號"
}, {
    "POIID": "190617",
    "POIName": "凱立",
    "Telno": "(02)28329371",
    "Address": "台北市士林區忠義街68號"
}, {
    "POIID": "872832",
    "POIName": "華岡",
    "Telno": "(02)28625528",
    "Address": "台北市士林區光華路26巷7-1號"
}, {
    "POIID": "153261",
    "POIName": "華齡",
    "Telno": "(02)28835452",
    "Address": "台北市士林區華齡街17巷2號4號1樓"
}, {
    "POIID": "129132",
    "POIName": "集鑫",
    "Telno": "(02)28163245",
    "Address": "台北市士林區延平北路6段202號204號"
}, {
    "POIID": "132574",
    "POIName": "新士林",
    "Telno": "(02)28835732",
    "Address": "台北市士林區大東路123號125號1樓"
}, {
    "POIID": "131294",
    "POIName": "新天強",
    "Telno": "(02)28385947",
    "Address": "台北市士林區克強路11及11-1號1樓"
}, {
    "POIID": "957366",
    "POIName": "新文",
    "Telno": "(02)28353709",
    "Address": "台北市士林區文昌路64號"
}, {
    "POIID": "185578",
    "POIName": "新忠誠",
    "Telno": "(02)28314978",
    "Address": "台北市士林區中山北路6段18號20號1樓"
}, {
    "POIID": "140416",
    "POIName": "新承德",
    "Telno": "(02)28857157",
    "Address": "台北市士林區承德路4段30號"
}, {
    "POIID": "966278",
    "POIName": "新福慶",
    "Telno": "(02)28813445",
    "Address": "台北市士林區基河路1號1樓(部份)"
}, {
    "POIID": "161217",
    "POIName": "新劍潭",
    "Telno": "(02)28882016",
    "Address": "台北市士林區福港街246號"
}, {
    "POIID": "154297",
    "POIName": "葫東",
    "Telno": "(02)28137082",
    "Address": "台北市士林區延平北路五段228號230號1樓"
}, {
    "POIID": "151416",
    "POIName": "葫蘆",
    "Telno": "(02)28112919",
    "Address": "台北市士林區延平北路五段134號134-2號1樓"
}, {
    "POIID": "135377",
    "POIName": "誠義",
    "Telno": "(02)28353013",
    "Address": "台北市士林區忠誠路一段126號"
}, {
    "POIID": "890900",
    "POIName": "福志",
    "Telno": "(02)88663358",
    "Address": "台北市士林區雨農路25號"
}, {
    "POIID": "896160",
    "POIName": "福芝",
    "Telno": "(02)28358739",
    "Address": "台北市士林區福國路94號"
}, {
    "POIID": "170130",
    "POIName": "福氣",
    "Telno": "(02)28162416",
    "Address": "台北市士林區延平北路六段122號124號1樓"
}, {
    "POIID": "957193",
    "POIName": "福捷",
    "Telno": "(02)28839690",
    "Address": "台北市士林區中正路235巷14號"
}, {
    "POIID": "992381",
    "POIName": "福通",
    "Telno": "(02)28881028",
    "Address": "台北市士林區大南路400號402號1樓"
}, {
    "POIID": "161549",
    "POIName": "福陽",
    "Telno": "(02)28162119",
    "Address": "台北市士林區延平北路五段269號271號1樓"
}, {
    "POIID": "992370",
    "POIName": "福順",
    "Telno": "(02)28166747",
    "Address": "台北市士林區重慶北路4段149號151號1樓"
}, {
    "POIID": "901570",
    "POIName": "福溢",
    "Telno": "(02)28312758",
    "Address": "台北市士林區德行西路96號"
}, {
    "POIID": "171764",
    "POIName": "福榮",
    "Telno": "(02)28330676",
    "Address": "台北市士林區中正路220號222號"
}, {
    "POIID": "171432",
    "POIName": "福鑫",
    "Telno": "(02)28356026",
    "Address": "台北市士林區中正路324號"
}, {
    "POIID": "997571",
    "POIName": "聚鑫",
    "Telno": "(02)88111492",
    "Address": "台北市士林區延平北路六段350號"
}, {
    "POIID": "187954",
    "POIName": "銘傳",
    "Telno": "(02)28836632",
    "Address": "台北市士林區中山北路五段250號"
}, {
    "POIID": "190592",
    "POIName": "德天",
    "Telno": "(02)28344941",
    "Address": "台北市士林區德行西路52號1樓"
}, {
    "POIID": "128807",
    "POIName": "德行",
    "Telno": "(02)28341724",
    "Address": "台北市士林區忠誠路二段7號1樓"
}, {
    "POIID": "149549",
    "POIName": "德東",
    "Telno": "(02)28342488",
    "Address": "台北市士林區德行東路262號1樓"
}, {
    "POIID": "180861",
    "POIName": "德芝",
    "Telno": "(02)28347532",
    "Address": "台北市士林區士東路266巷5弄18號20號1樓"
}, {
    "POIID": "187541",
    "POIName": "德華",
    "Telno": "(02)28310427",
    "Address": "台北市士林區文林路669號1樓及B1"
}, {
    "POIID": "190097",
    "POIName": "德誠",
    "Telno": "(02)28344429",
    "Address": "台北市士林區德行東路106號108號1樓"
}, {
    "POIID": "181118",
    "POIName": "德寶",
    "Telno": "(02)28311750",
    "Address": "台北市士林區德行東路109巷102弄15號1樓"
}, {
    "POIID": "988326",
    "POIName": "豫鋒",
    "Telno": "(02)28832762",
    "Address": "台北市士林區大南路322號"
}, {
    "POIID": "185556",
    "POIName": "豐基",
    "Telno": "(02)28344187",
    "Address": "台北市士林區基河路368號370號"
}, {
    "POIID": "155223",
    "POIName": "蘭雅",
    "Telno": "(02)28345909",
    "Address": "台北市士林區德行東路6之2號1樓"
}, {
    "POIID": "982878",
    "POIName": "鑫仰德",
    "Telno": "(02)28618640",
    "Address": "台北市士林區仰德大道三段68號70號"
}, {
    "POIID": "167905",
    "POIName": "鑫港",
    "Telno": "(02)28836276",
    "Address": "台北市士林區後港街210號"
}, ], [{
    "POIID": "851721",
    "POIName": "一德",
    "Telno": "(02)28984000",
    "Address": "台北市北投區中央北路4段513號"
}, {
    "POIID": "187552",
    "POIName": "大中",
    "Telno": "(02)28963137",
    "Address": "台北市北投區中央南路一段114號"
}, {
    "POIID": "128874",
    "POIName": "中陽",
    "Telno": "(02)28953832",
    "Address": "台北市北投區中央北路三段55號57號1樓"
}, {
    "POIID": "155496",
    "POIName": "公岩",
    "Telno": "(02)28946735",
    "Address": "台北市北投區公館路259號1樓"
}, {
    "POIID": "936244",
    "POIName": "公館",
    "Telno": "(02)28965936",
    "Address": "台北市北投區公館路31號"
}, {
    "POIID": "980436",
    "POIName": "天富",
    "Telno": "(02)28226934",
    "Address": "台北市北投區富貴一路3號1樓"
}, {
    "POIID": "135975",
    "POIName": "加賀屋",
    "Telno": "(02)28941650",
    "Address": "台北市北投區溫泉路73巷5號地下二樓之1"
}, {
    "POIID": "136141",
    "POIName": "北投",
    "Telno": "(02)28941151",
    "Address": "台北市北投區中和街222號"
}, {
    "POIID": "962483",
    "POIName": "石捷",
    "Telno": "(02)28208526",
    "Address": "台北市北投區石牌路二段8號"
}, {
    "POIID": "165839",
    "POIName": "立農",
    "Telno": "(02)28203682",
    "Address": "台北市北投區承德路7段378號"
}, {
    "POIID": "935805",
    "POIName": "光中",
    "Telno": "(02)28971043",
    "Address": "台北市北投區光明路122號"
}, {
    "POIID": "181060",
    "POIName": "光寶",
    "Telno": "(02)28911841",
    "Address": "台北市北投區光明路132之2號1.2樓"
}, {
    "POIID": "128818",
    "POIName": "安遠",
    "Telno": "(02)28261043",
    "Address": "台北市北投區致遠二路149號"
}, {
    "POIID": "138778",
    "POIName": "百齡",
    "Telno": "(02)28209915",
    "Address": "台北市北投區石牌路一段35號"
}, {
    "POIID": "180067",
    "POIName": "行義",
    "Telno": "(02)28728452",
    "Address": "台北市北投區石牌路2段348巷1號3號1樓"
}, {
    "POIID": "187286",
    "POIName": "西安",
    "Telno": "(02)28949299",
    "Address": "台北市北投區大興街44號46號1樓"
}, {
    "POIID": "171166",
    "POIName": "秀山",
    "Telno": "(02)28947141",
    "Address": "台北市北投區中和街476號478號"
}, {
    "POIID": "993649",
    "POIName": "和信醫",
    "Telno": "(02)28936831",
    "Address": "台北市北投區立德路125號1樓"
}, {
    "POIID": "996637",
    "POIName": "和業",
    "Telno": "(02)28951924",
    "Address": "台北市北投區中和街10號"
}, {
    "POIID": "132976",
    "POIName": "和碩",
    "Telno": "(02)28988710",
    "Address": "台北市北投區立功街76號1樓"
}, {
    "POIID": "183859",
    "POIName": "和碩二",
    "Telno": "(02)28916312",
    "Address": "台北市北投區立德路150之3號B1樓"
}, {
    "POIID": "865454",
    "POIName": "奇岩",
    "Telno": "(02)28952945",
    "Address": "台北市北投區崇仁路一段76號"
}, {
    "POIID": "162885",
    "POIName": "明華",
    "Telno": "(02)28262195",
    "Address": "台北市北投區明德路99號"
}, {
    "POIID": "948649",
    "POIName": "明德",
    "Telno": "(02)28220224",
    "Address": "台北市北投區明德路114號"
}, {
    "POIID": "170071",
    "POIName": "東華",
    "Telno": "(02)28262900",
    "Address": "台北市北投區裕民一路40巷1號"
}, {
    "POIID": "139140",
    "POIName": "知心",
    "Telno": "(02)28585721",
    "Address": "台北市北投區知行路185號1樓"
}, {
    "POIID": "141604",
    "POIName": "金和",
    "Telno": "(02)28919043",
    "Address": "台北市北投區中和街314號316號1樓"
}, {
    "POIID": "149402",
    "POIName": "政戰",
    "Telno": "(02)28914209",
    "Address": "台北市北投區中央北路二段15號17號"
}, {
    "POIID": "993720",
    "POIName": "春天",
    "Telno": "(02)28950720",
    "Address": "台北市北投區泉源路12-1號1樓"
}, {
    "POIID": "138169",
    "POIName": "泉北",
    "Telno": "(02)28930420",
    "Address": "台北市北投區溫泉路70號"
}, {
    "POIID": "138170",
    "POIName": "泉源",
    "Telno": "(02)28975244",
    "Address": "台北市北投區泉源路30號地下一樓"
}, {
    "POIID": "874573",
    "POIName": "致遠",
    "Telno": "(02)28208072",
    "Address": "台北市北投區石牌路一段126號"
}, {
    "POIID": "928531",
    "POIName": "振華",
    "Telno": "(02)28218145",
    "Address": "台北市北投區石牌路2段80號82號"
}, {
    "POIID": "130637",
    "POIName": "振興醫",
    "Telno": "(02)28216509",
    "Address": "台北市北投區振興街45號B1"
}, {
    "POIID": "993454",
    "POIName": "清江",
    "Telno": "(02)28950047",
    "Address": "台北市北投區公館路165號1樓"
}, {
    "POIID": "128335",
    "POIName": "統勝",
    "Telno": "(02)28234063",
    "Address": "台北市北投區自強街82號"
}, {
    "POIID": "960753",
    "POIName": "富邦",
    "Telno": "(02)28214947",
    "Address": "台北市北投區實踐街22號24號"
}, {
    "POIID": "181369",
    "POIName": "華碩",
    "Telno": "(02)28917572",
    "Address": "台北市北投區立德路15號1樓"
}, {
    "POIID": "962209",
    "POIName": "新豪美",
    "Telno": "(02)28233553",
    "Address": "台北市北投區文林北路98號100號"
}, {
    "POIID": "186087",
    "POIName": "榮總",
    "Telno": "(02)28715743",
    "Address": "台北市北投區石牌路2段301號"
}, {
    "POIID": "185464",
    "POIName": "榮護",
    "Telno": "(02)28216943",
    "Address": "台北市北投區石牌路二段179號1樓"
}, {
    "POIID": "188005",
    "POIName": "福致",
    "Telno": "(02)28223783",
    "Address": "台北市北投區致遠一路二段49號51號1樓"
}, {
    "POIID": "167466",
    "POIName": "福瀛",
    "Telno": "(02)28239491",
    "Address": "台北市北投區西安街2段345號1樓"
}, {
    "POIID": "177038",
    "POIName": "德致",
    "Telno": "(02)28231984",
    "Address": "台北市北投區明德路87號89號1樓"
}, {
    "POIID": "964995",
    "POIName": "擎天崗",
    "Telno": "(02)28613652",
    "Address": "台北市北投區湖山路一段12號"
}, {
    "POIID": "936255",
    "POIName": "薇閣",
    "Telno": "(02)28944880",
    "Address": "台北市北投區中央北路一段108號"
}, {
    "POIID": "985626",
    "POIName": "雙全",
    "Telno": "(02)28940338",
    "Address": "台北市北投區中庸里大業路715-717號"
}, {
    "POIID": "972479",
    "POIName": "懷得",
    "Telno": "(02)28279042",
    "Address": "台北市北投區懷德街85號1樓"
}, {
    "POIID": "833332",
    "POIName": "關渡",
    "Telno": "(02)28581719",
    "Address": "台北市北投區知行路282號"
}, {
    "POIID": "190547",
    "POIName": "鐏賢",
    "Telno": "(02)28272331",
    "Address": "台北市北投區尊賢街247號"
}, {
    "POIID": "162221",
    "POIName": "護專",
    "Telno": "(02)28264184",
    "Address": "台北市北投區振興街31號"
}, ], ], [[{
    "POIID": "148498",
    "POIName": "八斗子",
    "Telno": "(02)24694510",
    "Address": "基隆市中正區北寧路327號1樓"
}, {
    "POIID": "906759",
    "POIName": "北寧",
    "Telno": "(02)24691825",
    "Address": "基隆市中正區北寧路382號382-5號"
}, {
    "POIID": "906553",
    "POIName": "正濱",
    "Telno": "(02)24632658",
    "Address": "基隆市中正區豊稔街27號"
}, {
    "POIID": "163604",
    "POIName": "旭東",
    "Telno": "(02)24274196",
    "Address": "基隆市中正區中正路54號"
}, {
    "POIID": "140597",
    "POIName": "和平島",
    "Telno": "(02)24629596",
    "Address": "基隆市中正區和一路125號127號"
}, {
    "POIID": "155522",
    "POIName": "和豐",
    "Telno": "(02)24698861",
    "Address": "基隆市中正區新豐街203號1樓"
}, {
    "POIID": "159373",
    "POIName": "哨船頭",
    "Telno": "(02)24289268",
    "Address": "基隆市中正區義一路43號1樓"
}, {
    "POIID": "185383",
    "POIName": "海洋",
    "Telno": "(02)24637174",
    "Address": "基隆市中正區中正路609號1樓"
}, {
    "POIID": "165806",
    "POIName": "財高",
    "Telno": "(02)24695318",
    "Address": "基隆市中正區新豐街381號383號"
}, {
    "POIID": "140748",
    "POIName": "祥濱",
    "Telno": "(02)24631972",
    "Address": "基隆市中正區建國里祥豐街339號"
}, {
    "POIID": "164065",
    "POIName": "新財發",
    "Telno": "(02)24697904",
    "Address": "基隆市中正區新豐街303巷11弄1號3號1樓"
}, {
    "POIID": "161295",
    "POIName": "漁港",
    "Telno": "(02)24634393",
    "Address": "基隆市中正區中正路672號"
}, {
    "POIID": "886303",
    "POIName": "龍騰",
    "Telno": "(02)24264670",
    "Address": "基隆市中正區義一路22號24號"
}, {
    "POIID": "928368",
    "POIName": "豐勝",
    "Telno": "(02)24631011",
    "Address": "基隆市中正區中正路322號"
}, ], [{
    "POIID": "171007",
    "POIName": "七堵",
    "Telno": "(02)24562044",
    "Address": "基隆市七堵區明德一路174號"
}, {
    "POIID": "154596",
    "POIName": "七堵站",
    "Telno": "(02)24567295",
    "Address": "基隆市七堵區東新街2號1樓"
}, {
    "POIID": "163512",
    "POIName": "六工",
    "Telno": "(02)24529983",
    "Address": "基隆市七堵區工建路1之22號1之23號1樓"
}, {
    "POIID": "891246",
    "POIName": "巧龍",
    "Telno": "(02)24517061",
    "Address": "基隆市七堵區百三街61號"
}, {
    "POIID": "132415",
    "POIName": "正光",
    "Telno": "(02)24564983",
    "Address": "基隆市七堵區自治街9號11號"
}, {
    "POIID": "154769",
    "POIName": "永富",
    "Telno": "(02)24557494",
    "Address": "基隆市七堵區永富路99號101號103號1樓"
}, {
    "POIID": "144670",
    "POIName": "華新一",
    "Telno": "(02)24519705",
    "Address": "基隆市七堵區華新一路22號26號1樓"
}, {
    "POIID": "127114",
    "POIName": "新五福",
    "Telno": "(02)24529901",
    "Address": "基隆市七堵區福五街80號82號1樓"
}, {
    "POIID": "141338",
    "POIName": "福聚",
    "Telno": "(02)24524570",
    "Address": "基隆市七堵區實踐路286號福二街229號1樓"
}, {
    "POIID": "119216",
    "POIName": "篤鑫",
    "Telno": "(02)24527780",
    "Address": "基隆市七堵區堵南街22-1號1樓"
}, ], [{
    "POIID": "170967",
    "POIName": "八堵站",
    "Telno": "(02)24565483",
    "Address": "基隆市暖暖區八堵路142號"
}, {
    "POIID": "971292",
    "POIName": "新暖東",
    "Telno": "(02)24580719",
    "Address": "基隆市暖暖區暖暖街177號1樓"
}, {
    "POIID": "993856",
    "POIName": "暖碇",
    "Telno": "(02)24595262",
    "Address": "基隆市暖暖區碇內街9號11號"
}, {
    "POIID": "127103",
    "POIName": "暖鑫",
    "Telno": "(02)24585245",
    "Address": "基隆市暖暖區暖暖街554號"
}, {
    "POIID": "977142",
    "POIName": "源遠",
    "Telno": "(02)24575289",
    "Address": "基隆市暖暖區源遠路296號"
}, {
    "POIID": "112879",
    "POIName": "碇內",
    "Telno": "(02)24586443",
    "Address": "基隆市暖暖區源遠路158號160號"
}, ], [{
    "POIID": "990879",
    "POIName": "大武崙",
    "Telno": "(02)24345690",
    "Address": "基隆市安樂區基金一路381號383號1樓"
}, {
    "POIID": "151830",
    "POIName": "大武嶺",
    "Telno": "(02)24348246",
    "Address": "基隆市安樂區大武嶺里基金一路135巷21弄2-1號"
}, {
    "POIID": "184689",
    "POIName": "安一",
    "Telno": "(02)24260343",
    "Address": "基隆市安樂區安一路172及174號"
}, {
    "POIID": "154840",
    "POIName": "武訓",
    "Telno": "(02)24329441",
    "Address": "基隆市安樂區武訓街102號1樓"
}, {
    "POIID": "170886",
    "POIName": "基金",
    "Telno": "(02)34010722",
    "Address": "基隆市安樂區麥金路197號1樓"
}, {
    "POIID": "187530",
    "POIName": "麥金",
    "Telno": "(02)34011778",
    "Address": "基隆市安樂區基金三路80號80-1號"
}, {
    "POIID": "118866",
    "POIName": "新壯觀",
    "Telno": "(02)24335384",
    "Address": "基隆市安樂區麥金路64號1樓"
}, {
    "POIID": "139313",
    "POIName": "新武嶺",
    "Telno": "(02)24334459",
    "Address": "基隆市安樂區基金一路168號"
}, {
    "POIID": "942478",
    "POIName": "新金樂",
    "Telno": "(02)34010954",
    "Address": "基隆市安樂區麥金路427號"
}, {
    "POIID": "164593",
    "POIName": "新長基",
    "Telno": "(02)24336241",
    "Address": "基隆市安樂區安樂路二段161號"
}, {
    "POIID": "161468",
    "POIName": "瑞金",
    "Telno": "(02)24344408",
    "Address": "基隆市安樂區基金三路75-1號"
}, {
    "POIID": "183239",
    "POIName": "樂添",
    "Telno": "(02)24347940",
    "Address": "基隆市安樂區樂利二街62巷291號2樓292號293號1樓"
}, ], [{
    "POIID": "119788",
    "POIName": "富華",
    "Telno": "(02)24369132",
    "Address": "基隆市中山區中華路9號"
}, {
    "POIID": "185176",
    "POIName": "新大慶",
    "Telno": "(02)24367046",
    "Address": "基隆市中山區中和路168巷7弄13號15號1樓"
}, {
    "POIID": "118419",
    "POIName": "聖心",
    "Telno": "(02)24249719",
    "Address": "基隆市中山區西定路38號40號"
}, {
    "POIID": "113746",
    "POIName": "德欣",
    "Telno": "(02)24378991",
    "Address": "基隆市中山區復興路328號之6號之7號1樓"
}, {
    "POIID": "170255",
    "POIName": "德復",
    "Telno": "(02)24374364",
    "Address": "基隆市中山區復興路197號"
}, ], [{
    "POIID": "989086",
    "POIName": "仁五",
    "Telno": "(02)24258951",
    "Address": "基隆市仁愛區仁五路63號2-1號"
}, {
    "POIID": "996730",
    "POIName": "孝三",
    "Telno": "(02)24287460",
    "Address": "基隆市仁愛區孝三路89號91號1樓"
}, {
    "POIID": "117623",
    "POIName": "忠三",
    "Telno": "(02)24273391",
    "Address": "基隆市仁愛區忠三路52之1號54號1樓"
}, {
    "POIID": "143699",
    "POIName": "崁頂",
    "Telno": "(02)24264442",
    "Address": "基隆市仁愛區仁四路60號62號1樓"
}, {
    "POIID": "180986",
    "POIName": "基隆",
    "Telno": "(02)24280407",
    "Address": "基隆市仁愛區仁二路236號"
}, {
    "POIID": "128900",
    "POIName": "港西",
    "Telno": "(02)24259886",
    "Address": "基隆市仁愛區港西街6-2號"
}, {
    "POIID": "147978",
    "POIName": "愛六",
    "Telno": "(02)24272836",
    "Address": "基隆市仁愛區仁一路275號"
}, {
    "POIID": "159177",
    "POIName": "愛鑫",
    "Telno": "(02)24269831",
    "Address": "基隆市仁愛區愛二路65號"
}, {
    "POIID": "179827",
    "POIName": "新仁二",
    "Telno": "(02)24264807",
    "Address": "基隆市仁愛區仁二路11號13號1樓"
}, {
    "POIID": "182683",
    "POIName": "新基隆一",
    "Telno": "(02)24278597",
    "Address": "基隆市仁愛區港西街5號"
}, {
    "POIID": "940977",
    "POIName": "新華成",
    "Telno": "(02)24339873",
    "Address": "基隆市仁愛區成功一路115號117號"
}, {
    "POIID": "171155",
    "POIName": "新福成",
    "Telno": "(02)24274348",
    "Address": "基隆市仁愛區仁二路84號86號1樓"
}, {
    "POIID": "184874",
    "POIName": "新廟口",
    "Telno": "(02)24227687",
    "Address": "基隆市仁愛區仁二路228號1樓"
}, {
    "POIID": "155625",
    "POIName": "極上",
    "Telno": "(02)24257644",
    "Address": "基隆市仁愛區仁三路66號愛二路54巷10號1樓"
}, {
    "POIID": "981233",
    "POIName": "極品",
    "Telno": "(02)24256943",
    "Address": "基隆市仁愛區仁三路19號21號1樓"
}, {
    "POIID": "112477",
    "POIName": "極緻",
    "Telno": "(02)24274717",
    "Address": "基隆市仁愛區仁二路197號1樓"
}, {
    "POIID": "970738",
    "POIName": "慶龍",
    "Telno": "(02)24264929",
    "Address": "基隆市仁愛區南榮路187號1樓"
}, ], [{
    "POIID": "962313",
    "POIName": "坤海",
    "Telno": "(02)24658451",
    "Address": "基隆市信義區東明路69號"
}, {
    "POIID": "903819",
    "POIName": "杰昕",
    "Telno": "(02)24236427",
    "Address": "基隆市信義區信二路243號245號"
}, {
    "POIID": "892272",
    "POIName": "信二",
    "Telno": "(02)24287557",
    "Address": "基隆市信義區信二路167號"
}, {
    "POIID": "174040",
    "POIName": "基醫",
    "Telno": "(02)24257678",
    "Address": "基隆市信義區信二路268號1樓"
}, {
    "POIID": "989422",
    "POIName": "崇信",
    "Telno": "(02)24684284",
    "Address": "基隆市信義區東信路166號168號1F"
}, {
    "POIID": "951003",
    "POIName": "深美",
    "Telno": "(02)24664831",
    "Address": "基隆市信義區深美街196號"
}, {
    "POIID": "117896",
    "POIName": "深澳坑",
    "Telno": "(02)24685466",
    "Address": "基隆市信義區深澳坑路2-6號2-7號"
}, {
    "POIID": "138697",
    "POIName": "新福樂",
    "Telno": "(02)24683607",
    "Address": "基隆市信義區深溪路43號45號1樓"
}, {
    "POIID": "123525",
    "POIName": "滿福",
    "Telno": "(02)24684530",
    "Address": "基隆市信義區深澳坑路166之30號1樓"
}, {
    "POIID": "117140",
    "POIName": "德信",
    "Telno": "(02)24669681",
    "Address": "基隆市信義區東信路50號52號"
}, ], ], [[{
    "POIID": "872441",
    "POIName": "千群",
    "Telno": "(02)89612979",
    "Address": "新北市板橋區東丘里民享街53號"
}, {
    "POIID": "125509",
    "POIName": "大庭",
    "Telno": "(02)29607369",
    "Address": "新北市板橋區國光里6鄰國光路65號1樓"
}, {
    "POIID": "992037",
    "POIName": "中一",
    "Telno": "(02)29654415",
    "Address": "新北市板橋區中正路332之5號1樓"
}, {
    "POIID": "977485",
    "POIName": "心心",
    "Telno": "(02)29584608",
    "Address": "新北市板橋區實踐路105號107號"
}, {
    "POIID": "188223",
    "POIName": "文聖",
    "Telno": "(02)22589508",
    "Address": "新北市板橋區文聖街64號"
}, {
    "POIID": "153423",
    "POIName": "台藝大",
    "Telno": "(02)89654552",
    "Address": "新北市板橋區大觀路一段59號"
}, {
    "POIID": "135388",
    "POIName": "正泰",
    "Telno": "(02)29622750",
    "Address": "新北市板橋區三民路二段202-20及21號1樓"
}, {
    "POIID": "165297",
    "POIName": "正華",
    "Telno": "(02)29681440",
    "Address": "新北市板橋區中正路274號276號"
}, {
    "POIID": "985534",
    "POIName": "正隆",
    "Telno": "(02)29567793",
    "Address": "新北市板橋區民生路一段53號"
}, {
    "POIID": "135034",
    "POIName": "民族",
    "Telno": "(02)29575939",
    "Address": "新北市板橋區福祿里民族路310號"
}, {
    "POIID": "165448",
    "POIName": "光仁",
    "Telno": "(02)29592301",
    "Address": "新北市板橋區中山路二段273號"
}, {
    "POIID": "135403",
    "POIName": "存德",
    "Telno": "(02)26758053",
    "Address": "新北市板橋區篤行路二段86號88號1樓"
}, {
    "POIID": "968791",
    "POIName": "成合",
    "Telno": "(02)86873728",
    "Address": "新北市板橋區金門街40號"
}, {
    "POIID": "181875",
    "POIName": "江翠",
    "Telno": "(02)22540316",
    "Address": "新北市板橋區文化路2段417巷8號1樓10號1樓2樓"
}, {
    "POIID": "132079",
    "POIName": "百壽",
    "Telno": "(02)22541758",
    "Address": "新北市板橋區文化路一段305號1樓"
}, {
    "POIID": "891730",
    "POIName": "佑容",
    "Telno": "(02)29595675",
    "Address": "新北市板橋區五權里五權街49號51號"
}, {
    "POIID": "171649",
    "POIName": "坤耀",
    "Telno": "(02)22723226",
    "Address": "新北市板橋區南門街39號1F"
}, {
    "POIID": "189499",
    "POIName": "幸運",
    "Telno": "(02)29614123",
    "Address": "新北市板橋區區運路21號"
}, {
    "POIID": "185785",
    "POIName": "府中",
    "Telno": "(02)29654479",
    "Address": "新北市板橋區府中路82號84號1樓"
}, {
    "POIID": "980942",
    "POIName": "府運",
    "Telno": "(02)29640712",
    "Address": "新北市板橋區重慶路18號20號1樓"
}, {
    "POIID": "902311",
    "POIName": "昇容",
    "Telno": "(02)29581032",
    "Address": "新北市板橋區重慶路346巷8號"
}, {
    "POIID": "174512",
    "POIName": "杰朋",
    "Telno": "(02)22574817",
    "Address": "新北市板橋區新海路385巷10弄11號"
}, {
    "POIID": "169808",
    "POIName": "板民",
    "Telno": "(02)29635213",
    "Address": "新北市板橋區三民路二段77號1樓"
}, {
    "POIID": "182166",
    "POIName": "板府",
    "Telno": "(02)29625901",
    "Address": "新北市板橋區中山路一段158巷4號6號1樓"
}, {
    "POIID": "190466",
    "POIName": "板信",
    "Telno": "(02)29647407",
    "Address": "新北市板橋區信義路142號144號146號1樓"
}, {
    "POIID": "967879",
    "POIName": "板站",
    "Telno": "(02)22727815",
    "Address": "新北市板橋區文化路一段54號B1樓(板站)"
}, {
    "POIID": "136554",
    "POIName": "板站北",
    "Telno": "(02)22729547",
    "Address": "新北市板橋區文化路一段54號(板站北)"
}, {
    "POIID": "975700",
    "POIName": "板站東",
    "Telno": "(02)22724021",
    "Address": "新北市板橋區文化路一段54號(板站東)"
}, {
    "POIID": "864060",
    "POIName": "板聖",
    "Telno": "(02)22524835",
    "Address": "新北市板橋區文化路二段472號"
}, {
    "POIID": "167846",
    "POIName": "板維",
    "Telno": "(02)22546684",
    "Address": "新北市板橋區四維路345號347號1樓"
}, {
    "POIID": "121208",
    "POIName": "板慶",
    "Telno": "(02)29556584",
    "Address": "新北市板橋區忠孝路37號1樓2樓"
}, {
    "POIID": "183398",
    "POIName": "板鐵",
    "Telno": "(02)89693012",
    "Address": "新北市板橋區縣民大道2段7號B1"
}, {
    "POIID": "148948",
    "POIName": "板權",
    "Telno": "(02)22720703",
    "Address": "新北市板橋區民權路198-200號"
}, {
    "POIID": "144393",
    "POIName": "松林",
    "Telno": "(02)22509964",
    "Address": "新北市板橋區松江街109巷1號松江街107號"
}, {
    "POIID": "159306",
    "POIName": "武江",
    "Telno": "(02)22504440",
    "Address": "新北市板橋區光武街2巷2號"
}, {
    "POIID": "141475",
    "POIName": "油庫口",
    "Telno": "(02)22569422",
    "Address": "新北市板橋區文化路一段188巷38號40號1樓"
}, {
    "POIID": "174992",
    "POIName": "金林",
    "Telno": "(02)26843135",
    "Address": "新北市板橋區金門街303號305號"
}, {
    "POIID": "136037",
    "POIName": "金園",
    "Telno": "(02)26864776",
    "Address": "新北市板橋區金門街175號"
}, {
    "POIID": "181853",
    "POIName": "金福",
    "Telno": "(02)26834061",
    "Address": "新北市板橋區金門街330號1樓"
}, {
    "POIID": "953663",
    "POIName": "青蘋果",
    "Telno": "(02)29629746",
    "Address": "新北市板橋區中山路2段531巷17弄20號"
}, {
    "POIID": "185246",
    "POIName": "南雅",
    "Telno": "(02)29654054",
    "Address": "新北市板橋區新興里南雅南路一段8號1樓"
}, {
    "POIID": "922533",
    "POIName": "建宗",
    "Telno": "(02)26852258",
    "Address": "新北市板橋區溪福里篤行路3段玉平巷76弄8號及10號"
}, {
    "POIID": "118512",
    "POIName": "建茗",
    "Telno": "(02)29565541",
    "Address": "新北市板橋區四川路一段104號"
}, {
    "POIID": "113779",
    "POIName": "春秋",
    "Telno": "(02)22567192",
    "Address": "新北市板橋區莒光路40巷14號16號"
}, {
    "POIID": "121323",
    "POIName": "秋雅",
    "Telno": "(02)89669323",
    "Address": "新北市板橋區南雅南路2段144巷14號1樓"
}, {
    "POIID": "148177",
    "POIName": "致理",
    "Telno": "(02)22556976",
    "Address": "新北市板橋區陽明街23巷29號1樓"
}, {
    "POIID": "158602",
    "POIName": "英海",
    "Telno": "(02)22511636",
    "Address": "新北市板橋區雨農路50號"
}, {
    "POIID": "922131",
    "POIName": "香雅",
    "Telno": "(02)29679674",
    "Address": "新北市板橋區南雅西路2段297號299號"
}, {
    "POIID": "185028",
    "POIName": "埔西",
    "Telno": "(02)22555399",
    "Address": "新北市板橋區文化路一段419之5號1樓"
}, {
    "POIID": "148041",
    "POIName": "埔站",
    "Telno": "(02)22552884",
    "Address": "新北市板橋區民生路二段247號1樓"
}, {
    "POIID": "161572",
    "POIName": "埔運",
    "Telno": "(02)82524260",
    "Address": "新北市板橋區民生路三段40號42號1樓"
}, {
    "POIID": "846660",
    "POIName": "埔墘",
    "Telno": "(02)29614894",
    "Address": "新北市板橋區永豐街87號"
}, {
    "POIID": "173737",
    "POIName": "家豐",
    "Telno": "(02)29573209",
    "Address": "新北市板橋區中山路二段137號1樓"
}, {
    "POIID": "137904",
    "POIName": "家麒",
    "Telno": "(02)22587476",
    "Address": "新北市板橋區宏國路27號"
}, {
    "POIID": "165792",
    "POIName": "海山",
    "Telno": "(02)89611889",
    "Address": "新北市板橋區漢生東路310號"
}, {
    "POIID": "901710",
    "POIName": "偉嘉",
    "Telno": "(02)22595486",
    "Address": "新北市板橋區文化路一段270巷3弄2號"
}, {
    "POIID": "924665",
    "POIName": "國和",
    "Telno": "(02)89526934",
    "Address": "新北市板橋區和平路29號"
}, {
    "POIID": "161424",
    "POIName": "國府",
    "Telno": "(02)89698428",
    "Address": "新北市板橋區國光路184號186號1樓"
}, {
    "POIID": "170244",
    "POIName": "國庭",
    "Telno": "(02)29651700",
    "Address": "新北市板橋區國光路1號3號1樓"
}, {
    "POIID": "158347",
    "POIName": "國慶",
    "Telno": "(02)29647052",
    "Address": "新北市板橋區國慶路151號"
}, {
    "POIID": "975537",
    "POIName": "勝多",
    "Telno": "(02)29613848",
    "Address": "新北市板橋區縣民大道三段270巷2-6號"
}, {
    "POIID": "174730",
    "POIName": "智樂",
    "Telno": "(02)29601143",
    "Address": "新北市板橋區新生街89巷2號"
}, {
    "POIID": "979263",
    "POIName": "華翠",
    "Telno": "(02)22555452",
    "Address": "新北市板橋區莒光路63號"
}, {
    "POIID": "163866",
    "POIName": "華德",
    "Telno": "(02)89664633",
    "Address": "新北市板橋區四川路2段47巷3弄8號及8之1號"
}, {
    "POIID": "153386",
    "POIName": "貴興",
    "Telno": "(02)29593301",
    "Address": "新北市板橋區貴興路25號27號1樓"
}, {
    "POIID": "170222",
    "POIName": "雅東",
    "Telno": "(02)29660592",
    "Address": "新北市板橋區南雅東路31之1號5號6號7號1樓"
}, {
    "POIID": "115823",
    "POIName": "雅盛",
    "Telno": "(02)29568540",
    "Address": "新北市板橋區漢生東路181號183號1樓"
}, {
    "POIID": "165552",
    "POIName": "園林",
    "Telno": "(02)89698424",
    "Address": "新北市板橋區南雅西路二段102號104號1樓"
}, {
    "POIID": "119825",
    "POIName": "新巨蛋",
    "Telno": "(02)22561484",
    "Address": "新北市板橋區長江路一段419號421號423號"
}, {
    "POIID": "147989",
    "POIName": "新兆圓",
    "Telno": "(02)89646258",
    "Address": "新北市板橋區實踐路34號34-1號1樓"
}, {
    "POIID": "143275",
    "POIName": "新亞醫",
    "Telno": "(02)89660864",
    "Address": "新北市板橋區南雅南路二段21號1樓2樓"
}, {
    "POIID": "118349",
    "POIName": "新板橋",
    "Telno": "(02)29686041",
    "Address": "新北市板橋區文化路1段135號"
}, {
    "POIID": "143183",
    "POIName": "新展",
    "Telno": "(02)89697978",
    "Address": "新北市板橋區大觀路二段185號1樓"
}, {
    "POIID": "146805",
    "POIName": "新海",
    "Telno": "(02)82525425",
    "Address": "新北市板橋區文德里新海路138號"
}, {
    "POIID": "968089",
    "POIName": "新僑中",
    "Telno": "(02)29694324",
    "Address": "新北市板橋區僑中一街124巷3弄3號"
}, {
    "POIID": "125613",
    "POIName": "新翠華",
    "Telno": "(02)29547438",
    "Address": "新北市板橋區三民路一段31巷14號16號"
}, {
    "POIID": "982579",
    "POIName": "新觀和",
    "Telno": "(02)22754553",
    "Address": "新北市板橋區大觀路二段55號57號1樓"
}, {
    "POIID": "122924",
    "POIName": "溪州",
    "Telno": "(02)86873740",
    "Address": "新北市板橋區溪崑二街108.110號1樓"
}, {
    "POIID": "185899",
    "POIName": "溪崑",
    "Telno": "(02)26829303",
    "Address": "新北市板橋區大觀路3段212巷70號72號1樓"
}, {
    "POIID": "158691",
    "POIName": "瑞林",
    "Telno": "(02)22588414",
    "Address": "新北市板橋區龍翠里大同街52號"
}, {
    "POIID": "126890",
    "POIName": "瑞新",
    "Telno": "(02)89683252",
    "Address": "新北市板橋區瑞安街75號"
}, {
    "POIID": "953087",
    "POIName": "萬板",
    "Telno": "(02)22519201",
    "Address": "新北市板橋區莒光路221號223號"
}, {
    "POIID": "128955",
    "POIName": "萬鄰",
    "Telno": "(02)22588121",
    "Address": "新北市板橋區華江里民生路二段226巷46號1樓"
}, {
    "POIID": "166898",
    "POIName": "裕民",
    "Telno": "(02)22571695",
    "Address": "新北市板橋區裕民街110號"
}, {
    "POIID": "188371",
    "POIName": "僑一",
    "Telno": "(02)29685784",
    "Address": "新北市板橋區僑中一街104號"
}, {
    "POIID": "171029",
    "POIName": "漢西",
    "Telno": "(02)22540140",
    "Address": "新北市板橋區漢生西路64號66號1樓"
}, {
    "POIID": "950745",
    "POIName": "漢東",
    "Telno": "(02)29534142",
    "Address": "新北市板橋區漢生東路309號"
}, {
    "POIID": "180148",
    "POIName": "維陽",
    "Telno": "(02)22544725",
    "Address": "新北市板橋區陽明街158號160號1樓"
}, {
    "POIID": "148546",
    "POIName": "維群",
    "Telno": "(02)22596008",
    "Address": "新北市板橋區四維路139號"
}, {
    "POIID": "183790",
    "POIName": "維禮",
    "Telno": "(02)82570705",
    "Address": "新北市板橋區四維路276號278號1樓"
}, {
    "POIID": "978662",
    "POIName": "遠揚",
    "Telno": "(02)89664602",
    "Address": "新北市板橋區南雅南路2段124號"
}, {
    "POIID": "170990",
    "POIName": "慶中",
    "Telno": "(02)29577176",
    "Address": "新北市板橋區重慶路194號光明街91號1樓"
}, {
    "POIID": "131490",
    "POIName": "樂福",
    "Telno": "(02)29633922",
    "Address": "新北市板橋區中山路二段304號306號1樓"
}, {
    "POIID": "921998",
    "POIName": "緯中",
    "Telno": "(02)29657833",
    "Address": "新北市板橋區中正路21號23號"
}, {
    "POIID": "163730",
    "POIName": "戰國",
    "Telno": "(02)29541991",
    "Address": "新北市板橋區永豐街173號175號"
}, {
    "POIID": "120364",
    "POIName": "樹中",
    "Telno": "(02)26861044",
    "Address": "新北市板橋區溪城路105號1樓"
}, {
    "POIID": "186799",
    "POIName": "縣東",
    "Telno": "(02)29628655",
    "Address": "新北市板橋區縣民大道二段108號1樓"
}, {
    "POIID": "151070",
    "POIName": "縣道",
    "Telno": "(02)29512083",
    "Address": "新北市板橋區縣民大道二段196號"
}, {
    "POIID": "128047",
    "POIName": "興板",
    "Telno": "(02)89678162",
    "Address": "新北市板橋區德興街22號24號"
}, {
    "POIID": "119397",
    "POIName": "館東",
    "Telno": "(02)29560071",
    "Address": "新北市板橋區館前東路17號"
}, {
    "POIID": "122887",
    "POIName": "館慶",
    "Telno": "(02)29514559",
    "Address": "新北市板橋區館前東路26號1樓"
}, {
    "POIID": "844907",
    "POIName": "龍翠",
    "Telno": "(02)22538130",
    "Address": "新北市板橋區雙十路二段138之1號138之2號"
}, {
    "POIID": "910688",
    "POIName": "糧驛",
    "Telno": "(02)22562936",
    "Address": "新北市板橋區德翠里龍泉街93號"
}, {
    "POIID": "931571",
    "POIName": "舊社",
    "Telno": "(02)29636183",
    "Address": "新北市板橋區中山路2段412號"
}, {
    "POIID": "185671",
    "POIName": "豐成",
    "Telno": "(02)29593790",
    "Address": "新北市板橋區三民路1段31巷89弄10號12號1樓"
}, {
    "POIID": "174062",
    "POIName": "雙源",
    "Telno": "(02)82527754",
    "Address": "新北市板橋區雙十路二段47巷30號32號"
}, {
    "POIID": "165688",
    "POIName": "馥都",
    "Telno": "(02)29640706",
    "Address": "新北市板橋區中山路二段399號401號"
}, {
    "POIID": "996279",
    "POIName": "懷民",
    "Telno": "(02)22504664",
    "Address": "新北市板橋區民治街111號"
}, {
    "POIID": "155186",
    "POIName": "懷翠",
    "Telno": "(02)22504367",
    "Address": "新北市板橋區懷德街203號205號1樓"
}, {
    "POIID": "855206",
    "POIName": "懷德",
    "Telno": "(02)22554373",
    "Address": "新北市板橋區懷德街55號57號"
}, {
    "POIID": "110301",
    "POIName": "耀心",
    "Telno": "(02)89541780",
    "Address": "新北市板橋區中山路一段50巷22-2-15-39-46號"
}, {
    "POIID": "865269",
    "POIName": "議會",
    "Telno": "(02)22542852",
    "Address": "新北市板橋區莊敬路60號"
}, {
    "POIID": "151380",
    "POIName": "觀泰",
    "Telno": "(02)29686509",
    "Address": "新北市板橋區大觀路2段174巷166弄2號4號"
}, {
    "POIID": "180816",
    "POIName": "觀龍",
    "Telno": "(02)22756709",
    "Address": "新北市板橋區龍興街39號41號1樓"
}, ], [{
    "POIID": "131157",
    "POIName": "三禾",
    "Telno": "(02)29818723",
    "Address": "新北市三重區大智街139號139之2號1樓"
}, {
    "POIID": "159465",
    "POIName": "三好",
    "Telno": "(02)89857653",
    "Address": "新北市三重區自強路四段102號104號1樓"
}, {
    "POIID": "128863",
    "POIName": "三安",
    "Telno": "(02)29835596",
    "Address": "新北市三重區正義北路235號"
}, {
    "POIID": "989411",
    "POIName": "三重",
    "Telno": "(02)29727244",
    "Address": "新北市三重區重新路3段18號"
}, {
    "POIID": "183893",
    "POIName": "三重一",
    "Telno": "(02)29747875",
    "Address": "新北市三重區正義南路133號135號"
}, {
    "POIID": "171568",
    "POIName": "下竹圍",
    "Telno": "(02)22800646",
    "Address": "新北市三重區下竹圍街26號"
}, {
    "POIID": "948638",
    "POIName": "大智",
    "Telno": "(02)29836622",
    "Address": "新北市三重區大同北路63號"
}, {
    "POIID": "130143",
    "POIName": "大興",
    "Telno": "(02)28577324",
    "Address": "新北市三重區仁華街80巷27號1樓"
}, {
    "POIID": "180953",
    "POIName": "川詠山",
    "Telno": "(02)28577239",
    "Address": "新北市三重區集賢路158號1樓"
}, {
    "POIID": "119179",
    "POIName": "中南",
    "Telno": "(02)29754553",
    "Address": "新北市三重區中正南路248-1號248-2號"
}, {
    "POIID": "996132",
    "POIName": "五華",
    "Telno": "(02)29889366",
    "Address": "新北市三重區五華街148號"
}, {
    "POIID": "991654",
    "POIName": "仁仁",
    "Telno": "(02)29763564",
    "Address": "新北市三重區仁愛街50號"
}, {
    "POIID": "120700",
    "POIName": "分子尾",
    "Telno": "(02)89857944",
    "Address": "新北市三重區仁愛街479號479之1號"
}, {
    "POIID": "137096",
    "POIName": "天台",
    "Telno": "(02)29771812",
    "Address": "新北市三重區仁德里正義南路13號15號1樓"
}, {
    "POIID": "996969",
    "POIName": "天勝",
    "Telno": "(02)28571747",
    "Address": "新北市三重區仁愛街687號"
}, {
    "POIID": "957333",
    "POIName": "天龍",
    "Telno": "(02)29775504",
    "Address": "新北市三重區龍門路217號219號221號"
}, {
    "POIID": "893873",
    "POIName": "文興",
    "Telno": "(02)89727842",
    "Address": "新北市三重區文化南路7號"
}, {
    "POIID": "164537",
    "POIName": "日揚",
    "Telno": "(02)89852787",
    "Address": "新北市三重區中正北路18之2號之3號之4號1樓"
}, {
    "POIID": "962586",
    "POIName": "平安",
    "Telno": "(02)29871687",
    "Address": "新北市三重區正義北路51號"
}, {
    "POIID": "996338",
    "POIName": "正大",
    "Telno": "(02)29841990",
    "Address": "新北市三重區中正北路235號"
}, {
    "POIID": "164238",
    "POIName": "正孝",
    "Telno": "(02)29867748",
    "Address": "新北市三重區中正北路151號153號"
}, {
    "POIID": "154862",
    "POIName": "正果",
    "Telno": "(02)89859885",
    "Address": "新北市三重區中正北路122號124號1樓"
}, {
    "POIID": "119755",
    "POIName": "正南",
    "Telno": "(02)29762825",
    "Address": "新北市三重區正義南路67號69號"
}, {
    "POIID": "189824",
    "POIName": "正強",
    "Telno": "(02)29817723",
    "Address": "新北市三重區自強路一段38號40號1樓"
}, {
    "POIID": "855217",
    "POIName": "正陽",
    "Telno": "(02)29822396",
    "Address": "新北市三重區正義北路386號388號"
}, {
    "POIID": "171225",
    "POIName": "正龍",
    "Telno": "(02)89814199",
    "Address": "新北市三重區正義北路332號"
}, {
    "POIID": "126616",
    "POIName": "立行",
    "Telno": "(02)82839480",
    "Address": "新北市三重區力行路2段160號"
}, {
    "POIID": "189466",
    "POIName": "立福",
    "Telno": "(02)29847213",
    "Address": "新北市三重區力行路一段60之1號60之2號1樓"
}, {
    "POIID": "171719",
    "POIName": "先嗇宮",
    "Telno": "(02)29990523",
    "Address": "新北市三重區光復路一段25號27號1樓"
}, {
    "POIID": "179632",
    "POIName": "合康",
    "Telno": "(02)22807405",
    "Address": "新北市三重區永福街179之1及179之2號1樓"
}, {
    "POIID": "137720",
    "POIName": "百利",
    "Telno": "(02)89827881",
    "Address": "新北市三重區仁義街208號"
}, {
    "POIID": "971100",
    "POIName": "百義",
    "Telno": "(02)89859414",
    "Address": "新北市三重區仁義街232號"
}, {
    "POIID": "845715",
    "POIName": "車路頭",
    "Telno": "(02)22800354",
    "Address": "新北市三重區車路頭街135號"
}, {
    "POIID": "119032",
    "POIName": "幸亞",
    "Telno": "(02)89853160",
    "Address": "新北市三重區溪尾街29號"
}, {
    "POIID": "832498",
    "POIName": "幸福",
    "Telno": "(02)29860690",
    "Address": "新北市三重區自強路1段272號"
}, {
    "POIID": "888158",
    "POIName": "明益",
    "Telno": "(02)89882175",
    "Address": "新北市三重區忠孝路三段61號"
}, {
    "POIID": "165666",
    "POIName": "長元",
    "Telno": "(02)29777863",
    "Address": "新北市三重區長元街2-2號"
}, {
    "POIID": "128782",
    "POIName": "長泰",
    "Telno": "(02)29787305",
    "Address": "新北市三重區介壽路1號"
}, {
    "POIID": "187297",
    "POIName": "長揚",
    "Telno": "(02)29786970",
    "Address": "新北市三重區三和路二段6號之2"
}, {
    "POIID": "167949",
    "POIName": "長壽",
    "Telno": "(02)29817585",
    "Address": "新北市三重區正義北路198號200號1樓"
}, {
    "POIID": "173667",
    "POIName": "前瞻",
    "Telno": "(02)29996424",
    "Address": "新北市三重區新北大道2段258號"
}, {
    "POIID": "170923",
    "POIName": "美吉",
    "Telno": "(02)29741941",
    "Address": "新北市三重區集美街240號"
}, {
    "POIID": "158945",
    "POIName": "美慈",
    "Telno": "(02)22860963",
    "Address": "新北市三重區慈愛街52號"
}, {
    "POIID": "113539",
    "POIName": "虹諭",
    "Telno": "(02)29848146",
    "Address": "新北市三重區中正北路193巷21弄43號"
}, {
    "POIID": "173999",
    "POIName": "重安",
    "Telno": "(02)29724075",
    "Address": "新北市三重區重安街60號及60-1號"
}, {
    "POIID": "142135",
    "POIName": "重美",
    "Telno": "(02)29748754",
    "Address": "新北市三重區重新路四段100號102號1樓"
}, {
    "POIID": "190400",
    "POIName": "重富",
    "Telno": "(02)28571641",
    "Address": "新北市三重區溪尾街321號323號1樓"
}, {
    "POIID": "122773",
    "POIName": "重智",
    "Telno": "(02)29869556",
    "Address": "新北市三重區大智街195號"
}, {
    "POIID": "147440",
    "POIName": "重華",
    "Telno": "(02)28579451",
    "Address": "新北市三重區五華街181號185號1樓"
}, {
    "POIID": "149284",
    "POIName": "重新",
    "Telno": "(02)29717873",
    "Address": "新北市三重區重新路四段45號"
}, {
    "POIID": "118408",
    "POIName": "重運",
    "Telno": "(02)22860431",
    "Address": "新北市三重區三和路四段111-1及111-2號1樓"
}, {
    "POIID": "141822",
    "POIName": "重樂",
    "Telno": "(02)28559436",
    "Address": "新北市三重區三信路196號1樓"
}, {
    "POIID": "187035",
    "POIName": "竑嘉",
    "Telno": "(02)29752331",
    "Address": "新北市三重區仁愛街32號之1"
}, {
    "POIID": "174213",
    "POIName": "修德",
    "Telno": "(02)29874770",
    "Address": "新北市三重區重陽路3段11號13號1樓"
}, {
    "POIID": "977119",
    "POIName": "泰和",
    "Telno": "(02)89762147",
    "Address": "新北市三重區長安街71號1樓"
}, {
    "POIID": "188418",
    "POIName": "真旺",
    "Telno": "(02)29742151",
    "Address": "新北市三重區成功路50巷1號"
}, {
    "POIID": "171281",
    "POIName": "陡門頭",
    "Telno": "(02)29832749",
    "Address": "新北市三重區三民街329號"
}, {
    "POIID": "846420",
    "POIName": "高仁",
    "Telno": "(02)29875145",
    "Address": "新北市三重區仁愛街274號"
}, {
    "POIID": "116675",
    "POIName": "健華",
    "Telno": "(02)89825067",
    "Address": "新北市三重區忠孝路二段63號"
}, {
    "POIID": "875060",
    "POIName": "清茂",
    "Telno": "(02)29742235",
    "Address": "新北市三重區成功路106號之2"
}, {
    "POIID": "181358",
    "POIName": "荷運",
    "Telno": "(02)22809692",
    "Address": "新北市三重區三和路4段97號.97之1.97之2號1樓"
}, {
    "POIID": "181428",
    "POIName": "頂宏",
    "Telno": "(02)29869877",
    "Address": "新北市三重區頂崁街210巷23弄1號3號1樓"
}, {
    "POIID": "174660",
    "POIName": "頂崁",
    "Telno": "(02)85112088",
    "Address": "新北市三重區光復路一段82號1樓"
}, {
    "POIID": "900924",
    "POIName": "頂華",
    "Telno": "(02)29875488",
    "Address": "新北市三重區頂崁街189號"
}, {
    "POIID": "138860",
    "POIName": "富仟",
    "Telno": "(02)29990329",
    "Address": "新北市三重區五谷王北街139號"
}, {
    "POIID": "190525",
    "POIName": "復貴",
    "Telno": "(02)85124863",
    "Address": "新北市三重區光復路2段146之2號1樓"
}, {
    "POIID": "116538",
    "POIName": "湯旺",
    "Telno": "(02)22789758",
    "Address": "新北市三重區重新路五段609巷2之3號1樓"
}, {
    "POIID": "188902",
    "POIName": "湯城",
    "Telno": "(02)29995017",
    "Address": "新北市三重區重新路5段609巷12號之9之10"
}, {
    "POIID": "164180",
    "POIName": "登頂",
    "Telno": "(02)85121927",
    "Address": "新北市三重區光復路2段2號"
}, {
    "POIID": "170200",
    "POIName": "集吉",
    "Telno": "(02)28570294",
    "Address": "新北市三重區三賢街61號63號1樓"
}, {
    "POIID": "976105",
    "POIName": "集美",
    "Telno": "(02)29772012",
    "Address": "新北市三重區集美街107號"
}, {
    "POIID": "174741",
    "POIName": "集興",
    "Telno": "(02)29743480",
    "Address": "新北市三重區光明里24鄰集美街202號"
}, {
    "POIID": "117966",
    "POIName": "匯和",
    "Telno": "(02)22865428",
    "Address": "新北市三重區三和路4段390巷2號"
}, {
    "POIID": "114174",
    "POIName": "慈佑",
    "Telno": "(02)89852194",
    "Address": "新北市三重區溪尾街189號191號"
}, {
    "POIID": "187415",
    "POIName": "愛家",
    "Telno": "(02)85110144",
    "Address": "新北市三重區中興北街42巷11號"
}, {
    "POIID": "130350",
    "POIName": "新洛華",
    "Telno": "(02)29844685",
    "Address": "新北市三重區中華路113號115號"
}, {
    "POIID": "190190",
    "POIName": "新陽",
    "Telno": "(02)29898294",
    "Address": "新北市三重區三陽路62號64號"
}, {
    "POIID": "165611",
    "POIName": "福運",
    "Telno": "(02)29741171",
    "Address": "新北市三重區福德北路57號59號1樓"
}, {
    "POIID": "188809",
    "POIName": "福濱",
    "Telno": "(02)29761371",
    "Address": "新北市三重區龍濱路51號53號1樓"
}, {
    "POIID": "947369",
    "POIName": "銀座",
    "Telno": "(02)29714834",
    "Address": "新北市三重區信義西街4號"
}, {
    "POIID": "164696",
    "POIName": "興光",
    "Telno": "(02)29763955",
    "Address": "新北市三重區大同南路220號"
}, {
    "POIID": "188245",
    "POIName": "興頂",
    "Telno": "(02)29990814",
    "Address": "新北市三重區中興北街177號"
}, {
    "POIID": "141671",
    "POIName": "興園",
    "Telno": "(02)29846951",
    "Address": "新北市三重區重陽路1段132號134號1樓"
}, {
    "POIID": "144289",
    "POIName": "龍濱",
    "Telno": "(02)29769472",
    "Address": "新北市三重區龍濱路207號209號"
}, {
    "POIID": "189352",
    "POIName": "環德",
    "Telno": "(02)29769304",
    "Address": "新北市三重區福德南路38號1樓"
}, {
    "POIID": "985545",
    "POIName": "鑫強",
    "Telno": "(02)29869271",
    "Address": "新北市三重區自強路三段30號32號"
}, ], [{
    "POIID": "173793",
    "POIName": "一新",
    "Telno": "(02)22468497",
    "Address": "新北市中和區福祥里27鄰永和路56號58號1樓"
}, {
    "POIID": "961871",
    "POIName": "中安",
    "Telno": "(02)29459706",
    "Address": "新北市中和區宜安路62號66號"
}, {
    "POIID": "164881",
    "POIName": "元龍",
    "Telno": "(02)32349309",
    "Address": "新北市中和區板南路655號1樓"
}, {
    "POIID": "127930",
    "POIName": "天城",
    "Telno": "(02)29484876",
    "Address": "新北市中和區景平路240巷1弄4號"
}, {
    "POIID": "895787",
    "POIName": "日福",
    "Telno": "(02)29209816",
    "Address": "新北市中和區中和路380號"
}, {
    "POIID": "126775",
    "POIName": "水源",
    "Telno": "(02)22477245",
    "Address": "新北市中和區中山路2段62號"
}, {
    "POIID": "174590",
    "POIName": "世紀",
    "Telno": "(02)82278576",
    "Address": "新北市中和區中正路710號1樓K棟"
}, {
    "POIID": "179724",
    "POIName": "正原",
    "Telno": "(02)22281549",
    "Address": "新北市中和區中山路二段530號1樓"
}, {
    "POIID": "875646",
    "POIName": "民自",
    "Telno": "(02)32348395",
    "Address": "新北市中和區冠穗里民享街38號38之1號"
}, {
    "POIID": "150859",
    "POIName": "民德",
    "Telno": "(02)89517714",
    "Address": "新北市中和區民德路47號47-1號"
}, {
    "POIID": "169794",
    "POIName": "永振",
    "Telno": "(02)22425124",
    "Address": "新北市中和區南華路14號"
}, {
    "POIID": "177212",
    "POIName": "永華",
    "Telno": "(02)22433147",
    "Address": "新北市中和區南山路127巷18弄42號1樓"
}, {
    "POIID": "165725",
    "POIName": "立言",
    "Telno": "(02)22287924",
    "Address": "新北市中和區中正路872號"
}, {
    "POIID": "961387",
    "POIName": "立德",
    "Telno": "(02)32347894",
    "Address": "新北市中和區立德街103號"
}, {
    "POIID": "981990",
    "POIName": "全茂",
    "Telno": "(02)82286711",
    "Address": "新北市中和區連城路469巷9號11號"
}, {
    "POIID": "141202",
    "POIName": "吉客",
    "Telno": "(02)89535763",
    "Address": "新北市中和區德光路90號92號1樓"
}, {
    "POIID": "144418",
    "POIName": "安斌",
    "Telno": "(02)29202294",
    "Address": "新北市中和區中安街84號86號1樓"
}, {
    "POIID": "187013",
    "POIName": "艾德蒙",
    "Telno": "(02)82262320",
    "Address": "新北市中和區中正路738號1樓"
}, {
    "POIID": "950435",
    "POIName": "孝忠",
    "Telno": "(02)29401045",
    "Address": "新北市中和區忠孝街37巷2號"
}, {
    "POIID": "146609",
    "POIName": "宏禧",
    "Telno": "(02)22483082",
    "Address": "新北市中和區景平路429號1樓"
}, {
    "POIID": "148502",
    "POIName": "宏鑫",
    "Telno": "(02)82282070",
    "Address": "新北市中和區中正路837號"
}, {
    "POIID": "132264",
    "POIName": "沅氣",
    "Telno": "(02)22263294",
    "Address": "新北市中和區中山路三段29號31號1樓"
}, {
    "POIID": "132219",
    "POIName": "秀杉",
    "Telno": "(02)29421382",
    "Address": "新北市中和區自立路129號131號"
}, {
    "POIID": "901363",
    "POIName": "秀景",
    "Telno": "(02)29438436",
    "Address": "新北市中和區成功路115號117號"
}, {
    "POIID": "958934",
    "POIName": "佳客",
    "Telno": "(02)29633321",
    "Address": "新北市中和區民德路126號126之1號"
}, {
    "POIID": "189916",
    "POIName": "和建",
    "Telno": "(02)22224875",
    "Address": "新北市中和區建一路16號1樓"
}, {
    "POIID": "190558",
    "POIName": "和捷",
    "Telno": "(02)29491524",
    "Address": "新北市中和區和平街84號86號88號1樓"
}, {
    "POIID": "138457",
    "POIName": "和復",
    "Telno": "(02)29431063",
    "Address": "新北市中和區復興路19號"
}, {
    "POIID": "113609",
    "POIName": "和錦",
    "Telno": "(02)22435251",
    "Address": "新北市中和區錦和路402號404號"
}, {
    "POIID": "971775",
    "POIName": "和醫",
    "Telno": "(02)22497312",
    "Address": "新北市中和區中正路291號B1"
}, {
    "POIID": "159317",
    "POIName": "宜安",
    "Telno": "(02)29415661",
    "Address": "新北市中和區宜安路103號1樓"
}, {
    "POIID": "122865",
    "POIName": "杰明",
    "Telno": "(02)22425701",
    "Address": "新北市中和區泰和街25號1樓"
}, {
    "POIID": "137133",
    "POIName": "板南",
    "Telno": "(02)22216293",
    "Address": "新北市中和區板南路486號"
}, {
    "POIID": "166441",
    "POIName": "板勝",
    "Telno": "(02)22437141",
    "Address": "新北市中和區連城路219巷6號8號"
}, {
    "POIID": "902953",
    "POIName": "松旺",
    "Telno": "(02)82276167",
    "Address": "新北市中和區中山路三段108號"
}, {
    "POIID": "138181",
    "POIName": "保健",
    "Telno": "(02)89411332",
    "Address": "新北市中和區保健路2巷1號1樓"
}, {
    "POIID": "159166",
    "POIName": "冠德",
    "Telno": "(02)29405370",
    "Address": "新北市中和區景平路71-5號"
}, {
    "POIID": "946528",
    "POIName": "南谷",
    "Telno": "(02)22493893",
    "Address": "新北市中和區中和路257號"
}, {
    "POIID": "135300",
    "POIName": "南勢角",
    "Telno": "(02)29446821",
    "Address": "新北市中和區興南路1段55號"
}, {
    "POIID": "946551",
    "POIName": "建一",
    "Telno": "(02)32343779",
    "Address": "新北市中和區建康路101號"
}, {
    "POIID": "188485",
    "POIName": "建六",
    "Telno": "(02)22228354",
    "Address": "新北市中和區建六路62號"
}, {
    "POIID": "159498",
    "POIName": "建康",
    "Telno": "(02)82452425",
    "Address": "新北市中和區建康路270號"
}, {
    "POIID": "164858",
    "POIName": "春吉",
    "Telno": "(02)32340711",
    "Address": "新北市中和區建一路148號"
}, {
    "POIID": "844712",
    "POIName": "員山",
    "Telno": "(02)22238595",
    "Address": "新北市中和區員山路163號"
}, {
    "POIID": "185349",
    "POIName": "員新",
    "Telno": "(02)22215243",
    "Address": "新北市中和區員山路504號"
}, {
    "POIID": "165426",
    "POIName": "家美",
    "Telno": "(02)22420594",
    "Address": "新北市中和區中山路二段317號之1"
}, {
    "POIID": "985682",
    "POIName": "泰隆",
    "Telno": "(02)32345468",
    "Address": "新北市中和區立德街102號"
}, {
    "POIID": "165921",
    "POIName": "得晴",
    "Telno": "(02)29494039",
    "Address": "新北市中和區景平路239巷1號1樓"
}, {
    "POIID": "135056",
    "POIName": "捷興",
    "Telno": "(02)29423902",
    "Address": "新北市中和區興南路1段81號"
}, {
    "POIID": "113458",
    "POIName": "莒光",
    "Telno": "(02)29641491",
    "Address": "新北市中和區莒光路138號1樓"
}, {
    "POIID": "186892",
    "POIName": "莒城",
    "Telno": "(02)32346247",
    "Address": "新北市中和區莒光路91號93號1樓"
}, {
    "POIID": "120113",
    "POIName": "連城",
    "Telno": "(02)82458951",
    "Address": "新北市中和區連城路89巷3之1號5之1號1樓"
}, {
    "POIID": "163877",
    "POIName": "連通",
    "Telno": "(02)22446708",
    "Address": "新北市中和區圓通路293號"
}, {
    "POIID": "140508",
    "POIName": "連勝",
    "Telno": "(02)22423559",
    "Address": "新北市中和區景平路513號"
}, {
    "POIID": "186825",
    "POIName": "頂新",
    "Telno": "(02)29493001",
    "Address": "新北市中和區興南路2段49號51號"
}, {
    "POIID": "895710",
    "POIName": "富興",
    "Telno": "(02)22404174",
    "Address": "新北市中和區中興里復興路277-1號279號"
}, {
    "POIID": "862374",
    "POIName": "景仁",
    "Telno": "(02)29424974",
    "Address": "新北市中和區東南里14鄰忠孝街103號1樓"
}, {
    "POIID": "181211",
    "POIName": "景平",
    "Telno": "(02)29426487",
    "Address": "新北市中和區景平路149號1樓"
}, {
    "POIID": "864749",
    "POIName": "景安",
    "Telno": "(02)22453094",
    "Address": "新北市中和區景安路210號"
}, {
    "POIID": "160339",
    "POIName": "景旺",
    "Telno": "(02)29485754",
    "Address": "新北市中和區成功路1號"
}, {
    "POIID": "164847",
    "POIName": "景順",
    "Telno": "(02)22267420",
    "Address": "新北市中和區中正路778號1樓"
}, {
    "POIID": "188762",
    "POIName": "景圓",
    "Telno": "(02)22480308",
    "Address": "新北市中和區圓通路162-1號162-2號1樓"
}, {
    "POIID": "141729",
    "POIName": "景愛",
    "Telno": "(02)89419312",
    "Address": "新北市中和區仁愛街45號47號1樓"
}, {
    "POIID": "832605",
    "POIName": "景新",
    "Telno": "(02)29472362",
    "Address": "新北市中和區景新街436號"
}, {
    "POIID": "880899",
    "POIName": "景福",
    "Telno": "(02)89422088",
    "Address": "新北市中和區景新街467巷22號"
}, {
    "POIID": "886875",
    "POIName": "景禮",
    "Telno": "(02)22434828",
    "Address": "新北市中和區景安路100號102號"
}, {
    "POIID": "139195",
    "POIName": "景鑫",
    "Telno": "(02)32349418",
    "Address": "新北市中和區中正路683號"
}, {
    "POIID": "180492",
    "POIName": "景鑽",
    "Telno": "(02)29435424",
    "Address": "新北市中和區景新街373號373之1號"
}, {
    "POIID": "864901",
    "POIName": "圓通",
    "Telno": "(02)22452292",
    "Address": "新北市中和區圓通路280號282號"
}, {
    "POIID": "186386",
    "POIName": "新民享",
    "Telno": "(02)32342502",
    "Address": "新北市中和區民享街91號"
}, {
    "POIID": "148166",
    "POIName": "新和高",
    "Telno": "(02)22217490",
    "Address": "新北市中和區中正路502號1樓"
}, {
    "POIID": "911924",
    "POIName": "新連正",
    "Telno": "(02)22281985",
    "Address": "新北市中和區連城路347巷2號"
}, {
    "POIID": "158521",
    "POIName": "新積穗",
    "Telno": "(02)22226128",
    "Address": "新北市中和區民安街27號29號1樓"
}, {
    "POIID": "137959",
    "POIName": "椰城",
    "Telno": "(02)29478067",
    "Address": "新北市中和區安平路61號"
}, {
    "POIID": "114657",
    "POIName": "聖武",
    "Telno": "(02)22224961",
    "Address": "新北市中和區新生街48號50號1樓"
}, {
    "POIID": "141268",
    "POIName": "嘉新",
    "Telno": "(02)22220392",
    "Address": "新北市中和區員山路419號421號1樓"
}, {
    "POIID": "993650",
    "POIName": "壽德",
    "Telno": "(02)29520956",
    "Address": "新北市中和區壽德街11號1樓"
}, {
    "POIID": "152006",
    "POIName": "漳和",
    "Telno": "(02)22452548",
    "Address": "新北市中和區中山路2段131-6號"
}, {
    "POIID": "123064",
    "POIName": "福和",
    "Telno": "(02)29408207",
    "Address": "新北市中和區秀朗里大勇街25巷1號"
}, {
    "POIID": "132884",
    "POIName": "福泉",
    "Telno": "(02)22436653",
    "Address": "新北市中和區福祥路68號70號"
}, {
    "POIID": "148155",
    "POIName": "福美",
    "Telno": "(02)22437842",
    "Address": "新北市中和區景平路756號758號"
}, {
    "POIID": "187910",
    "POIName": "福真",
    "Telno": "(02)82452305",
    "Address": "新北市中和區景平路679號681號"
}, {
    "POIID": "951313",
    "POIName": "福勝",
    "Telno": "(02)22499480",
    "Address": "新北市中和區福祥路158號"
}, {
    "POIID": "188267",
    "POIName": "廣麗",
    "Telno": "(02)82456964",
    "Address": "新北市中和區廣福路87號89號91號1樓"
}, {
    "POIID": "111647",
    "POIName": "德旺",
    "Telno": "(02)29648813",
    "Address": "新北市中和區壽德街22號1樓"
}, {
    "POIID": "148007",
    "POIName": "德偉",
    "Telno": "(02)22429271",
    "Address": "新北市中和區中興街162號164號"
}, {
    "POIID": "166120",
    "POIName": "樂鑫",
    "Telno": "(02)22214293",
    "Address": "新北市中和區新生街146號"
}, {
    "POIID": "137982",
    "POIName": "橋安",
    "Telno": "(02)22424310",
    "Address": "新北市中和區橋安街20號1F"
}, {
    "POIID": "132747",
    "POIName": "興和",
    "Telno": "(02)29464251",
    "Address": "新北市中和區自立路187號189號1樓"
}, {
    "POIID": "975456",
    "POIName": "興榮",
    "Telno": "(02)86688301",
    "Address": "新北市中和區福南里21鄰興南路二段90號1樓"
}, {
    "POIID": "151601",
    "POIName": "錦盛",
    "Telno": "(02)22479571",
    "Address": "新北市中和區錦盛里圓通路335巷三弄21號"
}, {
    "POIID": "144717",
    "POIName": "環冠",
    "Telno": "(02)22287912",
    "Address": "新北市中和區中山路三段118之6之7之8號"
}, {
    "POIID": "902931",
    "POIName": "禧緻",
    "Telno": "(02)29448161",
    "Address": "新北市中和區華新街156號"
}, {
    "POIID": "127309",
    "POIName": "藍山",
    "Telno": "(02)22455838",
    "Address": "新北市中和區南山路41號及37巷2號"
}, ], [{
    "POIID": "166164",
    "POIName": "大正",
    "Telno": "(02)89213847",
    "Address": "新北市永和區中正路559號561號1樓2樓"
}, {
    "POIID": "188197",
    "POIName": "仁愛",
    "Telno": "(02)22316781",
    "Address": "新北市永和區仁愛路128號130號1樓"
}, {
    "POIID": "997548",
    "POIName": "仁寶",
    "Telno": "(02)86601617",
    "Address": "新北市永和區仁愛路302號304號"
}, {
    "POIID": "152062",
    "POIName": "元坊",
    "Telno": "(02)29285539",
    "Address": "新北市永和區保安路134號136號"
}, {
    "POIID": "992624",
    "POIName": "北福",
    "Telno": "(02)89211047",
    "Address": "新北市永和區福和路121號1樓"
}, {
    "POIID": "885698",
    "POIName": "民光",
    "Telno": "(02)29459258",
    "Address": "新北市永和區中正路166號"
}, {
    "POIID": "166153",
    "POIName": "永中",
    "Telno": "(02)29231380",
    "Address": "新北市永和區中山路一段58號"
}, {
    "POIID": "189765",
    "POIName": "永平",
    "Telno": "(02)29279417",
    "Address": "新北市永和區中山路一段149至153號"
}, {
    "POIID": "955094",
    "POIName": "永竹",
    "Telno": "(02)29210296",
    "Address": "新北市永和區竹林路146號"
}, {
    "POIID": "875303",
    "POIName": "永利",
    "Telno": "(02)86605379",
    "Address": "新北市永和區永元里永元路93號"
}, {
    "POIID": "895798",
    "POIName": "永和",
    "Telno": "(02)29291091",
    "Address": "新北市永和區文化路7號"
}, {
    "POIID": "810410",
    "POIName": "永興",
    "Telno": "(02)29215441",
    "Address": "新北市永和區竹林路98號"
}, {
    "POIID": "181473",
    "POIName": "永權",
    "Telno": "(02)29440937",
    "Address": "新北市永和區民權路32號34號1樓"
}, {
    "POIID": "122980",
    "POIName": "宇陽",
    "Telno": "(02)29252456",
    "Address": "新北市永和區永利路77號"
}, {
    "POIID": "978802",
    "POIName": "安福",
    "Telno": "(02)29226454",
    "Address": "新北市永和區福和路213號"
}, {
    "POIID": "153397",
    "POIName": "有民",
    "Telno": "(02)29495640",
    "Address": "新北市永和區民有街9號11號1樓"
}, {
    "POIID": "985615",
    "POIName": "竹林",
    "Telno": "(02)89251932",
    "Address": "新北市永和區竹林路211號"
}, {
    "POIID": "148638",
    "POIName": "宏圖",
    "Telno": "(02)32335456",
    "Address": "新北市永和區永和路一段85號"
}, {
    "POIID": "142456",
    "POIName": "秀朗",
    "Telno": "(02)29299747",
    "Address": "新北市永和區得和路389號391號1樓"
}, {
    "POIID": "127332",
    "POIName": "和和",
    "Telno": "(02)29299306",
    "Address": "新北市永和區秀朗路2段128號"
}, {
    "POIID": "872061",
    "POIName": "孟揚",
    "Telno": "(02)29235080",
    "Address": "新北市永和區秀和里林森路62號"
}, {
    "POIID": "118785",
    "POIName": "忠信",
    "Telno": "(02)89211344",
    "Address": "新北市永和區中興街101號"
}, {
    "POIID": "978606",
    "POIName": "昇庚",
    "Telno": "(02)82317044",
    "Address": "新北市永和區永貞路182號184號"
}, {
    "POIID": "906092",
    "POIName": "昇陽",
    "Telno": "(02)22311802",
    "Address": "新北市永和區雙和里1鄰中和路417號419號"
}, {
    "POIID": "159487",
    "POIName": "保平",
    "Telno": "(02)29239344",
    "Address": "新北市永和區保平路135號"
}, {
    "POIID": "860655",
    "POIName": "保生",
    "Telno": "(02)22314015",
    "Address": "新北市永和區保安里保生路1號"
}, {
    "POIID": "951438",
    "POIName": "保順",
    "Telno": "(02)89232533",
    "Address": "新北市永和區保順路39號及保順路37巷2號"
}, {
    "POIID": "912282",
    "POIName": "保鑽",
    "Telno": "(02)29453250",
    "Address": "新北市永和區潭墘里安樂路138號140號"
}, {
    "POIID": "164009",
    "POIName": "界和",
    "Telno": "(02)29211350",
    "Address": "新北市永和區中和路339號339號之1"
}, {
    "POIID": "189868",
    "POIName": "得和",
    "Telno": "(02)29282743",
    "Address": "新北市永和區得和路113號1樓"
}, {
    "POIID": "162575",
    "POIName": "得福",
    "Telno": "(02)29225730",
    "Address": "新北市永和區得和路241號"
}, {
    "POIID": "186342",
    "POIName": "添丁",
    "Telno": "(02)29210564",
    "Address": "新北市永和區永貞路365號367號1樓"
}, {
    "POIID": "170048",
    "POIName": "富朋",
    "Telno": "(02)29287719",
    "Address": "新北市永和區永和路二段116號"
}, {
    "POIID": "999359",
    "POIName": "復美",
    "Telno": "(02)29293764",
    "Address": "新北市永和區秀朗路1段146號"
}, {
    "POIID": "989042",
    "POIName": "新永元",
    "Telno": "(02)29273661",
    "Address": "新北市永和區永元路28號30號"
}, {
    "POIID": "990640",
    "POIName": "新保捷",
    "Telno": "(02)82316627",
    "Address": "新北市永和區保生路22巷2號1樓"
}, {
    "POIID": "970439",
    "POIName": "新保福",
    "Telno": "(02)29233298",
    "Address": "新北市永和區保安路220號"
}, {
    "POIID": "166197",
    "POIName": "福愛",
    "Telno": "(02)22324404",
    "Address": "新北市永和區永平路274號仁愛路242號"
}, {
    "POIID": "166795",
    "POIName": "樂華",
    "Telno": "(02)29252723",
    "Address": "新北市永和區永和路一段143之1號145號1至2樓"
}, {
    "POIID": "163992",
    "POIName": "潭安",
    "Telno": "(02)29476442",
    "Address": "新北市永和區中正路167號"
}, {
    "POIID": "165541",
    "POIName": "豫溪",
    "Telno": "(02)29295836",
    "Address": "新北市永和區中正路702巷1號3號及中正路710號"
}, {
    "POIID": "930981",
    "POIName": "龍馬",
    "Telno": "(02)22323194",
    "Address": "新北市永和區文化路188號"
}, {
    "POIID": "130866",
    "POIName": "環永",
    "Telno": "(02)22326083",
    "Address": "新北市永和區環河西路2段231號233號1樓"
}, {
    "POIID": "959270",
    "POIName": "邁群",
    "Telno": "(02)29451487",
    "Address": "新北市永和區民生路42號"
}, {
    "POIID": "992598",
    "POIName": "麗金",
    "Telno": "(02)29267956",
    "Address": "新北市永和區成功路一段83號85號1樓"
}, ], [{
    "POIID": "174257",
    "POIName": "一級棒",
    "Telno": "(02)29018947",
    "Address": "新北市新莊區新北大道七段482號"
}, {
    "POIID": "177245",
    "POIName": "三洋",
    "Telno": "(02)29088626",
    "Address": "新北市新莊區中正路677號679號"
}, {
    "POIID": "159432",
    "POIName": "中央",
    "Telno": "(02)85217131",
    "Address": "新北市新莊區中平路439號B1樓"
}, {
    "POIID": "167592",
    "POIName": "中平",
    "Telno": "(02)29904121",
    "Address": "新北市新莊區中平路76號1樓"
}, {
    "POIID": "136967",
    "POIName": "中泰",
    "Telno": "(02)22762842",
    "Address": "新北市新莊區中港一街10號10-1號"
}, {
    "POIID": "780399",
    "POIName": "中港",
    "Telno": "(02)29978073",
    "Address": "新北市新莊區中港路133號"
}, {
    "POIID": "890092",
    "POIName": "丹鳳",
    "Telno": "(02)29072566",
    "Address": "新北市新莊區新北大道七段842號"
}, {
    "POIID": "128689",
    "POIName": "五工",
    "Telno": "(02)22999109",
    "Address": "新北市新莊區福基里17鄰五工二路91號"
}, {
    "POIID": "184276",
    "POIName": "文正",
    "Telno": "(02)29942142",
    "Address": "新北市新莊區中正路188號1樓"
}, {
    "POIID": "171111",
    "POIName": "加州",
    "Telno": "(02)29983481",
    "Address": "新北市新莊區中平路81巷2號"
}, {
    "POIID": "164227",
    "POIName": "弘安",
    "Telno": "(02)22035994",
    "Address": "新北市新莊區萬安街82號84號"
}, {
    "POIID": "934776",
    "POIName": "光華",
    "Telno": "(02)22073795",
    "Address": "新北市新莊區民安西路390號"
}, {
    "POIID": "119364",
    "POIName": "后福",
    "Telno": "(02)22051513",
    "Address": "新北市新莊區後港一路29號"
}, {
    "POIID": "832502",
    "POIName": "安復",
    "Telno": "(02)29971153",
    "Address": "新北市新莊區復興路1段213號"
}, {
    "POIID": "921714",
    "POIName": "西盛",
    "Telno": "(02)22084323",
    "Address": "新北市新莊區民安西路113號之1"
}, {
    "POIID": "944441",
    "POIName": "宏全",
    "Telno": "(02)22799919",
    "Address": "新北市新莊區中和街61號"
}, {
    "POIID": "112569",
    "POIName": "宏福",
    "Telno": "(02)22778284",
    "Address": "新北市新莊區公園一路34號36號1樓"
}, {
    "POIID": "174224",
    "POIName": "宏懋",
    "Telno": "(02)22047391",
    "Address": "新北市新莊區民安西路70號72號1樓"
}, {
    "POIID": "169901",
    "POIName": "宜增",
    "Telno": "(02)29906376",
    "Address": "新北市新莊區中平路158號1樓"
}, {
    "POIID": "135023",
    "POIName": "幸和",
    "Telno": "(02)22771851",
    "Address": "新北市新莊區中和街174號176號1樓"
}, {
    "POIID": "170163",
    "POIName": "昌宏",
    "Telno": "(02)29939148",
    "Address": "新北市新莊區昌隆街31號"
}, {
    "POIID": "169897",
    "POIName": "昌原",
    "Telno": "(02)29962402",
    "Address": "新北市新莊區中原路137之1之2之3號1樓"
}, {
    "POIID": "183354",
    "POIName": "昌福",
    "Telno": "(02)29906614",
    "Address": "新北市新莊區福壽街101號1樓"
}, {
    "POIID": "163626",
    "POIName": "林宏",
    "Telno": "(02)22036415",
    "Address": "新北市新莊區成功街1號"
}, {
    "POIID": "872108",
    "POIName": "花旗",
    "Telno": "(02)89918896",
    "Address": "新北市新莊區中港路132巷26號"
}, {
    "POIID": "893448",
    "POIName": "采旺",
    "Telno": "(02)29087919",
    "Address": "新北市新莊區天祥街74號"
}, {
    "POIID": "120744",
    "POIName": "金座",
    "Telno": "(02)29927231",
    "Address": "新北市新莊區長青街5號7號"
}, {
    "POIID": "150804",
    "POIName": "品嘉",
    "Telno": "(02)29087554",
    "Address": "新北市新莊區新樹路69之4號之5號1樓"
}, {
    "POIID": "174833",
    "POIName": "建中",
    "Telno": "(02)29961326",
    "Address": "新北市新莊區建中街6號8號"
}, {
    "POIID": "113182",
    "POIName": "後港",
    "Telno": "(02)22040529",
    "Address": "新北市新莊區後港一路76巷14弄1號1樓"
}, {
    "POIID": "159443",
    "POIName": "思源",
    "Telno": "(02)29977848",
    "Address": "新北市新莊區幸福路40號42號"
}, {
    "POIID": "129844",
    "POIName": "美新",
    "Telno": "(02)29964129",
    "Address": "新北市新莊區復興路二段141號143號"
}, {
    "POIID": "170565",
    "POIName": "茂源",
    "Telno": "(02)29949736",
    "Address": "新北市新莊區思源路40-1號"
}, {
    "POIID": "166201",
    "POIName": "原成",
    "Telno": "(02)85212445",
    "Address": "新北市新莊區化成路305號1樓"
}, {
    "POIID": "174202",
    "POIName": "時安",
    "Telno": "(02)22041891",
    "Address": "新北市新莊區建安街95號97號1樓"
}, {
    "POIID": "940863",
    "POIName": "真豪",
    "Telno": "(02)89944791",
    "Address": "新北市新莊區中華路1段73號"
}, {
    "POIID": "183723",
    "POIName": "迴龍站",
    "Telno": "(02)29015542",
    "Address": "新北市新莊區中正路895號895號之1號"
}, {
    "POIID": "182719",
    "POIName": "副都心",
    "Telno": "(02)85213407",
    "Address": "新北市新莊區中央路287號289號1樓"
}, {
    "POIID": "998105",
    "POIName": "國瑞",
    "Telno": "(02)22045410",
    "Address": "新北市新莊區新樹路300號之5"
}, {
    "POIID": "132633",
    "POIName": "添祥",
    "Telno": "(02)29012645",
    "Address": "新北市新莊區天祥街22號24號1樓"
}, {
    "POIID": "957355",
    "POIName": "莊成",
    "Telno": "(02)29947258",
    "Address": "新北市新莊區化成路354號"
}, {
    "POIID": "970222",
    "POIName": "莊泰",
    "Telno": "(02)22023295",
    "Address": "新北市新莊區新泰路21號"
}, {
    "POIID": "161701",
    "POIName": "莊勝",
    "Telno": "(02)22027506",
    "Address": "新北市新莊區八德街59號61號1樓"
}, {
    "POIID": "968827",
    "POIName": "莊龍",
    "Telno": "(02)29043056",
    "Address": "新北市新莊區龍安路66號"
}, {
    "POIID": "139173",
    "POIName": "傑元",
    "Telno": "(02)29068264",
    "Address": "新北市新莊區中正路929巷11號13號"
}, {
    "POIID": "120755",
    "POIName": "傑出",
    "Telno": "(02)29920278",
    "Address": "新北市新莊區昌平街61號63號1樓2樓"
}, {
    "POIID": "153401",
    "POIName": "富旺",
    "Telno": "(02)29945910",
    "Address": "新北市新莊區自立街176號178號1樓"
}, {
    "POIID": "190651",
    "POIName": "富新",
    "Telno": "(02)22047494",
    "Address": "新北市新莊區瓊林南路118-5號"
}, {
    "POIID": "158565",
    "POIName": "富營",
    "Telno": "(02)29033920",
    "Address": "新北市新莊區富國路20號1樓"
}, {
    "POIID": "164021",
    "POIName": "復和",
    "Telno": "(02)22769964",
    "Address": "新北市新莊區復興路一段79號81號1樓"
}, {
    "POIID": "149745",
    "POIName": "港義",
    "Telno": "(02)22766035",
    "Address": "新北市新莊區中港路527號"
}, {
    "POIID": "188751",
    "POIName": "新化成",
    "Telno": "(02)29920145",
    "Address": "新北市新莊區化成路213號1樓"
}, {
    "POIID": "166038",
    "POIName": "新安",
    "Telno": "(02)22028937",
    "Address": "新北市新莊區民安東路185號187號部份1樓"
}, {
    "POIID": "864897",
    "POIName": "新年",
    "Telno": "(02)22023870",
    "Address": "新北市新莊區豐年街54號"
}, {
    "POIID": "967190",
    "POIName": "新宏盛",
    "Telno": "(02)22064537",
    "Address": "新北市新莊區後港一路114號"
}, {
    "POIID": "166131",
    "POIName": "新茂",
    "Telno": "(02)29900950",
    "Address": "新北市新莊區化成路118號120號"
}, {
    "POIID": "980805",
    "POIName": "新展盛",
    "Telno": "(02)22048185",
    "Address": "新北市新莊區西盛街325號327號1樓"
}, {
    "POIID": "844310",
    "POIName": "新泰",
    "Telno": "(02)29973483",
    "Address": "新北市新莊區新泰路267號"
}, {
    "POIID": "144692",
    "POIName": "新統義",
    "Telno": "(02)29960564",
    "Address": "新北市新莊區建中街91號93號1樓"
}, {
    "POIID": "158875",
    "POIName": "新港原",
    "Telno": "(02)29923296",
    "Address": "新北市新莊區中原路201號203號1樓"
}, {
    "POIID": "982627",
    "POIName": "新福圓",
    "Telno": "(02)22984180",
    "Address": "新北市新莊區五工三路93號1樓"
}, {
    "POIID": "901307",
    "POIName": "新遠",
    "Telno": "(02)29088727",
    "Address": "新北市新莊區中正路651號之8號"
}, {
    "POIID": "136059",
    "POIName": "新樹",
    "Telno": "(02)22048764",
    "Address": "新北市新莊區新樹路166號及民安路461號"
}, {
    "POIID": "947336",
    "POIName": "新龍",
    "Telno": "(02)22056440",
    "Address": "新北市新莊區光明里民安西路232號"
}, {
    "POIID": "151988",
    "POIName": "榮和",
    "Telno": "(02)29919383",
    "Address": "新北市新莊區中和街191巷1號3號5號"
}, {
    "POIID": "148557",
    "POIName": "榮信",
    "Telno": "(02)29963682",
    "Address": "新北市新莊區中原里中榮街25鄰90號92號1樓"
}, {
    "POIID": "164098",
    "POIName": "榮富",
    "Telno": "(02)29972753",
    "Address": "新北市新莊區中榮街43號47號"
}, {
    "POIID": "126797",
    "POIName": "福來",
    "Telno": "(02)22984899",
    "Address": "新北市新莊區五權一路8號"
}, {
    "POIID": "946366",
    "POIName": "福基",
    "Telno": "(02)22991171",
    "Address": "新北市新莊區福基里五工路70號"
}, {
    "POIID": "161963",
    "POIName": "福港",
    "Telno": "(02)29977091",
    "Address": "新北市新莊區中港路390號"
}, {
    "POIID": "171546",
    "POIName": "福壽",
    "Telno": "(02)22761740",
    "Address": "新北市新莊區福壽街140號"
}, {
    "POIID": "158990",
    "POIName": "福營",
    "Telno": "(02)29013274",
    "Address": "新北市新莊區福營里建國一路50號52號"
}, {
    "POIID": "181716",
    "POIName": "維妮",
    "Telno": "(02)22037122",
    "Address": "新北市新莊區四維路23號1樓"
}, {
    "POIID": "960535",
    "POIName": "輔大",
    "Telno": "(02)29026304",
    "Address": "新北市新莊區中正路516-1號"
}, {
    "POIID": "965220",
    "POIName": "輔明",
    "Telno": "(02)29028207",
    "Address": "新北市新莊區中正路514巷99號"
}, {
    "POIID": "962748",
    "POIName": "輔泰",
    "Telno": "(02)29048544",
    "Address": "新北市新莊區三泰路11號"
}, {
    "POIID": "165828",
    "POIName": "輔進",
    "Telno": "(02)29056534",
    "Address": "新北市新莊區中正路510號"
}, {
    "POIID": "131777",
    "POIName": "鳳祥",
    "Telno": "(02)29072129",
    "Address": "新北市新莊區中正路708-2號"
}, {
    "POIID": "893035",
    "POIName": "廣進",
    "Telno": "(02)82019030",
    "Address": "新北市新莊區四維路173號"
}, {
    "POIID": "127262",
    "POIName": "興洲",
    "Telno": "(02)22765348",
    "Address": "新北市新莊區新泰路472號1樓"
}, {
    "POIID": "164087",
    "POIName": "錦興",
    "Telno": "(02)29965441",
    "Address": "新北市新莊區思源路181號"
}, {
    "POIID": "886082",
    "POIName": "頭前",
    "Telno": "(02)85216806",
    "Address": "新北市新莊區化成路429-4號"
}, {
    "POIID": "164249",
    "POIName": "龍安",
    "Telno": "(02)22049994",
    "Address": "新北市新莊區龍安路256號"
}, {
    "POIID": "119504",
    "POIName": "龍盛",
    "Telno": "(02)22029412",
    "Address": "新北市新莊區西盛街204巷1號1樓206號1樓"
}, {
    "POIID": "928151",
    "POIName": "雙泰",
    "Telno": "(02)29971829",
    "Address": "新北市新莊區新泰路330號"
}, {
    "POIID": "137834",
    "POIName": "雙鳳",
    "Telno": "(02)29081398",
    "Address": "新北市新莊區雙鳳路114號1樓"
}, {
    "POIID": "148568",
    "POIName": "藝高",
    "Telno": "(02)29972069",
    "Address": "新北市新莊區中平路357號"
}, {
    "POIID": "149723",
    "POIName": "藝寶",
    "Telno": "(02)22771804",
    "Address": "新北市新莊區立信三街8號"
}, {
    "POIID": "892032",
    "POIName": "儷新",
    "Telno": "(02)82019766",
    "Address": "新北市新莊區新樹路451號"
}, {
    "POIID": "142168",
    "POIName": "鑫福",
    "Telno": "(02)29964324",
    "Address": "新北市新莊區幸福路727號1樓"
}, ], [{
    "POIID": "144360",
    "POIName": "二十張",
    "Telno": "(02)29102940",
    "Address": "新北市新店區二十張路5號1樓"
}, {
    "POIID": "164685",
    "POIName": "凡賽絲",
    "Telno": "(02)22120010",
    "Address": "新北市新店區安民街290號1樓"
}, {
    "POIID": "159225",
    "POIName": "大坪林",
    "Telno": "(02)29101292",
    "Address": "新北市新店區民權路18號"
}, {
    "POIID": "181668",
    "POIName": "大盛",
    "Telno": "(02)22198674",
    "Address": "新北市新店區建國路167號169號1樓"
}, {
    "POIID": "188706",
    "POIName": "中行",
    "Telno": "(02)29128620",
    "Address": "新北市新店區中興路一段193號195號"
}, {
    "POIID": "896366",
    "POIName": "五峰",
    "Telno": "(02)29105740",
    "Address": "新北市新店區中興路一段252號"
}, {
    "POIID": "976426",
    "POIName": "及人",
    "Telno": "(02)86663157",
    "Address": "新北市新店區安民街72號"
}, {
    "POIID": "128520",
    "POIName": "天闊",
    "Telno": "(02)89123449",
    "Address": "新北市新店區環河路16號"
}, {
    "POIID": "185811",
    "POIName": "北宜",
    "Telno": "(02)22174891",
    "Address": "新北市新店區北宜路二段82號之2"
}, {
    "POIID": "170705",
    "POIName": "北新",
    "Telno": "(02)29152711",
    "Address": "新北市新店區北新路1段289號291號"
}, {
    "POIID": "189905",
    "POIName": "正民",
    "Telno": "(02)82193475",
    "Address": "新北市新店區中正路508號1樓"
}, {
    "POIID": "112743",
    "POIName": "全新",
    "Telno": "(02)22127952",
    "Address": "新北市新店區安康路2段147號1樓"
}, {
    "POIID": "906748",
    "POIName": "同仁",
    "Telno": "(02)22187490",
    "Address": "新北市新店區民權路96號"
}, {
    "POIID": "138893",
    "POIName": "安民",
    "Telno": "(02)86666260",
    "Address": "新北市新店區安民街133巷9號11號"
}, {
    "POIID": "159328",
    "POIName": "安成",
    "Telno": "(02)86662996",
    "Address": "新北市新店區安成街35號29號"
}, {
    "POIID": "165530",
    "POIName": "安佳",
    "Telno": "(02)22004799",
    "Address": "新北市新店區安祥路111號"
}, {
    "POIID": "953353",
    "POIName": "安忠",
    "Telno": "(02)22119842",
    "Address": "新北市新店區安忠路20號"
}, {
    "POIID": "159339",
    "POIName": "安城",
    "Telno": "(02)86661108",
    "Address": "新北市新店區安康路一段283號"
}, {
    "POIID": "180034",
    "POIName": "安康",
    "Telno": "(02)22124641",
    "Address": "新北市新店區安德街70號72號1樓+2樓"
}, {
    "POIID": "992495",
    "POIName": "江菱",
    "Telno": "(02)86673234",
    "Address": "新北市新店區民權路93號1樓"
}, {
    "POIID": "996903",
    "POIName": "百和",
    "Telno": "(02)29128626",
    "Address": "新北市新店區中正路306號308號"
}, {
    "POIID": "188278",
    "POIName": "百福",
    "Telno": "(02)29160810",
    "Address": "新北市新店區三民路50號52號1樓"
}, {
    "POIID": "110998",
    "POIName": "百豐",
    "Telno": "(02)86669386",
    "Address": "新北市新店區安康路一段168號1樓"
}, {
    "POIID": "895961",
    "POIName": "青潭",
    "Telno": "(02)86657746",
    "Address": "新北市新店區北宜路一段41-1號"
}, {
    "POIID": "184760",
    "POIName": "冠冠",
    "Telno": "(02)29131493",
    "Address": "新北市新店區北新路1段231號"
}, {
    "POIID": "185534",
    "POIName": "南強",
    "Telno": "(02)89147488",
    "Address": "新北市新店區中興路3段168號1F"
}, {
    "POIID": "189813",
    "POIName": "建國",
    "Telno": "(02)29179890",
    "Address": "新北市新店區中正路236號"
}, {
    "POIID": "185073",
    "POIName": "真莘",
    "Telno": "(02)22193728",
    "Address": "新北市新店區中正路362號"
}, {
    "POIID": "167189",
    "POIName": "真親切",
    "Telno": "(02)22199322",
    "Address": "新北市新店區中央路212號214號"
}, {
    "POIID": "141073",
    "POIName": "康曜",
    "Telno": "(02)22158391",
    "Address": "新北市新店區安康路三段41號"
}, {
    "POIID": "990260",
    "POIName": "涵碧",
    "Telno": "(02)22124146",
    "Address": "新北市新店區碧潭路37號"
}, {
    "POIID": "128911",
    "POIName": "統和",
    "Telno": "(02)86662431",
    "Address": "新北市新店區安和里安民街335號337號"
}, {
    "POIID": "143688",
    "POIName": "統客",
    "Telno": "(02)29143624",
    "Address": "新北市新店區寶興路49號"
}, {
    "POIID": "190307",
    "POIName": "莊鑫",
    "Telno": "(02)86673439",
    "Address": "新北市新店區中正路503之3號503之4號1樓2樓"
}, {
    "POIID": "996121",
    "POIName": "連豐",
    "Telno": "(02)89116434",
    "Address": "新北市新店區大豐路12號"
}, {
    "POIID": "187769",
    "POIName": "景大",
    "Telno": "(02)22120371",
    "Address": "新北市新店區安忠路71巷1號1樓"
}, {
    "POIID": "166946",
    "POIName": "愛莘",
    "Telno": "(02)22191951",
    "Address": "新北市新店區民族路112號"
}, {
    "POIID": "189787",
    "POIName": "新中",
    "Telno": "(02)89113412",
    "Address": "新北市新店區中正路160號1樓"
}, {
    "POIID": "125141",
    "POIName": "新正",
    "Telno": "(02)22188559",
    "Address": "新北市新店區中正路682號"
}, {
    "POIID": "132105",
    "POIName": "新和",
    "Telno": "(02)29438493",
    "Address": "新北市新店區新和街70號72號1樓"
}, {
    "POIID": "905701",
    "POIName": "新宜",
    "Telno": "(02)22170873",
    "Address": "新北市新店區北宜路二段4號6號"
}, {
    "POIID": "129154",
    "POIName": "新店站",
    "Telno": "(02)29129553",
    "Address": "新北市新店區北宜路一段2號"
}, {
    "POIID": "991333",
    "POIName": "新明",
    "Telno": "(02)29127361",
    "Address": "新北市新店區光明街140號"
}, {
    "POIID": "119021",
    "POIName": "新矽谷",
    "Telno": "(02)89131481",
    "Address": "新北市新店區北新路三段205-1號"
}, {
    "POIID": "155566",
    "POIName": "新順安",
    "Telno": "(02)29118504",
    "Address": "新北市新店區順安街51號53號1樓"
}, {
    "POIID": "159199",
    "POIName": "新極景",
    "Telno": "(02)29109385",
    "Address": "新北市新店區北新路2段252-1號"
}, {
    "POIID": "166393",
    "POIName": "新猷",
    "Telno": "(02)29433640",
    "Address": "新北市新店區安和路三段81號83號1樓"
}, {
    "POIID": "185442",
    "POIName": "新福民",
    "Telno": "(02)22196485",
    "Address": "新北市新店區中央路135號"
}, {
    "POIID": "173782",
    "POIName": "新廣",
    "Telno": "(02)22188613",
    "Address": "新北市新店區中正路542之5號1樓"
}, {
    "POIID": "980090",
    "POIName": "新燕",
    "Telno": "(02)26667848",
    "Address": "新北市新店區新烏路2段382號384號1樓"
}, {
    "POIID": "971889",
    "POIName": "新錦秀",
    "Telno": "(02)22141427",
    "Address": "新北市新店區錦秀路13號15號1樓"
}, {
    "POIID": "185947",
    "POIName": "新贊",
    "Telno": "(02)29138103",
    "Address": "新北市新店區北新路1段14號1樓"
}, {
    "POIID": "980919",
    "POIName": "新鵬",
    "Telno": "(02)22185512",
    "Address": "新北市新店區中正路696號1樓"
}, {
    "POIID": "931216",
    "POIName": "新寶橋",
    "Telno": "(02)89145826",
    "Address": "新北市新店區寶橋路192號"
}, {
    "POIID": "981794",
    "POIName": "嶄新",
    "Telno": "(02)89146919",
    "Address": "新北市新店區中正路57-2號1樓"
}, {
    "POIID": "119777",
    "POIName": "碧潭",
    "Telno": "(02)86659633",
    "Address": "新北市新店區北宜路一段28號"
}, {
    "POIID": "148719",
    "POIName": "碧興",
    "Telno": "(02)29119875",
    "Address": "新北市新店區北宜路一段120號122號1樓"
}, {
    "POIID": "149538",
    "POIName": "福強",
    "Telno": "(02)29161926",
    "Address": "新北市新店區三民路147之1號149號1樓"
}, {
    "POIID": "173542",
    "POIName": "福德",
    "Telno": "(02)29139545",
    "Address": "新北市新店區三民路179號1樓"
}, {
    "POIID": "976932",
    "POIName": "德正",
    "Telno": "(02)29185319",
    "Address": "新北市新店區德正街23巷1號"
}, {
    "POIID": "188407",
    "POIName": "德玉",
    "Telno": "(02)22144764",
    "Address": "新北市新店區安康路三段195號"
}, {
    "POIID": "985349",
    "POIName": "鎮鑫",
    "Telno": "(02)89146427",
    "Address": "新北市新店區中興路1段289號"
}, {
    "POIID": "110507",
    "POIName": "雙建",
    "Telno": "(02)22194843",
    "Address": "新北市新店區二十張路64號64之1號1樓"
}, {
    "POIID": "162173",
    "POIName": "雙鑫",
    "Telno": "(02)86658848",
    "Address": "新北市新店區北新路二段169號"
}, {
    "POIID": "958901",
    "POIName": "寶中",
    "Telno": "(02)86653843",
    "Address": "新北市新店區寶慶街66號"
}, {
    "POIID": "174718",
    "POIName": "寶科",
    "Telno": "(02)89118174",
    "Address": "新北市新店區寶橋路235巷5號1樓"
}, {
    "POIID": "173841",
    "POIName": "寶強",
    "Telno": "(02)89145258",
    "Address": "新北市新店區寶中路88號1樓"
}, {
    "POIID": "146126",
    "POIName": "寶新",
    "Telno": "(02)29137463",
    "Address": "新北市新店區北新路二段57號"
}, {
    "POIID": "152132",
    "POIName": "寶福",
    "Telno": "(02)86653467",
    "Address": "新北市新店區寶橋路78巷3號1F"
}, ], [{
    "POIID": "183619",
    "POIName": "TBI",
    "Telno": "(02)26886797",
    "Address": "新北市樹林區三多路139號1樓"
}, {
    "POIID": "934606",
    "POIName": "三暉",
    "Telno": "(02)26868745",
    "Address": "新北市樹林區樹福里復興路1號"
}, {
    "POIID": "846235",
    "POIName": "千歲",
    "Telno": "(02)26829285",
    "Address": "新北市樹林區千歲街26-10號"
}, {
    "POIID": "164386",
    "POIName": "大東圓",
    "Telno": "(02)26809701",
    "Address": "新北市樹林區柑園街一段67號67-1號67-2號1樓"
}, {
    "POIID": "142951",
    "POIName": "大展",
    "Telno": "(02)86874074",
    "Address": "新北市樹林區俊英街232號234號1樓"
}, {
    "POIID": "151003",
    "POIName": "大智通",
    "Telno": "(02)26685036",
    "Address": "新北市樹林區佳園路二段70-1號"
}, {
    "POIID": "931054",
    "POIName": "山佳",
    "Telno": "(02)26808909",
    "Address": "新北市樹林區中山路3段87號"
}, {
    "POIID": "131940",
    "POIName": "友勤",
    "Telno": "(02)89701627",
    "Address": "新北市樹林區大有路65號1樓"
}, {
    "POIID": "188016",
    "POIName": "太順",
    "Telno": "(02)86847720",
    "Address": "新北市樹林區太順街49巷2號"
}, {
    "POIID": "173704",
    "POIName": "合喬",
    "Telno": "(02)86882331",
    "Address": "新北市樹林區三福街68號"
}, {
    "POIID": "941567",
    "POIName": "佳宏",
    "Telno": "(02)86868619",
    "Address": "新北市樹林區太平路150巷1號"
}, {
    "POIID": "116594",
    "POIName": "佳辰",
    "Telno": "(02)89700664",
    "Address": "新北市樹林區佳園路三段488號"
}, {
    "POIID": "165770",
    "POIName": "昌展",
    "Telno": "(02)26819109",
    "Address": "新北市樹林區復興路67號1樓"
}, {
    "POIID": "130268",
    "POIName": "昌聖",
    "Telno": "(02)86754204",
    "Address": "新北市樹林區文化街21號23號1樓"
}, {
    "POIID": "916468",
    "POIName": "武林",
    "Telno": "(02)26887713",
    "Address": "新北市樹林區光華街2號4號"
}, {
    "POIID": "111371",
    "POIName": "俊安",
    "Telno": "(02)26756413",
    "Address": "新北市樹林區俊英街156號"
}, {
    "POIID": "118475",
    "POIName": "俊興",
    "Telno": "(02)26897687",
    "Address": "新北市樹林區三俊街172號1樓"
}, {
    "POIID": "953928",
    "POIName": "俊龍",
    "Telno": "(02)86881124",
    "Address": "新北市樹林區三俊街96號1樓"
}, {
    "POIID": "111946",
    "POIName": "城雅",
    "Telno": "(02)89706098",
    "Address": "新北市樹林區學成路519號1樓"
}, {
    "POIID": "116697",
    "POIName": "御昇",
    "Telno": "(02)26809307",
    "Address": "新北市樹林區佳園路二段34號1樓"
}, {
    "POIID": "883728",
    "POIName": "統友",
    "Telno": "(02)26866259",
    "Address": "新北市樹林區中山路一段86號"
}, {
    "POIID": "113894",
    "POIName": "凱園",
    "Telno": "(02)86849170",
    "Address": "新北市樹林區國凱街55號1樓"
}, {
    "POIID": "182812",
    "POIName": "復育",
    "Telno": "(02)26855167",
    "Address": "新北市樹林區復興路227號1樓"
}, {
    "POIID": "891280",
    "POIName": "順興",
    "Telno": "(02)86869460",
    "Address": "新北市樹林區東興街41號"
}, {
    "POIID": "971133",
    "POIName": "新宇鈞",
    "Telno": "(02)26754414",
    "Address": "新北市樹林區大安路115號117號1樓"
}, {
    "POIID": "164917",
    "POIName": "新樹工",
    "Telno": "(02)26851613",
    "Address": "新北市樹林區保安街二段6號"
}, {
    "POIID": "932482",
    "POIName": "榮德",
    "Telno": "(02)86851196",
    "Address": "新北市樹林區東榮街8-10號"
}, {
    "POIID": "158473",
    "POIName": "福多",
    "Telno": "(02)86884842",
    "Address": "新北市樹林區三福街39號41號"
}, {
    "POIID": "123101",
    "POIName": "慶斌",
    "Telno": "(02)26684258",
    "Address": "新北市樹林區中洲街51巷1號"
}, {
    "POIID": "130615",
    "POIName": "慶嶸",
    "Telno": "(02)26853064",
    "Address": "新北市樹林區保安街一段323號323-1號1樓"
}, {
    "POIID": "119238",
    "POIName": "學林",
    "Telno": "(02)26687903",
    "Address": "新北市樹林區大雅路341號343號1樓"
}, {
    "POIID": "992576",
    "POIName": "樹安",
    "Telno": "(02)26810554",
    "Address": "新北市樹林區大安路530號1樓"
}, {
    "POIID": "180414",
    "POIName": "樹佳",
    "Telno": "(02)26684654",
    "Address": "新北市樹林區佳園路3段31之1號"
}, {
    "POIID": "174637",
    "POIName": "樹林",
    "Telno": "(02)26873876",
    "Address": "新北市樹林區保安街1段3號"
}, {
    "POIID": "158783",
    "POIName": "樹林一",
    "Telno": "(02)86751125",
    "Address": "新北市樹林區鎮前街112號"
}, {
    "POIID": "923097",
    "POIName": "樹保",
    "Telno": "(02)86884493",
    "Address": "新北市樹林區保安街二段357號"
}, {
    "POIID": "936303",
    "POIName": "樹英",
    "Telno": "(02)86866284",
    "Address": "新北市樹林區大同里中華路120號"
}, {
    "POIID": "160111",
    "POIName": "樹復",
    "Telno": "(02)26874232",
    "Address": "新北市樹林區復興路340號"
}, {
    "POIID": "975331",
    "POIName": "樹園",
    "Telno": "(02)26806053",
    "Address": "新北市樹林區佳園路一段52號1樓"
}, {
    "POIID": "164397",
    "POIName": "樹新",
    "Telno": "(02)26812205",
    "Address": "新北市樹林區樹新路245號"
}, {
    "POIID": "173597",
    "POIName": "樹鳳",
    "Telno": "(02)26765713",
    "Address": "新北市樹林區中正路417號 1樓"
}, {
    "POIID": "165220",
    "POIName": "樹樺",
    "Telno": "(02)86861904",
    "Address": "新北市樹林區中華路341之5號341之6號一樓"
}, {
    "POIID": "996567",
    "POIName": "樹龍",
    "Telno": "(02)26822314",
    "Address": "新北市樹林區中正路222號1樓"
}, {
    "POIID": "151531",
    "POIName": "龍興",
    "Telno": "(02)26891028",
    "Address": "新北市樹林區三興里龍興街33號"
}, ], [{
    "POIID": "883924",
    "POIName": "上北可",
    "Telno": "(02)22668183",
    "Address": "新北市土城區明德路一段232號"
}, {
    "POIID": "833642",
    "POIName": "土城",
    "Telno": "(02)22678704",
    "Address": "新北市土城區中央路三段42號"
}, {
    "POIID": "130534",
    "POIName": "中山二",
    "Telno": "(02)22695891",
    "Address": "新北市土城區中山路3號B1樓"
}, {
    "POIID": "186870",
    "POIName": "中林",
    "Telno": "(02)22749849",
    "Address": "新北市土城區員林街14號"
}, {
    "POIID": "187138",
    "POIName": "太子",
    "Telno": "(02)22684903",
    "Address": "新北市土城區中山路47號"
}, {
    "POIID": "133108",
    "POIName": "太陽城",
    "Telno": "(02)22677452",
    "Address": "新北市土城區中央路四段281之8號281之9號"
}, {
    "POIID": "187471",
    "POIName": "文青",
    "Telno": "(02)82602435",
    "Address": "新北市土城區青雲路243號245號"
}, {
    "POIID": "970602",
    "POIName": "民生廠",
    "Telno": "(02)22677917",
    "Address": "新北市土城區民生街4號B1"
}, {
    "POIID": "158646",
    "POIName": "立金",
    "Telno": "(02)22603255",
    "Address": "新北市土城區立德路70號72號"
}, {
    "POIID": "148627",
    "POIName": "光員",
    "Telno": "(02)22669197",
    "Address": "新北市土城區光明街15號"
}, {
    "POIID": "155120",
    "POIName": "廷寮",
    "Telno": "(02)82627892",
    "Address": "新北市土城區清水路252號254號1樓"
}, {
    "POIID": "189330",
    "POIName": "志城",
    "Telno": "(02)22661870",
    "Address": "新北市土城區金城路三段243號245號247號1樓"
}, {
    "POIID": "149239",
    "POIName": "佳福",
    "Telno": "(02)22644239",
    "Address": "新北市土城區青雲路152號"
}, {
    "POIID": "864613",
    "POIName": "延和",
    "Telno": "(02)22619569",
    "Address": "新北市土城區平和里延和路106號"
}, {
    "POIID": "151092",
    "POIName": "延城",
    "Telno": "(02)22629014",
    "Address": "新北市土城區延和路203號1樓"
}, {
    "POIID": "185648",
    "POIName": "延福",
    "Telno": "(02)22708998",
    "Address": "新北市土城區延平街36號"
}, {
    "POIID": "992897",
    "POIName": "忠承",
    "Telno": "(02)22696854",
    "Address": "新北市土城區忠承路103號1樓"
}, {
    "POIID": "164375",
    "POIName": "忠華",
    "Telno": "(02)22629661",
    "Address": "新北市土城區中華路一段185號187號1樓"
}, {
    "POIID": "119283",
    "POIName": "承天",
    "Telno": "(02)22687436",
    "Address": "新北市土城區承天路1號"
}, {
    "POIID": "187839",
    "POIName": "泳豐",
    "Telno": "(02)22746318",
    "Address": "新北市土城區永豐路264之1號"
}, {
    "POIID": "888147",
    "POIName": "金城",
    "Telno": "(02)22633381",
    "Address": "新北市土城區金城路3段71號"
}, {
    "POIID": "128483",
    "POIName": "金峰",
    "Telno": "(02)22616746",
    "Address": "新北市土城區明峰街9號11號"
}, {
    "POIID": "126085",
    "POIName": "金源",
    "Telno": "(02)22604178",
    "Address": "新北市土城區水源街59號"
}, {
    "POIID": "184184",
    "POIName": "金裕",
    "Telno": "(02)22706865",
    "Address": "新北市土城區裕民路255號1樓"
}, {
    "POIID": "148694",
    "POIName": "青雲",
    "Telno": "(02)22742215",
    "Address": "新北市土城區青雲路499號501號"
}, {
    "POIID": "924757",
    "POIName": "信利",
    "Telno": "(02)22749266",
    "Address": "新北市土城區興城路96巷4號"
}, {
    "POIID": "167271",
    "POIName": "城政",
    "Telno": "(02)22668017",
    "Address": "新北市土城區中正路69號1樓"
}, {
    "POIID": "956662",
    "POIName": "城運",
    "Telno": "(02)22688683",
    "Address": "新北市土城區承天路10號"
}, {
    "POIID": "992923",
    "POIName": "皇翔",
    "Telno": "(02)22645433",
    "Address": "新北市土城區中央路一段88號1樓"
}, {
    "POIID": "962069",
    "POIName": "皇裕",
    "Telno": "(02)22707944",
    "Address": "新北市土城區裕民路114巷16號1樓"
}, {
    "POIID": "164663",
    "POIName": "虹海",
    "Telno": "(02)22678273",
    "Address": "新北市土城區中央路四段109號111號1樓"
}, {
    "POIID": "187655",
    "POIName": "高峰",
    "Telno": "(02)22704792",
    "Address": "新北市土城區中央路二段187號"
}, {
    "POIID": "163899",
    "POIName": "清和",
    "Telno": "(02)22740716",
    "Address": "新北市土城區清水路100號"
}, {
    "POIID": "880268",
    "POIName": "祥吉",
    "Telno": "(02)82602068",
    "Address": "新北市土城區延吉街194號"
}, {
    "POIID": "184678",
    "POIName": "祥泰",
    "Telno": "(02)22679712",
    "Address": "新北市土城區中山路38號"
}, {
    "POIID": "186995",
    "POIName": "頂埔",
    "Telno": "(02)22676292",
    "Address": "新北市土城區中央路4段274號276號1樓"
}, {
    "POIID": "131537",
    "POIName": "隆城",
    "Telno": "(02)22647617",
    "Address": "新北市土城區學士路17號"
}, {
    "POIID": "971144",
    "POIName": "新永寧",
    "Telno": "(02)22671893",
    "Address": "新北市土城區中央路三段191之1號及永寧路1號3號"
}, {
    "POIID": "141969",
    "POIName": "新亞洲",
    "Telno": "(02)22693503",
    "Address": "新北市土城區亞洲路110號112號1樓"
}, {
    "POIID": "126823",
    "POIName": "新紫城",
    "Telno": "(02)22681974",
    "Address": "新北市土城區福安街38號40號"
}, {
    "POIID": "971203",
    "POIName": "新裕生",
    "Telno": "(02)22632523",
    "Address": "新北市土城區裕民路57號及55巷2號"
}, {
    "POIID": "188212",
    "POIName": "新學府",
    "Telno": "(02)22627929",
    "Address": "新北市土城區學府路一段223號225號1樓"
}, {
    "POIID": "996202",
    "POIName": "聖運",
    "Telno": "(02)22730671",
    "Address": "新北市土城區柑林里明德路二段159號"
}, {
    "POIID": "163903",
    "POIName": "福祥",
    "Telno": "(02)82613294",
    "Address": "新北市土城區中央路一段320號322號"
}, {
    "POIID": "171122",
    "POIName": "德城",
    "Telno": "(02)22648474",
    "Address": "新北市土城區明德路一段139號141號"
}, {
    "POIID": "174763",
    "POIName": "慶祥",
    "Telno": "(02)22690465",
    "Address": "新北市土城區中華路2段126號1樓"
}, {
    "POIID": "182292",
    "POIName": "摩漾",
    "Telno": "(02)82733155",
    "Address": "新北市土城區中央路二段61巷21號1樓"
}, {
    "POIID": "164755",
    "POIName": "學城",
    "Telno": "(02)22652690",
    "Address": "新北市土城區學府路一段118號"
}, {
    "POIID": "165998",
    "POIName": "學裕",
    "Telno": "(02)22663508",
    "Address": "新北市土城區學成路91巷2號93號1樓"
}, {
    "POIID": "977913",
    "POIName": "濬家",
    "Telno": "(02)89669773",
    "Address": "新北市土城區廣明街2號"
}, {
    "POIID": "110286",
    "POIName": "鴻成",
    "Telno": "(02)22628731",
    "Address": "新北市土城區學府路一段28號1樓"
}, {
    "POIID": "182317",
    "POIName": "燿福",
    "Telno": "(02)22675013",
    "Address": "新北市土城區中山路1-1號1樓"
}, {
    "POIID": "183158",
    "POIName": "鑫城",
    "Telno": "(02)82733284",
    "Address": "新北市土城區中華路1段100號1樓"
}, ], [{
    "POIID": "144511",
    "POIName": "文豪",
    "Telno": "(02)28482734",
    "Address": "新北市蘆洲區民族路402號406號1樓"
}, {
    "POIID": "130327",
    "POIName": "民仁",
    "Telno": "(02)82868495",
    "Address": "新北市蘆洲區仁愛街58號60號"
}, {
    "POIID": "113285",
    "POIName": "民欣",
    "Telno": "(02)28473454",
    "Address": "新北市蘆洲區光榮路63號65號67號"
}, {
    "POIID": "173760",
    "POIName": "永樂",
    "Telno": "(02)82868745",
    "Address": "新北市蘆洲區永樂街35號37號1樓"
}, {
    "POIID": "180643",
    "POIName": "池田",
    "Telno": "(02)82869533",
    "Address": "新北市蘆洲區民族路224號226號1樓"
}, {
    "POIID": "185039",
    "POIName": "和華",
    "Telno": "(02)22899461",
    "Address": "新北市蘆洲區正和街28號"
}, {
    "POIID": "159476",
    "POIName": "長九",
    "Telno": "(02)82861065",
    "Address": "新北市蘆洲區九芎街92號94號1樓"
}, {
    "POIID": "128748",
    "POIName": "長樂",
    "Telno": "(02)22892936",
    "Address": "新北市蘆洲區長安街269號"
}, {
    "POIID": "184531",
    "POIName": "前進",
    "Telno": "(02)82812439",
    "Address": "新北市蘆洲區中正路185巷50號52號1樓"
}, {
    "POIID": "186951",
    "POIName": "美禎",
    "Telno": "(02)28473199",
    "Address": "新北市蘆洲區復興路322號"
}, {
    "POIID": "113377",
    "POIName": "飛龍",
    "Telno": "(02)28474291",
    "Address": "新北市蘆洲區永安南路二段356號環堤大道2號6號"
}, {
    "POIID": "985785",
    "POIName": "珈英",
    "Telno": "(02)22857510",
    "Address": "新北市蘆洲區復興路92號"
}, {
    "POIID": "129383",
    "POIName": "徐匯",
    "Telno": "(02)82816747",
    "Address": "新北市蘆洲區中山一路6號1樓"
}, {
    "POIID": "187046",
    "POIName": "泰星",
    "Telno": "(02)82853450",
    "Address": "新北市蘆洲區成功里長安街276號"
}, {
    "POIID": "151128",
    "POIName": "健倫",
    "Telno": "(02)22839655",
    "Address": "新北市蘆洲區保新里4鄰三民路230號"
}, {
    "POIID": "185590",
    "POIName": "得勝",
    "Telno": "(02)82854204",
    "Address": "新北市蘆洲區得勝街67號1樓"
}, {
    "POIID": "871482",
    "POIName": "統吉",
    "Telno": "(02)22897033",
    "Address": "新北市蘆洲區永平街32巷12弄1號"
}, {
    "POIID": "158989",
    "POIName": "智華",
    "Telno": "(02)22897911",
    "Address": "新北市蘆洲區光華路72號"
}, {
    "POIID": "113388",
    "POIName": "華安",
    "Telno": "(02)28480247",
    "Address": "新北市蘆洲區長安街107號"
}, {
    "POIID": "185589",
    "POIName": "集德",
    "Telno": "(02)82862748",
    "Address": "新北市蘆洲區集賢路228號1樓"
}, {
    "POIID": "961033",
    "POIName": "集賢",
    "Telno": "(02)22835304",
    "Address": "新北市蘆洲區集賢路271號"
}, {
    "POIID": "179702",
    "POIName": "新天際",
    "Telno": "(02)28480473",
    "Address": "新北市蘆洲區三民路575號"
}, {
    "POIID": "990639",
    "POIName": "新吉麗",
    "Telno": "(02)22889790",
    "Address": "新北市蘆洲區中山一路204號1樓"
}, {
    "POIID": "972424",
    "POIName": "新義民",
    "Telno": "(02)22895415",
    "Address": "新北市蘆洲區民族路122號124號"
}, {
    "POIID": "141176",
    "POIName": "榮華",
    "Telno": "(02)82856572",
    "Address": "新北市蘆洲區長榮路75號1樓"
}, {
    "POIID": "916284",
    "POIName": "領袖",
    "Telno": "(02)82863383",
    "Address": "新北市蘆洲區集賢路224巷60號62號"
}, {
    "POIID": "158462",
    "POIName": "憲金",
    "Telno": "(02)22857237",
    "Address": "新北市蘆洲區光華路22巷1號"
}, {
    "POIID": "141626",
    "POIName": "雙捷",
    "Telno": "(02)82856703",
    "Address": "新北市蘆洲區信義路162號166號168號1樓"
}, {
    "POIID": "155393",
    "POIName": "雙華",
    "Telno": "(02)28488245",
    "Address": "新北市蘆洲區中華街39號1樓"
}, {
    "POIID": "170679",
    "POIName": "蘆三",
    "Telno": "(02)82812524",
    "Address": "新北市蘆洲區三民路6號8號"
}, {
    "POIID": "158451",
    "POIName": "蘆正",
    "Telno": "(02)22827244",
    "Address": "新北市蘆洲區中正路261號"
}, {
    "POIID": "149815",
    "POIName": "蘆永",
    "Telno": "(02)28483614",
    "Address": "新北市蘆洲區永安南路二段18號"
}, {
    "POIID": "190411",
    "POIName": "蘆安",
    "Telno": "(02)28484952",
    "Address": "新北市蘆洲區長安街64號1樓"
}, {
    "POIID": "110552",
    "POIName": "蘆荻",
    "Telno": "(02)82862547",
    "Address": "新北市蘆洲區永康街1巷35號1樓"
}, {
    "POIID": "967101",
    "POIName": "蘆揚",
    "Telno": "(02)28488352",
    "Address": "新北市蘆洲區民生街30號"
}, {
    "POIID": "131515",
    "POIName": "蘆華",
    "Telno": "(02)82850614",
    "Address": "新北市蘆洲區長安街140號1樓"
}, {
    "POIID": "960166",
    "POIName": "蘆樂",
    "Telno": "(02)28474074",
    "Address": "新北市蘆洲區長樂路55號1樓"
}, {
    "POIID": "136934",
    "POIName": "蘆權",
    "Telno": "(02)82866843",
    "Address": "新北市蘆洲區民權路136號138號1樓"
}, {
    "POIID": "138332",
    "POIName": "蘆讚",
    "Telno": "(02)82854801",
    "Address": "新北市蘆洲區中山二路184號"
}, {
    "POIID": "160166",
    "POIName": "鷺江",
    "Telno": "(02)82855403",
    "Address": "新北市蘆洲區長榮路679號1樓"
}, ], [{
    "POIID": "118914",
    "POIName": "白雲",
    "Telno": "(02)26606510",
    "Address": "新北市汐止區民權街二段79號之1"
}, {
    "POIID": "177061",
    "POIName": "旭昇",
    "Telno": "(02)86478304",
    "Address": "新北市汐止區大同路三段332號"
}, {
    "POIID": "111120",
    "POIName": "旭泰",
    "Telno": "(02)26414436",
    "Address": "新北市汐止區建成路57巷1號3號"
}, {
    "POIID": "977935",
    "POIName": "汐止站",
    "Telno": "(02)86915835",
    "Address": "新北市汐止區信義路1號"
}, {
    "POIID": "171580",
    "POIName": "汐忠",
    "Telno": "(02)86917056",
    "Address": "新北市汐止區忠孝東路282號"
}, {
    "POIID": "190662",
    "POIName": "汐旺",
    "Telno": "(02)26934931",
    "Address": "新北市汐止區中興里6鄰中興路105號"
}, {
    "POIID": "186869",
    "POIName": "汐政",
    "Telno": "(02)26419577",
    "Address": "新北市汐止區汐萬路一段222號"
}, {
    "POIID": "135768",
    "POIName": "汐科",
    "Telno": "(02)26498508",
    "Address": "新北市汐止區大同路二段167-1號1樓"
}, {
    "POIID": "174121",
    "POIName": "汐峰",
    "Telno": "(02)26429873",
    "Address": "新北市汐止區仁愛路32號34號1樓"
}, {
    "POIID": "142331",
    "POIName": "汐湖",
    "Telno": "(02)26923147",
    "Address": "新北市汐止區康寧街141巷49號51號1樓"
}, {
    "POIID": "183642",
    "POIName": "汐園",
    "Telno": "(02)26902446",
    "Address": "新北市汐止區大同路一段237之7號1樓"
}, {
    "POIID": "146861",
    "POIName": "汐福",
    "Telno": "(02)26949011",
    "Address": "新北市汐止區福德一路243號"
}, {
    "POIID": "141062",
    "POIName": "艾科卡",
    "Telno": "(02)86489199",
    "Address": "新北市汐止區茄苳路196號"
}, {
    "POIID": "180997",
    "POIName": "伯爵",
    "Telno": "(02)86951684",
    "Address": "新北市汐止區明峰街13號13之1號1樓"
}, {
    "POIID": "187688",
    "POIName": "明峰",
    "Telno": "(02)26944744",
    "Address": "新北市汐止區明峰街179之1號"
}, {
    "POIID": "173575",
    "POIName": "明園",
    "Telno": "(02)26462170",
    "Address": "新北市汐止區汐萬路二段62巷1號1樓"
}, {
    "POIID": "151852",
    "POIName": "東科大",
    "Telno": "(02)26969945",
    "Address": "新北市汐止區新台五路一段96號"
}, {
    "POIID": "174925",
    "POIName": "東晴",
    "Telno": "(02)26481974",
    "Address": "新北市汐止區新台五路2段80號"
}, {
    "POIID": "966430",
    "POIName": "矽功",
    "Telno": "(02)26410436",
    "Address": "新北市汐止區大同路1段284號"
}, {
    "POIID": "148753",
    "POIName": "社后",
    "Telno": "(02)26943031",
    "Address": "新北市汐止區中興里中興路190號"
}, {
    "POIID": "136163",
    "POIName": "建陽",
    "Telno": "(02)26958543",
    "Address": "新北市汐止區福德一路452號1樓"
}, {
    "POIID": "163800",
    "POIName": "建德",
    "Telno": "(02)26932349",
    "Address": "新北市汐止區福德一路399號1樓"
}, {
    "POIID": "185523",
    "POIName": "茄苳",
    "Telno": "(02)86484946",
    "Address": "新北市汐止區忠孝東路357號359號1樓"
}, {
    "POIID": "999898",
    "POIName": "康湖",
    "Telno": "(02)26950174",
    "Address": "新北市汐止區康寧街490號"
}, {
    "POIID": "132002",
    "POIName": "勝福",
    "Telno": "(02)86934526",
    "Address": "新北市汐止區福德一路98號100號(夾層)樓"
}, {
    "POIID": "128737",
    "POIName": "富鄰",
    "Telno": "(02)26601799",
    "Address": "新北市汐止區宜興街8號"
}, {
    "POIID": "906841",
    "POIName": "尊爵",
    "Telno": "(02)26429012",
    "Address": "新北市汐止區伯爵街32號"
}, {
    "POIID": "959292",
    "POIName": "智慧",
    "Telno": "(02)86421397",
    "Address": "新北市汐止區大同路2段281號"
}, {
    "POIID": "167732",
    "POIName": "湖前",
    "Telno": "(02)26958128",
    "Address": "新北市汐止區明峰街120號1樓"
}, {
    "POIID": "171133",
    "POIName": "湖鑫",
    "Telno": "(02)26943740",
    "Address": "新北市汐止區湖前街37號39號1樓"
}, {
    "POIID": "174523",
    "POIName": "登峰",
    "Telno": "(02)26919970",
    "Address": "新北市汐止區新台五路一段149號1樓"
}, {
    "POIID": "897864",
    "POIName": "進益",
    "Telno": "(02)86923235",
    "Address": "新北市汐止區大同路二段314號"
}, {
    "POIID": "959306",
    "POIName": "鄉長",
    "Telno": "(02)26917900",
    "Address": "新北市汐止區鄉長路二段16號"
}, {
    "POIID": "184841",
    "POIName": "新工建",
    "Telno": "(02)26486390",
    "Address": "新北市汐止區中興路60號"
}, {
    "POIID": "128391",
    "POIName": "新旭勝",
    "Telno": "(02)26490241",
    "Address": "新北市汐止區建成路160巷2號"
}, {
    "POIID": "185936",
    "POIName": "新汐農",
    "Telno": "(02)26414429",
    "Address": "新北市汐止區樟樹一路113號115號"
}, {
    "POIID": "922968",
    "POIName": "新盛昌",
    "Telno": "(02)26486529",
    "Address": "新北市汐止區長江街13巷1號"
}, {
    "POIID": "996235",
    "POIName": "新樟樹",
    "Telno": "(02)26436365",
    "Address": "新北市汐止區樟樹二路255號"
}, {
    "POIID": "188359",
    "POIName": "實萬",
    "Telno": "(02)26461145",
    "Address": "新北市汐止區汐萬路二段248號1樓"
}, {
    "POIID": "164456",
    "POIName": "福仁",
    "Telno": "(02)26496368",
    "Address": "新北市汐止區仁愛路143號"
}, {
    "POIID": "896447",
    "POIName": "福百",
    "Telno": "(02)26933348",
    "Address": "新北市汐止區福德一路161號"
}, {
    "POIID": "179849",
    "POIName": "遠東",
    "Telno": "(02)86981019",
    "Address": "新北市汐止區新台五路一段75號1樓之2"
}, {
    "POIID": "184759",
    "POIName": "樟福",
    "Telno": "(02)26434449",
    "Address": "新北市汐止區樟樹一路256號258號1樓"
}, {
    "POIID": "891006",
    "POIName": "潤安",
    "Telno": "(02)26485573",
    "Address": "新北市汐止區龍安路32號"
}, {
    "POIID": "184977",
    "POIName": "橋東",
    "Telno": "(02)86423691",
    "Address": "新北市汐止區建成路31號33號1樓"
}, {
    "POIID": "990204",
    "POIName": "聯合報",
    "Telno": "(02)26484793",
    "Address": "新北市汐止區大同路一段369號1樓"
}, {
    "POIID": "180506",
    "POIName": "鎮天",
    "Telno": "(02)26905907",
    "Address": "新北市汐止區大同路三段611之5號611之6號1樓"
}, ], [{
    "POIID": "166751",
    "POIName": "二甲",
    "Telno": "(02)26797209",
    "Address": "新北市鶯歌區中正三路165號167號"
}, {
    "POIID": "138549",
    "POIName": "二橋",
    "Telno": "(02)26774894",
    "Address": "新北市鶯歌區中正三路93號"
}, {
    "POIID": "950907",
    "POIName": "三靖",
    "Telno": "(02)26746991",
    "Address": "新北市鶯歌區三鶯路52號一樓"
}, {
    "POIID": "165596",
    "POIName": "元町",
    "Telno": "(02)26708742",
    "Address": "新北市鶯歌區光明街128號130號1樓"
}, {
    "POIID": "126786",
    "POIName": "尖山",
    "Telno": "(02)26774621",
    "Address": "新北市鶯歌區國際二路6巷1號"
}, {
    "POIID": "123639",
    "POIName": "金億",
    "Telno": "(02)26777111",
    "Address": "新北市鶯歌區建國路278號"
}, {
    "POIID": "912271",
    "POIName": "金鶯",
    "Telno": "(02)26777210",
    "Address": "新北市鶯歌區鶯桃路131-133號"
}, {
    "POIID": "982328",
    "POIName": "長虹",
    "Telno": "(02)26789855",
    "Address": "新北市鶯歌區鶯桃路432號1樓"
}, {
    "POIID": "945042",
    "POIName": "國鶯",
    "Telno": "(02)26705843",
    "Address": "新北市鶯歌區中山路142號1F"
}, {
    "POIID": "972273",
    "POIName": "博鑫",
    "Telno": "(02)26708042",
    "Address": "新北市鶯歌區中正三路283-1號283-2號1樓"
}, {
    "POIID": "190422",
    "POIName": "翔鳳",
    "Telno": "(02)26773047",
    "Address": "新北市鶯歌區鶯桃路467號469號"
}, {
    "POIID": "959742",
    "POIName": "新鶯歌站",
    "Telno": "(02)26797045",
    "Address": "新北市鶯歌區文化路68號之1"
}, {
    "POIID": "901260",
    "POIName": "萬全",
    "Telno": "(02)86776880",
    "Address": "新北市鶯歌區鶯桃路660號"
}, {
    "POIID": "976150",
    "POIName": "聖陶",
    "Telno": "(02)26783246",
    "Address": "新北市鶯歌區文化路407號411號"
}, {
    "POIID": "916099",
    "POIName": "歌亭",
    "Telno": "(02)26791544",
    "Address": "新北市鶯歌區尖山里尖山路150號"
}, {
    "POIID": "126373",
    "POIName": "歌園",
    "Telno": "(02)86774484",
    "Address": "新北市鶯歌區國華路31號"
}, {
    "POIID": "123477",
    "POIName": "歌德",
    "Telno": "(02)86780326",
    "Address": "新北市鶯歌區德昌二街77號之1"
}, {
    "POIID": "163947",
    "POIName": "鳳福",
    "Telno": "(02)26774207",
    "Address": "新北市鶯歌區鶯桃路2段48號50號1樓"
}, {
    "POIID": "179861",
    "POIName": "樂陶",
    "Telno": "(02)26775483",
    "Address": "新北市鶯歌區尖山路276號1樓"
}, {
    "POIID": "993867",
    "POIName": "鶯育",
    "Telno": "(02)86781712",
    "Address": "新北市鶯歌區南雅路34號36號1樓"
}, {
    "POIID": "165633",
    "POIName": "鶯桃",
    "Telno": "(02)26782143",
    "Address": "新北市鶯歌區鶯桃路二段7號"
}, {
    "POIID": "149653",
    "POIName": "鶯瓷",
    "Telno": "(02)26776941",
    "Address": "新北市鶯歌區尖山埔路100號102號"
}, {
    "POIID": "162542",
    "POIName": "鶯歌",
    "Telno": "(02)26798006",
    "Address": "新北市鶯歌區國慶街139號"
}, ], [{
    "POIID": "188876",
    "POIName": "大峽",
    "Telno": "(02)86722354",
    "Address": "新北市三峽區大學路13鄰147號1樓"
}, {
    "POIID": "121426",
    "POIName": "中園",
    "Telno": "(02)86715297",
    "Address": "新北市三峽區民權街235號1樓"
}, {
    "POIID": "111913",
    "POIName": "天下",
    "Telno": "(02)26713245",
    "Address": "新北市三峽區中正路1段110號112號1樓"
}, {
    "POIID": "187482",
    "POIName": "北大成",
    "Telno": "(02)86713490",
    "Address": "新北市三峽區學成路301號303號1樓"
}, {
    "POIID": "144706",
    "POIName": "民昇",
    "Telno": "(02)86713134",
    "Address": "新北市三峽區民生街136號"
}, {
    "POIID": "179780",
    "POIName": "成峽",
    "Telno": "(02)86767975",
    "Address": "新北市三峽區介壽路3段153號1樓"
}, {
    "POIID": "126432",
    "POIName": "岩昇",
    "Telno": "(02)86761485",
    "Address": "新北市三峽區溪東路300號"
}, {
    "POIID": "185545",
    "POIName": "芳榮",
    "Telno": "(02)26741474",
    "Address": "新北市三峽區中正路二段536號538號"
}, {
    "POIID": "902241",
    "POIName": "金銘",
    "Telno": "(02)86741722",
    "Address": "新北市三峽區介壽路一段27號"
}, {
    "POIID": "120412",
    "POIName": "冠綸",
    "Telno": "(02)86721694",
    "Address": "新北市三峽區中華路59號61號1樓"
}, {
    "POIID": "111038",
    "POIName": "峽太",
    "Telno": "(02)86711944",
    "Address": "新北市三峽區大同路90號92號"
}, {
    "POIID": "181417",
    "POIName": "峽北",
    "Telno": "(02)86726321",
    "Address": "新北市三峽區大同路9號1樓"
}, {
    "POIID": "187976",
    "POIName": "峽光",
    "Telno": "(02)86716051",
    "Address": "新北市三峽區光明路62號1樓"
}, {
    "POIID": "148960",
    "POIName": "恩主",
    "Telno": "(02)26721540",
    "Address": "新北市三峽區鳶山里21鄰復興路447號"
}, {
    "POIID": "942515",
    "POIName": "御成",
    "Telno": "(02)86710784",
    "Address": "新北市三峽區國光街35號"
}, {
    "POIID": "177418",
    "POIName": "新北大",
    "Telno": "(02)26714880",
    "Address": "新北市三峽區大學路156號1樓"
}, {
    "POIID": "174785",
    "POIName": "新峽",
    "Telno": "(02)26731461",
    "Address": "新北市三峽區民權街184號186號1樓"
}, {
    "POIID": "185132",
    "POIName": "萬誠",
    "Telno": "(02)26748742",
    "Address": "新北市三峽區民生街25號"
}, {
    "POIID": "137591",
    "POIName": "嘉添",
    "Telno": "(02)86714891",
    "Address": "新北市三峽區嘉添路109-2號"
}, {
    "POIID": "185925",
    "POIName": "榮泰",
    "Telno": "(02)86711644",
    "Address": "新北市三峽區文化路63號65巷2號1樓"
}, {
    "POIID": "122245",
    "POIName": "福峽",
    "Telno": "(02)86720541",
    "Address": "新北市三峽區介壽路1段286號1樓"
}, {
    "POIID": "861131",
    "POIName": "綠洲",
    "Telno": "(02)26717933",
    "Address": "新北市三峽區鳶山里12鄰中山路186號1樓"
}, {
    "POIID": "959328",
    "POIName": "綠雅",
    "Telno": "(02)86715490",
    "Address": "新北市三峽區文化路122號"
}, {
    "POIID": "158336",
    "POIName": "歐洲",
    "Telno": "(02)26719429",
    "Address": "新北市三峽區三樹路199號"
}, {
    "POIID": "982007",
    "POIName": "學勤",
    "Telno": "(02)86721564",
    "Address": "新北市三峽區學勤路105號及大德路211號1樓"
}, {
    "POIID": "997962",
    "POIName": "橫溪",
    "Telno": "(02)86766628",
    "Address": "新北市三峽區溪北街109號"
}, {
    "POIID": "131249",
    "POIName": "龍恩",
    "Telno": "(02)86715410",
    "Address": "新北市三峽區國學街13號"
}, {
    "POIID": "959339",
    "POIName": "豐康",
    "Telno": "(02)26726462",
    "Address": "新北市三峽區成福路241號"
}, ], [{
    "POIID": "143770",
    "POIName": "天元",
    "Telno": "(02)26269419",
    "Address": "新北市淡水區北新路三段30號1樓2樓"
}, {
    "POIID": "189857",
    "POIName": "水鑫",
    "Telno": "(02)26219837",
    "Address": "新北市淡水區大忠街83號"
}, {
    "POIID": "173601",
    "POIName": "北淡",
    "Telno": "(02)26298932",
    "Address": "新北市淡水區北新路182巷34號36號38號40號"
}, {
    "POIID": "186010",
    "POIName": "台北灣",
    "Telno": "(02)26236308",
    "Address": "新北市淡水區新市一路一段108號1樓"
}, {
    "POIID": "981347",
    "POIName": "巧立",
    "Telno": "(02)86311635",
    "Address": "新北市淡水區北新路184巷57號59號1樓"
}, {
    "POIID": "180126",
    "POIName": "立竹",
    "Telno": "(02)88092553",
    "Address": "新北市淡水區民族路58號1樓2樓"
}, {
    "POIID": "122256",
    "POIName": "立征",
    "Telno": "(02)86315475",
    "Address": "新北市淡水區大義街16號1樓"
}, {
    "POIID": "143035",
    "POIName": "立飛",
    "Telno": "(02)88095328",
    "Address": "新北市淡水區民生路126號128號1樓2樓"
}, {
    "POIID": "933120",
    "POIName": "吉發",
    "Telno": "(02)28084565",
    "Address": "新北市淡水區自強路275號"
}, {
    "POIID": "149206",
    "POIName": "竹捷",
    "Telno": "(02)28085610",
    "Address": "新北市淡水區竹圍里民族路10號"
}, {
    "POIID": "119308",
    "POIName": "竹圍",
    "Telno": "(02)28091574",
    "Address": "新北市淡水區民權路109號111號"
}, {
    "POIID": "144522",
    "POIName": "老街",
    "Telno": "(02)26229691",
    "Address": "新北市淡水區公明街48號1樓"
}, {
    "POIID": "130453",
    "POIName": "見欣",
    "Telno": "(02)26261243",
    "Address": "新北市淡水區中正東路一段三巷12號1樓"
}, {
    "POIID": "162195",
    "POIName": "協元",
    "Telno": "(02)26219045",
    "Address": "新北市淡水區中山路176之2號1樓"
}, {
    "POIID": "991137",
    "POIName": "武強",
    "Telno": "(02)28095608",
    "Address": "新北市淡水區自強路375號1樓"
}, {
    "POIID": "956341",
    "POIName": "金旦",
    "Telno": "(02)26213108",
    "Address": "新北市淡水區淡金路三段254號256號"
}, {
    "POIID": "173612",
    "POIName": "金沙",
    "Telno": "(02)28057369",
    "Address": "新北市淡水區沙崙路133號"
}, {
    "POIID": "170107",
    "POIName": "金星",
    "Telno": "(02)26260905",
    "Address": "新北市淡水區北新路65號"
}, {
    "POIID": "916538",
    "POIName": "金紅",
    "Telno": "(02)26200484",
    "Address": "新北市淡水區淡金路3段2號"
}, {
    "POIID": "112400",
    "POIName": "金崙",
    "Telno": "(02)28055104",
    "Address": "新北市淡水區沙崙路24號1樓"
}, {
    "POIID": "167156",
    "POIName": "金聖",
    "Telno": "(02)28010623",
    "Address": "新北市淡水區淡金路四段493號"
}, {
    "POIID": "900429",
    "POIName": "金寶",
    "Telno": "(02)26297608",
    "Address": "新北市淡水區中正路169號"
}, {
    "POIID": "972918",
    "POIName": "皇后",
    "Telno": "(02)26200724",
    "Address": "新北市淡水區新春街87號"
}, {
    "POIID": "160041",
    "POIName": "紅林站",
    "Telno": "(02)26242082",
    "Address": "新北市淡水區中正東路二段65號"
}, {
    "POIID": "135540",
    "POIName": "紅樹林",
    "Telno": "(02)28086437",
    "Address": "新北市淡水區中正東路二段81號1樓"
}, {
    "POIID": "129187",
    "POIName": "英專",
    "Telno": "(02)86317597",
    "Address": "新北市淡水區英專路93號"
}, {
    "POIID": "137764",
    "POIName": "真善美",
    "Telno": "(02)26297240",
    "Address": "新北市淡水區新市一路三段141號141之1號1樓"
}, {
    "POIID": "185420",
    "POIName": "偕成",
    "Telno": "(02)28091272",
    "Address": "新北市淡水區民生路54號"
}, {
    "POIID": "874126",
    "POIName": "淡大",
    "Telno": "(02)26203554",
    "Address": "新北市淡水區北新路182巷5弄39號"
}, {
    "POIID": "190008",
    "POIName": "淡水",
    "Telno": "(02)26233091",
    "Address": "新北市淡水區中正東路3號"
}, {
    "POIID": "985604",
    "POIName": "淡江",
    "Telno": "(02)26204950",
    "Address": "新北市淡水區學府路207號"
}, {
    "POIID": "961778",
    "POIName": "淡欣",
    "Telno": "(02)26210745",
    "Address": "新北市淡水區水源街2段104號"
}, {
    "POIID": "185235",
    "POIName": "淡芝",
    "Telno": "(02)28013735",
    "Address": "新北市淡水區淡金路五段120號1樓"
}, {
    "POIID": "946377",
    "POIName": "渡船頭",
    "Telno": "(02)26222172",
    "Address": "新北市淡水區中正路57號59號"
}, {
    "POIID": "184391",
    "POIName": "愛琴灣",
    "Telno": "(02)26239285",
    "Address": "新北市淡水區濱海路一段430號432號"
}, {
    "POIID": "131179",
    "POIName": "新市鎮",
    "Telno": "(02)26228481",
    "Address": "新北市淡水區新市一路三段18號1樓"
}, {
    "POIID": "174039",
    "POIName": "新春",
    "Telno": "(02)26267510",
    "Address": "新北市淡水區新春街142號1樓"
}, {
    "POIID": "161158",
    "POIName": "新真理",
    "Telno": "(02)26292848",
    "Address": "新北市淡水區新民街102號104號"
}, {
    "POIID": "163981",
    "POIName": "新淡專",
    "Telno": "(02)26282814",
    "Address": "新北市淡水區新民街180巷18號20號1樓"
}, {
    "POIID": "179883",
    "POIName": "新滬站",
    "Telno": "(02)26267791",
    "Address": "新北市淡水區中正路1號"
}, {
    "POIID": "190499",
    "POIName": "源德",
    "Telno": "(02)26265872",
    "Address": "新北市淡水區水源街一段75之2號1樓B1"
}, {
    "POIID": "975180",
    "POIName": "聖約翰",
    "Telno": "(02)28010894",
    "Address": "新北市淡水區淡金路四段532號"
}, {
    "POIID": "164320",
    "POIName": "學府",
    "Telno": "(02)26281792",
    "Address": "新北市淡水區學府路39號41號1樓"
}, {
    "POIID": "912891",
    "POIName": "霞關",
    "Telno": "(02)26253171",
    "Address": "新北市淡水區淡金路59-61號B1"
}, {
    "POIID": "181934",
    "POIName": "馥竹",
    "Telno": "(02)28086729",
    "Address": "新北市淡水區民權路187巷19號1樓"
}, {
    "POIID": "181130",
    "POIName": "鯊魚",
    "Telno": "(02)28052232",
    "Address": "新北市淡水區沙崙路196號"
}, {
    "POIID": "150860",
    "POIName": "鑫鑫",
    "Telno": "(02)26262742",
    "Address": "新北市淡水區水源街2段76號"
}, ], [{
    "POIID": "909541",
    "POIName": "九份",
    "Telno": "(02)24061659",
    "Address": "新北市瑞芳區基山街3號"
}, {
    "POIID": "126959",
    "POIName": "三爪坑",
    "Telno": "(02)24978934",
    "Address": "新北市瑞芳區三爪子坑路15號17號"
}, {
    "POIID": "151841",
    "POIName": "新建興",
    "Telno": "(02)24570184",
    "Address": "新北市瑞芳區大埔路138號"
}, {
    "POIID": "167938",
    "POIName": "瑞明",
    "Telno": "(02)24061545",
    "Address": "新北市瑞芳區明燈路三段86號1樓2樓"
}, {
    "POIID": "112189",
    "POIName": "瑞芳",
    "Telno": "(02)24063893",
    "Address": "新北市瑞芳區明燈路3段52號54號"
}, {
    "POIID": "149011",
    "POIName": "瑞信",
    "Telno": "(02)24063884",
    "Address": "新北市瑞芳區民生街23號"
}, {
    "POIID": "855033",
    "POIName": "瑞濱",
    "Telno": "(02)24972897",
    "Address": "新北市瑞芳區海濱路157號"
}, {
    "POIID": "184210",
    "POIName": "鼻頭角",
    "Telno": "(02)24911584",
    "Address": "新北市瑞芳區鼻頭路227之4號1樓"
}, ], [{
    "POIID": "962380",
    "POIName": "大五股",
    "Telno": "(02)22953630",
    "Address": "新北市五股區成泰路2段81號"
}, {
    "POIID": "890601",
    "POIName": "水碓",
    "Telno": "(02)22917335",
    "Address": "新北市五股區水碓路14號"
}, {
    "POIID": "967983",
    "POIName": "弘龍",
    "Telno": "(02)22952745",
    "Address": "新北市五股區工商路16號"
}, {
    "POIID": "183402",
    "POIName": "民揚",
    "Telno": "(02)22952225",
    "Address": "新北市五股區新五路2段572號1樓"
}, {
    "POIID": "185877",
    "POIName": "成旺",
    "Telno": "(02)82922814",
    "Address": "新北市五股區成泰路3段212號216號218號1樓"
}, {
    "POIID": "163888",
    "POIName": "成洲",
    "Telno": "(02)82925864",
    "Address": "新北市五股區成泰路三段577巷92號94號"
}, {
    "POIID": "187127",
    "POIName": "成泰",
    "Telno": "(02)22935446",
    "Address": "新北市五股區成泰路2段84號1樓"
}, {
    "POIID": "985671",
    "POIName": "利客來",
    "Telno": "(02)22953384",
    "Address": "新北市五股區成泰路3段419號"
}, {
    "POIID": "186766",
    "POIName": "來峰",
    "Telno": "(02)82927346",
    "Address": "新北市五股區成泰路一段163號165號1樓"
}, {
    "POIID": "174419",
    "POIName": "股興",
    "Telno": "(02)29873854",
    "Address": "新北市五股區中興路一段3號"
}, {
    "POIID": "186191",
    "POIName": "洲子洋",
    "Telno": "(02)82925292",
    "Address": "新北市五股區芳洲八路107號109號111號1.2樓"
}, {
    "POIID": "148982",
    "POIName": "泰里",
    "Telno": "(02)82927574",
    "Address": "新北市五股區成泰路四段12號1樓"
}, {
    "POIID": "978640",
    "POIName": "泰股",
    "Telno": "(02)22936457",
    "Address": "新北市五股區成泰路3段577巷24號"
}, {
    "POIID": "175065",
    "POIName": "御城",
    "Telno": "(02)22937343",
    "Address": "新北市五股區御史路3號5號1樓"
}, {
    "POIID": "942733",
    "POIName": "富美",
    "Telno": "(02)22981368",
    "Address": "新北市五股區五股工業區五權路23號"
}, {
    "POIID": "126281",
    "POIName": "富得",
    "Telno": "(02)22990711",
    "Address": "新北市五股區五權路48號1樓"
}, {
    "POIID": "921149",
    "POIName": "登福",
    "Telno": "(02)82952765",
    "Address": "新北市五股區登林路76之3號"
}, {
    "POIID": "922348",
    "POIName": "新台",
    "Telno": "(02)22997131",
    "Address": "新北市五股區五工六路14號"
}, {
    "POIID": "977636",
    "POIName": "新圓山",
    "Telno": "(02)22926587",
    "Address": "新北市五股區成泰路一段191號"
}, {
    "POIID": "165703",
    "POIName": "福泰",
    "Telno": "(02)22933841",
    "Address": "新北市五股區五福路49號51號1樓"
}, {
    "POIID": "956835",
    "POIName": "福臨",
    "Telno": "(02)82921740",
    "Address": "新北市五股區工商路150號"
}, {
    "POIID": "966898",
    "POIName": "維中",
    "Telno": "(02)29840834",
    "Address": "新北市五股區四維路120號"
}, {
    "POIID": "185729",
    "POIName": "德泰",
    "Telno": "(02)85317352",
    "Address": "新北市五股區成泰路一段10號"
}, {
    "POIID": "921976",
    "POIName": "龍五",
    "Telno": "(02)82952619",
    "Address": "新北市五股區凌雲路一段136號"
}, ], [{
    "POIID": "188946",
    "POIName": "十八甲",
    "Telno": "(02)85314338",
    "Address": "新北市泰山區福興一街87號"
}, {
    "POIID": "170369",
    "POIName": "仁泰",
    "Telno": "(02)29099380",
    "Address": "新北市泰山區明志路二段1號"
}, {
    "POIID": "136624",
    "POIName": "公園賞",
    "Telno": "(02)85315095",
    "Address": "新北市泰山區仁愛路66號"
}, {
    "POIID": "979241",
    "POIName": "日勝",
    "Telno": "(02)29090401",
    "Address": "新北市泰山區山腳里泰林路2段515號517號"
}, {
    "POIID": "148199",
    "POIName": "季欣",
    "Telno": "(02)29009494",
    "Address": "新北市泰山區全興路109號"
}, {
    "POIID": "185095",
    "POIName": "明日城",
    "Telno": "(02)85315790",
    "Address": "新北市泰山區信華六街17號19號1樓"
}, {
    "POIID": "127642",
    "POIName": "明志",
    "Telno": "(02)29046227",
    "Address": "新北市泰山區工專路68號70號1樓"
}, {
    "POIID": "131618",
    "POIName": "明泰",
    "Telno": "(02)29047697",
    "Address": "新北市泰山區明志路二段366號368號1樓"
}, {
    "POIID": "141006",
    "POIName": "明貴",
    "Telno": "(02)29041663",
    "Address": "新北市泰山區明志路三段44號46號1樓"
}, {
    "POIID": "932851",
    "POIName": "武仁",
    "Telno": "(02)29007082",
    "Address": "新北市泰山區仁愛路100巷28號30號"
}, {
    "POIID": "993144",
    "POIName": "奕真",
    "Telno": "(02)22960960",
    "Address": "新北市泰山區明志路二段185號1樓(部份)"
}, {
    "POIID": "181107",
    "POIName": "珈多",
    "Telno": "(02)29082024",
    "Address": "新北市泰山區台麗街5號7號9號1樓"
}, {
    "POIID": "149309",
    "POIName": "泰山",
    "Telno": "(02)22975073",
    "Address": "新北市泰山區楓江路22號24號"
}, {
    "POIID": "120722",
    "POIName": "泰陽",
    "Telno": "(02)29047256",
    "Address": "新北市泰山區新北大道六段470號472號"
}, {
    "POIID": "189503",
    "POIName": "羚陽",
    "Telno": "(02)29000858",
    "Address": "新北市泰山區泰林路二段302號304號"
}, {
    "POIID": "159122",
    "POIName": "貴鳳",
    "Telno": "(02)29044794",
    "Address": "新北市泰山區貴鳳街2號"
}, {
    "POIID": "128221",
    "POIName": "新陽光",
    "Telno": "(02)85311274",
    "Address": "新北市泰山區泰林路2段368號370號"
}, {
    "POIID": "177407",
    "POIName": "義學",
    "Telno": "(02)29097094",
    "Address": "新北市泰山區明志路2段74號76號"
}, {
    "POIID": "170509",
    "POIName": "滿泰",
    "Telno": "(02)22978381",
    "Address": "新北市泰山區明志路1段28號"
}, {
    "POIID": "147956",
    "POIName": "輔新",
    "Telno": "(02)29090535",
    "Address": "新北市泰山區新北大道五段385號"
}, ], [{
    "POIID": "987769",
    "POIName": "工林",
    "Telno": "(02)26012135",
    "Address": "新北市林口區工六路76號"
}, {
    "POIID": "190329",
    "POIName": "仁森",
    "Telno": "(02)26032979",
    "Address": "新北市林口區粉寮路1段64號"
}, {
    "POIID": "164892",
    "POIName": "未來",
    "Telno": "(02)26035631",
    "Address": "新北市林口區文化二路一段571號1樓2樓"
}, {
    "POIID": "188522",
    "POIName": "正林",
    "Telno": "(02)86014008",
    "Address": "新北市林口區中正路201號1樓"
}, {
    "POIID": "168023",
    "POIName": "民視",
    "Telno": "(02)86019437",
    "Address": "新北市林口區信義路101號1樓"
}, {
    "POIID": "186755",
    "POIName": "安林",
    "Telno": "(02)26082671",
    "Address": "新北市林口區文化二路一段24號26號"
}, {
    "POIID": "183295",
    "POIName": "臣峰",
    "Telno": "(02)26003717",
    "Address": "新北市林口區文化北路一段62之1號"
}, {
    "POIID": "113986",
    "POIName": "至富",
    "Telno": "(02)86012128",
    "Address": "新北市林口區中湖里14鄰中湖40號之9"
}, {
    "POIID": "186803",
    "POIName": "貝比",
    "Telno": "(02)86014119",
    "Address": "新北市林口區湖南村8鄰頭湖70-9號"
}, {
    "POIID": "160122",
    "POIName": "佳林",
    "Telno": "(02)26020865",
    "Address": "新北市林口區林口路197號"
}, {
    "POIID": "135573",
    "POIName": "幸福市",
    "Telno": "(02)26022319",
    "Address": "新北市林口區文化三路二段302號1樓"
}, {
    "POIID": "162162",
    "POIName": "忠柯",
    "Telno": "(02)26080054",
    "Address": "新北市林口區忠孝路642號"
}, {
    "POIID": "153526",
    "POIName": "旺來",
    "Telno": "(02)86014442",
    "Address": "新北市林口區文化三路二段20號1樓"
}, {
    "POIID": "968023",
    "POIName": "采鋺",
    "Telno": "(02)26007384",
    "Address": "新北市林口區文化三路一段368號"
}, {
    "POIID": "187116",
    "POIName": "長坤",
    "Telno": "(02)26001344",
    "Address": "新北市林口區文化一路一段43號1樓"
}, {
    "POIID": "158266",
    "POIName": "美雅仕",
    "Telno": "(02)26003114",
    "Address": "新北市林口區文化二路一段262號1樓"
}, {
    "POIID": "119571",
    "POIName": "香賓",
    "Telno": "(02)26088040",
    "Address": "新北市林口區忠孝路382號1樓"
}, {
    "POIID": "947934",
    "POIName": "卿斳",
    "Telno": "(02)26015984",
    "Address": "新北市林口區竹林路48號"
}, {
    "POIID": "976024",
    "POIName": "粉寮",
    "Telno": "(02)86014401",
    "Address": "新北市林口區粉寮路二段36號"
}, {
    "POIID": "189525",
    "POIName": "愛鄉",
    "Telno": "(02)86012278",
    "Address": "新北市林口區仁愛路2段140號142號1樓"
}, {
    "POIID": "188669",
    "POIName": "新林口",
    "Telno": "(02)26035613",
    "Address": "新北市林口區中正路90號92號1樓"
}, {
    "POIID": "185121",
    "POIName": "遠來",
    "Telno": "(02)26017102",
    "Address": "新北市林口區仁愛路2段510號1樓"
}, {
    "POIID": "154183",
    "POIName": "德園",
    "Telno": "(02)26068918",
    "Address": "新北市林口區文化二路一段120巷1之1號"
}, {
    "POIID": "174165",
    "POIName": "德聖",
    "Telno": "(02)26090148",
    "Address": "新北市林口區公園路17號"
}, {
    "POIID": "966603",
    "POIName": "興林",
    "Telno": "(02)26009072",
    "Address": "新北市林口區南勢村南勢街280號"
}, {
    "POIID": "146791",
    "POIName": "興都",
    "Telno": "(02)26090392",
    "Address": "新北市林口區文化二路一段378號1樓之一之二之三"
}, {
    "POIID": "163615",
    "POIName": "霖口",
    "Telno": "(02)26032893",
    "Address": "新北市林口區中山路250號250之3號1樓"
}, {
    "POIID": "183882",
    "POIName": "藍天",
    "Telno": "(02)26094849",
    "Address": "新北市林口區公園路203號之1;203號之2"
}, {
    "POIID": "960203",
    "POIName": "麗池",
    "Telno": "(02)26027950",
    "Address": "新北市林口區文化二路2段120號"
}, {
    "POIID": "166072",
    "POIName": "麗興",
    "Telno": "(02)26093347",
    "Address": "新北市林口區麗園一街11巷1號1樓之2"
}, {
    "POIID": "189639",
    "POIName": "麗寶",
    "Telno": "(02)26002592",
    "Address": "新北市林口區文化北路一段301號1樓"
}, {
    "POIID": "890634",
    "POIName": "觀林",
    "Telno": "(02)26035527",
    "Address": "新北市林口區林口路78號80號"
}, ], [{
    "POIID": "187622",
    "POIName": "北深",
    "Telno": "(02)26640166",
    "Address": "新北市深坑區北深路二段183號"
}, {
    "POIID": "127435",
    "POIName": "平埔",
    "Telno": "(02)26645195",
    "Address": "新北市深坑區文化街82號"
}, {
    "POIID": "963567",
    "POIName": "埔昇",
    "Telno": "(02)26645677",
    "Address": "新北市深坑區埔新街63號"
}, {
    "POIID": "880833",
    "POIName": "真誠",
    "Telno": "(02)26642915",
    "Address": "新北市深坑區北深路三段263號"
}, {
    "POIID": "162313",
    "POIName": "深坑",
    "Telno": "(02)26624509",
    "Address": "新北市深坑區北深路三段145號"
}, {
    "POIID": "143024",
    "POIName": "萬順",
    "Telno": "(02)26647847",
    "Address": "新北市深坑區北深路3段198號200號1樓"
}, {
    "POIID": "901330",
    "POIName": "鑫庫",
    "Telno": "(02)26645927",
    "Address": "新北市深坑區北深路一段118號120號"
}, ], [{
    "POIID": "146517",
    "POIName": "錠富",
    "Telno": "(02)26633273",
    "Address": "新北市石碇區隆盛村雙溪56號1樓"
}, ], [{
    "POIID": "920249",
    "POIName": "坪林",
    "Telno": "(02)26656655",
    "Address": "新北市坪林區水柳腳路159號"
}, ], [{
    "POIID": "122360",
    "POIName": "三芝",
    "Telno": "(02)86353879",
    "Address": "新北市三芝區中正路1段61號63號1樓"
}, {
    "POIID": "881548",
    "POIName": "金芝",
    "Telno": "(02)26364574",
    "Address": "新北市三芝區中興街一段2號"
}, {
    "POIID": "164054",
    "POIName": "淺水灣",
    "Telno": "(02)86352497",
    "Address": "新北市三芝區中柳村北勢子42之11號1樓"
}, ], [{
    "POIID": "909390",
    "POIName": "石門",
    "Telno": "(02)26383480",
    "Address": "新北市石門區中山路78號"
}, ], [{
    "POIID": "991458",
    "POIName": "八里",
    "Telno": "(02)26193747",
    "Address": "新北市八里區中山路二段343號1樓"
}, {
    "POIID": "149217",
    "POIName": "左岸",
    "Telno": "(02)26108502",
    "Address": "新北市八里區龍米路2段230號之1號之2號1樓"
}, {
    "POIID": "165390",
    "POIName": "西雅圖",
    "Telno": "(02)86305421",
    "Address": "新北市八里區中山路2段151號153號1樓"
}, {
    "POIID": "186928",
    "POIName": "長坑",
    "Telno": "(02)26195195",
    "Address": "新北市八里區中華路3段168號"
}, {
    "POIID": "183491",
    "POIName": "海神",
    "Telno": "(02)86305062",
    "Address": "新北市八里區中山路二段6號8號"
}, {
    "POIID": "852230",
    "POIName": "益彰",
    "Telno": "(02)26102771",
    "Address": "新北市八里區中山路二段409號411號"
}, {
    "POIID": "890184",
    "POIName": "神州",
    "Telno": "(02)26184212",
    "Address": "新北市八里區龍米路一段113號"
}, {
    "POIID": "127228",
    "POIName": "喜城",
    "Telno": "(02)26194462",
    "Address": "新北市八里區中華路二段562號"
}, {
    "POIID": "167570",
    "POIName": "龍米",
    "Telno": "(02)26188711",
    "Address": "新北市八里區龍米路二段46號48號50號"
}, {
    "POIID": "123628",
    "POIName": "觀海",
    "Telno": "(02)26185125",
    "Address": "新北市八里區龍米路一段140號"
}, {
    "POIID": "173715",
    "POIName": "觀景",
    "Telno": "(02)26107757",
    "Address": "新北市八里區觀海大道53號"
}, ], [{
    "POIID": "144359",
    "POIName": "平溪",
    "Telno": "(02)24952040",
    "Address": "新北市平溪區靜安路二段338號340號"
}, ], [{
    "POIID": "953319",
    "POIName": "雙祥",
    "Telno": "(02)24932928",
    "Address": "新北市雙溪區雙溪村太平路65號67號"
}, {
    "POIID": "903646",
    "POIName": "雙溪",
    "Telno": "(02)24931201",
    "Address": "新北市雙溪區自強路7號"
}, ], [{
    "POIID": "187426",
    "POIName": "和川",
    "Telno": "(02)24902709",
    "Address": "新北市貢寮區延平街63號"
}, {
    "POIID": "127549",
    "POIName": "貢寮",
    "Telno": "(02)24903435",
    "Address": "新北市貢寮區仁和路9號"
}, {
    "POIID": "946816",
    "POIName": "新福隆",
    "Telno": "(02)24992350",
    "Address": "新北市貢寮區福隆里興隆街24之1號"
}, {
    "POIID": "159421",
    "POIName": "福隆站",
    "Telno": "(02)24991826",
    "Address": "新北市貢寮區福隆街8號8-1號"
}, ], [{
    "POIID": "188175",
    "POIName": "金中",
    "Telno": "(02)24081762",
    "Address": "新北市金山區中山路305號307號"
}, {
    "POIID": "999854",
    "POIName": "金全",
    "Telno": "(02)24081935",
    "Address": "新北市金山區清水路52號"
}, {
    "POIID": "182236",
    "POIName": "金美",
    "Telno": "(02)24985386",
    "Address": "新北市金山區中山路143號145號"
}, {
    "POIID": "148786",
    "POIName": "金祥",
    "Telno": "(02)24082441",
    "Address": "新北市金山區中正路145號"
}, ], [{
    "POIID": "961354",
    "POIName": "新野柳",
    "Telno": "(02)24926187",
    "Address": "新北市萬里區野柳港東路158號"
}, {
    "POIID": "153331",
    "POIName": "溫泉",
    "Telno": "(02)24987100",
    "Address": "新北市萬里區大鵬里萬里加投15鄰197號1樓"
}, {
    "POIID": "875417",
    "POIName": "萬里",
    "Telno": "(02)24924901",
    "Address": "新北市萬里區瑪鍊路49號51號"
}, {
    "POIID": "127952",
    "POIName": "翡翠灣",
    "Telno": "(02)24928842",
    "Address": "新北市萬里區龜吼村美崙38號39號"
}, ], [{
    "POIID": "910552",
    "POIName": "那魯灣",
    "Telno": "(02)26616123",
    "Address": "新北市烏來區烏來里溫泉街80號"
}, {
    "POIID": "987909",
    "POIName": "來鑫",
    "Telno": "(02)26617621",
    "Address": "新北市烏來區忠治里堰堤9號11號"
}, ], ], [[{
    "POIID": "122315",
    "POIName": "三元",
    "Telno": "(03)3311502",
    "Address": "桃園市桃園區大業路1段54號56號1樓"
}, {
    "POIID": "184656",
    "POIName": "千山",
    "Telno": "(03)3335381",
    "Address": "桃園市桃園區縣府路212號216號"
}, {
    "POIID": "155430",
    "POIName": "大有",
    "Telno": "(03)3584876",
    "Address": "桃園市桃園區大有路547號1樓"
}, {
    "POIID": "123547",
    "POIName": "大佶",
    "Telno": "(03)3638720",
    "Address": "桃園市桃園區三民路3段490號"
}, {
    "POIID": "165884",
    "POIName": "大椿",
    "Telno": "(03)3577774",
    "Address": "桃園市桃園區春日路1193號1樓"
}, {
    "POIID": "135621",
    "POIName": "大權",
    "Telno": "(03)3357053",
    "Address": "桃園市桃園區大同路57號59號"
}, {
    "POIID": "130899",
    "POIName": "文中",
    "Telno": "(03)2173104",
    "Address": "桃園市桃園區文中路65號1樓"
}, {
    "POIID": "173656",
    "POIName": "文仁",
    "Telno": "(03)3794066",
    "Address": "桃園市桃園區延壽街9號11號1樓"
}, {
    "POIID": "111522",
    "POIName": "文城",
    "Telno": "(03)3705798",
    "Address": "桃園市桃園區龍壽街273巷1號1樓"
}, {
    "POIID": "882404",
    "POIName": "文福",
    "Telno": "(03)3709798",
    "Address": "桃園市桃園區文中路747號"
}, {
    "POIID": "147369",
    "POIName": "世貿",
    "Telno": "(03)3468471",
    "Address": "桃園市桃園區中正路1087號1樓"
}, {
    "POIID": "113849",
    "POIName": "平昌",
    "Telno": "(03)2206730",
    "Address": "桃園市桃園區中平路161號1樓"
}, {
    "POIID": "173678",
    "POIName": "正康",
    "Telno": "(03)3370054",
    "Address": "桃園市桃園區民光路49號"
}, {
    "POIID": "171694",
    "POIName": "正麗",
    "Telno": "(03)3413273",
    "Address": "桃園市桃園區莊一街11號13號1樓"
}, {
    "POIID": "131168",
    "POIName": "民大",
    "Telno": "(03)3256860",
    "Address": "桃園市桃園區大興路221號1樓"
}, {
    "POIID": "972387",
    "POIName": "民越",
    "Telno": "(03)3339237",
    "Address": "桃園市桃園區大有路141號143號"
}, {
    "POIID": "123466",
    "POIName": "禾豐",
    "Telno": "(03)3331864",
    "Address": "桃園市桃園區秀山路95號1樓"
}, {
    "POIID": "136495",
    "POIName": "立國",
    "Telno": "(03)3323125",
    "Address": "桃園市桃園區中山東路51號1樓"
}, {
    "POIID": "150907",
    "POIName": "光北",
    "Telno": "(03)3318631",
    "Address": "桃園市桃園區中山北路42號1樓及地下1樓"
}, {
    "POIID": "113045",
    "POIName": "全鎮",
    "Telno": "(03)3398439",
    "Address": "桃園市桃園區春日路238號240號1樓"
}, {
    "POIID": "189798",
    "POIName": "同德",
    "Telno": "(03)2150474",
    "Address": "桃園市桃園區中埔二街150號"
}, {
    "POIID": "163660",
    "POIName": "成皇",
    "Telno": "(03)3366648",
    "Address": "桃園市桃園區復興路80號"
}, {
    "POIID": "145145",
    "POIName": "有家",
    "Telno": "(03)3257574",
    "Address": "桃園市桃園區大有路457號459號1樓"
}, {
    "POIID": "121725",
    "POIName": "有寶",
    "Telno": "(03)3467732",
    "Address": "桃園市桃園區寶山街209號1樓"
}, {
    "POIID": "170428",
    "POIName": "宏太",
    "Telno": "(03)3752641",
    "Address": "桃園市桃園區桃鶯路384-9號384-10號1樓"
}, {
    "POIID": "190374",
    "POIName": "宏亞",
    "Telno": "(03)2289084",
    "Address": "桃園市桃園區中平路102號"
}, {
    "POIID": "982144",
    "POIName": "宏達電",
    "Telno": "(03)3638382",
    "Address": "桃園市桃園區興華路23號"
}, {
    "POIID": "138985",
    "POIName": "辰興",
    "Telno": "(03)3583730",
    "Address": "桃園市桃園區大興西路一段178號"
}, {
    "POIID": "987862",
    "POIName": "昇宏",
    "Telno": "(03)3462286",
    "Address": "桃園市桃園區大業路二段111號之2"
}, {
    "POIID": "990433",
    "POIName": "欣國榮",
    "Telno": "(03)3554963",
    "Address": "桃園市桃園區經國路860號1樓"
}, {
    "POIID": "948650",
    "POIName": "金凱旋",
    "Telno": "(03)2206756",
    "Address": "桃園市桃園區壽昌街20巷45號47號"
}, {
    "POIID": "116343",
    "POIName": "金富多",
    "Telno": "(03)2161281",
    "Address": "桃園市桃園區寶慶路428號"
}, {
    "POIID": "913012",
    "POIName": "長陽",
    "Telno": "(03)3711375",
    "Address": "桃園市桃園區長沙街90號1樓"
}, {
    "POIID": "120607",
    "POIName": "青溪",
    "Telno": "(03)3313487",
    "Address": "桃園市桃園區自強路2號1樓與中山東路153號1樓"
}, {
    "POIID": "963327",
    "POIName": "冠吾",
    "Telno": "(03)3367050",
    "Address": "桃園市桃園區中正路455號"
}, {
    "POIID": "148269",
    "POIName": "冠桃園",
    "Telno": "(03)3691483",
    "Address": "桃園市桃園區中泰里國際路一段1179號"
}, {
    "POIID": "188038",
    "POIName": "城邦",
    "Telno": "(03)3757509",
    "Address": "桃園市桃園區樹仁三街81號83號85號1樓"
}, {
    "POIID": "122784",
    "POIName": "春寶",
    "Telno": "(03)3574543",
    "Address": "桃園市桃園區春日路670號1樓"
}, {
    "POIID": "992831",
    "POIName": "星寶",
    "Telno": "(03)3256367",
    "Address": "桃園市桃園區大業路一段426號1樓"
}, {
    "POIID": "137867",
    "POIName": "紅蕃茄",
    "Telno": "(03)3362103",
    "Address": "桃園市桃園區復興路83號85號"
}, {
    "POIID": "154725",
    "POIName": "埔子",
    "Telno": "(03)2150752",
    "Address": "桃園市桃園區永安路1040號1040之1號1樓"
}, {
    "POIID": "143758",
    "POIName": "埔民",
    "Telno": "(03)3470875",
    "Address": "桃園市桃園區民生路535號1樓"
}, {
    "POIID": "144267",
    "POIName": "桃中",
    "Telno": "(03)3398295",
    "Address": "桃園市桃園區中正路233號1樓"
}, {
    "POIID": "142076",
    "POIName": "桃民",
    "Telno": "(03)3349819",
    "Address": "桃園市桃園區民族路79號1樓"
}, {
    "POIID": "183653",
    "POIName": "桃全",
    "Telno": "(03)3394721",
    "Address": "桃園市桃園區中正路342號1樓2樓"
}, {
    "POIID": "874506",
    "POIName": "桃朋",
    "Telno": "(03)3021150",
    "Address": "桃園市桃園區大興西路二段1號1樓"
}, {
    "POIID": "988289",
    "POIName": "桃金",
    "Telno": "(03)3628357",
    "Address": "桃園市桃園區金門2街83號及93號"
}, {
    "POIID": "127251",
    "POIName": "桃華",
    "Telno": "(03)3376874",
    "Address": "桃園市桃園區南華街113號"
}, {
    "POIID": "185431",
    "POIName": "桃匯",
    "Telno": "(03)2151041",
    "Address": "桃園市桃園區國際路二段557號559號1樓"
}, {
    "POIID": "154873",
    "POIName": "桃新站",
    "Telno": "(03)3673946",
    "Address": "桃園市桃園區中正路1號"
}, {
    "POIID": "167857",
    "POIName": "桃農",
    "Telno": "(03)3364609",
    "Address": "桃園市桃園區萬壽路3段111號113號115號1樓"
}, {
    "POIID": "887100",
    "POIName": "桃龍",
    "Telno": "(03)3703291",
    "Address": "桃園市桃園區龍安街79號81號"
}, {
    "POIID": "179584",
    "POIName": "桃醫",
    "Telno": "(03)3708564",
    "Address": "桃園市桃園區中山路1492號"
}, {
    "POIID": "997870",
    "POIName": "泰昌",
    "Telno": "(03)2201788",
    "Address": "桃園市桃園區泰昌三街51-6號"
}, {
    "POIID": "187987",
    "POIName": "益志",
    "Telno": "(03)3647281",
    "Address": "桃園市桃園區樹仁三街102號"
}, {
    "POIID": "921471",
    "POIName": "益壽",
    "Telno": "(03)3922974",
    "Address": "桃園市桃園區延壽街169號171號"
}, {
    "POIID": "864886",
    "POIName": "假日",
    "Telno": "(03)3568448",
    "Address": "桃園市桃園區大有路560號1樓"
}, {
    "POIID": "151782",
    "POIName": "健業",
    "Telno": "(03)3581545",
    "Address": "桃園市桃園區健行路88號"
}, {
    "POIID": "180573",
    "POIName": "國力",
    "Telno": "(03)2170120",
    "Address": "桃園市桃園區國際路二段426號428號1樓"
}, {
    "POIID": "138103",
    "POIName": "國仲",
    "Telno": "(03)2180453",
    "Address": "桃園市桃園區中德里國際路1段538號"
}, {
    "POIID": "870788",
    "POIName": "國安",
    "Telno": "(03)3586607",
    "Address": "桃園市桃園區經國路405號"
}, {
    "POIID": "902540",
    "POIName": "國祥",
    "Telno": "(03)3461185",
    "Address": "桃園市桃園區自強里經國路685號"
}, {
    "POIID": "874942",
    "POIName": "國揚",
    "Telno": "(03)3254441",
    "Address": "桃園市桃園區經國路242號"
}, {
    "POIID": "940058",
    "POIName": "國豐",
    "Telno": "(03)2174894",
    "Address": "桃園市桃園區國豐六街25號"
}, {
    "POIID": "182373",
    "POIName": "國藝",
    "Telno": "(03)3576015",
    "Address": "桃園市桃園區南平路185號187號1樓"
}, {
    "POIID": "112617",
    "POIName": "得寶",
    "Telno": "(03)3162211",
    "Address": "桃園市桃園區春日路1344號1346號"
}, {
    "POIID": "123031",
    "POIName": "敏盛",
    "Telno": "(03)3460823",
    "Address": "桃園市桃園區經國路168號B1樓"
}, {
    "POIID": "920227",
    "POIName": "祥佑",
    "Telno": "(03)3414608",
    "Address": "桃園市桃園區寶慶路176號"
}, {
    "POIID": "174936",
    "POIName": "莊正",
    "Telno": "(03)3015412",
    "Address": "桃園市桃園區莊二街148號1樓"
}, {
    "POIID": "992462",
    "POIName": "富有",
    "Telno": "(03)3026291",
    "Address": "桃園市桃園區富國路656號"
}, {
    "POIID": "963408",
    "POIName": "富邑",
    "Telno": "(03)3785009",
    "Address": "桃園市桃園區龍祥里龍泉五街82號龍祥街98號"
}, {
    "POIID": "112086",
    "POIName": "尊品",
    "Telno": "(03)3634561",
    "Address": "桃園市桃園區建國路41-1號1樓"
}, {
    "POIID": "130741",
    "POIName": "崴正",
    "Telno": "(03)3570476",
    "Address": "桃園市桃園區中正五街137號139號1樓"
}, {
    "POIID": "184623",
    "POIName": "崴信",
    "Telno": "(03)3265379",
    "Address": "桃園市桃園區信光路22號1樓"
}, {
    "POIID": "138712",
    "POIName": "崴盛",
    "Telno": "(03)3575040",
    "Address": "桃園市桃園區慈文路51號;正康三街284號"
}, {
    "POIID": "142582",
    "POIName": "智勝",
    "Telno": "(03)3679443",
    "Address": "桃園市桃園區桃智路1號3號1樓"
}, {
    "POIID": "118682",
    "POIName": "華信",
    "Telno": "(03)3369130",
    "Address": "桃園市桃園區成功路1段47號"
}, {
    "POIID": "183273",
    "POIName": "貴族",
    "Telno": "(03)3562962",
    "Address": "桃園市桃園區南平路306號1樓"
}, {
    "POIID": "180115",
    "POIName": "慈中",
    "Telno": "(03)3254968",
    "Address": "桃園市桃園區中正路820號1樓2樓"
}, {
    "POIID": "151634",
    "POIName": "慈安",
    "Telno": "(03)3264308",
    "Address": "桃園市桃園區永安路600號1樓"
}, {
    "POIID": "130017",
    "POIName": "慈德",
    "Telno": "(03)3575083",
    "Address": "桃園市桃園區慈德街53號55號57號"
}, {
    "POIID": "976389",
    "POIName": "新大興",
    "Telno": "(03)2160587",
    "Address": "桃園市桃園區大興西路二段253號1樓"
}, {
    "POIID": "981037",
    "POIName": "新光信",
    "Telno": "(03)3316920",
    "Address": "桃園市桃園區中正路612號"
}, {
    "POIID": "126591",
    "POIName": "新武陵",
    "Telno": "(03)3692146",
    "Address": "桃園市桃園區上海路54號56號"
}, {
    "POIID": "170956",
    "POIName": "新虎山",
    "Telno": "(03)3339282",
    "Address": "桃園市桃園區成功路三段50號52號1樓"
}, {
    "POIID": "171753",
    "POIName": "新桃行",
    "Telno": "(03)3317975",
    "Address": "桃園市桃園區力行路7號"
}, {
    "POIID": "159351",
    "POIName": "新桃府",
    "Telno": "(03)3365913",
    "Address": "桃園市桃園區縣府路312號312之1號"
}, {
    "POIID": "142157",
    "POIName": "新桃林",
    "Telno": "(03)3641912",
    "Address": "桃園市桃園區延平路4號6號1樓"
}, {
    "POIID": "135252",
    "POIName": "新莊伯",
    "Telno": "(03)3464840",
    "Address": "桃園市桃園區莊敬路一段175號177號1樓"
}, {
    "POIID": "186962",
    "POIName": "新達豐",
    "Telno": "(03)3643819",
    "Address": "桃園市桃園區延平路202號;大豐路194號"
}, {
    "POIID": "957388",
    "POIName": "新德鴻",
    "Telno": "(03)3767172",
    "Address": "桃園市桃園區永福西街111號113號"
}, {
    "POIID": "164560",
    "POIName": "新龍壽",
    "Telno": "(03)3709725",
    "Address": "桃園市桃園區龍壽街20號"
}, {
    "POIID": "187378",
    "POIName": "新雙安",
    "Telno": "(03)3342304",
    "Address": "桃園市桃園區安樂街48號50號1樓;安東街56號1樓"
}, {
    "POIID": "996017",
    "POIName": "源盛",
    "Telno": "(03)2172463",
    "Address": "桃園市桃園區國聖一街188號1樓;宏昌十二街587號1樓"
}, {
    "POIID": "991300",
    "POIName": "瑞家",
    "Telno": "(03)3349526",
    "Address": "桃園市桃園區三民路三段84號86號1樓"
}, {
    "POIID": "132426",
    "POIName": "聖民",
    "Telno": "(03)3476249",
    "Address": "桃園市桃園區民生路208號一樓"
}, {
    "POIID": "184715",
    "POIName": "聖保祿",
    "Telno": "(03)3758496",
    "Address": "桃園市桃園區福安里建新街68號"
}, {
    "POIID": "152084",
    "POIName": "鼎桃",
    "Telno": "(03)2171897",
    "Address": "桃園市桃園區宏昌六街281號1樓"
}, {
    "POIID": "144072",
    "POIName": "鈺朋",
    "Telno": "(03)3023234",
    "Address": "桃園市桃園區莊敬路二段105號1樓"
}, {
    "POIID": "143356",
    "POIName": "漢豐",
    "Telno": "(03)2184486",
    "Address": "桃園市桃園區漢中街146號1樓"
}, {
    "POIID": "141811",
    "POIName": "福利國",
    "Telno": "(03)3467422",
    "Address": "桃園市桃園區同德六街170號1樓"
}, {
    "POIID": "987910",
    "POIName": "維瀚",
    "Telno": "(03)3468299",
    "Address": "桃園市桃園區中埔六街36號1樓"
}, {
    "POIID": "977991",
    "POIName": "蜜鄰",
    "Telno": "(03)3606256",
    "Address": "桃園市桃園區龍壽街96號98號"
}, {
    "POIID": "135469",
    "POIName": "輕井澤",
    "Telno": "(03)3565648",
    "Address": "桃園市桃園區大業路一段355號357號一樓"
}, {
    "POIID": "162922",
    "POIName": "澄和",
    "Telno": "(03)3174729",
    "Address": "桃園市桃園區大業路一段277號1加2樓"
}, {
    "POIID": "149240",
    "POIName": "箱根",
    "Telno": "(03)3461928",
    "Address": "桃園市桃園區南平路416號418號1樓"
}, {
    "POIID": "126878",
    "POIName": "縣北",
    "Telno": "(03)3318746",
    "Address": "桃園市桃園區中山北路136號1樓"
}, {
    "POIID": "943895",
    "POIName": "臻愛",
    "Telno": "(03)3352178",
    "Address": "桃園市桃園區大業路一段152號"
}, {
    "POIID": "164674",
    "POIName": "興武",
    "Telno": "(03)3345654",
    "Address": "桃園市桃園區復興路239之1號1樓;241號1樓"
}, {
    "POIID": "181347",
    "POIName": "興源",
    "Telno": "(03)3028487",
    "Address": "桃園市桃園區大興西路2段82號1樓"
}, {
    "POIID": "957377",
    "POIName": "龍行",
    "Telno": "(03)3395057",
    "Address": "桃園市桃園區長安里力行路156號"
}, {
    "POIID": "935757",
    "POIName": "龍袖",
    "Telno": "(03)3698426",
    "Address": "桃園市桃園區龍安街143號1樓"
}, {
    "POIID": "167709",
    "POIName": "擎天",
    "Telno": "(03)3753250",
    "Address": "桃園市桃園區桃鶯路50號52號1樓"
}, {
    "POIID": "142663",
    "POIName": "謙悅",
    "Telno": "(03)3151916",
    "Address": "桃園市桃園區新埔六街58號60號1樓"
}, {
    "POIID": "113920",
    "POIName": "雙假",
    "Telno": "(03)3568380",
    "Address": "桃園市桃園區大有路660號1樓之2"
}, {
    "POIID": "882622",
    "POIName": "雙慶",
    "Telno": "(03)3013836",
    "Address": "桃園市桃園區安慶街84號86號"
}, {
    "POIID": "166463",
    "POIName": "藝德",
    "Telno": "(03)3258230",
    "Address": "桃園市桃園區同德11街98號100號"
}, {
    "POIID": "158370",
    "POIName": "鶯明",
    "Telno": "(03)3766270",
    "Address": "桃園市桃園區桃鶯路251號"
}, {
    "POIID": "164607",
    "POIName": "驊豐",
    "Telno": "(03)3627150",
    "Address": "桃園市桃園區建國路101號1樓"
}, {
    "POIID": "144751",
    "POIName": "鑫帝標",
    "Telno": "(03)3441963",
    "Address": "桃園市桃園區龍泉二街65號龍城五街66.68號1樓"
}, ], [{
    "POIID": "138538",
    "POIName": "三光",
    "Telno": "(03)4029671",
    "Address": "桃園市中壢區中央西路二段259號259-1號1樓"
}, {
    "POIID": "158358",
    "POIName": "大中原",
    "Telno": "(03)4363353",
    "Address": "桃園市中壢區新中北路151號151-1號一樓"
}, {
    "POIID": "111175",
    "POIName": "大享",
    "Telno": "(03)4224805",
    "Address": "桃園市中壢區中正路1262號1樓"
}, {
    "POIID": "154116",
    "POIName": "大崙",
    "Telno": "(03)4984287",
    "Address": "桃園市中壢區中正路四段35號"
}, {
    "POIID": "186250",
    "POIName": "工業",
    "Telno": "(03)4510966",
    "Address": "桃園市中壢區吉林路131號1樓"
}, {
    "POIID": "155337",
    "POIName": "中天",
    "Telno": "(03)4224304",
    "Address": "桃園市中壢區石頭里中和路184號1樓"
}, {
    "POIID": "111418",
    "POIName": "中同",
    "Telno": "(03)4266927",
    "Address": "桃園市中壢區大同路141號143號1樓"
}, {
    "POIID": "159188",
    "POIName": "中孝",
    "Telno": "(03)4517904",
    "Address": "桃園市中壢區忠孝路248號1樓"
}, {
    "POIID": "964940",
    "POIName": "中壢站",
    "Telno": "(03)4275099",
    "Address": "桃園市中壢區中和路139號"
}, {
    "POIID": "153629",
    "POIName": "中壢高",
    "Telno": "(03)2622030",
    "Address": "桃園市中壢區青埔里高鐵北路1段6號B1"
}, {
    "POIID": "116310",
    "POIName": "仁勛",
    "Telno": "(03)4568527",
    "Address": "桃園市中壢區華勛里華勛街112號114號"
}, {
    "POIID": "177566",
    "POIName": "元化",
    "Telno": "(03)4279534",
    "Address": "桃園市中壢區元化路1-1號"
}, {
    "POIID": "111555",
    "POIName": "日月光",
    "Telno": "(03)4345910",
    "Address": "桃園市中壢區中華路一段560號"
}, {
    "POIID": "913159",
    "POIName": "王子",
    "Telno": "(03)4913785",
    "Address": "桃園市中壢區三光路130號1樓"
}, {
    "POIID": "940106",
    "POIName": "世紀廣場",
    "Telno": "(03)2806459",
    "Address": "桃園市中壢區興南里新生路182號"
}, {
    "POIID": "989064",
    "POIName": "仕新",
    "Telno": "(03)4387640",
    "Address": "桃園市中壢區日新路112號"
}, {
    "POIID": "141235",
    "POIName": "北原",
    "Telno": "(03)4655694",
    "Address": "桃園市中壢區新中北路239號241號1樓"
}, {
    "POIID": "122898",
    "POIName": "台達二",
    "Telno": "(03)4639487",
    "Address": "桃園市中壢區東園路3號B1樓"
}, {
    "POIID": "164722",
    "POIName": "弘揚",
    "Telno": "(03)4363264",
    "Address": "桃園市中壢區弘揚路47號1樓"
}, {
    "POIID": "982063",
    "POIName": "正神",
    "Telno": "(03)4615309",
    "Address": "桃園市中壢區成章一街10號12號1樓2樓"
}, {
    "POIID": "130556",
    "POIName": "立莊",
    "Telno": "(03)4632452",
    "Address": "桃園市中壢區莊敬路805號"
}, {
    "POIID": "164135",
    "POIName": "光壢",
    "Telno": "(03)2830784",
    "Address": "桃園市中壢區莒光路35號1樓"
}, {
    "POIID": "148742",
    "POIName": "吉利",
    "Telno": "(03)4625759",
    "Address": "桃園市中壢區吉林二路83巷30號32號34號"
}, {
    "POIID": "942375",
    "POIName": "吉豐",
    "Telno": "(03)4285206",
    "Address": "桃園市中壢區長沙路8號10號1樓"
}, {
    "POIID": "882862",
    "POIName": "成章",
    "Telno": "(03)4352320",
    "Address": "桃園市中壢區成章二街192號"
}, {
    "POIID": "189927",
    "POIName": "成豐",
    "Telno": "(03)4526834",
    "Address": "桃園市中壢區元化路197巷3號1樓"
}, {
    "POIID": "167514",
    "POIName": "自強一",
    "Telno": "(03)4637354",
    "Address": "桃園市中壢區自強一路65號67號69號"
}, {
    "POIID": "174501",
    "POIName": "志廣",
    "Telno": "(03)4028631",
    "Address": "桃園市中壢區志廣路107號109號1樓2樓"
}, {
    "POIID": "111795",
    "POIName": "亞文",
    "Telno": "(03)4371428",
    "Address": "桃園市中壢區龍川街108號110號1樓2樓及112號1樓"
}, {
    "POIID": "128656",
    "POIName": "來來",
    "Telno": "(03)4251211",
    "Address": "桃園市中壢區中央東路62號"
}, {
    "POIID": "934695",
    "POIName": "夜市",
    "Telno": "(03)4024619",
    "Address": "桃園市中壢區中央西路二段125號"
}, {
    "POIID": "912352",
    "POIName": "奇采",
    "Telno": "(03)4378428",
    "Address": "桃園市中壢區晉元路289巷76號"
}, {
    "POIID": "141660",
    "POIName": "忠敬",
    "Telno": "(03)4514795",
    "Address": "桃園市中壢區莊敬路90號"
}, {
    "POIID": "985877",
    "POIName": "金鋒",
    "Telno": "(03)4385214",
    "Address": "桃園市中壢區金鋒四街50巷2號1樓"
}, {
    "POIID": "159041",
    "POIName": "金權",
    "Telno": "(03)2813118",
    "Address": "桃園市中壢區光明里中央西路二段49號"
}, {
    "POIID": "146540",
    "POIName": "長業",
    "Telno": "(03)4535480",
    "Address": "桃園市中壢區長春路23號"
}, {
    "POIID": "180609",
    "POIName": "青禾",
    "Telno": "(03)4533841",
    "Address": "桃園市中壢區高鐵站前西路二段96號1樓"
}, {
    "POIID": "116055",
    "POIName": "青埔",
    "Telno": "(03)4531079",
    "Address": "桃園市中壢區青昇路257號1樓"
}, {
    "POIID": "153984",
    "POIName": "青埔高",
    "Telno": "(03)2635667",
    "Address": "桃園市中壢區青埔里高鐵北路1段6號B1"
}, {
    "POIID": "903484",
    "POIName": "政群",
    "Telno": "(03)4525289",
    "Address": "桃園市中壢區中園路二段138號"
}, {
    "POIID": "158750",
    "POIName": "柏德",
    "Telno": "(03)4664235",
    "Address": "桃園市中壢區中北路158號1樓"
}, {
    "POIID": "912709",
    "POIName": "科學城",
    "Telno": "(03)4590209",
    "Address": "桃園市中壢區中北路二段206號"
}, {
    "POIID": "182937",
    "POIName": "美家",
    "Telno": "(03)4663458",
    "Address": "桃園市中壢區中北路34號36號1樓"
}, {
    "POIID": "137948",
    "POIName": "美壢",
    "Telno": "(03)4222708",
    "Address": "桃園市中壢區中美路二段72號"
}, {
    "POIID": "183251",
    "POIName": "羿龍",
    "Telno": "(03)4563734",
    "Address": "桃園市中壢區龍慈路283號1樓"
}, {
    "POIID": "130176",
    "POIName": "原大",
    "Telno": "(03)4368760",
    "Address": "桃園市中壢區實踐路46號"
}, {
    "POIID": "963626",
    "POIName": "家權",
    "Telno": "(03)2810712",
    "Address": "桃園市中壢區民權路2段98號"
}, {
    "POIID": "158705",
    "POIName": "桃園高鐵",
    "Telno": "(03)2622031",
    "Address": "桃園市中壢區青埔里高鐵北路1段6號1樓"
}, {
    "POIID": "958015",
    "POIName": "海和",
    "Telno": "(03)4265714",
    "Address": "桃園市中壢區六和路66號68號"
}, {
    "POIID": "142548",
    "POIName": "海帝",
    "Telno": "(03)4273723",
    "Address": "桃園市中壢區元化路307號1樓"
}, {
    "POIID": "131700",
    "POIName": "海華",
    "Telno": "(03)2806864",
    "Address": "桃園市中壢區慈惠三街152號154號"
}, {
    "POIID": "875484",
    "POIName": "站行",
    "Telno": "(03)4574334",
    "Address": "桃園市中壢區新興路162號"
}, {
    "POIID": "951162",
    "POIName": "高正",
    "Telno": "(03)4988724",
    "Address": "桃園市中壢區中正路三段134號136號一樓"
}, {
    "POIID": "967271",
    "POIName": "高欣",
    "Telno": "(03)4533973",
    "Address": "桃園市中壢區領航南路2段208號1樓"
}, {
    "POIID": "122142",
    "POIName": "高屋",
    "Telno": "(03)4945931",
    "Address": "桃園市中壢區民族路2段150號152號"
}, {
    "POIID": "179997",
    "POIName": "高萱",
    "Telno": "(03)2870142",
    "Address": "桃園市中壢區高鐵南路二段369號1樓"
}, {
    "POIID": "159063",
    "POIName": "健行",
    "Telno": "(03)4679214",
    "Address": "桃園市中壢區健行路230號1樓"
}, {
    "POIID": "154736",
    "POIName": "笙園",
    "Telno": "(03)4517406",
    "Address": "桃園市中壢區新生路738號740號742號1樓"
}, {
    "POIID": "970635",
    "POIName": "統上",
    "Telno": "(03)4510953",
    "Address": "桃園市中壢區新中北路465號1樓"
}, {
    "POIID": "130822",
    "POIName": "統壢",
    "Telno": "(03)4614295",
    "Address": "桃園市中壢區定寧路15號"
}, {
    "POIID": "126580",
    "POIName": "統讚",
    "Telno": "(03)4658221",
    "Address": "桃園市中壢區龍江路62號1樓"
}, {
    "POIID": "132323",
    "POIName": "速達",
    "Telno": "(03)4533441",
    "Address": "桃園市中壢區新生路二段378之2號"
}, {
    "POIID": "153559",
    "POIName": "創薪",
    "Telno": "(03)4369813",
    "Address": "桃園市中壢區龍昌路270號1號"
}, {
    "POIID": "135713",
    "POIName": "勝壢",
    "Telno": "(03)4251981",
    "Address": "桃園市中壢區中央西路一段一號一樓"
}, {
    "POIID": "957702",
    "POIName": "富莊",
    "Telno": "(03)4623667",
    "Address": "桃園市中壢區莊敬路141號"
}, {
    "POIID": "141361",
    "POIName": "復強",
    "Telno": "(03)4638447",
    "Address": "桃園市中壢區自強六路53號復華街212號1樓"
}, {
    "POIID": "114071",
    "POIName": "復華",
    "Telno": "(03)4631941",
    "Address": "桃園市中壢區中華路1段670號672號1樓"
}, {
    "POIID": "894418",
    "POIName": "惠祥",
    "Telno": "(03)4636004",
    "Address": "桃園市中壢區榮安一街293號"
}, {
    "POIID": "144773",
    "POIName": "森壢",
    "Telno": "(03)4583746",
    "Address": "桃園市中壢區新興里2鄰林森路30號1樓"
}, {
    "POIID": "187725",
    "POIName": "湯華",
    "Telno": "(03)4638554",
    "Address": "桃園市中壢區中華路一段745號747號749號1樓"
}, {
    "POIID": "118648",
    "POIName": "華勛",
    "Telno": "(03)4361613",
    "Address": "桃園市中壢區華勛街191號193號"
}, {
    "POIID": "944197",
    "POIName": "華愛",
    "Telno": "(03)4380269",
    "Address": "桃園市中壢區華美一路132號136號1樓"
}, {
    "POIID": "188968",
    "POIName": "華薪",
    "Telno": "(03)4634283",
    "Address": "桃園市中壢區新中北路二段179號181號"
}, {
    "POIID": "138963",
    "POIName": "新中北",
    "Telno": "(03)4617466",
    "Address": "桃園市中壢區新中北路1018-1號1樓"
}, {
    "POIID": "991595",
    "POIName": "新中華",
    "Telno": "(03)4627052",
    "Address": "桃園市中壢區中華路2段328號"
}, {
    "POIID": "161413",
    "POIName": "新元",
    "Telno": "(03)4275192",
    "Address": "桃園市中壢區新生路232號234號"
}, {
    "POIID": "119881",
    "POIName": "新街",
    "Telno": "(03)4617330",
    "Address": "桃園市中壢區環北路543號"
}, {
    "POIID": "122072",
    "POIName": "新福街",
    "Telno": "(03)4553072",
    "Address": "桃園市中壢區福州二街392號1樓"
}, {
    "POIID": "129305",
    "POIName": "新壢",
    "Telno": "(03)4387924",
    "Address": "桃園市中壢區日新路66號68號"
}, {
    "POIID": "957034",
    "POIName": "新壢揚",
    "Telno": "(03)2804403",
    "Address": "桃園市中壢區中山路138號"
}, {
    "POIID": "185109",
    "POIName": "新壢智",
    "Telno": "(03)2854198",
    "Address": "桃園市中壢區興仁路二段57號1樓"
}, {
    "POIID": "921437",
    "POIName": "萬能",
    "Telno": "(03)4680614",
    "Address": "桃園市中壢區萬能路1號"
}, {
    "POIID": "183974",
    "POIName": "萬能科",
    "Telno": "(03)4536259",
    "Address": "桃園市中壢區萬能路1之2號1樓"
}, {
    "POIID": "968160",
    "POIName": "萬興",
    "Telno": "(03)4984476",
    "Address": "桃園市中壢區月眉路二段357號1樓部份"
}, {
    "POIID": "141453",
    "POIName": "聖央",
    "Telno": "(03)4228137",
    "Address": "桃園市中壢區中央西路一段78號1樓"
}, {
    "POIID": "119010",
    "POIName": "過嶺",
    "Telno": "(03)4203473",
    "Address": "桃園市中壢區民族路五段451號453號1樓"
}, {
    "POIID": "122119",
    "POIName": "榮安",
    "Telno": "(03)4515728",
    "Address": "桃園市中壢區榮安十三街297號1樓及榮安十四街2號1樓"
}, {
    "POIID": "181026",
    "POIName": "榮躍",
    "Telno": "(03)4650762",
    "Address": "桃園市中壢區榮民南路462號464號"
}, {
    "POIID": "110390",
    "POIName": "福冠",
    "Telno": "(03)4353958",
    "Address": "桃園市中壢區福州一街242號1樓及2樓"
}, {
    "POIID": "935089",
    "POIName": "福神",
    "Telno": "(03)4631992",
    "Address": "桃園市中壢區福德路79號81號"
}, {
    "POIID": "122326",
    "POIName": "福記",
    "Telno": "(03)4681347",
    "Address": "桃園市中壢區林森路164號166號168號"
}, {
    "POIID": "165024",
    "POIName": "福瑞",
    "Telno": "(03)4162840",
    "Address": "桃園市中壢區信義里福州路201號"
}, {
    "POIID": "144728",
    "POIName": "精材",
    "Telno": "(03)4620942",
    "Address": "桃園市中壢區吉林路23號B1樓"
}, {
    "POIID": "141486",
    "POIName": "領航",
    "Telno": "(03)4225452",
    "Address": "桃園市中壢區領航北路二段239號1樓"
}, {
    "POIID": "935643",
    "POIName": "影華",
    "Telno": "(03)4275504",
    "Address": "桃園市中壢區九和一街20號之1樓"
}, {
    "POIID": "132437",
    "POIName": "慶和",
    "Telno": "(03)4163181",
    "Address": "桃園市中壢區後寮一路140號142號1樓"
}, {
    "POIID": "923824",
    "POIName": "慶福",
    "Telno": "(03)4379089",
    "Address": "桃園市中壢區同慶路277號1樓"
}, {
    "POIID": "165529",
    "POIName": "學屋",
    "Telno": "(03)4907780",
    "Address": "桃園市中壢區民族路三段402號406號"
}, {
    "POIID": "165091",
    "POIName": "興東",
    "Telno": "(03)4567639",
    "Address": "桃園市中壢區中山東路三段206號"
}, {
    "POIID": "951597",
    "POIName": "興美",
    "Telno": "(03)4277815",
    "Address": "桃園市中壢區興國路85號87號一樓"
}, {
    "POIID": "180207",
    "POIName": "興榮珍",
    "Telno": "(03)2854526",
    "Address": "桃園市中壢區興仁路二段200之1號;198巷1之3號1樓"
}, {
    "POIID": "122681",
    "POIName": "龍岡",
    "Telno": "(03)4665712",
    "Address": "桃園市中壢區龍東路508號510號1樓"
}, {
    "POIID": "130567",
    "POIName": "龍東",
    "Telno": "(03)4560328",
    "Address": "桃園市中壢區龍東路138號140號1樓"
}, {
    "POIID": "963350",
    "POIName": "龍翔",
    "Telno": "(03)4616036",
    "Address": "桃園市中壢區普義路175號"
}, {
    "POIID": "978112",
    "POIName": "龍學",
    "Telno": "(03)4655821",
    "Address": "桃園市中壢區龍昌路178號1樓A1"
}, {
    "POIID": "846707",
    "POIName": "環民",
    "Telno": "(03)4925034",
    "Address": "桃園市中壢區環西路2號"
}, {
    "POIID": "174279",
    "POIName": "環宇",
    "Telno": "(03)4519446",
    "Address": "桃園市中壢區自強15鄰環中東路8號"
}, {
    "POIID": "180001",
    "POIName": "環埔",
    "Telno": "(03)4255450",
    "Address": "桃園市中壢區領航北路一段281號1樓"
}, {
    "POIID": "922625",
    "POIName": "環福",
    "Telno": "(03)4334878",
    "Address": "桃園市中壢區普忠路213號"
}, {
    "POIID": "158967",
    "POIName": "豐利",
    "Telno": "(03)4617821",
    "Address": "桃園市中壢區南園二路63號"
}, {
    "POIID": "965378",
    "POIName": "豐亞",
    "Telno": "(03)4207484",
    "Address": "桃園市中壢區民族路6段232號236號1樓"
}, {
    "POIID": "182915",
    "POIName": "雙嶺",
    "Telno": "(03)4204993",
    "Address": "桃園市中壢區松義路111號113號1樓"
}, {
    "POIID": "190352",
    "POIName": "壢和",
    "Telno": "(03)4266230",
    "Address": "桃園市中壢區中和路114號"
}, {
    "POIID": "138620",
    "POIName": "壢美",
    "Telno": "(03)4268113",
    "Address": "桃園市中壢區中美路39號1樓及建國北路55號1樓"
}, {
    "POIID": "163970",
    "POIName": "壢都",
    "Telno": "(03)4579045",
    "Address": "桃園市中壢區長沙路131號成都路72號"
}, {
    "POIID": "140092",
    "POIName": "壢福",
    "Telno": "(03)4589913",
    "Address": "桃園市中壢區信義里廣州路202號"
}, {
    "POIID": "154677",
    "POIName": "瓏門",
    "Telno": "(03)4662035",
    "Address": "桃園市中壢區龍昌路538號1樓"
}, {
    "POIID": "171339",
    "POIName": "瓏慈",
    "Telno": "(03)4584639",
    "Address": "桃園市中壢區龍慈路712號716號718號1樓"
}, {
    "POIID": "944717",
    "POIName": "耀康",
    "Telno": "(03)4332976",
    "Address": "桃園市中壢區溪洲街267巷1號一樓"
}, {
    "POIID": "922614",
    "POIName": "鑫旺",
    "Telno": "(03)2852868",
    "Address": "桃園市中壢區興安二街1號"
}, ], [{
    "POIID": "187895",
    "POIName": "八勇",
    "Telno": "(03)3760357",
    "Address": "桃園市八德區忠勇街197號"
}, {
    "POIID": "120571",
    "POIName": "八福",
    "Telno": "(03)3714641",
    "Address": "桃園市八德區福國街76-1號"
}, {
    "POIID": "179562",
    "POIName": "八德介壽",
    "Telno": "(03)3647065",
    "Address": "桃園市八德區介壽路二段216號218號1樓"
}, {
    "POIID": "187390",
    "POIName": "八德建國",
    "Telno": "(03)3689752",
    "Address": "桃園市八德區建國路165號"
}, {
    "POIID": "131191",
    "POIName": "大湳",
    "Telno": "(03)2184780",
    "Address": "桃園市八德區和平路875-1號"
}, {
    "POIID": "142124",
    "POIName": "世傳",
    "Telno": "(03)3670224",
    "Address": "桃園市八德區和平路122號126號1樓"
}, {
    "POIID": "941338",
    "POIName": "吉富",
    "Telno": "(03)3619882",
    "Address": "桃園市八德區白鷺里永豐南路72號"
}, {
    "POIID": "180470",
    "POIName": "尚群",
    "Telno": "(03)3681497",
    "Address": "桃園市八德區中山路181號"
}, {
    "POIID": "924986",
    "POIName": "明光",
    "Telno": "(03)3780845",
    "Address": "桃園市八德區中華路157號"
}, {
    "POIID": "116044",
    "POIName": "明福",
    "Telno": "(03)3614512",
    "Address": "桃園市八德區大明街105號107號"
}, {
    "POIID": "160155",
    "POIName": "東勇",
    "Telno": "(03)3629131",
    "Address": "桃園市八德區東勇街83號"
}, {
    "POIID": "181222",
    "POIName": "東凌",
    "Telno": "(03)3689594",
    "Address": "桃園市八德區中正路112號116號"
}, {
    "POIID": "189592",
    "POIName": "松柏林",
    "Telno": "(03)3685745",
    "Address": "桃園市八德區介壽路二段685巷50弄2號1樓"
}, {
    "POIID": "182225",
    "POIName": "迎和",
    "Telno": "(03)3634716",
    "Address": "桃園市八德區金和路52號"
}, {
    "POIID": "943954",
    "POIName": "冠成",
    "Telno": "(03)3749327",
    "Address": "桃園市八德區重慶街172號"
}, {
    "POIID": "149491",
    "POIName": "勇伯",
    "Telno": "(03)2182953",
    "Address": "桃園市八德區東勇北路380號"
}, {
    "POIID": "167628",
    "POIName": "振裕",
    "Telno": "(03)3768214",
    "Address": "桃園市八德區福德一路54號"
}, {
    "POIID": "125923",
    "POIName": "桃德",
    "Telno": "(03)3630849",
    "Address": "桃園市八德區介壽路一段794號"
}, {
    "POIID": "942113",
    "POIName": "茗安",
    "Telno": "(03)3741190",
    "Address": "桃園市八德區陸光街45號"
}, {
    "POIID": "113702",
    "POIName": "高城",
    "Telno": "(03)2173952",
    "Address": "桃園市八德區高城八街58巷5號1樓"
}, {
    "POIID": "882172",
    "POIName": "國僑",
    "Telno": "(03)3644882",
    "Address": "桃園市八德區建國路1075號"
}, {
    "POIID": "165105",
    "POIName": "捷安",
    "Telno": "(03)3731247",
    "Address": "桃園市八德區興豐路689號1樓"
}, {
    "POIID": "874012",
    "POIName": "麻園",
    "Telno": "(03)3666344",
    "Address": "桃園市八德區介壽路二段360號362號"
}, {
    "POIID": "122393",
    "POIName": "湧北",
    "Telno": "(03)3712775",
    "Address": "桃園市八德區東勇街396-1號"
}, {
    "POIID": "980528",
    "POIName": "新宏國",
    "Telno": "(03)3709426",
    "Address": "桃園市八德區中華路292號294號1樓"
}, {
    "POIID": "167363",
    "POIName": "瑞星",
    "Telno": "(03)3686482",
    "Address": "桃園市八德區介壽路二段616號618號1樓"
}, {
    "POIID": "954699",
    "POIName": "義展",
    "Telno": "(03)3763771",
    "Address": "桃園市八德區義勇街151號151-1號1樓"
}, {
    "POIID": "116479",
    "POIName": "榮興",
    "Telno": "(03)3656510",
    "Address": "桃園市八德區榮興路1139號"
}, {
    "POIID": "182384",
    "POIName": "榮豐",
    "Telno": "(03)3679415",
    "Address": "桃園市八德區興豐路2168號"
}, {
    "POIID": "180481",
    "POIName": "福厚",
    "Telno": "(03)3686404",
    "Address": "桃園市八德區興仁里建德路229號"
}, {
    "POIID": "167396",
    "POIName": "福國",
    "Telno": "(03)3644967",
    "Address": "桃園市八德區福國北街48號50號1樓"
}, {
    "POIID": "146311",
    "POIName": "福僑",
    "Telno": "(03)3671450",
    "Address": "桃園市八德區廣福路162號164號1樓2樓及地下室"
}, {
    "POIID": "166773",
    "POIName": "廣隆",
    "Telno": "(03)3732294",
    "Address": "桃園市八德區廣興路195號"
}, {
    "POIID": "189880",
    "POIName": "廣福",
    "Telno": "(03)3627382",
    "Address": "桃園市八德區廣福路16號"
}, {
    "POIID": "126915",
    "POIName": "廣懋",
    "Telno": "(03)3769956",
    "Address": "桃園市八德區廣福路578號"
}, {
    "POIID": "164353",
    "POIName": "德力",
    "Telno": "(03)3778096",
    "Address": "桃園市八德區大福里介壽路一段134號136號"
}, {
    "POIID": "167307",
    "POIName": "德沅",
    "Telno": "(03)3749372",
    "Address": "桃園市八德區介壽路2段455號"
}, {
    "POIID": "931456",
    "POIName": "德勇",
    "Telno": "(03)2188300",
    "Address": "桃園市八德區大勇里忠勇街365號"
}, {
    "POIID": "174132",
    "POIName": "德隆",
    "Telno": "(03)3781543",
    "Address": "桃園市八德區永豐路408號410號1樓"
}, {
    "POIID": "996475",
    "POIName": "德僑",
    "Telno": "(03)3659877",
    "Address": "桃園市八德區豐德路31號1樓"
}, {
    "POIID": "160018",
    "POIName": "興圓",
    "Telno": "(03)3653530",
    "Address": "桃園市八德區長興路76號1樓"
}, {
    "POIID": "180975",
    "POIName": "興豐",
    "Telno": "(03)3656424",
    "Address": "桃園市八德區興豐路418號"
}, {
    "POIID": "166935",
    "POIName": "豐德",
    "Telno": "(03)3786102",
    "Address": "桃園市八德區永豐路605號1樓"
}, ], [{
    "POIID": "113355",
    "POIName": "丰順",
    "Telno": "(03)4670341",
    "Address": "桃園市平鎮區中豐路一段281之1號1樓"
}, {
    "POIID": "922485",
    "POIName": "比利",
    "Telno": "(03)4396297",
    "Address": "桃園市平鎮區上海路161號"
}, {
    "POIID": "122821",
    "POIName": "平東",
    "Telno": "(03)4607776",
    "Address": "桃園市平鎮區平東路225號227號229號1樓"
}, {
    "POIID": "977614",
    "POIName": "正湧",
    "Telno": "(03)4686477",
    "Address": "桃園市平鎮區正義路82號1樓"
}, {
    "POIID": "165219",
    "POIName": "成達",
    "Telno": "(03)4953412",
    "Address": "桃園市平鎮區育達路136號"
}, {
    "POIID": "964434",
    "POIName": "成德",
    "Telno": "(03)4679841",
    "Address": "桃園市平鎮區承德路2號4號1樓"
}, {
    "POIID": "893172",
    "POIName": "宏宇",
    "Telno": "(03)4288596",
    "Address": "桃園市平鎮區金陵路二段104號"
}, {
    "POIID": "184601",
    "POIName": "技嘉",
    "Telno": "(03)4391574",
    "Address": "桃園市平鎮區南平路180之1號"
}, {
    "POIID": "153995",
    "POIName": "京利",
    "Telno": "(03)4397374",
    "Address": "桃園市平鎮區南京路206號"
}, {
    "POIID": "996257",
    "POIName": "明揚",
    "Telno": "(03)4925297",
    "Address": "桃園市平鎮區延平路二段76號"
}, {
    "POIID": "186021",
    "POIName": "東正",
    "Telno": "(03)4606888",
    "Address": "桃園市平鎮區平東路661號"
}, {
    "POIID": "154747",
    "POIName": "東洸",
    "Telno": "(03)4609764",
    "Address": "桃園市平鎮區平東路27號東光路16之1號1樓"
}, {
    "POIID": "990400",
    "POIName": "金平",
    "Telno": "(03)4505739",
    "Address": "桃園市平鎮區東勢里金陵路四段485號1樓"
}, {
    "POIID": "942102",
    "POIName": "金沅",
    "Telno": "(03)4506616",
    "Address": "桃園市平鎮區東勢里金陵路5段255號"
}, {
    "POIID": "130257",
    "POIName": "金陵",
    "Telno": "(03)4683147",
    "Address": "桃園市平鎮區金陵路76號78號1樓"
}, {
    "POIID": "910817",
    "POIName": "金磚",
    "Telno": "(03)4284567",
    "Address": "桃園市平鎮區新富里新富二街18號20號"
}, {
    "POIID": "126454",
    "POIName": "海利",
    "Telno": "(03)4398201",
    "Address": "桃園市平鎮區上海路115號"
}, {
    "POIID": "139287",
    "POIName": "翁京",
    "Telno": "(03)4399112",
    "Address": "桃園市平鎮區中豐路南勢二段118號"
}, {
    "POIID": "930925",
    "POIName": "高安",
    "Telno": "(03)2811823",
    "Address": "桃園市平鎮區民族路3段95號"
}, {
    "POIID": "143529",
    "POIName": "高義",
    "Telno": "(03)4918607",
    "Address": "桃園市平鎮區復旦路二段211巷10號1樓"
}, {
    "POIID": "136864",
    "POIName": "祥鋐",
    "Telno": "(03)4280330",
    "Address": "桃園市平鎮區金陵路三段74號76號"
}, {
    "POIID": "183745",
    "POIName": "凱利",
    "Telno": "(03)4964671",
    "Address": "桃園市平鎮區延平路3段413號415號417號1樓"
}, {
    "POIID": "154024",
    "POIName": "富寶",
    "Telno": "(03)4288651",
    "Address": "桃園市平鎮區新富五街9號1樓"
}, {
    "POIID": "892582",
    "POIName": "皓倫",
    "Telno": "(03)2813125",
    "Address": "桃園市平鎮區振興西路72號"
}, {
    "POIID": "920906",
    "POIName": "開立",
    "Telno": "(03)4950392",
    "Address": "桃園市平鎮區廣仁里新光路19號21號"
}, {
    "POIID": "170462",
    "POIName": "新貴中",
    "Telno": "(03)4670486",
    "Address": "桃園市平鎮區新貴里中豐路一段98號1樓"
}, {
    "POIID": "187301",
    "POIName": "新鎮興",
    "Telno": "(03)4695420",
    "Address": "桃園市平鎮區中興路平鎮段349號351號353號"
}, {
    "POIID": "968919",
    "POIName": "楊崧",
    "Telno": "(03)4920151",
    "Address": "桃園市平鎮區復旦路二段123-5;123-6號1樓"
}, {
    "POIID": "892995",
    "POIName": "裕達",
    "Telno": "(03)2813124",
    "Address": "桃園市平鎮區育達路160號"
}, {
    "POIID": "180942",
    "POIName": "達義",
    "Telno": "(03)4022472",
    "Address": "桃園市平鎮區義民路199號1樓"
}, {
    "POIID": "952981",
    "POIName": "瑋特",
    "Telno": "(03)4920447",
    "Address": "桃園市平鎮區延平路三段246號248號一樓"
}, {
    "POIID": "167639",
    "POIName": "福龍",
    "Telno": "(03)4505197",
    "Address": "桃園市平鎮區福龍路一段556號"
}, {
    "POIID": "952143",
    "POIName": "廣文",
    "Telno": "(03)4940550",
    "Address": "桃園市平鎮區復興里文化街241號"
}, {
    "POIID": "174774",
    "POIName": "廣城",
    "Telno": "(03)4924445",
    "Address": "桃園市平鎮區廣達里廣平街20號24號1樓"
}, {
    "POIID": "883625",
    "POIName": "廣泰",
    "Telno": "(03)4910675",
    "Address": "桃園市平鎮區廣泰路130號132號"
}, {
    "POIID": "115971",
    "POIName": "廣興",
    "Telno": "(03)4953721",
    "Address": "桃園市平鎮區忠孝路69號及廣東段305號306號"
}, {
    "POIID": "190710",
    "POIName": "德享",
    "Telno": "(03)4398120",
    "Address": "桃園市平鎮區南勢里14鄰中豐路南勢二段377號379號381號"
}, {
    "POIID": "129811",
    "POIName": "德興",
    "Telno": "(03)4575450",
    "Address": "桃園市平鎮區振興路12號"
}, {
    "POIID": "130648",
    "POIName": "學央",
    "Telno": "(03)4205014",
    "Address": "桃園市平鎮區中央路187號"
}, {
    "POIID": "970624",
    "POIName": "龍侑",
    "Telno": "(03)4601054",
    "Address": "桃園市平鎮區龍德路8號1樓;龍福路1號1樓"
}, {
    "POIID": "138480",
    "POIName": "龍南",
    "Telno": "(03)4602664",
    "Address": "桃園市平鎮區龍南路348號"
}, {
    "POIID": "166485",
    "POIName": "環興",
    "Telno": "(03)4937978",
    "Address": "桃園市平鎮區環南路188號1 樓"
}, {
    "POIID": "997515",
    "POIName": "豐訊",
    "Telno": "(03)4698787",
    "Address": "桃園市平鎮區中豐路山頂段479號"
}, {
    "POIID": "916136",
    "POIName": "鎮光",
    "Telno": "(03)4192232",
    "Address": "桃園市平鎮區湧光里中豐路山頂段206號208號之1樓"
}, {
    "POIID": "174671",
    "POIName": "鎮宮",
    "Telno": "(03)4384181",
    "Address": "桃園市平鎮區中山路233號235號237號1樓"
}, {
    "POIID": "992657",
    "POIName": "鎮業",
    "Telno": "(03)4697147",
    "Address": "桃園市平鎮區南豐路238號240號1樓"
}, {
    "POIID": "190385",
    "POIName": "鎮豐",
    "Telno": "(03)4699948",
    "Address": "桃園市平鎮區南豐路99號"
}, {
    "POIID": "112592",
    "POIName": "雙榮",
    "Telno": "(03)4204705",
    "Address": "桃園市平鎮區雙連里民族路雙連三段8號1樓"
}, {
    "POIID": "137546",
    "POIName": "壢達",
    "Telno": "(03)4944387",
    "Address": "桃園市平鎮區環南路231-5號1樓"
}, {
    "POIID": "143839",
    "POIName": "關爺",
    "Telno": "(03)2840273",
    "Address": "桃園市平鎮區南東路376號1樓"
}, {
    "POIID": "130729",
    "POIName": "韻翔",
    "Telno": "(03)4930896",
    "Address": "桃園市平鎮區文化街71號1樓"
}, {
    "POIID": "182487",
    "POIName": "寶勇",
    "Telno": "(03)4694080",
    "Address": "桃園市平鎮區湧光路455號457號459號1樓"
}, {
    "POIID": "158543",
    "POIName": "寶麗",
    "Telno": "(03)4698937",
    "Address": "桃園市平鎮區湧安里自由街57號59號"
}, ], [{
    "POIID": "110080",
    "POIName": "千禧",
    "Telno": "(03)2134732",
    "Address": "桃園市龜山區光峰路千禧新城15號1樓"
}, {
    "POIID": "892320",
    "POIName": "大崗",
    "Telno": "(03)3963173",
    "Address": "桃園市龜山區大崗里17鄰大湖41之2號"
}, {
    "POIID": "131467",
    "POIName": "大傳",
    "Telno": "(03)3296730",
    "Address": "桃園市龜山區大同路357號357-1號1樓及壽山段926地號"
}, {
    "POIID": "932426",
    "POIName": "山民",
    "Telno": "(03)3198039",
    "Address": "桃園市龜山區三民路100號"
}, {
    "POIID": "138642",
    "POIName": "山興",
    "Telno": "(03)3498212",
    "Address": "桃園市龜山區山頂里明興街223號"
}, {
    "POIID": "850762",
    "POIName": "山鶯",
    "Telno": "(03)3194142",
    "Address": "桃園市龜山區山鶯路372號"
}, {
    "POIID": "990422",
    "POIName": "友達電",
    "Telno": "(03)3187564",
    "Address": "桃園市龜山區華亞二路189號B1"
}, {
    "POIID": "187002",
    "POIName": "巴頓",
    "Telno": "(02)82001454",
    "Address": "桃園市龜山區龍壽里萬壽路1段492號1樓"
}, {
    "POIID": "111289",
    "POIName": "台達電",
    "Telno": "(03)3294091",
    "Address": "桃園市龜山區山鶯路252號B1樓"
}, {
    "POIID": "188566",
    "POIName": "民生北",
    "Telno": "(03)3583816",
    "Address": "桃園市龜山區民生北路一段54號1樓"
}, {
    "POIID": "957768",
    "POIName": "光峰",
    "Telno": "(03)3209796",
    "Address": "桃園市龜山區楓樹里光峰路296號298號一樓"
}, {
    "POIID": "111898",
    "POIName": "同銘",
    "Telno": "(03)3595385",
    "Address": "桃園市龜山區大同路212號1樓"
}, {
    "POIID": "186283",
    "POIName": "宏義",
    "Telno": "(02)82091307",
    "Address": "桃園市龜山區萬壽路1段378號380號1樓"
}, {
    "POIID": "992738",
    "POIName": "汶興",
    "Telno": "(03)3498771",
    "Address": "桃園市龜山區頂興路31-1號1樓"
}, {
    "POIID": "167097",
    "POIName": "庚大",
    "Telno": "(03)2118165",
    "Address": "桃園市龜山區文化一路259號B1樓"
}, {
    "POIID": "923569",
    "POIName": "庚林",
    "Telno": "(03)3298923",
    "Address": "桃園市龜山區頂湖路123號B2"
}, {
    "POIID": "972310",
    "POIName": "忠湖",
    "Telno": "(03)3287847",
    "Address": "桃園市龜山區忠義路二段630號"
}, {
    "POIID": "810258",
    "POIName": "長林",
    "Telno": "(03)3287173",
    "Address": "桃園市龜山區復興街9號"
}, {
    "POIID": "166429",
    "POIName": "長運",
    "Telno": "(03)2130250",
    "Address": "桃園市龜山區長青路7號C棟B1樓"
}, {
    "POIID": "119087",
    "POIName": "信陽",
    "Telno": "(03)3280293",
    "Address": "桃園市龜山區公西里12鄰復興一路86號"
}, {
    "POIID": "902458",
    "POIName": "冠廷",
    "Telno": "(03)3525795",
    "Address": "桃園市龜山區南美里南上路332號1F"
}, {
    "POIID": "137568",
    "POIName": "勇利",
    "Telno": "(03)2114483",
    "Address": "桃園市龜山區文化一路86-6號"
}, {
    "POIID": "180735",
    "POIName": "建發",
    "Telno": "(03)3530806",
    "Address": "桃園市龜山區南上里8鄰民生北路一段516號1樓"
}, {
    "POIID": "151900",
    "POIName": "柏魁",
    "Telno": "(03)3503111",
    "Address": "桃園市龜山區振興路1021之1號"
}, {
    "POIID": "180252",
    "POIName": "美光一",
    "Telno": "(03)3271990",
    "Address": "桃園市龜山區復興三路667號一廠5樓"
}, {
    "POIID": "180241",
    "POIName": "美光二",
    "Telno": "(03)3272003",
    "Address": "桃園市龜山區華亞五路2號二廠7樓"
}, {
    "POIID": "183527",
    "POIName": "振陞",
    "Telno": "(03)3974104",
    "Address": "桃園市龜山區振興路1301號1樓"
}, {
    "POIID": "124506",
    "POIName": "茶專",
    "Telno": "(03)3594995",
    "Address": "桃園市龜山區萬壽路2段353號1樓"
}, {
    "POIID": "904018",
    "POIName": "財春",
    "Telno": "(03)3494303",
    "Address": "桃園市龜山區振興路636號638號"
}, {
    "POIID": "120906",
    "POIName": "祥崁",
    "Telno": "(03)3530382",
    "Address": "桃園市龜山區南祥路41號43號45號1樓"
}, {
    "POIID": "153490",
    "POIName": "祥櫂",
    "Telno": "(03)3595849",
    "Address": "桃園市龜山區萬壽路二段97號"
}, {
    "POIID": "153445",
    "POIName": "統文",
    "Telno": "(03)3185635",
    "Address": "桃園市龜山區文化七路179號1樓"
}, {
    "POIID": "153478",
    "POIName": "陸光",
    "Telno": "(03)2132406",
    "Address": "桃園市龜山區陸光路83號85號1樓"
}, {
    "POIID": "120917",
    "POIName": "頂湖",
    "Telno": "(03)3277012",
    "Address": "桃園市龜山區新興街240號242號244號1樓"
}, {
    "POIID": "111614",
    "POIName": "凱華",
    "Telno": "(03)3283249",
    "Address": "桃園市龜山區文化二路183號1樓"
}, {
    "POIID": "118936",
    "POIName": "凱達",
    "Telno": "(03)3503973",
    "Address": "桃園市龜山區精忠里長壽路155號157號"
}, {
    "POIID": "166681",
    "POIName": "富亨",
    "Telno": "(03)3275307",
    "Address": "桃園市龜山區文青路206號208號210號1樓"
}, {
    "POIID": "167879",
    "POIName": "富勝",
    "Telno": "(03)3180439",
    "Address": "桃園市龜山區文學路250號1樓"
}, {
    "POIID": "142375",
    "POIName": "富寓",
    "Telno": "(03)3275230",
    "Address": "桃園市龜山區文德路80號82號"
}, {
    "POIID": "187275",
    "POIName": "登冠",
    "Telno": "(03)3186887",
    "Address": "桃園市龜山區文化二路52巷53號一樓"
}, {
    "POIID": "148775",
    "POIName": "華亞",
    "Telno": "(03)3962549",
    "Address": "桃園市龜山區文化二路43號"
}, {
    "POIID": "985143",
    "POIName": "華亞文化",
    "Telno": "(03)3973713",
    "Address": "桃園市龜山區文化一路86之55號"
}, {
    "POIID": "187792",
    "POIName": "華龍",
    "Telno": "(02)82001415",
    "Address": "桃園市龜山區萬壽路1段292號1樓龍華街2巷6號B1"
}, {
    "POIID": "895651",
    "POIName": "貴林",
    "Telno": "(03)3278297",
    "Address": "桃園市龜山區樂善里15鄰文明路43號"
}, {
    "POIID": "184922",
    "POIName": "新九揚",
    "Telno": "(03)3274670",
    "Address": "桃園市龜山區復興一路264號1樓"
}, {
    "POIID": "971616",
    "POIName": "新長明",
    "Telno": "(03)3961534",
    "Address": "桃園市龜山區復興一路62號1樓"
}, {
    "POIID": "159155",
    "POIName": "新尊爵",
    "Telno": "(03)3186563",
    "Address": "桃園市龜山區復興三路139號141號143號145號1樓"
}, {
    "POIID": "141970",
    "POIName": "新龜山",
    "Telno": "(03)3493562",
    "Address": "桃園市龜山區萬壽路2段1170號"
}, {
    "POIID": "185291",
    "POIName": "萬壽",
    "Telno": "(03)3194079",
    "Address": "桃園市龜山區萬壽路二段1057號1樓"
}, {
    "POIID": "180377",
    "POIName": "萬龍",
    "Telno": "(02)82001015",
    "Address": "桃園市龜山區萬壽路一段307號309號1樓"
}, {
    "POIID": "120858",
    "POIName": "壽興",
    "Telno": "(03)3198162",
    "Address": "桃園市龜山區中興路一段73號1樓2樓3樓"
}, {
    "POIID": "185855",
    "POIName": "愿景",
    "Telno": "(03)3974428",
    "Address": "桃園市龜山區文化一路42號"
}, {
    "POIID": "114015",
    "POIName": "福鶯",
    "Telno": "(03)3290720",
    "Address": "桃園市龜山區山鶯路156之4號1樓"
}, {
    "POIID": "987976",
    "POIName": "廣智",
    "Telno": "(03)3180296",
    "Address": "桃園市龜山區復興一路392-1號"
}, {
    "POIID": "128243",
    "POIName": "廣華",
    "Telno": "(03)2115427",
    "Address": "桃園市龜山區文化三路386號1樓"
}, {
    "POIID": "117151",
    "POIName": "廣瀨",
    "Telno": "(03)3180360",
    "Address": "桃園市龜山區忠義路二段13號"
}, {
    "POIID": "122647",
    "POIName": "樂高",
    "Telno": "(03)3184670",
    "Address": "桃園市龜山區文化七路85號1樓"
}, {
    "POIID": "138664",
    "POIName": "樂善",
    "Telno": "(03)3185542",
    "Address": "桃園市龜山區文明路131號1樓"
}, {
    "POIID": "131445",
    "POIName": "緯華",
    "Telno": "(03)3184914",
    "Address": "桃園市龜山區文化二路34巷6號及14弄18號1樓"
}, {
    "POIID": "932150",
    "POIName": "養生村",
    "Telno": "(03)2130001",
    "Address": "桃園市龜山區長青路2號A棟"
}, {
    "POIID": "930121",
    "POIName": "憲訓",
    "Telno": "(03)3979949",
    "Address": "桃園市龜山區文化三路1-1號"
}, {
    "POIID": "977164",
    "POIName": "興龍",
    "Telno": "(03)3596170",
    "Address": "桃園市龜山區新路里中興路366-6號1樓2樓"
}, {
    "POIID": "130039",
    "POIName": "龜山銘傳",
    "Telno": "(03)3504227",
    "Address": "桃園市龜山區德明路152號154號1樓"
}, {
    "POIID": "942216",
    "POIName": "龜山廣達",
    "Telno": "(03)3183985",
    "Address": "桃園市龜山區文化二路211號"
}, {
    "POIID": "924573",
    "POIName": "嶺頂",
    "Telno": "(03)3192515",
    "Address": "桃園市龜山區嶺頂里2鄰西嶺頂26號"
}, {
    "POIID": "138000",
    "POIName": "鴻臣",
    "Telno": "(03)3498529",
    "Address": "桃園市龜山區楓樹里忠義路一段870-1號"
}, {
    "POIID": "190101",
    "POIName": "醫林",
    "Telno": "(03)3273179",
    "Address": "桃園市龜山區長庚醫護新村80號B1樓"
}, {
    "POIID": "131607",
    "POIName": "體育大",
    "Telno": "(03)3186047",
    "Address": "桃園市龜山區文化一路250號"
}, {
    "POIID": "982214",
    "POIName": "鑫華夏",
    "Telno": "(03)2115130",
    "Address": "桃園市龜山區文化二路28-1號28-2號28-3號1樓"
}, {
    "POIID": "189396",
    "POIName": "鑫騰龍",
    "Telno": "(02)82006592",
    "Address": "桃園市龜山區萬壽路1段110號112號114號1樓2樓"
}, ], [{
    "POIID": "924654",
    "POIName": "士香",
    "Telno": "(03)3072579",
    "Address": "桃園市大溪區員林路一段228號"
}, {
    "POIID": "844745",
    "POIName": "大溪",
    "Telno": "(03)3871334",
    "Address": "桃園市大溪區中央路152號"
}, {
    "POIID": "941752",
    "POIName": "仁冠",
    "Telno": "(03)3808072",
    "Address": "桃園市大溪區仁和路二段319號321號"
}, {
    "POIID": "148649",
    "POIName": "仁善",
    "Telno": "(03)3906270",
    "Address": "桃園市大溪區埔頂路二段183號"
}, {
    "POIID": "988278",
    "POIName": "內柵",
    "Telno": "(03)3888941",
    "Address": "桃園市大溪區康莊路三段20號"
}, {
    "POIID": "121817",
    "POIName": "文漢",
    "Telno": "(03)3883094",
    "Address": "桃園市大溪區文化路188號"
}, {
    "POIID": "110138",
    "POIName": "百吉",
    "Telno": "(03)3887825",
    "Address": "桃園市大溪區復興路二段35號"
}, {
    "POIID": "113735",
    "POIName": "亞都",
    "Telno": "(03)3078613",
    "Address": "桃園市大溪區僑愛一街72巷15號"
}, {
    "POIID": "118523",
    "POIName": "和氣",
    "Telno": "(03)3809338",
    "Address": "桃園市大溪區仁和路二段51號1樓"
}, {
    "POIID": "173818",
    "POIName": "忠新",
    "Telno": "(03)3803797",
    "Address": "桃園市大溪區大鶯路1539-1號"
}, {
    "POIID": "155359",
    "POIName": "芯德",
    "Telno": "(03)3882592",
    "Address": "桃園市大溪區復興路186號1樓188號1至2樓"
}, {
    "POIID": "933050",
    "POIName": "埔頂",
    "Telno": "(03)3804535",
    "Address": "桃園市大溪區仁愛里埔頂路1段468號"
}, {
    "POIID": "118903",
    "POIName": "峰里",
    "Telno": "(03)3825986",
    "Address": "桃園市大溪區復興路二段782號786號"
}, {
    "POIID": "174556",
    "POIName": "翁和",
    "Telno": "(03)3891007",
    "Address": "桃園市大溪區仁文里介壽路1153號一樓"
}, {
    "POIID": "110909",
    "POIName": "翁武",
    "Telno": "(03)3884037",
    "Address": "桃園市大溪區民權東路149號"
}, {
    "POIID": "189031",
    "POIName": "園頂",
    "Telno": "(03)3804436",
    "Address": "桃園市大溪區公園路111號115號"
}, {
    "POIID": "954895",
    "POIName": "新康莊",
    "Telno": "(03)3886359",
    "Address": "桃園市大溪區復興路31號1樓"
}, {
    "POIID": "148362",
    "POIName": "新劉興",
    "Telno": "(03)3907955",
    "Address": "桃園市大溪區南興里永昌路320號"
}, {
    "POIID": "953917",
    "POIName": "瑞員",
    "Telno": "(03)3072349",
    "Address": "桃園市大溪區員林路3段157號1樓"
}, {
    "POIID": "901802",
    "POIName": "嘉福",
    "Telno": "(03)3070854",
    "Address": "桃園市大溪區員林路2段359之1號"
}, {
    "POIID": "173896",
    "POIName": "頭寮",
    "Telno": "(03)3884554",
    "Address": "桃園市大溪區復興路一段906號"
}, {
    "POIID": "144223",
    "POIName": "龍園",
    "Telno": "(03)4115715",
    "Address": "桃園市大溪區石園路615號"
}, {
    "POIID": "151058",
    "POIName": "雙橡園",
    "Telno": "(03)3894464",
    "Address": "桃園市大溪區僑愛里介壽路210號"
}, ], [{
    "POIID": "171742",
    "POIName": "大成",
    "Telno": "(03)4781599",
    "Address": "桃園市楊梅區梅山西街10號"
}, {
    "POIID": "185361",
    "POIName": "大楊",
    "Telno": "(03)2888571",
    "Address": "桃園市楊梅區楊湖路1段90號92號94號1樓"
}, {
    "POIID": "972066",
    "POIName": "水美",
    "Telno": "(03)4850499",
    "Address": "桃園市楊梅區楊新路二段52號52-1號"
}, {
    "POIID": "123282",
    "POIName": "秀才",
    "Telno": "(03)4850972",
    "Address": "桃園市楊梅區秀才路313號315號1樓"
}, {
    "POIID": "148801",
    "POIName": "欣高",
    "Telno": "(03)4788447",
    "Address": "桃園市楊梅區楊梅里文德路1號1樓梅高路52-9號"
}, {
    "POIID": "933016",
    "POIName": "苙佑",
    "Telno": "(03)4782270",
    "Address": "桃園市楊梅區梅高路133號"
}, {
    "POIID": "967145",
    "POIName": "高山頂",
    "Telno": "(03)4854744",
    "Address": "桃園市楊梅區幼獅路二段297-1號"
}, {
    "POIID": "142272",
    "POIName": "高尚",
    "Telno": "(03)4850532",
    "Address": "桃園市楊梅區梅高路二段136巷5號"
}, {
    "POIID": "913540",
    "POIName": "梅獅",
    "Telno": "(03)4814576",
    "Address": "桃園市楊梅區瑞塘里梅獅路二段231號"
}, {
    "POIID": "159410",
    "POIName": "凱成",
    "Telno": "(03)4313241",
    "Address": "桃園市楊梅區文化街220號222號222-1號"
}, {
    "POIID": "920962",
    "POIName": "富先",
    "Telno": "(03)4312760",
    "Address": "桃園市楊梅區萬大路111號113號"
}, {
    "POIID": "131906",
    "POIName": "富崗",
    "Telno": "(03)4728942",
    "Address": "桃園市楊梅區新明街450號"
}, {
    "POIID": "166496",
    "POIName": "富證",
    "Telno": "(03)4728416",
    "Address": "桃園市楊梅區中正路80號82號1樓"
}, {
    "POIID": "154091",
    "POIName": "揚善",
    "Telno": "(03)4785578",
    "Address": "桃園市楊梅區中山北路一段23號25號1樓"
}, {
    "POIID": "131076",
    "POIName": "新梅",
    "Telno": "(03)4883261",
    "Address": "桃園市楊梅區新農街469-8號469-9號1樓"
}, {
    "POIID": "182672",
    "POIName": "新楊欣",
    "Telno": "(03)4754036",
    "Address": "桃園市楊梅區中山北路一段360號362號1樓"
}, {
    "POIID": "185981",
    "POIName": "新楊埔",
    "Telno": "(03)4814647",
    "Address": "桃園市楊梅區中興路47號1樓新興街66號1樓"
}, {
    "POIID": "151771",
    "POIName": "楊山",
    "Telno": "(03)4882611",
    "Address": "桃園市楊梅區中山南路98號100號1樓"
}, {
    "POIID": "141187",
    "POIName": "楊功",
    "Telno": "(03)4820217",
    "Address": "桃園市楊梅區瑞溪路二段162號1樓"
}, {
    "POIID": "942401",
    "POIName": "楊民",
    "Telno": "(03)4316640",
    "Address": "桃園市楊梅區三民北路177號"
}, {
    "POIID": "151689",
    "POIName": "楊昌",
    "Telno": "(03)4856432",
    "Address": "桃園市楊梅區楊新北路23號"
}, {
    "POIID": "987839",
    "POIName": "楊昇",
    "Telno": "(03)2888644",
    "Address": "桃園市楊梅區校前路241號"
}, {
    "POIID": "130006",
    "POIName": "楊展",
    "Telno": "(03)4882501",
    "Address": "桃園市楊梅區校前路312號316號1樓"
}, {
    "POIID": "118693",
    "POIName": "楊梅",
    "Telno": "(03)4754529",
    "Address": "桃園市楊梅區楊新路73號"
}, {
    "POIID": "924528",
    "POIName": "楊陳",
    "Telno": "(03)4884658",
    "Address": "桃園市楊梅區中山里環東路497號499號"
}, {
    "POIID": "163590",
    "POIName": "楊興",
    "Telno": "(03)4850364",
    "Address": "桃園市楊梅區楊新路3段331號333號"
}, {
    "POIID": "152017",
    "POIName": "瑞揚",
    "Telno": "(03)4756179",
    "Address": "桃園市楊梅區新成路97號"
}, {
    "POIID": "138790",
    "POIName": "瑞豐",
    "Telno": "(03)4725387",
    "Address": "桃園市楊梅區瑞原里民富路三段24號"
}, {
    "POIID": "962645",
    "POIName": "蓮花",
    "Telno": "(03)4644856",
    "Address": "桃園市楊梅區青山一街2號"
}, {
    "POIID": "982557",
    "POIName": "駿躍",
    "Telno": "(03)4780803",
    "Address": "桃園市楊梅區環南路132號1樓"
}, {
    "POIID": "875370",
    "POIName": "寶楊",
    "Telno": "(03)4825220",
    "Address": "桃園市楊梅區中山北路二段113號"
}, ], [{
    "POIID": "922474",
    "POIName": "八角店",
    "Telno": "(03)2151993",
    "Address": "桃園市蘆竹區大竹路5號"
}, {
    "POIID": "139106",
    "POIName": "上興",
    "Telno": "(03)3135392",
    "Address": "桃園市蘆竹區上興路251號253號1樓"
}, {
    "POIID": "180285",
    "POIName": "千富",
    "Telno": "(03)3223875",
    "Address": "桃園市蘆竹區長安路二段220號222號1樓"
}, {
    "POIID": "138273",
    "POIName": "千雄",
    "Telno": "(03)3120074",
    "Address": "桃園市蘆竹區南崁路2段96號"
}, {
    "POIID": "159270",
    "POIName": "元翔",
    "Telno": "(03)3112034",
    "Address": "桃園市蘆竹區六福路247巷2-1號"
}, {
    "POIID": "181794",
    "POIName": "北崁",
    "Telno": "(03)3521797",
    "Address": "桃園市蘆竹區中正路85號87號89號1樓"
}, {
    "POIID": "992510",
    "POIName": "台茂城堡店",
    "Telno": "(03)2123583",
    "Address": "桃園市蘆竹區南崁路1段112號2樓"
}, {
    "POIID": "126889",
    "POIName": "吉福",
    "Telno": "(03)2126804",
    "Address": "桃園市蘆竹區吉林路167號1樓"
}, {
    "POIID": "952279",
    "POIName": "竹盈",
    "Telno": "(03)3135745",
    "Address": "桃園市蘆竹區大竹里大新路133號1-3樓"
}, {
    "POIID": "132378",
    "POIName": "長榮航",
    "Telno": "(03)3121749",
    "Address": "桃園市蘆竹區新南路一段376號"
}, {
    "POIID": "180089",
    "POIName": "亮亞",
    "Telno": "(03)3231648",
    "Address": "桃園市蘆竹區大福路189號"
}, {
    "POIID": "182801",
    "POIName": "南山北",
    "Telno": "(03)3543450",
    "Address": "桃園市蘆竹區南山北路2段426號1樓"
}, {
    "POIID": "915122",
    "POIName": "南崁",
    "Telno": "(03)3225706",
    "Address": "桃園市蘆竹區南崁路156號"
}, {
    "POIID": "182889",
    "POIName": "映竹",
    "Telno": "(03)3231498",
    "Address": "桃園市蘆竹區南竹路4段250號1樓"
}, {
    "POIID": "181141",
    "POIName": "桃捷",
    "Telno": "(03)3244919",
    "Address": "桃園市蘆竹區南山路3段98號100號1樓2樓"
}, {
    "POIID": "112329",
    "POIName": "海湖",
    "Telno": "(03)3544721",
    "Address": "桃園市蘆竹區濱海路一段40號42號"
}, {
    "POIID": "993502",
    "POIName": "航竹",
    "Telno": "(03)3231007",
    "Address": "桃園市蘆竹區大竹路408號"
}, {
    "POIID": "152109",
    "POIName": "航宏",
    "Telno": "(03)3119338",
    "Address": "桃園市蘆竹區蘆竹里蘆竹街256號一樓"
}, {
    "POIID": "181462",
    "POIName": "航明",
    "Telno": "(03)3241971",
    "Address": "桃園市蘆竹區南山路二段497號1樓"
}, {
    "POIID": "864462",
    "POIName": "航空",
    "Telno": "(03)3223603",
    "Address": "桃園市蘆竹區中正路304號"
}, {
    "POIID": "154895",
    "POIName": "航海",
    "Telno": "(03)3528510",
    "Address": "桃園市蘆竹區南山路一段175之1號1樓"
}, {
    "POIID": "880372",
    "POIName": "航榮",
    "Telno": "(03)3111108",
    "Address": "桃園市蘆竹區南崁路二段473號"
}, {
    "POIID": "149295",
    "POIName": "航福",
    "Telno": "(03)3229743",
    "Address": "桃園市蘆竹區南福街97號99號"
}, {
    "POIID": "129062",
    "POIName": "航興",
    "Telno": "(03)3139174",
    "Address": "桃園市蘆竹區中福里大興路233號1樓"
}, {
    "POIID": "904111",
    "POIName": "國邦",
    "Telno": "(03)3522987",
    "Address": "桃園市蘆竹區忠孝西路206號1樓"
}, {
    "POIID": "991252",
    "POIName": "頂社",
    "Telno": "(03)3243632",
    "Address": "桃園市蘆竹區山林路3段170-2號"
}, {
    "POIID": "182823",
    "POIName": "富丞",
    "Telno": "(03)3530824",
    "Address": "桃園市蘆竹區中正北路599號"
}, {
    "POIID": "187873",
    "POIName": "富竹",
    "Telno": "(03)3138184",
    "Address": "桃園市蘆竹區南竹路2段313號1樓"
}, {
    "POIID": "902034",
    "POIName": "景旭",
    "Telno": "(03)3135724",
    "Address": "桃園市蘆竹區大新路852號854號之1樓"
}, {
    "POIID": "133061",
    "POIName": "景竹",
    "Telno": "(03)3134014",
    "Address": "桃園市蘆竹區南竹路五段200號1樓"
}, {
    "POIID": "183583",
    "POIName": "湖海",
    "Telno": "(03)3544607",
    "Address": "桃園市蘆竹區濱海路一段335號337號1樓"
}, {
    "POIID": "183044",
    "POIName": "進三廠",
    "Telno": "(03)3528113",
    "Address": "桃園市蘆竹區長榮路168號6樓"
}, {
    "POIID": "121046",
    "POIName": "開南",
    "Telno": "(03)3024195",
    "Address": "桃園市蘆竹區新興街136號1樓"
}, {
    "POIID": "123581",
    "POIName": "新台茂",
    "Telno": "(03)2124416",
    "Address": "桃園市蘆竹區南崁路1段135號"
}, {
    "POIID": "139210",
    "POIName": "瑞元",
    "Telno": "(03)3220661",
    "Address": "桃園市蘆竹區長春路87號"
}, {
    "POIID": "174338",
    "POIName": "嘉美",
    "Telno": "(03)3138416",
    "Address": "桃園市蘆竹區大新路454.456號1樓"
}, {
    "POIID": "116701",
    "POIName": "福祿",
    "Telno": "(03)3119482",
    "Address": "桃園市蘆竹區五福六路45號1樓"
}, {
    "POIID": "167695",
    "POIName": "鳳儀",
    "Telno": "(03)3520490",
    "Address": "桃園市蘆竹區南崁路二段285號1樓"
}, {
    "POIID": "151025",
    "POIName": "樂購",
    "Telno": "(03)2224621",
    "Address": "桃園市蘆竹區五福一路41號1樓"
}, {
    "POIID": "190086",
    "POIName": "盧奉",
    "Telno": "(03)2129384",
    "Address": "桃園市蘆竹區奉化路25號27號1樓"
}, {
    "POIID": "130903",
    "POIName": "盧長",
    "Telno": "(03)3528714",
    "Address": "桃園市蘆竹區南山路二段183號1樓"
}, {
    "POIID": "953870",
    "POIName": "盧興",
    "Telno": "(03)3244562",
    "Address": "桃園市蘆竹區內展里長興路3段231號1樓"
}, {
    "POIID": "941132",
    "POIName": "錦坎",
    "Telno": "(03)3118092",
    "Address": "桃園市蘆竹區南崁路1段76號78號"
}, {
    "POIID": "136314",
    "POIName": "錦明",
    "Telno": "(03)3116303",
    "Address": "桃園市蘆竹區光明路二段102號1樓"
}, {
    "POIID": "186032",
    "POIName": "錦欣",
    "Telno": "(03)2227474",
    "Address": "桃園市蘆竹區南竹路一段63號1樓"
}, {
    "POIID": "893840",
    "POIName": "蘆山",
    "Telno": "(03)3118955",
    "Address": "桃園市蘆竹區中山路152號154號156號一樓"
}, {
    "POIID": "138192",
    "POIName": "蘆工",
    "Telno": "(03)3134490",
    "Address": "桃園市蘆竹區中興路97號1樓"
}, {
    "POIID": "860301",
    "POIName": "蘆竹",
    "Telno": "(03)3244567",
    "Address": "桃園市蘆竹區山腳里南山路3段308號"
}, {
    "POIID": "951036",
    "POIName": "蘆坎",
    "Telno": "(03)3215438",
    "Address": "桃園市蘆竹區南崁里南華一街142號一樓"
}, {
    "POIID": "126317",
    "POIName": "蘆海",
    "Telno": "(03)3541187",
    "Address": "桃園市蘆竹區坑口里海山路一段76號一樓"
}, {
    "POIID": "952327",
    "POIName": "蘆航",
    "Telno": "(03)3124710",
    "Address": "桃園市蘆竹區南興里南昌路18號1樓"
}, {
    "POIID": "163752",
    "POIName": "蘆勝",
    "Telno": "(03)3529927",
    "Address": "桃園市蘆竹區忠孝西路21號1樓"
}, {
    "POIID": "142261",
    "POIName": "蘆順",
    "Telno": "(03)3113932",
    "Address": "桃園市蘆竹區奉化路168號170號172號1樓"
}, {
    "POIID": "153467",
    "POIName": "蘆豐",
    "Telno": "(03)3522712",
    "Address": "桃園市蘆竹區南山路二段48號1樓"
}, ], [{
    "POIID": "113344",
    "POIName": "大和園",
    "Telno": "(03)3842854",
    "Address": "桃園市大園區中山南路272號及272-1號1樓"
}, {
    "POIID": "188027",
    "POIName": "大園港",
    "Telno": "(03)3856957",
    "Address": "桃園市大園區大觀路1088號"
}, {
    "POIID": "174914",
    "POIName": "內海",
    "Telno": "(03)3865474",
    "Address": "桃園市大園區內海里下厝9之9號1樓"
}, {
    "POIID": "188511",
    "POIName": "民新",
    "Telno": "(03)3850549",
    "Address": "桃園市大園區民生南路167號"
}, {
    "POIID": "154208",
    "POIName": "玉興",
    "Telno": "(03)3862354",
    "Address": "桃園市大園區華興路一段1號1樓.和平西路145號2樓"
}, {
    "POIID": "153515",
    "POIName": "江海",
    "Telno": "(03)3815675",
    "Address": "桃園市大園區中正東路三段343號"
}, {
    "POIID": "992211",
    "POIName": "江園",
    "Telno": "(03)3812411",
    "Address": "桃園市大園區中正東路3段620號"
}, {
    "POIID": "126638",
    "POIName": "沙崙",
    "Telno": "(03)3937240",
    "Address": "桃園市大園區沙崙里國際路二段759號761號763號1樓"
}, {
    "POIID": "944544",
    "POIName": "東懋",
    "Telno": "(03)3855371",
    "Address": "桃園市大園區和平西路一段272號274號"
}, {
    "POIID": "113573",
    "POIName": "果林",
    "Telno": "(03)3935321",
    "Address": "桃園市大園區果林里3鄰拔子林23之45號1"
}, {
    "POIID": "169820",
    "POIName": "武青",
    "Telno": "(03)3814498",
    "Address": "桃園市大園區五青路287號289號1樓"
}, {
    "POIID": "166887",
    "POIName": "城邑",
    "Telno": "(03)3818657",
    "Address": "桃園市大園區高鐵北路二段186號188號1樓"
}, {
    "POIID": "967097",
    "POIName": "埔東",
    "Telno": "(03)3814491",
    "Address": "桃園市大園區埔心里中正東路一段165號1樓"
}, {
    "POIID": "182775",
    "POIName": "航林",
    "Telno": "(03)3836620",
    "Address": "桃園市大園區三民路2段626號1樓"
}, {
    "POIID": "184298",
    "POIName": "航站北",
    "Telno": "(03)3932812",
    "Address": "桃園市大園區航站南路15號B1樓"
}, {
    "POIID": "184287",
    "POIName": "航站南",
    "Telno": "(03)3931733",
    "Address": "桃園市大園區航站南路15號B1樓"
}, {
    "POIID": "132965",
    "POIName": "航祥",
    "Telno": "(03)3935275",
    "Address": "桃園市大園區三民路一段785號1樓"
}, {
    "POIID": "882024",
    "POIName": "航園",
    "Telno": "(03)3858746",
    "Address": "桃園市大園區中正東路102號"
}, {
    "POIID": "162782",
    "POIName": "航廈",
    "Telno": "(03)3932539",
    "Address": "桃園市大園區航站南路9號B2"
}, {
    "POIID": "130213",
    "POIName": "國航",
    "Telno": "(03)3841586",
    "Address": "桃園市大園區國際路1段300-1號1樓"
}, {
    "POIID": "932655",
    "POIName": "統大",
    "Telno": "(03)3859917",
    "Address": "桃園市大園區中正東路428號"
}, {
    "POIID": "942032",
    "POIName": "園山",
    "Telno": "(03)3858593",
    "Address": "桃園市大園區民族路1號"
}, {
    "POIID": "164711",
    "POIName": "新田園",
    "Telno": "(03)3868997",
    "Address": "桃園市大園區新興路62號"
}, {
    "POIID": "160100",
    "POIName": "達昇",
    "Telno": "(03)3840165",
    "Address": "桃園市大園區大觀路525號527號1樓"
}, {
    "POIID": "181509",
    "POIName": "遠雄",
    "Telno": "(03)3995176",
    "Address": "桃園市大園區航翔路5之7號1樓"
}, {
    "POIID": "871079",
    "POIName": "機場",
    "Telno": "(03)3831429",
    "Address": "桃園市大園區三民路二段110號112號"
}, {
    "POIID": "113078",
    "POIName": "濱海",
    "Telno": "(03)3935661",
    "Address": "桃園市大園區竹圍里五鄰竹圍街45-3號"
}, {
    "POIID": "187585",
    "POIName": "鐵鎮",
    "Telno": "(03)3816914",
    "Address": "桃園市大園區中正東路2段428號"
}, {
    "POIID": "870917",
    "POIName": "觀園",
    "Telno": "(03)3854111",
    "Address": "桃園市大園區大觀路604號606號"
}, {
    "POIID": "113919",
    "POIName": "觀群",
    "Telno": "(03)3851278",
    "Address": "桃園市大園區大工路106號"
}, ], [{
    "POIID": "147967",
    "POIName": "上華",
    "Telno": "(03)4891711",
    "Address": "桃園市龍潭區中正路上華段6號"
}, {
    "POIID": "144119",
    "POIName": "中科院",
    "Telno": "(03)4714990",
    "Address": "桃園市龍潭區中正路佳安段481號"
}, {
    "POIID": "170727",
    "POIName": "水龍吟",
    "Telno": "(03)4117393",
    "Address": "桃園市龍潭區中原路一段506號1樓"
}, {
    "POIID": "153618",
    "POIName": "台積Q",
    "Telno": "(03)4899769",
    "Address": "桃園市龍潭區龍園六路101號2樓"
}, {
    "POIID": "886646",
    "POIName": "正同",
    "Telno": "(03)4808831",
    "Address": "桃園市龍潭區中正里15鄰中正路472號474號"
}, {
    "POIID": "138505",
    "POIName": "禾臣",
    "Telno": "(03)4116316",
    "Address": "桃園市龍潭區高平里高楊北路1號"
}, {
    "POIID": "936233",
    "POIName": "同華",
    "Telno": "(03)4898471",
    "Address": "桃園市龍潭區中正里龍華路396號"
}, {
    "POIID": "161550",
    "POIName": "百年",
    "Telno": "(03)4700905",
    "Address": "桃園市龍潭區中豐路烏樹林段317號"
}, {
    "POIID": "163763",
    "POIName": "宏龍",
    "Telno": "(03)4710464",
    "Address": "桃園市龍潭區中原路二段393號1樓"
}, {
    "POIID": "165046",
    "POIName": "易仕",
    "Telno": "(03)4702557",
    "Address": "桃園市龍潭區中豐路695巷2-1號"
}, {
    "POIID": "138147",
    "POIName": "泉僑",
    "Telno": "(03)4112122",
    "Address": "桃園市龍潭區文化路12-3號"
}, {
    "POIID": "184612",
    "POIName": "凌雲",
    "Telno": "(03)4995805",
    "Address": "桃園市龍潭區中豐路上林段358-1號"
}, {
    "POIID": "972608",
    "POIName": "紹福",
    "Telno": "(03)4796178",
    "Address": "桃園市龍潭區五福街210號"
}, {
    "POIID": "126926",
    "POIName": "渴望村",
    "Telno": "(03)4071070",
    "Address": "桃園市龍潭區三和里渴望路428號"
}, {
    "POIID": "973036",
    "POIName": "新友達",
    "Telno": "(03)4072501",
    "Address": "桃園市龍潭區三和里新和路1號B棟7樓"
}, {
    "POIID": "952707",
    "POIName": "新龍鄉",
    "Telno": "(03)4809419",
    "Address": "桃園市龍潭區民族路170號172號1F"
}, {
    "POIID": "965965",
    "POIName": "聖興",
    "Telno": "(03)4994805",
    "Address": "桃園市龍潭區聖亭路186號1樓"
}, {
    "POIID": "182580",
    "POIName": "銅鑼圈",
    "Telno": "(03)4117340",
    "Address": "桃園市龍潭區中豐路高平段402之1號1樓"
}, {
    "POIID": "142401",
    "POIName": "龍功",
    "Telno": "(03)4709121",
    "Address": "桃園市龍潭區成功路186之1號"
}, {
    "POIID": "978400",
    "POIName": "龍池",
    "Telno": "(03)4802137",
    "Address": "桃園市龍潭區中豐路上林段121號"
}, {
    "POIID": "112293",
    "POIName": "龍昌",
    "Telno": "(03)4994355",
    "Address": "桃園市龍潭區大昌路二段139之1號"
}, {
    "POIID": "111234",
    "POIName": "龍欣",
    "Telno": "(03)4894543",
    "Address": "桃園市龍潭區中興路257號259號"
}, {
    "POIID": "143286",
    "POIName": "龍政",
    "Telno": "(03)4793503",
    "Address": "桃園市龍潭區中正路162號"
}, {
    "POIID": "153434",
    "POIName": "龍科",
    "Telno": "(03)4792675",
    "Address": "桃園市龍潭區龍科街228號B1"
}, {
    "POIID": "965758",
    "POIName": "龍美",
    "Telno": "(03)4709693",
    "Address": "桃園市龍潭區民豐路3號4號5號1樓"
}, {
    "POIID": "148270",
    "POIName": "龍運",
    "Telno": "(03)4097607",
    "Address": "桃園市龍潭區中正路105號1樓及107巷1號1樓"
}, {
    "POIID": "122692",
    "POIName": "龍德",
    "Telno": "(03)4707206",
    "Address": "桃園市龍潭區中興路460號462號"
}, {
    "POIID": "143781",
    "POIName": "龍潭",
    "Telno": "(03)4798442",
    "Address": "桃園市龍潭區東龍路257號259號1樓"
}, {
    "POIID": "922555",
    "POIName": "龍潭友達",
    "Telno": "(03)4072446",
    "Address": "桃園市龍潭區三和里新和路1號"
}, {
    "POIID": "985408",
    "POIName": "龍潭佳園",
    "Telno": "(03)4112989",
    "Address": "桃園市龍潭區中正路三坑段776號1樓"
}, {
    "POIID": "187633",
    "POIName": "曜駿",
    "Telno": "(03)4704913",
    "Address": "桃園市龍潭區中興路292號1樓"
}, {
    "POIID": "141280",
    "POIName": "豐彩",
    "Telno": "(03)4795793",
    "Address": "桃園市龍潭區中豐路398號1樓"
}, {
    "POIID": "188382",
    "POIName": "鑽石",
    "Telno": "(03)4700461",
    "Address": "桃園市龍潭區八德里梅龍路23鄰139號141號1樓"
}, ], [{
    "POIID": "166670",
    "POIName": "日日興",
    "Telno": "(03)4970459",
    "Address": "桃園市新屋區中山西路1段280巷20號"
}, {
    "POIID": "179676",
    "POIName": "北勢",
    "Telno": "(03)4774277",
    "Address": "桃園市新屋區中山東路一段745號"
}, {
    "POIID": "126328",
    "POIName": "永安港",
    "Telno": "(03)4864411",
    "Address": "桃園市新屋區中山西路三段1148號"
}, {
    "POIID": "153560",
    "POIName": "多利",
    "Telno": "(03)4904152",
    "Address": "桃園市新屋區中山東路二段760號1樓"
}, {
    "POIID": "130659",
    "POIName": "金帝寶",
    "Telno": "(03)4770613",
    "Address": "桃園市新屋區中山東路1段106號"
}, {
    "POIID": "181554",
    "POIName": "盛烽",
    "Telno": "(03)4903974",
    "Address": "桃園市新屋區梅高路三段310之6號"
}, {
    "POIID": "966038",
    "POIName": "景碩一廠",
    "Telno": "(03)4970443",
    "Address": "桃園市新屋區中華路1245號3樓"
}, {
    "POIID": "966083",
    "POIName": "景碩新廠",
    "Telno": "(03)4972958",
    "Address": "桃園市新屋區中華路810號1樓"
}, {
    "POIID": "866158",
    "POIName": "新屋",
    "Telno": "(03)4772056",
    "Address": "桃園市新屋區新生里12鄰中山路367號369號371號"
}, {
    "POIID": "137661",
    "POIName": "新屋山",
    "Telno": "(03)4870863",
    "Address": "桃園市新屋區新屋里中山路288號"
}, {
    "POIID": "954622",
    "POIName": "新屋中華",
    "Telno": "(03)4776260",
    "Address": "桃園市新屋區中華路357號1樓"
}, ], [{
    "POIID": "155326",
    "POIName": "大新",
    "Telno": "(03)4837792",
    "Address": "桃園市觀音區大觀路二段65號67號"
}, {
    "POIID": "992716",
    "POIName": "忠愛莊",
    "Telno": "(03)4984189",
    "Address": "桃園市觀音區忠愛路一段90號92號1樓"
}, {
    "POIID": "982890",
    "POIName": "欣富晟",
    "Telno": "(03)4834215",
    "Address": "桃園市觀音區草漯里大觀路2段312-1號"
}, {
    "POIID": "121448",
    "POIName": "富中",
    "Telno": "(03)2820766",
    "Address": "桃園市觀音區中山路二段925號"
}, {
    "POIID": "163844",
    "POIName": "富源",
    "Telno": "(03)4908940",
    "Address": "桃園市觀音區富源里57之1號2號"
}, {
    "POIID": "881940",
    "POIName": "新坡",
    "Telno": "(03)4980645",
    "Address": "桃園市觀音區中山路二段663號"
}, {
    "POIID": "944566",
    "POIName": "福音",
    "Telno": "(03)4832773",
    "Address": "桃園市觀音區草漯里五福三街83號"
}, {
    "POIID": "903185",
    "POIName": "觀工",
    "Telno": "(03)4834579",
    "Address": "桃園市觀音區成功路一段525號527號1F"
}, {
    "POIID": "122371",
    "POIName": "觀成",
    "Telno": "(03)4837597",
    "Address": "桃園市觀音區成功路1段557號559號1樓"
}, {
    "POIID": "892984",
    "POIName": "觀昌",
    "Telno": "(03)4732899",
    "Address": "桃園市觀音區中山路21號"
}, {
    "POIID": "139069",
    "POIName": "觀埔",
    "Telno": "(03)4971489",
    "Address": "桃園市觀音區藍埔里新華路1段488號"
}, {
    "POIID": "968137",
    "POIName": "觀喜",
    "Telno": "(03)4735286",
    "Address": "桃園市觀音區中山路一段1159號之1號"
}, {
    "POIID": "142353",
    "POIName": "觀富",
    "Telno": "(03)4909409",
    "Address": "桃園市觀音區新富路701號1樓"
}, {
    "POIID": "164342",
    "POIName": "觀湘",
    "Telno": "(03)4834272",
    "Address": "桃園市觀音區忠孝路705號1樓"
}, {
    "POIID": "138608",
    "POIName": "觀湖",
    "Telno": "(03)4736056",
    "Address": "桃園市觀音區濱海路廣興段132號"
}, {
    "POIID": "174800",
    "POIName": "觀濤",
    "Telno": "(03)4834204",
    "Address": "桃園市觀音區樹林里民權路1號"
}, ], ], [[{
    "POIID": "184520",
    "POIName": "GRC",
    "Telno": "(03)6686584",
    "Address": "新竹市東區工業東三路1號1樓"
}, {
    "POIID": "920032",
    "POIName": "千久",
    "Telno": "(03)5338512",
    "Address": "新竹市東區民主路154號156號"
}, {
    "POIID": "155647",
    "POIName": "千甲",
    "Telno": "(03)5750224",
    "Address": "新竹市東區千甲路235號"
}, {
    "POIID": "138158",
    "POIName": "大遠百",
    "Telno": "(03)5210960",
    "Address": "新竹市東區西門街105號"
}, {
    "POIID": "158406",
    "POIName": "公學",
    "Telno": "(03)5748532",
    "Address": "新竹市東區建功一路93號"
}, {
    "POIID": "922577",
    "POIName": "友達五",
    "Telno": "(03)5773422",
    "Address": "新竹市東區力行路23號6樓"
}, {
    "POIID": "944326",
    "POIName": "天湖",
    "Telno": "(03)5621482",
    "Address": "新竹市東區明湖路180號"
}, {
    "POIID": "180090",
    "POIName": "文清",
    "Telno": "(03)5744701",
    "Address": "新竹市東區建功路49號1.2樓"
}, {
    "POIID": "970451",
    "POIName": "世界先進",
    "Telno": "(03)5778992",
    "Address": "新竹市東區力行路9號2樓"
}, {
    "POIID": "902849",
    "POIName": "台積-12",
    "Telno": "(03)6663357",
    "Address": "新竹市東區力行六路8號"
}, {
    "POIID": "121415",
    "POIName": "交大",
    "Telno": "(03)5724785",
    "Address": "新竹市東區大學路1001號(第二餐廳)"
}, {
    "POIID": "122636",
    "POIName": "竹科",
    "Telno": "(03)5790747",
    "Address": "新竹市東區埔頂路8號"
}, {
    "POIID": "141590",
    "POIName": "竹高",
    "Telno": "(03)6885432",
    "Address": "新竹市東區東山街17號19號21號1樓"
}, {
    "POIID": "180403",
    "POIName": "竹博",
    "Telno": "(03)5152946",
    "Address": "新竹市東區民生路226號"
}, {
    "POIID": "916631",
    "POIName": "竹揚",
    "Telno": "(03)5318119",
    "Address": "新竹市東區文華里北大路38號"
}, {
    "POIID": "189606",
    "POIName": "竹運",
    "Telno": "(03)5266371",
    "Address": "新竹市東區中華路二段471號"
}, {
    "POIID": "131928",
    "POIName": "竹醫",
    "Telno": "(03)5334622",
    "Address": "新竹市東區鐵道路二段9號1樓"
}, {
    "POIID": "961402",
    "POIName": "自興",
    "Telno": "(03)5354292",
    "Address": "新竹市東區自由路69號"
}, {
    "POIID": "942191",
    "POIName": "佑忠",
    "Telno": "(03)5619024",
    "Address": "新竹市東區忠孝路430號432號"
}, {
    "POIID": "942917",
    "POIName": "宏府",
    "Telno": "(03)5745036",
    "Address": "新竹市東區學府路164號"
}, {
    "POIID": "121150",
    "POIName": "宏欣",
    "Telno": "(03)5772746",
    "Address": "新竹市東區金山街152號156號1樓"
}, {
    "POIID": "179654",
    "POIName": "宏遠",
    "Telno": "(03)6686441",
    "Address": "新竹市東區金山十五街1號1樓"
}, {
    "POIID": "142010",
    "POIName": "育賢",
    "Telno": "(03)5624805",
    "Address": "新竹市東區南大路611號613號1樓"
}, {
    "POIID": "951678",
    "POIName": "里客",
    "Telno": "(03)5244323",
    "Address": "新竹市東區民族路7號1樓"
}, {
    "POIID": "852724",
    "POIName": "孟竹",
    "Telno": "(03)5723256",
    "Address": "新竹市東區軍功里16鄰建新路26號1樓"
}, {
    "POIID": "181233",
    "POIName": "明泰科技",
    "Telno": "(03)5795684",
    "Address": "新竹市東區力行七路8號B1樓"
}, {
    "POIID": "122979",
    "POIName": "明瑚",
    "Telno": "(03)5191443",
    "Address": "新竹市東區明湖路410號1樓"
}, {
    "POIID": "996660",
    "POIName": "東品",
    "Telno": "(03)5618092",
    "Address": "新竹市東區食品路146號1樓"
}, {
    "POIID": "980791",
    "POIName": "東環",
    "Telno": "(03)5267230",
    "Address": "新竹市東區東門街36號1樓"
}, {
    "POIID": "165851",
    "POIName": "矽導",
    "Telno": "(03)5794397",
    "Address": "新竹市東區力行一路1號"
}, {
    "POIID": "142629",
    "POIName": "金山六",
    "Telno": "(03)5786334",
    "Address": "新竹市東區金山六街51號1樓"
}, {
    "POIID": "992864",
    "POIName": "金山街",
    "Telno": "(03)5794468",
    "Address": "新竹市東區金山街30號1樓"
}, {
    "POIID": "135470",
    "POIName": "金功",
    "Telno": "(03)5738402",
    "Address": "新竹市東區建功二路2號及6號1樓"
}, {
    "POIID": "154828",
    "POIName": "青草湖",
    "Telno": "(03)5296583",
    "Address": "新竹市東區明湖里明湖路3鄰1012-1號"
}, {
    "POIID": "135861",
    "POIName": "保忠",
    "Telno": "(03)5738890",
    "Address": "新竹市東區忠孝路1號"
}, {
    "POIID": "885621",
    "POIName": "俊友",
    "Telno": "(03)5263172",
    "Address": "新竹市東區林森路81號"
}, {
    "POIID": "131386",
    "POIName": "建盛",
    "Telno": "(035)748898",
    "Address": "新竹市東區建中一路52號1樓"
}, {
    "POIID": "147015",
    "POIName": "科技城",
    "Telno": "(03)5670954",
    "Address": "新竹市東區工業東四路42號"
}, {
    "POIID": "137672",
    "POIName": "科園",
    "Telno": "(03)5678117",
    "Address": "新竹市東區科學園路45號"
}, {
    "POIID": "970118",
    "POIName": "科管",
    "Telno": "(03)5670844",
    "Address": "新竹市東區新安路2號"
}, {
    "POIID": "161170",
    "POIName": "科學",
    "Telno": "(03)6686852",
    "Address": "新竹市東區光復路一段527號527之1號1樓"
}, {
    "POIID": "155197",
    "POIName": "風城",
    "Telno": "(03)5331847",
    "Address": "新竹市東區民權路181號1樓"
}, {
    "POIID": "143806",
    "POIName": "埔竹",
    "Telno": "(03)5781471",
    "Address": "新竹市東區埔頂二路148號1樓"
}, {
    "POIID": "170853",
    "POIName": "晏丞",
    "Telno": "(03)5612425",
    "Address": "新竹市東區振興路50號1樓"
}, {
    "POIID": "130833",
    "POIName": "泰一",
    "Telno": "(03)5254716",
    "Address": "新竹市東區中華路二段668號"
}, {
    "POIID": "874609",
    "POIName": "高清",
    "Telno": "(03)5737884",
    "Address": "新竹市東區建功里建功路6號1樓"
}, {
    "POIID": "155142",
    "POIName": "高灃",
    "Telno": "(03)5670804",
    "Address": "新竹市東區高翠路331號1樓"
}, {
    "POIID": "136819",
    "POIName": "梅竹",
    "Telno": "(03)5714668",
    "Address": "新竹市東區光明里14鄰大學路56號58號60號"
}, {
    "POIID": "164962",
    "POIName": "清大",
    "Telno": "(03)5166254",
    "Address": "新竹市東區光復路二段101號"
}, {
    "POIID": "920216",
    "POIName": "翊銘",
    "Telno": "(03)5774378",
    "Address": "新竹市東區新莊街182號186號"
}, {
    "POIID": "155131",
    "POIName": "富首",
    "Telno": "(03)5678054",
    "Address": "新竹市東區慈濟路230號1樓"
}, {
    "POIID": "127240",
    "POIName": "復全",
    "Telno": "(03)5771145",
    "Address": "新竹市東區新莊里長春街13號"
}, {
    "POIID": "993786",
    "POIName": "揚明",
    "Telno": "(03)5795413",
    "Address": "新竹市東區新安路7號"
}, {
    "POIID": "137694",
    "POIName": "智邦",
    "Telno": "(03)6661816",
    "Address": "新竹市東區科學工業園區研新三路1號"
}, {
    "POIID": "173955",
    "POIName": "華國",
    "Telno": "(03)5332309",
    "Address": "新竹市東區中華路一段107號109號"
}, {
    "POIID": "922566",
    "POIName": "新竹友達",
    "Telno": "(03)5789976",
    "Address": "新竹市東區科學園區力行二路1號"
}, {
    "POIID": "137030",
    "POIName": "新竹民",
    "Telno": "(03)5341957",
    "Address": "新竹市東區民族路114號116號1樓"
}, {
    "POIID": "943046",
    "POIName": "新竹建華",
    "Telno": "(03)5621048",
    "Address": "新竹市東區建華街2號1樓"
}, {
    "POIID": "128173",
    "POIName": "新竹站",
    "Telno": "(03)5249543",
    "Address": "新竹市東區中華路二段445號"
}, {
    "POIID": "149712",
    "POIName": "新科享",
    "Telno": "(03)5784403",
    "Address": "新竹市東區科學園路146號142-1號1樓"
}, {
    "POIID": "972985",
    "POIName": "新唐",
    "Telno": "(03)5787840",
    "Address": "新竹市東區研新三路4號2樓"
}, {
    "POIID": "141855",
    "POIName": "新站",
    "Telno": "(03)5244549",
    "Address": "新竹市東區榮光里林森路7號中華路二段458號"
}, {
    "POIID": "123204",
    "POIName": "新馬偕",
    "Telno": "(03)5718278",
    "Address": "新竹市東區光復路二段690號1樓"
}, {
    "POIID": "991506",
    "POIName": "新勝",
    "Telno": "(03)5715124",
    "Address": "新竹市東區東光路75號1樓"
}, {
    "POIID": "111452",
    "POIName": "新揚",
    "Telno": "(03)5316942",
    "Address": "新竹市東區民生路149號151號153號1樓"
}, {
    "POIID": "941914",
    "POIName": "新親仁",
    "Telno": "(03)5336597",
    "Address": "新竹市東區親仁里仁愛街30號1樓"
}, {
    "POIID": "972262",
    "POIName": "煙波",
    "Telno": "(03)5296586",
    "Address": "新竹市東區明湖路967號1樓"
}, {
    "POIID": "116000",
    "POIName": "鉅晶",
    "Telno": "(03)5780840",
    "Address": "新竹市東區力行一路18號4樓"
}, {
    "POIID": "991399",
    "POIName": "鳳美",
    "Telno": "(03)5337159",
    "Address": "新竹市東區中華路二段64號"
}, {
    "POIID": "924919",
    "POIName": "學英",
    "Telno": "(03)5728236",
    "Address": "新竹市東區學府路37號"
}, {
    "POIID": "110105",
    "POIName": "篤明",
    "Telno": "(03)5284791",
    "Address": "新竹市東區林森路184號"
}, {
    "POIID": "120870",
    "POIName": "聯發科",
    "Telno": "(03)5679040",
    "Address": "新竹市東區篤行一路1號"
}, {
    "POIID": "187323",
    "POIName": "聯電B",
    "Telno": "(03)6686453",
    "Address": "新竹市東區力行二路3號B1"
}, {
    "POIID": "991067",
    "POIName": "聯電E",
    "Telno": "(03)5797804",
    "Address": "新竹市東區力行路17號7樓"
}, {
    "POIID": "991056",
    "POIName": "聯電F",
    "Telno": "(03)5794222",
    "Address": "新竹市東區力行六路3號B1樓"
}, {
    "POIID": "126410",
    "POIName": "聯電T",
    "Telno": "(03)6687786",
    "Address": "新竹市東區力行二路3號7樓"
}, {
    "POIID": "185257",
    "POIName": "藍海",
    "Telno": "(03)5679182",
    "Address": "新竹市東區關新路21號1樓"
}, {
    "POIID": "166348",
    "POIName": "雙民",
    "Telno": "(03)5347583",
    "Address": "新竹市東區民族路205號1樓"
}, {
    "POIID": "118589",
    "POIName": "關東",
    "Telno": "(03)5782975",
    "Address": "新竹市東區光復路一段187號189號"
}, {
    "POIID": "154666",
    "POIName": "關圓",
    "Telno": "(03)5788214",
    "Address": "新竹市東區關東路56號1樓"
}, {
    "POIID": "142102",
    "POIName": "關新",
    "Telno": "(03)5782449",
    "Address": "新竹市東區關新路179號1樓"
}, {
    "POIID": "151564",
    "POIName": "寶捷",
    "Telno": "(03)5341705",
    "Address": "新竹市東區田美三街35-1號"
}, {
    "POIID": "123190",
    "POIName": "寶豐",
    "Telno": "(03)5294018",
    "Address": "新竹市東區高峰路536巷58號之1"
}, {
    "POIID": "120962",
    "POIName": "耀明",
    "Telno": "(03)5622948",
    "Address": "新竹市東區南大路521號1樓"
}, {
    "POIID": "972240",
    "POIName": "鑫八廠",
    "Telno": "(03)6668578",
    "Address": "新竹市東區力行路25號1樓"
}, {
    "POIID": "980735",
    "POIName": "鑫旭升",
    "Telno": "(03)5619048",
    "Address": "新竹市東區東南街98號1樓"
}, {
    "POIID": "921046",
    "POIName": "鑫昌",
    "Telno": "(03)5267141",
    "Address": "新竹市東區復興路34號1樓"
}, ], [{
    "POIID": "957687",
    "POIName": "大潤",
    "Telno": "(03)5359394",
    "Address": "新竹市北區湳雅里22鄰湳雅街46號"
}, {
    "POIID": "920191",
    "POIName": "水擇",
    "Telno": "(03)5210801",
    "Address": "新竹市北區水田里中正路194號"
}, {
    "POIID": "985866",
    "POIName": "世達",
    "Telno": "(03)5268728",
    "Address": "新竹市北區延平路一段159號1樓"
}, {
    "POIID": "976688",
    "POIName": "正國",
    "Telno": "(03)5436459",
    "Address": "新竹市北區中正路286之1號一樓"
}, {
    "POIID": "184162",
    "POIName": "正御",
    "Telno": "(03)5430369",
    "Address": "新竹市北區中正路309號1+B1樓"
}, {
    "POIID": "149170",
    "POIName": "民富",
    "Telno": "(03)5262998",
    "Address": "新竹市北區新民里西大路642號"
}, {
    "POIID": "173922",
    "POIName": "竹光",
    "Telno": "(03)5323204",
    "Address": "新竹市北區文雅里18鄰竹光路123號"
}, {
    "POIID": "886761",
    "POIName": "竹城",
    "Telno": "(03)5250326",
    "Address": "新竹市北區西門里中山路100號"
}, {
    "POIID": "118730",
    "POIName": "竹陵",
    "Telno": "(03)5153239",
    "Address": "新竹市北區東大路二段174號"
}, {
    "POIID": "174176",
    "POIName": "竹森",
    "Telno": "(03)5424164",
    "Address": "新竹市北區光華東街107號"
}, {
    "POIID": "164467",
    "POIName": "竹灣",
    "Telno": "(03)5263560",
    "Address": "新竹市北區客雃里延平路一段252號1樓"
}, {
    "POIID": "136152",
    "POIName": "宏光",
    "Telno": "(03)5317661",
    "Address": "新竹市北區光華一街29號1樓"
}, {
    "POIID": "136451",
    "POIName": "東中",
    "Telno": "(03)5212078",
    "Address": "新竹市北區東門街167號"
}, {
    "POIID": "155290",
    "POIName": "東妮",
    "Telno": "(03)5362446",
    "Address": "新竹市北區東大路3段718號720號1樓"
}, {
    "POIID": "132297",
    "POIName": "空軍",
    "Telno": "(03)5430162",
    "Address": "新竹市北區中正路385號387號1樓"
}, {
    "POIID": "120010",
    "POIName": "冠盈",
    "Telno": "(03)5364694",
    "Address": "新竹市北區西濱路1段286號"
}, {
    "POIID": "122706",
    "POIName": "厚稼",
    "Telno": "(03)5425780",
    "Address": "新竹市北區鐵道路二段280號"
}, {
    "POIID": "864808",
    "POIName": "城北",
    "Telno": "(03)5239470",
    "Address": "新竹市北區城北街43號"
}, {
    "POIID": "896137",
    "POIName": "恆新",
    "Telno": "(03)5242900",
    "Address": "新竹市北區民富里7鄰北大路342號"
}, {
    "POIID": "985796",
    "POIName": "海寶",
    "Telno": "(03)5367934",
    "Address": "新竹市北區海濱里榮濱路1號"
}, {
    "POIID": "950033",
    "POIName": "盛天",
    "Telno": "(03)5369457",
    "Address": "新竹市北區延平路三段545號"
}, {
    "POIID": "187437",
    "POIName": "富盛",
    "Telno": "(03)5224473",
    "Address": "新竹市北區經國路二段346號1樓"
}, {
    "POIID": "124621",
    "POIName": "雅新",
    "Telno": "(03)5319675",
    "Address": "新竹市北區湳雅街154號"
}, {
    "POIID": "167994",
    "POIName": "菄大",
    "Telno": "(03)5360700",
    "Address": "新竹市北區東大路四段258.260號1樓"
}, {
    "POIID": "150723",
    "POIName": "新大",
    "Telno": "(03)5426095",
    "Address": "新竹市北區東大路3段2號"
}, {
    "POIID": "953478",
    "POIName": "新世界",
    "Telno": "(03)5242975",
    "Address": "新竹市北區中正路121號"
}, {
    "POIID": "973047",
    "POIName": "新悅",
    "Telno": "(03)5428767",
    "Address": "新竹市北區經國路二段166號168號1樓"
}, {
    "POIID": "188463",
    "POIName": "新雅竹",
    "Telno": "(03)5456467",
    "Address": "新竹市北區湳雅街255號"
}, {
    "POIID": "112466",
    "POIName": "聖華",
    "Telno": "(03)5363894",
    "Address": "新竹市北區西濱路1段399號"
}, {
    "POIID": "932862",
    "POIName": "福盛",
    "Telno": "(03)5327718",
    "Address": "新竹市北區鐵道路3段2號"
}, {
    "POIID": "181439",
    "POIName": "磐石",
    "Telno": "(03)5338457",
    "Address": "新竹市北區西大路740號1樓"
}, ], [{
    "POIID": "150767",
    "POIName": "佳香",
    "Telno": "(03)5182254",
    "Address": "新竹市香山區中華路6段60-1號"
}, {
    "POIID": "158749",
    "POIName": "東香",
    "Telno": "(03)5402700",
    "Address": "新竹市香山區頂埔路2號"
}, {
    "POIID": "130936",
    "POIName": "東埔",
    "Telno": "(03)5399314",
    "Address": "新竹市香山區牛埔路146號"
}, {
    "POIID": "123411",
    "POIName": "松邑",
    "Telno": "(03)5304086",
    "Address": "新竹市香山區牛埔南路2號"
}, {
    "POIID": "130925",
    "POIName": "岦湖",
    "Telno": "(03)5182449",
    "Address": "新竹市香山區內湖路138號1樓"
}, {
    "POIID": "946241",
    "POIName": "香山",
    "Telno": "(03)5300114",
    "Address": "新竹市香山區牛埔路447號"
}, {
    "POIID": "126498",
    "POIName": "香光",
    "Telno": "(03)5400747",
    "Address": "新竹市香山區香北路82號1樓"
}, {
    "POIID": "126524",
    "POIName": "香江",
    "Telno": "(03)5181847",
    "Address": "新竹市香山區中華路6段428-430號"
}, {
    "POIID": "151656",
    "POIName": "香圃",
    "Telno": "(03)5305337",
    "Address": "新竹市香山區牛埔東路253號1樓"
}, {
    "POIID": "947635",
    "POIName": "香華",
    "Telno": "(03)5309674",
    "Address": "新竹市香山區中華路四段602號604號"
}, {
    "POIID": "149181",
    "POIName": "海天",
    "Telno": "(03)5364888",
    "Address": "新竹市香山區海埔路136號"
}, {
    "POIID": "932183",
    "POIName": "祥園",
    "Telno": "(03)5402722",
    "Address": "新竹市香山區牛埔北路50號"
}, {
    "POIID": "901868",
    "POIName": "頂福",
    "Telno": "(03)5388361",
    "Address": "新竹市香山區中山路628號630號"
}, {
    "POIID": "982867",
    "POIName": "華耀",
    "Telno": "(03)5378614",
    "Address": "新竹市香山區明德路1號1樓"
}, {
    "POIID": "113218",
    "POIName": "華鑫",
    "Telno": "(03)5182741",
    "Address": "新竹市香山區五福路二段725號727號729號1樓"
}, {
    "POIID": "167444",
    "POIName": "隆華",
    "Telno": "(03)5398995",
    "Address": "新竹市香山區中華路5段193號1樓"
}, {
    "POIID": "943600",
    "POIName": "新竹延平",
    "Telno": "(03)5401035",
    "Address": "新竹市香山區延平路二段82號84號"
}, {
    "POIID": "143828",
    "POIName": "新豪康",
    "Telno": "(03)5398534",
    "Address": "新竹市香山區元培街371號1樓"
}, {
    "POIID": "187183",
    "POIName": "豪運",
    "Telno": "(03)5398840",
    "Address": "新竹市香山區香北路181號183號"
}, {
    "POIID": "188108",
    "POIName": "璟觀",
    "Telno": "(03)5297705",
    "Address": "新竹市香山區景觀大道830號1樓"
}, {
    "POIID": "180263",
    "POIName": "鎵華",
    "Telno": "(03)5183412",
    "Address": "新竹市香山區中華路六段131.133.135號1樓"
}, ], ], [[{
    "POIID": "131098",
    "POIName": "十興",
    "Telno": "(03)6589536",
    "Address": "新竹縣竹北市莊敬北路130號"
}, {
    "POIID": "124632",
    "POIName": "中新",
    "Telno": "(03)5559619",
    "Address": "新竹縣竹北市中正西路389號1樓"
}, {
    "POIID": "112802",
    "POIName": "六家",
    "Telno": "(03)6672052",
    "Address": "新竹縣竹北市福興東路二段105號1樓"
}, {
    "POIID": "154002",
    "POIName": "文元",
    "Telno": "(03)5601747",
    "Address": "新竹縣竹北市台元二街1號1樓"
}, {
    "POIID": "132770",
    "POIName": "文嘉",
    "Telno": "(03)6577740",
    "Address": "新竹縣竹北市文興路一段398號1樓"
}, {
    "POIID": "190053",
    "POIName": "斗崙",
    "Telno": "(03)5511063",
    "Address": "新竹縣竹北市光明十一路188號190號1樓"
}, {
    "POIID": "183985",
    "POIName": "加勝",
    "Telno": "(03)5501009",
    "Address": "新竹縣竹北市勝利八街二段63.65號1樓"
}, {
    "POIID": "163637",
    "POIName": "北泰",
    "Telno": "(03)5530956",
    "Address": "新竹縣竹北市中正西路134號1樓"
}, {
    "POIID": "112318",
    "POIName": "台元",
    "Telno": "(03)5526524",
    "Address": "新竹縣竹北市台元街26-8號"
}, {
    "POIID": "951623",
    "POIName": "光揚",
    "Telno": "(03)5588571",
    "Address": "新竹縣竹北市光明六路247號249號251號一樓"
}, {
    "POIID": "122038",
    "POIName": "宇軒",
    "Telno": "(03)6576632",
    "Address": "新竹縣竹北市勝利二路85號1樓"
}, {
    "POIID": "149804",
    "POIName": "安村",
    "Telno": "(03)5559247",
    "Address": "新竹縣竹北市中山路416-1號"
}, {
    "POIID": "896218",
    "POIName": "竹北",
    "Telno": "(03)5513391",
    "Address": "新竹縣竹北市中正東路194號"
}, {
    "POIID": "142515",
    "POIName": "竹北中華",
    "Telno": "(03)5535441",
    "Address": "新竹縣竹北市中華路881號1樓"
}, {
    "POIID": "131456",
    "POIName": "竹崙",
    "Telno": "(03)5539359",
    "Address": "新竹縣竹北市中華路153號1樓"
}, {
    "POIID": "177337",
    "POIName": "竹樺",
    "Telno": "(03)5516946",
    "Address": "新竹縣竹北市華興街298號1樓"
}, {
    "POIID": "997847",
    "POIName": "沐庭",
    "Telno": "(03)5586247",
    "Address": "新竹縣竹北市光明六路106號1樓"
}, {
    "POIID": "158934",
    "POIName": "府樂",
    "Telno": "(03)5585235",
    "Address": "新竹縣竹北市縣政九路80號一樓"
}, {
    "POIID": "165493",
    "POIName": "明采",
    "Telno": "(03)5587067",
    "Address": "新竹縣竹北市光明一路158號1樓"
}, {
    "POIID": "179953",
    "POIName": "東鐵",
    "Telno": "(03)6670376",
    "Address": "新竹縣竹北市隘口三街231號1樓"
}, {
    "POIID": "180322",
    "POIName": "采虹",
    "Telno": "(03)6583504",
    "Address": "新竹縣竹北市勝利八街一段345.347號1樓"
}, {
    "POIID": "883315",
    "POIName": "飛利浦",
    "Telno": "(03)5544216",
    "Address": "新竹縣竹北市中華路548號550號"
}, {
    "POIID": "122603",
    "POIName": "首璽",
    "Telno": "(03)6682461",
    "Address": "新竹縣竹北市自強六街13號1樓"
}, {
    "POIID": "158831",
    "POIName": "家興",
    "Telno": "(03)5502894",
    "Address": "新竹縣竹北市嘉豐五路二段168號1樓"
}, {
    "POIID": "929187",
    "POIName": "泰鑫",
    "Telno": "(03)6567717",
    "Address": "新竹縣竹北市新泰路31號一樓"
}, {
    "POIID": "153537",
    "POIName": "強利",
    "Telno": "(03)6577810",
    "Address": "新竹縣竹北市自強北路111號"
}, {
    "POIID": "165208",
    "POIName": "強鹿",
    "Telno": "(03)6577734",
    "Address": "新竹縣竹北市自強北路256號1樓"
}, {
    "POIID": "174327",
    "POIName": "強興",
    "Telno": "(03)6684746",
    "Address": "新竹縣竹北市自強北路223號"
}, {
    "POIID": "182018",
    "POIName": "晨星科",
    "Telno": "(03)5601439",
    "Address": "新竹縣竹北市台元街18號7樓之1"
}, {
    "POIID": "947738",
    "POIName": "統賀",
    "Telno": "(03)5536749",
    "Address": "新竹縣竹北市中正東路67號69號"
}, {
    "POIID": "923226",
    "POIName": "鹿家",
    "Telno": "(03)5509423",
    "Address": "新竹縣竹北市自強南路136號"
}, {
    "POIID": "142559",
    "POIName": "博明",
    "Telno": "(03)5529864",
    "Address": "新竹縣竹北市博愛街235號237號1樓"
}, {
    "POIID": "952811",
    "POIName": "博祐",
    "Telno": "(03)5535243",
    "Address": "新竹縣竹北市博愛街25-1號"
}, {
    "POIID": "185903",
    "POIName": "博愛街",
    "Telno": "(03)5530848",
    "Address": "新竹縣竹北市博愛街709號1樓"
}, {
    "POIID": "127402",
    "POIName": "華盛",
    "Telno": "(03)6560893",
    "Address": "新竹縣竹北市新社里華興街68號"
}, {
    "POIID": "183033",
    "POIName": "新北竹",
    "Telno": "(03)5554064",
    "Address": "新竹縣竹北市博愛街358.360號1樓"
}, {
    "POIID": "179746",
    "POIName": "新瓦屋",
    "Telno": "(03)6577424",
    "Address": "新竹縣竹北市文興路1段172.176號1樓"
}, {
    "POIID": "999957",
    "POIName": "新縣政",
    "Telno": "(03)6568254",
    "Address": "新竹縣竹北市光明九路12號1樓"
}, {
    "POIID": "136576",
    "POIName": "新縣福",
    "Telno": "(03)5587354",
    "Address": "新竹縣竹北市縣政二路414號416號1樓"
}, {
    "POIID": "977315",
    "POIName": "新薪荷",
    "Telno": "(03)5543978",
    "Address": "新竹縣竹北市三民路243號245號1樓"
}, {
    "POIID": "158082",
    "POIName": "隘口",
    "Telno": "(03)6585403",
    "Address": "新竹縣竹北市隘口二路27號"
}, {
    "POIID": "180399",
    "POIName": "隘心",
    "Telno": "(03)6583107",
    "Address": "新竹縣竹北市興隆路五段151號"
}, {
    "POIID": "132389",
    "POIName": "嘉家",
    "Telno": "(03)6681534",
    "Address": "新竹縣竹北市嘉豐十一路一段30號1樓"
}, {
    "POIID": "123189",
    "POIName": "嘉豐",
    "Telno": "(03)6582578",
    "Address": "新竹縣竹北市嘉豐北路76號78號"
}, {
    "POIID": "163497",
    "POIName": "銘豐",
    "Telno": "(03)6589700",
    "Address": "新竹縣竹北市嘉豐五路一段1號1樓"
}, {
    "POIID": "944588",
    "POIName": "鳳岡",
    "Telno": "(03)5563289",
    "Address": "新竹縣竹北市長青路一段388號390號"
}, {
    "POIID": "181738",
    "POIName": "璞玉",
    "Telno": "(03)6577690",
    "Address": "新竹縣竹北市東興路二段39號"
}, {
    "POIID": "142098",
    "POIName": "縣汶",
    "Telno": "(03)5584427",
    "Address": "新竹縣竹北市縣政二路233號235號1樓"
}, {
    "POIID": "182720",
    "POIName": "縣政府",
    "Telno": "(03)6573682",
    "Address": "新竹縣竹北市光明六路10號"
}, {
    "POIID": "144739",
    "POIName": "縣科",
    "Telno": "(03)5585349",
    "Address": "新竹縣竹北市縣政二路南段103號"
}, {
    "POIID": "149701",
    "POIName": "縣運",
    "Telno": "(03)5502437",
    "Address": "新竹縣竹北市莊敬南路21號1樓"
}, {
    "POIID": "113838",
    "POIName": "興韻",
    "Telno": "(03)5584179",
    "Address": "新竹縣竹北市福興路753號"
}, {
    "POIID": "173807",
    "POIName": "聯新",
    "Telno": "(03)5517846",
    "Address": "新竹縣竹北市中正西路602號1樓"
}, {
    "POIID": "944256",
    "POIName": "鐵家",
    "Telno": "(03)6583620",
    "Address": "新竹縣竹北市自強南路211號"
}, {
    "POIID": "975157",
    "POIName": "鐵興",
    "Telno": "(03)6582631",
    "Address": "新竹縣竹北市文興路一段246號248號一樓"
}, ], [{
    "POIID": "164504",
    "POIName": "上員",
    "Telno": "(03)5833769",
    "Address": "新竹縣竹東鎮光明路538巷25號"
}, {
    "POIID": "126672",
    "POIName": "四重埔",
    "Telno": "(03)5830831",
    "Address": "新竹縣竹東鎮中興路一段157號"
}, {
    "POIID": "871976",
    "POIName": "光春",
    "Telno": "(03)5952490",
    "Address": "新竹縣竹東鎮長春路三段253號"
}, {
    "POIID": "181325",
    "POIName": "竹永",
    "Telno": "(03)5102849",
    "Address": "新竹縣竹東鎮仁愛里北興路二段185號187號"
}, {
    "POIID": "131629",
    "POIName": "竹東",
    "Telno": "(03)5102610",
    "Address": "新竹縣竹東鎮學前路29號1樓"
}, {
    "POIID": "967961",
    "POIName": "竹興",
    "Telno": "(03)5827876",
    "Address": "新竹縣竹東鎮中興路四段650號"
}, {
    "POIID": "161181",
    "POIName": "竹豐",
    "Telno": "(03)5110479",
    "Address": "新竹縣竹東鎮中豐路三段93號95號1樓"
}, {
    "POIID": "165013",
    "POIName": "昌春",
    "Telno": "(03)5102827",
    "Address": "新竹縣竹東鎮長春路三段26號1樓2樓"
}, {
    "POIID": "144865",
    "POIName": "東宏",
    "Telno": "(03)5102990",
    "Address": "新竹縣竹東鎮中正路217號1樓"
}, {
    "POIID": "912765",
    "POIName": "東亭",
    "Telno": "(03)5104097",
    "Address": "新竹縣竹東鎮和江街2號6號"
}, {
    "POIID": "958956",
    "POIName": "東福",
    "Telno": "(03)5947900",
    "Address": "新竹縣竹東鎮中豐路2段245號"
}, {
    "POIID": "181059",
    "POIName": "東興",
    "Telno": "(03)5102419",
    "Address": "新竹縣竹東鎮北興路一段468號1樓"
}, {
    "POIID": "155429",
    "POIName": "東融",
    "Telno": "(03)5821769",
    "Address": "新竹縣竹東鎮中興路二段148號1樓"
}, {
    "POIID": "947381",
    "POIName": "東豐",
    "Telno": "(03)5947715",
    "Address": "新竹縣竹東鎮東寧里東寧路1段1號"
}, {
    "POIID": "188979",
    "POIName": "東鑽",
    "Telno": "(03)5963395",
    "Address": "新竹縣竹東鎮北興路三段517號519號"
}, {
    "POIID": "941121",
    "POIName": "員崠",
    "Telno": "(03)5953697",
    "Address": "新竹縣竹東鎮東峰路336號"
}, {
    "POIID": "188865",
    "POIName": "商華",
    "Telno": "(03)5100157",
    "Address": "新竹縣竹東鎮東寧路三段25號1樓"
}, {
    "POIID": "144843",
    "POIName": "崠豪",
    "Telno": "(03)5104291",
    "Address": "新竹縣竹東鎮東林路103號1樓"
}, {
    "POIID": "165002",
    "POIName": "富正",
    "Telno": "(03)5110382",
    "Address": "新竹縣竹東鎮東寧路一段261號1樓"
}, {
    "POIID": "164973",
    "POIName": "朝陽",
    "Telno": "(03)5942462",
    "Address": "新竹縣竹東鎮朝陽路72號74號"
}, {
    "POIID": "130707",
    "POIName": "菄族",
    "Telno": "(03)5822817",
    "Address": "新竹縣竹東鎮民族路66號1樓"
}, {
    "POIID": "128140",
    "POIName": "寶山",
    "Telno": "(03)5821311",
    "Address": "新竹縣竹東鎮中興路三段173號"
}, ], [{
    "POIID": "893655",
    "POIName": "埔中",
    "Telno": "(03)5888775",
    "Address": "新竹縣新埔鎮中正路619號621號"
}, {
    "POIID": "137535",
    "POIName": "埔田",
    "Telno": "(03)5882584",
    "Address": "新竹縣新埔鎮中正路7號1樓"
}, {
    "POIID": "167606",
    "POIName": "埔昌",
    "Telno": "(03)5886284",
    "Address": "新竹縣新埔鎮義民路一段92號"
}, {
    "POIID": "132356",
    "POIName": "埔義",
    "Telno": "(03)5884984",
    "Address": "新竹縣新埔鎮下寮里義民路三段317號1樓"
}, {
    "POIID": "154013",
    "POIName": "新埔",
    "Telno": "(03)5887237",
    "Address": "新竹縣新埔鎮中正路221號"
}, ], [{
    "POIID": "141659",
    "POIName": "石光",
    "Telno": "(03)5868624",
    "Address": "新竹縣關西鎮石光里石岡子252號1樓"
}, {
    "POIID": "971340",
    "POIName": "馬武督",
    "Telno": "(03)5171785",
    "Address": "新竹縣關西鎮中豐新路2-1號1樓"
}, {
    "POIID": "911876",
    "POIName": "新關中",
    "Telno": "(03)5879439",
    "Address": "新竹縣關西鎮中興路17號"
}, {
    "POIID": "130475",
    "POIName": "關西",
    "Telno": "(03)5171983",
    "Address": "新竹縣關西鎮正義路286-1號"
}, ], [{
    "POIID": "182971",
    "POIName": "力成三",
    "Telno": "(03)6960346",
    "Address": "新竹縣湖口鄉大同路15之1號6樓"
}, {
    "POIID": "990710",
    "POIName": "力成科",
    "Telno": "(03)5972154",
    "Address": "新竹縣湖口鄉大同路26號6樓"
}, {
    "POIID": "990846",
    "POIName": "力成貳",
    "Telno": "(03)5974877",
    "Address": "新竹縣湖口鄉三民路7號B1"
}, {
    "POIID": "910806",
    "POIName": "三立",
    "Telno": "(03)5693326",
    "Address": "新竹縣湖口鄉湖鏡村八德路一段718號"
}, {
    "POIID": "973081",
    "POIName": "仁智",
    "Telno": "(03)6960527",
    "Address": "新竹縣湖口鄉仁和路38號1樓"
}, {
    "POIID": "149310",
    "POIName": "文樂",
    "Telno": "(03)6960007",
    "Address": "新竹縣湖口鄉文化路55號"
}, {
    "POIID": "182340",
    "POIName": "王爺",
    "Telno": "(03)5904065",
    "Address": "新竹縣湖口鄉中山路一段790號1樓"
}, {
    "POIID": "953489",
    "POIName": "宏橋",
    "Telno": "(03)5974841",
    "Address": "新竹縣湖口鄉工業一路7號7-1號"
}, {
    "POIID": "154105",
    "POIName": "忠平",
    "Telno": "(03)5904720",
    "Address": "新竹縣湖口鄉中平路一段271號1樓"
}, {
    "POIID": "110699",
    "POIName": "耕新",
    "Telno": "(03)5907092",
    "Address": "新竹縣湖口鄉成功路276號"
}, {
    "POIID": "143817",
    "POIName": "國碩",
    "Telno": "(03)5974789",
    "Address": "新竹縣湖口鄉工業一路3號5樓"
}, {
    "POIID": "990880",
    "POIName": "晨希",
    "Telno": "(03)5976142",
    "Address": "新竹縣湖口鄉榮光路617號"
}, {
    "POIID": "167765",
    "POIName": "晨寶",
    "Telno": "(03)6960464",
    "Address": "新竹縣湖口鄉三民南路117號1樓"
}, {
    "POIID": "123363",
    "POIName": "湖口",
    "Telno": "(03)5994895",
    "Address": "新竹縣湖口鄉中正路一段36號"
}, {
    "POIID": "169886",
    "POIName": "湖口廠",
    "Telno": "(03)5694694",
    "Address": "新竹縣湖口鄉八德路三段30號"
}, {
    "POIID": "930800",
    "POIName": "湖山",
    "Telno": "(03)5901262",
    "Address": "新竹縣湖口鄉中山路3段489號"
}, {
    "POIID": "988337",
    "POIName": "湖安",
    "Telno": "(03)5974735",
    "Address": "新竹縣湖口鄉光復東路395號1樓"
}, {
    "POIID": "187091",
    "POIName": "湖崗",
    "Telno": "(03)5995848",
    "Address": "新竹縣湖口鄉中山路二段430號"
}, {
    "POIID": "171351",
    "POIName": "新湖工",
    "Telno": "(03)5974942",
    "Address": "新竹縣湖口鄉中華路54號"
}, {
    "POIID": "966865",
    "POIName": "新湖中",
    "Telno": "(03)6992852",
    "Address": "新竹縣湖口鄉中正村中正路二段235號"
}, {
    "POIID": "910703",
    "POIName": "源威",
    "Telno": "(03)5986517",
    "Address": "新竹縣湖口鄉光華路666號1F"
}, {
    "POIID": "922751",
    "POIName": "源泰",
    "Telno": "(03)5999488",
    "Address": "新竹縣湖口鄉中興街174-176號"
}, {
    "POIID": "944751",
    "POIName": "源晟",
    "Telno": "(03)5579768",
    "Address": "新竹縣湖口鄉新興路628號630號"
}, {
    "POIID": "138929",
    "POIName": "裝甲",
    "Telno": "(03)6960001",
    "Address": "新竹縣湖口鄉勝利路二段93號94號95號1樓"
}, {
    "POIID": "141556",
    "POIName": "達陞",
    "Telno": "(03)5905264",
    "Address": "新竹縣湖口鄉中山路一段537號1樓"
}, {
    "POIID": "141877",
    "POIName": "鳳山綺",
    "Telno": "(03)5974427",
    "Address": "新竹縣湖口鄉勝利路二段254號1樓"
}, {
    "POIID": "155599",
    "POIName": "德和",
    "Telno": "(03)5903462",
    "Address": "新竹縣湖口鄉德興路216號218號"
}, {
    "POIID": "127343",
    "POIName": "豐鈴",
    "Telno": "(03)5972263",
    "Address": "新竹縣湖口鄉安宅四街2號"
}, {
    "POIID": "141718",
    "POIName": "豐鼎",
    "Telno": "(03)6960448",
    "Address": "新竹縣湖口鄉光復東路8號1樓"
}, {
    "POIID": "863458",
    "POIName": "醫湖",
    "Telno": "(03)5904938",
    "Address": "新竹縣湖口鄉孝勢里忠孝路20號22號"
}, {
    "POIID": "187220",
    "POIName": "羅湖",
    "Telno": "(03)5902084",
    "Address": "新竹縣湖口鄉成功路1092號"
}, {
    "POIID": "131755",
    "POIName": "鑫力成",
    "Telno": "(03)6960841",
    "Address": "新竹縣湖口鄉大同路10號6樓"
}, ], [{
    "POIID": "988038",
    "POIName": "世豊",
    "Telno": "(03)5590282",
    "Address": "新竹縣新豐鄉建興路一段173號175號一樓"
}, {
    "POIID": "169842",
    "POIName": "明大",
    "Telno": "(03)5578461",
    "Address": "新竹縣新豐鄉松林村新興路1號"
}, {
    "POIID": "123352",
    "POIName": "明新",
    "Telno": "(03)5594933",
    "Address": "新竹縣新豐鄉新興路7號"
}, {
    "POIID": "154943",
    "POIName": "欣樂",
    "Telno": "(03)5577364",
    "Address": "新竹縣新豐鄉康樂路一段358號"
}, {
    "POIID": "137524",
    "POIName": "冠宇",
    "Telno": "(03)5578596",
    "Address": "新竹縣新豐鄉忠孝路1號"
}, {
    "POIID": "121460",
    "POIName": "冠華",
    "Telno": "(03)5577964",
    "Address": "新竹縣新豐鄉忠孝村員山148之2號1樓"
}, {
    "POIID": "166854",
    "POIName": "埔和",
    "Telno": "(03)5689849",
    "Address": "新竹縣新豐鄉埔和村埔頂281之1號"
}, {
    "POIID": "181831",
    "POIName": "景碩",
    "Telno": "(03)5574721",
    "Address": "新竹縣新豐鄉建興路二段526號行政棟3樓"
}, {
    "POIID": "962977",
    "POIName": "新庄子",
    "Telno": "(03)5597054",
    "Address": "新竹縣新豐鄉建興路二段752號1樓"
}, {
    "POIID": "967282",
    "POIName": "新高湖",
    "Telno": "(03)5571841",
    "Address": "新竹縣新豐鄉新興路403號1樓"
}, {
    "POIID": "121459",
    "POIName": "新康",
    "Telno": "(03)5572191",
    "Address": "新竹縣新豐鄉松林村7鄰康樂路1段216號1樓"
}, {
    "POIID": "954633",
    "POIName": "新新豐",
    "Telno": "(03)5578411",
    "Address": "新竹縣新豐鄉新興路177號179號1樓"
}, {
    "POIID": "126340",
    "POIName": "新豐新庄",
    "Telno": "(03)5577859",
    "Address": "新竹縣新豐鄉新庄路383號"
}, {
    "POIID": "142526",
    "POIName": "源冠",
    "Telno": "(03)5572871",
    "Address": "新竹縣新豐鄉尚仁街92號1樓"
}, {
    "POIID": "180160",
    "POIName": "鳳鼻",
    "Telno": "(03)5578428",
    "Address": "新竹縣新豐鄉鳳坑村坑子口750之2號"
}, {
    "POIID": "914037",
    "POIName": "豐興",
    "Telno": "(03)5599897",
    "Address": "新竹縣新豐鄉建興路一段128號"
}, ], [{
    "POIID": "953607",
    "POIName": "大矽谷",
    "Telno": "(03)5928993",
    "Address": "新竹縣芎林鄉三民路279號1樓"
}, {
    "POIID": "991089",
    "POIName": "芎林",
    "Telno": "(03)5927327",
    "Address": "新竹縣芎林鄉文山路529號531號1樓"
}, {
    "POIID": "181691",
    "POIName": "宥昌",
    "Telno": "(03)5926051",
    "Address": "新竹縣芎林鄉文富街100號1樓"
}, {
    "POIID": "124687",
    "POIName": "飛凰",
    "Telno": "(03)5120589",
    "Address": "新竹縣芎林鄉富林路二段729號"
}, {
    "POIID": "965932",
    "POIName": "飛鳳",
    "Telno": "(03)5928161",
    "Address": "新竹縣芎林鄉富林路二段556號"
}, {
    "POIID": "992233",
    "POIName": "富林",
    "Telno": "(03)5924182",
    "Address": "新竹縣芎林鄉富林路三段239號1樓"
}, ], [{
    "POIID": "920917",
    "POIName": "內灣",
    "Telno": "(03)5849373",
    "Address": "新竹縣橫山鄉內灣村20號"
}, {
    "POIID": "142928",
    "POIName": "華科",
    "Telno": "(03)5931167",
    "Address": "新竹縣橫山鄉橫山村9鄰中豐路一段100號1樓"
}, {
    "POIID": "910437",
    "POIName": "橫山",
    "Telno": "(03)5934706",
    "Address": "新竹縣橫山鄉中豐路二段122號"
}, {
    "POIID": "180528",
    "POIName": "騰達",
    "Telno": "(03)5934063",
    "Address": "新竹縣橫山鄉中豐路二段211號"
}, ], [{
    "POIID": "188430",
    "POIName": "中德",
    "Telno": "(03)5805510",
    "Address": "新竹縣北埔鄉北埔村中山路42號一樓"
}, {
    "POIID": "137926",
    "POIName": "金廣福",
    "Telno": "(03)5803135",
    "Address": "新竹縣北埔鄉南興街135號1樓"
}, ], [{
    "POIID": "143552",
    "POIName": "台積",
    "Telno": "(03)5790640",
    "Address": "新竹縣寶山鄉園區二路168號1樓"
}, {
    "POIID": "122290",
    "POIName": "台積P6",
    "Telno": "(03)5798243",
    "Address": "新竹縣寶山鄉新竹科學園區園區二路166號"
}, {
    "POIID": "912927",
    "POIName": "台積二",
    "Telno": "(03)5797355",
    "Address": "新竹縣寶山鄉園區三路121號B1"
}, {
    "POIID": "912938",
    "POIName": "台積三",
    "Telno": "(03)5797212",
    "Address": "新竹縣寶山鄉研新一路9號"
}, {
    "POIID": "130338",
    "POIName": "台積電",
    "Telno": "(03)5773140",
    "Address": "新竹縣寶山鄉研新二路6號"
}, {
    "POIID": "912617",
    "POIName": "情友",
    "Telno": "(03)5206568",
    "Address": "新竹縣寶山鄉雙溪村寶新路1號"
}, {
    "POIID": "183343",
    "POIName": "進一廠",
    "Telno": "(03)5798620",
    "Address": "新竹縣寶山鄉園區三路123號"
}, {
    "POIID": "161125",
    "POIName": "園區",
    "Telno": "(03)6686614",
    "Address": "新竹縣寶山鄉園區三路1號"
}, {
    "POIID": "953696",
    "POIName": "盟創",
    "Telno": "(03)6686093",
    "Address": "新竹縣寶山鄉創新二路6號"
}, {
    "POIID": "154080",
    "POIName": "積七",
    "Telno": "(03)5790146",
    "Address": "新竹縣寶山鄉園區二路170號1樓"
}, {
    "POIID": "991078",
    "POIName": "聯電S",
    "Telno": "(03)5679778",
    "Address": "新竹縣寶山鄉雙溪村研新一路16號3樓"
}, {
    "POIID": "131272",
    "POIName": "寶雅",
    "Telno": "(03)5679055",
    "Address": "新竹縣寶山鄉大崎村大雅路二段103巷15號"
}, ], ], [[{
    "POIID": "180344",
    "POIName": "大千",
    "Telno": "(037)359348",
    "Address": "苗栗縣苗栗市中正路903號1樓"
}, {
    "POIID": "189949",
    "POIName": "為公",
    "Telno": "(037)261722",
    "Address": "苗栗縣苗栗市嘉盛里25鄰為公路584號"
}, {
    "POIID": "912721",
    "POIName": "苗公",
    "Telno": "(037)338150",
    "Address": "苗栗縣苗栗市中山路602之1號"
}, {
    "POIID": "990916",
    "POIName": "苗治",
    "Telno": "(037)374353",
    "Address": "苗栗縣苗栗市自治路72號"
}, {
    "POIID": "143367",
    "POIName": "苗栗",
    "Telno": "(037)371479",
    "Address": "苗栗縣苗栗市民族路99號101號1樓"
}, {
    "POIID": "860611",
    "POIName": "苗勝",
    "Telno": "(037)360941",
    "Address": "苗栗縣苗栗市勝利里中正路1045號"
}, {
    "POIID": "952626",
    "POIName": "苗碩",
    "Telno": "(037)321719",
    "Address": "苗栗縣苗栗市維新里新東街219號"
}, {
    "POIID": "993085",
    "POIName": "苗豐",
    "Telno": "(037)266930",
    "Address": "苗栗縣苗栗市為公路167-1號"
}, {
    "POIID": "118028",
    "POIName": "苗鑫",
    "Telno": "(037)374655",
    "Address": "苗栗縣苗栗市國華路1092號"
}, {
    "POIID": "112710",
    "POIName": "恭敬",
    "Telno": "(037)364673",
    "Address": "苗栗縣苗栗市恭敬里恭敬路18號"
}, {
    "POIID": "164331",
    "POIName": "栗華",
    "Telno": "(037)278968",
    "Address": "苗栗縣苗栗市中華路78號"
}, {
    "POIID": "967662",
    "POIName": "真樂",
    "Telno": "(037)322936",
    "Address": "苗栗縣苗栗市玉清路329號1樓"
}, {
    "POIID": "982281",
    "POIName": "新苗中",
    "Telno": "(037)359140",
    "Address": "苗栗縣苗栗市府前路120號"
}, {
    "POIID": "113366",
    "POIName": "福華",
    "Telno": "(037)270476",
    "Address": "苗栗縣苗栗市福星里中華路273號"
}, {
    "POIID": "951612",
    "POIName": "豪榮",
    "Telno": "(037)364660",
    "Address": "苗栗縣苗栗市南勢里豪榮1號"
}, {
    "POIID": "160203",
    "POIName": "頤和",
    "Telno": "(037)261762",
    "Address": "苗栗縣苗栗市中正路55號1樓"
}, {
    "POIID": "130855",
    "POIName": "館源",
    "Telno": "(037)227165",
    "Address": "苗栗縣苗栗市水源里11鄰水流娘15-3號1樓"
}, {
    "POIID": "180104",
    "POIName": "龍躍",
    "Telno": "(037)361706",
    "Address": "苗栗縣苗栗市新川里圓墩路28號"
}, {
    "POIID": "115867",
    "POIName": "鑫正發",
    "Telno": "(037)333281",
    "Address": "苗栗縣苗栗市正發路196號"
}, ], [{
    "POIID": "110666",
    "POIName": "天文",
    "Telno": "(037)633952",
    "Address": "苗栗縣竹南鎮天文路176號"
}, {
    "POIID": "188854",
    "POIName": "仟翔",
    "Telno": "(037)484318",
    "Address": "苗栗縣竹南鎮龍山路2段275號"
}, {
    "POIID": "111854",
    "POIName": "布洛瓦",
    "Telno": "(037)584419",
    "Address": "苗栗縣竹南鎮科東三路12號"
}, {
    "POIID": "120537",
    "POIName": "弘運",
    "Telno": "(037)550537",
    "Address": "苗栗縣竹南鎮守法街3-2號3-3號3-5號1樓"
}, {
    "POIID": "138295",
    "POIName": "光南",
    "Telno": "(037)464661",
    "Address": "苗栗縣竹南鎮光復路265號1樓"
}, {
    "POIID": "181679",
    "POIName": "圳營",
    "Telno": "(037)477965",
    "Address": "苗栗縣竹南鎮中正路114號1樓"
}, {
    "POIID": "116169",
    "POIName": "竹南和興",
    "Telno": "(037)582482",
    "Address": "苗栗縣竹南鎮大埔里和興路191-1號"
}, {
    "POIID": "139368",
    "POIName": "竹南建國",
    "Telno": "(037)461793",
    "Address": "苗栗縣竹南鎮龍鳳里龍山路1段162號1樓"
}, {
    "POIID": "166315",
    "POIName": "科七",
    "Telno": "(037)587193",
    "Address": "苗栗縣竹南鎮科專七路396號1樓"
}, {
    "POIID": "991296",
    "POIName": "展宏",
    "Telno": "(037)684874",
    "Address": "苗栗縣竹南鎮中華路169號171號1樓"
}, {
    "POIID": "921552",
    "POIName": "海福",
    "Telno": "(037)466511",
    "Address": "苗栗縣竹南鎮海口里街86號"
}, {
    "POIID": "967064",
    "POIName": "真開",
    "Telno": "(037)482127",
    "Address": "苗栗縣竹南鎮大厝里開元路412號1樓"
}, {
    "POIID": "963187",
    "POIName": "晟乾",
    "Telno": "(037)582294",
    "Address": "苗栗縣竹南鎮仁愛路902號"
}, {
    "POIID": "137557",
    "POIName": "國豪",
    "Telno": "(037)470992",
    "Address": "苗栗縣竹南鎮延平路170號"
}, {
    "POIID": "175076",
    "POIName": "統寶",
    "Telno": "(037)580641",
    "Address": "苗栗縣竹南鎮科中路12號B2"
}, {
    "POIID": "188142",
    "POIName": "群創",
    "Telno": "(037)582940",
    "Address": "苗栗縣竹南鎮頂埔里科學路160號1樓"
}, {
    "POIID": "138837",
    "POIName": "廣沅",
    "Telno": "(037)585521",
    "Address": "苗栗縣竹南鎮公義里公義路1683號1685號1樓"
}, {
    "POIID": "882080",
    "POIName": "慶竹",
    "Telno": "(037)480406",
    "Address": "苗栗縣竹南鎮民族路82號民權路47號"
}, {
    "POIID": "167813",
    "POIName": "龍昇",
    "Telno": "(037)463595",
    "Address": "苗栗縣竹南鎮龍山路二段120號"
}, {
    "POIID": "121080",
    "POIName": "龍宸",
    "Telno": "(037)466904",
    "Address": "苗栗縣竹南鎮營盤里博愛街367號1樓"
}, {
    "POIID": "951863",
    "POIName": "龍詮",
    "Telno": "(037)611551",
    "Address": "苗栗縣竹南鎮山佳里龍山路三段305號"
}, {
    "POIID": "964858",
    "POIName": "龍鳳",
    "Telno": "(037)483823",
    "Address": "苗栗縣竹南鎮龍鳳里龍江街25號"
}, {
    "POIID": "923385",
    "POIName": "環竹",
    "Telno": "(037)463644",
    "Address": "苗栗縣竹南鎮環市路1段16號"
}, ], [{
    "POIID": "120021",
    "POIName": "大山",
    "Telno": "(037)432540",
    "Address": "苗栗縣後龍鎮大山里龍文路6號1樓"
}, {
    "POIID": "166290",
    "POIName": "苗栗高",
    "Telno": "(037)725775",
    "Address": "苗栗縣後龍鎮新東路468號"
}, {
    "POIID": "182694",
    "POIName": "苗龍",
    "Telno": "(037)729203",
    "Address": "苗栗縣後龍鎮造豐路333號"
}, {
    "POIID": "942364",
    "POIName": "新裕龍",
    "Telno": "(037)721202",
    "Address": "苗栗縣後龍鎮中華路52-8號"
}, {
    "POIID": "130512",
    "POIName": "龍日",
    "Telno": "(037)732881",
    "Address": "苗栗縣後龍鎮溪洲里七鄰勝利路60之1號"
}, {
    "POIID": "188049",
    "POIName": "龍庄",
    "Telno": "(037)729105",
    "Address": "苗栗縣後龍鎮大庄里成功路207號"
}, {
    "POIID": "963073",
    "POIName": "龍坑",
    "Telno": "(037)723758",
    "Address": "苗栗縣後龍鎮龍坑里16鄰156號之10"
}, {
    "POIID": "130121",
    "POIName": "鑫龍",
    "Telno": "(037)720945",
    "Address": "苗栗縣後龍鎮中山路53號"
}, ], [{
    "POIID": "123422",
    "POIName": "中群",
    "Telno": "(037)684526",
    "Address": "苗栗縣頭份市中正路319號1樓"
}, {
    "POIID": "155315",
    "POIName": "正合",
    "Telno": "(037)690551",
    "Address": "苗栗縣頭份市中正一路58號1F"
}, {
    "POIID": "112857",
    "POIName": "永和山",
    "Telno": "(037)692143",
    "Address": "苗栗縣頭份市水源路206號1樓"
}, {
    "POIID": "931825",
    "POIName": "尖豐",
    "Telno": "(037)616773",
    "Address": "苗栗縣頭份市尖山里尖豐路320巷316號1樓"
}, {
    "POIID": "148720",
    "POIName": "宏恩",
    "Telno": "(037)692273",
    "Address": "苗栗縣頭份市中正路2號"
}, {
    "POIID": "924470",
    "POIName": "信東",
    "Telno": "(037)692583",
    "Address": "苗栗縣頭份市忠孝里12鄰信東路158號"
}, {
    "POIID": "144854",
    "POIName": "建鑫",
    "Telno": "(037)695417",
    "Address": "苗栗縣頭份市建國路86號1樓"
}, {
    "POIID": "958819",
    "POIName": "後庄",
    "Telno": "(037)674612",
    "Address": "苗栗縣頭份市中央路603-605號"
}, {
    "POIID": "113137",
    "POIName": "珊湖",
    "Telno": "(037)603252",
    "Address": "苗栗縣頭份市中正三路271號1樓及親民路1號3號1樓"
}, {
    "POIID": "174589",
    "POIName": "貞永",
    "Telno": "(037)634588",
    "Address": "苗栗縣頭份市永貞路二段1號"
}, {
    "POIID": "121367",
    "POIName": "貞豪",
    "Telno": "(037)635612",
    "Address": "苗栗縣頭份市永貞路一段128號1樓"
}, {
    "POIID": "943909",
    "POIName": "昶誼",
    "Telno": "(037)676674",
    "Address": "苗栗縣頭份市後庄里幼英街131號1樓"
}, {
    "POIID": "980827",
    "POIName": "得意",
    "Telno": "(037)675801",
    "Address": "苗栗縣頭份市蟠桃里德義路13鄰81號"
}, {
    "POIID": "933164",
    "POIName": "淇丞",
    "Telno": "(037)673025",
    "Address": "苗栗縣頭份市建國路2段128號"
}, {
    "POIID": "120401",
    "POIName": "鈞吉",
    "Telno": "(037)672445",
    "Address": "苗栗縣頭份市成功里11鄰建國路198號1樓"
}, {
    "POIID": "121552",
    "POIName": "新華",
    "Telno": "(037)672649",
    "Address": "苗栗縣頭份市中華路755號及民生街2號"
}, {
    "POIID": "991377",
    "POIName": "新頭高",
    "Telno": "(037)696421",
    "Address": "苗栗縣頭份市中華路1156號1樓"
}, {
    "POIID": "910116",
    "POIName": "煥日",
    "Telno": "(037)591977",
    "Address": "苗栗縣頭份市新華里中正一路554號556號"
}, {
    "POIID": "981510",
    "POIName": "慶丞",
    "Telno": "(037)596428",
    "Address": "苗栗縣頭份市合興里信義路14鄰381號"
}, {
    "POIID": "130958",
    "POIName": "興德",
    "Telno": "(037)661171",
    "Address": "苗栗縣頭份市文化街172號八德二路292號 1樓"
}, {
    "POIID": "170554",
    "POIName": "頭份",
    "Telno": "(037)593250",
    "Address": "苗栗縣頭份市中正路232號"
}, {
    "POIID": "142397",
    "POIName": "頭興",
    "Telno": "(037)674661",
    "Address": "苗栗縣頭份市中央路228號230號1樓"
}, {
    "POIID": "173634",
    "POIName": "龍仁",
    "Telno": "(037)688211",
    "Address": "苗栗縣頭份區中華路968-974號"
}, ], [{
    "POIID": "923167",
    "POIName": "大坪",
    "Telno": "(037)544653",
    "Address": "苗栗縣造橋鄉十字路16號"
}, {
    "POIID": "913034",
    "POIName": "育大",
    "Telno": "(037)651855",
    "Address": "苗栗縣造橋鄉學府路100號"
}, ], [{
    "POIID": "164515",
    "POIName": "三灣",
    "Telno": "(037)834838",
    "Address": "苗栗縣三灣鄉中正路255號與文化街13號"
}, ], [{
    "POIID": "141143",
    "POIName": "象山",
    "Telno": "(037)255838",
    "Address": "苗栗縣頭屋鄉象山村象山路239之1號"
}, {
    "POIID": "110758",
    "POIName": "頭屋",
    "Telno": "(037)251643",
    "Address": "苗栗縣頭屋鄉尖豐路118號120號1樓"
}, ], [{
    "POIID": "122658",
    "POIName": "田野",
    "Telno": "(037)834841",
    "Address": "苗栗縣南庄鄉員林村下員林2鄰68-10號"
}, {
    "POIID": "950284",
    "POIName": "新南庄",
    "Telno": "(037)822488",
    "Address": "苗栗縣南庄鄉西村中正路7號9號1樓"
}, ], [{
    "POIID": "141154",
    "POIName": "大大",
    "Telno": "(037)229711",
    "Address": "苗栗縣公館鄉大同路160號162號1樓"
}, {
    "POIID": "155533",
    "POIName": "東館",
    "Telno": "(037)227942",
    "Address": "苗栗縣公館鄉五谷村12鄰71之1號1樓"
}, {
    "POIID": "165242",
    "POIName": "苗谷",
    "Telno": "(037)239684",
    "Address": "苗栗縣公館鄉五谷村200號"
}, {
    "POIID": "923835",
    "POIName": "館南",
    "Telno": "(037)236443",
    "Address": "苗栗縣公館鄉通明街68號"
}, {
    "POIID": "941925",
    "POIName": "館福",
    "Telno": "(037)236205",
    "Address": "苗栗縣公館鄉館南村館南路216-2號"
}, ], [{
    "POIID": "911647",
    "POIName": "白沙屯",
    "Telno": "(037)791746",
    "Address": "苗栗縣通霄鎮白東里白東100號"
}, {
    "POIID": "966636",
    "POIName": "金金",
    "Telno": "(037)761975",
    "Address": "苗栗縣通霄鎮內湖里17鄰內湖165-8號"
}, {
    "POIID": "997973",
    "POIName": "通宏",
    "Telno": "(037)759112",
    "Address": "苗栗縣通霄鎮通西里中正路83之5號"
}, {
    "POIID": "882563",
    "POIName": "通霄",
    "Telno": "(037)760451",
    "Address": "苗栗縣通霄鎮中正路19號"
}, {
    "POIID": "921769",
    "POIName": "通館",
    "Telno": "(037)764476",
    "Address": "苗栗縣通霄鎮通西里中山路10號"
}, ], [{
    "POIID": "932105",
    "POIName": "山腳",
    "Telno": "(037)745613",
    "Address": "苗栗縣苑裡鎮山腳里七鄰山腳157號"
}, {
    "POIID": "953272",
    "POIName": "田馨",
    "Telno": "(037)854380",
    "Address": "苗栗縣苑裡鎮田心里田心段36之3號"
}, {
    "POIID": "137638",
    "POIName": "客庄",
    "Telno": "(037)862097",
    "Address": "苗栗縣苑裡鎮客庄里客庄90-20號"
}, {
    "POIID": "131353",
    "POIName": "新和苑",
    "Telno": "(037)855563",
    "Address": "苗栗縣苑裡鎮苑南里為公路4鄰16之1號1樓"
}, {
    "POIID": "138516",
    "POIName": "新苑",
    "Telno": "(037)863031",
    "Address": "苗栗縣苑裡鎮苑北里為公路70號"
}, {
    "POIID": "971410",
    "POIName": "鈺田",
    "Telno": "(037)743258",
    "Address": "苗栗縣苑裡鎮山柑里2-2號"
}, ], [{
    "POIID": "158727",
    "POIName": "大銅",
    "Telno": "(037)985886",
    "Address": "苗栗縣銅鑼鄉中正路6-25號"
}, {
    "POIID": "957322",
    "POIName": "銅利",
    "Telno": "(037)239187",
    "Address": "苗栗縣銅鑼鄉中興一街1號"
}, {
    "POIID": "990950",
    "POIName": "銅鑼",
    "Telno": "(037)983418",
    "Address": "苗栗縣銅鑼鄉銅鑼村中正路173號1樓"
}, ], [{
    "POIID": "167684",
    "POIName": "酒莊",
    "Telno": "(037)997857",
    "Address": "苗栗縣大湖鄉富興村9鄰八寮灣2之11號"
}, {
    "POIID": "873020",
    "POIName": "菁英",
    "Telno": "(037)995624",
    "Address": "苗栗縣大湖鄉明湖村中正路107號"
}, {
    "POIID": "153607",
    "POIName": "新雪霸",
    "Telno": "(037)992824",
    "Address": "苗栗縣大湖鄉富興村1鄰水尾39號"
}, ], [{
    "POIID": "870766",
    "POIName": "三義",
    "Telno": "(037)876099",
    "Address": "苗栗縣三義鄉中正路118號"
}, {
    "POIID": "873215",
    "POIName": "龍邦",
    "Telno": "(037)870441",
    "Address": "苗栗縣三義鄉勝興村水美街315之8號9號"
}, ], [{
    "POIID": "167329",
    "POIName": "新卓蘭",
    "Telno": "(04)25897961",
    "Address": "苗栗縣卓蘭鎮興南街318號"
}, {
    "POIID": "116480",
    "POIName": "豪麥",
    "Telno": "(04)25899467",
    "Address": "苗栗縣卓蘭鎮中山路48號之4"
}, ], ], [[{
    "POIID": "997766",
    "POIName": "三豐路",
    "Telno": "(04)25247784",
    "Address": "台中市豐原區三豐路909號"
}, {
    "POIID": "881814",
    "POIName": "水豐",
    "Telno": "(04)25390920",
    "Address": "台中市豐原區鐮村路462號"
}, {
    "POIID": "903288",
    "POIName": "京展",
    "Telno": "(04)25158368",
    "Address": "台中市豐原區中正路858號1樓"
}, {
    "POIID": "893725",
    "POIName": "京泰",
    "Telno": "(04)25123668",
    "Address": "台中市豐原區成功路195號"
}, {
    "POIID": "910530",
    "POIName": "京達",
    "Telno": "(04)25158358",
    "Address": "台中市豐原區中正路805號"
}, {
    "POIID": "953755",
    "POIName": "東洲",
    "Telno": "(04)25285663",
    "Address": "台中市豐原區豐原大道7段488號"
}, {
    "POIID": "149505",
    "POIName": "欣三豐",
    "Telno": "(04)25285477",
    "Address": "台中市豐原區源豐路89號"
}, {
    "POIID": "943851",
    "POIName": "直興",
    "Telno": "(04)25154228",
    "Address": "台中市豐原區水源路695號"
}, {
    "POIID": "182199",
    "POIName": "保康",
    "Telno": "(04)25130718",
    "Address": "台中市豐原區保康路160號"
}, {
    "POIID": "891914",
    "POIName": "茂陽",
    "Telno": "(04)25268191",
    "Address": "台中市豐原區南陽路299之8號299之9號"
}, {
    "POIID": "125118",
    "POIName": "晉豐",
    "Telno": "(04)25342864",
    "Address": "台中市豐原區西勢路425號"
}, {
    "POIID": "113333",
    "POIName": "翁子",
    "Telno": "(04)25132013",
    "Address": "台中市豐原區豐勢路一段669號一樓"
}, {
    "POIID": "174394",
    "POIName": "康泰",
    "Telno": "(04)25297271",
    "Address": "台中市豐原區安康路34號36號38號"
}, {
    "POIID": "116790",
    "POIName": "甜心",
    "Telno": "(04)25273695",
    "Address": "台中市豐原區圓環東路168號"
}, {
    "POIID": "883326",
    "POIName": "新豐民",
    "Telno": "(04)25209750",
    "Address": "台中市豐原區三民路93號1樓"
}, {
    "POIID": "883913",
    "POIName": "新豐田",
    "Telno": "(04)25151215",
    "Address": "台中市豐原區豐南街145號"
}, {
    "POIID": "982292",
    "POIName": "新豐喜",
    "Telno": "(04)25298405",
    "Address": "台中市豐原區南陽路127號1樓"
}, {
    "POIID": "922304",
    "POIName": "新豐興",
    "Telno": "(04)25297609",
    "Address": "台中市豐原區東勢里中興路57號"
}, {
    "POIID": "972929",
    "POIName": "新豐寶",
    "Telno": "(04)25299253",
    "Address": "台中市豐原區中山路143-2號1樓"
}, {
    "POIID": "890003",
    "POIName": "瑞彬",
    "Telno": "(04)25281288",
    "Address": "台中市豐原區西安街68號"
}, {
    "POIID": "967765",
    "POIName": "瑞慶",
    "Telno": "(04)25293116",
    "Address": "台中市豐原區豐原大道3段261號"
}, {
    "POIID": "187747",
    "POIName": "瑞興",
    "Telno": "(04)25281213",
    "Address": "台中市豐原區中正路497號"
}, {
    "POIID": "890036",
    "POIName": "葫蘆墩",
    "Telno": "(04)25250701",
    "Address": "台中市豐原區水源路127-1號"
}, {
    "POIID": "951586",
    "POIName": "萳陽",
    "Telno": "(04)25297014",
    "Address": "台中市豐原區南陽路480號"
}, {
    "POIID": "132459",
    "POIName": "豐三民",
    "Telno": "(04)25220935",
    "Address": "台中市豐原區三民路38號1樓"
}, {
    "POIID": "141316",
    "POIName": "豐王",
    "Telno": "(04)25298813",
    "Address": "台中市豐原區三豐路940號1樓"
}, {
    "POIID": "822424",
    "POIName": "豐正",
    "Telno": "(04)25290142",
    "Address": "台中市豐原區中正路16號18號"
}, {
    "POIID": "138284",
    "POIName": "豐光",
    "Telno": "(04)25254437",
    "Address": "台中市豐原區中山路581號583號"
}, {
    "POIID": "886392",
    "POIName": "豐后",
    "Telno": "(04)25220527",
    "Address": "台中市豐原區三豐路690號692號"
}, {
    "POIID": "122809",
    "POIName": "豐村",
    "Telno": "(04)25297481",
    "Address": "台中市豐原區南村里豐東路412號416號1樓"
}, {
    "POIID": "981657",
    "POIName": "豐尚",
    "Telno": "(04)25158471",
    "Address": "台中市豐原區豐勢路二段680號一樓"
}, {
    "POIID": "800125",
    "POIName": "豐東",
    "Telno": "(04)25280312",
    "Address": "台中市豐原區豐東路218號"
}, {
    "POIID": "854742",
    "POIName": "豐信",
    "Telno": "(04)25270791",
    "Address": "台中市豐原區復興路75號信義街77號"
}, {
    "POIID": "992222",
    "POIName": "豐勇",
    "Telno": "(04)25156415",
    "Address": "台中市豐原區豐中路125號127號129號"
}, {
    "POIID": "142216",
    "POIName": "豐科",
    "Telno": "(04)25251821",
    "Address": "台中市豐原區豐原大道七段381號1樓"
}, {
    "POIID": "179665",
    "POIName": "豐原站",
    "Telno": "(04)25132221",
    "Address": "台中市豐原區中正路1-1號1樓"
}, {
    "POIID": "954138",
    "POIName": "豐原道",
    "Telno": "(04)25151463",
    "Address": "台中市豐原區水源路307號"
}, {
    "POIID": "160225",
    "POIName": "豐泰",
    "Telno": "(04)25281143",
    "Address": "台中市豐原區豐勢路二段396號"
}, {
    "POIID": "161620",
    "POIName": "豐陽",
    "Telno": "(04)25287340",
    "Address": "台中市豐原區南陽路372號"
}, {
    "POIID": "952235",
    "POIName": "豐環",
    "Telno": "(04)25254624",
    "Address": "台中市豐原區豐原大道1段370號"
}, {
    "POIID": "131180",
    "POIName": "豐贊",
    "Telno": "(04)25721074",
    "Address": "台中市豐原區豐勢路二段979號1樓"
}, {
    "POIID": "119803",
    "POIName": "豐鑫",
    "Telno": "(04)25235475",
    "Address": "台中市豐原區向陽路276號"
}, ], [{
    "POIID": "173520",
    "POIName": "市鑫",
    "Telno": "(04)22255056",
    "Address": "台中市中區自由路二段9號1樓"
}, {
    "POIID": "136521",
    "POIName": "地球村",
    "Telno": "(04)22235330",
    "Address": "台中市中區中山里中山路2號"
}, {
    "POIID": "149608",
    "POIName": "成興",
    "Telno": "(04)22258097",
    "Address": "台中市中區成功路271號1樓"
}, {
    "POIID": "185741",
    "POIName": "東平驛",
    "Telno": "(04)22298340",
    "Address": "台中市中區台灣大道一段531號"
}, {
    "POIID": "170233",
    "POIName": "第一廣場",
    "Telno": "(04)22236627",
    "Address": "台中市中區台灣大道一段35號"
}, {
    "POIID": "123042",
    "POIName": "新繼光",
    "Telno": "(04)22207425",
    "Address": "台中市中區中山路69號1樓"
}, {
    "POIID": "135551",
    "POIName": "鼎站",
    "Telno": "(04)22264467",
    "Address": "台中市中區建國路202號"
}, {
    "POIID": "158842",
    "POIName": "錦花",
    "Telno": "(04)22230402",
    "Address": "台中市中區光復路127號"
}, {
    "POIID": "991805",
    "POIName": "聯華",
    "Telno": "(04)22267149",
    "Address": "台中市中區公園路13號"
}, {
    "POIID": "183675",
    "POIName": "聯鑫",
    "Telno": "(04)22298432",
    "Address": "台中市中區建國路143.145號"
}, {
    "POIID": "970864",
    "POIName": "鑫華新",
    "Telno": "(04)22293905",
    "Address": "台中市中區中華里中華路一段75號77號及民族路218號"
}, ], [{
    "POIID": "180838",
    "POIName": "十九甲",
    "Telno": "(04)24835542",
    "Address": "台中市大里區東昇里新仁路二段92號"
}, {
    "POIID": "175054",
    "POIName": "大明",
    "Telno": "(04)24850579",
    "Address": "台中市大里區中興路2段833號835號"
}, {
    "POIID": "181314",
    "POIName": "大金",
    "Telno": "(04)24964085",
    "Address": "台中市大里區中興路一段255號"
}, {
    "POIID": "880822",
    "POIName": "大峰",
    "Telno": "(04)24954806",
    "Address": "台中市大里區大峰路167號"
}, {
    "POIID": "905424",
    "POIName": "大道",
    "Telno": "(04)24962420",
    "Address": "台中市大里區仁化里至善路188號"
}, {
    "POIID": "971041",
    "POIName": "大衛",
    "Telno": "(04)24070776",
    "Address": "台中市大里區國中路276號"
}, {
    "POIID": "188740",
    "POIName": "中城",
    "Telno": "(04)24966827",
    "Address": "台中市大里區中興路一段328號"
}, {
    "POIID": "970565",
    "POIName": "中湖",
    "Telno": "(04)24952746",
    "Address": "台中市大里區中興路一段292之11及292之12號"
}, {
    "POIID": "142995",
    "POIName": "仁化",
    "Telno": "(04)24964332",
    "Address": "台中市大里區仁化路657號"
}, {
    "POIID": "145031",
    "POIName": "元百",
    "Telno": "(04)24962475",
    "Address": "台中市大里區成功路512號516號"
}, {
    "POIID": "189709",
    "POIName": "巧聖",
    "Telno": "(04)24821505",
    "Address": "台中市大里區西榮里益民路二段137號"
}, {
    "POIID": "946850",
    "POIName": "永隆",
    "Telno": "(04)24074438",
    "Address": "台中市大里區大明路457號"
}, {
    "POIID": "127066",
    "POIName": "玉豐",
    "Telno": "(04)24823982",
    "Address": "台中市大里區東榮路483號"
}, {
    "POIID": "890704",
    "POIName": "立新",
    "Telno": "(04)22798641",
    "Address": "台中市大里區立仁路142號"
}, {
    "POIID": "931434",
    "POIName": "里德",
    "Telno": "(04)24851020",
    "Address": "台中市大里區德芳南路211號"
}, {
    "POIID": "885780",
    "POIName": "東里",
    "Telno": "(04)24060269",
    "Address": "台中市大里區大里路295號"
}, {
    "POIID": "936185",
    "POIName": "東富",
    "Telno": "(04)24823721",
    "Address": "台中市大里區東榮路282號"
}, {
    "POIID": "150952",
    "POIName": "宥辰",
    "Telno": "(04)22760520",
    "Address": "台中市大里區立新街350號"
}, {
    "POIID": "170635",
    "POIName": "美群",
    "Telno": "(04)24950645",
    "Address": "台中市大里區美群路60號"
}, {
    "POIID": "998013",
    "POIName": "修平",
    "Telno": "(04)24917541",
    "Address": "台中市大里區工業二路100號"
}, {
    "POIID": "874296",
    "POIName": "益民",
    "Telno": "(04)24815624",
    "Address": "台中市大里區東興里10鄰大明路238號"
}, {
    "POIID": "810018",
    "POIName": "草湖",
    "Telno": "(04)24927373",
    "Address": "台中市大里區中興路1段11之6號"
}, {
    "POIID": "131087",
    "POIName": "國光",
    "Telno": "(04)24064271",
    "Address": "台中市大里區國光路二段257號"
}, {
    "POIID": "111979",
    "POIName": "喬城",
    "Telno": "(04)22809095",
    "Address": "台中市大里區大智路567號"
}, {
    "POIID": "893345",
    "POIName": "新仁華",
    "Telno": "(04)24914732",
    "Address": "台中市大里區仁化路460號"
}, {
    "POIID": "165035",
    "POIName": "新永大",
    "Telno": "(04)24823074",
    "Address": "台中市大里區大明路340號1樓"
}, {
    "POIID": "153722",
    "POIName": "新里",
    "Telno": "(04)24838467",
    "Address": "台中市大里區中興路2段480號"
}, {
    "POIID": "980207",
    "POIName": "新堤",
    "Telno": "(04)22759206",
    "Address": "台中市大里區立德里甲堤南路71號"
}, {
    "POIID": "182764",
    "POIName": "新榮",
    "Telno": "(04)24062770",
    "Address": "台中市大里區東榮路552號"
}, {
    "POIID": "111027",
    "POIName": "瑞城",
    "Telno": "(04)24963006",
    "Address": "台中市大里區瑞城一街1號"
}, {
    "POIID": "954585",
    "POIName": "樹王",
    "Telno": "(04)24077449",
    "Address": "台中市大里區文心南路1252號"
}, {
    "POIID": "130235",
    "POIName": "興生",
    "Telno": "(04)24831710",
    "Address": "台中市大里區大里路95號97號1樓"
}, {
    "POIID": "112204",
    "POIName": "興城",
    "Telno": "(04)24936537",
    "Address": "台中市大里區塗城路765號"
}, ], [{
    "POIID": "147129",
    "POIName": "中農",
    "Telno": "(04)22806276",
    "Address": "台中市東區台中路195號197號199號"
}, {
    "POIID": "181565",
    "POIName": "世界",
    "Telno": "(04)22134376",
    "Address": "台中市東區十甲路202號"
}, {
    "POIID": "923307",
    "POIName": "光園",
    "Telno": "(04)22800510",
    "Address": "台中市東區東光園路142號"
}, {
    "POIID": "971742",
    "POIName": "東泓",
    "Telno": "(04)22809073",
    "Address": "台中市東區東門里東門路140號"
}, {
    "POIID": "969026",
    "POIName": "東英",
    "Telno": "(04)22139200",
    "Address": "台中市東區自由路四段339號"
}, {
    "POIID": "977256",
    "POIName": "建智",
    "Telno": "(04)22817953",
    "Address": "台中市東區建成路668號"
}, {
    "POIID": "113425",
    "POIName": "富仁",
    "Telno": "(04)22133717",
    "Address": "台中市東區富榮街2號1樓"
}, {
    "POIID": "164571",
    "POIName": "富麗",
    "Telno": "(04)22123172",
    "Address": "台中市東區十甲里十甲路397號"
}, {
    "POIID": "976208",
    "POIName": "復大",
    "Telno": "(04)22201952",
    "Address": "台中市東區復興路四段231-5號231-6號1樓"
}, {
    "POIID": "958277",
    "POIName": "進德",
    "Telno": "(04)22138518",
    "Address": "台中市東區自由路3段226號及進德路77號"
}, {
    "POIID": "972745",
    "POIName": "新平智",
    "Telno": "(04)22297551",
    "Address": "台中市東區新庄里大智路49號"
}, {
    "POIID": "845612",
    "POIName": "新立德",
    "Telno": "(04)22202225",
    "Address": "台中市東區復興路4段4號台中路45號"
}, {
    "POIID": "164582",
    "POIName": "新振興",
    "Telno": "(04)22153224",
    "Address": "台中市東區十甲東路217號"
}, {
    "POIID": "111142",
    "POIName": "漢溪",
    "Telno": "(04)22139779",
    "Address": "台中市東區十甲東路575號1樓"
}, {
    "POIID": "913643",
    "POIName": "福明",
    "Telno": "(04)22135826",
    "Address": "台中市東區進化路170號1樓"
}, {
    "POIID": "164146",
    "POIName": "綠都",
    "Telno": "(04)22123831",
    "Address": "台中市東區自由路三段169-1號"
}, {
    "POIID": "110172",
    "POIName": "樂東",
    "Telno": "(04)22139547",
    "Address": "台中市東區東英路331號"
}, {
    "POIID": "872957",
    "POIName": "樂業",
    "Telno": "(04)22134683",
    "Address": "台中市東區樂業路259號"
}, ], [{
    "POIID": "171074",
    "POIName": "大東家",
    "Telno": "(04)22214273",
    "Address": "台中市南區新榮里復興路3段140號"
}, {
    "POIID": "136130",
    "POIName": "大時代",
    "Telno": "(04)22609203",
    "Address": "台中市南區工學路55號57號"
}, {
    "POIID": "130811",
    "POIName": "台火",
    "Telno": "(04)22600615",
    "Address": "台中市南區高工路355號1樓"
}, {
    "POIID": "146089",
    "POIName": "民主",
    "Telno": "(04)22234962",
    "Address": "台中市南區復興路3段322號324號326號"
}, {
    "POIID": "114303",
    "POIName": "生活",
    "Telno": "(04)22603843",
    "Address": "台中市南區復興路2段71巷70號1樓及忠明南路730巷17號1樓"
}, {
    "POIID": "118969",
    "POIName": "光輝",
    "Telno": "(04)23754586",
    "Address": "台中市南區美村路二段79號81號1F"
}, {
    "POIID": "166027",
    "POIName": "百祐",
    "Telno": "(04)22651641",
    "Address": "台中市南區美村路二段188號190號1樓"
}, {
    "POIID": "140726",
    "POIName": "宜寧",
    "Telno": "(04)22605645",
    "Address": "台中市南區東興路一段21號1樓"
}, {
    "POIID": "990765",
    "POIName": "明樓",
    "Telno": "(04)22809432",
    "Address": "台中市南區明德街84號(校內店)"
}, {
    "POIID": "181244",
    "POIName": "明興",
    "Telno": "(04)22654252",
    "Address": "台中市南區忠明南路929號"
}, {
    "POIID": "991861",
    "POIName": "長億",
    "Telno": "(04)22653820",
    "Address": "台中市南區工學路108號"
}, {
    "POIID": "920892",
    "POIName": "南美",
    "Telno": "(04)22650922",
    "Address": "台中市南區南平路182號"
}, {
    "POIID": "174822",
    "POIName": "高工",
    "Telno": "(04)22634012",
    "Address": "台中市南區高工路168號1樓"
}, {
    "POIID": "911290",
    "POIName": "頂橋",
    "Telno": "(04)22857908",
    "Address": "台中市南區興大路338號340號"
}, {
    "POIID": "860541",
    "POIName": "復慶",
    "Telno": "(04)22638927",
    "Address": "台中市南區樹義里大慶街二段5-2號"
}, {
    "POIID": "922913",
    "POIName": "無尾熊",
    "Telno": "(04)22605412",
    "Address": "台中市南區德富路73號"
}, {
    "POIID": "112237",
    "POIName": "詠權",
    "Telno": "(04)22655461",
    "Address": "台中市南區五權南路527號"
}, {
    "POIID": "950963",
    "POIName": "雅典",
    "Telno": "(04)23787407",
    "Address": "台中市南區三民西路377號西川一路1號"
}, {
    "POIID": "118796",
    "POIName": "新國光",
    "Telno": "(04)22203755",
    "Address": "台中市南區國光路82及84號;愛國街69號"
}, {
    "POIID": "112628",
    "POIName": "新學和",
    "Telno": "(04)22856891",
    "Address": "台中市南區學府路70號70-1號72號1樓"
}, {
    "POIID": "151140",
    "POIName": "義興",
    "Telno": "(04)22602308",
    "Address": "台中市南區復興路一段128號"
}, {
    "POIID": "912743",
    "POIName": "福田",
    "Telno": "(04)22612900",
    "Address": "台中市南區文心南路885號"
}, {
    "POIID": "982225",
    "POIName": "慶樹",
    "Telno": "(04)22609823",
    "Address": "台中市南區樹德里大慶街2段36號"
}, {
    "POIID": "127583",
    "POIName": "興大",
    "Telno": "(04)22814276",
    "Address": "台中市南區國光路301號"
}, {
    "POIID": "181624",
    "POIName": "興惠",
    "Telno": "(04)22850793",
    "Address": "台中市南區國光路250號"
}, {
    "POIID": "118545",
    "POIName": "興學",
    "Telno": "(04)22857397",
    "Address": "台中市南區學府路64號"
}, {
    "POIID": "186054",
    "POIName": "聯信",
    "Telno": "(04)22853023",
    "Address": "台中市南區建成路1107號1樓"
}, {
    "POIID": "187448",
    "POIName": "權貴",
    "Telno": "(04)22617268",
    "Address": "台中市南區五權南路189號"
}, {
    "POIID": "980931",
    "POIName": "鑫廣",
    "Telno": "(04)22650986",
    "Address": "台中市南區福順里忠明南路787號"
}, ], [{
    "POIID": "126306",
    "POIName": "一江橋",
    "Telno": "(04)22770154",
    "Address": "台中市太平區東平路1號"
}, {
    "POIID": "190536",
    "POIName": "大榮",
    "Telno": "(04)22703976",
    "Address": "台中市太平區中興東路189號191號"
}, {
    "POIID": "146388",
    "POIName": "丰太",
    "Telno": "(04)23510560",
    "Address": "台中市太平區永豐路351號1樓"
}, {
    "POIID": "895695",
    "POIName": "太平",
    "Telno": "(04)22770941",
    "Address": "台中市太平區中興路171號"
}, {
    "POIID": "890416",
    "POIName": "太隆",
    "Telno": "(04)22716192",
    "Address": "台中市太平區德隆里工業路148號150號"
}, {
    "POIID": "993122",
    "POIName": "功興",
    "Telno": "(04)22769121",
    "Address": "台中市太平區建興路47號"
}, {
    "POIID": "142799",
    "POIName": "光隆",
    "Telno": "(04)22770849",
    "Address": "台中市太平區光興路707號"
}, {
    "POIID": "138088",
    "POIName": "光興",
    "Telno": "(04)22793598",
    "Address": "台中市太平區興隆里12鄰光興路1632號"
}, {
    "POIID": "910079",
    "POIName": "全利",
    "Telno": "(04)23926723",
    "Address": "台中市太平區樹孝路338號"
}, {
    "POIID": "164272",
    "POIName": "吉仕多",
    "Telno": "(04)23957784",
    "Address": "台中市太平區樹德路255號"
}, {
    "POIID": "174431",
    "POIName": "旱溪東",
    "Telno": "(04)23955934",
    "Address": "台中市太平區中山路四段235號"
}, {
    "POIID": "167248",
    "POIName": "育智",
    "Telno": "(04)23958492",
    "Address": "台中市太平區育賢路520號"
}, {
    "POIID": "143378",
    "POIName": "育鑫",
    "Telno": "(04)23910301",
    "Address": "台中市太平區樹孝路490號"
}, {
    "POIID": "881663",
    "POIName": "宜昌",
    "Telno": "(04)22735742",
    "Address": "台中市太平區宜昌路400號"
}, {
    "POIID": "123569",
    "POIName": "尚晉",
    "Telno": "(04)23911323",
    "Address": "台中市太平區新平路三段1號1樓"
}, {
    "POIID": "151520",
    "POIName": "東村",
    "Telno": "(04)23511075",
    "Address": "台中市太平區東村路200號"
}, {
    "POIID": "170451",
    "POIName": "金興",
    "Telno": "(04)23957220",
    "Address": "台中市太平區新興路312號"
}, {
    "POIID": "174604",
    "POIName": "長德",
    "Telno": "(04)22798640",
    "Address": "台中市太平區長億里永成北路125號"
}, {
    "POIID": "901525",
    "POIName": "紅億",
    "Telno": "(04)22715793",
    "Address": "台中市太平區光興路572號576號"
}, {
    "POIID": "151553",
    "POIName": "振福",
    "Telno": "(04)23954715",
    "Address": "台中市太平區振福路419號421號423號425號"
}, {
    "POIID": "930109",
    "POIName": "盛民興",
    "Telno": "(04)23926373",
    "Address": "台中市太平區中山路二段366號366-1號368號"
}, {
    "POIID": "840488",
    "POIName": "第一",
    "Telno": "(04)23957421",
    "Address": "台中市太平區中山路四段112-2號"
}, {
    "POIID": "174349",
    "POIName": "勤科大",
    "Telno": "(04)23938945",
    "Address": "台中市太平區中山路一段215巷35號(行政大樓後方)"
}, {
    "POIID": "921459",
    "POIName": "新大億",
    "Telno": "(04)23917413",
    "Address": "台中市太平區大興路151號151-1號"
}, {
    "POIID": "132851",
    "POIName": "新平",
    "Telno": "(04)22785952",
    "Address": "台中市太平區永平路一段105號107號1樓"
}, {
    "POIID": "893851",
    "POIName": "新勤益",
    "Telno": "(04)23922680",
    "Address": "台中市太平區中山路1段217號"
}, {
    "POIID": "188441",
    "POIName": "新樹孝",
    "Telno": "(04)23910886",
    "Address": "台中市太平區樹孝路48號50號1樓"
}, {
    "POIID": "993270",
    "POIName": "溪洲",
    "Telno": "(04)22795623",
    "Address": "台中市太平區新平路二段221號"
}, {
    "POIID": "993708",
    "POIName": "精中",
    "Telno": "(04)22798881",
    "Address": "台中市太平區太平一街220號"
}, {
    "POIID": "863975",
    "POIName": "精美",
    "Telno": "(04)22701765",
    "Address": "台中市太平區中平里精美路1號"
}, {
    "POIID": "123248",
    "POIName": "樹廣",
    "Telno": "(04)23955449",
    "Address": "台中市太平區樹德路98-9號"
}, {
    "POIID": "982568",
    "POIName": "鑫佳慶",
    "Telno": "(04)23919759",
    "Address": "台中市太平區大源二街1號3號1F"
}, ], [{
    "POIID": "982339",
    "POIName": "欣谷關",
    "Telno": "(04)25950389",
    "Address": "台中市和平區東關路一段135-2號1樓"
}, {
    "POIID": "183170",
    "POIName": "梨山",
    "Telno": "(04)25981890",
    "Address": "台中市和平區中正路6號1樓"
}, {
    "POIID": "180632",
    "POIName": "環山",
    "Telno": "(04)25802573",
    "Address": "台中市和平區中興路三段64-5號.64-6號"
}, ], [{
    "POIID": "185866",
    "POIName": "三中",
    "Telno": "(04)23146826",
    "Address": "台中市西區忠明路54之1號1樓"
}, {
    "POIID": "152073",
    "POIName": "上誠",
    "Telno": "(04)24739542",
    "Address": "台中市西區向上路一段381號383號385號"
}, {
    "POIID": "854661",
    "POIName": "大全",
    "Telno": "(04)23753022",
    "Address": "台中市西區公館路136號138號"
}, {
    "POIID": "185958",
    "POIName": "大將作",
    "Telno": "(04)23205843",
    "Address": "台中市西區英才路410號"
}, {
    "POIID": "144566",
    "POIName": "五權",
    "Telno": "(04)23759066",
    "Address": "台中市西區南屯路一段60號62號64號"
}, {
    "POIID": "962715",
    "POIName": "台麗",
    "Telno": "(04)22060119",
    "Address": "台中市西區五權路119號"
}, {
    "POIID": "171373",
    "POIName": "市民",
    "Telno": "(04)23020614",
    "Address": "台中市西區公益路157號"
}, {
    "POIID": "141132",
    "POIName": "民府",
    "Telno": "(04)22203832",
    "Address": "台中市西區四維街22-1號24號"
}, {
    "POIID": "158288",
    "POIName": "吉龍",
    "Telno": "(04)23754680",
    "Address": "台中市西區忠明南路410號"
}, {
    "POIID": "170211",
    "POIName": "向美",
    "Telno": "(04)23016027",
    "Address": "台中市西區美村路一段302之1號302之7號"
}, {
    "POIID": "865889",
    "POIName": "向勝",
    "Telno": "(04)24723508",
    "Address": "台中市西區東興路三段57號"
}, {
    "POIID": "885539",
    "POIName": "安龍",
    "Telno": "(04)23752146",
    "Address": "台中市西區五權路2-12號13號"
}, {
    "POIID": "171203",
    "POIName": "忠明義",
    "Telno": "(04)23269542",
    "Address": "台中市西區忠明南路16號16之1號18號1樓"
}, {
    "POIID": "174626",
    "POIName": "忠福",
    "Telno": "(04)23787263",
    "Address": "台中市西區忠明南路192號"
}, {
    "POIID": "936048",
    "POIName": "明義",
    "Telno": "(04)23287885",
    "Address": "台中市西區美村路1段22號"
}, {
    "POIID": "940483",
    "POIName": "金典",
    "Telno": "(04)23265492",
    "Address": "台中市西區健行路1046;1046之1號"
}, {
    "POIID": "136336",
    "POIName": "保誠",
    "Telno": "(04)23721062",
    "Address": "台中市西區五權路2-104號及貴和街222號"
}, {
    "POIID": "184911",
    "POIName": "美生",
    "Telno": "(04)23275818",
    "Address": "台中市西區美村路1段54號"
}, {
    "POIID": "112639",
    "POIName": "美村",
    "Telno": "(04)23762435",
    "Address": "台中市西區美村路一段542號546號"
}, {
    "POIID": "154644",
    "POIName": "益風",
    "Telno": "(04)23202817",
    "Address": "台中市西區精誠路107號"
}, {
    "POIID": "902757",
    "POIName": "華生",
    "Telno": "(04)23765931",
    "Address": "台中市西區民生路517號"
}, {
    "POIID": "114152",
    "POIName": "鄉林夏都",
    "Telno": "(04)23267921",
    "Address": "台中市西區忠明南路117號1樓"
}, {
    "POIID": "865384",
    "POIName": "新五廊",
    "Telno": "(04)22240981",
    "Address": "台中市西區民生路155號一樓"
}, {
    "POIID": "139298",
    "POIName": "新文化",
    "Telno": "(04)23019624",
    "Address": "台中市西區中美街283號"
}, {
    "POIID": "143068",
    "POIName": "精明",
    "Telno": "(04)23292349",
    "Address": "台中市西區精誠路15號"
}, {
    "POIID": "118659",
    "POIName": "精業",
    "Telno": "(04)23191670",
    "Address": "台中市西區精誠路41號之6之7"
}, {
    "POIID": "912732",
    "POIName": "模範",
    "Telno": "(04)23024571",
    "Address": "台中市西區模範街34巷1號"
}, {
    "POIID": "186227",
    "POIName": "樂群",
    "Telno": "(04)23714557",
    "Address": "台中市西區林森路80號及樂群街81號"
}, {
    "POIID": "182409",
    "POIName": "權大",
    "Telno": "(04)23780449",
    "Address": "台中市西區五權西路一段271號1樓2樓"
}, {
    "POIID": "187079",
    "POIName": "權美",
    "Telno": "(04)23723672",
    "Address": "台中市西區美村路1段736號"
}, ], [{
    "POIID": "179920",
    "POIName": "一中",
    "Telno": "(04)22293258",
    "Address": "台中市北區一中街98號1樓"
}, {
    "POIID": "128380",
    "POIName": "中友",
    "Telno": "(04)22256137",
    "Address": "台中市北區育才北路74號76號"
}, {
    "POIID": "119652",
    "POIName": "中醫",
    "Telno": "(04)22078812",
    "Address": "台中市北區育德路13號"
}, {
    "POIID": "969059",
    "POIName": "中醫五權",
    "Telno": "(04)22346053",
    "Address": "台中市北區學士路2號"
}, {
    "POIID": "167086",
    "POIName": "元保",
    "Telno": "(04)22068717",
    "Address": "台中市北區進化北路413號1樓"
}, {
    "POIID": "130420",
    "POIName": "文津",
    "Telno": "(04)22994768",
    "Address": "台中市北區天津路二段138之10號之11號"
}, {
    "POIID": "190639",
    "POIName": "平西",
    "Telno": "(04)22936706",
    "Address": "台中市北區陜西路107號109號"
}, {
    "POIID": "791573",
    "POIName": "永進",
    "Telno": "(04)22366485",
    "Address": "台中市北區進化北路297號"
}, {
    "POIID": "127929",
    "POIName": "立夫",
    "Telno": "(04)22070910",
    "Address": "台中市北區育德路2號"
}, {
    "POIID": "952316",
    "POIName": "光大國宅",
    "Telno": "(04)22068491",
    "Address": "台中市北區文莊里日興街180號1樓"
}, {
    "POIID": "875093",
    "POIName": "合作",
    "Telno": "(04)23608343",
    "Address": "台中市北區自強一街1號"
}, {
    "POIID": "113469",
    "POIName": "汶莊",
    "Telno": "(04)22063620",
    "Address": "台中市北區中清路1段102號1樓"
}, {
    "POIID": "846109",
    "POIName": "育仁",
    "Telno": "(04)22373045",
    "Address": "台中市北區進化路583號"
}, {
    "POIID": "177441",
    "POIName": "亞太",
    "Telno": "(04)22057324",
    "Address": "台中市北區賴福里中清路一段508號"
}, {
    "POIID": "150815",
    "POIName": "庚樺",
    "Telno": "(04)22349868",
    "Address": "台中市北區崇德路一段143之2號"
}, {
    "POIID": "887029",
    "POIName": "忠太",
    "Telno": "(04)22063209",
    "Address": "台中市北區忠明8街1號或太原路1段492號1樓"
}, {
    "POIID": "120939",
    "POIName": "忠權",
    "Telno": "(04)22061836",
    "Address": "台中市北區忠明路426號1樓"
}, {
    "POIID": "131135",
    "POIName": "昌鴻",
    "Telno": "(04)22990002",
    "Address": "台中市北區賴厝里山西路一段48號"
}, {
    "POIID": "991355",
    "POIName": "東義",
    "Telno": "(04)22981487",
    "Address": "台中市北區北平路二段141號1樓"
}, {
    "POIID": "165057",
    "POIName": "科博館",
    "Telno": "(04)23268634",
    "Address": "台中市北區淡溝里博館路92號1樓"
}, {
    "POIID": "181255",
    "POIName": "美德",
    "Telno": "(04)22071869",
    "Address": "台中市北區民權路472號1樓466巷1.3號1樓"
}, {
    "POIID": "935632",
    "POIName": "益華",
    "Telno": "(04)22301107",
    "Address": "台中市北區健行路49號"
}, {
    "POIID": "136082",
    "POIName": "陜西",
    "Telno": "(04)22918766",
    "Address": "台中市北區陜西路48號48之1號1樓"
}, {
    "POIID": "132921",
    "POIName": "健興",
    "Telno": "(04)22363079",
    "Address": "台中市北區健行路354號"
}, {
    "POIID": "110987",
    "POIName": "淡溝",
    "Telno": "(04)22065373",
    "Address": "台中市北區淡溝里民權路361號1樓"
}, {
    "POIID": "864923",
    "POIName": "通豪",
    "Telno": "(04)22951490",
    "Address": "台中市北區漢口路三段172號174號"
}, {
    "POIID": "993591",
    "POIName": "婷婷",
    "Telno": "(04)22081433",
    "Address": "台中市北區學士路67號69號1樓"
}, {
    "POIID": "993111",
    "POIName": "富強",
    "Telno": "(04)22338064",
    "Address": "台中市北區國強街142號及天祥街100號1樓"
}, {
    "POIID": "968621",
    "POIName": "華太",
    "Telno": "(04)22061723",
    "Address": "台中市北區中華路二段137號"
}, {
    "POIID": "177522",
    "POIName": "進合",
    "Telno": "(04)23609986",
    "Address": "台中市北區進化路328號"
}, {
    "POIID": "891361",
    "POIName": "雅昌",
    "Telno": "(04)22984769",
    "Address": "台中市北區中清路一段569號"
}, {
    "POIID": "130718",
    "POIName": "雅亭",
    "Telno": "(04)22063783",
    "Address": "台中市北區中清路1段320號"
}, {
    "POIID": "148085",
    "POIName": "雅津",
    "Telno": "(04)22913927",
    "Address": "台中市北區天津路2段7號"
}, {
    "POIID": "895592",
    "POIName": "順益",
    "Telno": "(04)22014671",
    "Address": "台中市北區五權路387號及五常街13號15號"
}, {
    "POIID": "865100",
    "POIName": "新北平",
    "Telno": "(04)22968483",
    "Address": "台中市北區北平路二段96號"
}, {
    "POIID": "941028",
    "POIName": "新民高中",
    "Telno": "(04)22330573",
    "Address": "台中市北區金龍里三民路三段289號"
}, {
    "POIID": "941039",
    "POIName": "新民國",
    "Telno": "(04)22330621",
    "Address": "台中市北區金龍里三民路三段289號"
}, {
    "POIID": "912363",
    "POIName": "新育才",
    "Telno": "(04)22232877",
    "Address": "台中市北區三民路三段116號"
}, {
    "POIID": "916206",
    "POIName": "新東峰",
    "Telno": "(04)22349431",
    "Address": "台中市北區東光路340號"
}, {
    "POIID": "978617",
    "POIName": "新德化",
    "Telno": "(04)22084550",
    "Address": "台中市北區德化街660號"
}, {
    "POIID": "893231",
    "POIName": "嘟嘟",
    "Telno": "(04)22384760",
    "Address": "台中市北區興進路60號"
}, {
    "POIID": "944511",
    "POIName": "漢華",
    "Telno": "(04)22355816",
    "Address": "台中市北區漢口路五段60號62號66號1樓"
}, {
    "POIID": "149033",
    "POIName": "德毅",
    "Telno": "(04)22278757",
    "Address": "台中市北區尊賢街9號"
}, {
    "POIID": "126801",
    "POIName": "衛道",
    "Telno": "(04)22353537",
    "Address": "台中市北區進化北路378-6號"
}, {
    "POIID": "886130",
    "POIName": "學士",
    "Telno": "(04)22038425",
    "Address": "台中市北區學士路163號165號"
}, {
    "POIID": "148351",
    "POIName": "篤行",
    "Telno": "(04)22015811",
    "Address": "台中市北區篤行路120號122號"
}, {
    "POIID": "151302",
    "POIName": "興悅",
    "Telno": "(04)23602265",
    "Address": "台中市北區金華里進德北路160號162號"
}, {
    "POIID": "185969",
    "POIName": "親親",
    "Telno": "(04)22372379",
    "Address": "台中市北區錦洲里北屯路14號1樓"
}, {
    "POIID": "956581",
    "POIName": "錦中",
    "Telno": "(04)22361820",
    "Address": "台中市北區三民路3段258號"
}, {
    "POIID": "136174",
    "POIName": "錦新",
    "Telno": "(04)22257113",
    "Address": "台中市北區錦新街70-2號70-3號及一中街136-2號136-6號"
}, {
    "POIID": "864288",
    "POIName": "豐華",
    "Telno": "(04)22378824",
    "Address": "台中市北區進化北路148號"
}, {
    "POIID": "144038",
    "POIName": "醫德",
    "Telno": "(04)22075331",
    "Address": "台中市北區大德街87號1樓"
}, {
    "POIID": "822642",
    "POIName": "雙行",
    "Telno": "(04)22278400",
    "Address": "台中市北區雙十路二段47號"
}, ], [{
    "POIID": "131283",
    "POIName": "大茅埔",
    "Telno": "(04)25852415",
    "Address": "台中市東勢區東關路298-5號1樓"
}, {
    "POIID": "158369",
    "POIName": "東展",
    "Telno": "(04)25886569",
    "Address": "台中市東勢區南平里豐勢路336號"
}, {
    "POIID": "111865",
    "POIName": "東泰",
    "Telno": "(04)25774323",
    "Address": "台中市東勢區東蘭路41-5號"
}, {
    "POIID": "142766",
    "POIName": "東關",
    "Telno": "(04)25887433",
    "Address": "台中市東勢區中正路191號"
}, {
    "POIID": "990329",
    "POIName": "欣東雲",
    "Telno": "(04)25871926",
    "Address": "台中市東勢區第五橫街28號及三民街165號"
}, {
    "POIID": "187194",
    "POIName": "欣東勢",
    "Telno": "(04)25887812",
    "Address": "台中市東勢區第一橫街153號155號"
}, {
    "POIID": "155603",
    "POIName": "粵西",
    "Telno": "(04)25877305",
    "Address": "台中市東勢區東坑路62號1樓"
}, ], [{
    "POIID": "160199",
    "POIName": "久豐",
    "Telno": "(04)25588646",
    "Address": "台中市后里區三光路36號"
}, {
    "POIID": "875141",
    "POIName": "月眉",
    "Telno": "(04)25570109",
    "Address": "台中市后里區民生路226號"
}, {
    "POIID": "113252",
    "POIName": "后里廠",
    "Telno": "(04)25584367",
    "Address": "台中市后里區馬場路1號"
}, {
    "POIID": "900359",
    "POIName": "后東",
    "Telno": "(04)25570647",
    "Address": "台中市后里區甲后路97號"
}, {
    "POIID": "966913",
    "POIName": "后冠",
    "Telno": "(04)25581232",
    "Address": "台中市后里區民生路1號"
}, {
    "POIID": "865823",
    "POIName": "后綜",
    "Telno": "(04)25575290",
    "Address": "台中市后里區義里里31鄰甲后路313號315號1樓"
}, {
    "POIID": "981325",
    "POIName": "后糖",
    "Telno": "(04)25584498",
    "Address": "台中市后里區甲后路835號1樓"
}, {
    "POIID": "112134",
    "POIName": "后興",
    "Telno": "(04)25589357",
    "Address": "台中市后里區甲后路742號"
}, {
    "POIID": "951298",
    "POIName": "后寶",
    "Telno": "(04)25580374",
    "Address": "台中市后里區三豐路113之24號25號"
}, {
    "POIID": "142478",
    "POIName": "美光",
    "Telno": "(04)25584700",
    "Address": "台中市后里區三豐路429之1號"
}, {
    "POIID": "180894",
    "POIName": "美晶",
    "Telno": "(04)25581875",
    "Address": "台中市后里區后科南路88號1樓"
}, {
    "POIID": "954389",
    "POIName": "彩豐",
    "Telno": "(04)25589538",
    "Address": "台中市后里區三豐路473之5號"
}, {
    "POIID": "950251",
    "POIName": "福豐",
    "Telno": "(04)25588374",
    "Address": "台中市后里區福美路17號"
}, {
    "POIID": "893150",
    "POIName": "寶利旺",
    "Telno": "(04)25585834",
    "Address": "台中市后里區三豐路227-3號1F"
}, ], [{
    "POIID": "913735",
    "POIName": "上安",
    "Telno": "(04)24528528",
    "Address": "台中市西屯區至善路61路"
}, {
    "POIID": "155267",
    "POIName": "大都會",
    "Telno": "(04)22524461",
    "Address": "台中市西屯區惠來路二段238之1號1樓"
}, {
    "POIID": "180517",
    "POIName": "大貿",
    "Telno": "(04)22957569",
    "Address": "台中市西屯區中平路279號"
}, {
    "POIID": "977061",
    "POIName": "大鵬",
    "Telno": "(04)22963912",
    "Address": "台中市西屯區長安路二段125號"
}, {
    "POIID": "901536",
    "POIName": "工一",
    "Telno": "(04)23501228",
    "Address": "台中市西屯區工業區一路98-32號1樓"
}, {
    "POIID": "118497",
    "POIName": "中川",
    "Telno": "(04)23127422",
    "Address": "台中市西屯區台灣大道二段938號940號"
}, {
    "POIID": "124539",
    "POIName": "中榮",
    "Telno": "(04)23594713",
    "Address": "台中市西屯區台灣大道四段1650號1樓"
}, {
    "POIID": "942490",
    "POIName": "友達光電",
    "Telno": "(04)24637323",
    "Address": "台中市西屯區中科路1號"
}, {
    "POIID": "164629",
    "POIName": "友達宿舍",
    "Telno": "(04)24639308",
    "Address": "台中市西屯區科雅路2號"
}, {
    "POIID": "114369",
    "POIName": "天佑",
    "Telno": "(04)23585474",
    "Address": "台中市西屯區中工二路196號198號1樓"
}, {
    "POIID": "822310",
    "POIName": "文心",
    "Telno": "(04)23138420",
    "Address": "台中市西屯區文心路3段76號"
}, {
    "POIID": "977201",
    "POIName": "文華",
    "Telno": "(04)23121615",
    "Address": "台中市西屯區寧夏路232號"
}, {
    "POIID": "142973",
    "POIName": "玉門",
    "Telno": "(04)24612480",
    "Address": "台中市西屯區西屯路三段166之92號1樓"
}, {
    "POIID": "128553",
    "POIName": "甘肅",
    "Telno": "(04)23152941",
    "Address": "台中市西屯區甘肅路二段22號"
}, {
    "POIID": "951405",
    "POIName": "安河",
    "Telno": "(04)22953577",
    "Address": "台中市西屯區河南路二段14號"
}, {
    "POIID": "951427",
    "POIName": "西屯重慶",
    "Telno": "(04)23175147",
    "Address": "台中市西屯區西屯路二段95之25號"
}, {
    "POIID": "143220",
    "POIName": "西苑",
    "Telno": "(04)24528983",
    "Address": "台中市西屯區福星路112號1樓"
}, {
    "POIID": "166669",
    "POIName": "奇積",
    "Telno": "(04)24621293",
    "Address": "台中市西屯區新科路1號"
}, {
    "POIID": "120168",
    "POIName": "尚仁",
    "Telno": "(04)24527497",
    "Address": "台中市西屯區上仁街139號"
}, {
    "POIID": "154622",
    "POIName": "東儷",
    "Telno": "(04)23590457",
    "Address": "台中市西屯區臺灣大道四段1727號"
}, {
    "POIID": "129246",
    "POIName": "青海",
    "Telno": "(04)23178274",
    "Address": "台中市西屯區青海路1段1號"
}, {
    "POIID": "992543",
    "POIName": "俊國",
    "Telno": "(04)24631814",
    "Address": "台中市西屯區永福路40巷5號7號1樓"
}, {
    "POIID": "112651",
    "POIName": "科安",
    "Telno": "(04)24631686",
    "Address": "台中市西屯區國安一路105號107號109號一樓"
}, {
    "POIID": "182982",
    "POIName": "科雅",
    "Telno": "(04)24636793",
    "Address": "台中市西屯區福雅路571-1號"
}, {
    "POIID": "171487",
    "POIName": "秋紅谷",
    "Telno": "(04)22542731",
    "Address": "台中市西屯區朝富路30號32號1樓"
}, {
    "POIID": "967123",
    "POIName": "宸騰",
    "Telno": "(04)24520743",
    "Address": "台中市西屯區上石路201號"
}, {
    "POIID": "186881",
    "POIName": "展騰",
    "Telno": "(04)24524805",
    "Address": "台中市西屯區台灣大道三段688號690號"
}, {
    "POIID": "155463",
    "POIName": "恩光站",
    "Telno": "(04)24261435",
    "Address": "台中市西屯區環中路一段2490號"
}, {
    "POIID": "943390",
    "POIName": "校友會館",
    "Telno": "(04)23592722",
    "Address": "台中市西屯區台灣大道4段1727號1樓"
}, {
    "POIID": "110884",
    "POIName": "桂冠",
    "Telno": "(04)23117162",
    "Address": "台中市西屯區四川路120號1樓"
}, {
    "POIID": "115926",
    "POIName": "航發",
    "Telno": "(04)24526841",
    "Address": "台中市西屯區河南路二段242號"
}, {
    "POIID": "943091",
    "POIName": "國安國宅",
    "Telno": "(04)24610890",
    "Address": "台中市西屯區國安一路208巷1號"
}, {
    "POIID": "149114",
    "POIName": "逢大一",
    "Telno": "(04)24527714",
    "Address": "台中市西屯區文華路100號1樓"
}, {
    "POIID": "122197",
    "POIName": "逢大二",
    "Telno": "(04)24525048",
    "Address": "台中市西屯區福星北路98號1樓"
}, {
    "POIID": "977500",
    "POIName": "逢仁",
    "Telno": "(04)24512777",
    "Address": "台中市西屯區青海路二段262號"
}, {
    "POIID": "159111",
    "POIName": "逢甲",
    "Telno": "(04)24525542",
    "Address": "台中市西屯區西屯路二段272之3號之4號1樓"
}, {
    "POIID": "144577",
    "POIName": "逢明",
    "Telno": "(04)24513983",
    "Address": "台中市西屯區黎明路三段158號"
}, {
    "POIID": "957931",
    "POIName": "逢盛",
    "Telno": "(04)27064895",
    "Address": "台中市西屯區福星路330號"
}, {
    "POIID": "967422",
    "POIName": "逢喜",
    "Telno": "(04)27084476",
    "Address": "台中市西屯區逢甲路247號"
}, {
    "POIID": "182948",
    "POIName": "逢貿",
    "Telno": "(04)24264926",
    "Address": "台中市西屯區黎明路三段1218號"
}, {
    "POIID": "896274",
    "POIName": "逢源",
    "Telno": "(04)27054642",
    "Address": "台中市西屯區逢甲路162號之5"
}, {
    "POIID": "865502",
    "POIName": "逢福",
    "Telno": "(04)27082309",
    "Address": "台中市西屯區黎明路三段348號"
}, {
    "POIID": "128690",
    "POIName": "逢廣",
    "Telno": "(04)24528846",
    "Address": "台中市西屯區文華路170號172號1樓"
}, {
    "POIID": "135780",
    "POIName": "逢德",
    "Telno": "(04)24518827",
    "Address": "台中市西屯區青海路二段321號323號"
}, {
    "POIID": "166267",
    "POIName": "逢學",
    "Telno": "(04)24523524",
    "Address": "台中市西屯區文華路100號"
}, {
    "POIID": "886129",
    "POIName": "朝馬",
    "Telno": "(04)22598249",
    "Address": "台中市西屯區黎明路2段1010號"
}, {
    "POIID": "162025",
    "POIName": "港安",
    "Telno": "(04)24613492",
    "Address": "台中市西屯區西屯路三段179之9號"
}, {
    "POIID": "113001",
    "POIName": "港強",
    "Telno": "(04)24632861",
    "Address": "台中市西屯區福科路295號一樓"
}, {
    "POIID": "930604",
    "POIName": "港惠",
    "Telno": "(04)23128333",
    "Address": "台中市西屯區台灣大道三段328號"
}, {
    "POIID": "158668",
    "POIName": "華美",
    "Telno": "(04)23143424",
    "Address": "台中市西屯區西屯路2段19號19之1號21號"
}, {
    "POIID": "142984",
    "POIName": "隆心",
    "Telno": "(04)23109505",
    "Address": "台中市西屯區文心路2段566號"
}, {
    "POIID": "874458",
    "POIName": "隆安",
    "Telno": "(04)23271980",
    "Address": "台中市西屯區大隆路56號"
}, {
    "POIID": "188924",
    "POIName": "隆恩",
    "Telno": "(04)23103957",
    "Address": "台中市西屯區大墩十八街116號1樓"
}, {
    "POIID": "944533",
    "POIName": "新中工",
    "Telno": "(04)23596579",
    "Address": "台中市西屯區工業區一路58之1號"
}, {
    "POIID": "163523",
    "POIName": "新市政",
    "Telno": "(04)22519134",
    "Address": "台中市西屯區臺灣大道三段99號1樓"
}, {
    "POIID": "189307",
    "POIName": "新西屯",
    "Telno": "(04)24522290",
    "Address": "台中市西屯區西屯路二段281-3號281-4號"
}, {
    "POIID": "142191",
    "POIName": "新越",
    "Telno": "(04)22511084",
    "Address": "台中市西屯區台灣大道三段301號11樓"
}, {
    "POIID": "832030",
    "POIName": "新墩",
    "Telno": "(04)23221655",
    "Address": "台中市西屯區大墩路901號"
}, {
    "POIID": "161653",
    "POIName": "瑞盟",
    "Telno": "(04)24616042",
    "Address": "台中市西屯區西屯路三段159號之12"
}, {
    "POIID": "120146",
    "POIName": "瑞聯",
    "Telno": "(04)24634826",
    "Address": "台中市西屯區福科路890號1樓"
}, {
    "POIID": "977360",
    "POIName": "寧夏",
    "Telno": "(04)23178934",
    "Address": "台中市西屯區寧夏路105號"
}, {
    "POIID": "900887",
    "POIName": "漢成",
    "Telno": "(04)23166771",
    "Address": "台中市西屯區漢成四街2號"
}, {
    "POIID": "180274",
    "POIName": "漢翔",
    "Telno": "(04)24525134",
    "Address": "台中市西屯區福星北路59號"
}, {
    "POIID": "164113",
    "POIName": "福上",
    "Telno": "(04)23155607",
    "Address": "台中市西屯區河南路2段71號1樓"
}, {
    "POIID": "167721",
    "POIName": "福林",
    "Telno": "(04)24628940",
    "Address": "台中市西屯區福林路31巷150號"
}, {
    "POIID": "128829",
    "POIName": "福星",
    "Telno": "(04)24519553",
    "Address": "台中市西屯區福星路580號"
}, {
    "POIID": "900175",
    "POIName": "福茂",
    "Telno": "(04)24628460",
    "Address": "台中市西屯區西屯路三段148-30號"
}, {
    "POIID": "149103",
    "POIName": "福康",
    "Telno": "(04)24638081",
    "Address": "台中市西屯區福林里福康路33號"
}, {
    "POIID": "953858",
    "POIName": "福雅",
    "Telno": "(04)24639859",
    "Address": "台中市西屯區福雅路338號"
}, {
    "POIID": "980492",
    "POIName": "福漢",
    "Telno": "(04)23152060",
    "Address": "台中市西屯區何福里漢口路二段112號112-1號"
}, {
    "POIID": "154633",
    "POIName": "管院",
    "Telno": "(04)23590943",
    "Address": "台中市西屯區臺灣大道四段1727號"
}, {
    "POIID": "180230",
    "POIName": "遠百",
    "Telno": "(04)22544225",
    "Address": "台中市西屯區台灣大道三段251號10樓"
}, {
    "POIID": "903255",
    "POIName": "墩隆",
    "Telno": "(04)23273302",
    "Address": "台中市西屯區大墩路966號"
}, {
    "POIID": "158093",
    "POIName": "廣環",
    "Telno": "(04)24524421",
    "Address": "台中市西屯區環中路二段698號"
}, {
    "POIID": "158808",
    "POIName": "歐風",
    "Telno": "(04)22514455",
    "Address": "台中市西屯區惠民路199號"
}, {
    "POIID": "960487",
    "POIName": "潮洋",
    "Telno": "(04)22541499",
    "Address": "台中市西屯區市政路596號"
}, {
    "POIID": "921758",
    "POIName": "聯順",
    "Telno": "(04)24629546",
    "Address": "台中市西屯區福聯里福順路898號900號"
}, {
    "POIID": "993498",
    "POIName": "豐慶",
    "Telno": "(04)23164548",
    "Address": "台中市西屯區甘肅路一段196號及198號1樓"
}, {
    "POIID": "112190",
    "POIName": "寶慶",
    "Telno": "(04)24529273",
    "Address": "台中市西屯區西屯路二段256巷8號10號"
}, {
    "POIID": "891671",
    "POIName": "櫻花",
    "Telno": "(04)23151726",
    "Address": "台中市西屯區櫻花路111號"
}, {
    "POIID": "180827",
    "POIName": "鑫工三",
    "Telno": "(04)23598492",
    "Address": "台中市西屯區中工三路123.125號1樓"
}, {
    "POIID": "971328",
    "POIName": "鑫工和",
    "Telno": "(04)23593506",
    "Address": "台中市西屯區協和里工業區38路30號1樓"
}, {
    "POIID": "971269",
    "POIName": "鑫友達",
    "Telno": "(04)24635067",
    "Address": "台中市西屯區中科路1號"
}, {
    "POIID": "167617",
    "POIName": "鑫晶積",
    "Telno": "(04)24639081",
    "Address": "台中市西屯區新科路1號"
}, {
    "POIID": "159395",
    "POIName": "鑫港醫",
    "Telno": "(04)23596765",
    "Address": "台中市西屯區台灣大道四段1650號1樓"
}, ], [{
    "POIID": "160236",
    "POIName": "大甲東",
    "Telno": "(04)26802083",
    "Address": "台中市外埔區甲后路5段15號"
}, {
    "POIID": "116756",
    "POIName": "新甲后",
    "Telno": "(04)26839447",
    "Address": "台中市外埔區甲后路3段1025號"
}, ], [{
    "POIID": "136510",
    "POIName": "上楓樹",
    "Telno": "(04)24702620",
    "Address": "台中市南屯區中和里黎明路一段263號"
}, {
    "POIID": "181381",
    "POIName": "大立光",
    "Telno": "(04)23594826",
    "Address": "台中市南屯區精科路13號4樓"
}, {
    "POIID": "158624",
    "POIName": "大進",
    "Telno": "(04)24759161",
    "Address": "台中市南屯區五權西路二段185號"
}, {
    "POIID": "922658",
    "POIName": "工權",
    "Telno": "(04)23553123",
    "Address": "台中市南屯區工業區十八路31-1號"
}, {
    "POIID": "144061",
    "POIName": "中勇",
    "Telno": "(04)23809105",
    "Address": "台中市南屯區忠勇路105之27號1樓"
}, {
    "POIID": "965312",
    "POIName": "文嶺",
    "Telno": "(04)23805911",
    "Address": "台中市南屯區嶺東路806號"
}, {
    "POIID": "854258",
    "POIName": "向上",
    "Telno": "(04)23846325",
    "Address": "台中市南屯區黎明路二段193號"
}, {
    "POIID": "846486",
    "POIName": "向心",
    "Telno": "(04)24751265",
    "Address": "台中市南屯區大墩6街284號"
}, {
    "POIID": "920261",
    "POIName": "向權",
    "Telno": "(04)23811490",
    "Address": "台中市南屯區五權西路2段412號1樓"
}, {
    "POIID": "185350",
    "POIName": "南屯",
    "Telno": "(04)23891441",
    "Address": "台中市南屯區南屯路2段570號"
}, {
    "POIID": "886174",
    "POIName": "海德堡",
    "Telno": "(04)24759288",
    "Address": "台中市南屯區向心南路928號930號"
}, {
    "POIID": "167868",
    "POIName": "惠中",
    "Telno": "(04)22515764",
    "Address": "台中市南屯區黎明路二段425號1樓"
}, {
    "POIID": "131711",
    "POIName": "惠文",
    "Telno": "(04)22546680",
    "Address": "台中市南屯區河南路四段226號228號1樓"
}, {
    "POIID": "159029",
    "POIName": "惠宇",
    "Telno": "(04)24739173",
    "Address": "台中市南屯區向上南路一段167之1號"
}, {
    "POIID": "154884",
    "POIName": "詠豐",
    "Telno": "(04)23809792",
    "Address": "台中市南屯區永春東路1230號"
}, {
    "POIID": "921116",
    "POIName": "鄉林",
    "Telno": "(04)23107226",
    "Address": "台中市南屯區大業路177號"
}, {
    "POIID": "953098",
    "POIName": "新春社",
    "Telno": "(04)23802312",
    "Address": "台中市南屯區永春南路136號138號"
}, {
    "POIID": "931294",
    "POIName": "新墩興",
    "Telno": "(04)24712169",
    "Address": "台中市南屯區東興路二段98號1樓"
}, {
    "POIID": "996752",
    "POIName": "新豐功",
    "Telno": "(04)23862140",
    "Address": "台中市南屯區豐樂里永春東路860號"
}, {
    "POIID": "142065",
    "POIName": "瑞陽",
    "Telno": "(04)22510797",
    "Address": "台中市南屯區河南路四段442號446號1,2樓"
}, {
    "POIID": "909149",
    "POIName": "萬文",
    "Telno": "(04)23840027",
    "Address": "台中市南屯區黎明路一段1033號"
}, {
    "POIID": "886406",
    "POIName": "熊貓",
    "Telno": "(04)24754550",
    "Address": "台中市南屯區向上南路1段325號1-2樓"
}, {
    "POIID": "993096",
    "POIName": "精田",
    "Telno": "(04)24700590",
    "Address": "台中市南屯區黎明路一段142號"
}, {
    "POIID": "174903",
    "POIName": "精科",
    "Telno": "(04)23807963",
    "Address": "台中市南屯區嶺東路368號"
}, {
    "POIID": "180182",
    "POIName": "精站",
    "Telno": "(04)23801449",
    "Address": "台中市南屯區向上路5段289號"
}, {
    "POIID": "150745",
    "POIName": "聚懋",
    "Telno": "(04)24750835",
    "Address": "台中市南屯區大墩路287號289號一樓"
}, {
    "POIID": "980322",
    "POIName": "墩正",
    "Telno": "(04)22510497",
    "Address": "台中市南屯區溝墘里大墩11街330號1樓"
}, {
    "POIID": "958831",
    "POIName": "墩南",
    "Telno": "(04)24731595",
    "Address": "台中市南屯區南屯路二段212號1樓"
}, {
    "POIID": "162955",
    "POIName": "墩富",
    "Telno": "(04)23207553",
    "Address": "台中市南屯區大墩路572號"
}, {
    "POIID": "891903",
    "POIName": "墩陽",
    "Telno": "(04)23289729",
    "Address": "台中市南屯區大墩10街254號之1樓"
}, {
    "POIID": "148915",
    "POIName": "墩業",
    "Telno": "(04)23275693",
    "Address": "台中市南屯區大墩路717-5號"
}, {
    "POIID": "119065",
    "POIName": "黎明東",
    "Telno": "(04)23810985",
    "Address": "台中市南屯區黎明東街22號"
}, {
    "POIID": "117830",
    "POIName": "興春",
    "Telno": "(04)24715845",
    "Address": "台中市南屯區永春東路96號"
}, {
    "POIID": "111393",
    "POIName": "嶺中",
    "Telno": "(04)23806007",
    "Address": "台中市南屯區永春南路58號"
}, {
    "POIID": "180964",
    "POIName": "嶺寶",
    "Telno": "(04)23862931",
    "Address": "台中市南屯區忠勇路23-12號1樓"
}, {
    "POIID": "166337",
    "POIName": "豐河",
    "Telno": "(04)23806215",
    "Address": "台中市南屯區向上路二段376號"
}, {
    "POIID": "855631",
    "POIName": "豐采",
    "Telno": "(04)22598297",
    "Address": "台中市南屯區黎明路二段506號506-1號"
}, {
    "POIID": "946584",
    "POIName": "豐春",
    "Telno": "(04)24734980",
    "Address": "台中市南屯區文心南路100號"
}, {
    "POIID": "182339",
    "POIName": "權旺",
    "Telno": "(04)23806902",
    "Address": "台中市南屯區五權西路二段812號"
}, {
    "POIID": "905527",
    "POIName": "權興",
    "Telno": "(04)24717712",
    "Address": "台中市南屯區五權西路二段62號"
}, {
    "POIID": "155038",
    "POIName": "鑫權勝",
    "Telno": "(04)23801953",
    "Address": "台中市南屯區五權西路2段882號"
}, {
    "POIID": "171247",
    "POIName": "鑫鑽",
    "Telno": "(04)23860795",
    "Address": "台中市南屯區文心南三路663號"
}, ], [{
    "POIID": "921013",
    "POIName": "大坑",
    "Telno": "(04)22398412",
    "Address": "台中市北屯區橫坑巷28-1號"
}, {
    "POIID": "151690",
    "POIName": "大連",
    "Telno": "(04)22953446",
    "Address": "台中市北屯區大連路1段40號1樓"
}, {
    "POIID": "966175",
    "POIName": "中台禾豐",
    "Telno": "(04)24390923",
    "Address": "台中市北屯區太原路三段1505號"
}, {
    "POIID": "171498",
    "POIName": "中清",
    "Telno": "(04)22952695",
    "Address": "台中市北屯區中清路二段340號"
}, {
    "POIID": "951069",
    "POIName": "丰瑞",
    "Telno": "(04)24214855",
    "Address": "台中市北屯區四民里四平路563號"
}, {
    "POIID": "991159",
    "POIName": "天星",
    "Telno": "(04)24390965",
    "Address": "台中市北屯區東山路二段77之8號9號10號1樓"
}, {
    "POIID": "870401",
    "POIName": "水景",
    "Telno": "(04)24360603",
    "Address": "台中市北屯區東山路1段212號"
}, {
    "POIID": "185730",
    "POIName": "台中東山",
    "Telno": "(04)24378846",
    "Address": "台中市北屯區軍功里東山路一段221號"
}, {
    "POIID": "174408",
    "POIName": "平興",
    "Telno": "(04)22421651",
    "Address": "台中市北屯區遼寧路一段120號"
}, {
    "POIID": "114727",
    "POIName": "同榮",
    "Telno": "(04)24257349",
    "Address": "台中市北屯區同榮路161號1樓"
}, {
    "POIID": "892412",
    "POIName": "后庄",
    "Telno": "(04)24251026",
    "Address": "台中市北屯區后庄里后庄路141號1樓"
}, {
    "POIID": "181635",
    "POIName": "何藥局",
    "Telno": "(04)24360442",
    "Address": "台中市北屯區東山路一段306-1號1.2樓"
}, {
    "POIID": "852425",
    "POIName": "昌大",
    "Telno": "(04)22477783",
    "Address": "台中市北屯區大連路二段283號"
}, {
    "POIID": "162966",
    "POIName": "昌平",
    "Telno": "(04)22326743",
    "Address": "台中市北屯區昌平路1段70號"
}, {
    "POIID": "153700",
    "POIName": "昌和",
    "Telno": "(04)24362834",
    "Address": "台中市北屯區東山路一段146之39號"
}, {
    "POIID": "174855",
    "POIName": "昌旺",
    "Telno": "(04)22474819",
    "Address": "台中市北屯區昌平路二段12之16號"
}, {
    "POIID": "863632",
    "POIName": "昌盛",
    "Telno": "(04)24224542",
    "Address": "台中市北屯區昌平路2段45號之8及45號之9"
}, {
    "POIID": "152028",
    "POIName": "昌陽",
    "Telno": "(04)22434735",
    "Address": "台中市北屯區昌平路一段264號"
}, {
    "POIID": "138228",
    "POIName": "昌順",
    "Telno": "(04)22439430",
    "Address": "台中市北屯區北屯路439之16號1樓"
}, {
    "POIID": "131308",
    "POIName": "東侑",
    "Telno": "(04)22391830",
    "Address": "台中市北屯區東山路一段396號1樓"
}, {
    "POIID": "150790",
    "POIName": "松竹",
    "Telno": "(04)22472627",
    "Address": "台中市北屯區昌平路二段11-1號"
}, {
    "POIID": "179609",
    "POIName": "松佑",
    "Telno": "(04)24364087",
    "Address": "台中市北屯區松竹五路二段22號1樓"
}, {
    "POIID": "931098",
    "POIName": "松東",
    "Telno": "(04)22463373",
    "Address": "台中市北屯區松竹路3段125號"
}, {
    "POIID": "950295",
    "POIName": "松強",
    "Telno": "(04)22432398",
    "Address": "台中市北屯區松安里崇德六路一段47號"
}, {
    "POIID": "988267",
    "POIName": "松豪",
    "Telno": "(04)24214950",
    "Address": "台中市北屯區四平路218號"
}, {
    "POIID": "965356",
    "POIName": "松潭",
    "Telno": "(04)24392157",
    "Address": "台中市北屯區軍功路二段183號1樓"
}, {
    "POIID": "182214",
    "POIName": "欣花園",
    "Telno": "(04)22937902",
    "Address": "台中市北屯區華美西街二段478號"
}, {
    "POIID": "167237",
    "POIName": "金格",
    "Telno": "(04)24368410",
    "Address": "台中市北屯區松竹路一段965號1樓"
}, {
    "POIID": "991975",
    "POIName": "青河",
    "Telno": "(04)22362409",
    "Address": "台中市北屯區青島路三段155號1樓"
}, {
    "POIID": "911670",
    "POIName": "南北通",
    "Telno": "(04)24260092",
    "Address": "台中市北屯區同榮里環中路一段1686號"
}, {
    "POIID": "143792",
    "POIName": "軍松",
    "Telno": "(04)24366314",
    "Address": "台中市北屯區松竹五路二段199號1樓"
}, {
    "POIID": "153571",
    "POIName": "軍建",
    "Telno": "(04)24367480",
    "Address": "台中市北屯區軍福13路198號"
}, {
    "POIID": "111212",
    "POIName": "軍福",
    "Telno": "(04)24376717",
    "Address": "台中市北屯區軍功路一段500號"
}, {
    "POIID": "158978",
    "POIName": "健太",
    "Telno": "(04)24367881",
    "Address": "台中市北屯區太原路三段1138號"
}, {
    "POIID": "175010",
    "POIName": "國校",
    "Telno": "(04)22336256",
    "Address": "台中市北屯區國校巷16號"
}, {
    "POIID": "991942",
    "POIName": "崇尚",
    "Telno": "(04)22411034",
    "Address": "台中市北屯區崇德路二段450號1樓"
}, {
    "POIID": "167776",
    "POIName": "崇金",
    "Telno": "(04)24229483",
    "Address": "台中市北屯區崇德路三段195號"
}, {
    "POIID": "132563",
    "POIName": "連河",
    "Telno": "(04)22477023",
    "Address": "台中市北屯區河北路二段218之1號1樓"
}, {
    "POIID": "910998",
    "POIName": "逢運",
    "Telno": "(04)22984055",
    "Address": "台中市北屯區雷中街95號"
}, {
    "POIID": "141589",
    "POIName": "博吉",
    "Telno": "(04)24364574",
    "Address": "台中市北屯區東光路786號1樓"
}, {
    "POIID": "901846",
    "POIName": "敦煌",
    "Telno": "(04)22925869",
    "Address": "台中市北屯區敦化路456號"
}, {
    "POIID": "183099",
    "POIName": "景和",
    "Telno": "(04)24368700",
    "Address": "台中市北屯區太原路三段907號"
}, {
    "POIID": "966566",
    "POIName": "鈞泰",
    "Telno": "(04)24368075",
    "Address": "台中市北屯區太原路三段1112之1號1120之1號1樓"
}, {
    "POIID": "166212",
    "POIName": "雅樂",
    "Telno": "(04)22422858",
    "Address": "台中市北屯區松竹路二段88號"
}, {
    "POIID": "155050",
    "POIName": "新北屯",
    "Telno": "(04)22369034",
    "Address": "台中市北屯區太原路三段516號1樓"
}, {
    "POIID": "993018",
    "POIName": "新象",
    "Telno": "(04)24261619",
    "Address": "台中市北屯區中清路2段776號778號"
}, {
    "POIID": "165194",
    "POIName": "新興陽",
    "Telno": "(04)22431809",
    "Address": "台中市北屯區平田里興安路一段289號1樓"
}, {
    "POIID": "882105",
    "POIName": "瑞登",
    "Telno": "(04)22416245",
    "Address": "台中市北屯區松安里松竹路二段193號"
}, {
    "POIID": "996291",
    "POIName": "萬寶",
    "Telno": "(04)22959440",
    "Address": "台中市北屯區中清路二段567號一樓"
}, {
    "POIID": "114048",
    "POIName": "福寶",
    "Telno": "(04)22935012",
    "Address": "台中市北屯區陳平路50號52號1樓"
}, {
    "POIID": "148616",
    "POIName": "遠平",
    "Telno": "(04)22384398",
    "Address": "台中市北屯區北平路三段75-4號75-5號"
}, {
    "POIID": "992808",
    "POIName": "熱天",
    "Telno": "(04)22373652",
    "Address": "台中市北屯區天津路四段68號1樓"
}, {
    "POIID": "111485",
    "POIName": "熱陽",
    "Telno": "(04)22425271",
    "Address": "台中市北屯區熱河路二段217號"
}, {
    "POIID": "180137",
    "POIName": "賢和",
    "Telno": "(04)24360884",
    "Address": "台中市北屯區景賢路230號"
}, {
    "POIID": "144887",
    "POIName": "興昌",
    "Telno": "(04)22435875",
    "Address": "台中市北屯區興安路2段62號1樓"
}, {
    "POIID": "131397",
    "POIName": "瀋陽",
    "Telno": "(04)22911125",
    "Address": "台中市北屯區瀋陽路1段104號1樓"
}, {
    "POIID": "185497",
    "POIName": "豐樂",
    "Telno": "(04)24222105",
    "Address": "台中市北屯區崇德路三段608號"
}, {
    "POIID": "165415",
    "POIName": "瀚尹",
    "Telno": "(04)22477852",
    "Address": "台中市北屯區文心路4段577號579號"
}, {
    "POIID": "903093",
    "POIName": "寶昇",
    "Telno": "(04)22313622",
    "Address": "台中市北屯區北屯路224之1號"
}, {
    "POIID": "136886",
    "POIName": "鑫巴黎",
    "Telno": "(04)22491770",
    "Address": "台中市北屯區崇德路二段199號1樓"
}, ], [{
    "POIID": "892777",
    "POIName": "大甲站",
    "Telno": "(04)26761395",
    "Address": "台中市大甲區中山路一段828號"
}, {
    "POIID": "951737",
    "POIName": "大安港",
    "Telno": "(04)26804055",
    "Address": "台中市大甲區大安港路118號"
}, {
    "POIID": "860644",
    "POIName": "日出",
    "Telno": "(04)26818410",
    "Address": "台中市大甲區孟春里通天路168號"
}, {
    "POIID": "903831",
    "POIName": "日南",
    "Telno": "(04)26821781",
    "Address": "台中市大甲區日南里青年路130號"
}, {
    "POIID": "968528",
    "POIName": "永在",
    "Telno": "(04)26821479",
    "Address": "台中市大甲區日南里黎明路3之21號1樓"
}, {
    "POIID": "122577",
    "POIName": "甲渭",
    "Telno": "(04)26821407",
    "Address": "台中市大甲區龍泉里8鄰中山路二段905之8號"
}, {
    "POIID": "143301",
    "POIName": "金甲后",
    "Telno": "(04)26804065",
    "Address": "台中市大甲區甲后路5段360號"
}, {
    "POIID": "852067",
    "POIName": "順大",
    "Telno": "(04)26870347",
    "Address": "台中市大甲區中山路一段1085號"
}, {
    "POIID": "184852",
    "POIName": "順天",
    "Telno": "(04)26867403",
    "Address": "台中市大甲區順天路154號"
}, {
    "POIID": "165161",
    "POIName": "媽祖",
    "Telno": "(04)26867485",
    "Address": "台中市大甲區光明路1號"
}, {
    "POIID": "971971",
    "POIName": "新政",
    "Telno": "(04)26761738",
    "Address": "台中市大甲區信義路193號"
}, {
    "POIID": "185006",
    "POIName": "新美",
    "Telno": "(04)26864979",
    "Address": "台中市大甲區經國路329號"
}, {
    "POIID": "137845",
    "POIName": "義和",
    "Telno": "(04)26882372",
    "Address": "台中市大甲區中山路一段492號"
}, {
    "POIID": "971926",
    "POIName": "鈺英",
    "Telno": "(04)26765542",
    "Address": "台中市大甲區育英路283號"
}, {
    "POIID": "120157",
    "POIName": "蔣公",
    "Telno": "(04)26881120",
    "Address": "台中市大甲區蔣公路221號"
}, ], [{
    "POIID": "141730",
    "POIName": "金大安",
    "Telno": "(04)26713224",
    "Address": "台中市大安區中山南路241號1樓"
}, ], [{
    "POIID": "138631",
    "POIName": "一路發",
    "Telno": "(04)26577023",
    "Address": "台中市清水區鰲峰路580號之15"
}, {
    "POIID": "142320",
    "POIName": "大秀",
    "Telno": "(04)26281748",
    "Address": "台中市清水區五權路328號"
}, {
    "POIID": "931423",
    "POIName": "巧竹",
    "Telno": "(04)26569583",
    "Address": "台中市清水區海濱里臨海路46-53及46-54號"
}, {
    "POIID": "921770",
    "POIName": "昌興",
    "Telno": "(04)26222843",
    "Address": "台中市清水區新興路238號文昌街12-1號"
}, {
    "POIID": "180436",
    "POIName": "欣浩",
    "Telno": "(04)26281007",
    "Address": "台中市清水區五權路121號"
}, {
    "POIID": "183365",
    "POIName": "英荃",
    "Telno": "(04)26229642",
    "Address": "台中市清水區中山路39.41.43號"
}, {
    "POIID": "130800",
    "POIName": "海濱",
    "Telno": "(04)26281097",
    "Address": "台中市清水區中華路429號"
}, {
    "POIID": "933223",
    "POIName": "高美祿",
    "Telno": "(04)26275803",
    "Address": "台中市清水區高美路190號1樓"
}, {
    "POIID": "880718",
    "POIName": "清中",
    "Telno": "(04)26233237",
    "Address": "台中市清水區北寧里董公街56號"
}, {
    "POIID": "965242",
    "POIName": "清峰",
    "Telno": "(04)26226842",
    "Address": "台中市清水區中華路330號"
}, {
    "POIID": "130486",
    "POIName": "港藝",
    "Telno": "(04)26281895",
    "Address": "台中市清水區中社路19號"
}, {
    "POIID": "953342",
    "POIName": "菁埔",
    "Telno": "(04)26221350",
    "Address": "台中市清水區中央北路1號"
}, {
    "POIID": "136956",
    "POIName": "新清水",
    "Telno": "(04)26268398",
    "Address": "台中市清水區五權路16號"
}, {
    "POIID": "980816",
    "POIName": "億承",
    "Telno": "(04)26566134",
    "Address": "台中市清水區民和路2段195號"
}, {
    "POIID": "978293",
    "POIName": "鰲峰",
    "Telno": "(04)26221728",
    "Address": "台中市清水區鰲峰路22號"
}, ], [{
    "POIID": "971188",
    "POIName": "大洲",
    "Telno": "(04)25298470",
    "Address": "台中市神岡區大洲路299之1號"
}, {
    "POIID": "959340",
    "POIName": "奇晉",
    "Telno": "(04)25202546",
    "Address": "台中市神岡區豐洲路469號1樓"
}, {
    "POIID": "950170",
    "POIName": "承軒",
    "Telno": "(04)25629203",
    "Address": "台中市神岡區民生路48之7號8號9號"
}, {
    "POIID": "862330",
    "POIName": "社口",
    "Telno": "(04)25618246",
    "Address": "台中市神岡區社口里8鄰中山路736號"
}, {
    "POIID": "111876",
    "POIName": "倍沅",
    "Telno": "(04)25633834",
    "Address": "台中市神岡區中山路473號"
}, {
    "POIID": "153582",
    "POIName": "栗豐",
    "Telno": "(04)25356135",
    "Address": "台中市神岡區承德路219號"
}, {
    "POIID": "113595",
    "POIName": "神洲",
    "Telno": "(04)25284035",
    "Address": "台中市神岡區神洲路332號"
}, {
    "POIID": "944692",
    "POIName": "神寶",
    "Telno": "(04)25613400",
    "Address": "台中市神岡區中正路100號"
}, {
    "POIID": "972468",
    "POIName": "新北庄",
    "Telno": "(04)25632407",
    "Address": "台中市神岡區北庄里中山路1320-3號"
}, {
    "POIID": "154493",
    "POIName": "新禾",
    "Telno": "(04)25632930",
    "Address": "台中市神岡區和睦路一段363號"
}, {
    "POIID": "883902",
    "POIName": "豐洲",
    "Telno": "(04)25247925",
    "Address": "台中市神岡區五權路63號"
}, {
    "POIID": "982351",
    "POIName": "鑫和睦",
    "Telno": "(04)25625741",
    "Address": "台中市神岡區神清路266號268號及福成路56-1號"
}, ], [{
    "POIID": "923558",
    "POIName": "新石岡",
    "Telno": "(04)25724608",
    "Address": "台中市石岡區明德路118號"
}, ], [{
    "POIID": "112145",
    "POIName": "中興嶺",
    "Telno": "(04)25820985",
    "Address": "台中市新社區中興嶺172之2號"
}, {
    "POIID": "966810",
    "POIName": "永源村",
    "Telno": "(04)25825448",
    "Address": "台中市新社區東山街88-29號30號"
}, {
    "POIID": "151586",
    "POIName": "社和",
    "Telno": "(04)25824929",
    "Address": "台中市新社區中和街五段115號1樓"
}, {
    "POIID": "123293",
    "POIName": "新社",
    "Telno": "(04)25819166",
    "Address": "台中市新社區興社街4段27之1號"
}, {
    "POIID": "954758",
    "POIName": "薰衣草",
    "Telno": "(04)25825277",
    "Address": "台中市新社區協中街169之1號"
}, ], [{
    "POIID": "180333",
    "POIName": "大仁",
    "Telno": "(04)26584589",
    "Address": "台中市梧棲區頂寮里28鄰大仁路2段71號"
}, {
    "POIID": "145053",
    "POIName": "大聖",
    "Telno": "(04)26595625",
    "Address": "台中市梧棲區草湳里臨港路3段351號"
}, {
    "POIID": "909080",
    "POIName": "大維",
    "Telno": "(04)26584759",
    "Address": "台中市梧棲區四維路73號"
}, {
    "POIID": "910770",
    "POIName": "台中港",
    "Telno": "(04)26560576",
    "Address": "台中市梧棲區台灣大道九段301號1樓"
}, {
    "POIID": "950321",
    "POIName": "弘新",
    "Telno": "(04)26355306",
    "Address": "台中市梧棲區永興路一段112號"
}, {
    "POIID": "155153",
    "POIName": "吉得堡",
    "Telno": "(04)26567304",
    "Address": "台中市梧棲區中興路121號"
}, {
    "POIID": "190341",
    "POIName": "梧棲",
    "Telno": "(04)26578003",
    "Address": "台中市梧棲區台灣大道八段962號"
}, {
    "POIID": "166533",
    "POIName": "智光",
    "Telno": "(04)26568163",
    "Address": "台中市梧棲區大智路一段525號1樓"
}, {
    "POIID": "120179",
    "POIName": "港中",
    "Telno": "(04)26564037",
    "Address": "台中市梧棲區中央路一段666之28號"
}, {
    "POIID": "183424",
    "POIName": "港昌",
    "Telno": "(04)26582445",
    "Address": "台中市梧棲區港埠路一段986號"
}, {
    "POIID": "992358",
    "POIName": "港區",
    "Telno": "(04)26580687",
    "Address": "台中市梧棲區安仁里文化路二段2鄰55號1樓"
}, {
    "POIID": "154806",
    "POIName": "港埠",
    "Telno": "(04)26562460",
    "Address": "台中市梧棲區港埠路一段989號"
}, {
    "POIID": "174877",
    "POIName": "港臻",
    "Telno": "(04)26563851",
    "Address": "台中市梧棲區文昌路333號"
}, {
    "POIID": "944418",
    "POIName": "詠珊",
    "Telno": "(04)26575417",
    "Address": "台中市梧棲區大智路1017號"
}, {
    "POIID": "908320",
    "POIName": "詠德",
    "Telno": "(04)26567101",
    "Address": "台中市梧棲區大智路二段385號"
}, {
    "POIID": "901950",
    "POIName": "新童",
    "Telno": "(04)26570026",
    "Address": "台中市梧棲區台灣大道8段699號"
}, {
    "POIID": "924539",
    "POIName": "關連",
    "Telno": "(04)26399899",
    "Address": "台中市梧棲區臨港路3段72號"
}, ], [{
    "POIID": "842325",
    "POIName": "中棲",
    "Telno": "(04)26324033",
    "Address": "台中市沙鹿區台灣大道七段259號"
}, {
    "POIID": "891132",
    "POIName": "丹聯",
    "Telno": "(04)26653949",
    "Address": "台中市沙鹿區中山路田尾巷3號4號5號"
}, {
    "POIID": "126720",
    "POIName": "天仁",
    "Telno": "(04)26361763",
    "Address": "台中市沙鹿區斗抵里沙田路17之19號"
}, {
    "POIID": "139139",
    "POIName": "斗抵",
    "Telno": "(04)26359855",
    "Address": "台中市沙鹿區沙田路43-12號"
}, {
    "POIID": "181772",
    "POIName": "北勢東",
    "Telno": "(04)26318451",
    "Address": "台中市沙鹿區北勢東路507之8號9號"
}, {
    "POIID": "116505",
    "POIName": "弘光",
    "Telno": "(04)26529515",
    "Address": "台中市沙鹿區晉江里台灣大道六段1018號"
}, {
    "POIID": "151069",
    "POIName": "沙鹿中山",
    "Telno": "(04)26629334",
    "Address": "台中市沙鹿區中山路198號"
}, {
    "POIID": "951324",
    "POIName": "沙鹿光田",
    "Telno": "(04)26626074",
    "Address": "台中市沙鹿區沙田路115號"
}, {
    "POIID": "971959",
    "POIName": "保屏",
    "Telno": "(04)26368705",
    "Address": "台中市沙鹿區向上路七段132號"
}, {
    "POIID": "144555",
    "POIName": "星河",
    "Telno": "(04)26227926",
    "Address": "台中市沙鹿區鹿峰里中山路646號"
}, {
    "POIID": "940575",
    "POIName": "祐瑄",
    "Telno": "(04)26629437",
    "Address": "台中市沙鹿區光華路502號506號"
}, {
    "POIID": "890944",
    "POIName": "清泉崗",
    "Telno": "(04)26152389",
    "Address": "台中市沙鹿區中清路六段259號"
}, {
    "POIID": "922728",
    "POIName": "頂尖",
    "Telno": "(04)26529629",
    "Address": "台中市沙鹿區北勢東路617號619號"
}, {
    "POIID": "125314",
    "POIName": "鹿心",
    "Telno": "(04)26355174",
    "Address": "台中市沙鹿區興仁里四平街58號"
}, {
    "POIID": "886680",
    "POIName": "鹿鼎",
    "Telno": "(04)26628465",
    "Address": "台中市沙鹿區台灣大道7段812號1樓"
}, {
    "POIID": "971476",
    "POIName": "鹿維",
    "Telno": "(04)26319135",
    "Address": "台中市沙鹿區北勢東路330號"
}, {
    "POIID": "151818",
    "POIName": "鹿興",
    "Telno": "(04)26368423",
    "Address": "台中市沙鹿區向上路七段1號"
}, {
    "POIID": "831598",
    "POIName": "童醫",
    "Telno": "(04)26624967",
    "Address": "台中市沙鹿區成功東街1號"
}, {
    "POIID": "155049",
    "POIName": "新忠貞",
    "Telno": "(04)26154547",
    "Address": "台中市沙鹿區東大路二段1587號"
}, {
    "POIID": "131571",
    "POIName": "靜大",
    "Telno": "(04)26310417",
    "Address": "台中市沙鹿區晉江里台灣大道七段142號"
}, {
    "POIID": "844192",
    "POIName": "靜宜",
    "Telno": "(04)26350632",
    "Address": "台中市沙鹿區鎮南路二段293號"
}, {
    "POIID": "954792",
    "POIName": "鎮欣",
    "Telno": "(04)26314831",
    "Address": "台中市沙鹿區北勢里鎮南路二段368號"
}, {
    "POIID": "947370",
    "POIName": "鎮揚",
    "Telno": "(04)26521648",
    "Address": "台中市沙鹿區南陽路439號"
}, {
    "POIID": "111717",
    "POIName": "鎮權",
    "Telno": "(04)26363948",
    "Address": "台中市沙鹿區鎮南路二段107號109號"
}, ], [{
    "POIID": "903303",
    "POIName": "上楓",
    "Telno": "(04)25688574",
    "Address": "台中市大雅區民生路3段523號"
}, {
    "POIID": "910736",
    "POIName": "百達",
    "Telno": "(04)25651768",
    "Address": "台中市大雅區中清路三段721號"
}, {
    "POIID": "151508",
    "POIName": "亞和",
    "Telno": "(04)25602429",
    "Address": "台中市大雅區中山北路410號"
}, {
    "POIID": "114624",
    "POIName": "佳積",
    "Telno": "(04)25694520",
    "Address": "台中市大雅區科雅六路1號"
}, {
    "POIID": "121286",
    "POIName": "科邦",
    "Telno": "(04)25607547",
    "Address": "台中市大雅區科雅一路8號5樓"
}, {
    "POIID": "962988",
    "POIName": "神林",
    "Telno": "(04)25688503",
    "Address": "台中市大雅區神林南路144號"
}, {
    "POIID": "122913",
    "POIName": "通山",
    "Telno": "(04)25604991",
    "Address": "台中市大雅區永和路11號18號"
}, {
    "POIID": "962704",
    "POIName": "超全",
    "Telno": "(04)25652753",
    "Address": "台中市大雅區中清路四段910號"
}, {
    "POIID": "952121",
    "POIName": "雅神",
    "Telno": "(04)25670120",
    "Address": "台中市大雅區昌平路四段286號"
}, {
    "POIID": "968517",
    "POIName": "雅勝",
    "Telno": "(04)25692742",
    "Address": "台中市大雅區雅潭路4段491號"
}, {
    "POIID": "174372",
    "POIName": "雅潭",
    "Telno": "(04)25685151",
    "Address": "台中市大雅區學府路209號"
}, {
    "POIID": "942283",
    "POIName": "雅興",
    "Telno": "(04)25686782",
    "Address": "台中市大雅區雅潭路4段81號"
}, {
    "POIID": "165150",
    "POIName": "新德勝",
    "Telno": "(04)25604319",
    "Address": "台中市大雅區民生路三段68號70號"
}, {
    "POIID": "122418",
    "POIName": "福廣",
    "Telno": "(04)25674255",
    "Address": "台中市大雅區中山路1號3號5號1樓"
}, {
    "POIID": "953076",
    "POIName": "綠點",
    "Telno": "(04)25609479",
    "Address": "台中市大雅區神林路一段300號302號"
}, {
    "POIID": "186906",
    "POIName": "廣裕",
    "Telno": "(04)25600961",
    "Address": "台中市大雅區中山路145號"
}, {
    "POIID": "159030",
    "POIName": "興府",
    "Telno": "(04)25677731",
    "Address": "台中市大雅區學府路51號"
}, {
    "POIID": "114691",
    "POIName": "環太",
    "Telno": "(04)25674424",
    "Address": "台中市大雅區雅環路一段330號"
}, {
    "POIID": "112570",
    "POIName": "環雅",
    "Telno": "(04)25607351",
    "Address": "台中市大雅區雅環路二段320號一樓"
}, {
    "POIID": "891682",
    "POIName": "豐碩",
    "Telno": "(04)25600634",
    "Address": "台中市大雅區中清路四段46號"
}, {
    "POIID": "180469",
    "POIName": "豐積",
    "Telno": "(04)25607825",
    "Address": "台中市大雅區科雅西路5號B2樓"
}, {
    "POIID": "900430",
    "POIName": "雙喜",
    "Telno": "(04)25687934",
    "Address": "台中市大雅區中山北路167號"
}, ], [{
    "POIID": "151405",
    "POIName": "大運通",
    "Telno": "(04)25390930",
    "Address": "台中市潭子區復興路一段16號18號"
}, {
    "POIID": "140014",
    "POIName": "佳茂",
    "Telno": "(04)25346907",
    "Address": "台中市潭子區中山路一段17號1樓"
}, {
    "POIID": "880866",
    "POIName": "東寶",
    "Telno": "(04)25344621",
    "Address": "台中市潭子區昌平路三段152號"
}, {
    "POIID": "912606",
    "POIName": "矽品",
    "Telno": "(04)25353262",
    "Address": "台中市潭子區大豐路3段188號190號"
}, {
    "POIID": "924850",
    "POIName": "栗林",
    "Telno": "(04)25387300",
    "Address": "台中市潭子區祥和路169號171號"
}, {
    "POIID": "967709",
    "POIName": "甜園",
    "Telno": "(04)25327349",
    "Address": "台中市潭子區豐栗路9號"
}, {
    "POIID": "187367",
    "POIName": "圓通南",
    "Telno": "(04)25345324",
    "Address": "台中市潭子區潭陽里圓通南路239號"
}, {
    "POIID": "893046",
    "POIName": "榮晉",
    "Telno": "(04)25359250",
    "Address": "台中市潭子區頭張路二段2號"
}, {
    "POIID": "131021",
    "POIName": "潭北",
    "Telno": "(04)25360956",
    "Address": "台中市潭子區仁愛路三段11號13號15號"
}, {
    "POIID": "171650",
    "POIName": "潭秀",
    "Telno": "(04)25354453",
    "Address": "台中市潭子區雅潭路一段167號1樓"
}, {
    "POIID": "190606",
    "POIName": "潭欣",
    "Telno": "(04)25394615",
    "Address": "台中市潭子區光陽路142號"
}, {
    "POIID": "970808",
    "POIName": "潭春",
    "Telno": "(04)25342320",
    "Address": "台中市潭子區東寶里大豐路二段1號1樓"
}, {
    "POIID": "180045",
    "POIName": "潭厝",
    "Telno": "(04)25341014",
    "Address": "台中市潭子區環中東路一段5號"
}, {
    "POIID": "131032",
    "POIName": "潭勝",
    "Telno": "(04)25344613",
    "Address": "台中市潭子區勝利路101號103號"
}, {
    "POIID": "164869",
    "POIName": "潭富",
    "Telno": "(04)25346731",
    "Address": "台中市潭子區中山路二段585之1號"
}, {
    "POIID": "130408",
    "POIName": "潭陽",
    "Telno": "(04)25361043",
    "Address": "台中市潭子區圓通南路2號1樓"
}, {
    "POIID": "120582",
    "POIName": "潭榮",
    "Telno": "(04)25351431",
    "Address": "台中市潭子區榮興街19號1樓21巷1號21巷3號1樓"
}, {
    "POIID": "942087",
    "POIName": "潭德",
    "Telno": "(04)25343039",
    "Address": "台中市潭子區崇德路五段489號"
}, {
    "POIID": "941464",
    "POIName": "潭慶",
    "Telno": "(04)25352600",
    "Address": "台中市潭子區大豐路三段123號"
}, {
    "POIID": "954220",
    "POIName": "潭興",
    "Telno": "(04)25392368",
    "Address": "台中市潭子區豐興路1段593號595號"
}, {
    "POIID": "180883",
    "POIName": "潭濟",
    "Telno": "(04)25394279",
    "Address": "台中市潭子區豐興路一段88號B1樓"
}, {
    "POIID": "952246",
    "POIName": "潭豐",
    "Telno": "(04)25355870",
    "Address": "台中市潭子區崇德路4段250之1號"
}, {
    "POIID": "944245",
    "POIName": "潭寶",
    "Telno": "(04)25357382",
    "Address": "台中市潭子區潭興路三段51號"
}, {
    "POIID": "127077",
    "POIName": "頭張",
    "Telno": "(04)25351934",
    "Address": "台中市潭子區家福里頭張路一段31號"
}, ], [{
    "POIID": "188290",
    "POIName": "中龍",
    "Telno": "(04)26396481",
    "Address": "台中市龍井區龍昌路100號"
}, {
    "POIID": "863218",
    "POIName": "巨龍",
    "Telno": "(04)26301570",
    "Address": "台中市龍井區中央路3段51號"
}, {
    "POIID": "988061",
    "POIName": "東風",
    "Telno": "(04)26521941",
    "Address": "台中市龍井區遠東街3號"
}, {
    "POIID": "185419",
    "POIName": "東海",
    "Telno": "(04)26315975",
    "Address": "台中市龍井區台灣大道5段3巷43號45號1樓"
}, {
    "POIID": "147945",
    "POIName": "理想",
    "Telno": "(04)26529013",
    "Address": "台中市龍井區國際街155號157號159號1樓"
}, {
    "POIID": "121345",
    "POIName": "鈦譜",
    "Telno": "(04)26396273",
    "Address": "台中市龍井區龍門路48之15號"
}, {
    "POIID": "141291",
    "POIName": "新仁",
    "Telno": "(04)26318428",
    "Address": "台中市龍井區新興路40之3之3號1樓"
}, {
    "POIID": "978374",
    "POIName": "新庄",
    "Telno": "(04)26525538",
    "Address": "台中市龍井區台灣大道5段232號236號1樓"
}, {
    "POIID": "121301",
    "POIName": "廣洽",
    "Telno": "(04)26398952",
    "Address": "台中市龍井區西濱路三段247號"
}, {
    "POIID": "992794",
    "POIName": "學園",
    "Telno": "(04)26315902",
    "Address": "台中市龍井區台灣大道5段3巷62弄21號1樓"
}, {
    "POIID": "170783",
    "POIName": "龍井",
    "Telno": "(04)26320205",
    "Address": "台中市龍井區遊園南路210號"
}, {
    "POIID": "123086",
    "POIName": "龍田",
    "Telno": "(04)26307486",
    "Address": "台中市龍井區田中里臨港東路一段75號"
}, {
    "POIID": "131250",
    "POIName": "龍合",
    "Telno": "(04)26366931",
    "Address": "台中市龍井區中華路一段36號"
}, {
    "POIID": "900898",
    "POIName": "龍津",
    "Telno": "(04)26398228",
    "Address": "台中市龍井區三德里中央路二段4號"
}, {
    "POIID": "165600",
    "POIName": "龍峰",
    "Telno": "(04)26520553",
    "Address": "台中市龍井區向上路6段298號"
}, {
    "POIID": "891501",
    "POIName": "龍祥",
    "Telno": "(04)26366226",
    "Address": "台中市龍井區沙田路4段636號"
}, {
    "POIID": "976736",
    "POIName": "龍新",
    "Telno": "(04)26527270",
    "Address": "台中市龍井區新興路18號1樓"
}, {
    "POIID": "968838",
    "POIName": "鑫井源",
    "Telno": "(04)26365266",
    "Address": "台中市龍井區沙田路六段323號"
}, ], [{
    "POIID": "110035",
    "POIName": "一勝",
    "Telno": "(04)26930674",
    "Address": "台中市大肚區福山村沙田路一段432-1號"
}, {
    "POIID": "174545",
    "POIName": "大肚",
    "Telno": "(04)26994658",
    "Address": "台中市大肚區沙田路二段740號"
}, {
    "POIID": "165862",
    "POIName": "王田",
    "Telno": "(04)26930490",
    "Address": "台中市大肚區沙田路一段386號"
}, {
    "POIID": "893596",
    "POIName": "台紙",
    "Telno": "(04)26983260",
    "Address": "台中市大肚區沙田路二段645號"
}, {
    "POIID": "189020",
    "POIName": "遊園",
    "Telno": "(04)26911486",
    "Address": "台中市大肚區遊園路二段146號1樓"
}, {
    "POIID": "163693",
    "POIName": "蔗園",
    "Telno": "(04)26914816",
    "Address": "台中市大肚區遊園路1段143號"
}, {
    "POIID": "132068",
    "POIName": "親旺",
    "Telno": "(04)26934817",
    "Address": "台中市大肚區沙田路一段929號"
}, {
    "POIID": "981196",
    "POIName": "豐肚",
    "Telno": "(04)26999770",
    "Address": "台中市大肚區社腳里沙田路一段916號"
}, ], [{
    "POIID": "165817",
    "POIName": "九德",
    "Telno": "(04)23363783",
    "Address": "台中市烏日區九德里中華路45號47號1樓"
}, {
    "POIID": "182421",
    "POIName": "中展館",
    "Telno": "(04)23369243",
    "Address": "台中市烏日區中山路三段1-1號"
}, {
    "POIID": "153696",
    "POIName": "中高一",
    "Telno": "(04)36007563",
    "Address": "台中市烏日區站區二路8號1樓"
}, {
    "POIID": "153711",
    "POIName": "中高二",
    "Telno": "(04)36006618",
    "Address": "台中市烏日區站區二路8號2樓"
}, {
    "POIID": "187080",
    "POIName": "元宏",
    "Telno": "(04)23357738",
    "Address": "台中市烏日區溪南路一段722號"
}, {
    "POIID": "179621",
    "POIName": "太明",
    "Telno": "(04)23356899",
    "Address": "台中市烏日區太明路136號"
}, {
    "POIID": "954013",
    "POIName": "台中高鐵",
    "Telno": "(04)36007820",
    "Address": "台中市烏日區站區二路8號2樓"
}, {
    "POIID": "131962",
    "POIName": "吉宏",
    "Telno": "(04)23387989",
    "Address": "台中市烏日區九德里20鄰中華路593號"
}, {
    "POIID": "992406",
    "POIName": "明道一",
    "Telno": "(04)23362043",
    "Address": "台中市烏日區中山路一段497號(蠡海大樓)"
}, {
    "POIID": "143002",
    "POIName": "明道二",
    "Telno": "(04)23372406",
    "Address": "台中市烏日區中山路一段497號地下室1樓"
}, {
    "POIID": "110736",
    "POIName": "東園",
    "Telno": "(04)23351590",
    "Address": "台中市烏日區溪南路一段375號"
}, {
    "POIID": "120847",
    "POIName": "烏日",
    "Telno": "(04)23362682",
    "Address": "台中市烏日區新興路247號"
}, {
    "POIID": "132769",
    "POIName": "喀哩",
    "Telno": "(04)23355202",
    "Address": "台中市烏日區溪南路二段380號1樓"
}, {
    "POIID": "967569",
    "POIName": "新光德",
    "Telno": "(04)23370951",
    "Address": "台中市烏日區信義街162號1樓"
}, {
    "POIID": "863447",
    "POIName": "鼎好",
    "Telno": "(04)23380421",
    "Address": "台中市烏日區中山路2段289號"
}, {
    "POIID": "182432",
    "POIName": "榮田",
    "Telno": "(04)23362440",
    "Address": "台中市烏日區三榮路二段199號"
}, {
    "POIID": "967927",
    "POIName": "榮泉",
    "Telno": "(04)23371990",
    "Address": "台中市烏日區中山路三段1007號"
}, ], [{
    "POIID": "138907",
    "POIName": "丁台",
    "Telno": "(04)23398562",
    "Address": "台中市霧峰區四德路392號"
}, {
    "POIID": "132758",
    "POIName": "中投",
    "Telno": "(04)23302080",
    "Address": "台中市霧峰區中投西路二段388號"
}, {
    "POIID": "131951",
    "POIName": "四德",
    "Telno": "(04)23392812",
    "Address": "台中市霧峰區四德里四德路525之2號"
}, {
    "POIID": "154138",
    "POIName": "吉峰",
    "Telno": "(04)23309220",
    "Address": "台中市霧峰區德泰街9號"
}, {
    "POIID": "187312",
    "POIName": "坑口",
    "Telno": "(04)23312737",
    "Address": "台中市霧峰區中正路563號"
}, {
    "POIID": "967352",
    "POIName": "育成",
    "Telno": "(04)23334418",
    "Address": "台中市霧峰區樹仁路161-1及161-2號"
}, {
    "POIID": "166902",
    "POIName": "亞大醫",
    "Telno": "(04)23390883",
    "Address": "台中市霧峰區福新路222號B1樓"
}, {
    "POIID": "967950",
    "POIName": "亞洲一店",
    "Telno": "(04)23392765",
    "Address": "台中市霧峰區柳豐路500號"
}, {
    "POIID": "113997",
    "POIName": "易鴻",
    "Telno": "(04)23399397",
    "Address": "台中市霧峰區柳豐路422號1樓"
}, {
    "POIID": "164995",
    "POIName": "峰資",
    "Telno": "(04)23332547",
    "Address": "台中市霧峰區樹仁路26號"
}, {
    "POIID": "182867",
    "POIName": "曾厝",
    "Telno": "(04)23304246",
    "Address": "台中市霧峰區振興街32.36.38號"
}, {
    "POIID": "146997",
    "POIName": "朝科大",
    "Telno": "(04)23398840",
    "Address": "台中市霧峰區吉峰東路168號宿舍大樓"
}, {
    "POIID": "155304",
    "POIName": "朝陽大學",
    "Telno": "(04)23301489",
    "Address": "台中市霧峰區吉峰東路74號"
}, {
    "POIID": "967776",
    "POIName": "新亞大",
    "Telno": "(04)23302128",
    "Address": "台中市霧峰區中正路473號475號"
}, {
    "POIID": "153630",
    "POIName": "新峰",
    "Telno": "(04)23304476",
    "Address": "台中市霧峰區吉峰路153號"
}, {
    "POIID": "890483",
    "POIName": "新霧峰",
    "Telno": "(04)23335941",
    "Address": "台中市霧峰區中正路916號"
}, {
    "POIID": "158761",
    "POIName": "萬峰",
    "Telno": "(04)23329875",
    "Address": "台中市霧峰區中正路146-20號"
}, ], ], [], [[{
    "POIID": "138848",
    "POIName": "大竹",
    "Telno": "(04)7388101",
    "Address": "彰化縣彰化市大竹里彰南路2段181號"
}, {
    "POIID": "112385",
    "POIName": "大陽",
    "Telno": "(04)7114077",
    "Address": "彰化縣彰化市延平里大埔路405號"
}, {
    "POIID": "931179",
    "POIName": "太子哈佛",
    "Telno": "(04)7287276",
    "Address": "彰化縣彰化市泰和中街72號"
}, {
    "POIID": "111223",
    "POIName": "火車頭",
    "Telno": "(04)7221901",
    "Address": "彰化縣彰化市長樂里中正路一段536號538號"
}, {
    "POIID": "966072",
    "POIName": "台化",
    "Telno": "(04)7281512",
    "Address": "彰化縣彰化市復興里中山路3段306號"
}, {
    "POIID": "126753",
    "POIName": "巨林",
    "Telno": "(04)7111846",
    "Address": "彰化縣彰化市中山路一段286號1樓"
}, {
    "POIID": "993812",
    "POIName": "巨峰",
    "Telno": "(04)7612461",
    "Address": "彰化縣彰化市天祥路359號"
}, {
    "POIID": "887177",
    "POIName": "民生",
    "Telno": "(04)7278025",
    "Address": "彰化縣彰化市華山路27號"
}, {
    "POIID": "932002",
    "POIName": "兆詠",
    "Telno": "(04)7374661",
    "Address": "彰化縣彰化市台鳳里一德南路252號"
}, {
    "POIID": "993823",
    "POIName": "宇勝",
    "Telno": "(04)7518778",
    "Address": "彰化縣彰化市崙平里崙平北路22號"
}, {
    "POIID": "165286",
    "POIName": "安豐",
    "Telno": "(04)7624340",
    "Address": "彰化縣彰化市南安里彰鹿路166號1樓"
}, {
    "POIID": "144050",
    "POIName": "成發",
    "Telno": "(04)7617040",
    "Address": "彰化縣彰化市彰水路177號"
}, {
    "POIID": "144016",
    "POIName": "秀傳",
    "Telno": "(04)7229255",
    "Address": "彰化縣彰化市中山路1段546號1樓"
}, {
    "POIID": "921161",
    "POIName": "東芳",
    "Telno": "(04)7513705",
    "Address": "彰化縣彰化市東芳里永芳路199號"
}, {
    "POIID": "966016",
    "POIName": "欣兆陽",
    "Telno": "(04)7514876",
    "Address": "彰化縣彰化市向陽里向陽街205及207號1樓"
}, {
    "POIID": "978525",
    "POIName": "附工",
    "Telno": "(04)7290120",
    "Address": "彰化縣彰化市工校街21號"
}, {
    "POIID": "967916",
    "POIName": "沓澤",
    "Telno": "(04)7203441",
    "Address": "彰化縣彰化市彰美路一段206號208號"
}, {
    "POIID": "130224",
    "POIName": "家樂福",
    "Telno": "(04)7357208",
    "Address": "彰化縣彰化市茄苳路一段276號"
}, {
    "POIID": "177050",
    "POIName": "崙北",
    "Telno": "(04)7518161",
    "Address": "彰化縣彰化市中央路232號234號"
}, {
    "POIID": "140069",
    "POIName": "得利",
    "Telno": "(04)7618096",
    "Address": "彰化縣彰化市中華西路212號"
}, {
    "POIID": "941970",
    "POIName": "勝全",
    "Telno": "(04)7636581",
    "Address": "彰化縣彰化市林森路205號"
}, {
    "POIID": "992783",
    "POIName": "博愛",
    "Telno": "(04)7288993",
    "Address": "彰化縣彰化市光南里南校街132及130之1號1樓"
}, {
    "POIID": "931700",
    "POIName": "智富",
    "Telno": "(04)7200758",
    "Address": "彰化縣彰化市萬安里長順街170號"
}, {
    "POIID": "161790",
    "POIName": "新大埔",
    "Telno": "(04)7118047",
    "Address": "彰化縣彰化市延平里大埔路540號542號"
}, {
    "POIID": "126742",
    "POIName": "新桃源",
    "Telno": "(04)7287306",
    "Address": "彰化縣彰化市卦山里公園路一段335號"
}, {
    "POIID": "187459",
    "POIName": "新龍邸",
    "Telno": "(04)7127345",
    "Address": "彰化縣彰化市光南里中興路109號"
}, {
    "POIID": "890896",
    "POIName": "萬安",
    "Telno": "(04)7283966",
    "Address": "彰化縣彰化市三民路329號"
}, {
    "POIID": "121471",
    "POIName": "彰工",
    "Telno": "(04)7284580",
    "Address": "彰化縣彰化市復興里進德路11號13號1樓"
}, {
    "POIID": "158299",
    "POIName": "彰化",
    "Telno": "(04)7201346",
    "Address": "彰化縣彰化市長樂里中正路2段41號1樓"
}, {
    "POIID": "875369",
    "POIName": "彰和",
    "Telno": "(04)7269723",
    "Address": "彰化縣彰化市民族路163號"
}, {
    "POIID": "131375",
    "POIName": "彰泳",
    "Telno": "(04)7364752",
    "Address": "彰化縣彰化市永安街388號1樓"
}, {
    "POIID": "120320",
    "POIName": "彰泰",
    "Telno": "(04)7281709",
    "Address": "彰化縣彰化市安平街58號1樓"
}, {
    "POIID": "120490",
    "POIName": "彰馬",
    "Telno": "(04)7610492",
    "Address": "彰化縣彰化市彰馬路246號之5"
}, {
    "POIID": "138468",
    "POIName": "彰強",
    "Telno": "(04)7201342",
    "Address": "彰化縣彰化市五權里自強南路80-11號1樓"
}, {
    "POIID": "160030",
    "POIName": "彰陽",
    "Telno": "(04)7284353",
    "Address": "彰化縣彰化市中正路一段75號1樓地下室1樓"
}, {
    "POIID": "170118",
    "POIName": "彰督",
    "Telno": "(04)7228749",
    "Address": "彰化縣彰化市南校街135號1樓"
}, {
    "POIID": "951128",
    "POIName": "彰德",
    "Telno": "(04)7384178",
    "Address": "彰化縣彰化市香山里彰南路二段510號"
}, {
    "POIID": "137889",
    "POIName": "彰辭",
    "Telno": "(04)7288420",
    "Address": "彰化縣彰化市忠孝里辭修路292號"
}, {
    "POIID": "142674",
    "POIName": "彰寶",
    "Telno": "(04)7110865",
    "Address": "彰化縣彰化市介壽北路82號"
}, {
    "POIID": "129361",
    "POIName": "彰鐵",
    "Telno": "(04)7289078",
    "Address": "彰化縣彰化市三民路1號"
}, {
    "POIID": "164283",
    "POIName": "福山",
    "Telno": "(04)7370905",
    "Address": "彰化縣彰化市彰南路一段466號"
}, {
    "POIID": "132367",
    "POIName": "締寶",
    "Telno": "(04)7286690",
    "Address": "彰化縣彰化市金馬路一段358號1樓"
}, {
    "POIID": "155278",
    "POIName": "曉陽",
    "Telno": "(04)7286185",
    "Address": "彰化縣彰化市民族路341號343號1樓"
}, {
    "POIID": "136853",
    "POIName": "鑫彰安",
    "Telno": "(04)7220483",
    "Address": "彰化縣彰化市中正路2段611號"
}, ], [{
    "POIID": "950583",
    "POIName": "東崎",
    "Telno": "(04)7840668",
    "Address": "彰化縣鹿港鎮東崎里彰鹿路五段7號"
}, {
    "POIID": "166555",
    "POIName": "桂花",
    "Telno": "(04)7775251",
    "Address": "彰化縣鹿港鎮鹿東路150號1+2樓"
}, {
    "POIID": "112949",
    "POIName": "頂番",
    "Telno": "(04)7715387",
    "Address": "彰化縣鹿港鎮頂草路一段61號"
}, {
    "POIID": "971155",
    "POIName": "鹿正",
    "Telno": "(04)7769640",
    "Address": "彰化縣鹿港鎮中正路556號"
}, {
    "POIID": "952350",
    "POIName": "鹿秀",
    "Telno": "(04)7812400",
    "Address": "彰化縣鹿港鎮鹿工路6號"
}, {
    "POIID": "165356",
    "POIName": "鹿和",
    "Telno": "(04)7746247",
    "Address": "彰化縣鹿港鎮鹿和路一段273號275號"
}, {
    "POIID": "953881",
    "POIName": "鹿棋",
    "Telno": "(04)7716246",
    "Address": "彰化縣鹿港鎮溝墘里鹿和路3段438號"
}, {
    "POIID": "165367",
    "POIName": "鹿港",
    "Telno": "(04)7760627",
    "Address": "彰化縣鹿港鎮中山路257號"
}, {
    "POIID": "972170",
    "POIName": "鹿慶",
    "Telno": "(04)7715045",
    "Address": "彰化縣鹿港鎮慶安街116號"
}, {
    "POIID": "112640",
    "POIName": "鹿濱",
    "Telno": "(04)7774269",
    "Address": "彰化縣鹿港鎮彰濱五路二段392號"
}, {
    "POIID": "967400",
    "POIName": "鹿寶",
    "Telno": "(04)7710051",
    "Address": "彰化縣鹿港鎮彰頂路17號"
}, {
    "POIID": "142238",
    "POIName": "鹿鑫",
    "Telno": "(04)7773419",
    "Address": "彰化縣鹿港鎮復興路289號291號293號"
}, {
    "POIID": "922245",
    "POIName": "創新",
    "Telno": "(04)7756389",
    "Address": "彰化縣鹿港鎮順興里復興路595號1樓"
}, ], [{
    "POIID": "138686",
    "POIName": "巨航",
    "Telno": "(04)7987089",
    "Address": "彰化縣伸港鄉新港村中興路1段355號"
}, {
    "POIID": "138996",
    "POIName": "伸東",
    "Telno": "(04)7981020",
    "Address": "彰化縣伸港鄉七嘉村中華路519號"
}, {
    "POIID": "963121",
    "POIName": "伸冠",
    "Telno": "(04)7987795",
    "Address": "彰化縣伸港鄉大同村中興路二段316號"
}, {
    "POIID": "920711",
    "POIName": "伸港",
    "Telno": "(04)7987458",
    "Address": "彰化縣伸港鄉中山路190號192號"
}, {
    "POIID": "120319",
    "POIName": "伸濱",
    "Telno": "(04)7982870",
    "Address": "彰化縣伸港鄉新港路425號"
}, ], [{
    "POIID": "993465",
    "POIName": "線西",
    "Telno": "(04)7589134",
    "Address": "彰化縣線西鄉寓埔村沿海路一段892號"
}, ], [{
    "POIID": "961941",
    "POIName": "秀工",
    "Telno": "(04)7689373",
    "Address": "彰化縣秀水鄉彰水路二段795-1號"
}, {
    "POIID": "932194",
    "POIName": "秀中",
    "Telno": "(04)7699755",
    "Address": "彰化縣秀水鄉安東村中山路251號"
}, {
    "POIID": "125510",
    "POIName": "秀水",
    "Telno": "(04)7698322",
    "Address": "彰化縣秀水鄉文化街31號"
}, {
    "POIID": "113827",
    "POIName": "秀安",
    "Telno": "(04)7627910",
    "Address": "彰化縣秀水鄉安溪村彰鹿路19號"
}, {
    "POIID": "142803",
    "POIName": "秀發",
    "Telno": "(04)7684821",
    "Address": "彰化縣秀水鄉番花路臨558之7號"
}, {
    "POIID": "163648",
    "POIName": "秀鴻",
    "Telno": "(04)7688579",
    "Address": "彰化縣秀水鄉埔崙村民生街960號"
}, {
    "POIID": "180931",
    "POIName": "秀鑫",
    "Telno": "(04)7684034",
    "Address": "彰化縣秀水鄉番花路101號"
}, {
    "POIID": "922809",
    "POIName": "鶴鳴",
    "Telno": "(04)7687642",
    "Address": "彰化縣秀水鄉鶴鳴村彰鹿路362號"
}, ], [{
    "POIID": "132611",
    "POIName": "三春",
    "Telno": "(04)7875146",
    "Address": "彰化縣花壇鄉彰員路一段臨551號"
}, {
    "POIID": "116767",
    "POIName": "口庄",
    "Telno": "(04)7882970",
    "Address": "彰化縣花壇鄉中山路2段649號651號"
}, {
    "POIID": "971638",
    "POIName": "本鈿",
    "Telno": "(04)7864156",
    "Address": "彰化縣花壇鄉彰員路2段1208號1樓"
}, {
    "POIID": "862097",
    "POIName": "花壇",
    "Telno": "(04)7870374",
    "Address": "彰化縣花壇鄉中山路2段1號3號1樓"
}, {
    "POIID": "132301",
    "POIName": "長沙",
    "Telno": "(04)7861109",
    "Address": "彰化縣花壇鄉中正路130號1樓"
}, {
    "POIID": "931238",
    "POIName": "薪世麥",
    "Telno": "(04)7882902",
    "Address": "彰化縣花壇鄉長沙村彰員路二段550號552號"
}, ], [{
    "POIID": "164205",
    "POIName": "芬草",
    "Telno": "(049)2512395",
    "Address": "彰化縣芬園鄉茄荖村芬草路一段607號"
}, {
    "POIID": "165459",
    "POIName": "芬園",
    "Telno": "(049)2511565",
    "Address": "彰化縣芬園鄉彰南路四段172號及光復路6號"
}, {
    "POIID": "183136",
    "POIName": "芬農",
    "Telno": "(049)2510028",
    "Address": "彰化縣芬園鄉彰南路4段337號1樓"
}, ], [{
    "POIID": "131733",
    "POIName": "日新",
    "Telno": "(04)7773584",
    "Address": "彰化縣福興鄉番婆村彰鹿路6段547號1樓"
}, {
    "POIID": "965563",
    "POIName": "昇沅",
    "Telno": "(04)7760281",
    "Address": "彰化縣福興鄉福南村沿海路四段750號"
}, {
    "POIID": "113816",
    "POIName": "金福興",
    "Telno": "(04)7754941",
    "Address": "彰化縣福興鄉員鹿路二段198號1樓"
}, {
    "POIID": "154655",
    "POIName": "鹿東",
    "Telno": "(04)7784755",
    "Address": "彰化縣福興鄉中正路224號"
}, {
    "POIID": "883762",
    "POIName": "新香珍",
    "Telno": "(04)7684877",
    "Address": "彰化縣福興鄉彰水路56號58號60號"
}, {
    "POIID": "180779",
    "POIName": "福鹿",
    "Telno": "(04)7774193",
    "Address": "彰化縣福興鄉彰鹿路7段652.654號"
}, {
    "POIID": "122153",
    "POIName": "福環",
    "Telno": "(04)7778243",
    "Address": "彰化縣福興鄉同安村員鹿路一段439號"
}, {
    "POIID": "953744",
    "POIName": "管嶼",
    "Telno": "(04)7705499",
    "Address": "彰化縣福興鄉沿海路三段69號"
}, {
    "POIID": "968506",
    "POIName": "龍舟",
    "Telno": "(04)7764411",
    "Address": "彰化縣福興鄉福興村龍舟路15號"
}, ], [{
    "POIID": "982373",
    "POIName": "好修",
    "Telno": "(04)8656861",
    "Address": "彰化縣埔鹽鄉員鹿路二段95號"
}, {
    "POIID": "892560",
    "POIName": "埔鹽",
    "Telno": "(04)8658570",
    "Address": "彰化縣埔鹽鄉彰水路二段36號38號"
}, ], [{
    "POIID": "941903",
    "POIName": "村尚",
    "Telno": "(04)8538049",
    "Address": "彰化縣大村鄉中山路二段357號357-2號1樓"
}, {
    "POIID": "164928",
    "POIName": "村東",
    "Telno": "(04)8526618",
    "Address": "彰化縣大村鄉山腳路92之8號1樓"
}, {
    "POIID": "163682",
    "POIName": "品客",
    "Telno": "(04)8384010",
    "Address": "彰化縣大村鄉中山路1段86號"
}, {
    "POIID": "952578",
    "POIName": "美皇",
    "Telno": "(04)8533935",
    "Address": "彰化縣大村鄉山腳路72號"
}, {
    "POIID": "922898",
    "POIName": "新大村",
    "Telno": "(04)8538047",
    "Address": "彰化縣大村鄉中正西路331號1樓"
}, {
    "POIID": "888549",
    "POIName": "葉大",
    "Telno": "(04)8511147",
    "Address": "彰化縣大村鄉學府路168號"
}, {
    "POIID": "997836",
    "POIName": "鎮安",
    "Telno": "(04)8523639",
    "Address": "彰化縣大村鄉大溪路7-4號1樓"
}, ], [{
    "POIID": "967019",
    "POIName": "大員山",
    "Telno": "(04)8398846",
    "Address": "彰化縣員林市中山路一段300號"
}, {
    "POIID": "931711",
    "POIName": "金東山",
    "Telno": "(04)8365820",
    "Address": "彰化縣員林市南東里山腳路四段1號3號"
}, {
    "POIID": "137878",
    "POIName": "品冠",
    "Telno": "(04)8368549",
    "Address": "彰化縣員林市新生路278號"
}, {
    "POIID": "183240",
    "POIName": "員大",
    "Telno": "(04)8397793",
    "Address": "彰化縣員林市員大路一段374號"
}, {
    "POIID": "161907",
    "POIName": "員成",
    "Telno": "(04)8338460",
    "Address": "彰化縣員林市中山路二段216號"
}, {
    "POIID": "110459",
    "POIName": "員昌",
    "Telno": "(04)8361812",
    "Address": "彰化縣員林市黎明里12鄰南昌路70號72號1樓"
}, {
    "POIID": "126731",
    "POIName": "員東",
    "Telno": "(04)8395201",
    "Address": "彰化縣員林市三和里大同路一段8鄰238號"
}, {
    "POIID": "112215",
    "POIName": "員林",
    "Telno": "(04)8361931",
    "Address": "彰化縣員林市忠孝里4鄰員東路二段417號"
}, {
    "POIID": "144599",
    "POIName": "員林站",
    "Telno": "(04)8366760",
    "Address": "彰化縣員林市民權街55號2樓"
}, {
    "POIID": "909552",
    "POIName": "員家",
    "Telno": "(04)8393359",
    "Address": "彰化縣員林市中正路75號"
}, {
    "POIID": "160063",
    "POIName": "員勝",
    "Telno": "(04)8333464",
    "Address": "彰化縣員林市育英路131號"
}, {
    "POIID": "120478",
    "POIName": "員農",
    "Telno": "(04)8368446",
    "Address": "彰化縣員林市萬年里員水路2段19鄰433號"
}, {
    "POIID": "130877",
    "POIName": "員慶",
    "Telno": "(04)8362486",
    "Address": "彰化縣員林市山腳路一段386號"
}, {
    "POIID": "991838",
    "POIName": "家和",
    "Telno": "(04)8337781",
    "Address": "彰化縣員林市大饒里員集路二段216號"
}, {
    "POIID": "187150",
    "POIName": "真愛",
    "Telno": "(04)8331363",
    "Address": "彰化縣員林市大同路2段2號"
}, {
    "POIID": "959317",
    "POIName": "惠明",
    "Telno": "(04)8348418",
    "Address": "彰化縣員林市惠明街51號"
}, {
    "POIID": "954459",
    "POIName": "新百川",
    "Telno": "(04)8391980",
    "Address": "彰化縣員林市莒光路379號"
}, {
    "POIID": "189569",
    "POIName": "新員民",
    "Telno": "(04)8379887",
    "Address": "彰化縣員林市三民街20號"
}, {
    "POIID": "990835",
    "POIName": "新靜修",
    "Telno": "(04)8394776",
    "Address": "彰化縣員林市靜修路77號之4"
}, {
    "POIID": "143138",
    "POIName": "豐昌",
    "Telno": "(04)8337162",
    "Address": "彰化縣員林市永昌街86號1樓"
}, ], [{
    "POIID": "184519",
    "POIName": "員全",
    "Telno": "(04)8283150",
    "Address": "彰化縣埔心鄉員林大道七段22號"
}, {
    "POIID": "126535",
    "POIName": "員埔",
    "Telno": "(04)8294556",
    "Address": "彰化縣埔心鄉員鹿路二段248號"
}, {
    "POIID": "188500",
    "POIName": "埔成",
    "Telno": "(04)8281820",
    "Address": "彰化縣埔心鄉中正路一段137號139號1樓"
}, {
    "POIID": "155474",
    "POIName": "埔新",
    "Telno": "(04)8284109",
    "Address": "彰化縣埔心鄉員鹿路一段145號"
}, {
    "POIID": "968610",
    "POIName": "順心",
    "Telno": "(04)8399902",
    "Address": "彰化縣埔心鄉中山路145號147號149號"
}, {
    "POIID": "913274",
    "POIName": "彰醫",
    "Telno": "(04)8280380",
    "Address": "彰化縣埔心鄉舊館村中興路1號"
}, ], [{
    "POIID": "160029",
    "POIName": "二溪",
    "Telno": "(04)8813960",
    "Address": "彰化縣溪湖鎮二溪路一段369號"
}, {
    "POIID": "166289",
    "POIName": "向福",
    "Telno": "(04)8858331",
    "Address": "彰化縣溪湖鎮大溪路二段140號"
}, {
    "POIID": "922511",
    "POIName": "美溪",
    "Telno": "(04)8859275",
    "Address": "彰化縣溪湖鎮大溪路2段451號"
}, {
    "POIID": "967363",
    "POIName": "員鹿",
    "Telno": "(04)8823092",
    "Address": "彰化縣溪湖鎮員鹿路二段臨130號"
}, {
    "POIID": "882839",
    "POIName": "湖北",
    "Telno": "(04)8822411",
    "Address": "彰化縣溪湖鎮彰水路4段79號"
}, {
    "POIID": "131227",
    "POIName": "湖貴",
    "Telno": "(04)8850251",
    "Address": "彰化縣溪湖鎮西寮里員鹿路四段7號1樓"
}, {
    "POIID": "118822",
    "POIName": "新安可",
    "Telno": "(04)8817110",
    "Address": "彰化縣溪湖鎮西環路373號"
}, {
    "POIID": "966577",
    "POIName": "新員高",
    "Telno": "(04)8852770",
    "Address": "彰化縣溪湖鎮員鹿路一段101號"
}, {
    "POIID": "181886",
    "POIName": "溪東",
    "Telno": "(04)8856701",
    "Address": "彰化縣溪湖鎮員鹿路一段403號"
}, {
    "POIID": "845472",
    "POIName": "溪湖",
    "Telno": "(04)8821557",
    "Address": "彰化縣溪湖鎮彰水路三段105號107號109號"
}, ], [{
    "POIID": "113403",
    "POIName": "王功",
    "Telno": "(04)8933711",
    "Address": "彰化縣芳苑鄉王功村3鄰芳漢路王功段544號1樓"
}, {
    "POIID": "115890",
    "POIName": "功湖",
    "Telno": "(04)8863351",
    "Address": "彰化縣芳苑鄉建平村二溪路草二段372號"
}, {
    "POIID": "924609",
    "POIName": "芳林",
    "Telno": "(04)8981924",
    "Address": "彰化縣芳苑鄉斗苑路156號之1"
}, {
    "POIID": "121219",
    "POIName": "芳苑",
    "Telno": "(04)8951413",
    "Address": "彰化縣芳苑鄉後寮村斗苑路頂後段7號"
}, ], [{
    "POIID": "180171",
    "POIName": "欣二林",
    "Telno": "(04)8965081",
    "Address": "彰化縣二林鎮大成路一段236號"
}, {
    "POIID": "131722",
    "POIName": "挖子",
    "Telno": "(04)8681539",
    "Address": "彰化縣二林鎮華崙里二溪路七段195號197號1樓"
}, {
    "POIID": "119098",
    "POIName": "源益",
    "Telno": "(04)8962423",
    "Address": "彰化縣二林鎮斗苑路4段720號"
}, {
    "POIID": "953629",
    "POIName": "群茂",
    "Telno": "(04)8964541",
    "Address": "彰化縣二林鎮斗苑路四段159號"
}, {
    "POIID": "881641",
    "POIName": "彰基",
    "Telno": "(04)8968580",
    "Address": "彰化縣二林鎮大成路一段571號"
}, {
    "POIID": "110367",
    "POIName": "儒林",
    "Telno": "(04)8964853",
    "Address": "彰化縣二林鎮北平里仁愛路11鄰425號"
}, ], [{
    "POIID": "144588",
    "POIName": "斗苑",
    "Telno": "(04)8925951",
    "Address": "彰化縣埤頭鄉斗苑東路588號"
}, {
    "POIID": "181657",
    "POIName": "合興",
    "Telno": "(04)8928013",
    "Address": "彰化縣埤頭鄉斗苑西路406號"
}, {
    "POIID": "931618",
    "POIName": "金順利",
    "Telno": "(04)8783227",
    "Address": "彰化縣埤頭鄉和豐村斗苑東路87號89號"
}, {
    "POIID": "110356",
    "POIName": "埤頭",
    "Telno": "(04)8928985",
    "Address": "彰化縣埤頭鄉合興村彰水路3段5鄰537號"
}, {
    "POIID": "968997",
    "POIName": "路口厝",
    "Telno": "(04)8899377",
    "Address": "彰化縣埤頭鄉中和村彰水路一段臨325號"
}, {
    "POIID": "966935",
    "POIName": "彰興",
    "Telno": "(04)8920771",
    "Address": "彰化縣埤頭鄉興農村彰水路四段107號1樓"
}, ], [{
    "POIID": "953467",
    "POIName": "田正",
    "Telno": "(04)8837740",
    "Address": "彰化縣田尾鄉中山路一段191號"
}, {
    "POIID": "175098",
    "POIName": "田尾",
    "Telno": "(04)8833791",
    "Address": "彰化縣田尾鄉光復路二段752號"
}, ], [{
    "POIID": "181761",
    "POIName": "永冠",
    "Telno": "(04)8233132",
    "Address": "彰化縣永靖鄉永北村西門路142號1樓"
}, {
    "POIID": "150941",
    "POIName": "永靖",
    "Telno": "(04)8242613",
    "Address": "彰化縣永靖鄉永坡路2號"
}, {
    "POIID": "122304",
    "POIName": "湳港",
    "Telno": "(04)8230457",
    "Address": "彰化縣永靖鄉港西村中山路一段842號"
}, {
    "POIID": "971535",
    "POIName": "祿靖",
    "Telno": "(04)8247543",
    "Address": "彰化縣永靖鄉中山路2段435號437號"
}, ], [{
    "POIID": "940232",
    "POIName": "社員",
    "Telno": "(04)8725605",
    "Address": "彰化縣社頭鄉員集路三段16號"
}, {
    "POIID": "122278",
    "POIName": "社集",
    "Telno": "(04)8736715",
    "Address": "彰化縣社頭鄉員集路一段臨351號"
}, {
    "POIID": "179942",
    "POIName": "社腳",
    "Telno": "(04)8711130",
    "Address": "彰化縣社頭鄉湳雅村山腳路三段525號"
}, {
    "POIID": "970691",
    "POIName": "金佳旺",
    "Telno": "(04)8713886",
    "Address": "彰化縣社頭鄉中山路一段516號"
}, {
    "POIID": "187404",
    "POIName": "新社頭",
    "Telno": "(04)8713851",
    "Address": "彰化縣社頭鄉員集路二段279號"
}, ], [{
    "POIID": "164652",
    "POIName": "內安",
    "Telno": "(04)8746504",
    "Address": "彰化縣田中鎮碧峰里中南路2段562號"
}, {
    "POIID": "970026",
    "POIName": "加吉利",
    "Telno": "(04)8745147",
    "Address": "彰化縣田中鎮中正路276號"
}, {
    "POIID": "977371",
    "POIName": "田中",
    "Telno": "(04)8748608",
    "Address": "彰化縣田中鎮福安路144號146號"
}, {
    "POIID": "892825",
    "POIName": "田中站",
    "Telno": "(04)8746933",
    "Address": "彰化縣田中鎮中州路1號"
}, {
    "POIID": "953032",
    "POIName": "梅州里",
    "Telno": "(04)8749058",
    "Address": "彰化縣田中鎮中州路二段372號"
}, ], [{
    "POIID": "941660",
    "POIName": "中圳",
    "Telno": "(04)8783147",
    "Address": "彰化縣北斗鎮中和里斗中路319號"
}, {
    "POIID": "142722",
    "POIName": "斗金",
    "Telno": "(04)8873974",
    "Address": "彰化縣北斗鎮中正路57號1樓"
}, {
    "POIID": "150789",
    "POIName": "光政",
    "Telno": "(04)8780102",
    "Address": "彰化縣北斗鎮光復路208號"
}, {
    "POIID": "982513",
    "POIName": "新斗中",
    "Telno": "(04)8873848",
    "Address": "彰化縣北斗鎮中華路205號1樓"
}, {
    "POIID": "971627",
    "POIName": "彰苑",
    "Telno": "(04)8875268",
    "Address": "彰化縣北斗鎮斗苑路2段298之2號"
}, {
    "POIID": "167880",
    "POIName": "寶斗",
    "Telno": "(04)8870492",
    "Address": "彰化縣北斗鎮復興路281號"
}, ], [{
    "POIID": "170646",
    "POIName": "二水",
    "Telno": "(04)8793484",
    "Address": "彰化縣二水鄉員集路四段8號10號"
}, ], [{
    "POIID": "164548",
    "POIName": "明道站",
    "Telno": "(04)8872668",
    "Address": "彰化縣溪州鄉中山路4段627號"
}, {
    "POIID": "993683",
    "POIName": "新溪州",
    "Telno": "(04)8891103",
    "Address": "彰化縣溪州鄉尾厝村中山路三段474號"
}, ], [{
    "POIID": "971199",
    "POIName": "新竹塘",
    "Telno": "(04)8972918",
    "Address": "彰化縣竹塘鄉竹五路臨2號"
}, ], [{
    "POIID": "180159",
    "POIName": "明城",
    "Telno": "(04)8943106",
    "Address": "彰化縣大城鄉東城村北平路76號"
}, ], [{
    "POIID": "175102",
    "POIName": "和全",
    "Telno": "(04)7550329",
    "Address": "彰化縣和美鎮竹營里美寮路2段390號"
}, {
    "POIID": "188337",
    "POIName": "和東",
    "Telno": "(04)7557118",
    "Address": "彰化縣和美鎮愛德路27號"
}, {
    "POIID": "132231",
    "POIName": "和美",
    "Telno": "(04)7557704",
    "Address": "彰化縣和美鎮和頭路189號1樓"
}, {
    "POIID": "169635",
    "POIName": "和美仁愛",
    "Telno": "(04)7558495",
    "Address": "彰化縣和美鎮鹿和路六段臨22號"
}, {
    "POIID": "952062",
    "POIName": "和卿",
    "Telno": "(04)7562670",
    "Address": "彰化縣和美鎮和南里和卿路193號"
}, {
    "POIID": "122175",
    "POIName": "和峰",
    "Telno": "(04)7560406",
    "Address": "彰化縣和美鎮山犁里道周路6鄰279號1樓"
}, {
    "POIID": "133094",
    "POIName": "和港",
    "Telno": "(04)7564782",
    "Address": "彰化縣和美鎮和港路552號1樓"
}, {
    "POIID": "166452",
    "POIName": "和新",
    "Telno": "(04)7559878",
    "Address": "彰化縣和美鎮彰新路五段臨396號"
}, {
    "POIID": "954552",
    "POIName": "和線",
    "Telno": "(04)7350549",
    "Address": "彰化縣和美鎮嘉犁里線東路2段722號"
}, {
    "POIID": "127413",
    "POIName": "和輝",
    "Telno": "(04)7627079",
    "Address": "彰化縣和美鎮鎮平里彰草路二段臨448號"
}, {
    "POIID": "971731",
    "POIName": "和鎮",
    "Telno": "(04)7566069",
    "Address": "彰化縣和美鎮和線路323號"
}, {
    "POIID": "991160",
    "POIName": "新勝利",
    "Telno": "(04)7579421",
    "Address": "彰化縣和美鎮鹿和路6段402之2號"
}, {
    "POIID": "167167",
    "POIName": "嘉佃",
    "Telno": "(04)7358738",
    "Address": "彰化縣和美鎮彰和路三段臨51號"
}, {
    "POIID": "165714",
    "POIName": "彰美",
    "Telno": "(04)7569352",
    "Address": "彰化縣和美鎮彰美路三段385號387號"
}, {
    "POIID": "904133",
    "POIName": "德美",
    "Telno": "(04)7577337",
    "Address": "彰化縣和美鎮德美路700號"
}, {
    "POIID": "981923",
    "POIName": "糖廉",
    "Telno": "(04)7367672",
    "Address": "彰化縣和美鎮糖友一街2號"
}, ], ], [[{
    "POIID": "913229",
    "POIName": "中營",
    "Telno": "(049)2370508",
    "Address": "南投縣南投市中華路130號"
}, {
    "POIID": "970716",
    "POIName": "宏旺",
    "Telno": "(049)2245147",
    "Address": "南投縣南投市復興路38號"
}, {
    "POIID": "992185",
    "POIName": "旺泉",
    "Telno": "(049)2391405",
    "Address": "南投縣南投市中興路198號"
}, {
    "POIID": "137823",
    "POIName": "長崗",
    "Telno": "(049)2264270",
    "Address": "南投縣南投市南崗二路581號"
}, {
    "POIID": "140852",
    "POIName": "南投",
    "Telno": "(049)2242363",
    "Address": "南投縣南投市民族路289號291號293號"
}, {
    "POIID": "898351",
    "POIName": "南崗",
    "Telno": "(049)2228189",
    "Address": "南投縣南投市民族路515號"
}, {
    "POIID": "905675",
    "POIName": "南豐",
    "Telno": "(049)2223881",
    "Address": "南投縣南投市民族路66號"
}, {
    "POIID": "126764",
    "POIName": "祖祠",
    "Telno": "(049)2244378",
    "Address": "南投縣南投市祖祠路16-4號"
}, {
    "POIID": "981956",
    "POIName": "唯鑫",
    "Telno": "(049)2257141",
    "Address": "南投縣南投市南崗三路8號2樓"
}, {
    "POIID": "931180",
    "POIName": "常春藤",
    "Telno": "(049)2264496",
    "Address": "南投縣南投市工業路33號"
}, {
    "POIID": "993672",
    "POIName": "康壽",
    "Telno": "(049)2247098",
    "Address": "南投縣南投市復興路311號1樓"
}, {
    "POIID": "174017",
    "POIName": "猴探井",
    "Telno": "(049)2292842",
    "Address": "南投縣南投市八德路600之1號"
}, {
    "POIID": "940092",
    "POIName": "詠旭",
    "Telno": "(049)2207249",
    "Address": "南投縣南投市彰南路一段1031-1號"
}, {
    "POIID": "163501",
    "POIName": "樂天",
    "Telno": "(049)2247448",
    "Address": "南投縣南投市南陽路476號"
}, {
    "POIID": "894315",
    "POIName": "龍巳",
    "Telno": "(049)2244777",
    "Address": "南投縣南投市東山路408號"
}, {
    "POIID": "151645",
    "POIName": "龍辰",
    "Telno": "(049)2339252",
    "Address": "南投縣南投市中學西路61號"
}, {
    "POIID": "923466",
    "POIName": "豐億",
    "Telno": "(049)2203756",
    "Address": "南投縣南投市彰南路一段573號"
}, ], [{
    "POIID": "179908",
    "POIName": "中心園",
    "Telno": "(049)2986922",
    "Address": "南投縣埔里鎮中山路1段427號1樓"
}, {
    "POIID": "991986",
    "POIName": "中翔",
    "Telno": "(049)2993759",
    "Address": "南投縣埔里鎮中正路704號"
}, {
    "POIID": "993203",
    "POIName": "中銘",
    "Telno": "(049)2997200",
    "Address": "南投縣埔里鎮西安路一段104號"
}, {
    "POIID": "127011",
    "POIName": "中禪",
    "Telno": "(049)2987834",
    "Address": "南投縣埔里鎮西安路一段306號1樓"
}, {
    "POIID": "113274",
    "POIName": "台一",
    "Telno": "(049)2983957",
    "Address": "南投縣埔里鎮中山路一段149號"
}, {
    "POIID": "901776",
    "POIName": "東東",
    "Telno": "(049)2421161",
    "Address": "南投縣埔里鎮忠孝路138-140號"
}, {
    "POIID": "114680",
    "POIName": "恆吉",
    "Telno": "(049)2984207",
    "Address": "南投縣埔里鎮南興街172號"
}, {
    "POIID": "993052",
    "POIName": "埔佑",
    "Telno": "(049)2906748",
    "Address": "南投縣埔里鎮中華路116號1樓"
}, {
    "POIID": "126292",
    "POIName": "埔惠",
    "Telno": "(049)2916066",
    "Address": "南投縣埔里鎮大城里中山路三段546號1樓"
}, {
    "POIID": "120261",
    "POIName": "埔德",
    "Telno": "(049)2420729",
    "Address": "南投縣埔里鎮仁愛路450之2號1樓"
}, {
    "POIID": "932367",
    "POIName": "埔慶",
    "Telno": "(049)2997682",
    "Address": "南投縣埔里鎮中山路三段168號170號"
}, {
    "POIID": "153663",
    "POIName": "埔灃",
    "Telno": "(049)2903876",
    "Address": "南投縣埔里鎮中山路二段108號中華路184之2號"
}, {
    "POIID": "982306",
    "POIName": "勝財興",
    "Telno": "(049)2996495",
    "Address": "南投縣埔里鎮榮光路1-11號"
}, {
    "POIID": "121091",
    "POIName": "愛蘭",
    "Telno": "(049)2914901",
    "Address": "南投縣埔里鎮鐵山路36號1樓"
}, {
    "POIID": "902997",
    "POIName": "暨大",
    "Telno": "(049)2912612",
    "Address": "南投縣埔里鎮大學路501號"
}, {
    "POIID": "971362",
    "POIName": "暨大二",
    "Telno": "(049)2916553",
    "Address": "南投縣埔里鎮大學路1號(人文學院)"
}, {
    "POIID": "144212",
    "POIName": "龍揚",
    "Telno": "(049)2989339",
    "Address": "南投縣埔里鎮樹人路221之2號"
}, {
    "POIID": "977706",
    "POIName": "豐登",
    "Telno": "(049)2995855",
    "Address": "南投縣埔里鎮枇杷里中正路183-23號"
}, {
    "POIID": "155289",
    "POIName": "鑫潭",
    "Telno": "(049)2910310",
    "Address": "南投縣埔里鎮中山路四段97之1.97之2號"
}, ], [{
    "POIID": "111544",
    "POIName": "向日葵",
    "Telno": "(049)2354118",
    "Address": "南投縣草屯鎮芬草路三段219-1號"
}, {
    "POIID": "181303",
    "POIName": "合廣",
    "Telno": "(049)2303250",
    "Address": "南投縣草屯鎮碧山路307.309號"
}, {
    "POIID": "958691",
    "POIName": "佑民",
    "Telno": "(049)2316868",
    "Address": "南投縣草屯鎮太平路1段221號"
}, {
    "POIID": "138952",
    "POIName": "京埔",
    "Telno": "(049)2562210",
    "Address": "南投縣草屯鎮南埔里中正路254-10號"
}, {
    "POIID": "183332",
    "POIName": "京鑫",
    "Telno": "(049)2565173",
    "Address": "南投縣草屯鎮中正路483號"
}, {
    "POIID": "121736",
    "POIName": "草鞋鐓",
    "Telno": "(049)2561628",
    "Address": "南投縣草屯鎮中正路344之30號"
}, {
    "POIID": "127538",
    "POIName": "國泰",
    "Telno": "(049)2336243",
    "Address": "南投縣草屯鎮中正路636號1樓及和興街93號1樓"
}, {
    "POIID": "110219",
    "POIName": "國寶",
    "Telno": "(049)2564932",
    "Address": "南投縣草屯鎮中正路557之26號"
}, {
    "POIID": "965437",
    "POIName": "惠德",
    "Telno": "(049)2302342",
    "Address": "南投縣草屯鎮太平路二段248號250號"
}, {
    "POIID": "977577",
    "POIName": "敦和",
    "Telno": "(049)2314596",
    "Address": "南投縣草屯鎮仁愛街197號"
}, {
    "POIID": "954596",
    "POIName": "登瀛",
    "Telno": "(049)2301131",
    "Address": "南投縣草屯鎮新庄里博愛路1012號"
}, {
    "POIID": "121574",
    "POIName": "福元",
    "Telno": "(049)2318808",
    "Address": "南投縣草屯鎮中正路885號1樓"
}, {
    "POIID": "187828",
    "POIName": "福新",
    "Telno": "(049)2391643",
    "Address": "南投縣草屯鎮虎山路495號497號"
}, {
    "POIID": "966832",
    "POIName": "稻豐",
    "Telno": "(049)2305977",
    "Address": "南投縣草屯鎮新豐路351號"
}, {
    "POIID": "920054",
    "POIName": "龍星",
    "Telno": "(049)2330848",
    "Address": "南投縣草屯鎮碧山路739號"
}, {
    "POIID": "164191",
    "POIName": "龍泰",
    "Telno": "(049)2362572",
    "Address": "南投縣草屯鎮碧興路一段798-1號"
}, {
    "POIID": "154530",
    "POIName": "鴻寶",
    "Telno": "(049)2312260",
    "Address": "南投縣草屯鎮民權西路221號"
}, {
    "POIID": "126351",
    "POIName": "鑫永安",
    "Telno": "(049)2566397",
    "Address": "南投縣草屯鎮御史里登輝路558號"
}, ], [{
    "POIID": "950561",
    "POIName": "竹山大智",
    "Telno": "(049)2659214",
    "Address": "南投縣竹山鎮中山里自強路176號"
}, {
    "POIID": "110079",
    "POIName": "竹秀",
    "Telno": "(049)2625248",
    "Address": "南投縣竹山鎮集山路二段58號"
}, {
    "POIID": "992521",
    "POIName": "竹慶",
    "Telno": "(049)2658545",
    "Address": "南投縣竹山鎮竹山路92號94號1樓"
}, {
    "POIID": "132161",
    "POIName": "竹寶",
    "Telno": "(049)2659184",
    "Address": "南投縣竹山鎮延正里延正路45之30號1樓"
}, {
    "POIID": "922290",
    "POIName": "和育",
    "Telno": "(049)2648909",
    "Address": "南投縣竹山鎮大智路57號"
}, {
    "POIID": "124540",
    "POIName": "狀元",
    "Telno": "(049)2659560",
    "Address": "南投縣竹山鎮大明路500號"
}, {
    "POIID": "931168",
    "POIName": "社寮",
    "Telno": "(049)2624730",
    "Address": "南投縣竹山鎮集山路一段2051號"
}, {
    "POIID": "111005",
    "POIName": "前山",
    "Telno": "(049)2651842",
    "Address": "南投縣竹山鎮集山路三段1089號"
}, {
    "POIID": "187518",
    "POIName": "鹿山",
    "Telno": "(049)2651428",
    "Address": "南投縣竹山鎮延祥里集山路三段73號"
}, ], [{
    "POIID": "160144",
    "POIName": "集利",
    "Telno": "(049)2764506",
    "Address": "南投縣集集鎮吳厝里民生路65-1號"
}, {
    "POIID": "110208",
    "POIName": "集寶",
    "Telno": "(049)2764780",
    "Address": "南投縣集集鎮八張街75號"
}, ], [{
    "POIID": "164401",
    "POIName": "名間",
    "Telno": "(049)2738412",
    "Address": "南投縣名間鄉彰南路71之5號"
}, {
    "POIID": "954415",
    "POIName": "合心",
    "Telno": "(049)2734153",
    "Address": "南投縣名間鄉中山村彰南路218-32號"
}, {
    "POIID": "164412",
    "POIName": "雅集",
    "Telno": "(049)2734440",
    "Address": "南投縣名間鄉員集路137號"
}, ], [{
    "POIID": "141615",
    "POIName": "和雅",
    "Telno": "(049)2755979",
    "Address": "南投縣鹿谷鄉廣興村中正一路225號"
}, {
    "POIID": "900614",
    "POIName": "新鹿谷",
    "Telno": "(049)2754897",
    "Address": "南投縣鹿谷鄉仁義路148號"
}, {
    "POIID": "155441",
    "POIName": "鳳凰谷",
    "Telno": "(049)2750993",
    "Address": "南投縣鹿谷鄉中正路三段63號"
}, ], [{
    "POIID": "131825",
    "POIName": "日月潭",
    "Telno": "(049)2856426",
    "Address": "南投縣魚池鄉水社村中山路118號"
}, {
    "POIID": "122441",
    "POIName": "水社",
    "Telno": "(049)2856673",
    "Address": "南投縣魚池鄉中興路32之3號1樓"
}, {
    "POIID": "969037",
    "POIName": "伊達邵",
    "Telno": "(049)2850593",
    "Address": "南投縣魚池鄉日月村義勇街89號"
}, {
    "POIID": "902562",
    "POIName": "佳軒",
    "Telno": "(049)2899468",
    "Address": "南投縣魚池鄉魚池街350號"
}, {
    "POIID": "188348",
    "POIName": "鑫魚池",
    "Telno": "(049)2899633",
    "Address": "南投縣魚池鄉魚池街799號"
}, ], [{
    "POIID": "913355",
    "POIName": "新國姓",
    "Telno": "(049)2724347",
    "Address": "南投縣國姓鄉國姓村中興路301號"
}, ], [{
    "POIID": "113687",
    "POIName": "六合",
    "Telno": "(049)2775480",
    "Address": "南投縣水里鄉民生路175號1樓"
}, {
    "POIID": "139070",
    "POIName": "水里",
    "Telno": "(049)2777616",
    "Address": "南投縣水里鄉中山路一段63號"
}, {
    "POIID": "155588",
    "POIName": "新車埕",
    "Telno": "(049)2772732",
    "Address": "南投縣水里鄉車埕村民權巷110之1號"
}, {
    "POIID": "941741",
    "POIName": "瑞峰",
    "Telno": "(049)2777035",
    "Address": "南投縣水里鄉北埔村中山路一段540號"
}, {
    "POIID": "882079",
    "POIName": "龍寶",
    "Telno": "(049)2778956",
    "Address": "南投縣水里鄉民權路170號"
}, ], [{
    "POIID": "981222",
    "POIName": "和社",
    "Telno": "(049)2702941",
    "Address": "南投縣信義鄉同和巷8號1樓"
}, {
    "POIID": "138011",
    "POIName": "信義鄉",
    "Telno": "(049)2791077",
    "Address": "南投縣信義鄉明德村玉山路82-2號"
}, ], [{
    "POIID": "972804",
    "POIName": "小瑞士",
    "Telno": "(049)2803447",
    "Address": "南投縣仁愛鄉定遠新村28號"
}, {
    "POIID": "923765",
    "POIName": "見晴園",
    "Telno": "(049)2803691",
    "Address": "南投縣仁愛鄉大同村定遠新村路18-1號"
}, {
    "POIID": "181370",
    "POIName": "城堡",
    "Telno": "(049)2803817",
    "Address": "南投縣仁愛鄉仁和路171號"
}, {
    "POIID": "153652",
    "POIName": "恩泉",
    "Telno": "(049)2921076",
    "Address": "南投縣仁愛鄉南豐村中正路88附1號"
}, {
    "POIID": "136370",
    "POIName": "清境",
    "Telno": "(049)2802718",
    "Address": "南投縣仁愛鄉定遠新村26之1號"
}, {
    "POIID": "970510",
    "POIName": "富嘉",
    "Telno": "(049)2802133",
    "Address": "南投縣仁愛鄉仁和路223-1號"
}, {
    "POIID": "992956",
    "POIName": "霧社",
    "Telno": "(049)2802309",
    "Address": "南投縣仁愛鄉仁和路43號45號1樓"
}, ], ], [[{
    "POIID": "920478",
    "POIName": "山好",
    "Telno": "(05)5223195",
    "Address": "雲林縣斗六市崙峰里仁義路52號1樓"
}, {
    "POIID": "896045",
    "POIName": "斗六",
    "Telno": "(05)5347990",
    "Address": "雲林縣斗六市大同路41號"
}, {
    "POIID": "130202",
    "POIName": "永昌",
    "Telno": "(05)5321369",
    "Address": "雲林縣斗六市中山路269號"
}, {
    "POIID": "920489",
    "POIName": "好家庭",
    "Telno": "(05)5576530",
    "Address": "雲林縣斗六市榴中里工業路69號"
}, {
    "POIID": "185475",
    "POIName": "成苑",
    "Telno": "(05)5339622",
    "Address": "雲林縣斗六市莊敬路345號"
}, {
    "POIID": "174154",
    "POIName": "朱丹灣",
    "Telno": "(05)5514845",
    "Address": "雲林縣斗六市西平路362號"
}, {
    "POIID": "950860",
    "POIName": "育北",
    "Telno": "(05)5331163",
    "Address": "雲林縣斗六市明德北路1段110號"
}, {
    "POIID": "942146",
    "POIName": "坤麟",
    "Telno": "(05)5339597",
    "Address": "雲林縣斗六市社口里大學路二段579號"
}, {
    "POIID": "183930",
    "POIName": "昕美",
    "Telno": "(05)5334310",
    "Address": "雲林縣斗六市民生路170號"
}, {
    "POIID": "113296",
    "POIName": "東宇",
    "Telno": "(05)5343868",
    "Address": "雲林縣斗六市文化路538號540號1樓"
}, {
    "POIID": "185486",
    "POIName": "欣苑",
    "Telno": "(05)5330314",
    "Address": "雲林縣斗六市莊敬路345號1樓"
}, {
    "POIID": "153766",
    "POIName": "保庄",
    "Telno": "(05)5372683",
    "Address": "雲林縣斗六市明德北路三段285號"
}, {
    "POIID": "991931",
    "POIName": "保長",
    "Telno": "(05)5360729",
    "Address": "雲林縣斗六市雲林路二段76號1樓"
}, {
    "POIID": "922027",
    "POIName": "春流",
    "Telno": "(05)5575671",
    "Address": "雲林縣斗六市梅林里梅林路446號1樓"
}, {
    "POIID": "971096",
    "POIName": "晟業",
    "Telno": "(05)5518278",
    "Address": "雲林縣斗六市萬年路592號"
}, {
    "POIID": "830698",
    "POIName": "富盟",
    "Telno": "(05)5336375",
    "Address": "雲林縣斗六市文化路304號306號"
}, {
    "POIID": "963062",
    "POIName": "景雄",
    "Telno": "(05)5514863",
    "Address": "雲林縣斗六市虎溪里西平路521號"
}, {
    "POIID": "911267",
    "POIName": "詠順",
    "Telno": "(05)5327221",
    "Address": "雲林縣斗六市鎮北路229號"
}, {
    "POIID": "170716",
    "POIName": "雲龍",
    "Telno": "(05)5377613",
    "Address": "雲林縣斗六市龍潭路14-1號"
}, {
    "POIID": "117874",
    "POIName": "雲醫",
    "Telno": "(05)5337452",
    "Address": "雲林縣斗六市雲林路二段627號"
}, {
    "POIID": "131917",
    "POIName": "新東立",
    "Telno": "(05)5362367",
    "Address": "雲林縣斗六市成功路286號288號290號"
}, {
    "POIID": "880567",
    "POIName": "福懋",
    "Telno": "(05)5576345",
    "Address": "雲林縣斗六市石榴路196之1號"
}, {
    "POIID": "968229",
    "POIName": "福懋科",
    "Telno": "(05)5571842",
    "Address": "雲林縣斗六市河南街319號"
}, {
    "POIID": "992071",
    "POIName": "慶生",
    "Telno": "(05)5377906",
    "Address": "雲林縣斗六市漢口路167號1樓"
}, {
    "POIID": "138804",
    "POIName": "環科大",
    "Telno": "(05)5361538",
    "Address": "雲林縣斗六市鎮南路1221號1樓"
}, {
    "POIID": "990396",
    "POIName": "鑫斗商",
    "Telno": "(05)5343408",
    "Address": "雲林縣斗六市中華路207號209號1樓"
}, ], [{
    "POIID": "980045",
    "POIName": "于滿",
    "Telno": "(05)5971920",
    "Address": "雲林縣斗南鎮延平路二段581號1樓"
}, {
    "POIID": "126568",
    "POIName": "斗高",
    "Telno": "(05)5951305",
    "Address": "雲林縣斗南鎮小東里17鄰大業路86號"
}, {
    "POIID": "128254",
    "POIName": "欣怡",
    "Telno": "(05)5960866",
    "Address": "雲林縣斗南鎮南昌里中山路79號"
}, {
    "POIID": "128634",
    "POIName": "真嘉",
    "Telno": "(05)5974106",
    "Address": "雲林縣斗南鎮南昌西路1號"
}, {
    "POIID": "990466",
    "POIName": "凱瑄",
    "Telno": "(05)5962353",
    "Address": "雲林縣斗南鎮西岐里大同路135號1樓"
}, {
    "POIID": "943367",
    "POIName": "雲南",
    "Telno": "(05)5970835",
    "Address": "雲林縣斗南鎮中興路160號"
}, {
    "POIID": "139014",
    "POIName": "雲嘉",
    "Telno": "(05)5962274",
    "Address": "雲林縣斗南鎮新光里21鄰光華路231號"
}, {
    "POIID": "972114",
    "POIName": "寶宏",
    "Telno": "(05)5975581",
    "Address": "雲林縣斗南鎮文昌路99號"
}, ], [{
    "POIID": "182579",
    "POIName": "大屯",
    "Telno": "(05)6652107",
    "Address": "雲林縣虎尾鎮西屯里大屯349號"
}, {
    "POIID": "854421",
    "POIName": "工專",
    "Telno": "(05)6333495",
    "Address": "雲林縣虎尾鎮中正路307號"
}, {
    "POIID": "110600",
    "POIName": "冬念",
    "Telno": "(05)6227318",
    "Address": "雲林縣虎尾鎮埒內里林森路一段9鄰39號"
}, {
    "POIID": "131858",
    "POIName": "宇宸",
    "Telno": "(05)6320634",
    "Address": "雲林縣虎尾鎮清雲路770號"
}, {
    "POIID": "132024",
    "POIName": "李斯特",
    "Telno": "(05)6320131",
    "Address": "雲林縣虎尾鎮興南里竹圍60號"
}, {
    "POIID": "174073",
    "POIName": "東仁",
    "Telno": "(05)6327941",
    "Address": "雲林縣虎尾鎮光復路391號1樓"
}, {
    "POIID": "174246",
    "POIName": "東尊",
    "Telno": "(05)6226384",
    "Address": "雲林縣虎尾鎮惠來里142-3號"
}, {
    "POIID": "170875",
    "POIName": "東億",
    "Telno": "(05)6337003",
    "Address": "雲林縣虎尾鎮光明路3號"
}, {
    "POIID": "953445",
    "POIName": "虎大",
    "Telno": "(05)6364442",
    "Address": "雲林縣虎尾鎮工專路156號"
}, {
    "POIID": "110839",
    "POIName": "虎威",
    "Telno": "(05)6326392",
    "Address": "雲林縣虎尾鎮光復路122號1樓及成和街2號1樓"
}, {
    "POIID": "968676",
    "POIName": "虎高",
    "Telno": "(05)6629672",
    "Address": "雲林縣虎尾鎮延平里3鄰中南34之26號"
}, {
    "POIID": "112558",
    "POIName": "夏恩",
    "Telno": "(05)6330135",
    "Address": "雲林縣虎尾鎮立仁里復興路137號"
}, {
    "POIID": "121828",
    "POIName": "晟泰",
    "Telno": "(05)6365446",
    "Address": "雲林縣虎尾鎮光復路521號"
}, {
    "POIID": "155212",
    "POIName": "雲鐵",
    "Telno": "(05)7005200",
    "Address": "雲林縣虎尾鎮站前東路301號1樓"
}, {
    "POIID": "973025",
    "POIName": "新安慶",
    "Telno": "(05)6313445",
    "Address": "雲林縣虎尾鎮民主路52-1號"
}, {
    "POIID": "128265",
    "POIName": "新宗行",
    "Telno": "(05)6363071",
    "Address": "雲林縣虎尾鎮林森路二段240號1樓"
}, {
    "POIID": "921068",
    "POIName": "新湖",
    "Telno": "(05)6321877",
    "Address": "雲林縣虎尾鎮林森路二段475號"
}, {
    "POIID": "931674",
    "POIName": "綠松",
    "Telno": "(05)6332711",
    "Address": "雲林縣虎尾鎮博愛路47-6號"
}, ], [{
    "POIID": "998080",
    "POIName": "七崁",
    "Telno": "(05)5878541",
    "Address": "雲林縣西螺鎮建興路163號1樓2樓"
}, {
    "POIID": "902322",
    "POIName": "三井",
    "Telno": "(05)5878875",
    "Address": "雲林縣西螺鎮振興振興里振興路118號"
}, {
    "POIID": "943747",
    "POIName": "和心",
    "Telno": "(05)5866552",
    "Address": "雲林縣西螺鎮河南里埔心路113-3號"
}, {
    "POIID": "968816",
    "POIName": "星光",
    "Telno": "(05)5867224",
    "Address": "雲林縣西螺鎮公正路15號"
}, {
    "POIID": "110611",
    "POIName": "富來",
    "Telno": "(05)5874084",
    "Address": "雲林縣西螺鎮新豐里13鄰新社320-8號"
}, {
    "POIID": "872522",
    "POIName": "興平",
    "Telno": "(05)5870936",
    "Address": "雲林縣西螺鎮中興里延平路418號420號"
}, {
    "POIID": "144153",
    "POIName": "豐樺",
    "Telno": "(05)5875886",
    "Address": "雲林縣西螺鎮福興里中山路70號1樓"
}, {
    "POIID": "182627",
    "POIName": "豐鎮",
    "Telno": "(05)5883547",
    "Address": "雲林縣西螺鎮平和南路352號"
}, ], [{
    "POIID": "840101",
    "POIName": "土庫",
    "Telno": "(05)6624835",
    "Address": "雲林縣土庫鎮建國路164號"
}, {
    "POIID": "901684",
    "POIName": "馬光",
    "Telno": "(05)6656300",
    "Address": "雲林縣土庫鎮南平里馬光路67號"
}, ], [{
    "POIID": "968115",
    "POIName": "北英",
    "Telno": "(05)7826147",
    "Address": "雲林縣北港鎮華勝里華勝路212號"
}, {
    "POIID": "850119",
    "POIName": "北港",
    "Telno": "(05)7827717",
    "Address": "雲林縣北港鎮民主路106號"
}, {
    "POIID": "873400",
    "POIName": "民樂",
    "Telno": "(05)7838949",
    "Address": "雲林縣北港鎮華勝里28鄰民樂路39號"
}, {
    "POIID": "972826",
    "POIName": "宗聖",
    "Telno": "(05)7825129",
    "Address": "雲林縣北港鎮文仁路398號"
}, {
    "POIID": "188555",
    "POIName": "朝天宮",
    "Telno": "(05)7824873",
    "Address": "雲林縣北港鎮東華里中山路150號"
}, ], [{
    "POIID": "881009",
    "POIName": "口湖",
    "Telno": "(05)7891871",
    "Address": "雲林縣口湖鄉中正路一段222號"
}, {
    "POIID": "931652",
    "POIName": "世鑫",
    "Telno": "(05)7993396",
    "Address": "雲林縣口湖鄉崙東村中山路96-6號"
}, {
    "POIID": "982650",
    "POIName": "宜梧",
    "Telno": "(05)7905080",
    "Address": "雲林縣口湖鄉梧南村光明路31號1樓"
}, ], [{
    "POIID": "969071",
    "POIName": "三勝",
    "Telno": "(05)6915741",
    "Address": "雲林縣麥寮鄉三盛村仁德西路一段21號1樓"
}, {
    "POIID": "890793",
    "POIName": "六輕",
    "Telno": "(05)6915621",
    "Address": "雲林縣麥寮鄉中興村仁德西路二段567號1樓"
}, {
    "POIID": "952349",
    "POIName": "永茂",
    "Telno": "(05)6910642",
    "Address": "雲林縣麥寮鄉中興村豐安路951號1樓"
}, {
    "POIID": "881386",
    "POIName": "快來",
    "Telno": "(05)6917456",
    "Address": "雲林縣麥寮鄉橋頭村橋頭路234號"
}, {
    "POIID": "971568",
    "POIName": "後安",
    "Telno": "(05)6930182",
    "Address": "雲林縣麥寮鄉後安村後安路201之13號"
}, {
    "POIID": "951922",
    "POIName": "麥鄉",
    "Telno": "(05)6937775",
    "Address": "雲林縣麥寮鄉中興路78-3號"
}, {
    "POIID": "863551",
    "POIName": "麥寮",
    "Telno": "(05)6934538",
    "Address": "雲林縣麥寮鄉麥津村中山路196號"
}, {
    "POIID": "969060",
    "POIName": "麥豐",
    "Telno": "(05)6938623",
    "Address": "雲林縣麥寮鄉新興路27之5號"
}, {
    "POIID": "958635",
    "POIName": "富登",
    "Telno": "(05)6914014",
    "Address": "雲林縣麥寮鄉施厝村239號"
}, ], [{
    "POIID": "968665",
    "POIName": "安榮",
    "Telno": "(05)6553792",
    "Address": "雲林縣崙背鄉豐榮村1鄰豐榮32之3號"
}, {
    "POIID": "972505",
    "POIName": "崙中",
    "Telno": "(05)6961671",
    "Address": "雲林縣崙背鄉南陽村中山路489號"
}, {
    "POIID": "952545",
    "POIName": "崙多",
    "Telno": "(05)6963416",
    "Address": "雲林縣崙背鄉東明村正義路194號"
}, {
    "POIID": "871839",
    "POIName": "崙背",
    "Telno": "(05)6960475",
    "Address": "雲林縣崙背鄉南光路3號"
}, ], [{
    "POIID": "912112",
    "POIName": "二崙",
    "Telno": "(05)5991711",
    "Address": "雲林縣二崙鄉崙東村中山路一段269號"
}, {
    "POIID": "110297",
    "POIName": "油車",
    "Telno": "(05)5981135",
    "Address": "雲林縣二崙鄉油車村文化路9號1樓"
}, ], [{
    "POIID": "932437",
    "POIName": "大美",
    "Telno": "(05)5843730",
    "Address": "雲林縣莿桐鄉大美村大美53號1樓"
}, {
    "POIID": "114808",
    "POIName": "晟安",
    "Telno": "(05)5712839",
    "Address": "雲林縣莿桐鄉饒平村饒平路2之2號"
}, {
    "POIID": "167075",
    "POIName": "雲桐",
    "Telno": "(05)5850490",
    "Address": "雲林縣莿桐鄉莿桐村中山路70號72號1樓"
}, {
    "POIID": "982432",
    "POIName": "新莿桐",
    "Telno": "(05)5841479",
    "Address": "雲林縣莿桐鄉莿桐村中正路62-2號"
}, ], [{
    "POIID": "997906",
    "POIName": "晟興",
    "Telno": "(05)5893565",
    "Address": "雲林縣林內鄉九芎村大同路20號"
}, {
    "POIID": "967525",
    "POIName": "新林內",
    "Telno": "(05)5899113",
    "Address": "雲林縣林內鄉中正路373號375號"
}, ], [{
    "POIID": "954297",
    "POIName": "新古坑",
    "Telno": "(05)5827582",
    "Address": "雲林縣古坑鄉中山路201號"
}, {
    "POIID": "954079",
    "POIName": "劍湖",
    "Telno": "(05)5821196",
    "Address": "雲林縣古坑鄉永昌村永興路145號"
}, {
    "POIID": "991920",
    "POIName": "廣濟",
    "Telno": "(05)5264860",
    "Address": "雲林縣古坑鄉東和村廣濟路78號78之1號"
}, ], [{
    "POIID": "153951",
    "POIName": "大埤",
    "Telno": "(05)5911189",
    "Address": "雲林縣大埤鄉南和村6鄰民生路32號"
}, ], [{
    "POIID": "931962",
    "POIName": "褒忠",
    "Telno": "(05)6978101",
    "Address": "雲林縣褒忠鄉中正路99號1樓"
}, ], [{
    "POIID": "998116",
    "POIName": "元東",
    "Telno": "(05)7862645",
    "Address": "雲林縣元長鄉下寮村東興路28號1樓"
}, {
    "POIID": "158613",
    "POIName": "元長",
    "Telno": "(05)7887853",
    "Address": "雲林縣元長鄉長南村7鄰中山路32-2號1F"
}, ], [{
    "POIID": "870870",
    "POIName": "長旺",
    "Telno": "(05)6993428",
    "Address": "雲林縣東勢鄉東勢東路84號"
}, ], [{
    "POIID": "151081",
    "POIName": "五條港",
    "Telno": "(05)6980428",
    "Address": "雲林縣台西鄉五港路420-1號"
}, {
    "POIID": "115878",
    "POIName": "新台西",
    "Telno": "(05)6982903",
    "Address": "雲林縣台西鄉海南村民族路16-7號1樓"
}, ], [{
    "POIID": "184863",
    "POIName": "四湖",
    "Telno": "(05)7875093",
    "Address": "雲林縣四湖鄉村中山東路113號"
}, ], [{
    "POIID": "174958",
    "POIName": "水林",
    "Telno": "(05)7854085",
    "Address": "雲林縣水林鄉水南村水林路157號159號"
}, ], ], [[{
    "POIID": "965493",
    "POIName": "元福",
    "Telno": "(05)2775489",
    "Address": "嘉義市東區王田里林森東路288號"
}, {
    "POIID": "854498",
    "POIName": "台林",
    "Telno": "(05)2780939",
    "Address": "嘉義市東區新生路723號"
}, {
    "POIID": "187965",
    "POIName": "立宣",
    "Telno": "(05)2254565",
    "Address": "嘉義市東區立仁路120號"
}, {
    "POIID": "990248",
    "POIName": "旭豐",
    "Telno": "(05)2395797",
    "Address": "嘉義市東區溪興街107號109號1樓"
}, {
    "POIID": "130154",
    "POIName": "東嘉院",
    "Telno": "(05)2777764",
    "Address": "嘉義市東區忠孝路642號(嘉義基督教醫院門診大樓內)"
}, {
    "POIID": "941279",
    "POIName": "軍暉",
    "Telno": "(05)2308498",
    "Address": "嘉義市東區軍輝路60號"
}, {
    "POIID": "971580",
    "POIName": "新大業",
    "Telno": "(05)2285312",
    "Address": "嘉義市東區安寮里24鄰吳鳳南路194號"
}, {
    "POIID": "982454",
    "POIName": "新嘉家",
    "Telno": "(05)2166390",
    "Address": "嘉義市東區宣信里和平路103號1樓"
}, {
    "POIID": "981624",
    "POIName": "新嘉院",
    "Telno": "(05)2772846",
    "Address": "嘉義市東區忠孝路539號1樓(嘉義基督教醫院住院大樓內)"
}, {
    "POIID": "149826",
    "POIName": "新嘉商",
    "Telno": "(05)2762449",
    "Address": "嘉義市東區民權路72號1樓"
}, {
    "POIID": "951070",
    "POIName": "新嘉基",
    "Telno": "(05)2745600",
    "Address": "嘉義市東區頂庄里忠孝路650號(嘉義基督教醫院門診大樓外)"
}, {
    "POIID": "144186",
    "POIName": "義東",
    "Telno": "(05)2760974",
    "Address": "嘉義市東區東義路85號"
}, {
    "POIID": "909323",
    "POIName": "嘉工",
    "Telno": "(05)2745575",
    "Address": "嘉義市東區彌陀路240號"
}, {
    "POIID": "951601",
    "POIName": "嘉文",
    "Telno": "(05)2776182",
    "Address": "嘉義市東區盧厝里文雅街211號"
}, {
    "POIID": "111533",
    "POIName": "嘉和",
    "Telno": "(05)2236235",
    "Address": "嘉義市東區中山路169號171號173號"
}, {
    "POIID": "111500",
    "POIName": "嘉府",
    "Telno": "(05)2745579",
    "Address": "嘉義市東區民權路194號196號198號"
}, {
    "POIID": "180023",
    "POIName": "嘉林",
    "Telno": "(05)2763478",
    "Address": "嘉義市東區林森東路950號"
}, {
    "POIID": "972125",
    "POIName": "嘉英",
    "Telno": "(05)2209516",
    "Address": "嘉義市東區荖藤里忠孝北街206號"
}, {
    "POIID": "111751",
    "POIName": "嘉國",
    "Telno": "(05)2710151",
    "Address": "嘉義市東區民族路102號"
}, {
    "POIID": "112503",
    "POIName": "嘉雅",
    "Telno": "(05)2783069",
    "Address": "嘉義市東區大雅路2段421號1樓"
}, {
    "POIID": "180780",
    "POIName": "嘉義大",
    "Telno": "(05)2764674",
    "Address": "嘉義市東區學府路300號1樓"
}, {
    "POIID": "180791",
    "POIName": "嘉潭",
    "Telno": "(05)2769124",
    "Address": "嘉義市東區學府路300號1樓"
}, {
    "POIID": "116262",
    "POIName": "精城",
    "Telno": "(05)2780668",
    "Address": "嘉義市東區圳頭里林森東路720號"
}, {
    "POIID": "844882",
    "POIName": "彌陀",
    "Telno": "(05)2285187",
    "Address": "嘉義市東區芳安路1號1F"
}, {
    "POIID": "914174",
    "POIName": "蘭潭",
    "Telno": "(05)2784998",
    "Address": "嘉義市東區大雅路二段573號575號"
}, ], [{
    "POIID": "131560",
    "POIName": "八大",
    "Telno": "(05)2910423",
    "Address": "嘉義市西區保福里八德路237號"
}, {
    "POIID": "141512",
    "POIName": "北社尾",
    "Telno": "(05)2381594",
    "Address": "嘉義市西區北湖里北社尾路165號附1"
}, {
    "POIID": "993834",
    "POIName": "光彩",
    "Telno": "(05)2221535",
    "Address": "嘉義市西區民生北路182號184號1樓"
}, {
    "POIID": "182742",
    "POIName": "安捷",
    "Telno": "(05)2910730",
    "Address": "嘉義市西區保安里保安一路301.303號1樓"
}, {
    "POIID": "166500",
    "POIName": "秀泰",
    "Telno": "(05)2279175",
    "Address": "嘉義市西區國華里文化路293號1樓及2樓"
}, {
    "POIID": "941095",
    "POIName": "保愛",
    "Telno": "(05)2319768",
    "Address": "嘉義市西區新厝里捌鄰友愛路711號"
}, {
    "POIID": "874355",
    "POIName": "垂楊",
    "Telno": "(05)2854609",
    "Address": "嘉義市西區垂楊里仁愛路315號"
}, {
    "POIID": "144201",
    "POIName": "秋園",
    "Telno": "(05)2844176",
    "Address": "嘉義市西區新民路681號"
}, {
    "POIID": "141501",
    "POIName": "香湖",
    "Telno": "(05)2910784",
    "Address": "嘉義市西區香湖里文化路8鄰700號"
}, {
    "POIID": "967318",
    "POIName": "博元",
    "Telno": "(05)2353893",
    "Address": "嘉義市西區博愛路2段572號"
}, {
    "POIID": "932895",
    "POIName": "湖子內",
    "Telno": "(05)2867470",
    "Address": "嘉義市西區湖內里南京路124號"
}, {
    "POIID": "992819",
    "POIName": "圓環",
    "Telno": "(05)2291759",
    "Address": "嘉義市西區北杏里文化路155之2號1樓"
}, {
    "POIID": "171188",
    "POIName": "新車店",
    "Telno": "(05)2837702",
    "Address": "嘉義市西區福民里南京路462號1樓"
}, {
    "POIID": "981107",
    "POIName": "新港坪",
    "Telno": "(05)2837015",
    "Address": "嘉義市西區玉山路203號"
}, {
    "POIID": "184885",
    "POIName": "新瑞鴻",
    "Telno": "(05)2225301",
    "Address": "嘉義市西區文化里民族路456號458號1樓"
}, {
    "POIID": "990891",
    "POIName": "新嘉友",
    "Telno": "(05)2313680",
    "Address": "嘉義市西區竹圍里中興路241號1樓"
}, {
    "POIID": "990374",
    "POIName": "新嘉勝",
    "Telno": "(05)2316614",
    "Address": "嘉義市西區博愛路一段421號及北興街148號150號152號"
}, {
    "POIID": "137797",
    "POIName": "新嘉醫",
    "Telno": "(05)2318138",
    "Address": "嘉義市西區福全里北港路309號"
}, {
    "POIID": "110426",
    "POIName": "資砡",
    "Telno": "(05)2844049",
    "Address": "嘉義市西區港坪里玉山路422號"
}, {
    "POIID": "151461",
    "POIName": "鈺順",
    "Telno": "(05)2226313",
    "Address": "嘉義市西區新榮路35巷20號1樓"
}, {
    "POIID": "185453",
    "POIName": "嘉上",
    "Telno": "(05)2841670",
    "Address": "嘉義市西區車店里上海路147號1樓"
}, {
    "POIID": "976459",
    "POIName": "嘉北",
    "Telno": "(05)2319204",
    "Address": "嘉義市西區保安里興達路331號"
}, {
    "POIID": "980034",
    "POIName": "嘉永",
    "Telno": "(05)2253224",
    "Address": "嘉義市西區育英里民生南路129號131號1樓"
}, {
    "POIID": "113311",
    "POIName": "嘉西",
    "Telno": "(05)2380745",
    "Address": "嘉義市西區大溪里北港路13鄰597號"
}, {
    "POIID": "165482",
    "POIName": "嘉坪",
    "Telno": "(05)2355843",
    "Address": "嘉義市西區大同路455號1樓"
}, {
    "POIID": "880154",
    "POIName": "嘉洋",
    "Telno": "(05)2857922",
    "Address": "嘉義市西區民生南路600號"
}, {
    "POIID": "947679",
    "POIName": "嘉高",
    "Telno": "(05)2375597",
    "Address": "嘉義市西區北港路1062號"
}, {
    "POIID": "888136",
    "POIName": "嘉華",
    "Telno": "(05)2282273",
    "Address": "嘉義市西區仁愛路415號417號"
}, {
    "POIID": "962678",
    "POIName": "嘉義站",
    "Telno": "(05)2162023",
    "Address": "嘉義市西區中山路528號"
}, {
    "POIID": "912639",
    "POIName": "嘉達",
    "Telno": "(05)2910665",
    "Address": "嘉義市西區保安里四維路18鄰302號"
}, {
    "POIID": "934813",
    "POIName": "嘉榮",
    "Telno": "(05)2840197",
    "Address": "嘉義市西區劉厝里自強街34號"
}, {
    "POIID": "923020",
    "POIName": "嘉賓",
    "Telno": "(05)2833800",
    "Address": "嘉義市西區新西里垂楊路611號"
}, {
    "POIID": "137786",
    "POIName": "嘉德",
    "Telno": "(05)2814022",
    "Address": "嘉義市西區八德路73號"
}, ], ], [[{
    "POIID": "114587",
    "POIName": "太保",
    "Telno": "(05)3712187",
    "Address": "嘉義縣太保市後潭里後潭408-7號408-8號一樓"
}, {
    "POIID": "179850",
    "POIName": "水牛厝",
    "Telno": "(05)2385141",
    "Address": "嘉義縣太保市中山路一段210號"
}, {
    "POIID": "951265",
    "POIName": "保祥",
    "Telno": "(05)3628476",
    "Address": "嘉義縣太保市祥和三路東段226號"
}, {
    "POIID": "953847",
    "POIName": "保新",
    "Telno": "(05)3611613",
    "Address": "嘉義縣太保市舊埤里1鄰新埤5-16號"
}, {
    "POIID": "123134",
    "POIName": "祥和",
    "Telno": "(05)3713445",
    "Address": "嘉義縣太保市太保里太保46-1號"
}, {
    "POIID": "944005",
    "POIName": "祥壹",
    "Telno": "(05)3628365",
    "Address": "嘉義縣太保市祥和一路東段29號"
}, {
    "POIID": "185763",
    "POIName": "嘉太",
    "Telno": "(05)2385458",
    "Address": "嘉義縣太保市北港路二段190號"
}, {
    "POIID": "980908",
    "POIName": "嘉保",
    "Telno": "(05)2372390",
    "Address": "嘉義縣太保市麻寮里北港路2段511號"
}, ], [{
    "POIID": "970657",
    "POIName": "大木康榔",
    "Telno": "(05)3702084",
    "Address": "嘉義縣朴子市大鄉里1鄰大(木康)榔179之4號"
}, {
    "POIID": "970679",
    "POIName": "朴中",
    "Telno": "(05)3709314",
    "Address": "嘉義縣朴子市博厚里開元路282號"
}, {
    "POIID": "121611",
    "POIName": "朴天",
    "Telno": "(05)3708423",
    "Address": "嘉義縣朴子市中正里開元路18鄰161號165號"
}, {
    "POIID": "991791",
    "POIName": "朴站",
    "Telno": "(05)3705205",
    "Address": "嘉義縣朴子市平和里光復路29號1樓"
}, {
    "POIID": "151623",
    "POIName": "長朴",
    "Telno": "(05)3627493",
    "Address": "嘉義縣朴子市仁和里嘉朴路西段6-7號1樓"
}, {
    "POIID": "163567",
    "POIName": "泉翔",
    "Telno": "(05)3622480",
    "Address": "嘉義縣朴子市大葛里嘉朴路西段121號"
}, {
    "POIID": "863757",
    "POIName": "配天",
    "Telno": "(05)3795579",
    "Address": "嘉義縣朴子市大同路212號"
}, {
    "POIID": "990983",
    "POIName": "嘉庚",
    "Telno": "(05)3625798",
    "Address": "嘉義縣朴子市仁和里嘉朴路西段8號"
}, {
    "POIID": "166913",
    "POIName": "諸羅山",
    "Telno": "(05)3628878",
    "Address": "嘉義縣朴子市祥和三路西段97號1樓"
}, ], [{
    "POIID": "120951",
    "POIName": "布袋",
    "Telno": "(05)3470775",
    "Address": "嘉義縣布袋鎮興中里14鄰上海路177號"
}, {
    "POIID": "941224",
    "POIName": "布新",
    "Telno": "(05)3478625",
    "Address": "嘉義縣布袋鎮中正路63號"
}, {
    "POIID": "141431",
    "POIName": "布鹽",
    "Telno": "(05)3473010",
    "Address": "嘉義縣布袋鎮新厝里13鄰新厝仔67之1號"
}, {
    "POIID": "967020",
    "POIName": "新塭",
    "Telno": "(05)3430616",
    "Address": "嘉義縣布袋鎮復興里12鄰新塭147-3號"
}, {
    "POIID": "900119",
    "POIName": "過溝",
    "Telno": "(05)3452245",
    "Address": "嘉義縣布袋鎮中安里19鄰11號"
}, ], [{
    "POIID": "990488",
    "POIName": "大林",
    "Telno": "(05)2658688",
    "Address": "嘉義縣大林鎮西林里仁愛路23號25號27號1樓"
}, {
    "POIID": "967260",
    "POIName": "大埔美",
    "Telno": "(05)2956768",
    "Address": "嘉義縣大林鎮過溪里過溪1號"
}, {
    "POIID": "182731",
    "POIName": "合泰",
    "Telno": "(05)2956112",
    "Address": "嘉義縣大林鎮大美里19鄰大智一街1號"
}, {
    "POIID": "942618",
    "POIName": "妙禎",
    "Telno": "(05)2724919",
    "Address": "嘉義縣大林鎮中坑里南華路一段55號B1(南華大學學慧樓)"
}, {
    "POIID": "942227",
    "POIName": "梅林",
    "Telno": "(05)2649694",
    "Address": "嘉義縣大林鎮忠孝路713號715號1樓"
}, {
    "POIID": "997733",
    "POIName": "慈苑",
    "Telno": "(05)2649610",
    "Address": "嘉義縣大林鎮平林里6鄰下潭底23-5號"
}, {
    "POIID": "972701",
    "POIName": "新冠林",
    "Telno": "(05)2658971",
    "Address": "嘉義縣大林鎮新興街113號"
}, {
    "POIID": "154839",
    "POIName": "誠穩",
    "Telno": "(05)2723676",
    "Address": "嘉義縣大林鎮中坑里南華路一段55號B1F"
}, ], [{
    "POIID": "165622",
    "POIName": "中正大學",
    "Telno": "(05)2721647",
    "Address": "嘉義縣民雄鄉三興村大學路一段421號"
}, {
    "POIID": "122511",
    "POIName": "友樂",
    "Telno": "(05)2203504",
    "Address": "嘉義縣民雄鄉雙福村建國路2段146之61號1樓"
}, {
    "POIID": "940324",
    "POIName": "民工",
    "Telno": "(05)2207154",
    "Address": "嘉義縣民雄鄉北斗村北勢子73-55號1樓"
}, {
    "POIID": "896713",
    "POIName": "民城",
    "Telno": "(05)2063745",
    "Address": "嘉義縣民雄鄉東榮村四鄰建國路一段134號"
}, {
    "POIID": "991540",
    "POIName": "民雄",
    "Telno": "(05)2269835",
    "Address": "嘉義縣民雄鄉民權路42-2號1樓"
}, {
    "POIID": "165389",
    "POIName": "民興",
    "Telno": "(05)2204703",
    "Address": "嘉義縣民雄鄉興中村6鄰江厝店54-1號"
}, {
    "POIID": "871345",
    "POIName": "英巧",
    "Telno": "(05)2064736",
    "Address": "嘉義縣民雄鄉西安村西安路37號"
}, {
    "POIID": "972103",
    "POIName": "倖福",
    "Telno": "(05)2204716",
    "Address": "嘉義縣民雄鄉大崎村十四甲17-10號1樓"
}, {
    "POIID": "167318",
    "POIName": "愛樂",
    "Telno": "(05)2202418",
    "Address": "嘉義縣民雄鄉福樂村埤角547號"
}, {
    "POIID": "970509",
    "POIName": "嘉大",
    "Telno": "(05)2267243",
    "Address": "嘉義縣民雄鄉文隆村鴨母水土1-92號"
}, {
    "POIID": "162379",
    "POIName": "嘉樂",
    "Telno": "(05)2264171",
    "Address": "嘉義縣民雄鄉東榮村文化路36號1樓"
}, {
    "POIID": "151254",
    "POIName": "鳳專",
    "Telno": "(05)2064761",
    "Address": "嘉義縣民雄鄉建國路二段99號97-7號"
}, {
    "POIID": "882138",
    "POIName": "興南",
    "Telno": "(05)2202635",
    "Address": "嘉義縣民雄鄉興南村15鄰頭橋557之45"
}, {
    "POIID": "180805",
    "POIName": "錚大",
    "Telno": "(05)2264113",
    "Address": "嘉義縣民雄鄉文隆村鴨母坔85號"
}, {
    "POIID": "132091",
    "POIName": "豐收",
    "Telno": "(05)2723887",
    "Address": "嘉義縣民雄鄉豐收村大學路二段291號"
}, ], [{
    "POIID": "137731",
    "POIName": "溪口",
    "Telno": "(05)2696543",
    "Address": "嘉義縣溪口鄉坪頂村中正東路1號1樓"
}, {
    "POIID": "952590",
    "POIName": "溪旺",
    "Telno": "(05)2698939",
    "Address": "嘉義縣溪口鄉溪西村中正路8鄰229-1號"
}, ], [{
    "POIID": "902230",
    "POIName": "中洋子",
    "Telno": "(05)3774319",
    "Address": "嘉義縣新港鄉中洋村後厝子1-33號"
}, {
    "POIID": "122728",
    "POIName": "宮前",
    "Telno": "(05)3748033",
    "Address": "嘉義縣新港鄉宮前村新民路24鄰252號附1"
}, {
    "POIID": "130165",
    "POIName": "新港",
    "Telno": "(05)3749850",
    "Address": "嘉義縣新港鄉宮前村中山路72巷1號.中山路74號"
}, {
    "POIID": "921242",
    "POIName": "嘉港",
    "Telno": "(05)3744576",
    "Address": "嘉義縣新港鄉福德路116號116-1號"
}, {
    "POIID": "912798",
    "POIName": "嘉禎",
    "Telno": "(05)3740849",
    "Address": "嘉義縣新港鄉菜公村7鄰菜公厝64號附6"
}, ], [{
    "POIID": "950952",
    "POIName": "六腳",
    "Telno": "(05)7812465",
    "Address": "嘉義縣六腳鄉蘇厝村蘇厝寮153-6號"
}, {
    "POIID": "182498",
    "POIName": "朴子橋",
    "Telno": "(05)3709147",
    "Address": "嘉義縣六腳鄉正義村大橋頭190-2號"
}, {
    "POIID": "120308",
    "POIName": "蒜頭",
    "Telno": "(05)3803410",
    "Address": "嘉義縣六腳鄉蒜頭村1鄰蒜頭1-18號"
}, ], [{
    "POIID": "950686",
    "POIName": "東石",
    "Telno": "(05)3734185",
    "Address": "嘉義縣東石鄉永屯村35附18號"
}, {
    "POIID": "141420",
    "POIName": "漁人",
    "Telno": "(05)3734843",
    "Address": "嘉義縣東石鄉猿樹村東石205-1號"
}, ], [{
    "POIID": "131009",
    "POIName": "二竹",
    "Telno": "(05)3414386",
    "Address": "嘉義縣義竹鄉仁里村423號"
}, {
    "POIID": "142227",
    "POIName": "義竹",
    "Telno": "(05)3411128",
    "Address": "嘉義縣義竹鄉六桂村2鄰義竹156之1號"
}, ], [{
    "POIID": "992141",
    "POIName": "鹿草",
    "Telno": "(05)3755652",
    "Address": "嘉義縣鹿草鄉西井村20鄰528號530號1樓"
}, ], [{
    "POIID": "952394",
    "POIName": "上龍",
    "Telno": "(05)2683050",
    "Address": "嘉義縣水上鄉龍德村十一指厝75-90號"
}, {
    "POIID": "910828",
    "POIName": "中庄",
    "Telno": "(05)2892949",
    "Address": "嘉義縣水上鄉中庄村69號"
}, {
    "POIID": "871725",
    "POIName": "水上",
    "Telno": "(05)2689754",
    "Address": "嘉義縣水上鄉中興路380號"
}, {
    "POIID": "120445",
    "POIName": "水頭",
    "Telno": "(05)2680784",
    "Address": "嘉義縣水上鄉水上村中正路171號173號"
}, {
    "POIID": "121253",
    "POIName": "世川",
    "Telno": "(05)2399887",
    "Address": "嘉義縣水上鄉內溪村中義路992號1樓"
}, {
    "POIID": "151519",
    "POIName": "北回",
    "Telno": "(05)2843550",
    "Address": "嘉義縣水上鄉回歸村中山路三段167號"
}, {
    "POIID": "183446",
    "POIName": "北雄",
    "Telno": "(05)2689856",
    "Address": "嘉義縣水上鄉粗溪村中山路二段381號"
}, {
    "POIID": "982188",
    "POIName": "新兆軒",
    "Telno": "(05)2840841",
    "Address": "嘉義縣水上鄉民生村忠孝街149號151號"
}, {
    "POIID": "124562",
    "POIName": "暘民",
    "Telno": "(05)2841178",
    "Address": "嘉義縣水上鄉寬士村崎子頭159-15號1樓"
}, ], [{
    "POIID": "841001",
    "POIName": "中埔",
    "Telno": "(05)2303458",
    "Address": "嘉義縣中埔鄉和美村中山路856號"
}, {
    "POIID": "930497",
    "POIName": "合豐",
    "Telno": "(05)2531719",
    "Address": "嘉義縣中埔鄉中埔村169號1樓"
}, {
    "POIID": "165965",
    "POIName": "年代",
    "Telno": "(05)2307305",
    "Address": "嘉義縣中埔鄉中華路863號"
}, {
    "POIID": "142696",
    "POIName": "金大義",
    "Telno": "(05)2399591",
    "Address": "嘉義縣中埔鄉和美村大義路416號"
}, {
    "POIID": "111511",
    "POIName": "翁聚德",
    "Telno": "(05)2397111",
    "Address": "嘉義縣中埔鄉和睦村司公部4-20號1樓"
}, {
    "POIID": "121666",
    "POIName": "彩虹",
    "Telno": "(05)2536433",
    "Address": "嘉義縣中埔鄉隆興村3鄰汴頭60號"
}, {
    "POIID": "124573",
    "POIName": "頂六",
    "Telno": "(05)2397083",
    "Address": "嘉義縣中埔鄉金蘭村頂山門41-2號1樓"
}, {
    "POIID": "968311",
    "POIName": "雲海",
    "Telno": "(05)2539073",
    "Address": "嘉義縣中埔鄉隆興村十字路233號"
}, ], [{
    "POIID": "173689",
    "POIName": "石棹",
    "Telno": "(05)2562736",
    "Address": "嘉義縣竹崎鄉中和村石棹22-27號22-29號"
}, {
    "POIID": "972620",
    "POIName": "新竹崎",
    "Telno": "(05)2615482",
    "Address": "嘉義縣竹崎鄉和平村田寮段98號"
}, {
    "POIID": "944382",
    "POIName": "嘉崎",
    "Telno": "(05)2618518",
    "Address": "嘉義縣竹崎鄉中山路111號"
}, {
    "POIID": "944016",
    "POIName": "奮起湖",
    "Telno": "(05)2562652",
    "Address": "嘉義縣竹崎鄉中和村12鄰奮起湖178-1號"
}, {
    "POIID": "170761",
    "POIName": "灣橋",
    "Telno": "(05)2793519",
    "Address": "嘉義縣竹崎鄉灣橋村221號"
}, ], [{
    "POIID": "144175",
    "POIName": "真美",
    "Telno": "(05)2620828",
    "Address": "嘉義縣梅山鄉梅北村006鄰新興路279號"
}, {
    "POIID": "113023",
    "POIName": "梅北",
    "Telno": "(05)2622903",
    "Address": "嘉義縣梅山鄉梅北村中山路437號"
}, {
    "POIID": "991997",
    "POIName": "梅鄉",
    "Telno": "(05)2623438",
    "Address": "嘉義縣梅山鄉梅南村中山路125號1樓"
}, ], [undefined, ], [{
    "POIID": "130523",
    "POIName": "嘉埔",
    "Telno": "(05)2522214",
    "Address": "嘉義縣大埔鄉大埔村大埔276號之6壹樓"
}, ], [{
    "POIID": "179757",
    "POIName": "阿里山",
    "Telno": "(05)2679810",
    "Address": "嘉義縣阿里山鄉中山村南阿里山55號"
}, {
    "POIID": "153733",
    "POIName": "神木",
    "Telno": "(05)2679776",
    "Address": "嘉義縣阿里山鄉中正村3號2樓"
}, ], ], [[{
    "POIID": "116826",
    "POIName": "太子宮",
    "Telno": "(06)6532433",
    "Address": "台南市新營區太北里太子宮142-34號"
}, {
    "POIID": "910323",
    "POIName": "好萊富",
    "Telno": "(06)6571898",
    "Address": "台南市新營區南紙里太子路191號"
}, {
    "POIID": "970255",
    "POIName": "欣奇",
    "Telno": "(06)6328038",
    "Address": "台南市新營區新東里東興路236號"
}, {
    "POIID": "113931",
    "POIName": "新北",
    "Telno": "(06)6564239",
    "Address": "台南市新營區民治路228號1樓"
}, {
    "POIID": "992152",
    "POIName": "新高",
    "Telno": "(06)6524884",
    "Address": "台南市新營區福安里復興路762號"
}, {
    "POIID": "111821",
    "POIName": "新國",
    "Telno": "(06)6326410",
    "Address": "台南市新營區大宏里民治東路1號1樓2樓"
}, {
    "POIID": "885115",
    "POIName": "新進",
    "Telno": "(06)6327544",
    "Address": "台南市新營區中正路33之14號15號"
}, {
    "POIID": "142537",
    "POIName": "新圓",
    "Telno": "(06)6351841",
    "Address": "台南市新營區忠政里中正路2鄰121號"
}, {
    "POIID": "954448",
    "POIName": "新新復",
    "Telno": "(06)6568708",
    "Address": "台南市新營區新進路二段466號"
}, {
    "POIID": "990271",
    "POIName": "新裕新",
    "Telno": "(06)6329505",
    "Address": "台南市新營區新進路二段90號1樓"
}, {
    "POIID": "870272",
    "POIName": "新銀",
    "Telno": "(06)6328599",
    "Address": "台南市新營區中山路140號"
}, {
    "POIID": "941419",
    "POIName": "新憲",
    "Telno": "(06)6334511",
    "Address": "台南市新營區埤寮里中正路530號"
}, {
    "POIID": "141039",
    "POIName": "新醫",
    "Telno": "(06)6327488",
    "Address": "台南市新營區民權里民權路96號96-1號1樓"
}, ], [{
    "POIID": "167569",
    "POIName": "九份子",
    "Telno": "(06)3580592",
    "Address": "台南市安南區國安里九份子大道6號1樓"
}, {
    "POIID": "160052",
    "POIName": "加吉吉",
    "Telno": "(06)3550573",
    "Address": "台南市安南區新順里培安路155號"
}, {
    "POIID": "912400",
    "POIName": "本安",
    "Telno": "(06)2550963",
    "Address": "台南市安南區淵東里安中路三段360號1樓"
}, {
    "POIID": "883898",
    "POIName": "本原",
    "Telno": "(06)2464793",
    "Address": "台南市安南區海佃路4段2號"
}, {
    "POIID": "944577",
    "POIName": "本興",
    "Telno": "(06)2477987",
    "Address": "台南市安南區公學路4段180號"
}, {
    "POIID": "845597",
    "POIName": "安中",
    "Telno": "(06)2473285",
    "Address": "台南市安南區安中路一段711號"
}, {
    "POIID": "121035",
    "POIName": "安北",
    "Telno": "(06)2474698",
    "Address": "台南市安南區安中路一段546號552號"
}, {
    "POIID": "970819",
    "POIName": "安立",
    "Telno": "(06)2473773",
    "Address": "台南市安南區安中路四段150號"
}, {
    "POIID": "179986",
    "POIName": "安同",
    "Telno": "(06)2461351",
    "Address": "台南市安南區同安路235號"
}, {
    "POIID": "966290",
    "POIName": "安安",
    "Telno": "(06)2574233",
    "Address": "台南市安南區安明路4段260-70號"
}, {
    "POIID": "932714",
    "POIName": "安佃",
    "Telno": "(06)2469087",
    "Address": "台南市安南區海佃路四段548號"
}, {
    "POIID": "188164",
    "POIName": "安昌",
    "Telno": "(06)3568205",
    "Address": "台南市安南區塭南里安昌街101號"
}, {
    "POIID": "891763",
    "POIName": "安東",
    "Telno": "(06)2554045",
    "Address": "台南市安南區安和路一段308號1樓"
}, {
    "POIID": "137742",
    "POIName": "安南",
    "Telno": "(06)3554906",
    "Address": "台南市安南區安和路四段520號"
}, {
    "POIID": "151243",
    "POIName": "安傑",
    "Telno": "(06)2566011",
    "Address": "台南市安南區頂安里北安路二段480號1樓"
}, {
    "POIID": "912097",
    "POIName": "安富",
    "Telno": "(06)2599397",
    "Address": "台南市安南區安富街343號"
}, {
    "POIID": "923868",
    "POIName": "安新",
    "Telno": "(06)2457294",
    "Address": "台南市安南區長溪路三段399號1樓"
}, {
    "POIID": "174567",
    "POIName": "安學",
    "Telno": "(06)2874351",
    "Address": "台南市安南區南興里12鄰公學路5段685號一樓"
}, {
    "POIID": "130305",
    "POIName": "安醫",
    "Telno": "(06)3571237",
    "Address": "台南市安南區州南里12鄰長和路二段66號B1"
}, {
    "POIID": "780827",
    "POIName": "和順",
    "Telno": "(06)3565013",
    "Address": "台南市安南區安和路5段166號"
}, {
    "POIID": "997504",
    "POIName": "府安",
    "Telno": "(06)2507072",
    "Address": "台南市安南區溪東里北安路二段59號61號"
}, {
    "POIID": "940254",
    "POIName": "怡安",
    "Telno": "(06)3568863",
    "Address": "台南市安南區安和路2段27號之2"
}, {
    "POIID": "137993",
    "POIName": "長和",
    "Telno": "(06)3555088",
    "Address": "台南市安南區長和一街39號"
}, {
    "POIID": "965057",
    "POIName": "長溪",
    "Telno": "(06)2568719",
    "Address": "台南市安南區安慶里長溪路一段307號"
}, {
    "POIID": "909529",
    "POIName": "城中",
    "Telno": "(06)2570930",
    "Address": "台南市安南區安中路六段599號601號"
}, {
    "POIID": "943002",
    "POIName": "科工",
    "Telno": "(06)3841731",
    "Address": "台南市安南區鹽田里鹽田路2號"
}, {
    "POIID": "893482",
    "POIName": "國銨",
    "Telno": "(06)2807583",
    "Address": "台南市安南區國安街111號113號"
}, {
    "POIID": "138251",
    "POIName": "淵中",
    "Telno": "(06)2556297",
    "Address": "台南市安南區安中路3段435號437號"
}, {
    "POIID": "965105",
    "POIName": "淵安",
    "Telno": "(06)2568738",
    "Address": "台南市安南區海佃路3段163號"
}, {
    "POIID": "911256",
    "POIName": "祥安",
    "Telno": "(06)2556812",
    "Address": "台南市安南區大安街60號"
}, {
    "POIID": "921518",
    "POIName": "逢安",
    "Telno": "(06)2550832",
    "Address": "台南市安南區海西里海中街73號"
}, {
    "POIID": "188474",
    "POIName": "富里",
    "Telno": "(06)3506537",
    "Address": "台南市安南區安富里府安路5段154號155號156號"
}, {
    "POIID": "969015",
    "POIName": "新同安",
    "Telno": "(06)2461306",
    "Address": "台南市安南區理想里海佃路二段432號"
}, {
    "POIID": "980126",
    "POIName": "新安順",
    "Telno": "(06)3564170",
    "Address": "台南市安南區安和路三段55-1號57號1樓"
}, {
    "POIID": "146953",
    "POIName": "新海佃",
    "Telno": "(06)3585834",
    "Address": "台南市安南區海佃路一段239號一樓"
}, {
    "POIID": "988223",
    "POIName": "新郡安",
    "Telno": "(06)2512571",
    "Address": "台南市安南區溪北里安和路一段105號1樓"
}, {
    "POIID": "187219",
    "POIName": "鳳凰",
    "Telno": "(06)2828100",
    "Address": "台南市安南區北安路二段122號"
}, {
    "POIID": "153825",
    "POIName": "環安",
    "Telno": "(06)3571959",
    "Address": "台南市安南區長和路2段12巷272號"
}, {
    "POIID": "883256",
    "POIName": "總安",
    "Telno": "(06)3559452",
    "Address": "台南市安南區安和路四段9號"
}, {
    "POIID": "155234",
    "POIName": "總頭寮",
    "Telno": "(06)2479503",
    "Address": "台南市安南區長溪路二段416號"
}, ], [{
    "POIID": "138066",
    "POIName": "文五",
    "Telno": "(06)2988638",
    "Address": "台南市安平區國平里文平路217號"
}, {
    "POIID": "149550",
    "POIName": "永華東",
    "Telno": "(06)2984141",
    "Address": "台南市安平區永華路2段210號"
}, {
    "POIID": "930796",
    "POIName": "同發",
    "Telno": "(06)3911709",
    "Address": "台南市安平區安北路170-3號1樓"
}, {
    "POIID": "140519",
    "POIName": "安平",
    "Telno": "(06)2226940",
    "Address": "台南市安平區安平路99號"
}, {
    "POIID": "167983",
    "POIName": "安期",
    "Telno": "(06)2992927",
    "Address": "台南市安平區慶平路60號62號"
}, {
    "POIID": "982410",
    "POIName": "安運",
    "Telno": "(06)3504407",
    "Address": "台南市安平區平安里華平路742號1樓"
}, {
    "POIID": "881489",
    "POIName": "府城",
    "Telno": "(06)2973245",
    "Address": "台南市安平區永華路二段532號"
}, {
    "POIID": "165127",
    "POIName": "怡平",
    "Telno": "(06)2984002",
    "Address": "台南市安平區文平路462號1樓"
}, {
    "POIID": "188810",
    "POIName": "建平",
    "Telno": "(06)2953181",
    "Address": "台南市安平區建平七街689號"
}, {
    "POIID": "122500",
    "POIName": "昜昇",
    "Telno": "(06)2228860",
    "Address": "台南市安平區安北路12-1號1樓"
}, {
    "POIID": "187253",
    "POIName": "郡豐",
    "Telno": "(06)2936349",
    "Address": "台南市安平區郡平路307號"
}, {
    "POIID": "934732",
    "POIName": "國平",
    "Telno": "(06)2936552",
    "Address": "台南市安平區平通里國平路381號"
}, {
    "POIID": "160351",
    "POIName": "康平",
    "Telno": "(06)2933064",
    "Address": "台南市安平區健康三街81號"
}, {
    "POIID": "143389",
    "POIName": "期建",
    "Telno": "(06)2952650",
    "Address": "台南市安平區文平里建平路277號"
}, {
    "POIID": "968104",
    "POIName": "華平",
    "Telno": "(06)2939147",
    "Address": "台南市安平區健康路三段242號"
}, {
    "POIID": "123019",
    "POIName": "慶平",
    "Telno": "(06)2955284",
    "Address": "台南市安平區慶平路235號1樓"
}, {
    "POIID": "978558",
    "POIName": "慶國",
    "Telno": "(06)2951171",
    "Address": "台南市安平區慶平路531號"
}, {
    "POIID": "981602",
    "POIName": "豐平",
    "Telno": "(06)2999400",
    "Address": "台南市安平區平豐路430號1樓"
}, ], [{
    "POIID": "990499",
    "POIName": "三村",
    "Telno": "(06)2433141",
    "Address": "台南市永康區鹽行里仁愛街68號70號1樓"
}, {
    "POIID": "874399",
    "POIName": "大橋",
    "Telno": "(06)2333228",
    "Address": "台南市永康區大橋里中華路747號"
}, {
    "POIID": "171214",
    "POIName": "大灣",
    "Telno": "(06)2056060",
    "Address": "台南市永康區大灣路951號"
}, {
    "POIID": "116561",
    "POIName": "工館",
    "Telno": "(06)2734870",
    "Address": "台南市永康區崑大路195號"
}, {
    "POIID": "144131",
    "POIName": "五王",
    "Telno": "(06)3029207",
    "Address": "台南市永康區中華二路146號1樓"
}, {
    "POIID": "180621",
    "POIName": "仁發",
    "Telno": "(06)3025783",
    "Address": "台南市永康區東橋里東橋六街61號"
}, {
    "POIID": "943208",
    "POIName": "仁灣",
    "Telno": "(06)2716914",
    "Address": "台南市永康區大仁街11巷1號"
}, {
    "POIID": "890324",
    "POIName": "文炳",
    "Telno": "(06)2426265",
    "Address": "台南市永康區南台街1號"
}, {
    "POIID": "184807",
    "POIName": "台南蔡",
    "Telno": "(06)2432423",
    "Address": "台南市永康區中正南路628號"
}, {
    "POIID": "136015",
    "POIName": "正新",
    "Telno": "(06)2510140",
    "Address": "台南市永康區甲頂里大武街33號"
}, {
    "POIID": "121769",
    "POIName": "永一",
    "Telno": "(06)2030846",
    "Address": "台南市永康區正強街221號1樓"
}, {
    "POIID": "922821",
    "POIName": "永大春",
    "Telno": "(06)2011976",
    "Address": "台南市永康區中山北路431號"
}, {
    "POIID": "903392",
    "POIName": "永正",
    "Telno": "(06)2018106",
    "Address": "台南市永康區永康里中山南路537號"
}, {
    "POIID": "153777",
    "POIName": "永玉",
    "Telno": "(06)2013336",
    "Address": "台南市永康區龍潭里永明街175號"
}, {
    "POIID": "131630",
    "POIName": "永科",
    "Telno": "(06)2011492",
    "Address": "台南市永康區新樹里3鄰中山北路634巷7號"
}, {
    "POIID": "139117",
    "POIName": "永強",
    "Telno": "(06)2041184",
    "Address": "台南市永康區埔園里中正路102號"
}, {
    "POIID": "186216",
    "POIName": "永勝",
    "Telno": "(06)2362091",
    "Address": "台南市永康區六合里中華二路320號1樓"
}, {
    "POIID": "893792",
    "POIName": "永復",
    "Telno": "(06)3128173",
    "Address": "台南市永康區復華里復華一街2號"
}, {
    "POIID": "967570",
    "POIName": "永愛",
    "Telno": "(06)2726912",
    "Address": "台南市永康區北灣里文賢街80-1號"
}, {
    "POIID": "946012",
    "POIName": "永新",
    "Telno": "(06)2426149",
    "Address": "台南市永康區中正北路122號"
}, {
    "POIID": "950620",
    "POIName": "永嘉",
    "Telno": "(06)2332200",
    "Address": "台南市永康區二王路139號"
}, {
    "POIID": "143312",
    "POIName": "永龍",
    "Telno": "(06)2015546",
    "Address": "台南市永康區埔園里中山路398號"
}, {
    "POIID": "871596",
    "POIName": "玉山",
    "Telno": "(06)2011061",
    "Address": "台南市永康區永明街97號"
}, {
    "POIID": "154998",
    "POIName": "白金",
    "Telno": "(06)2013496",
    "Address": "台南市永康區復國一路357號"
}, {
    "POIID": "167916",
    "POIName": "伍鈺",
    "Telno": "(06)2050408",
    "Address": "台南市永康區永華路406號408號"
}, {
    "POIID": "169875",
    "POIName": "好巧",
    "Telno": "(06)3027920",
    "Address": "台南市永康區安康里中華西街152號"
}, {
    "POIID": "144197",
    "POIName": "安興",
    "Telno": "(06)2071941",
    "Address": "台南市永康區北灣里20鄰北興路51號"
}, {
    "POIID": "121688",
    "POIName": "西勢",
    "Telno": "(06)2073977",
    "Address": "台南市永康區西勢里富強路一段304號"
}, {
    "POIID": "182546",
    "POIName": "辰佳",
    "Telno": "(06)2059664",
    "Address": "台南市永康區永大路二段11號"
}, {
    "POIID": "954080",
    "POIName": "奇蹟",
    "Telno": "(06)2330171",
    "Address": "台南市永康區永大路3段299號"
}, {
    "POIID": "895721",
    "POIName": "尚頂",
    "Telno": "(06)2422332",
    "Address": "台南市永康區中正南路314號"
}, {
    "POIID": "164766",
    "POIName": "忠勇",
    "Telno": "(06)3121548",
    "Address": "台南市永康區成功里小東路4鄰637號1樓"
}, {
    "POIID": "941062",
    "POIName": "東江",
    "Telno": "(06)2430264",
    "Address": "台南市永康區尚頂里23鄰南台街43號1樓"
}, {
    "POIID": "131113",
    "POIName": "東橋",
    "Telno": "(06)3020234",
    "Address": "台南市永康區東橋一路28號"
}, {
    "POIID": "164700",
    "POIName": "信雄",
    "Telno": "(06)3010034",
    "Address": "台南市永康區南台街1號"
}, {
    "POIID": "166957",
    "POIName": "南台",
    "Telno": "(06)2430965",
    "Address": "台南市永康區南台街1號1樓"
}, {
    "POIID": "138022",
    "POIName": "南科大",
    "Telno": "(06)2423672",
    "Address": "台南市永康區中正路529號"
}, {
    "POIID": "146252",
    "POIName": "南瀛",
    "Telno": "(06)2435224",
    "Address": "台南市永康區鹽行里中正路299號"
}, {
    "POIID": "928829",
    "POIName": "埔園",
    "Telno": "(06)2042274",
    "Address": "台南市永康區中山路90號"
}, {
    "POIID": "910976",
    "POIName": "庭園",
    "Telno": "(06)3013799",
    "Address": "台南市永康區埔園里龍國街77號"
}, {
    "POIID": "166407",
    "POIName": "時尚",
    "Telno": "(06)2438023",
    "Address": "台南市永康區鹽洲里仁愛街19號21號1樓"
}, {
    "POIID": "967673",
    "POIName": "桂田",
    "Telno": "(06)2425413",
    "Address": "台南市永康區鹽行里新行街251號一樓"
}, {
    "POIID": "140357",
    "POIName": "砲校",
    "Telno": "(06)2021843",
    "Address": "台南市永康區中山南路566號之1"
}, {
    "POIID": "977784",
    "POIName": "崑教",
    "Telno": "(06)2056419",
    "Address": "台南市永康區崑大路195號"
}, {
    "POIID": "142308",
    "POIName": "康永",
    "Telno": "(06)2017032",
    "Address": "台南市永康區永康里永平街120號"
}, {
    "POIID": "167891",
    "POIName": "康西",
    "Telno": "(06)2059240",
    "Address": "台南市永康區永大路二段440號"
}, {
    "POIID": "179805",
    "POIName": "康橋",
    "Telno": "(06)3025271",
    "Address": "台南市永康區中山南路12-5號"
}, {
    "POIID": "991001",
    "POIName": "康興",
    "Telno": "(06)3131314",
    "Address": "台南市永康區中華路196號1樓"
}, {
    "POIID": "952280",
    "POIName": "創意",
    "Telno": "(06)2434834",
    "Address": "台南市永康區鹽行里中正二街268號"
}, {
    "POIID": "155164",
    "POIName": "復康",
    "Telno": "(06)3025276",
    "Address": "台南市永康區二王里忠孝路429巷15弄6號"
}, {
    "POIID": "149044",
    "POIName": "華東",
    "Telno": "(06)2014517",
    "Address": "台南市永康區中華路472號"
}, {
    "POIID": "111588",
    "POIName": "華康",
    "Telno": "(06)3120204",
    "Address": "台南市永康區中華路8-7號1樓"
}, {
    "POIID": "902159",
    "POIName": "詠文",
    "Telno": "(06)2042598",
    "Address": "台南市永康區網寮里6鄰永二街202號"
}, {
    "POIID": "922670",
    "POIName": "詠信",
    "Telno": "(06)2311798",
    "Address": "台南市永康區復華七街68號"
}, {
    "POIID": "111360",
    "POIName": "感恩",
    "Telno": "(06)2318063",
    "Address": "台南市永康區烏竹里自強路825-1號"
}, {
    "POIID": "186858",
    "POIName": "新奇美",
    "Telno": "(06)2834564",
    "Address": "台南市永康區甲頂路18.20號一樓"
}, {
    "POIID": "148487",
    "POIName": "新東灣",
    "Telno": "(06)2737652",
    "Address": "台南市永康區民族路186號188號1樓"
}, {
    "POIID": "132390",
    "POIName": "新家專",
    "Telno": "(06)2438639",
    "Address": "台南市永康區鹽行里中正路12鄰545號1樓"
}, {
    "POIID": "162014",
    "POIName": "新康華",
    "Telno": "(06)3036846",
    "Address": "台南市永康區大橋二街38號"
}, {
    "POIID": "951483",
    "POIName": "雋鈺",
    "Telno": "(06)2053420",
    "Address": "台南市永康區西灣里永華路157號"
}, {
    "POIID": "892179",
    "POIName": "鈺華",
    "Telno": "(06)2058076",
    "Address": "台南市永康區崑南里37鄰大仁街220號"
}, {
    "POIID": "970174",
    "POIName": "鈺廣",
    "Telno": "(06)2715212",
    "Address": "台南市永康區大灣里民族路409號一樓"
}, {
    "POIID": "905343",
    "POIName": "精工",
    "Telno": "(06)2422132",
    "Address": "台南市永康區中正北路735號"
}, {
    "POIID": "141914",
    "POIName": "蔦松",
    "Telno": "(06)2536295",
    "Address": "台南市永康區中正北路431號433號"
}, {
    "POIID": "151494",
    "POIName": "臻品",
    "Telno": "(06)3026702",
    "Address": "台南市永康區三合里中山東路117號119號1樓"
}, {
    "POIID": "143884",
    "POIName": "臻鈺",
    "Telno": "(06)3123073",
    "Address": "台南市永康區勝利里18鄰勝學路226號"
}, {
    "POIID": "958761",
    "POIName": "興灣",
    "Telno": "(06)2059495",
    "Address": "台南市永康區大灣路591號"
}, {
    "POIID": "993351",
    "POIName": "雙永",
    "Telno": "(06)2031437",
    "Address": "台南市永康區永大一路60號1樓"
}, {
    "POIID": "997995",
    "POIName": "瓏埔",
    "Telno": "(06)2023184",
    "Address": "台南市永康區龍埔街108號"
}, {
    "POIID": "931386",
    "POIName": "鹽行",
    "Telno": "(06)2437395",
    "Address": "台南市永康區鹽洲里鹽洲二街83號"
}, {
    "POIID": "966991",
    "POIName": "鹽信",
    "Telno": "(06)2434808",
    "Address": "台南市永康區正南一街148號"
}, {
    "POIID": "116181",
    "POIName": "灣中",
    "Telno": "(06)2720510",
    "Address": "台南市永康區大灣路62號"
}, ], [{
    "POIID": "185305",
    "POIName": "大欣",
    "Telno": "(06)3581640",
    "Address": "台南市北區和緯路5段76號"
}, {
    "POIID": "165149",
    "POIName": "小北",
    "Telno": "(06)2810537",
    "Address": "台南市北區西門路四段455號"
}, {
    "POIID": "177371",
    "POIName": "丹比",
    "Telno": "(06)2822350",
    "Address": "台南市北區六甲里西門路四段332號"
}, {
    "POIID": "855055",
    "POIName": "公平",
    "Telno": "(06)2511415",
    "Address": "台南市北區公園路694號"
}, {
    "POIID": "822169",
    "POIName": "公園",
    "Telno": "(06)2813005",
    "Address": "台南市北區公園路1072-1號2號3號"
}, {
    "POIID": "180757",
    "POIName": "文成",
    "Telno": "(06)3588424",
    "Address": "台南市北區文元里文成路775號"
}, {
    "POIID": "174110",
    "POIName": "文賢",
    "Telno": "(06)2593008",
    "Address": "台南市北區文賢路1116號"
}, {
    "POIID": "184667",
    "POIName": "北安",
    "Telno": "(06)2814051",
    "Address": "台南市北區公園路599-11號"
}, {
    "POIID": "123112",
    "POIName": "北育",
    "Telno": "(06)2516477",
    "Address": "台南市北區成德里北安路一段189號"
}, {
    "POIID": "860688",
    "POIName": "立人",
    "Telno": "(06)2205089",
    "Address": "台南市北區和順里西門路三段81號"
}, {
    "POIID": "180872",
    "POIName": "成大",
    "Telno": "(06)2756065",
    "Address": "台南市北區勝利路138號B1樓"
}, {
    "POIID": "132910",
    "POIName": "成醫",
    "Telno": "(06)2088905",
    "Address": "台南市北區小東路35號(成大醫院門診一樓)"
}, {
    "POIID": "139265",
    "POIName": "西門",
    "Telno": "(06)2511673",
    "Address": "台南市北區西門路四段132號"
}, {
    "POIID": "137122",
    "POIName": "育德",
    "Telno": "(06)2502040",
    "Address": "台南市北區民德路87號"
}, {
    "POIID": "163785",
    "POIName": "和緯",
    "Telno": "(06)2830287",
    "Address": "台南市北區成功里和緯路二段252號"
}, {
    "POIID": "117520",
    "POIName": "東都",
    "Telno": "(06)2220909",
    "Address": "台南市北區成功路140號"
}, {
    "POIID": "120386",
    "POIName": "東森",
    "Telno": "(06)2341552",
    "Address": "台南市北區林森路3段76號78號"
}, {
    "POIID": "153973",
    "POIName": "修齊",
    "Telno": "(06)2293723",
    "Address": "台南市北區成功路54號"
}, {
    "POIID": "953191",
    "POIName": "常勝",
    "Telno": "(06)2751056",
    "Address": "台南市北區長榮里長勝路1號"
}, {
    "POIID": "181495",
    "POIName": "康健",
    "Telno": "(06)2525923",
    "Address": "台南市北區北門路三段49號"
}, {
    "POIID": "944278",
    "POIName": "康榮",
    "Telno": "(06)2822304",
    "Address": "台南市北區實踐里北門路3段2號"
}, {
    "POIID": "962863",
    "POIName": "湖美",
    "Telno": "(06)2805492",
    "Address": "台南市北區大豐里27鄰中華北路一段143號"
}, {
    "POIID": "138387",
    "POIName": "華園",
    "Telno": "(06)2218726",
    "Address": "台南市北區北門里公園南路71號"
}, {
    "POIID": "981635",
    "POIName": "新大港",
    "Telno": "(06)3507047",
    "Address": "台南市北區大和里大港街140號1樓2樓"
}, {
    "POIID": "990042",
    "POIName": "新海成",
    "Telno": "(06)2281334",
    "Address": "台南市北區海安路三段2號1樓"
}, {
    "POIID": "871747",
    "POIName": "聖賢",
    "Telno": "(06)2587164",
    "Address": "台南市北區大豐里文賢路315號"
}, {
    "POIID": "943714",
    "POIName": "道成",
    "Telno": "(06)2517084",
    "Address": "台南市北區北門路二段500號"
}, {
    "POIID": "130671",
    "POIName": "鈺勝",
    "Telno": "(06)2007620",
    "Address": "台南市北區小東路307巷75號77號1樓"
}, {
    "POIID": "153814",
    "POIName": "德緯",
    "Telno": "(06)2525864",
    "Address": "台南市北區成德里育德二路20鄰308號"
}, {
    "POIID": "116734",
    "POIName": "鄭子寮",
    "Telno": "(06)2526031",
    "Address": "台南市北區成德里38鄰北成路442號"
}, {
    "POIID": "143873",
    "POIName": "龍成",
    "Telno": "(06)2232679",
    "Address": "台南市北區成功路2號"
}, {
    "POIID": "935735",
    "POIName": "豐盛",
    "Telno": "(06)2362556",
    "Address": "台南市北區勝利路192號194號"
}, {
    "POIID": "982443",
    "POIName": "寶園",
    "Telno": "(06)2366671",
    "Address": "台南市北區元寶里北園街78號78-1號78-2號78-3號1樓"
}, ], [{
    "POIID": "165699",
    "POIName": "仙草埔",
    "Telno": "(06)6832662",
    "Address": "台南市白河區仙草里仙草6之30號"
}, {
    "POIID": "114532",
    "POIName": "白河",
    "Telno": "(06)6859907",
    "Address": "台南市白河區永安里17鄰國泰路101號"
}, {
    "POIID": "188887",
    "POIName": "東耕",
    "Telno": "(06)6832143",
    "Address": "台南市白河區河東里9鄰糞箕湖122-135號"
}, {
    "POIID": "181598",
    "POIName": "東楨",
    "Telno": "(06)6856583",
    "Address": "台南市白河區永安里新興路507號一樓"
}, {
    "POIID": "122588",
    "POIName": "新蓮鄉",
    "Telno": "(06)6858752",
    "Address": "台南市白河區永安里大德街150號1樓"
}, {
    "POIID": "944555",
    "POIName": "鈺善",
    "Telno": "(06)6832854",
    "Address": "台南市白河區昇安里1鄰三間厝2-56號"
}, ], [{
    "POIID": "885997",
    "POIName": "千福",
    "Telno": "(06)2996714",
    "Address": "台南市中西區大涼里中華西路二段36號"
}, {
    "POIID": "139335",
    "POIName": "大五",
    "Telno": "(06)2137794",
    "Address": "台南市中西區法華里大同路一段218號220號"
}, {
    "POIID": "149273",
    "POIName": "大府",
    "Telno": "(06)2229190",
    "Address": "台南市中西區府前路二段115號1樓2樓"
}, {
    "POIID": "886325",
    "POIName": "友愛",
    "Telno": "(06)2112975",
    "Address": "台南市中西區友愛街197之199號"
}, {
    "POIID": "127022",
    "POIName": "天公",
    "Telno": "(06)2213646",
    "Address": "台南市中西區忠義路二段109號"
}, {
    "POIID": "123156",
    "POIName": "水仙宮",
    "Telno": "(06)2217930",
    "Address": "台南市中西區水仙里民權路三段87號1樓"
}, {
    "POIID": "189662",
    "POIName": "永福",
    "Telno": "(06)2214463",
    "Address": "台南市中西區永福路二段65號1樓"
}, {
    "POIID": "165677",
    "POIName": "赤崁",
    "Telno": "(06)2214411",
    "Address": "台南市中西區民族路二段331號"
}, {
    "POIID": "130280",
    "POIName": "和善",
    "Telno": "(06)2266922",
    "Address": "台南市中西區藥王里民族路三段6鄰277號1樓"
}, {
    "POIID": "173564",
    "POIName": "府醫",
    "Telno": "(06)2211627",
    "Address": "台南市中西區赤崁里中山路125號"
}, {
    "POIID": "171708",
    "POIName": "明珠",
    "Telno": "(06)2230803",
    "Address": "台南市中西區公正里民族路二段53號"
}, {
    "POIID": "842060",
    "POIName": "武聖",
    "Telno": "(06)2800754",
    "Address": "台南市中西區武聖路47號49號"
}, {
    "POIID": "936484",
    "POIName": "武德",
    "Telno": "(06)2258549",
    "Address": "台南市中西區青年路134號"
}, {
    "POIID": "136598",
    "POIName": "南門城",
    "Telno": "(06)2147717",
    "Address": "台南市中西區南門路229號1樓"
}, {
    "POIID": "992820",
    "POIName": "南英",
    "Telno": "(06)2144007",
    "Address": "台南市中西區永福路一段30號32號1樓"
}, {
    "POIID": "129213",
    "POIName": "南醫",
    "Telno": "(06)2263238",
    "Address": "台南市中西區民族路二段76號之13"
}, {
    "POIID": "163969",
    "POIName": "郡王",
    "Telno": "(06)2204652",
    "Address": "台南市中西區府前路一段144號"
}, {
    "POIID": "990905",
    "POIName": "康樂",
    "Telno": "(06)2228184",
    "Address": "台南市中西區安海里康樂街223號1樓2樓"
}, {
    "POIID": "896333",
    "POIName": "頂美",
    "Telno": "(06)2595480",
    "Address": "台南市中西區西和路1號3號"
}, {
    "POIID": "159133",
    "POIName": "晶越",
    "Telno": "(06)3031015",
    "Address": "台南市中西區西門路一段658號B2"
}, {
    "POIID": "119696",
    "POIName": "湖華",
    "Telno": "(06)2507460",
    "Address": "台南市中西區西湖街3號"
}, {
    "POIID": "895857",
    "POIName": "開山",
    "Telno": "(06)2144197",
    "Address": "台南市中西區開山路245號"
}, {
    "POIID": "148410",
    "POIName": "新永健",
    "Telno": "(06)2143314",
    "Address": "台南市中西區健康路一段346號"
}, {
    "POIID": "968805",
    "POIName": "新永華",
    "Telno": "(06)2112375",
    "Address": "台南市中西區永華路248號"
}, {
    "POIID": "117807",
    "POIName": "新森榮",
    "Telno": "(06)2222795",
    "Address": "台南市中西區成功路451號453號"
}, {
    "POIID": "973014",
    "POIName": "新運河",
    "Telno": "(06)2950782",
    "Address": "台南市中西區府前路2段239號1樓"
}, {
    "POIID": "167134",
    "POIName": "綜合",
    "Telno": "(06)2215930",
    "Address": "台南市中西區水仙里民生路二段26號28號1樓"
}, {
    "POIID": "140542",
    "POIName": "鎮山",
    "Telno": "(06)3508724",
    "Address": "台南市中西區西湖里湖美街10號"
}, {
    "POIID": "905136",
    "POIName": "體育",
    "Telno": "(06)2149434",
    "Address": "台南市中西區健康路166號"
}, ], [{
    "POIID": "982096",
    "POIName": "新朝琴",
    "Telno": "(06)6525540",
    "Address": "台南市鹽水區岸內里朝琴路143號1樓"
}, {
    "POIID": "116620",
    "POIName": "歡雅",
    "Telno": "(06)6553117",
    "Address": "台南市鹽水區歡雅里26號"
}, {
    "POIID": "187208",
    "POIName": "鹽水",
    "Telno": "(06)6534572",
    "Address": "台南市鹽水區中正路35號"
}, {
    "POIID": "114705",
    "POIName": "鹽生",
    "Telno": "(06)6529626",
    "Address": "台南市鹽水區南門路1號"
}, {
    "POIID": "150848",
    "POIName": "鹽金",
    "Telno": "(06)6526971",
    "Address": "台南市鹽水區義稠里8鄰義稠110之19號"
}, {
    "POIID": "966212",
    "POIName": "鹽新",
    "Telno": "(06)6522984",
    "Address": "台南市鹽水區橋南里忠孝路93號"
}, ], [{
    "POIID": "167569",
    "POIName": "九份子",
    "Telno": "(06)3580592",
    "Address": "台南市安南區國安里九份子大道6號1樓"
}, {
    "POIID": "131423",
    "POIName": "土定富",
    "Telno": "(06)2636173",
    "Address": "台南市南區田寮里大成路二段86號88號"
}, {
    "POIID": "141800",
    "POIName": "大忠",
    "Telno": "(06)2143221",
    "Address": "台南市南區大忠里中華南路一段178號"
}, {
    "POIID": "865797",
    "POIName": "大恩",
    "Telno": "(06)2890509",
    "Address": "台南市南區大同路二段692號694號"
}, {
    "POIID": "906726",
    "POIName": "公道",
    "Telno": "(06)2233412",
    "Address": "台南市南區夏林路1-16號"
}, {
    "POIID": "971498",
    "POIName": "少觀",
    "Telno": "(06)2134175",
    "Address": "台南市南區大林路113號"
}, {
    "POIID": "170185",
    "POIName": "文南",
    "Telno": "(06)2635645",
    "Address": "台南市南區健康路2段270號"
}, {
    "POIID": "160052",
    "POIName": "加吉吉",
    "Telno": "(06)3550573",
    "Address": "台南市安南區新順里培安路155號"
}, {
    "POIID": "912400",
    "POIName": "本安",
    "Telno": "(06)2550963",
    "Address": "台南市安南區淵東里安中路三段360號1樓"
}, {
    "POIID": "883898",
    "POIName": "本原",
    "Telno": "(06)2464793",
    "Address": "台南市安南區海佃路4段2號"
}, {
    "POIID": "944577",
    "POIName": "本興",
    "Telno": "(06)2477987",
    "Address": "台南市安南區公學路4段180號"
}, {
    "POIID": "943666",
    "POIName": "正旺",
    "Telno": "(06)2628861",
    "Address": "台南市南區明興路917號"
}, {
    "POIID": "894407",
    "POIName": "立興",
    "Telno": "(06)2629520",
    "Address": "台南市南區灣裡路265號"
}, {
    "POIID": "150882",
    "POIName": "全興",
    "Telno": "(06)2643866",
    "Address": "台南市南區新樂路72號"
}, {
    "POIID": "845597",
    "POIName": "安中",
    "Telno": "(06)2473285",
    "Address": "台南市安南區安中路一段711號"
}, {
    "POIID": "121035",
    "POIName": "安北",
    "Telno": "(06)2474698",
    "Address": "台南市安南區安中路一段546號552號"
}, {
    "POIID": "970819",
    "POIName": "安立",
    "Telno": "(06)2473773",
    "Address": "台南市安南區安中路四段150號"
}, {
    "POIID": "179986",
    "POIName": "安同",
    "Telno": "(06)2461351",
    "Address": "台南市安南區同安路235號"
}, {
    "POIID": "966290",
    "POIName": "安安",
    "Telno": "(06)2574233",
    "Address": "台南市安南區安明路4段260-70號"
}, {
    "POIID": "932714",
    "POIName": "安佃",
    "Telno": "(06)2469087",
    "Address": "台南市安南區海佃路四段548號"
}, {
    "POIID": "188164",
    "POIName": "安昌",
    "Telno": "(06)3568205",
    "Address": "台南市安南區塭南里安昌街101號"
}, {
    "POIID": "891763",
    "POIName": "安東",
    "Telno": "(06)2554045",
    "Address": "台南市安南區安和路一段308號1樓"
}, {
    "POIID": "137742",
    "POIName": "安南",
    "Telno": "(06)3554906",
    "Address": "台南市安南區安和路四段520號"
}, {
    "POIID": "151243",
    "POIName": "安傑",
    "Telno": "(06)2566011",
    "Address": "台南市安南區頂安里北安路二段480號1樓"
}, {
    "POIID": "912097",
    "POIName": "安富",
    "Telno": "(06)2599397",
    "Address": "台南市安南區安富街343號"
}, {
    "POIID": "923868",
    "POIName": "安新",
    "Telno": "(06)2457294",
    "Address": "台南市安南區長溪路三段399號1樓"
}, {
    "POIID": "174567",
    "POIName": "安學",
    "Telno": "(06)2874351",
    "Address": "台南市安南區南興里12鄰公學路5段685號一樓"
}, {
    "POIID": "130305",
    "POIName": "安醫",
    "Telno": "(06)3571237",
    "Address": "台南市安南區州南里12鄰長和路二段66號B1"
}, {
    "POIID": "158820",
    "POIName": "西濱",
    "Telno": "(06)2657574",
    "Address": "台南市南區中華南路二段317號319號"
}, {
    "POIID": "780827",
    "POIName": "和順",
    "Telno": "(06)3565013",
    "Address": "台南市安南區安和路5段166號"
}, {
    "POIID": "997504",
    "POIName": "府安",
    "Telno": "(06)2507072",
    "Address": "台南市安南區溪東里北安路二段59號61號"
}, {
    "POIID": "940254",
    "POIName": "怡安",
    "Telno": "(06)3568863",
    "Address": "台南市安南區安和路2段27號之2"
}, {
    "POIID": "132172",
    "POIName": "明和",
    "Telno": "(06)2642546",
    "Address": "台南市南區中華西路一段89號"
}, {
    "POIID": "990385",
    "POIName": "金都",
    "Telno": "(06)2614924",
    "Address": "台南市南區金華路一段235號1樓"
}, {
    "POIID": "137993",
    "POIName": "長和",
    "Telno": "(06)3555088",
    "Address": "台南市安南區長和一街39號"
}, {
    "POIID": "965057",
    "POIName": "長溪",
    "Telno": "(06)2568719",
    "Address": "台南市安南區安慶里長溪路一段307號"
}, {
    "POIID": "114222",
    "POIName": "南都",
    "Telno": "(06)2614604",
    "Address": "台南市南區金華路一段27號1樓"
}, {
    "POIID": "137801",
    "POIName": "南德",
    "Telno": "(06)2625457",
    "Address": "台南市南區中華南路二段101之1號"
}, {
    "POIID": "909529",
    "POIName": "城中",
    "Telno": "(06)2570930",
    "Address": "台南市安南區安中路六段599號601號"
}, {
    "POIID": "171177",
    "POIName": "建華",
    "Telno": "(06)2611004",
    "Address": "台南市南區文華里中華西路一段438號"
}, {
    "POIID": "943002",
    "POIName": "科工",
    "Telno": "(06)3841731",
    "Address": "台南市安南區鹽田里鹽田路2號"
}, {
    "POIID": "864668",
    "POIName": "夏林",
    "Telno": "(06)2288192",
    "Address": "台南市南區夏林路134-1號134-2號"
}, {
    "POIID": "985822",
    "POIName": "國民",
    "Telno": "(06)2603696",
    "Address": "台南市南區國民路150號152號"
}, {
    "POIID": "946643",
    "POIName": "國宅",
    "Telno": "(06)2917993",
    "Address": "台南市南區新興路441號"
}, {
    "POIID": "893482",
    "POIName": "國銨",
    "Telno": "(06)2807583",
    "Address": "台南市安南區國安街111號113號"
}, {
    "POIID": "138251",
    "POIName": "淵中",
    "Telno": "(06)2556297",
    "Address": "台南市安南區安中路3段435號437號"
}, {
    "POIID": "965105",
    "POIName": "淵安",
    "Telno": "(06)2568738",
    "Address": "台南市安南區海佃路3段163號"
}, {
    "POIID": "911256",
    "POIName": "祥安",
    "Telno": "(06)2556812",
    "Address": "台南市安南區大安街60號"
}, {
    "POIID": "921518",
    "POIName": "逢安",
    "Telno": "(06)2550832",
    "Address": "台南市安南區海西里海中街73號"
}, {
    "POIID": "901466",
    "POIName": "喜樹",
    "Telno": "(06)2963467",
    "Address": "台南市南區喜東里10鄰明興路732號"
}, {
    "POIID": "188474",
    "POIName": "富里",
    "Telno": "(06)3506537",
    "Address": "台南市安南區安富里府安路5段154號155號156號"
}, {
    "POIID": "969015",
    "POIName": "新同安",
    "Telno": "(06)2461306",
    "Address": "台南市安南區理想里海佃路二段432號"
}, {
    "POIID": "980126",
    "POIName": "新安順",
    "Telno": "(06)3564170",
    "Address": "台南市安南區安和路三段55-1號57號1樓"
}, {
    "POIID": "982236",
    "POIName": "新府緯",
    "Telno": "(06)2281213",
    "Address": "台南市南區西門路一段553號1樓"
}, {
    "POIID": "146953",
    "POIName": "新海佃",
    "Telno": "(06)3585834",
    "Address": "台南市安南區海佃路一段239號一樓"
}, {
    "POIID": "988223",
    "POIName": "新郡安",
    "Telno": "(06)2512571",
    "Address": "台南市安南區溪北里安和路一段105號1樓"
}, {
    "POIID": "132149",
    "POIName": "新興",
    "Telno": "(06)2637118",
    "Address": "台南市南區光明里新興路6鄰529號531號1樓"
}, {
    "POIID": "187219",
    "POIName": "鳳凰",
    "Telno": "(06)2828100",
    "Address": "台南市安南區北安路二段122號"
}, {
    "POIID": "132253",
    "POIName": "樂豐",
    "Telno": "(06)2630401",
    "Address": "台南市南區新都路460號"
}, {
    "POIID": "153825",
    "POIName": "環安",
    "Telno": "(06)3571959",
    "Address": "台南市安南區長和路2段12巷272號"
}, {
    "POIID": "883256",
    "POIName": "總安",
    "Telno": "(06)3559452",
    "Address": "台南市安南區安和路四段9號"
}, {
    "POIID": "155234",
    "POIName": "總頭寮",
    "Telno": "(06)2479503",
    "Address": "台南市安南區長溪路二段416號"
}, {
    "POIID": "968780",
    "POIName": "鯤鯓",
    "Telno": "(06)2648213",
    "Address": "台南市南區南都里鯤鯓路20號"
}, ], [{
    "POIID": "965345",
    "POIName": "小腳腿",
    "Telno": "(06)6230327",
    "Address": "台南市柳營區重溪里義士路一段938號"
}, {
    "POIID": "153939",
    "POIName": "宜翔",
    "Telno": "(06)6226815",
    "Address": "台南市柳營區中埕里中山西路二段10鄰61號"
}, {
    "POIID": "860459",
    "POIName": "柳營",
    "Telno": "(06)6223592",
    "Address": "台南市柳營區士林里柳營路二段1號3號"
}, {
    "POIID": "121172",
    "POIName": "新工",
    "Telno": "(06)6225476",
    "Address": "台南市柳營區東昇里中山西路一段2號1樓"
}, {
    "POIID": "167802",
    "POIName": "新天地",
    "Telno": "(06)6223507",
    "Address": "台南市柳營區太康里22鄰201-10號"
}, ], [{
    "POIID": "854557",
    "POIName": "一心",
    "Telno": "(06)2084962",
    "Address": "台南市東區中華東路一段24號"
}, {
    "POIID": "164951",
    "POIName": "力大",
    "Telno": "(06)2683042",
    "Address": "台南市東區生產路299號"
}, {
    "POIID": "184645",
    "POIName": "小東",
    "Telno": "(06)2341994",
    "Address": "台南市東區小東路256號"
}, {
    "POIID": "967639",
    "POIName": "仁文",
    "Telno": "(06)3362101",
    "Address": "台南市東區仁和路57-7號59號1樓"
}, {
    "POIID": "865535",
    "POIName": "北門",
    "Telno": "(06)2292308",
    "Address": "台南市東區北門路1段310號"
}, {
    "POIID": "880419",
    "POIName": "古都",
    "Telno": "(06)2894755",
    "Address": "台南市東區仁和路133號"
}, {
    "POIID": "182177",
    "POIName": "台南站",
    "Telno": "(06)2234149",
    "Address": "台南市東區北門路二段4號"
}, {
    "POIID": "874757",
    "POIName": "市醫",
    "Telno": "(06)2673784",
    "Address": "台南市東區崇德路685號687號"
}, {
    "POIID": "950974",
    "POIName": "立東",
    "Telno": "(06)2691015",
    "Address": "台南市東區東門路3段220號"
}, {
    "POIID": "962771",
    "POIName": "吉吉好",
    "Telno": "(06)2906462",
    "Address": "台南市東區崇德路670號"
}, {
    "POIID": "950273",
    "POIName": "好富",
    "Telno": "(06)2353005",
    "Address": "台南市東區富強里裕農路320號"
}, {
    "POIID": "144980",
    "POIName": "自由",
    "Telno": "(06)2908094",
    "Address": "台南市東區和平里自由路二段37號"
}, {
    "POIID": "972435",
    "POIName": "育樂",
    "Telno": "(06)2096748",
    "Address": "台南市東區大學里勝利路116號"
}, {
    "POIID": "144968",
    "POIName": "東和",
    "Telno": "(06)2087403",
    "Address": "台南市東區東安路291號293號1樓"
}, {
    "POIID": "118660",
    "POIName": "東城",
    "Telno": "(06)2694483",
    "Address": "台南市東區中華東路二段293號"
}, {
    "POIID": "996718",
    "POIName": "東凱",
    "Telno": "(06)2091722",
    "Address": "台南市東區東安路102號"
}, {
    "POIID": "174693",
    "POIName": "東發",
    "Telno": "(06)2908238",
    "Address": "台南市東區中華東路3段379號"
}, {
    "POIID": "916516",
    "POIName": "東敬",
    "Telno": "(06)2755113",
    "Address": "台南市東區莊敬路90號"
}, {
    "POIID": "144979",
    "POIName": "東澓",
    "Telno": "(06)2673539",
    "Address": "台南市東區富農街一段167號1樓"
}, {
    "POIID": "165264",
    "POIName": "東龍",
    "Telno": "(06)2008630",
    "Address": "台南市東區東門路一段362號"
}, {
    "POIID": "833055",
    "POIName": "長寧",
    "Telno": "(06)2363597",
    "Address": "台南市東區長榮路三段12號"
}, {
    "POIID": "915203",
    "POIName": "長榮",
    "Telno": "(06)2381098",
    "Address": "台南市東區長榮路3段139號"
}, {
    "POIID": "173885",
    "POIName": "帝標",
    "Telno": "(06)2602997",
    "Address": "台南市東區龍山街109號111號"
}, {
    "POIID": "935779",
    "POIName": "致聖",
    "Telno": "(06)2235686",
    "Address": "台南市東區北門路二段12號"
}, {
    "POIID": "992440",
    "POIName": "席悅",
    "Telno": "(06)2388933",
    "Address": "台南市東區東光里東興路138號1樓"
}, {
    "POIID": "112075",
    "POIName": "財神",
    "Telno": "(06)2894503",
    "Address": "台南市東區中華東路2段171-177號"
}, {
    "POIID": "822790",
    "POIName": "崇明",
    "Telno": "(06)2678084",
    "Address": "台南市東區林森路1段184號"
}, {
    "POIID": "113193",
    "POIName": "崇祐",
    "Telno": "(06)2902815",
    "Address": "台南市東區崇成里崇明路561號1樓"
}, {
    "POIID": "991643",
    "POIName": "崇華",
    "Telno": "(06)2601426",
    "Address": "台南市東區崇善路259號1樓"
}, {
    "POIID": "886668",
    "POIName": "崇道",
    "Telno": "(06)2894813",
    "Address": "台南市東區崇善路571號"
}, {
    "POIID": "149332",
    "POIName": "崇學",
    "Telno": "(06)2604847",
    "Address": "台南市東區崇善路168號"
}, {
    "POIID": "947912",
    "POIName": "祥發",
    "Telno": "(06)2386965",
    "Address": "台南市東區裕豐街187號1樓"
}, {
    "POIID": "166544",
    "POIName": "富裕",
    "Telno": "(06)2091395",
    "Address": "台南市東區後甲里裕農路657號1樓"
}, {
    "POIID": "860448",
    "POIName": "森田",
    "Telno": "(06)2742079",
    "Address": "台南市東區東門里東門路一段199號"
}, {
    "POIID": "165138",
    "POIName": "新東",
    "Telno": "(06)2382073",
    "Address": "台南市東區林森路二段84號"
}, {
    "POIID": "941693",
    "POIName": "新東育",
    "Telno": "(06)2360105",
    "Address": "台南市東區大學路西段53號1樓2樓"
}, {
    "POIID": "982616",
    "POIName": "新新樓",
    "Telno": "(06)2360434",
    "Address": "台南市東區東門里前鋒路16號1樓"
}, {
    "POIID": "130970",
    "POIName": "裕文",
    "Telno": "(06)2909325",
    "Address": "台南市東區裕學路1號"
}, {
    "POIID": "965264",
    "POIName": "裕平",
    "Telno": "(06)3318240",
    "Address": "台南市東區關聖里裕信路177號1樓"
}, {
    "POIID": "952291",
    "POIName": "裕信",
    "Telno": "(06)3316406",
    "Address": "台南市東區裕信路352號"
}, {
    "POIID": "951379",
    "POIName": "裕興",
    "Telno": "(06)3317671",
    "Address": "台南市東區復興里裕文路76號1樓"
}, {
    "POIID": "166061",
    "POIName": "裕豐",
    "Telno": "(06)2351946",
    "Address": "台南市東區東門路2段291號"
}, {
    "POIID": "188991",
    "POIName": "鼎亨",
    "Telno": "(06)2908425",
    "Address": "台南市東區德東街101號"
}, {
    "POIID": "111809",
    "POIName": "榮譽",
    "Telno": "(06)2677923",
    "Address": "台南市東區榮譽街86號86-1號1樓"
}, {
    "POIID": "956846",
    "POIName": "福耀",
    "Telno": "(06)2690374",
    "Address": "台南市東區崇明路377號377-1號"
}, {
    "POIID": "895673",
    "POIName": "億載",
    "Telno": "(06)2145092",
    "Address": "台南市東區大同路二段95-3號"
}, {
    "POIID": "958602",
    "POIName": "德光",
    "Telno": "(06)2607217",
    "Address": "台南市東區崇德路269號"
}, {
    "POIID": "946193",
    "POIName": "慶東",
    "Telno": "(06)2352796",
    "Address": "台南市東區青年路416號"
}, ], [{
    "POIID": "903152",
    "POIName": "後壁",
    "Telno": "(06)6873221",
    "Address": "台南市後壁區後壁里後壁71號"
}, {
    "POIID": "132862",
    "POIName": "菁寮",
    "Telno": "(06)6621468",
    "Address": "台南市後壁區墨林里346號"
}, {
    "POIID": "931489",
    "POIName": "蓮營",
    "Telno": "(06)6358177",
    "Address": "台南市後壁區福安里200號"
}, ], [{
    "POIID": "131146",
    "POIName": "東山站",
    "Telno": "(06)6234071",
    "Address": "台南市東山區科里里枋子林74-6號"
}, {
    "POIID": "113517",
    "POIName": "東美",
    "Telno": "(06)6805521",
    "Address": "台南市東山區中興路1號"
}, {
    "POIID": "932574",
    "POIName": "東勝",
    "Telno": "(06)6805308",
    "Address": "台南市東山區東山里235號"
}, {
    "POIID": "124676",
    "POIName": "崇原",
    "Telno": "(06)6861774",
    "Address": "台南市東山區東原里24鄰前大埔191號1樓"
}, ], [{
    "POIID": "179573",
    "POIName": "代天府",
    "Telno": "(06)7864826",
    "Address": "台南市北門區鯤江里976號"
}, {
    "POIID": "921655",
    "POIName": "南鯤鯓",
    "Telno": "(06)7864853",
    "Address": "台南市北門區鯤江里841-1號"
}, ], [{
    "POIID": "881308",
    "POIName": "超順",
    "Telno": "(06)7831793",
    "Address": "台南市學甲區中正路143號"
}, {
    "POIID": "130969",
    "POIName": "夢公園",
    "Telno": "(06)7833506",
    "Address": "台南市學甲區中山路187號1樓"
}, {
    "POIID": "153744",
    "POIName": "學甲",
    "Telno": "(06)7835596",
    "Address": "台南市學甲區仁得里華宗路321號"
}, {
    "POIID": "164489",
    "POIName": "學成",
    "Telno": "(06)7821204",
    "Address": "台南市學甲區慈生里中正路296號"
}, ], [{
    "POIID": "931836",
    "POIName": "上營",
    "Telno": "(06)6890923",
    "Address": "台南市下營區中營里1286號"
}, {
    "POIID": "990167",
    "POIName": "新下營",
    "Telno": "(06)6890134",
    "Address": "台南市下營區下營里中山路一段46號48號1樓"
}, ], [{
    "POIID": "132482",
    "POIName": "七甲",
    "Telno": "(06)6981130",
    "Address": "台南市六甲區六甲里中正路321之1號"
}, {
    "POIID": "863252",
    "POIName": "六甲",
    "Telno": "(06)6992090",
    "Address": "台南市六甲區六甲里22鄰中正路552號"
}, {
    "POIID": "130110",
    "POIName": "林鳳營",
    "Telno": "(06)6989753",
    "Address": "台南市六甲區中社里林鳳營111-8號1樓"
}, ], [{
    "POIID": "971878",
    "POIName": "楠西",
    "Telno": "(06)5753552",
    "Address": "台南市楠西區鹿田里11鄰油車61號之10"
}, {
    "POIID": "167798",
    "POIName": "趣淘",
    "Telno": "(06)5754886",
    "Address": "台南市楠西區密枝里密枝102之5號1樓"
}, ], [{
    "POIID": "132596",
    "POIName": "將軍",
    "Telno": "(06)7945691",
    "Address": "台南市將軍區長榮里長榮29之2號"
}, {
    "POIID": "951760",
    "POIName": "將富",
    "Telno": "(06)7946598",
    "Address": "台南市將軍區將富里49之八號"
}, ], [{
    "POIID": "143851",
    "POIName": "子龍",
    "Telno": "(06)7265194",
    "Address": "台南市佳里區子龍里1鄰子良廟3-1號"
}, {
    "POIID": "122131",
    "POIName": "佳文",
    "Telno": "(06)7238343",
    "Address": "台南市佳里區佳西路215號1樓"
}, {
    "POIID": "980012",
    "POIName": "佳立",
    "Telno": "(06)7229051",
    "Address": "台南市佳里區新生東路1號1樓"
}, {
    "POIID": "175009",
    "POIName": "佳成",
    "Telno": "(06)7266010",
    "Address": "台南市佳里區興化里佳里興492-50號"
}, {
    "POIID": "791241",
    "POIName": "佳里",
    "Telno": "(06)7233631",
    "Address": "台南市佳里區光復路197號197-1號"
}, {
    "POIID": "120397",
    "POIName": "佳龍",
    "Telno": "(06)7237042",
    "Address": "台南市佳里區建南里勝利路216號1樓"
}, {
    "POIID": "143862",
    "POIName": "南龍",
    "Telno": "(06)7224188",
    "Address": "台南市佳里區建南里安南路22鄰256號"
}, {
    "POIID": "112525",
    "POIName": "新北中",
    "Telno": "(06)7225387",
    "Address": "台南市佳里區延平路195號"
}, {
    "POIID": "990156",
    "POIName": "新佳忠",
    "Telno": "(06)7237374",
    "Address": "台南市佳里區安西里忠孝路212號1樓"
}, {
    "POIID": "981059",
    "POIName": "新佳興",
    "Telno": "(06)7224825",
    "Address": "台南市佳里區東寧里文化路196號1樓"
}, ], [{
    "POIID": "120777",
    "POIName": "台首大",
    "Telno": "(06)5718413",
    "Address": "台南市麻豆區南勢里168號1樓"
}, {
    "POIID": "965600",
    "POIName": "麻中",
    "Telno": "(06)5719834",
    "Address": "台南市麻豆區南勢里南勢36-205號"
}, {
    "POIID": "880143",
    "POIName": "麻佳",
    "Telno": "(06)5702885",
    "Address": "台南市麻豆區苓子林17-13號"
}, {
    "POIID": "954183",
    "POIName": "麻善",
    "Telno": "(06)5718004",
    "Address": "台南市麻豆區晉江里民權路10-1號"
}, {
    "POIID": "931478",
    "POIName": "麻新",
    "Telno": "(06)5719211",
    "Address": "台南市麻豆區中正路289號"
}, {
    "POIID": "970358",
    "POIName": "麻學",
    "Telno": "(06)5704806",
    "Address": "台南市麻豆區大山里8鄰大山腳1之80號"
}, {
    "POIID": "120087",
    "POIName": "新麻豆",
    "Telno": "(06)5717493",
    "Address": "台南市麻豆區榖興里11鄰中山路11號"
}, {
    "POIID": "968263",
    "POIName": "新曾文",
    "Telno": "(06)5714049",
    "Address": "台南市麻豆區東角里興中路177號179號"
}, {
    "POIID": "188496",
    "POIName": "新黎明",
    "Telno": "(06)5710761",
    "Address": "台南市麻豆區興國路40-10號"
}, ], [{
    "POIID": "967086",
    "POIName": "二鎮",
    "Telno": "(06)6982725",
    "Address": "台南市官田區二區里工社西街25巷81號"
}, {
    "POIID": "923547",
    "POIName": "南藝",
    "Telno": "(06)6930253",
    "Address": "台南市官田區大崎里66號"
}, {
    "POIID": "942607",
    "POIName": "烏山頭",
    "Telno": "(06)6985149",
    "Address": "台南市官田區湖山里98-4號98-5號"
}, {
    "POIID": "871714",
    "POIName": "隆田",
    "Telno": "(06)5791099",
    "Address": "台南市官田區隆田里14鄰文化街130號"
}, ], [{
    "POIID": "970277",
    "POIName": "新大內",
    "Telno": "(06)5763553",
    "Address": "台南市大內區石城里石子瀨122之153號"
}, ], [{
    "POIID": "872360",
    "POIName": "玉井",
    "Telno": "(06)5749605",
    "Address": "台南市玉井區中正路54號"
}, {
    "POIID": "982889",
    "POIName": "新玉馥",
    "Telno": "(06)5748078",
    "Address": "台南市玉井區玉田里中山路97號1樓號中華路255-1號1樓"
}, ], [{
    "POIID": "183181",
    "POIName": "南化",
    "Telno": "(06)5775209",
    "Address": "台南市南化區南化里128號1樓"
}, ], [{
    "POIID": "903439",
    "POIName": "七股",
    "Telno": "(06)7872182",
    "Address": "台南市七股區七股里14鄰154-1號"
}, {
    "POIID": "111153",
    "POIName": "大埕",
    "Telno": "(06)7873054",
    "Address": "台南市七股區大埕里272號1樓"
}, ], [{
    "POIID": "165079",
    "POIName": "西港",
    "Telno": "(06)7954784",
    "Address": "台南市西港區西港里中山路366-1號"
}, {
    "POIID": "138675",
    "POIName": "後營",
    "Telno": "(06)7950374",
    "Address": "台南市西港區營西里1號"
}, {
    "POIID": "882552",
    "POIName": "慶安",
    "Telno": "(06)7956671",
    "Address": "台南市西港區慶安里新興街25-2號"
}, ], [{
    "POIID": "965633",
    "POIName": "安高",
    "Telno": "(06)5976231",
    "Address": "台南市安定區港尾里港子尾37-28號"
}, {
    "POIID": "116011",
    "POIName": "海寮",
    "Telno": "(06)5937359",
    "Address": "台南市安定區海寮里海寮街8號"
}, {
    "POIID": "112673",
    "POIName": "港達",
    "Telno": "(06)5935442",
    "Address": "台南市安定區港口里245-10號1樓"
}, {
    "POIID": "873363",
    "POIName": "港龍",
    "Telno": "(06)5937738",
    "Address": "台南市安定區港南里163號"
}, {
    "POIID": "126993",
    "POIName": "善安",
    "Telno": "(06)5975843",
    "Address": "台南市安定區蘇林里7號"
}, {
    "POIID": "971487",
    "POIName": "新吉",
    "Telno": "(06)5937776",
    "Address": "台南市安定區新吉里新吉126之12_126之13號"
}, {
    "POIID": "182502",
    "POIName": "新安發",
    "Telno": "(06)5975449",
    "Address": "台南市安定區安加里安定407號"
}, ], [{
    "POIID": "167020",
    "POIName": "P1廠",
    "Telno": "(06)5057528",
    "Address": "台南市善化區南科北路1之1號1樓"
}, {
    "POIID": "153755",
    "POIName": "P7廠",
    "Telno": "(06)5057202",
    "Address": "台南市善化區南關里三抱竹路1號"
}, {
    "POIID": "942652",
    "POIName": "六分寮",
    "Telno": "(06)5850190",
    "Address": "台南市善化區田寮里六分寮74-1號74-2號"
}, {
    "POIID": "951874",
    "POIName": "牛墟",
    "Telno": "(06)5814527",
    "Address": "台南市善化區什乃里什乃190號"
}, {
    "POIID": "153940",
    "POIName": "邦品廠",
    "Telno": "(06)5057220",
    "Address": "台南市善化區環西路二段3號"
}, {
    "POIID": "127158",
    "POIName": "松美",
    "Telno": "(06)5851826",
    "Address": "台南市善化區小新里成功路2-2號"
}, {
    "POIID": "150985",
    "POIName": "茄拔",
    "Telno": "(06)5851407",
    "Address": "台南市善化區嘉北里13鄰352號"
}, {
    "POIID": "112422",
    "POIName": "晶圓",
    "Telno": "(06)5056103",
    "Address": "台南市善化區南科北路1-1號(P3廠)"
}, {
    "POIID": "136978",
    "POIName": "善文",
    "Telno": "(06)5811531",
    "Address": "台南市善化區中山路518號"
}, {
    "POIID": "138262",
    "POIName": "善成",
    "Telno": "(06)5854215",
    "Address": "台南市善化區中正路386號"
}, {
    "POIID": "184036",
    "POIName": "善良",
    "Telno": "(06)5813736",
    "Address": "台南市善化區中正路385號1樓"
}, {
    "POIID": "187242",
    "POIName": "善和",
    "Telno": "(06)5854317",
    "Address": "台南市善化區坐駕里大成路319號"
}, {
    "POIID": "971465",
    "POIName": "善營",
    "Telno": "(06)5856032",
    "Address": "台南市善化區小新里成功路173之1號"
}, {
    "POIID": "133016",
    "POIName": "新P5",
    "Telno": "(06)5055694",
    "Address": "台南市善化區南科九路17號(P5P6廠O棟)"
}, {
    "POIID": "167019",
    "POIName": "新六廠",
    "Telno": "(06)5057554",
    "Address": "台南市善化區南科北路1號1樓"
}, {
    "POIID": "143231",
    "POIName": "新樹人",
    "Telno": "(06)5858736",
    "Address": "台南市善化區光文里中山路143-2號"
}, {
    "POIID": "179931",
    "POIName": "群創B",
    "Telno": "(06)5057717",
    "Address": "台南市善化區南關里南科八路12號B1樓"
}, {
    "POIID": "132644",
    "POIName": "群創C",
    "Telno": "(06)5056499",
    "Address": "台南市善化區南科八路12號B1"
}, {
    "POIID": "932884",
    "POIName": "興農",
    "Telno": "(06)5813851",
    "Address": "台南市善化區興農路4號"
}, ], [{
    "POIID": "181277",
    "POIName": "三舍",
    "Telno": "(06)5894091",
    "Address": "台南市新市區三舍里三舍55號"
}, {
    "POIID": "151977",
    "POIName": "大營",
    "Telno": "(06)5891679",
    "Address": "台南市新市區大營里136-1號"
}, {
    "POIID": "990075",
    "POIName": "東科",
    "Telno": "(06)5055155",
    "Address": "台南市新市區三舍里大順三路125號1樓"
}, {
    "POIID": "130626",
    "POIName": "社頂",
    "Telno": "(06)5894247",
    "Address": "台南市新市區大社里大社710號1樓"
}, {
    "POIID": "167215",
    "POIName": "南茂",
    "Telno": "(06)5057601",
    "Address": "台南市新市區南科七路5號2樓"
}, {
    "POIID": "153803",
    "POIName": "省新",
    "Telno": "(06)5896254",
    "Address": "台南市新市區永就里9鄰中山路180號1樓"
}, {
    "POIID": "141578",
    "POIName": "高大",
    "Telno": "(06)5897471",
    "Address": "台南市新市區銘傳街87號89號1樓"
}, {
    "POIID": "941936",
    "POIName": "高長",
    "Telno": "(06)5012170",
    "Address": "台南市新市區新和里仁愛街171號"
}, {
    "POIID": "188120",
    "POIName": "新市",
    "Telno": "(06)5896124",
    "Address": "台南市新市區華興街48號1樓"
}, {
    "POIID": "136325",
    "POIName": "新南科",
    "Telno": "(06)5050767",
    "Address": "台南市新市區南科三路17號1樓(台南科學工業區)"
}, {
    "POIID": "991849",
    "POIName": "新科",
    "Telno": "(06)5893953",
    "Address": "台南市新市區新市里中興街162號1樓"
}, {
    "POIID": "970266",
    "POIName": "新凱",
    "Telno": "(06)5898774",
    "Address": "台南市新市區社內里12之5號"
}, {
    "POIID": "137063",
    "POIName": "新新善",
    "Telno": "(06)5014359",
    "Address": "台南市新市區復興路59號61號63號一樓"
}, {
    "POIID": "954312",
    "POIName": "新墘",
    "Telno": "(06)5897739",
    "Address": "台南市新市區港墘里民族路118號"
}, {
    "POIID": "980838",
    "POIName": "新雙新",
    "Telno": "(06)5892146",
    "Address": "台南市新市區永就里中山路227號1樓"
}, {
    "POIID": "188061",
    "POIName": "群創三",
    "Telno": "(06)5055693",
    "Address": "台南市新市區環西路2段2號1樓(群創三廠)"
}, {
    "POIID": "188072",
    "POIName": "群創五",
    "Telno": "(06)5057432",
    "Address": "台南市新市區環西路二段2號1樓(群創五廠)"
}, {
    "POIID": "149147",
    "POIName": "遠專",
    "Telno": "(06)5987474",
    "Address": "台南市新市區永就里中華路53巷9號"
}, {
    "POIID": "993384",
    "POIName": "樹谷",
    "Telno": "(06)5895647",
    "Address": "台南市新市區中心路2號1樓"
}, {
    "POIID": "173690",
    "POIName": "聯晶",
    "Telno": "(06)5051140",
    "Address": "台南市新市區豐華里南科二路18號7樓"
}, {
    "POIID": "167525",
    "POIName": "聯電",
    "Telno": "(06)5057638",
    "Address": "台南市新市區南科三路57號"
}, {
    "POIID": "143079",
    "POIName": "瀚宇",
    "Telno": "(06)5057916",
    "Address": "台南市新市區南科二路35號1樓"
}, ], [{
    "POIID": "113126",
    "POIName": "山上",
    "Telno": "(06)5784711",
    "Address": "台南市山上區南洲337-3號"
}, ], [{
    "POIID": "980296",
    "POIName": "大目降",
    "Telno": "(06)5984053",
    "Address": "台南市新化區正新路233號"
}, {
    "POIID": "880165",
    "POIName": "那菝",
    "Telno": "(06)5912497",
    "Address": "台南市新化區那菝林241號"
}, {
    "POIID": "130992",
    "POIName": "知母義",
    "Telno": "(06)5907105",
    "Address": "台南市新化區知義里知母義15號之20一樓"
}, {
    "POIID": "931537",
    "POIName": "星辰",
    "Telno": "(06)5986694",
    "Address": "台南市新化區全興里竹子腳177-2號"
}, {
    "POIID": "147266",
    "POIName": "清美",
    "Telno": "(06)5982994",
    "Address": "台南市新化區協興里中山路624號"
}, {
    "POIID": "910334",
    "POIName": "清新",
    "Telno": "(06)5800790",
    "Address": "台南市新化區武安里中正路321號"
}, {
    "POIID": "958967",
    "POIName": "新化",
    "Telno": "(06)5907237",
    "Address": "台南市新化區中正路557號"
}, {
    "POIID": "990282",
    "POIName": "新興運",
    "Telno": "(06)5800340",
    "Address": "台南市新化區護國里中山路211號"
}, {
    "POIID": "965611",
    "POIName": "遠德",
    "Telno": "(06)5987483",
    "Address": "台南市新化區北勢里中正路1211號"
}, ], [{
    "POIID": "966061",
    "POIName": "車讚",
    "Telno": "(06)5954561",
    "Address": "台南市關廟區北花里中正路517號"
}, {
    "POIID": "943884",
    "POIName": "保東",
    "Telno": "(06)5955944",
    "Address": "台南市關廟區關新路二段7號"
}, {
    "POIID": "890140",
    "POIName": "威保",
    "Telno": "(06)5950963",
    "Address": "台南市關廟區南雄路一段829號"
}, {
    "POIID": "993340",
    "POIName": "香洋",
    "Telno": "(06)5950478",
    "Address": "台南市關廟區香洋里中山路一段203號1樓"
}, {
    "POIID": "188980",
    "POIName": "鼎利",
    "Telno": "(06)5950701",
    "Address": "台南市關廟區南雄路二段210號"
}, {
    "POIID": "188773",
    "POIName": "鼎富",
    "Telno": "(06)5965999",
    "Address": "台南市關廟區南花里中正路881號"
}, {
    "POIID": "188784",
    "POIName": "鼎鑫",
    "Telno": "(06)5966828",
    "Address": "台南市關廟區中山路2段27號1樓"
}, {
    "POIID": "971018",
    "POIName": "關聖",
    "Telno": "(06)5957447",
    "Address": "台南市關廟區南雄路一段471號"
}, ], [{
    "POIID": "902779",
    "POIName": "八甲",
    "Telno": "(06)2398072",
    "Address": "台南市歸仁區八甲里中正北路一段194號"
}, {
    "POIID": "155119",
    "POIName": "大通",
    "Telno": "(06)2307664",
    "Address": "台南市歸仁區和平北街32號"
}, {
    "POIID": "143840",
    "POIName": "大潭",
    "Telno": "(06)2783243",
    "Address": "台南市歸仁區大潭里長榮路一段320巷11號"
}, {
    "POIID": "187231",
    "POIName": "仁興",
    "Telno": "(06)2395784",
    "Address": "台南市歸仁區南保里大德路307號"
}, {
    "POIID": "931272",
    "POIName": "六發",
    "Telno": "(06)3307356",
    "Address": "台南市歸仁區六甲里中正南路一段1020號"
}, {
    "POIID": "188898",
    "POIName": "加賀",
    "Telno": "(06)2055024",
    "Address": "台南市歸仁區大廟里大廟一街1號"
}, {
    "POIID": "183734",
    "POIName": "立青",
    "Telno": "(06)2391997",
    "Address": "台南市歸仁區南保里民權南路一段108號1樓"
}, {
    "POIID": "165471",
    "POIName": "立登",
    "Telno": "(06)2399080",
    "Address": "台南市歸仁區民生北路106號"
}, {
    "POIID": "851064",
    "POIName": "伍誼",
    "Telno": "(06)2399459",
    "Address": "台南市歸仁區復興路162之1號"
}, {
    "POIID": "954529",
    "POIName": "長榮大",
    "Telno": "(06)2785977",
    "Address": "台南市歸仁區大潭里長榮路一段396號(長榮大學內第4宿舍B1)"
}, {
    "POIID": "953995",
    "POIName": "高鐵南站",
    "Telno": "(06)6005665",
    "Address": "台南市歸仁區沙崙里歸仁大道100號"
}, {
    "POIID": "165253",
    "POIName": "歸仁",
    "Telno": "(06)2390164",
    "Address": "台南市歸仁區中山路2段60號"
}, {
    "POIID": "118338",
    "POIName": "豐生",
    "Telno": "(06)3308121",
    "Address": "台南市歸仁區看東里中山路一段305號"
}, {
    "POIID": "880811",
    "POIName": "騰揮",
    "Telno": "(06)2300846",
    "Address": "台南市歸仁區中正南路一段110號"
}, ], [{
    "POIID": "179768",
    "POIName": "大瑩",
    "Telno": "(06)2667425",
    "Address": "台南市仁德區二行里中正西路347號1樓"
}, {
    "POIID": "942548",
    "POIName": "中洲",
    "Telno": "(06)3661512",
    "Address": "台南市仁德區中洲里中洲276-16號276-17號"
}, {
    "POIID": "966957",
    "POIName": "仁大",
    "Telno": "(06)2710234",
    "Address": "台南市仁德區太子里太子路120號122號"
}, {
    "POIID": "951966",
    "POIName": "仁伯",
    "Telno": "(06)2491560",
    "Address": "台南市仁德區後壁里德安路188號"
}, {
    "POIID": "187736",
    "POIName": "仁義",
    "Telno": "(06)2490131",
    "Address": "台南市仁德區中正路二段1052號"
}, {
    "POIID": "846659",
    "POIName": "仁德",
    "Telno": "(06)2703070",
    "Address": "台南市仁德區中山路501號"
}, {
    "POIID": "950538",
    "POIName": "文安",
    "Telno": "(06)2667371",
    "Address": "台南市仁德區文賢路一段576號"
}, {
    "POIID": "110703",
    "POIName": "北站",
    "Telno": "(06)2780853",
    "Address": "台南市仁德區中洲里中洲1-16號1樓"
}, {
    "POIID": "132688",
    "POIName": "奇美實",
    "Telno": "(06)2666124",
    "Address": "台南市仁德區三甲里59-1號"
}, {
    "POIID": "944658",
    "POIName": "奇勝",
    "Telno": "(06)2497315",
    "Address": "台南市仁德區新田里勝利路139號"
}, {
    "POIID": "180229",
    "POIName": "奇博",
    "Telno": "(06)2667434",
    "Address": "台南市仁德區文華路二段66號1樓"
}, {
    "POIID": "940999",
    "POIName": "林頂",
    "Telno": "(06)2496005",
    "Address": "台南市仁德區中山路155號"
}, {
    "POIID": "967891",
    "POIName": "虎尾寮",
    "Telno": "(06)2498487",
    "Address": "台南市仁德區仁德里文德路157號"
}, {
    "POIID": "151597",
    "POIName": "長益",
    "Telno": "(06)2052285",
    "Address": "台南市仁德區土庫里太子路233號"
}, {
    "POIID": "905963",
    "POIName": "保正",
    "Telno": "(06)3661321",
    "Address": "台南市仁德區中正路一段529號"
}, {
    "POIID": "967581",
    "POIName": "保華",
    "Telno": "(06)3369571",
    "Address": "台南市仁德區成功里崇德路88號"
}, {
    "POIID": "190260",
    "POIName": "南站",
    "Telno": "(06)3663985",
    "Address": "台南市仁德區中洲里中洲1-15號1樓"
}, {
    "POIID": "166979",
    "POIName": "素心",
    "Telno": "(06)2794866",
    "Address": "台南市仁德區中山路258號260號"
}, {
    "POIID": "851053",
    "POIName": "高梓",
    "Telno": "(06)2794891",
    "Address": "台南市仁德區後璧里中正路二段387號"
}, {
    "POIID": "187068",
    "POIName": "常興",
    "Telno": "(06)2721228",
    "Address": "台南市仁德區中正路三段701號"
}, {
    "POIID": "951830",
    "POIName": "華醫",
    "Telno": "(06)3357173",
    "Address": "台南市仁德區民安路一段115號"
}, {
    "POIID": "967938",
    "POIName": "新正賢",
    "Telno": "(06)2669825",
    "Address": "台南市仁德區保安里中正路一段209號"
}, {
    "POIID": "861544",
    "POIName": "嘉南",
    "Telno": "(06)2667175",
    "Address": "台南市仁德區二行里二仁路一段151號"
}, {
    "POIID": "117173",
    "POIName": "嘉科大",
    "Telno": "(06)2668785",
    "Address": "台南市仁德區保安里二仁路一段60號"
}, {
    "POIID": "161789",
    "POIName": "嘉凱",
    "Telno": "(06)2669463",
    "Address": "台南市仁德區保安里保安路1段56巷55號"
}, {
    "POIID": "184634",
    "POIName": "嘉藥",
    "Telno": "(06)3660383",
    "Address": "台南市仁德區保安里二仁路一段60號1樓"
}, {
    "POIID": "891213",
    "POIName": "德南",
    "Telno": "(06)2494918",
    "Address": "台南市仁德區中正路2段224號"
}, {
    "POIID": "151357",
    "POIName": "德航",
    "Telno": "(06)2684800",
    "Address": "台南市仁德區大同路三段202號"
}, {
    "POIID": "931559",
    "POIName": "德發",
    "Telno": "(06)2495272",
    "Address": "台南市仁德區中正路三段42號"
}, ], ], [], [[{
    "POIID": "126362",
    "POIName": "七老爺",
    "Telno": "(07)7929712",
    "Address": "高雄市鳳山區正義里鳳甲路491號493號"
}, {
    "POIID": "874610",
    "POIName": "大洋",
    "Telno": "(07)7664074",
    "Address": "高雄市鳳山區大明路142號144號"
}, {
    "POIID": "136288",
    "POIName": "工協",
    "Telno": "(07)7020916",
    "Address": "高雄市鳳山區埤頂里建國路一段79號1樓"
}, {
    "POIID": "854443",
    "POIName": "中東",
    "Telno": "(07)7439740",
    "Address": "高雄市鳳山區中山東路88號"
}, {
    "POIID": "147244",
    "POIName": "天虹",
    "Telno": "(07)7684836",
    "Address": "高雄市鳳山區鎮南里五甲二路744號"
}, {
    "POIID": "135263",
    "POIName": "文建",
    "Telno": "(07)7676924",
    "Address": "高雄市鳳山區文福里文化西路35號1樓"
}, {
    "POIID": "990732",
    "POIName": "文衡",
    "Telno": "(07)7677689",
    "Address": "高雄市鳳山區文衡里八德路305號1樓"
}, {
    "POIID": "953869",
    "POIName": "牛潮埔",
    "Telno": "(07)7356353",
    "Address": "高雄市鳳山區鎮北里鳳北路60之17號"
}, {
    "POIID": "182476",
    "POIName": "光泰",
    "Telno": "(07)7904495",
    "Address": "高雄市鳳山區光復路65號1樓(B室)1樓部分"
}, {
    "POIID": "122485",
    "POIName": "來家",
    "Telno": "(07)7224077",
    "Address": "高雄市鳳山區新強里崗山北街36號38號1樓"
}, {
    "POIID": "982502",
    "POIName": "欣福誠",
    "Telno": "(07)7684187",
    "Address": "高雄市鳳山區五福里五甲三路75號77號1樓"
}, {
    "POIID": "865513",
    "POIName": "武慶",
    "Telno": "(07)7167387",
    "Address": "高雄市鳳山區五武漢里武慶二路52號54號"
}, {
    "POIID": "190019",
    "POIName": "青文",
    "Telno": "(07)7776482",
    "Address": "高雄市鳳山區文衡里文衡路343號"
}, {
    "POIID": "900577",
    "POIName": "青建",
    "Telno": "(07)7417414",
    "Address": "高雄市鳳山區文福里建國路三段295號"
}, {
    "POIID": "170532",
    "POIName": "亮宏",
    "Telno": "(07)7781397",
    "Address": "高雄市鳳山區文德里文衡路558號1樓"
}, {
    "POIID": "942847",
    "POIName": "俊瑋",
    "Telno": "(07)7410481",
    "Address": "高雄市鳳山區忠義里光復路1段193號"
}, {
    "POIID": "136004",
    "POIName": "南華",
    "Telno": "(07)7713883",
    "Address": "高雄市鳳山區五甲二路232號"
}, {
    "POIID": "935621",
    "POIName": "建武",
    "Telno": "(07)7470282",
    "Address": "高雄市鳳山區武松里建國路二段2號"
}, {
    "POIID": "930062",
    "POIName": "建泰",
    "Telno": "(07)7538356",
    "Address": "高雄市鳳山區誠義路2號"
}, {
    "POIID": "136657",
    "POIName": "美澄",
    "Telno": "(07)7779914",
    "Address": "高雄市鳳山區文山里八德路二段116號"
}, {
    "POIID": "996589",
    "POIName": "海新",
    "Telno": "(07)7659203",
    "Address": "高雄市鳳山區國隆里新富路590巷13號15號"
}, {
    "POIID": "158901",
    "POIName": "高鳳",
    "Telno": "(07)7460354",
    "Address": "高雄市鳳山區忠義里中山西路398號400號"
}, {
    "POIID": "113090",
    "POIName": "統崙",
    "Telno": "(07)7536645",
    "Address": "高雄市鳳山區中民里中崙四路6號8號1樓"
}, {
    "POIID": "185752",
    "POIName": "博瑞",
    "Telno": "(07)7458935",
    "Address": "高雄市鳳山區瑞興里博愛路221號223號"
}, {
    "POIID": "171579",
    "POIName": "富凱",
    "Telno": "(07)7631240",
    "Address": "高雄市鳳山區新富路385號1樓"
}, {
    "POIID": "967237",
    "POIName": "森和",
    "Telno": "(07)7684826",
    "Address": "高雄市鳳山區南和里16鄰林森路203號"
}, {
    "POIID": "942755",
    "POIName": "翔富",
    "Telno": "(07)7805459",
    "Address": "高雄市鳳山區文德里濱山街12號1樓"
}, {
    "POIID": "167499",
    "POIName": "華鳳",
    "Telno": "(07)7334871",
    "Address": "高雄市鳳山區北昌路10號"
}, {
    "POIID": "161491",
    "POIName": "黃埔",
    "Telno": "(07)7478806",
    "Address": "高雄市鳳山區鎮東里光遠路73號"
}, {
    "POIID": "135746",
    "POIName": "新保泰",
    "Telno": "(07)7684815",
    "Address": "高雄市鳳山區鎮南里龍成路242-1號"
}, {
    "POIID": "981026",
    "POIName": "新新甲",
    "Telno": "(07)7673969",
    "Address": "高雄市鳳山區海洋里海洋二路57號59號1樓"
}, {
    "POIID": "180193",
    "POIName": "瑞竹",
    "Telno": "(07)7407954",
    "Address": "高雄市鳳山區中山東路209-1及209-2號1樓"
}, {
    "POIID": "992288",
    "POIName": "瑞順",
    "Telno": "(07)7458942",
    "Address": "高雄市鳳山區瑞興里瑞興路250-1號1樓"
}, {
    "POIID": "170358",
    "POIName": "鳳仁",
    "Telno": "(07)7109588",
    "Address": "高雄市鳳山區鳳仁路174號"
}, {
    "POIID": "110068",
    "POIName": "鳳文",
    "Telno": "(07)7104580",
    "Address": "高雄市鳳山區文英里文衡路50號1樓"
}, {
    "POIID": "155407",
    "POIName": "鳳來",
    "Telno": "(07)7927309",
    "Address": "高雄市鳳山區鳳甲路2號"
}, {
    "POIID": "956167",
    "POIName": "鳳和",
    "Telno": "(07)7990060",
    "Address": "高雄市鳳山區中和里自由路204號206號"
}, {
    "POIID": "902425",
    "POIName": "鳳東",
    "Telno": "(07)7199560",
    "Address": "高雄市鳳山區和德里中山路63號"
}, {
    "POIID": "117025",
    "POIName": "鳳南",
    "Telno": "(07)7963845",
    "Address": "高雄市鳳山區二甲里鳳南一路25號27號"
}, {
    "POIID": "121747",
    "POIName": "鳳城",
    "Telno": "(07)7829606",
    "Address": "高雄市鳳山區杭州西街111號1樓"
}, {
    "POIID": "180300",
    "POIName": "鳳凌",
    "Telno": "(07)7405747",
    "Address": "高雄市鳳山區中山路223.225.227號"
}, {
    "POIID": "164526",
    "POIName": "鳳埤",
    "Telno": "(07)7924286",
    "Address": "高雄市鳳山區過埤里過埤路170號"
}, {
    "POIID": "906335",
    "POIName": "鳳曹",
    "Telno": "(07)7474150",
    "Address": "高雄市鳳山區曹公里曹公路59號"
}, {
    "POIID": "980252",
    "POIName": "鳳頂",
    "Telno": "(07)7928892",
    "Address": "高雄市鳳山區過埤里鳳頂路285號1樓"
}, {
    "POIID": "166692",
    "POIName": "鳳陽",
    "Telno": "(07)7026091",
    "Address": "高雄市鳳山區鳳林路97號1樓"
}, {
    "POIID": "155072",
    "POIName": "鳳新",
    "Telno": "(07)7675107",
    "Address": "高雄市鳳山區新康街241號243號245號1樓"
}, {
    "POIID": "186375",
    "POIName": "鳳駿",
    "Telno": "(07)7407770",
    "Address": "高雄市鳳山區北門里鳳松路108.110.112號1樓"
}, {
    "POIID": "993317",
    "POIName": "德文",
    "Telno": "(07)7677524",
    "Address": "高雄市鳳山區文山里八德路197號"
}, {
    "POIID": "183206",
    "POIName": "澄清湖",
    "Telno": "(07)7808096",
    "Address": "高雄市鳳山區青年路二段596號.598巷2.4號1.2樓"
}, {
    "POIID": "990662",
    "POIName": "興仁",
    "Telno": "(07)7454010",
    "Address": "高雄市鳳山區興仁里五甲一路204號206號1樓"
}, ], [{
    "POIID": "960029",
    "POIName": "仁勇",
    "Telno": "(07)5329630",
    "Address": "高雄市鹽埕區大公路二號"
}, {
    "POIID": "121965",
    "POIName": "客宭",
    "Telno": "(07)5211715",
    "Address": "高雄市鹽埕區建國四路312號"
}, {
    "POIID": "169831",
    "POIName": "重義",
    "Telno": "(07)5218483",
    "Address": "高雄市鹽埕區五福4路83號"
}, {
    "POIID": "871828",
    "POIName": "新建",
    "Telno": "(07)5216102",
    "Address": "高雄市鹽埕區建國四路175號"
}, {
    "POIID": "184092",
    "POIName": "駁藝",
    "Telno": "(07)5212477",
    "Address": "高雄市鹽埕區大勇路29號"
}, {
    "POIID": "832915",
    "POIName": "鹽埕",
    "Telno": "(07)5320626",
    "Address": "高雄市鹽埕區大仁路139號瀨南路172號"
}, {
    "POIID": "171018",
    "POIName": "鑫漢王",
    "Telno": "(07)5215375",
    "Address": "高雄市鹽埕區港都里五福四路265號1樓"
}, ], [{
    "POIID": "182904",
    "POIName": "人田",
    "Telno": "(07)5524392",
    "Address": "高雄市鼓山區美術東二路7號"
}, {
    "POIID": "935768",
    "POIName": "內惟",
    "Telno": "(07)5879203",
    "Address": "高雄市鼓山區九如四路1432號1434號"
}, {
    "POIID": "896551",
    "POIName": "文信",
    "Telno": "(07)5536265",
    "Address": "高雄市鼓山區明誠里南屏路527號529號"
}, {
    "POIID": "844893",
    "POIName": "民強",
    "Telno": "(07)5214862",
    "Address": "高雄市鼓山區九如四路706號708號710號"
}, {
    "POIID": "170266",
    "POIName": "明榮",
    "Telno": "(07)5542062",
    "Address": "高雄市鼓山區明誠里明華路204號"
}, {
    "POIID": "183262",
    "POIName": "建榮",
    "Telno": "(07)5851507",
    "Address": "高雄市鼓山區建榮路180號1樓"
}, {
    "POIID": "158897",
    "POIName": "美珍",
    "Telno": "(07)5502901",
    "Address": "高雄市鼓山區明誠四路23號"
}, {
    "POIID": "158196",
    "POIName": "美術館",
    "Telno": "(07)5520479",
    "Address": "高雄市鼓山區美術館路73號1樓"
}, {
    "POIID": "166924",
    "POIName": "美賢",
    "Telno": "(07)5224914",
    "Address": "高雄市鼓山區美術東四路430號"
}, {
    "POIID": "120191",
    "POIName": "美藝",
    "Telno": "(07)5529812",
    "Address": "高雄市鼓山區龍水里美術東二路103號1樓"
}, {
    "POIID": "912145",
    "POIName": "昶玖",
    "Telno": "(07)5519575",
    "Address": "高雄市鼓山區九如四路929號931號"
}, {
    "POIID": "979089",
    "POIName": "柴山",
    "Telno": "(07)5327121",
    "Address": "高雄市鼓山區鼓山三路49號51號"
}, {
    "POIID": "171627",
    "POIName": "海青",
    "Telno": "(07)5219140",
    "Address": "高雄市鼓山區青海路641號1樓"
}, {
    "POIID": "980757",
    "POIName": "高美",
    "Telno": "(07)5224427",
    "Address": "高雄市鼓山區龍水里美術東二路181號"
}, {
    "POIID": "186733",
    "POIName": "祥裕",
    "Telno": "(07)5546011",
    "Address": "高雄市鼓山區明誠里裕誠路1610號1612號"
}, {
    "POIID": "171591",
    "POIName": "華榮",
    "Telno": "(07)5528627",
    "Address": "高雄市鼓山區華榮路236號238號"
}, {
    "POIID": "158440",
    "POIName": "華豐",
    "Telno": "(07)5524610",
    "Address": "高雄市鼓山區華豐里裕誠路1160號明倫路138號"
}, {
    "POIID": "966359",
    "POIName": "順屏",
    "Telno": "(07)5222541",
    "Address": "高雄市鼓山區龍子里大順一路825號"
}, {
    "POIID": "177555",
    "POIName": "順德",
    "Telno": "(07)5538510",
    "Address": "高雄市鼓山區龍子里大順一路860號1樓"
}, {
    "POIID": "972561",
    "POIName": "新前鋒",
    "Telno": "(07)5888031",
    "Address": "高雄市鼓山區雄峰里九如四路2007號1樓"
}, {
    "POIID": "115982",
    "POIName": "裕東",
    "Telno": "(07)5525924",
    "Address": "高雄市鼓山區裕誠路1946號1樓"
}, {
    "POIID": "170613",
    "POIName": "誠美",
    "Telno": "(07)5525694",
    "Address": "高雄市鼓山區龍子里裕誠路2080號"
}, {
    "POIID": "990237",
    "POIName": "農神",
    "Telno": "(07)5228389",
    "Address": "高雄市鼓山區龍子里神農路183號185號1樓"
}, {
    "POIID": "142319",
    "POIName": "鼓山",
    "Telno": "(07)5215439",
    "Address": "高雄市鼓山區鼓山二路125之1號127號127之1號1樓"
}, {
    "POIID": "114196",
    "POIName": "鼓波",
    "Telno": "(07)5312364",
    "Address": "高雄市鼓山區臨海二路45-1號"
}, {
    "POIID": "185202",
    "POIName": "榮夏",
    "Telno": "(07)5524255",
    "Address": "高雄市鼓山區華榮路387號1樓"
}, {
    "POIID": "171052",
    "POIName": "慶豐",
    "Telno": "(07)5524180",
    "Address": "高雄市鼓山區慶豐街1號"
}, {
    "POIID": "183376",
    "POIName": "臨海",
    "Telno": "(07)5311392",
    "Address": "高雄市鼓山區臨海二路8號"
}, {
    "POIID": "981613",
    "POIName": "鑫博",
    "Telno": "(07)5554632",
    "Address": "高雄市鼓山區明誠里博愛二路345號1樓"
}, ], [{
    "POIID": "114233",
    "POIName": "上芸",
    "Telno": "(07)6413906",
    "Address": "高雄市林園區西溪路133-30號"
}, {
    "POIID": "187699",
    "POIName": "中芸",
    "Telno": "(07)6438725",
    "Address": "高雄市林園區中芸里鳳芸二路57號1樓"
}, {
    "POIID": "148878",
    "POIName": "東林",
    "Telno": "(07)6411785",
    "Address": "高雄市林園區東林西路154號"
}, {
    "POIID": "187770",
    "POIName": "金潭",
    "Telno": "(07)6424521",
    "Address": "高雄市林園區中厝路125號127號"
}, {
    "POIID": "112053",
    "POIName": "神農",
    "Telno": "(07)6422561",
    "Address": "高雄市林園區廣應里王公路341號343號"
}, {
    "POIID": "155669",
    "POIName": "富田",
    "Telno": "(07)6411294",
    "Address": "高雄市林園區林園北路477號1號"
}, {
    "POIID": "174361",
    "POIName": "園中",
    "Telno": "(07)6437338",
    "Address": "高雄市林園區中門里中門路15-1號"
}, {
    "POIID": "131892",
    "POIName": "園東",
    "Telno": "(07)6416738",
    "Address": "高雄市林園區東林西路1號3號5號"
}, {
    "POIID": "162748",
    "POIName": "新元嘉",
    "Telno": "(07)6427160",
    "Address": "高雄市林園區港嘴里沿海路三段237號"
}, {
    "POIID": "177544",
    "POIName": "鳳麟",
    "Telno": "(07)6419269",
    "Address": "高雄市林園區東林里鳳林路一段169號1樓"
}, {
    "POIID": "122946",
    "POIName": "霖園",
    "Telno": "(07)6415934",
    "Address": "高雄市林園區鳳林路一段2號1樓"
}, ], [{
    "POIID": "154910",
    "POIName": "大發",
    "Telno": "(07)7839643",
    "Address": "高雄市大寮區振成里鳳林三路322號324號1樓"
}, {
    "POIID": "872005",
    "POIName": "山頂",
    "Telno": "(07)7837610",
    "Address": "高雄市大寮區內厝路219號"
}, {
    "POIID": "992761",
    "POIName": "永芳",
    "Telno": "(07)7831908",
    "Address": "高雄市大寮區永芳里萬丹路630號"
}, {
    "POIID": "954208",
    "POIName": "米奇",
    "Telno": "(07)7880413",
    "Address": "高雄市大寮區大寮里大寮路903號"
}, {
    "POIID": "187851",
    "POIName": "金山角",
    "Telno": "(07)7874168",
    "Address": "高雄市大寮區會社里1鄰鳳林三路1之10號"
}, {
    "POIID": "135919",
    "POIName": "前中",
    "Telno": "(07)7816922",
    "Address": "高雄市大寮區自由路1號"
}, {
    "POIID": "142618",
    "POIName": "昭明",
    "Telno": "(07)6414750",
    "Address": "高雄市大寮區義仁里鳳林一路51巷5號1樓"
}, {
    "POIID": "993926",
    "POIName": "美庄",
    "Telno": "(07)7013224",
    "Address": "高雄市大寮區後庄村成功路43號"
}, {
    "POIID": "981509",
    "POIName": "益慶",
    "Telno": "(07)6529512",
    "Address": "高雄市大寮區義和里義和路111-50號1樓"
}, {
    "POIID": "165275",
    "POIName": "開封",
    "Telno": "(07)7880424",
    "Address": "高雄市大寮區大寮路688號"
}, {
    "POIID": "894289",
    "POIName": "源隆",
    "Telno": "(07)7828004",
    "Address": "高雄市大寮區永芳里進學路74號76號"
}, {
    "POIID": "116745",
    "POIName": "義發",
    "Telno": "(07)7862644",
    "Address": "高雄市大寮區義發路7號"
}, {
    "POIID": "186836",
    "POIName": "鳳明",
    "Telno": "(07)7879642",
    "Address": "高雄市大寮區新厝里鳳林二路160號"
}, {
    "POIID": "171328",
    "POIName": "鳳屏",
    "Telno": "(07)7012100",
    "Address": "高雄市大寮區鳳屏一路564號"
}, {
    "POIID": "155245",
    "POIName": "德庄",
    "Telno": "(07)7030164",
    "Address": "高雄市大寮區中庄里八德路69號71號73號"
}, {
    "POIID": "189754",
    "POIName": "潮欣",
    "Telno": "(07)7884765",
    "Address": "高雄市大寮區潮寮里華中南路275號"
}, ], [{
    "POIID": "929028",
    "POIName": "大富",
    "Telno": "(07)5582580",
    "Address": "高雄市左營區大順一路278號280號"
}, {
    "POIID": "181440",
    "POIName": "山福",
    "Telno": "(07)3485366",
    "Address": "高雄市左營區重愛路168號1樓"
}, {
    "POIID": "951782",
    "POIName": "文自",
    "Telno": "(07)3452530",
    "Address": "高雄市左營區菜公里文自路512-1號"
}, {
    "POIID": "148535",
    "POIName": "文康",
    "Telno": "(07)3506567",
    "Address": "高雄市左營區新光里文康路156號1樓"
}, {
    "POIID": "184900",
    "POIName": "文慈",
    "Telno": "(07)3478545",
    "Address": "高雄市左營區福山里重愛路65號"
}, {
    "POIID": "173863",
    "POIName": "凹仔底",
    "Telno": "(07)5574859",
    "Address": "高雄市左營區新上里裕誠路448號"
}, {
    "POIID": "973117",
    "POIName": "巨漢",
    "Telno": "(07)5543968",
    "Address": "高雄市左營區新下里新莊一路350號"
}, {
    "POIID": "160177",
    "POIName": "左運",
    "Telno": "(07)5885443",
    "Address": "高雄市左營區高鐵路107號B1"
}, {
    "POIID": "966245",
    "POIName": "左營新站",
    "Telno": "(07)5881485",
    "Address": "高雄市左營區菜公里菜公路1號"
}, {
    "POIID": "158277",
    "POIName": "玉堂",
    "Telno": "(07)3414574",
    "Address": "高雄市左營區曾子路1號"
}, {
    "POIID": "185512",
    "POIName": "立文",
    "Telno": "(07)5509725",
    "Address": "高雄市左營區新上里立文路77號1樓"
}, {
    "POIID": "971085",
    "POIName": "先鋒",
    "Telno": "(07)5889876",
    "Address": "高雄市左營區介壽路247號249號1樓"
}, {
    "POIID": "188658",
    "POIName": "安華",
    "Telno": "(07)5564671",
    "Address": "高雄市左營區明華一路126號"
}, {
    "POIID": "129763",
    "POIName": "百事達",
    "Telno": "(07)5853058",
    "Address": "高雄市左營區頂西里左營大路261號263號"
}, {
    "POIID": "159007",
    "POIName": "孟新",
    "Telno": "(07)3483129",
    "Address": "高雄市左營區自由三路292號"
}, {
    "POIID": "127712",
    "POIName": "欣重文",
    "Telno": "(07)3506524",
    "Address": "高雄市左營區重愛路308號310號1樓"
}, {
    "POIID": "190514",
    "POIName": "信科",
    "Telno": "(07)3504964",
    "Address": "高雄市左營區重信路601號"
}, {
    "POIID": "146872",
    "POIName": "南屏",
    "Telno": "(07)5524582",
    "Address": "高雄市左營區新下里華夏路256號"
}, {
    "POIID": "963349",
    "POIName": "政德",
    "Telno": "(07)3451959",
    "Address": "高雄市左營區政德路130號132號1F"
}, {
    "POIID": "952969",
    "POIName": "重和",
    "Telno": "(07)3453508",
    "Address": "高雄市左營區福山里自由四路171號"
}, {
    "POIID": "182661",
    "POIName": "重信",
    "Telno": "(07)3454317",
    "Address": "高雄市左營區文川路195號.重建路2號"
}, {
    "POIID": "177108",
    "POIName": "重惠",
    "Telno": "(07)3457904",
    "Address": "高雄市左營區福山里華夏路1152號1樓"
}, {
    "POIID": "140209",
    "POIName": "重愛",
    "Telno": "(07)3436263",
    "Address": "高雄市左營區民族一路987號"
}, {
    "POIID": "154699",
    "POIName": "夏義",
    "Telno": "(07)3106564",
    "Address": "高雄市左營區福山里華夏路1453號1樓"
}, {
    "POIID": "149767",
    "POIName": "浚興",
    "Telno": "(07)3457497",
    "Address": "高雄市左營區新光里華夏路979號"
}, {
    "POIID": "129017",
    "POIName": "高高鐵",
    "Telno": "(07)8629981",
    "Address": "高雄市左營區菜公里高鐵路105號(高鐵高雄車站地上第二樓層)"
}, {
    "POIID": "190248",
    "POIName": "國勝",
    "Telno": "(07)5509786",
    "Address": "高雄市左營區富國路112號116號1樓"
}, {
    "POIID": "186113",
    "POIName": "彩虹市集",
    "Telno": "(07)3507294",
    "Address": "高雄市左營區菜公里高鐵路115號1樓"
}, {
    "POIID": "129039",
    "POIName": "速鐵",
    "Telno": "(07)9605706",
    "Address": "高雄市左營區高鐵路105號"
}, {
    "POIID": "177474",
    "POIName": "勝利",
    "Telno": "(07)5816873",
    "Address": "高雄市左營區勝利路123號"
}, {
    "POIID": "865421",
    "POIName": "博正",
    "Telno": "(07)5578128",
    "Address": "高雄市左營區忠言路174號"
}, {
    "POIID": "953940",
    "POIName": "博真",
    "Telno": "(07)3482621",
    "Address": "高雄市左營區新中里博愛三路16號"
}, {
    "POIID": "855480",
    "POIName": "華民",
    "Telno": "(07)3464185",
    "Address": "高雄市左營區民族一路1084號"
}, {
    "POIID": "892135",
    "POIName": "華崇",
    "Telno": "(07)3414988",
    "Address": "高雄市左營區華夏路672號"
}, {
    "POIID": "158484",
    "POIName": "進學",
    "Telno": "(07)5855660",
    "Address": "高雄市左營區左營大路491-1號491-2號"
}, {
    "POIID": "902333",
    "POIName": "雲崗",
    "Telno": "(07)5589457",
    "Address": "高雄市左營區明華一路236號"
}, {
    "POIID": "183480",
    "POIName": "新上明",
    "Telno": "(07)5569379",
    "Address": "高雄市左營區明誠二路318.320號"
}, {
    "POIID": "188614",
    "POIName": "新左營",
    "Telno": "(07)5852412",
    "Address": "高雄市左營區左營大路14-5號"
}, {
    "POIID": "170026",
    "POIName": "新昌",
    "Telno": "(07)3631254",
    "Address": "高雄市左營區光輝里後昌路637號639號1樓"
}, {
    "POIID": "973128",
    "POIName": "新海勝",
    "Telno": "(07)5882879",
    "Address": "高雄市左營區翠華路601巷122號"
}, {
    "POIID": "132183",
    "POIName": "新高榮",
    "Telno": "(07)3421447",
    "Address": "高雄市左營區福山里榮總路175號1樓"
}, {
    "POIID": "135001",
    "POIName": "瑞福",
    "Telno": "(07)5586745",
    "Address": "高雄市左營區裕誠路285號287號"
}, {
    "POIID": "154792",
    "POIName": "榮總一",
    "Telno": "(07)3489676",
    "Address": "高雄市左營區大中一路386號"
}, {
    "POIID": "159214",
    "POIName": "榮總二",
    "Telno": "(07)3463594",
    "Address": "高雄市左營區福山里大中一路386號"
}, {
    "POIID": "162623",
    "POIName": "榮耀",
    "Telno": "(07)3424718",
    "Address": "高雄市左營區福山里民族一路1014號1樓"
}, {
    "POIID": "909518",
    "POIName": "翠峰",
    "Telno": "(07)5810556",
    "Address": "高雄市左營區翠峰路34號"
}, {
    "POIID": "182650",
    "POIName": "廟東",
    "Telno": "(07)5850815",
    "Address": "高雄市左營區左營大路340號"
}, {
    "POIID": "164423",
    "POIName": "德昌",
    "Telno": "(07)3460165",
    "Address": "高雄市左營區菜公里文自路236號238號"
}, {
    "POIID": "999511",
    "POIName": "豐園",
    "Telno": "(07)5567732",
    "Address": "高雄市左營區自由二路484號"
}, ], [{
    "POIID": "135735",
    "POIName": "九曲堂",
    "Telno": "(07)6523141",
    "Address": "高雄市大樹區久堂里城隍巷15-8號"
}, {
    "POIID": "113768",
    "POIName": "大樹",
    "Telno": "(07)6528814",
    "Address": "高雄市大樹區樣腳里中興東路7號9號11號13號"
}, {
    "POIID": "950697",
    "POIName": "新鎮",
    "Telno": "(07)6517820",
    "Address": "高雄市大樹區九曲里九曲路99號"
}, {
    "POIID": "950387",
    "POIName": "溪埔",
    "Telno": "(07)6565516",
    "Address": "高雄市大樹區溪埔里溪埔路369號370號"
}, ], [{
    "POIID": "966902",
    "POIName": "久昌",
    "Telno": "(07)3647112",
    "Address": "高雄市楠梓區久昌里盛昌街26號"
}, {
    "POIID": "952741",
    "POIName": "元昌",
    "Telno": "(07)3644909",
    "Address": "高雄市楠梓區國昌里德民路900號902號"
}, {
    "POIID": "154574",
    "POIName": "日明",
    "Telno": "(07)3632411",
    "Address": "高雄市楠梓區楠梓加工出口區第二園區研發路66號3樓"
}, {
    "POIID": "180908",
    "POIName": "日星",
    "Telno": "(07)3647814",
    "Address": "高雄市楠梓區德賢路88號"
}, {
    "POIID": "896481",
    "POIName": "加群",
    "Telno": "(07)3636174",
    "Address": "高雄市楠梓區加昌里40鄰樂群路153號155號1樓"
}, {
    "POIID": "182845",
    "POIName": "好事登",
    "Telno": "(07)3526754",
    "Address": "高雄市楠梓區鳳楠路235號朝明路233號"
}, {
    "POIID": "120250",
    "POIName": "秀昌",
    "Telno": "(07)3641295",
    "Address": "高雄市楠梓區後昌路858之2號1樓"
}, {
    "POIID": "960133",
    "POIName": "亞新",
    "Telno": "(07)3659953",
    "Address": "高雄市楠梓區樂群路76號"
}, {
    "POIID": "180849",
    "POIName": "明月",
    "Telno": "(07)3633402",
    "Address": "高雄市楠梓加工區第二園區創意北路1號"
}, {
    "POIID": "167547",
    "POIName": "欣清心",
    "Telno": "(07)3533490",
    "Address": "高雄市楠梓區清豐二路16號"
}, {
    "POIID": "159281",
    "POIName": "建楠",
    "Telno": "(07)3551501",
    "Address": "高雄市楠梓區中陽里建楠路139號"
}, {
    "POIID": "881685",
    "POIName": "校和",
    "Telno": "(07)3012204",
    "Address": "高雄市楠梓區軍校路658號"
}, {
    "POIID": "990570",
    "POIName": "海科大",
    "Telno": "(07)3658863",
    "Address": "高雄市楠梓區海專路143號145號1樓"
}, {
    "POIID": "112972",
    "POIName": "常德",
    "Telno": "(07)3532424",
    "Address": "高雄市楠梓區清豐里常德路287號"
}, {
    "POIID": "141165",
    "POIName": "梓聖",
    "Telno": "(07)3648745",
    "Address": "高雄市楠梓區瑞屏路80之5號之6號之7號1樓"
}, {
    "POIID": "951988",
    "POIName": "盛田",
    "Telno": "(07)3519446",
    "Address": "高雄市楠梓區享平里興楠路326號"
}, {
    "POIID": "180919",
    "POIName": "祥嘉",
    "Telno": "(07)3538014",
    "Address": "高雄市楠梓區立民路33號"
}, {
    "POIID": "164102",
    "POIName": "都會",
    "Telno": "(07)3641804",
    "Address": "高雄市楠梓區惠豐里德民路115號"
}, {
    "POIID": "165574",
    "POIName": "惠心",
    "Telno": "(07)3600709",
    "Address": "高雄市楠梓區惠民里高楠公路1764之1號"
}, {
    "POIID": "131478",
    "POIName": "惠民",
    "Telno": "(07)3643954",
    "Address": "高雄市楠梓區翠屏里惠民路88號1樓"
}, {
    "POIID": "167385",
    "POIName": "新加昌",
    "Telno": "(07)3644425",
    "Address": "高雄市楠梓區加昌路275.277號"
}, {
    "POIID": "970462",
    "POIName": "新宏昌",
    "Telno": "(07)3654447",
    "Address": "高雄市楠梓區裕昌里右昌街468號1樓"
}, {
    "POIID": "111832",
    "POIName": "新後昌",
    "Telno": "(07)3646497",
    "Address": "高雄市楠梓區錦屏里後昌路115號1樓"
}, {
    "POIID": "189994",
    "POIName": "新創",
    "Telno": "(07)3538062",
    "Address": "高雄市楠梓區創新路1號"
}, {
    "POIID": "112260",
    "POIName": "新楠梓",
    "Telno": "(07)3524954",
    "Address": "高雄市楠梓區中陽里楠梓新路188號188-1號1樓"
}, {
    "POIID": "913067",
    "POIName": "廣昌",
    "Telno": "(07)3608353",
    "Address": "高雄市楠梓區廣昌里廣昌街140號"
}, {
    "POIID": "188429",
    "POIName": "德中",
    "Telno": "(07)5910016",
    "Address": "高雄市楠梓區中和里德中路8號1樓"
}, {
    "POIID": "999809",
    "POIName": "德民",
    "Telno": "(07)3634452",
    "Address": "高雄市楠梓區德民路156號158號"
}, {
    "POIID": "129040",
    "POIName": "德祥",
    "Telno": "(07)3661723",
    "Address": "高雄市楠梓區翠屏里德賢路246號"
}, {
    "POIID": "935883",
    "POIName": "德賢",
    "Telno": "(07)3662023",
    "Address": "高雄市楠梓區翠屏里德賢路594號596號"
}, {
    "POIID": "189374",
    "POIName": "慶昌",
    "Telno": "(07)3680748",
    "Address": "高雄市楠梓區後昌路722號"
}, {
    "POIID": "117911",
    "POIName": "樂民",
    "Telno": "(07)3634607",
    "Address": "高雄市楠梓區加昌里壽民路58號"
}, {
    "POIID": "900197",
    "POIName": "歐士盟",
    "Telno": "(07)3644743",
    "Address": "高雄市楠梓區右昌街619號"
}, {
    "POIID": "179816",
    "POIName": "學安",
    "Telno": "(07)3643028",
    "Address": "高雄市楠梓區藍田路816號"
}, {
    "POIID": "993797",
    "POIName": "藍田",
    "Telno": "(07)3647132",
    "Address": "高雄市楠梓區藍昌路379號1樓"
}, {
    "POIID": "177256",
    "POIName": "藍昌",
    "Telno": "(07)3642993",
    "Address": "高雄市楠梓區後昌路1187號1189號"
}, {
    "POIID": "167008",
    "POIName": "豐創",
    "Telno": "(07)3528747",
    "Address": "高雄市楠梓區創新路76號78號80號1樓"
}, {
    "POIID": "143242",
    "POIName": "雙德",
    "Telno": "(07)3010369",
    "Address": "高雄市楠梓區翠屏里德惠路66號1樓"
}, {
    "POIID": "115856",
    "POIName": "麗景",
    "Telno": "(07)3532334",
    "Address": "高雄市楠梓區清豐里旗楠路891號1樓"
}, {
    "POIID": "146171",
    "POIName": "鑫建昌",
    "Telno": "(07)3637139",
    "Address": "高雄市楠梓區建昌里右昌街148號"
}, ], [{
    "POIID": "154046",
    "POIName": "大阪",
    "Telno": "(07)2862296",
    "Address": "高雄市三民區建國三路28號30號1樓"
}, {
    "POIID": "946458",
    "POIName": "大義",
    "Telno": "(07)3870742",
    "Address": "高雄市三民區大昌二路123號123-1號"
}, {
    "POIID": "896698",
    "POIName": "大德",
    "Telno": "(07)3959257",
    "Address": "高雄市三民區寶玉里大豐二路348號"
}, {
    "POIID": "121873",
    "POIName": "中都",
    "Telno": "(07)3212028",
    "Address": "高雄市三民區力行路248號"
}, {
    "POIID": "115904",
    "POIName": "元隆",
    "Telno": "(07)3983369",
    "Address": "高雄市三民區正興里建元路58號1及2樓"
}, {
    "POIID": "161343",
    "POIName": "文藻",
    "Telno": "(07)3107895",
    "Address": "高雄市三民區民族一路900號"
}, {
    "POIID": "149136",
    "POIName": "本元",
    "Telno": "(07)3810634",
    "Address": "高雄市三民區建工路317號319號"
}, {
    "POIID": "943806",
    "POIName": "光武",
    "Telno": "(07)3875139",
    "Address": "高雄市三民區寶德里覺民路338號"
}, {
    "POIID": "151173",
    "POIName": "吉遠",
    "Telno": "(07)3224734",
    "Address": "高雄市三民區安東里吉林街271號"
}, {
    "POIID": "902735",
    "POIName": "如龍",
    "Telno": "(07)3963182",
    "Address": "高雄市三民區九如一路446號448號"
}, {
    "POIID": "985372",
    "POIName": "安生",
    "Telno": "(07)3214729",
    "Address": "高雄市三民區十全一路74號"
}, {
    "POIID": "862190",
    "POIName": "安冠",
    "Telno": "(07)3953487",
    "Address": "高雄市三民區莊敬路289號"
}, {
    "POIID": "188625",
    "POIName": "坎城",
    "Telno": "(07)3116563",
    "Address": "高雄市三民區十全一路183號"
}, {
    "POIID": "171513",
    "POIName": "孝豐",
    "Telno": "(07)3954224",
    "Address": "高雄市三民區覺民路238號240號"
}, {
    "POIID": "117726",
    "POIName": "宏明",
    "Telno": "(07)3802201",
    "Address": "高雄市三民區本和里大福街211號213號"
}, {
    "POIID": "970761",
    "POIName": "沅興",
    "Telno": "(07)3828237",
    "Address": "高雄市三民區正興里正興路121號123號"
}, {
    "POIID": "177430",
    "POIName": "延慶",
    "Telno": "(07)3926023",
    "Address": "高雄市三民區中民里永年街48號50號52號1樓"
}, {
    "POIID": "149387",
    "POIName": "昌富",
    "Telno": "(07)3905806",
    "Address": "高雄市三民區大豐一路151號153號"
}, {
    "POIID": "922496",
    "POIName": "明仁",
    "Telno": "(07)3438496",
    "Address": "高雄市三民區鼎泰里明仁路8號"
}, {
    "POIID": "128003",
    "POIName": "河堤",
    "Telno": "(07)3410500",
    "Address": "高雄市三民區鼎泰里河堤路510號"
}, {
    "POIID": "149516",
    "POIName": "建強",
    "Telno": "(07)2155083",
    "Address": "高雄市三民區建國三路437號"
}, {
    "POIID": "148063",
    "POIName": "春陽",
    "Telno": "(07)3810323",
    "Address": "高雄市三民區寶珠里正忠路246號"
}, {
    "POIID": "185914",
    "POIName": "科工館",
    "Telno": "(07)3809114",
    "Address": "高雄市三民區安發里平等路91號93號"
}, {
    "POIID": "946207",
    "POIName": "益昌",
    "Telno": "(07)3115571",
    "Address": "高雄市三民區九如二路582號"
}, {
    "POIID": "130040",
    "POIName": "國城",
    "Telno": "(07)2851840",
    "Address": "高雄市三民區自立一路68號70號"
}, {
    "POIID": "992772",
    "POIName": "理馨",
    "Telno": "(07)3506417",
    "Address": "高雄市三民區明吉路9號"
}, {
    "POIID": "162896",
    "POIName": "博河",
    "Telno": "(07)3221446",
    "Address": "高雄市三民區熱河二街17號"
}, {
    "POIID": "143921",
    "POIName": "智由",
    "Telno": "(07)3137226",
    "Address": "高雄市三民區德智里熱河一街190號192號"
}, {
    "POIID": "135964",
    "POIName": "港東",
    "Telno": "(07)2354300",
    "Address": "高雄市三民區建國二路233號"
}, {
    "POIID": "960007",
    "POIName": "港新",
    "Telno": "(07)2230958",
    "Address": "高雄市三民區建國一路417號"
}, {
    "POIID": "166810",
    "POIName": "皓東",
    "Telno": "(07)3987112",
    "Address": "高雄市三民區本武里大豐二路489號"
}, {
    "POIID": "130279",
    "POIName": "雄站",
    "Telno": "(07)2361408",
    "Address": "高雄市三民區港東里建國二路269號271號"
}, {
    "POIID": "946997",
    "POIName": "新大豐",
    "Telno": "(07)3849311",
    "Address": "高雄市三民區正忠路259號"
}, {
    "POIID": "186397",
    "POIName": "新本館",
    "Telno": "(07)3924430",
    "Address": "高雄市三民區大裕路119號"
}, {
    "POIID": "895880",
    "POIName": "新立寧",
    "Telno": "(07)3130332",
    "Address": "高雄市三民區自立一路287號289號"
}, {
    "POIID": "113621",
    "POIName": "新如東",
    "Telno": "(07)3221948",
    "Address": "高雄市三民區九如二路86號1樓"
}, {
    "POIID": "991171",
    "POIName": "新有光",
    "Telno": "(07)3971903",
    "Address": "高雄市三民區有光路123號"
}, {
    "POIID": "980229",
    "POIName": "新旺淇",
    "Telno": "(07)2855841",
    "Address": "高雄市三民區建國三路169號1樓"
}, {
    "POIID": "932965",
    "POIName": "新統興",
    "Telno": "(07)3835941",
    "Address": "高雄市三民區黃興路151號"
}, {
    "POIID": "137616",
    "POIName": "新鼎吉",
    "Telno": "(07)3926364",
    "Address": "高雄市三民區明誠一路381號"
}, {
    "POIID": "186308",
    "POIName": "新鼎祥",
    "Telno": "(07)3453114",
    "Address": "高雄市三民區鼎泰里民族一路543巷25號1樓"
}, {
    "POIID": "140025",
    "POIName": "義明",
    "Telno": "(07)3804208",
    "Address": "高雄市三民區寶國里義華路171號"
}, {
    "POIID": "896492",
    "POIName": "達仁",
    "Telno": "(07)3222813",
    "Address": "高雄市三民區吉林街68號"
}, {
    "POIID": "119618",
    "POIName": "達勇",
    "Telno": "(07)3114049",
    "Address": "高雄市三民區九如二路345-1號"
}, {
    "POIID": "854971",
    "POIName": "鼎力",
    "Telno": "(07)3494282",
    "Address": "高雄市三民區天祥一路124號"
}, {
    "POIID": "179735",
    "POIName": "鼎上",
    "Telno": "(07)3494150",
    "Address": "高雄市三民區鼎中路160號1樓"
}, {
    "POIID": "165910",
    "POIName": "鼎中",
    "Telno": "(07)3424542",
    "Address": "高雄市三民區鼎中路735號737號1樓"
}, {
    "POIID": "167293",
    "POIName": "鼎強",
    "Telno": "(07)3494114",
    "Address": "高雄市三民區鼎強里鼎金後路432號1.2樓"
}, {
    "POIID": "892375",
    "POIName": "鼎復",
    "Telno": "(07)3848597",
    "Address": "高雄市三民區鼎山街566-3號"
}, {
    "POIID": "132138",
    "POIName": "鼎貴",
    "Telno": "(07)3424756",
    "Address": "高雄市三民區鼎貴路146號1樓"
}, {
    "POIID": "932976",
    "POIName": "鼎新",
    "Telno": "(07)3104545",
    "Address": "高雄市三民區鼎新路86號88號1樓"
}, {
    "POIID": "170495",
    "POIName": "鼎瑞",
    "Telno": "(07)3430546",
    "Address": "高雄市三民區鼎泰里裕誠路56號"
}, {
    "POIID": "855239",
    "POIName": "嫩江",
    "Telno": "(07)3117581",
    "Address": "高雄市三民區嫩江街101號"
}, {
    "POIID": "182890",
    "POIName": "鳳中",
    "Telno": "(07)2855467",
    "Address": "高雄市三民區建國三路285號1樓"
}, {
    "POIID": "990134",
    "POIName": "興安邦",
    "Telno": "(07)3132327",
    "Address": "高雄市三民區安邦里察哈爾二街83號1樓"
}, {
    "POIID": "905354",
    "POIName": "興國",
    "Telno": "(07)2388472",
    "Address": "高雄市三民區復興１路176號"
}, {
    "POIID": "186272",
    "POIName": "龍城",
    "Telno": "(07)3982831",
    "Address": "高雄市三民區寶安里建興路51號53號1樓"
}, {
    "POIID": "885643",
    "POIName": "雙興",
    "Telno": "(07)3925474",
    "Address": "高雄市三民區正興路1號3號"
}, {
    "POIID": "161608",
    "POIName": "寶民",
    "Telno": "(07)3847183",
    "Address": "高雄市三民區寶民里正義路337號"
}, {
    "POIID": "960731",
    "POIName": "寶盛",
    "Telno": "(07)3952075",
    "Address": "高雄市三民區覺民路579號"
}, {
    "POIID": "864107",
    "POIName": "覺民",
    "Telno": "(07)3892352",
    "Address": "高雄市三民區覺民路113號115號"
}, {
    "POIID": "177290",
    "POIName": "鑫永年",
    "Telno": "(07)3805933",
    "Address": "高雄市三民區安康里九如一路877號"
}, {
    "POIID": "190673",
    "POIName": "鑫領千",
    "Telno": "(07)3809554",
    "Address": "高雄市三民區民族一路94號96號1樓"
}, {
    "POIID": "189514",
    "POIName": "鑫寶華",
    "Telno": "(07)3870904",
    "Address": "高雄市三民區九如一路126號"
}, {
    "POIID": "956477",
    "POIName": "灣勝",
    "Telno": "(07)3955648",
    "Address": "高雄市三民區新民路103號105號"
}, ], [{
    "POIID": "170347",
    "POIName": "大民",
    "Telno": "(07)3528550",
    "Address": "高雄市大社區三民路213號"
}, {
    "POIID": "186135",
    "POIName": "大社",
    "Telno": "(07)3527294",
    "Address": "高雄市大社區翠屏里三民路304號"
}, {
    "POIID": "170370",
    "POIName": "好事達",
    "Telno": "(07)3538846",
    "Address": "高雄市大社區保社里旗楠路71號"
}, {
    "POIID": "139092",
    "POIName": "鈦旺",
    "Telno": "(07)3531423",
    "Address": "高雄市大社區中山路261號"
}, {
    "POIID": "136532",
    "POIName": "翠屏",
    "Telno": "(07)3540580",
    "Address": "高雄市大社區中山路344號346號"
}, {
    "POIID": "991573",
    "POIName": "觀音",
    "Telno": "(07)3521272",
    "Address": "高雄市大社區大新路111號金龍路316號318號"
}, ], [{
    "POIID": "928612",
    "POIName": "大港埔",
    "Telno": "(07)2820698",
    "Address": "高雄市新興區東坡里大同一路81號83號"
}, {
    "POIID": "170060",
    "POIName": "中義",
    "Telno": "(07)2369600",
    "Address": "高雄市新興區中正三路30號"
}, {
    "POIID": "956400",
    "POIName": "天健",
    "Telno": "(07)2861637",
    "Address": "高雄市新興區中山一路279號"
}, {
    "POIID": "162117",
    "POIName": "文昌",
    "Telno": "(07)2242435",
    "Address": "高雄市新興區六合路117號"
}, {
    "POIID": "184209",
    "POIName": "正仁",
    "Telno": "(07)2365274",
    "Address": "高雄市新興區中正三路84號1.B1樓"
}, {
    "POIID": "181783",
    "POIName": "正達",
    "Telno": "(07)2236459",
    "Address": "高雄市新興區中正三路45號1樓"
}, {
    "POIID": "130246",
    "POIName": "尚義",
    "Telno": "(07)2236482",
    "Address": "高雄市新興區中正二路218號"
}, {
    "POIID": "129198",
    "POIName": "明星",
    "Telno": "(07)2889297",
    "Address": "高雄市新興區自立二路146號"
}, {
    "POIID": "110769",
    "POIName": "信賢",
    "Telno": "(07)2360634",
    "Address": "高雄市新興區南港里七賢一路432號1樓"
}, {
    "POIID": "996899",
    "POIName": "建興",
    "Telno": "(07)2863634",
    "Address": "高雄市新興區七賢二路86號"
}, {
    "POIID": "980403",
    "POIName": "高銀",
    "Telno": "(07)2357948",
    "Address": "高雄市新興區六合一路158號"
}, {
    "POIID": "170129",
    "POIName": "清漢",
    "Telno": "(07)2222403",
    "Address": "高雄市新興區德望里民生一路154號1樓"
}, {
    "POIID": "905077",
    "POIName": "復橫",
    "Telno": "(07)2268701",
    "Address": "高雄市新興區復興一路28號30號"
}, {
    "POIID": "971502",
    "POIName": "新三華",
    "Telno": "(07)2368423",
    "Address": "高雄市新興區中東里復興一路72號1樓"
}, {
    "POIID": "895879",
    "POIName": "新田",
    "Telno": "(07)2115007",
    "Address": "高雄市新興區新田路189號191號"
}, {
    "POIID": "154714",
    "POIName": "新崛江",
    "Telno": "(07)2163995",
    "Address": "高雄市新興區振成里新田路114號"
}, {
    "POIID": "185660",
    "POIName": "新球庭",
    "Telno": "(07)2414062",
    "Address": "高雄市新興區林森一路162號"
}, {
    "POIID": "920582",
    "POIName": "新新賢",
    "Telno": "(07)2385607",
    "Address": "高雄市新興區開平里七賢一路268號270號"
}, {
    "POIID": "948708",
    "POIName": "興村",
    "Telno": "(07)2829812",
    "Address": "高雄市新興區五福二路92號"
}, {
    "POIID": "865627",
    "POIName": "寶成",
    "Telno": "(07)2822363",
    "Address": "高雄市新興區青年一路220號"
}, {
    "POIID": "981820",
    "POIName": "鑫明莊",
    "Telno": "(07)2854756",
    "Address": "高雄市新興區六合二路24號"
}, ], [{
    "POIID": "127376",
    "POIName": "八卦寮",
    "Telno": "(07)3724588",
    "Address": "高雄市仁武區大灣里八德南路499號"
}, {
    "POIID": "982694",
    "POIName": "三福",
    "Telno": "(07)3751295",
    "Address": "高雄市仁武區仁武里中正路175號1樓"
}, {
    "POIID": "173900",
    "POIName": "仁心",
    "Telno": "(07)3749210",
    "Address": "高雄市仁武區考潭里仁心路198-1號1樓"
}, {
    "POIID": "154817",
    "POIName": "仁雄",
    "Telno": "(07)3742364",
    "Address": "高雄市仁武區仁雄路6之11號1樓"
}, {
    "POIID": "151324",
    "POIName": "仁慈",
    "Telno": "(07)7353499",
    "Address": "高雄市仁武區仁慈里仁慈路169號1樓"
}, {
    "POIID": "131582",
    "POIName": "仁樂",
    "Telno": "(07)3711110",
    "Address": "高雄市仁武區仁武里仁和街36號"
}, {
    "POIID": "125831",
    "POIName": "友福",
    "Telno": "(07)3736036",
    "Address": "高雄市仁武區灣內里鳳仁路95之15號"
}, {
    "POIID": "854030",
    "POIName": "台塑",
    "Telno": "(07)3729649",
    "Address": "高雄市仁武區竹後里水管路189號"
}, {
    "POIID": "923662",
    "POIName": "永仁",
    "Telno": "(07)3747347",
    "Address": "高雄市仁武區八卦里永仁街436號"
}, {
    "POIID": "182591",
    "POIName": "米妃",
    "Telno": "(07)3735004",
    "Address": "高雄市仁武區文武里中華路327-1號"
}, {
    "POIID": "941051",
    "POIName": "京富",
    "Telno": "(07)3732953",
    "Address": "高雄市仁武區八卦里八德南路382號1樓"
}, {
    "POIID": "153906",
    "POIName": "尚賀",
    "Telno": "(07)3748241",
    "Address": "高雄市仁武區赤山里仁雄路87號1樓"
}, {
    "POIID": "921172",
    "POIName": "家恩",
    "Telno": "(07)3736049",
    "Address": "高雄市仁武區中華路46號"
}, {
    "POIID": "185198",
    "POIName": "得合",
    "Telno": "(07)3754863",
    "Address": "高雄市仁武區八德西路1660號"
}, {
    "POIID": "124610",
    "POIName": "得富",
    "Telno": "(07)3723458",
    "Address": "高雄市仁武區八卦里八德西路246號"
}, {
    "POIID": "996280",
    "POIName": "登發",
    "Telno": "(07)3739703",
    "Address": "高雄市仁武區八卦里八德南路65號"
}, {
    "POIID": "141637",
    "POIName": "澄合",
    "Telno": "(07)3747531",
    "Address": "高雄市仁武區仁光路165號1樓"
}, ], [{
    "POIID": "158381",
    "POIName": "仁美",
    "Telno": "(07)7318554",
    "Address": "高雄市鳥松區學堂路18號20號"
}, {
    "POIID": "941198",
    "POIName": "正修",
    "Telno": "(07)7352360",
    "Address": "高雄市鳥松區鳥松里澄清路840號"
}, {
    "POIID": "996349",
    "POIName": "長青",
    "Telno": "(07)7327025",
    "Address": "高雄市鳥松區鳥松里大智路5號"
}, {
    "POIID": "188119",
    "POIName": "球場",
    "Telno": "(07)3706395",
    "Address": "高雄市鳥松區本館路196號1樓"
}, {
    "POIID": "971557",
    "POIName": "翔盛",
    "Telno": "(07)7351489",
    "Address": "高雄市鳥松區水土埔里神農路479號"
}, {
    "POIID": "148661",
    "POIName": "新鳳松",
    "Telno": "(07)7353853",
    "Address": "高雄市鳥松區鳥松里大仁北路2號1樓"
}, ], [{
    "POIID": "132150",
    "POIName": "太華",
    "Telno": "(07)2153185",
    "Address": "高雄市前金區成功一路455之1號"
}, {
    "POIID": "885838",
    "POIName": "文東",
    "Telno": "(07)2169478",
    "Address": "高雄市前金區新田路226號228號"
}, {
    "POIID": "935816",
    "POIName": "市賢",
    "Telno": "(07)2716220",
    "Address": "高雄市前金區市中一路242號"
}, {
    "POIID": "833594",
    "POIName": "自強",
    "Telno": "(07)2515634",
    "Address": "高雄市前金區自強二路39號"
}, {
    "POIID": "162667",
    "POIName": "長生",
    "Telno": "(07)2610818",
    "Address": "高雄市前金區五福三路54號"
}, {
    "POIID": "159074",
    "POIName": "長興",
    "Telno": "(07)2887238",
    "Address": "高雄市前金區瑞源路68號70號72號"
}, {
    "POIID": "996682",
    "POIName": "青盛",
    "Telno": "(07)2729349",
    "Address": "高雄市前金區大同一路268號1樓"
}, {
    "POIID": "928597",
    "POIName": "前金",
    "Telno": "(07)2419355",
    "Address": "高雄市前金區自強二路172號"
}, {
    "POIID": "166762",
    "POIName": "博仁",
    "Telno": "(07)2215703",
    "Address": "高雄市前金區五福三路97之1號1樓"
}, {
    "POIID": "185693",
    "POIName": "愛之船",
    "Telno": "(07)2218107",
    "Address": "高雄市前金區河東路165號1樓"
}, {
    "POIID": "171465",
    "POIName": "愛河",
    "Telno": "(07)2414252",
    "Address": "高雄市前金區博孝里河東路8號1樓"
}, {
    "POIID": "860208",
    "POIName": "新盛",
    "Telno": "(07)2871936",
    "Address": "高雄市前金區草江里七賢二路193號193之1"
}, {
    "POIID": "159502",
    "POIName": "龍客",
    "Telno": "(07)2158324",
    "Address": "高雄市前金區大同二路1號"
}, ], [{
    "POIID": "162726",
    "POIName": "仁東",
    "Telno": "(07)6217245",
    "Address": "高雄市岡山區大仁北路175號1樓"
}, {
    "POIID": "143611",
    "POIName": "仁峰",
    "Telno": "(07)6254834",
    "Address": "高雄市岡山區壽峰里前峰路152號之1一樓"
}, {
    "POIID": "122625",
    "POIName": "仁富",
    "Telno": "(07)6213744",
    "Address": "高雄市岡山區大仁路138號"
}, {
    "POIID": "968908",
    "POIName": "友情",
    "Telno": "(07)6252734",
    "Address": "高雄市岡山區大遼里大遼路122-3號"
}, {
    "POIID": "950480",
    "POIName": "北岡山",
    "Telno": "(07)6224840",
    "Address": "高雄市岡山區灣裡里岡山北路150號"
}, {
    "POIID": "950664",
    "POIName": "台興",
    "Telno": "(07)6226112",
    "Address": "高雄市岡山區台上里嘉新東路136號"
}, {
    "POIID": "153881",
    "POIName": "石潭",
    "Telno": "(07)6258364",
    "Address": "高雄市岡山區石潭路258號"
}, {
    "POIID": "913584",
    "POIName": "利明",
    "Telno": "(07)6257053",
    "Address": "高雄市岡山區壽峰里前峰路80號"
}, {
    "POIID": "136901",
    "POIName": "岡農",
    "Telno": "(07)6212911",
    "Address": "高雄市岡山區壽天里公園東路154號"
}, {
    "POIID": "165758",
    "POIName": "岡燕",
    "Telno": "(07)6235590",
    "Address": "高雄市岡山區岡山路264號266號"
}, {
    "POIID": "187666",
    "POIName": "肯娣",
    "Telno": "(07)6226672",
    "Address": "高雄市岡山區壽天里壽天路37號之3"
}, {
    "POIID": "181484",
    "POIName": "柳橋",
    "Telno": "(07)6256680",
    "Address": "高雄市岡山區後協里仁壽路248號"
}, {
    "POIID": "897886",
    "POIName": "森鴻",
    "Telno": "(07)6228076",
    "Address": "高雄市岡山區大德一路160號"
}, {
    "POIID": "965231",
    "POIName": "程香",
    "Telno": "(07)6225259",
    "Address": "高雄市岡山區後紅里大仁南路133號"
}, {
    "POIID": "188795",
    "POIName": "華仁",
    "Telno": "(07)6259821",
    "Address": "高雄市岡山區仁壽里仁壽路106號"
}, {
    "POIID": "990097",
    "POIName": "新上緯",
    "Telno": "(07)6231481",
    "Address": "高雄市岡山區嘉興里嘉興路340號"
}, {
    "POIID": "139081",
    "POIName": "新兆湘",
    "Telno": "(07)6250698",
    "Address": "高雄市岡山區信義里介壽路10巷25弄9號15號"
}, {
    "POIID": "936381",
    "POIName": "群弘益",
    "Telno": "(07)6222072",
    "Address": "高雄市岡山區碧紅里中山北路2號"
}, {
    "POIID": "954378",
    "POIName": "維洲",
    "Telno": "(07)6224493",
    "Address": "高雄市岡山區本洲里本洲路350-5號"
}, {
    "POIID": "111739",
    "POIName": "勵志",
    "Telno": "(07)6295142",
    "Address": "高雄市岡山區筧橋路12號16號1樓"
}, {
    "POIID": "186814",
    "POIName": "鴻林",
    "Telno": "(07)6267334",
    "Address": "高雄市岡山區仁壽里公園西路3段131號133號"
}, {
    "POIID": "143161",
    "POIName": "鑫省岡",
    "Telno": "(07)6213534",
    "Address": "高雄市岡山區台上里成功路82號1樓"
}, {
    "POIID": "129051",
    "POIName": "鑫程",
    "Telno": "(07)6227110",
    "Address": "高雄市岡山區大德二路61號"
}, ], [{
    "POIID": "159018",
    "POIName": "大順",
    "Telno": "(07)7230499",
    "Address": "高雄市苓雅區大順三路76號1樓"
}, {
    "POIID": "185800",
    "POIName": "大輔",
    "Telno": "(07)7228664",
    "Address": "高雄市苓雅區正心里輔仁路333號"
}, {
    "POIID": "143909",
    "POIName": "中仁",
    "Telno": "(07)3387403",
    "Address": "高雄市苓雅區興中二路38號1樓"
}, {
    "POIID": "896997",
    "POIName": "中雅",
    "Telno": "(07)5370234",
    "Address": "高雄市苓雅區中山二路463號"
}, {
    "POIID": "113953",
    "POIName": "正心",
    "Telno": "(07)7224176",
    "Address": "高雄市苓雅區正大里輔仁路一段145號1樓"
}, {
    "POIID": "991285",
    "POIName": "正文",
    "Telno": "(07)7277235",
    "Address": "高雄市苓雅區正大里建國一路125號125-1號1樓"
}, {
    "POIID": "896193",
    "POIName": "永泰",
    "Telno": "(07)3305281",
    "Address": "高雄市苓雅區苓雅二路243號"
}, {
    "POIID": "875440",
    "POIName": "合平",
    "Telno": "(07)2274811",
    "Address": "高雄市苓雅區安祥里六合路60號"
}, {
    "POIID": "166784",
    "POIName": "好正義",
    "Telno": "(07)7405026",
    "Address": "高雄市苓雅區正義路195號197號1樓"
}, {
    "POIID": "186098",
    "POIName": "宏順",
    "Telno": "(07)7218967",
    "Address": "高雄市苓雅區三多一路108.110號"
}, {
    "POIID": "121703",
    "POIName": "明得",
    "Telno": "(07)2234461",
    "Address": "高雄市苓雅區民主里憲政路100號1樓"
}, {
    "POIID": "914152",
    "POIName": "東泥",
    "Telno": "(07)2691458",
    "Address": "高雄市苓雅區意誠里三多四路93號"
}, {
    "POIID": "135274",
    "POIName": "林德",
    "Telno": "(07)7213735",
    "Address": "高雄市苓雅區林南里林德街37號1樓"
}, {
    "POIID": "177201",
    "POIName": "武勝",
    "Telno": "(07)7226240",
    "Address": "高雄市苓雅區武廟路55號55之1號57號1.2樓59號2樓"
}, {
    "POIID": "115889",
    "POIName": "武漢",
    "Telno": "(07)7214004",
    "Address": "高雄市苓雅區武漢街72號"
}, {
    "POIID": "130545",
    "POIName": "青雅",
    "Telno": "(07)2233056",
    "Address": "高雄市苓雅區青年一路6之8及6之9號"
}, {
    "POIID": "896001",
    "POIName": "建福",
    "Telno": "(07)7253369",
    "Address": "高雄市苓雅區五福里建國一路208號"
}, {
    "POIID": "833000",
    "POIName": "美田",
    "Telno": "(07)3391186",
    "Address": "高雄市苓雅區林森二路79號"
}, {
    "POIID": "892308",
    "POIName": "英明",
    "Telno": "(07)7521603",
    "Address": "高雄市苓雅區英明路190號1樓"
}, {
    "POIID": "137041",
    "POIName": "高昇",
    "Telno": "(07)3348738",
    "Address": "高雄市苓雅區中華四路64號"
}, {
    "POIID": "180713",
    "POIName": "強泥",
    "Telno": "(07)2692125",
    "Address": "高雄市苓雅區自強三路2.6號新光路72.74號"
}, {
    "POIID": "113481",
    "POIName": "復中",
    "Telno": "(07)3380029",
    "Address": "高雄市苓雅區興中一路138號"
}, {
    "POIID": "171270",
    "POIName": "晴朗",
    "Telno": "(07)3352263",
    "Address": "高雄市苓雅區晴朗里復興二路162號"
}, {
    "POIID": "128612",
    "POIName": "華堂",
    "Telno": "(07)3384922",
    "Address": "高雄市苓雅區廣澤里文橫二路41號"
}, {
    "POIID": "174659",
    "POIName": "雅慶",
    "Telno": "(07)2246828",
    "Address": "高雄市苓雅區同慶里同慶路88號90號"
}, {
    "POIID": "162586",
    "POIName": "新仁政",
    "Telno": "(07)3343963",
    "Address": "高雄市苓雅區仁政里青年一路299號301號303號1樓"
}, {
    "POIID": "941615",
    "POIName": "新強",
    "Telno": "(07)2695450",
    "Address": "高雄市苓雅區意誠里新光路64號66號"
}, {
    "POIID": "981211",
    "POIName": "新景有",
    "Telno": "(07)7238146",
    "Address": "高雄市苓雅區福德三路170號1樓"
}, {
    "POIID": "141246",
    "POIName": "新道明",
    "Telno": "(07)2251125",
    "Address": "高雄市苓雅區建國一路211號213號"
}, {
    "POIID": "165895",
    "POIName": "新灣",
    "Telno": "(07)5665433",
    "Address": "高雄市苓雅區自強三路3號12樓之6.7.8"
}, {
    "POIID": "186294",
    "POIName": "萬應",
    "Telno": "(07)3364904",
    "Address": "高雄市苓雅區四維四路190-1號"
}, {
    "POIID": "185040",
    "POIName": "福海",
    "Telno": "(07)7279275",
    "Address": "高雄市苓雅區三多一路239號1樓"
}, {
    "POIID": "159096",
    "POIName": "維雄",
    "Telno": "(07)7164323",
    "Address": "高雄市苓雅區和平一路100號"
}, {
    "POIID": "148203",
    "POIName": "銀光",
    "Telno": "(07)2230248",
    "Address": "高雄市苓雅區林圍里光華一路263號"
}, {
    "POIID": "170808",
    "POIName": "廣東",
    "Telno": "(07)7110044",
    "Address": "高雄市苓雅區四維二路94之21號"
}, ], [{
    "POIID": "131766",
    "POIName": "五里林",
    "Telno": "(07)6119640",
    "Address": "高雄市橋頭區東林里里林東路20號"
}, {
    "POIID": "978123",
    "POIName": "仕隆",
    "Telno": "(07)6120711",
    "Address": "高雄市橋頭區白樹里32鄰白樹路53號"
}, {
    "POIID": "181510",
    "POIName": "仕豐",
    "Telno": "(07)6113845",
    "Address": "高雄市橋頭區仕豐路61號1樓"
}, {
    "POIID": "947244",
    "POIName": "甲圍",
    "Telno": "(07)6130787",
    "Address": "高雄市橋頭區甲北里甲圍路71號"
}, {
    "POIID": "164032",
    "POIName": "新隆豐",
    "Telno": "(07)6126956",
    "Address": "高雄市橋頭區仕隆里隆豐路275號"
}, {
    "POIID": "188393",
    "POIName": "橋鄰",
    "Telno": "(07)6112945",
    "Address": "高雄市橋頭區仕隆里成功南路151號1樓"
}, ], [{
    "POIID": "922267",
    "POIName": "上德",
    "Telno": "(07)8314990",
    "Address": "高雄市前鎮區草衙里草衙二路299號299-1號"
}, {
    "POIID": "154552",
    "POIName": "中鋼會館",
    "Telno": "(07)5366649",
    "Address": "高雄市前鎮區忠純里忠勤路23號1樓"
}, {
    "POIID": "915546",
    "POIName": "天山",
    "Telno": "(07)3356854",
    "Address": "高雄市前鎮區一心一路406號"
}, {
    "POIID": "144898",
    "POIName": "天后",
    "Telno": "(07)8126049",
    "Address": "高雄市前鎮區后平路87號1樓"
}, {
    "POIID": "904041",
    "POIName": "心日",
    "Telno": "(07)8152321",
    "Address": "高雄市前鎮區忠誠路213號"
}, {
    "POIID": "861061",
    "POIName": "后安",
    "Telno": "(07)8314243",
    "Address": "高雄市前鎮區草衙里后安路146號"
}, {
    "POIID": "991528",
    "POIName": "竹中",
    "Telno": "(07)7222801",
    "Address": "高雄市前鎮區和平二路242號1樓"
}, {
    "POIID": "153858",
    "POIName": "京明",
    "Telno": "(07)7260457",
    "Address": "高雄市前鎮區瑞北路54號1樓及B1"
}, {
    "POIID": "184553",
    "POIName": "忠純",
    "Telno": "(07)5361082",
    "Address": "高雄市前鎮區忠純里中華五路969巷6號1樓"
}, {
    "POIID": "171535",
    "POIName": "泰豐",
    "Telno": "(07)7170231",
    "Address": "高雄市前鎮區永豐路1號"
}, {
    "POIID": "895938",
    "POIName": "高雄",
    "Telno": "(07)3367915",
    "Address": "高雄市前鎮區復興三路116號"
}, {
    "POIID": "922500",
    "POIName": "崗正",
    "Telno": "(07)7162008",
    "Address": "高雄市前鎮區瑞平里公正路25號"
}, {
    "POIID": "132873",
    "POIName": "康德",
    "Telno": "(07)8413825",
    "Address": "高雄市前鎮區鎮興路8號1樓"
}, {
    "POIID": "163729",
    "POIName": "軟科",
    "Telno": "(07)5364727",
    "Address": "高雄市前鎮區復興四路10號1樓"
}, {
    "POIID": "162911",
    "POIName": "復興",
    "Telno": "(07)3312662",
    "Address": "高雄市前鎮區復興三路150號1樓"
}, {
    "POIID": "909194",
    "POIName": "揚揚",
    "Telno": "(07)5373552",
    "Address": "高雄市前鎮區民權里鄭和路67號1F"
}, {
    "POIID": "971708",
    "POIName": "雄捷",
    "Telno": "(07)3386084",
    "Address": "高雄市前鎮區中山二路268號B1(高雄捷運R8站)"
}, {
    "POIID": "953065",
    "POIName": "雄鎮",
    "Telno": "(07)8116193",
    "Address": "高雄市前鎮區高雄加工出口區東一街7號"
}, {
    "POIID": "981093",
    "POIName": "新光和",
    "Telno": "(07)5367297",
    "Address": "高雄市前鎮區鄭和南路307號309號"
}, {
    "POIID": "162933",
    "POIName": "新盛心",
    "Telno": "(07)3309722",
    "Address": "高雄市前鎮區一心二路208號"
}, {
    "POIID": "143600",
    "POIName": "新衙",
    "Telno": "(07)8218714",
    "Address": "高雄市前鎮區草衙一路41號43號"
}, {
    "POIID": "140704",
    "POIName": "新憲德",
    "Telno": "(07)7279437",
    "Address": "高雄市前鎮區瑞隆路619號"
}, {
    "POIID": "936037",
    "POIName": "獅甲",
    "Telno": "(07)5373172",
    "Address": "高雄市前鎮區忠純里中華五路997號"
}, {
    "POIID": "960764",
    "POIName": "瑞正",
    "Telno": "(07)7168052",
    "Address": "高雄市前鎮區瑞興里瑞北路157號159號"
}, {
    "POIID": "158679",
    "POIName": "瑞崗",
    "Telno": "(07)7223731",
    "Address": "高雄市前鎮區瑞昌里瑞隆路310號312號"
}, {
    "POIID": "912101",
    "POIName": "瑞祥",
    "Telno": "(07)7154630",
    "Address": "高雄市前鎮區瑞祥里崗山中街251號"
}, {
    "POIID": "916402",
    "POIName": "達家",
    "Telno": "(07)8132874",
    "Address": "高雄市前鎮區草衙里草衙二路407號"
}, {
    "POIID": "120674",
    "POIName": "夢時代一",
    "Telno": "(07)8231906",
    "Address": "高雄市前鎮區中華五路789號B2樓"
}, {
    "POIID": "911555",
    "POIName": "德新",
    "Telno": "(07)8124289",
    "Address": "高雄市前鎮區仁愛里新衙路83號85號"
}, {
    "POIID": "148225",
    "POIName": "慶華",
    "Telno": "(07)3341721",
    "Address": "高雄市前鎮區光華二路395號"
}, {
    "POIID": "875602",
    "POIName": "賢明",
    "Telno": "(07)7238081",
    "Address": "高雄市前鎮區竹內里賢明路3號5號"
}, {
    "POIID": "111843",
    "POIName": "學源",
    "Telno": "(07)5364382",
    "Address": "高雄市前鎮區三多二路437號439號441號1樓"
}, {
    "POIID": "115960",
    "POIName": "臨廣",
    "Telno": "(07)8414875",
    "Address": "高雄市前鎮區新生路248-45號"
}, {
    "POIID": "136680",
    "POIName": "鎮昌",
    "Telno": "(07)8125504",
    "Address": "高雄市前鎮區鎮海里鎮海路17號1樓"
}, {
    "POIID": "956215",
    "POIName": "鎮陽",
    "Telno": "(07)8152693",
    "Address": "高雄市前鎮區鎮陽里前鎮街278號280號"
}, {
    "POIID": "130084",
    "POIName": "鎮興",
    "Telno": "(07)8415339",
    "Address": "高雄市前鎮區鎮興路170號"
}, {
    "POIID": "982409",
    "POIName": "鑫愛群",
    "Telno": "(07)3340695",
    "Address": "高雄市前鎮區復興三路435號437號"
}, ], [{
    "POIID": "131489",
    "POIName": "中民",
    "Telno": "(07)6143482",
    "Address": "高雄市燕巢區中民路712號714號"
}, {
    "POIID": "954781",
    "POIName": "安招",
    "Telno": "(07)6143179",
    "Address": "高雄市燕巢區安招里安東街380號"
}, {
    "POIID": "142412",
    "POIName": "高應大",
    "Telno": "(07)6154009",
    "Address": "高雄市燕巢區深中路58號1樓"
}, {
    "POIID": "151829",
    "POIName": "華輝",
    "Telno": "(07)6154213",
    "Address": "高雄市燕巢區橫山里橫山路59號"
}, {
    "POIID": "911854",
    "POIName": "旗鳳",
    "Telno": "(07)6154139",
    "Address": "高雄市燕巢區鳳雄里鳳旗路167號169號"
}, {
    "POIID": "163718",
    "POIName": "燕巢",
    "Telno": "(07)6168128",
    "Address": "高雄市燕巢區西燕里中民路612號"
}, ], [{
    "POIID": "970945",
    "POIName": "新旗聖",
    "Telno": "(07)5714983",
    "Address": "高雄市旗津區中洲二路83號85號"
}, {
    "POIID": "170576",
    "POIName": "旗津",
    "Telno": "(07)5719252",
    "Address": "高雄市旗津區海岸路9號"
}, {
    "POIID": "982317",
    "POIName": "旗皇",
    "Telno": "(07)5713430",
    "Address": "高雄市旗津區中華里旗津三路900巷1號3號"
}, {
    "POIID": "136266",
    "POIName": "旗海",
    "Telno": "(07)5714206",
    "Address": "高雄市旗津區中洲三路579號"
}, {
    "POIID": "990411",
    "POIName": "旗廟",
    "Telno": "(07)5712330",
    "Address": "高雄市旗津區振興里廟前路12號1樓"
}, ], [{
    "POIID": "131319",
    "POIName": "大坪頂",
    "Telno": "(07)8912651",
    "Address": "高雄市小港區坪頂里大平路192號196號1樓"
}, {
    "POIID": "165080",
    "POIName": "大林蒲",
    "Telno": "(07)8714082",
    "Address": "高雄市小港區鳳林路181號"
}, {
    "POIID": "158174",
    "POIName": "中鋼小港",
    "Telno": "(07)8021111#2684",
    "Address": "高雄市小港區鳳宮里中鋼路1號2樓"
}, {
    "POIID": "136749",
    "POIName": "孔鳳",
    "Telno": "(07)7917717",
    "Address": "高雄市小港區孔宅里高鳳路332號"
}, {
    "POIID": "972158",
    "POIName": "田金",
    "Telno": "(07)8070928",
    "Address": "高雄市小港區山明里水秀路59號"
}, {
    "POIID": "187493",
    "POIName": "名言",
    "Telno": "(07)8715921",
    "Address": "高雄市小港區鳳森里鳳林路2-18號"
}, {
    "POIID": "966119",
    "POIName": "宏文",
    "Telno": "(07)8036342",
    "Address": "高雄市小港區泰山里宏平路83-2號"
}, {
    "POIID": "855295",
    "POIName": "宏平",
    "Telno": "(07)8063604",
    "Address": "高雄市小港區宏平路390號392號"
}, {
    "POIID": "153870",
    "POIName": "宏亮",
    "Telno": "(07)8067220",
    "Address": "高雄市小港區宏亮里山明路445號447號壹+貳樓"
}, {
    "POIID": "930660",
    "POIName": "宏華",
    "Telno": "(07)8069912",
    "Address": "高雄市小港區松舍里漢民路829號"
}, {
    "POIID": "143563",
    "POIName": "松旅",
    "Telno": "(07)8069924",
    "Address": "高雄市小港區山明里松信路88號1樓"
}, {
    "POIID": "159247",
    "POIName": "松興",
    "Telno": "(07)8071434",
    "Address": "高雄市小港區松山里高鳳路34-5-6號"
}, {
    "POIID": "154954",
    "POIName": "沿海",
    "Telno": "(07)8012161",
    "Address": "高雄市小港區康莊路178之1號1樓"
}, {
    "POIID": "160328",
    "POIName": "金宏",
    "Telno": "(07)8061835",
    "Address": "高雄市小港區順苓里宏平路501號"
}, {
    "POIID": "131102",
    "POIName": "桂安",
    "Telno": "(07)7934767",
    "Address": "高雄市小港區孔鳳路557號"
}, {
    "POIID": "874104",
    "POIName": "桂陽",
    "Telno": "(07)7930117",
    "Address": "高雄市小港區桂陽路255號"
}, {
    "POIID": "971339",
    "POIName": "桂德",
    "Telno": "(07)7932498",
    "Address": "高雄市小港區桂林里中安路428號"
}, {
    "POIID": "893312",
    "POIName": "強民",
    "Telno": "(07)8124098",
    "Address": "高雄市小港區小港路182號"
}, {
    "POIID": "895949",
    "POIName": "港口",
    "Telno": "(07)8114439",
    "Address": "高雄市小港區港口里平和路77號"
}, {
    "POIID": "114602",
    "POIName": "港后",
    "Telno": "(07)8417962",
    "Address": "高雄市小港區平和路156號"
}, {
    "POIID": "958440",
    "POIName": "港瑞",
    "Telno": "(07)8022369",
    "Address": "高雄市小港區小港里小港路77號"
}, {
    "POIID": "181587",
    "POIName": "雄航",
    "Telno": "(07)8018305",
    "Address": "高雄市小港區山東里中山四路2號1樓"
}, {
    "POIID": "188670",
    "POIName": "順苓",
    "Telno": "(07)8039482",
    "Address": "高雄市小港區漢民路381號"
}, {
    "POIID": "118741",
    "POIName": "新漢北",
    "Telno": "(07)8021586",
    "Address": "高雄市小港區漢民路132號134號1樓"
}, {
    "POIID": "174729",
    "POIName": "樺鑫",
    "Telno": "(07)7928411",
    "Address": "高雄市小港區中安路739號"
}, ], [{
    "POIID": "170602",
    "POIName": "阿蓮",
    "Telno": "(07)6310329",
    "Address": "高雄市阿蓮區中山路15號17號19號"
}, {
    "POIID": "181521",
    "POIName": "展穫",
    "Telno": "(07)6310394",
    "Address": "高雄市阿蓮區中正路897號"
}, {
    "POIID": "998091",
    "POIName": "傳生",
    "Telno": "(07)6319041",
    "Address": "高雄市阿蓮區中正路407號"
}, {
    "POIID": "914244",
    "POIName": "蓮山",
    "Telno": "(07)6321745",
    "Address": "高雄市阿蓮區民生路92號"
}, {
    "POIID": "954530",
    "POIName": "蕙馨",
    "Telno": "(07)6319484",
    "Address": "高雄市阿蓮區阿蓮里中正路188-8號"
}, ], [{
    "POIID": "114118",
    "POIName": "一揚",
    "Telno": "(07)6977478",
    "Address": "高雄市路竹區國昌路1號"
}, {
    "POIID": "132208",
    "POIName": "元茗",
    "Telno": "(07)6966748",
    "Address": "高雄市路竹區中正路172號172之1號"
}, {
    "POIID": "966980",
    "POIName": "北嶺",
    "Telno": "(07)6969439",
    "Address": "高雄市路竹區北嶺里中山南路221號"
}, {
    "POIID": "163475",
    "POIName": "竹滬",
    "Telno": "(07)6983035",
    "Address": "高雄市路竹區華正路390號"
}, {
    "POIID": "150701",
    "POIName": "辰皓",
    "Telno": "(07)6965194",
    "Address": "高雄市路竹區國昌路312號"
}, {
    "POIID": "184830",
    "POIName": "高苑",
    "Telno": "(07)6960040",
    "Address": "高雄市路竹區中山路1821號"
}, {
    "POIID": "174235",
    "POIName": "華中",
    "Telno": "(07)6969279",
    "Address": "高雄市路竹區竹南里中華路124號"
}, {
    "POIID": "183549",
    "POIName": "群創八",
    "Telno": "(07)6955604",
    "Address": "高雄市路竹區路科十路11號1樓"
}, {
    "POIID": "114200",
    "POIName": "路好",
    "Telno": "(07)6964450",
    "Address": "高雄市路竹區大社路162號"
}, {
    "POIID": "131696",
    "POIName": "路科",
    "Telno": "(07)6075828",
    "Address": "高雄市路竹區社南里大社路42號42之1號46號1樓"
}, {
    "POIID": "932172",
    "POIName": "路園",
    "Telno": "(07)6952504",
    "Address": "高雄市路竹區下坑里太平路342-2號"
}, {
    "POIID": "142205",
    "POIName": "路嘉",
    "Telno": "(07)6955480",
    "Address": "高雄市路竹區後鄉路37號1樓之1.2"
}, {
    "POIID": "151922",
    "POIName": "環球",
    "Telno": "(07)6961045",
    "Address": "高雄市路竹區環球路201之27號"
}, ], [{
    "POIID": "950479",
    "POIName": "千湖",
    "Telno": "(07)6995620",
    "Address": "高雄市湖內區葉厝里保生路135號137號"
}, {
    "POIID": "165518",
    "POIName": "太湖",
    "Telno": "(07)6992060",
    "Address": "高雄市湖內區中正路二段158號1樓"
}, {
    "POIID": "967606",
    "POIName": "東敏",
    "Telno": "(07)6935784",
    "Address": "高雄市湖內區湖東里東方路103-1號103-2號"
}, {
    "POIID": "954666",
    "POIName": "湖慧",
    "Telno": "(07)6935969",
    "Address": "高雄市湖內區中山路一段540-1號"
}, {
    "POIID": "136727",
    "POIName": "新東專",
    "Telno": "(07)6935310",
    "Address": "高雄市湖內區湖東里中山路一段229號"
}, {
    "POIID": "138561",
    "POIName": "瑞蓁",
    "Telno": "(07)6991798",
    "Address": "高雄市湖內區海埔里信義路4號"
}, ], [{
    "POIID": "972309",
    "POIName": "展欣",
    "Telno": "(07)6909600",
    "Address": "高雄市茄萣區嘉安里仁愛路三段120號"
}, {
    "POIID": "127099",
    "POIName": "愛萣",
    "Telno": "(07)6909590",
    "Address": "高雄市茄萣區仁愛路二段157號159號161號"
}, {
    "POIID": "165736",
    "POIName": "新茄萣",
    "Telno": "(07)6900544",
    "Address": "高雄市茄萣區茄萣路二段403號1樓"
}, {
    "POIID": "914347",
    "POIName": "興達",
    "Telno": "(07)6908629",
    "Address": "高雄市茄萣區茄萣路一段350號"
}, {
    "POIID": "174187",
    "POIName": "興達港",
    "Telno": "(07)6987105",
    "Address": "高雄市茄萣區崎漏里民治路188號"
}, ], [{
    "POIID": "893057",
    "POIName": "永安",
    "Telno": "(07)6915041",
    "Address": "高雄市永安區永安里永安路34號"
}, {
    "POIID": "167640",
    "POIName": "維新",
    "Telno": "(07)6913260",
    "Address": "高雄市永安區維新路121號"
}, ], [{
    "POIID": "852377",
    "POIName": "彌盛",
    "Telno": "(07)6106141",
    "Address": "高雄市彌陀區中正路246號"
}, {
    "POIID": "138871",
    "POIName": "彌進",
    "Telno": "(07)6104803",
    "Address": "高雄市彌陀區彌陀里進學路33號"
}, ], [{
    "POIID": "952822",
    "POIName": "仁馨",
    "Telno": "(07)6100625",
    "Address": "高雄市梓官區梓義里中崙路287號"
}, {
    "POIID": "967503",
    "POIName": "正港",
    "Telno": "(07)6106594",
    "Address": "高雄市梓官區智蚵里中正路186號"
}, {
    "POIID": "968458",
    "POIName": "赤東",
    "Telno": "(07)6101134",
    "Address": "高雄市梓官區赤東里赤崁南路95號95-1號1F"
}, {
    "POIID": "970956",
    "POIName": "亞熱帶",
    "Telno": "(07)6106465",
    "Address": "高雄市梓官區典寶里大舍南路175號"
}, {
    "POIID": "181990",
    "POIName": "梓官",
    "Telno": "(07)6106291",
    "Address": "高雄市梓官區和平路278號1樓"
}, {
    "POIID": "970886",
    "POIName": "新舍東",
    "Telno": "(07)6104453",
    "Address": "高雄市梓官區大舍里大舍南路2號1樓"
}, {
    "POIID": "992934",
    "POIName": "嘉好",
    "Telno": "(07)6109619",
    "Address": "高雄市梓官區嘉展路370號"
}, ], [{
    "POIID": "993177",
    "POIName": "永久",
    "Telno": "(07)6622531",
    "Address": "高雄市旗山區延平一路446號1樓"
}, {
    "POIID": "880394",
    "POIName": "泰毅",
    "Telno": "(07)6615136",
    "Address": "高雄市旗山區太平里旗南一路121號"
}, {
    "POIID": "111382",
    "POIName": "圓興",
    "Telno": "(07)6692934",
    "Address": "高雄市旗山區旗甲路二段373號1樓"
}, {
    "POIID": "903901",
    "POIName": "新永光",
    "Telno": "(07)6662848",
    "Address": "高雄市旗山區南洲里旗南二路91之1號"
}, {
    "POIID": "911108",
    "POIName": "新林眾",
    "Telno": "(07)6624077",
    "Address": "高雄市旗山區延平一路78-1號"
}, {
    "POIID": "972516",
    "POIName": "新旗美",
    "Telno": "(07)6629434",
    "Address": "高雄市旗山區東平里延平二路136號"
}, {
    "POIID": "831554",
    "POIName": "旗山",
    "Telno": "(07)6615807",
    "Address": "高雄市旗山區中山路72號"
}, {
    "POIID": "966533",
    "POIName": "旗盟",
    "Telno": "(07)6629041",
    "Address": "高雄市旗山區大德里延平一路710-1號"
}, ], [{
    "POIID": "980702",
    "POIName": "月光山",
    "Telno": "(07)6811294",
    "Address": "高雄市美濃區泰安里泰安路59號"
}, {
    "POIID": "913193",
    "POIName": "正美",
    "Telno": "(07)6817197",
    "Address": "高雄市美濃區泰安里中正路一段21號23號"
}, {
    "POIID": "970299",
    "POIName": "柯達",
    "Telno": "(07)6834497",
    "Address": "高雄市美濃區中正路2段819號821號1樓"
}, {
    "POIID": "883186",
    "POIName": "美濃",
    "Telno": "(07)6818590",
    "Address": "高雄市美濃區合和里成功路6號"
}, {
    "POIID": "911636",
    "POIName": "興壇",
    "Telno": "(07)6810487",
    "Address": "高雄市美濃區中壇里忠孝路一段1號"
}, {
    "POIID": "968067",
    "POIName": "龍肚",
    "Telno": "(07)6852524",
    "Address": "高雄市美濃區龍山里中華路58號1樓"
}, ], [{
    "POIID": "123374",
    "POIName": "六龜",
    "Telno": "(07)6895325",
    "Address": "高雄市六龜區義寶里光復路98號"
}, {
    "POIID": "968757",
    "POIName": "荖濃",
    "Telno": "(07)6882559",
    "Address": "高雄市六龜區荖濃里南橫路45號1F"
}, {
    "POIID": "902229",
    "POIName": "寶來",
    "Telno": "(07)6882866",
    "Address": "高雄市六龜區寶來里中正路84號86號"
}, ], [{
    "POIID": "981015",
    "POIName": "新甲仙",
    "Telno": "(07)6754420",
    "Address": "高雄市甲仙區西安里文化路56號58號1樓"
}, ], [{
    "POIID": "944360",
    "POIName": "月美",
    "Telno": "(07)6774907",
    "Address": "高雄市杉林區月眉里清水路46號46號之1"
}, ], [{
    "POIID": "142711",
    "POIName": "好鄰居",
    "Telno": "(07)6673048",
    "Address": "高雄市內門區內門里內門99之19號"
}, {
    "POIID": "123385",
    "POIName": "實大",
    "Telno": "(07)6678178",
    "Address": "高雄市內門區內南里大學路200號"
}, {
    "POIID": "116608",
    "POIName": "觀亭",
    "Telno": "(07)6674786",
    "Address": "高雄市內門區觀亭里南屏路78號"
}, ], ], [], [[{
    "POIID": "110895",
    "POIName": "公華",
    "Telno": "(08)7516324",
    "Address": "屏東縣屏東市龍華里龍華路152號156號1樓"
}, {
    "POIID": "914211",
    "POIName": "公裕",
    "Telno": "(08)7329938",
    "Address": "屏東縣屏東市北興里廣東路818號"
}, {
    "POIID": "128999",
    "POIName": "永大",
    "Telno": "(08)7551329",
    "Address": "屏東縣屏東市大武路122號124號"
}, {
    "POIID": "125129",
    "POIName": "永發",
    "Telno": "(08)7562244",
    "Address": "屏東縣屏東市永安里復興路258號"
}, {
    "POIID": "153917",
    "POIName": "光榮",
    "Telno": "(08)7323254",
    "Address": "屏東縣屏東市信義路73之6 號73之7 號75號1樓"
}, {
    "POIID": "165378",
    "POIName": "同勝",
    "Telno": "(08)7664207",
    "Address": "屏東縣屏東市潭墘里大同北路1號1樓"
}, {
    "POIID": "963017",
    "POIName": "合家宜",
    "Telno": "(08)7387828",
    "Address": "屏東縣屏東市三山里海豐街7-12號"
}, {
    "POIID": "167662",
    "POIName": "東山河",
    "Telno": "(08)7328341",
    "Address": "屏東縣屏東市機場北路500號1樓"
}, {
    "POIID": "982476",
    "POIName": "欣欣鼎",
    "Telno": "(08)7339511",
    "Address": "屏東縣屏東市崇蘭里自由路666號1樓"
}, {
    "POIID": "149000",
    "POIName": "金樹",
    "Telno": "(08)7329631",
    "Address": "屏東縣屏東市仁愛路16號"
}, {
    "POIID": "854351",
    "POIName": "厚生",
    "Telno": "(08)7527083",
    "Address": "屏東縣屏東市和平路2號"
}, {
    "POIID": "914233",
    "POIName": "屏生",
    "Telno": "(08)7214612",
    "Address": "屏東縣屏東市瑞光里民生路33號"
}, {
    "POIID": "154703",
    "POIName": "屏東站",
    "Telno": "(08)7514200",
    "Address": "屏東縣屏東市擇仁里公勇路62號1樓"
}, {
    "POIID": "997799",
    "POIName": "屏客",
    "Telno": "(08)7330440",
    "Address": "屏東縣屏東市崇智里光復路104號"
}, {
    "POIID": "167422",
    "POIName": "屏基",
    "Telno": "(08)7365941",
    "Address": "屏東縣屏東市大連路60號"
}, {
    "POIID": "166588",
    "POIName": "屏醫",
    "Telno": "(08)7362930",
    "Address": "屏東縣屏東市自由路270號"
}, {
    "POIID": "870711",
    "POIName": "香楊",
    "Telno": "(08)7212123",
    "Address": "屏東縣屏東市瑞光里香楊巷59-12號"
}, {
    "POIID": "136255",
    "POIName": "崇武",
    "Telno": "(08)7511963",
    "Address": "屏東縣屏東市崇武里華盛街5-6號"
}, {
    "POIID": "126269",
    "POIName": "崇蘭",
    "Telno": "(08)7337084",
    "Address": "屏東縣屏東市潭漧里廣東路1588號1590號"
}, {
    "POIID": "922980",
    "POIName": "統棒",
    "Telno": "(08)7511410",
    "Address": "屏東縣屏東市永安里棒球路45號"
}, {
    "POIID": "913182",
    "POIName": "翊聖",
    "Telno": "(08)7321530",
    "Address": "屏東縣屏東市崇蘭里崇蘭路98-24號"
}, {
    "POIID": "127468",
    "POIName": "博勝",
    "Telno": "(08)7344565",
    "Address": "屏東縣屏東市博愛路263號1樓"
}, {
    "POIID": "174109",
    "POIName": "堡勤",
    "Telno": "(08)7511927",
    "Address": "屏東縣屏東市新生里復興南路一段370號1樓"
}, {
    "POIID": "921345",
    "POIName": "華敬",
    "Telno": "(08)7374094",
    "Address": "屏東縣屏東市華山里華正路9號"
}, {
    "POIID": "137627",
    "POIName": "愛買",
    "Telno": "(08)7514710",
    "Address": "屏東縣屏東市清溪里清寧街2號"
}, {
    "POIID": "159409",
    "POIName": "新自孝",
    "Telno": "(08)7332053",
    "Address": "屏東縣屏東市北勢里自由路476號壹樓"
}, {
    "POIID": "952729",
    "POIName": "新德蕙",
    "Telno": "(08)7387007",
    "Address": "屏東縣屏東市大連里興豐路193號"
}, {
    "POIID": "171030",
    "POIName": "新樂興",
    "Telno": "(08)7328134",
    "Address": "屏東縣屏東市興樂里杭州街30號1樓"
}, {
    "POIID": "136750",
    "POIName": "新豐榮",
    "Telno": "(08)7224433",
    "Address": "屏東縣屏東市豐源里廣東路86號"
}, {
    "POIID": "964009",
    "POIName": "瑞光",
    "Telno": "(08)7238479",
    "Address": "屏東縣屏東市民生東路48號"
}, {
    "POIID": "188153",
    "POIName": "瑞廣",
    "Telno": "(08)7518292",
    "Address": "屏東縣屏東市一心里廣東南路88-15號"
}, {
    "POIID": "110530",
    "POIName": "廣大",
    "Telno": "(08)7368032",
    "Address": "屏東縣屏東市仁愛里廣東路561號1樓"
}, {
    "POIID": "188603",
    "POIName": "廣正",
    "Telno": "(08)7365338",
    "Address": "屏東縣屏東市北興里中正路443號1樓"
}, {
    "POIID": "174844",
    "POIName": "廣吉",
    "Telno": "(08)7328572",
    "Address": "屏東縣屏東市廣東路991之1,991之2號1樓"
}, {
    "POIID": "162818",
    "POIName": "廣豐",
    "Telno": "(08)7380538",
    "Address": "屏東縣屏東市大連里廣東路280號280-1號"
}, {
    "POIID": "864587",
    "POIName": "潭墘",
    "Telno": "(08)7662392",
    "Address": "屏東縣屏東市勝利路224號"
}, {
    "POIID": "933245",
    "POIName": "頭前溪",
    "Telno": "(08)7515041",
    "Address": "屏東縣屏東市前進里清進巷150號"
}, {
    "POIID": "942180",
    "POIName": "薇豐",
    "Telno": "(08)7367740",
    "Address": "屏東縣屏東市大連里豐年街1號"
}, ], [{
    "POIID": "882208",
    "POIName": "山和",
    "Telno": "(08)7888874",
    "Address": "屏東縣潮州鎮三和里延平路89號"
}, {
    "POIID": "950848",
    "POIName": "友井",
    "Telno": "(08)7890274",
    "Address": "屏東縣潮州鎮三共里北門路2號"
}, {
    "POIID": "188647",
    "POIName": "合生",
    "Telno": "(08)7895261",
    "Address": "屏東縣潮州鎮中正路1號"
}, {
    "POIID": "891279",
    "POIName": "英順",
    "Telno": "(08)7803628",
    "Address": "屏東縣潮州鎮介壽路145號1樓"
}, {
    "POIID": "187703",
    "POIName": "清順",
    "Telno": "(08)7894577",
    "Address": "屏東縣潮州鎮光華里光華路153號1樓"
}, {
    "POIID": "132600",
    "POIName": "彭城",
    "Telno": "(08)7893436",
    "Address": "屏東縣潮州鎮潮州路512-3號1樓"
}, {
    "POIID": "119331",
    "POIName": "隆德",
    "Telno": "(08)7894253",
    "Address": "屏東縣潮州鎮永春里興隆路157-2號"
}, {
    "POIID": "990868",
    "POIName": "新潮",
    "Telno": "(08)7893791",
    "Address": "屏東縣潮州鎮新榮里中山路121號123號1樓"
}, {
    "POIID": "991517",
    "POIName": "潮昇",
    "Telno": "(08)7893323",
    "Address": "屏東縣潮州鎮三和里延平路189號1樓"
}, {
    "POIID": "174442",
    "POIName": "潮維",
    "Telno": "(08)7862741",
    "Address": "屏東縣潮州鎮四維路168號之4"
}, {
    "POIID": "186777",
    "POIName": "鵬權",
    "Telno": "(08)7894063",
    "Address": "屏東縣潮州鎮永春里光春路139號1樓"
}, ], [{
    "POIID": "992060",
    "POIName": "大鵬灣",
    "Telno": "(08)8324881",
    "Address": "屏東縣東港鎮船頭里船頭路26-33號1樓"
}, {
    "POIID": "137605",
    "POIName": "安泰",
    "Telno": "(08)8339623",
    "Address": "屏東縣東港鎮興東里中正路一段206號1樓"
}, {
    "POIID": "161206",
    "POIName": "東隆",
    "Telno": "(08)8353434",
    "Address": "屏東縣東港鎮頂中里延平路107號"
}, {
    "POIID": "142180",
    "POIName": "長春",
    "Telno": "(08)8325420",
    "Address": "屏東縣東港鎮興東里長春一路95號"
}, {
    "POIID": "913078",
    "POIName": "新輔英",
    "Telno": "(08)8336109",
    "Address": "屏東縣東港鎮興台里中山路3號"
}, {
    "POIID": "131412",
    "POIName": "鼎東",
    "Telno": "(08)8325165",
    "Address": "屏東縣東港鎮興東里中正路二段491號1樓"
}, {
    "POIID": "951704",
    "POIName": "億財富",
    "Telno": "(08)8336304",
    "Address": "屏東縣東港鎮新勝里光復路二段77號1樓"
}, {
    "POIID": "116789",
    "POIName": "鎮海",
    "Telno": "(08)8326154",
    "Address": "屏東縣東港鎮鎮海里鎮海路1-100號"
}, ], [{
    "POIID": "123271",
    "POIName": "日日春",
    "Telno": "(08)8897015",
    "Address": "屏東縣恆春鎮城北里中正路193號"
}, {
    "POIID": "179698",
    "POIName": "白沙灣",
    "Telno": "(08)8867528",
    "Address": "屏東縣恆春鎮大光里砂尾路38之6號1樓"
}, {
    "POIID": "910677",
    "POIName": "吉春",
    "Telno": "(08)8898264",
    "Address": "屏東縣恆春鎮恆南路1巷6之1號"
}, {
    "POIID": "119641",
    "POIName": "咚咚",
    "Telno": "(08)8862435",
    "Address": "屏東縣恆春鎮墾丁里墾丁路333號"
}, {
    "POIID": "882219",
    "POIName": "南彎",
    "Telno": "(08)8891571",
    "Address": "屏東縣恆春鎮南灣里南灣路122號"
}, {
    "POIID": "179964",
    "POIName": "屏鵝",
    "Telno": "(08)8881194",
    "Address": "屏東縣恆春鎮恆南路6-6號"
}, {
    "POIID": "900186",
    "POIName": "後壁湖",
    "Telno": "(08)8895686",
    "Address": "屏東縣恆春鎮南灣里南光路2號"
}, {
    "POIID": "166625",
    "POIName": "恆北",
    "Telno": "(08)8883342",
    "Address": "屏東縣恆春鎮網紗里省北路374-3號1樓"
}, {
    "POIID": "114130",
    "POIName": "恆春",
    "Telno": "(08)8883255",
    "Address": "屏東縣恆春鎮網紗里省北路45號47號49號1樓"
}, {
    "POIID": "110275",
    "POIName": "家的",
    "Telno": "(08)8881053",
    "Address": "屏東縣恆春鎮城南里中正路67號1樓"
}, {
    "POIID": "141257",
    "POIName": "船帆石",
    "Telno": "(08)8851490",
    "Address": "屏東縣恆春鎮船帆路720號1樓"
}, {
    "POIID": "128678",
    "POIName": "雅客",
    "Telno": "(08)8861871",
    "Address": "屏東縣恆春鎮墾丁里墾丁路166號"
}, {
    "POIID": "181266",
    "POIName": "墾丁",
    "Telno": "(08)8861565",
    "Address": "屏東縣恆春鎮墾丁里墾丁路78號1樓"
}, ], [{
    "POIID": "119685",
    "POIName": "丹榮",
    "Telno": "(08)7764624",
    "Address": "屏東縣萬丹鄉萬全村丹榮路625號"
}, {
    "POIID": "112307",
    "POIName": "社上",
    "Telno": "(08)7074750",
    "Address": "屏東縣萬丹鄉社中村社皮路三段246號248號1樓"
}, {
    "POIID": "131238",
    "POIName": "社皮",
    "Telno": "(08)7075841",
    "Address": "屏東縣萬丹鄉大昌路552號556號"
}, {
    "POIID": "187840",
    "POIName": "翔發",
    "Telno": "(08)7761245",
    "Address": "屏東縣萬丹鄉萬後村西環路637號"
}, {
    "POIID": "970598",
    "POIName": "萬惠",
    "Telno": "(08)7771790",
    "Address": "屏東縣萬丹鄉萬丹路1段21號1樓"
}, {
    "POIID": "952110",
    "POIName": "萬新",
    "Telno": "(08)7763331",
    "Address": "屏東縣萬丹鄉新鐘村萬新路342號"
}, {
    "POIID": "166005",
    "POIName": "廣得亨",
    "Telno": "(08)7074616",
    "Address": "屏東縣萬丹鄉廈北村下蚶187-10號"
}, {
    "POIID": "990503",
    "POIName": "囍洋洋",
    "Telno": "(08)7760327",
    "Address": "屏東縣萬丹鄉萬丹路一段366號368號1樓"
}, ], [{
    "POIID": "111957",
    "POIName": "長治",
    "Telno": "(08)7377784",
    "Address": "屏東縣長治鄉新潭村長興路13號1樓"
}, {
    "POIID": "174811",
    "POIName": "崙上",
    "Telno": "(08)7629817",
    "Address": "屏東縣長治鄉崙上村中興路372-2號"
}, {
    "POIID": "126395",
    "POIName": "新潭",
    "Telno": "(08)7368395",
    "Address": "屏東縣長治鄉新潭村長興路326號1樓"
}, {
    "POIID": "189558",
    "POIName": "瑞屏",
    "Telno": "(08)7216637",
    "Address": "屏東縣長治鄉香楊村瑞光路一段749號1樓"
}, {
    "POIID": "179610",
    "POIName": "繁華",
    "Telno": "(08)7625253",
    "Address": "屏東縣長治鄉繁華村水源路71.71-1號"
}, ], [{
    "POIID": "135676",
    "POIName": "信億",
    "Telno": "(08)7214406",
    "Address": "屏東縣麟洛鄉麟蹄村中山路166號166-1號166-2號1樓"
}, {
    "POIID": "965552",
    "POIName": "麟洛",
    "Telno": "(08)7216745",
    "Address": "屏東縣麟洛鄉麟趾村中山路519-5號"
}, ], [{
    "POIID": "122810",
    "POIName": "三多利",
    "Telno": "(08)7750032",
    "Address": "屏東縣九如鄉大坵村九如路三段56號1樓"
}, {
    "POIID": "183077",
    "POIName": "多多利",
    "Telno": "(08)7758429",
    "Address": "屏東縣九如鄉九如路三段85號"
}, {
    "POIID": "180311",
    "POIName": "守福",
    "Telno": "(08)7755192",
    "Address": "屏東縣九如鄉九如路3段450號"
}, {
    "POIID": "971351",
    "POIName": "東寧",
    "Telno": "(08)7396236",
    "Address": "屏東縣九如鄉東寧村東寧路225號1樓"
}, ], [{
    "POIID": "942777",
    "POIName": "里中",
    "Telno": "(08)7734453",
    "Address": "屏東縣里港鄉三部村三和路119-1號"
}, {
    "POIID": "188832",
    "POIName": "里宬",
    "Telno": "(08)7750324",
    "Address": "屏東縣里港鄉鐵店村鐵店路17-1號"
}, {
    "POIID": "880349",
    "POIName": "里港",
    "Telno": "(08)7759128",
    "Address": "屏東縣里港鄉永春村中山路46號"
}, {
    "POIID": "121183",
    "POIName": "里農",
    "Telno": "(08)7754226",
    "Address": "屏東縣里港鄉大平村中山路3號"
}, ], [{
    "POIID": "130291",
    "POIName": "永盛",
    "Telno": "(08)7931503",
    "Address": "屏東縣鹽埔鄉鹽中村勝利路81之3號"
}, {
    "POIID": "188821",
    "POIName": "鹽埔",
    "Telno": "(08)7935794",
    "Address": "屏東縣鹽埔鄉維新路134-3號136號"
}, ], [{
    "POIID": "940807",
    "POIName": "招英",
    "Telno": "(08)7964288",
    "Address": "屏東縣高樹鄉南興路74之3號"
}, {
    "POIID": "934684",
    "POIName": "高樹",
    "Telno": "(08)7963709",
    "Address": "屏東縣高樹鄉興中路193號"
}, {
    "POIID": "923857",
    "POIName": "鑫泰山",
    "Telno": "(08)7958900",
    "Address": "屏東縣高樹鄉泰山村產業路73號"
}, ], [{
    "POIID": "120973",
    "POIName": "欣佳和",
    "Telno": "(08)7836509",
    "Address": "屏東縣萬巒鄉佳和村佳興路38之9號"
}, {
    "POIID": "965655",
    "POIName": "青允",
    "Telno": "(08)7851556",
    "Address": "屏東縣萬巒鄉新置村新隆路75號"
}, {
    "POIID": "166108",
    "POIName": "萬金",
    "Telno": "(08)7836328",
    "Address": "屏東縣萬巒鄉萬金村萬興路18號1樓"
}, {
    "POIID": "142386",
    "POIName": "萬巒",
    "Telno": "(08)7815818",
    "Address": "屏東縣萬巒鄉萬和村中正路52號1樓"
}, ], [{
    "POIID": "121138",
    "POIName": "內埔",
    "Telno": "(08)7782606",
    "Address": "屏東縣內埔鄉內田村光明路224號226號1樓"
}, {
    "POIID": "970369",
    "POIName": "水門",
    "Telno": "(08)7995113",
    "Address": "屏東縣內埔鄉水門村忠孝路289號"
}, {
    "POIID": "188234",
    "POIName": "念楨",
    "Telno": "(08)7708081",
    "Address": "屏東縣內埔鄉黎明村黎東路221號1樓"
}, {
    "POIID": "982052",
    "POIName": "屏科大",
    "Telno": "(08)7705060",
    "Address": "屏東縣內埔鄉中林村中林路1號3號1樓"
}, {
    "POIID": "975825",
    "POIName": "昭勝",
    "Telno": "(08)7706398",
    "Address": "屏東縣內埔鄉龍潭村昭勝路216號218號220號"
}, {
    "POIID": "904214",
    "POIName": "埔豐",
    "Telno": "(08)7789567",
    "Address": "屏東縣內埔鄉豐田村中正路291號"
}, {
    "POIID": "167961",
    "POIName": "涼山",
    "Telno": "(08)7992029",
    "Address": "屏東縣內埔鄉新展路22號1樓"
}, {
    "POIID": "861430",
    "POIName": "順越",
    "Telno": "(08)7789176",
    "Address": "屏東縣內埔鄉南寧路19號"
}, {
    "POIID": "181129",
    "POIName": "新中勝",
    "Telno": "(08)7707202",
    "Address": "屏東縣內埔鄉龍潭村昭勝路13.15號1樓"
}, {
    "POIID": "188360",
    "POIName": "新東勢",
    "Telno": "(08)7781983",
    "Address": "屏東縣內埔鄉東勢村大同路三段2號6號1樓"
}, {
    "POIID": "997618",
    "POIName": "壽比",
    "Telno": "(08)7794133",
    "Address": "屏東縣內埔鄉老埤村壽比路348號"
}, {
    "POIID": "183952",
    "POIName": "學廣",
    "Telno": "(08)7788579",
    "Address": "屏東縣內埔鄉內埔村廣濟路2-6號"
}, {
    "POIID": "930659",
    "POIName": "學興",
    "Telno": "(08)7798902",
    "Address": "屏東縣內埔鄉和興村學人路592號"
}, ], [{
    "POIID": "942869",
    "POIName": "竹田",
    "Telno": "(08)7711933",
    "Address": "屏東縣竹田鄉中正路84號86號"
}, ], [{
    "POIID": "151807",
    "POIName": "新埤",
    "Telno": "(08)7973525",
    "Address": "屏東縣新埤鄉新埤村中正路72號"
}, ], [{
    "POIID": "120788",
    "POIName": "人和",
    "Telno": "(08)8717610",
    "Address": "屏東縣枋寮鄉人和村中山路二段232號1樓"
}, {
    "POIID": "971524",
    "POIName": "新枋寮",
    "Telno": "(08)8782887",
    "Address": "屏東縣枋寮鄉枋寮村中興路7號1樓"
}, {
    "POIID": "110253",
    "POIName": "僑德",
    "Telno": "(08)8782891",
    "Address": "屏東縣枋寮鄉安樂村中山路143號145號147號1樓"
}, {
    "POIID": "174291",
    "POIName": "維軒",
    "Telno": "(08)8715022",
    "Address": "屏東縣枋寮鄉人和村中山路2段143號"
}, ], [{
    "POIID": "972697",
    "POIName": "五房",
    "Telno": "(08)8692183",
    "Address": "屏東縣新園鄉五房村五房路721號1樓"
}, {
    "POIID": "990112",
    "POIName": "欣仙吉",
    "Telno": "(08)8686184",
    "Address": "屏東縣新園鄉仙吉路128號130號132號1樓"
}, {
    "POIID": "860057",
    "POIName": "新園",
    "Telno": "(08)8336288",
    "Address": "屏東縣新園鄉興龍村14鄰南興路319號"
}, {
    "POIID": "155452",
    "POIName": "鹽洲",
    "Telno": "(08)8321705",
    "Address": "屏東縣新園鄉共和村光復路1號"
}, ], [{
    "POIID": "928760",
    "POIName": "林興",
    "Telno": "(08)8751644",
    "Address": "屏東縣林邊鄉中山路312號"
}, {
    "POIID": "170288",
    "POIName": "林邊",
    "Telno": "(08)8758079",
    "Address": "屏東縣林邊鄉仁和里中山路275號277號"
}, ], [{
    "POIID": "903794",
    "POIName": "南州",
    "Telno": "(08)8647408",
    "Address": "屏東縣南州鄉溪南村三民路171號"
}, {
    "POIID": "992026",
    "POIName": "壽元",
    "Telno": "(08)8645237",
    "Address": "屏東縣南州鄉壽元村勝利路5-15號1樓"
}, ], [{
    "POIID": "920401",
    "POIName": "玉光",
    "Telno": "(08)8670860",
    "Address": "屏東縣佳冬鄉玉光村中山路69號"
}, {
    "POIID": "188256",
    "POIName": "佳冬",
    "Telno": "(08)8664904",
    "Address": "屏東縣佳冬鄉賴家村佳和路1號"
}, {
    "POIID": "181978",
    "POIName": "欣昌隆",
    "Telno": "(08)8667951",
    "Address": "屏東縣佳冬鄉昌隆村大豐路680號"
}, ], [{
    "POIID": "892113",
    "POIName": "小琉球",
    "Telno": "(08)8614309",
    "Address": "屏東縣琉球鄉本福村民生路61號"
}, {
    "POIID": "122382",
    "POIName": "白燈塔",
    "Telno": "(08)8612496",
    "Address": "屏東縣琉球鄉三民區大福村中正路303之2號1樓"
}, {
    "POIID": "182786",
    "POIName": "花瓶岩",
    "Telno": "(08)8612932",
    "Address": "屏東縣琉球鄉本福村中山路51-5號1樓"
}, ], [{
    "POIID": "934466",
    "POIName": "車城",
    "Telno": "(08)8824246",
    "Address": "屏東縣車城鄉福安村中山路76號"
}, {
    "POIID": "992277",
    "POIName": "保鑫",
    "Telno": "(08)8825135",
    "Address": "屏東縣車城鄉新街村保新路71號"
}, {
    "POIID": "950859",
    "POIName": "昱昇",
    "Telno": "(08)8822455",
    "Address": "屏東縣車城鄉溫泉村溫泉路125號"
}, ], [{
    "POIID": "112787",
    "POIName": "滿州",
    "Telno": "(08)8802431",
    "Address": "屏東縣滿州鄉滿州村中山路56號1樓"
}, ], [{
    "POIID": "188843",
    "POIName": "加祿堂",
    "Telno": "(08)8720963",
    "Address": "屏東縣枋山鄉加祿村加祿路155號"
}, {
    "POIID": "966614",
    "POIName": "南北棧",
    "Telno": "(08)8761583",
    "Address": "屏東縣枋山鄉枋山村中山路三段38號"
}, {
    "POIID": "167743",
    "POIName": "海豚灣",
    "Telno": "(08)8761758",
    "Address": "屏東縣枋山鄉坊山村中山路三段61-3號1樓"
}, {
    "POIID": "115915",
    "POIName": "新楓港",
    "Telno": "(08)8771484",
    "Address": "屏東縣枋山鄉楓港村舊庄路51之2號3號4號"
}, {
    "POIID": "863643",
    "POIName": "楓港",
    "Telno": "(08)8770354",
    "Address": "屏東縣枋山鄉楓港村10鄰舊庄路21號"
}, ], [{
    "POIID": "131331",
    "POIName": "頭目",
    "Telno": "(08)7993903",
    "Address": "屏東縣三地門鄉三地村中正路二段3號1樓"
}, ], [{
    "POIID": "883278",
    "POIName": "家家福",
    "Telno": "(08)8792220",
    "Address": "屏東縣春日鄉七佳村自強一路14號"
}, ], ], [[{
    "POIID": "870227",
    "POIName": "心蓮",
    "Telno": "(03)9364290",
    "Address": "宜蘭縣宜蘭市泰山路212號"
}, {
    "POIID": "113399",
    "POIName": "伍富",
    "Telno": "(03)9365457",
    "Address": "宜蘭縣宜蘭市女中路3段26-6號26-7號26-8號"
}, {
    "POIID": "112798",
    "POIName": "同慶",
    "Telno": "(03)9320912",
    "Address": "宜蘭縣宜蘭市中山路3段203號205號207號1樓"
}, {
    "POIID": "130730",
    "POIName": "壯五",
    "Telno": "(03)9373467",
    "Address": "宜蘭縣宜蘭市東港路3號1樓"
}, {
    "POIID": "135159",
    "POIName": "佳旺",
    "Telno": "(03)9312425",
    "Address": "宜蘭縣宜蘭市舊城東路47號"
}, {
    "POIID": "185062",
    "POIName": "宜莊",
    "Telno": "(03)9333660",
    "Address": "宜蘭縣宜蘭市光復路26號"
}, {
    "POIID": "186180",
    "POIName": "宜蘭站",
    "Telno": "(03)9333274",
    "Address": "宜蘭縣宜蘭市光復路1號"
}, {
    "POIID": "997825",
    "POIName": "承莊",
    "Telno": "(03)9288135",
    "Address": "宜蘭縣宜蘭市中山路五段92號"
}, {
    "POIID": "189628",
    "POIName": "省宜",
    "Telno": "(03)9311406",
    "Address": "宜蘭縣宜蘭市新民路159號161號1樓"
}, {
    "POIID": "141523",
    "POIName": "員泰",
    "Telno": "(03)9314092",
    "Address": "宜蘭縣宜蘭市泰山路33之3號33之4號1樓"
}, {
    "POIID": "139243",
    "POIName": "校舍",
    "Telno": "(03)9372896",
    "Address": "宜蘭縣宜蘭市校舍路25號"
}, {
    "POIID": "112341",
    "POIName": "健神",
    "Telno": "(03)9310270",
    "Address": "宜蘭縣宜蘭市神農路2段8號10號"
}, {
    "POIID": "923787",
    "POIName": "圓鴻",
    "Telno": "(03)9373214",
    "Address": "宜蘭縣宜蘭市慈安路40號"
}, {
    "POIID": "132699",
    "POIName": "新月",
    "Telno": "(03)9327903",
    "Address": "宜蘭縣宜蘭市民權路二段38巷6號"
}, {
    "POIID": "154987",
    "POIName": "新復興",
    "Telno": "(03)9315865",
    "Address": "宜蘭縣宜蘭市復興路二段49號1樓"
}, {
    "POIID": "165932",
    "POIName": "農專",
    "Telno": "(03)9355846",
    "Address": "宜蘭縣宜蘭市神農路1段96號98號"
}, {
    "POIID": "132895",
    "POIName": "滿冠",
    "Telno": "(03)9330864",
    "Address": "宜蘭縣宜蘭市新興路68號1樓"
}, {
    "POIID": "152095",
    "POIName": "馥華",
    "Telno": "(03)9373449",
    "Address": "宜蘭縣宜蘭市東港路30-22號"
}, {
    "POIID": "122120",
    "POIName": "騰豪",
    "Telno": "(03)9288578",
    "Address": "宜蘭縣宜蘭市大坡路2段215號217號"
}, {
    "POIID": "934514",
    "POIName": "蘭陽",
    "Telno": "(03)9366772",
    "Address": "宜蘭縣宜蘭市中山路2段101號"
}, ], [{
    "POIID": "188186",
    "POIName": "利陶",
    "Telno": "(03)9572730",
    "Address": "宜蘭縣羅東鎮興東南路188號"
}, {
    "POIID": "977418",
    "POIName": "宜泰",
    "Telno": "(03)9572315",
    "Address": "宜蘭縣羅東鎮公園路100號"
}, {
    "POIID": "155658",
    "POIName": "欣銓",
    "Telno": "(03)9543627",
    "Address": "宜蘭縣羅東鎮興東路263之1號1樓"
}, {
    "POIID": "165909",
    "POIName": "金站",
    "Telno": "(03)9531183",
    "Address": "宜蘭縣羅東鎮公正路31號1樓"
}, {
    "POIID": "970233",
    "POIName": "宣宏",
    "Telno": "(03)9558424",
    "Address": "宜蘭縣羅東鎮復興路2段257號"
}, {
    "POIID": "111201",
    "POIName": "徠一",
    "Telno": "(03)9615630",
    "Address": "宜蘭縣羅東鎮培英路98號100號"
}, {
    "POIID": "128106",
    "POIName": "集翔",
    "Telno": "(03)9552407",
    "Address": "宜蘭縣羅東鎮集翔里中正路147號"
}, {
    "POIID": "976242",
    "POIName": "新聖母",
    "Telno": "(03)9542849",
    "Address": "宜蘭縣羅東鎮中正南路160號(聖母醫院內)"
}, {
    "POIID": "979311",
    "POIName": "新羅東站",
    "Telno": "(03)9531157",
    "Address": "宜蘭縣羅東鎮公正路2號"
}, {
    "POIID": "993513",
    "POIName": "聖博",
    "Telno": "(03)9558229",
    "Address": "宜蘭縣羅東鎮南昌街53巷6-3號"
}, {
    "POIID": "993476",
    "POIName": "潤昌",
    "Telno": "(03)9617046",
    "Address": "宜蘭縣羅東鎮中山路四段197號199號"
}, {
    "POIID": "132529",
    "POIName": "潤霖",
    "Telno": "(03)9542776",
    "Address": "宜蘭縣羅東鎮公正路136號1樓"
}, {
    "POIID": "164984",
    "POIName": "羅東",
    "Telno": "(03)9574974",
    "Address": "宜蘭縣羅東鎮公正路197號"
}, {
    "POIID": "120456",
    "POIName": "羅高",
    "Telno": "(03)9518247",
    "Address": "宜蘭縣羅東鎮公正路357號359號"
}, {
    "POIID": "962335",
    "POIName": "權中",
    "Telno": "(03)9565552",
    "Address": "宜蘭縣羅東鎮民權路177號"
}, ], [{
    "POIID": "164076",
    "POIName": "豆腐岬",
    "Telno": "(03)9952161",
    "Address": "宜蘭縣蘇澳鎮南寧路41號42號"
}, {
    "POIID": "882655",
    "POIName": "南方澳",
    "Telno": "(03)9951870",
    "Address": "宜蘭縣蘇澳鎮江夏路27號"
}, {
    "POIID": "903037",
    "POIName": "南澳",
    "Telno": "(03)9982339",
    "Address": "宜蘭縣蘇澳鎮南強里蘇花路二段328號"
}, {
    "POIID": "187998",
    "POIName": "振盟",
    "Telno": "(03)9907994",
    "Address": "宜蘭縣蘇澳鎮蘇濱路2段302號"
}, {
    "POIID": "187932",
    "POIName": "馬賽",
    "Telno": "(03)9906751",
    "Address": "宜蘭縣蘇澳鎮永榮里馬賽路151號"
}, {
    "POIID": "130316",
    "POIName": "新馬",
    "Telno": "(03)9907083",
    "Address": "宜蘭縣蘇澳鎮海山西路489號1樓"
}, {
    "POIID": "183815",
    "POIName": "蜡藝館",
    "Telno": "(039)909947",
    "Address": "宜蘭縣蘇澳鎮海山西路500號"
}, {
    "POIID": "997537",
    "POIName": "蘇中",
    "Telno": "(03)9969750",
    "Address": "宜蘭縣蘇澳鎮中山路一段263號"
}, {
    "POIID": "916262",
    "POIName": "蘇澳",
    "Telno": "(03)9966847",
    "Address": "宜蘭縣蘇澳鎮蘇北里中山路一段74號"
}, {
    "POIID": "921183",
    "POIName": "蘇澳港",
    "Telno": "(03)9955466",
    "Address": "宜蘭縣蘇澳鎮蘇東中路4號"
}, {
    "POIID": "141567",
    "POIName": "蘇濱",
    "Telno": "(03)9908696",
    "Address": "宜蘭縣蘇澳鎮蘇濱路3段1之1號"
}, ], [{
    "POIID": "122005",
    "POIName": "家燕",
    "Telno": "(03)9776189",
    "Address": "宜蘭縣頭城鎮青雲路2段230號1樓"
}, {
    "POIID": "123396",
    "POIName": "新梗枋",
    "Telno": "(03)9771121",
    "Address": "宜蘭縣頭城鎮濱海路三段323號"
}, {
    "POIID": "138365",
    "POIName": "詮祥",
    "Telno": "(03)9778548",
    "Address": "宜蘭縣頭城鎮中山區青雲路三段238號240號"
}, {
    "POIID": "123008",
    "POIName": "噶瑪蘭",
    "Telno": "(03)9782335",
    "Address": "宜蘭縣頭城鎮復興路58號"
}, {
    "POIID": "136738",
    "POIName": "頭城",
    "Telno": "(03)9782342",
    "Address": "宜蘭縣頭城鎮青雲路三段73號"
}, {
    "POIID": "154390",
    "POIName": "纘祥",
    "Telno": "(03)9774578",
    "Address": "宜蘭縣頭城鎮民鋒路18號20號"
}, ], [{
    "POIID": "965909",
    "POIName": "永聖",
    "Telno": "(03)9876105",
    "Address": "宜蘭縣礁溪鄉大忠村大忠路120-122號"
}, {
    "POIID": "932116",
    "POIName": "永裕",
    "Telno": "(03)9872422",
    "Address": "宜蘭縣礁溪鄉中山路二段204號"
}, {
    "POIID": "183608",
    "POIName": "金桔",
    "Telno": "(039)873623",
    "Address": "宜蘭縣礁溪鄉玉龍路二段417號"
}, {
    "POIID": "167824",
    "POIName": "泉湧",
    "Telno": "(03)9876652",
    "Address": "宜蘭縣礁溪鄉玉石村溫泉路15鄰85號1樓"
}, {
    "POIID": "137753",
    "POIName": "泉發",
    "Telno": "(03)9875091",
    "Address": "宜蘭縣礁溪鄉礁溪路3段302號306號"
}, {
    "POIID": "981392",
    "POIName": "湯圍",
    "Telno": "(03)9883627",
    "Address": "宜蘭縣礁溪鄉礁溪路5段51號"
}, {
    "POIID": "112938",
    "POIName": "圓達",
    "Telno": "(03)9874660",
    "Address": "宜蘭縣礁溪鄉礁溪路7段65號69號"
}, {
    "POIID": "893895",
    "POIName": "瑞發",
    "Telno": "(03)9874162",
    "Address": "宜蘭縣礁溪鄉德陽路65號"
}, {
    "POIID": "930280",
    "POIName": "嘉融",
    "Telno": "(03)9289535",
    "Address": "宜蘭縣礁溪鄉吳沙村礁溪路一段142號"
}, {
    "POIID": "165437",
    "POIName": "礁溪",
    "Telno": "(03)9885542",
    "Address": "宜蘭縣礁溪鄉礁溪路4段85號87號"
}, {
    "POIID": "128117",
    "POIName": "駿隆",
    "Telno": "(03)9887913",
    "Address": "宜蘭縣礁溪鄉中山路一段175號"
}, ], [{
    "POIID": "903521",
    "POIName": "大福",
    "Telno": "(03)9304823",
    "Address": "宜蘭縣壯圍鄉大福村壯濱路六段222號"
}, {
    "POIID": "180218",
    "POIName": "全美",
    "Telno": "(03)9309733",
    "Address": "宜蘭縣壯圍鄉美城村大福路三段1號5號"
}, {
    "POIID": "183505",
    "POIName": "壯志",
    "Telno": "(03)9386429",
    "Address": "宜蘭縣壯圍鄉中央路二段311號"
}, {
    "POIID": "951564",
    "POIName": "壯圍",
    "Telno": "(03)9374524",
    "Address": "宜蘭縣壯圍鄉壯五路143之3號"
}, ], [{
    "POIID": "923008",
    "POIName": "同樂",
    "Telno": "(03)9232863",
    "Address": "宜蘭縣員山鄉同新路286號"
}, {
    "POIID": "890999",
    "POIName": "佳怡",
    "Telno": "(03)9223896",
    "Address": "宜蘭縣員山鄉員山路一段184號186號"
}, {
    "POIID": "181923",
    "POIName": "深溝",
    "Telno": "(03)9232491",
    "Address": "宜蘭縣員山鄉惠民路207號"
}, {
    "POIID": "921297",
    "POIName": "萬鴻",
    "Telno": "(03)9232867",
    "Address": "宜蘭縣員山鄉員山路一段303號305號"
}, ], [{
    "POIID": "931928",
    "POIName": "冬山",
    "Telno": "(03)9595237",
    "Address": "宜蘭縣冬山鄉冬山路一段984號"
}, {
    "POIID": "180296",
    "POIName": "冬森",
    "Telno": "(03)9595683",
    "Address": "宜蘭縣冬山鄉冬山路100之1號"
}, {
    "POIID": "943921",
    "POIName": "詠淇",
    "Telno": "(03)9596549",
    "Address": "宜蘭縣冬山鄉香和村冬山路1段725號"
}, {
    "POIID": "882644",
    "POIName": "義成",
    "Telno": "(03)9580078",
    "Address": "宜蘭縣冬山鄉順安村義成路三段2號"
}, {
    "POIID": "881179",
    "POIName": "廣達",
    "Telno": "(03)9613085",
    "Address": "宜蘭縣冬山鄉廣興村廣興路196號198號"
}, {
    "POIID": "991115",
    "POIName": "羅義",
    "Telno": "(03)9680401",
    "Address": "宜蘭縣冬山鄉義成路三段361號363號1樓"
}, ], [{
    "POIID": "139209",
    "POIName": "五結",
    "Telno": "(03)9605471",
    "Address": "宜蘭縣五結鄉五結路二段393號"
}, {
    "POIID": "967167",
    "POIName": "布蘭其",
    "Telno": "(03)9501494",
    "Address": "宜蘭縣五結鄉協和村親河路1段140號"
}, {
    "POIID": "132817",
    "POIName": "孝威",
    "Telno": "(039)604427",
    "Address": "宜蘭縣五結鄉傳藝路1段369號1樓"
}, {
    "POIID": "174383",
    "POIName": "佳美",
    "Telno": "(03)9655743",
    "Address": "宜蘭縣五結鄉中正路二段127號1樓"
}, {
    "POIID": "913300",
    "POIName": "杰昇",
    "Telno": "(03)9654642",
    "Address": "宜蘭縣五結鄉鎮安村西河路4-6號"
}, {
    "POIID": "165345",
    "POIName": "昱成",
    "Telno": "(03)9549291",
    "Address": "宜蘭縣五結鄉中正路一段174號176號"
}, {
    "POIID": "952338",
    "POIName": "親河",
    "Telno": "(03)9502774",
    "Address": "宜蘭縣五結鄉親河路2段289號"
}, {
    "POIID": "131320",
    "POIName": "羅結",
    "Telno": "(03)9603045",
    "Address": "宜蘭縣五結鄉五結路3段493號"
}, ], [{
    "POIID": "965596",
    "POIName": "三星",
    "Telno": "(03)9894704",
    "Address": "宜蘭縣三星鄉義德村三星路5段228號"
}, {
    "POIID": "942238",
    "POIName": "立昇",
    "Telno": "(03)9544118",
    "Address": "宜蘭縣三星鄉上將路二段355號"
}, {
    "POIID": "166234",
    "POIName": "樸隱",
    "Telno": "(03)9899824",
    "Address": "宜蘭縣三星鄉大隱村三星路二段25鄰13號"
}, {
    "POIID": "922360",
    "POIName": "麗騰",
    "Telno": "(03)9897137",
    "Address": "宜蘭縣三星鄉大隱村大埔路112之7號"
}, ], [{
    "POIID": "154541",
    "POIName": "金玉",
    "Telno": "(03)9981183",
    "Address": "宜蘭縣南澳鄉蘇花路二段165號1樓"
}, ], ], [[{
    "POIID": "122027",
    "POIName": "上美崙",
    "Telno": "(03)8246479",
    "Address": "花蓮縣花蓮市府前路298號298之1號1樓"
}, {
    "POIID": "121057",
    "POIName": "吉野",
    "Telno": "(03)8314830",
    "Address": "花蓮縣花蓮市中正路65號1樓2樓"
}, {
    "POIID": "921529",
    "POIName": "名品",
    "Telno": "(03)8570070",
    "Address": "花蓮縣花蓮市國富里莊敬路72號"
}, {
    "POIID": "966968",
    "POIName": "好家園",
    "Telno": "(03)8323748",
    "Address": "花蓮縣花蓮市國聯一路2號2-1號"
}, {
    "POIID": "959177",
    "POIName": "如意",
    "Telno": "(03)8346465",
    "Address": "花蓮縣花蓮市中美路37號"
}, {
    "POIID": "932529",
    "POIName": "尚美",
    "Telno": "(03)8236847",
    "Address": "花蓮縣花蓮市中興路71號"
}, {
    "POIID": "111980",
    "POIName": "花農",
    "Telno": "(03)8359660",
    "Address": "花蓮縣花蓮市建國路236號238號1樓"
}, {
    "POIID": "147288",
    "POIName": "花道",
    "Telno": "(03)8325049",
    "Address": "花蓮縣花蓮市中正路563號1樓"
}, {
    "POIID": "192554",
    "POIName": "花蓮站",
    "Telno": "(03)8311161",
    "Address": "花蓮縣花蓮市國聯一路100號 1樓"
}, {
    "POIID": "943725",
    "POIName": "長勝",
    "Telno": "(03)8239707",
    "Address": "花蓮縣花蓮市中美路83-1號83-2號"
}, {
    "POIID": "120995",
    "POIName": "思瑀",
    "Telno": "(03)8465568",
    "Address": "花蓮縣花蓮市建國路2段862號及866號1樓"
}, {
    "POIID": "120272",
    "POIName": "星潭",
    "Telno": "(03)8246834",
    "Address": "花蓮縣花蓮市華西121-10及121-11號"
}, {
    "POIID": "183457",
    "POIName": "國盛",
    "Telno": "(03)8310563",
    "Address": "花蓮縣花蓮市國民九街56號58號1樓"
}, {
    "POIID": "923134",
    "POIName": "統軒",
    "Telno": "(03)8347047",
    "Address": "花蓮縣花蓮市公園路7-1號"
}, {
    "POIID": "184829",
    "POIName": "富泰",
    "Telno": "(03)8325217",
    "Address": "花蓮縣花蓮市國聯一路55號"
}, {
    "POIID": "166522",
    "POIName": "富集",
    "Telno": "(03)8465458",
    "Address": "花蓮縣花蓮市國富里富國路32號1樓"
}, {
    "POIID": "123329",
    "POIName": "華原",
    "Telno": "(03)8349209",
    "Address": "花蓮縣花蓮市中華路426號"
}, {
    "POIID": "950723",
    "POIName": "華廈",
    "Telno": "(03)8237517",
    "Address": "花蓮縣花蓮市民享里府前路638號640號"
}, {
    "POIID": "891420",
    "POIName": "慈濟",
    "Telno": "(03)8461461",
    "Address": "花蓮縣花蓮市中央路3段808號810號"
}, {
    "POIID": "174350",
    "POIName": "愛民",
    "Telno": "(03)8310747",
    "Address": "花蓮縣花蓮市民國路22號"
}, {
    "POIID": "910965",
    "POIName": "新蓮信",
    "Telno": "(03)8233247",
    "Address": "花蓮縣花蓮市中美路186號"
}, {
    "POIID": "966739",
    "POIName": "德安一",
    "Telno": "(03)8324516",
    "Address": "花蓮縣花蓮市德安一街307號"
}, {
    "POIID": "987747",
    "POIName": "蓮成",
    "Telno": "(03)8358316",
    "Address": "花蓮縣花蓮市中華路283之1號"
}, {
    "POIID": "151014",
    "POIName": "蓮昌",
    "Telno": "(03)8465730",
    "Address": "花蓮縣花蓮市建國路2段298號"
}, {
    "POIID": "871220",
    "POIName": "蓮冠",
    "Telno": "(03)8333681",
    "Address": "花蓮縣花蓮市中山路426號"
}, {
    "POIID": "872382",
    "POIName": "蓮美",
    "Telno": "(03)8227819",
    "Address": "花蓮縣花蓮市中美路209號"
}, {
    "POIID": "991827",
    "POIName": "蓮華",
    "Telno": "(03)8339625",
    "Address": "花蓮縣花蓮市民生里中山路183-185號1樓"
}, {
    "POIID": "131836",
    "POIName": "蓮圓",
    "Telno": "(03)8462539",
    "Address": "花蓮縣花蓮市中山路891號893號"
}, {
    "POIID": "113665",
    "POIName": "蓮慈",
    "Telno": "(03)8465649",
    "Address": "花蓮縣花蓮市中山路1段7號9號1樓"
}, {
    "POIID": "113056",
    "POIName": "蓮慶",
    "Telno": "(03)8311077",
    "Address": "花蓮縣花蓮市林森路160號1樓"
}, {
    "POIID": "872740",
    "POIName": "蓮讚",
    "Telno": "(03)8329952",
    "Address": "花蓮縣花蓮市國聯里國聯三路16號18號"
}, {
    "POIID": "122935",
    "POIName": "豐川",
    "Telno": "(03)8462708",
    "Address": "花蓮縣花蓮市富強路214號216號"
}, {
    "POIID": "981738",
    "POIName": "鑫花蓮",
    "Telno": "(03)8342960",
    "Address": "花蓮縣花蓮市中正路383號385號"
}, {
    "POIID": "980137",
    "POIName": "鑫盈佳",
    "Telno": "(03)8357526",
    "Address": "花蓮縣花蓮市林森路258號1樓"
}, {
    "POIID": "174899",
    "POIName": "讚福",
    "Telno": "(03)8350342",
    "Address": "花蓮縣花蓮市國聯五路55號"
}, {
    "POIID": "920342",
    "POIName": "讚蓮",
    "Telno": "(03)8460857",
    "Address": "花蓮縣花蓮市富吉路2號"
}, ], [{
    "POIID": "110312",
    "POIName": "林田山",
    "Telno": "(03)8752227",
    "Address": "花蓮縣鳳林鎮長橋里長橋路108號1樓"
}, {
    "POIID": "881951",
    "POIName": "鳳林",
    "Telno": "(03)8760470",
    "Address": "花蓮縣鳳林鎮鳳禮里中正路二段143號145號"
}, {
    "POIID": "155511",
    "POIName": "鳳悅",
    "Telno": "(03)8761820",
    "Address": "花蓮縣鳳林鎮信義路216號1樓"
}, ], [{
    "POIID": "153375",
    "POIName": "玉里",
    "Telno": "(03)8880248",
    "Address": "花蓮縣玉里鎮中山路2段90號1樓"
}, {
    "POIID": "116354",
    "POIName": "玉明",
    "Telno": "(03)8887466",
    "Address": "花蓮縣玉里鎮泰昌里中山路2段135號"
}, {
    "POIID": "181288",
    "POIName": "玉富",
    "Telno": "(03)8980240",
    "Address": "花蓮縣玉里鎮大同路214號及光復路184號"
}, {
    "POIID": "174305",
    "POIName": "樂合",
    "Telno": "(03)8980204",
    "Address": "花蓮縣玉里鎮樂合里新民路13-1號"
}, {
    "POIID": "902469",
    "POIName": "璞石閣",
    "Telno": "(03)8980399",
    "Address": "花蓮縣玉里鎮中山路一段96號"
}, {
    "POIID": "116413",
    "POIName": "興玉",
    "Telno": "(03)8980392",
    "Address": "花蓮縣玉里鎮興國路2段23號"
}, ], [{
    "POIID": "151759",
    "POIName": "北埔",
    "Telno": "(03)8269176",
    "Address": "花蓮縣新城鄉北埔路282號"
}, {
    "POIID": "954437",
    "POIName": "祥祐",
    "Telno": "(03)8610548",
    "Address": "花蓮縣新城鄉順安村北三棧119之6號"
}, {
    "POIID": "151287",
    "POIName": "新廉瀚",
    "Telno": "(03)8612913",
    "Address": "花蓮縣新城鄉新興路28號30號1樓"
}, {
    "POIID": "138941",
    "POIName": "精舍",
    "Telno": "(03)8262915",
    "Address": "花蓮縣新城鄉康樂村康樂路286號288號"
}, {
    "POIID": "138745",
    "POIName": "蓮莊",
    "Telno": "(03)8262950",
    "Address": "花蓮縣新城鄉北埔村光復路462號"
}, {
    "POIID": "152040",
    "POIName": "蓮發",
    "Telno": "(03)8267790",
    "Address": "花蓮縣新城鄉北埔村7鄰北埔路172號"
}, {
    "POIID": "873385",
    "POIName": "蓮嘉",
    "Telno": "(03)8263127",
    "Address": "花蓮縣新城鄉嘉里村嘉里路155號157號"
}, ], [{
    "POIID": "920320",
    "POIName": "仁禮",
    "Telno": "(03)8514089",
    "Address": "花蓮縣吉安鄉南埔八街223號"
}, {
    "POIID": "120489",
    "POIName": "文景",
    "Telno": "(03)8546457",
    "Address": "花蓮縣吉安鄉中山路2段71-2號"
}, {
    "POIID": "132345",
    "POIName": "吉昌",
    "Telno": "(03)8462435",
    "Address": "花蓮縣吉安鄉吉安路一段114號"
}, {
    "POIID": "954817",
    "POIName": "吉海",
    "Telno": "(03)8423938",
    "Address": "花蓮縣吉安鄉海岸路683號"
}, {
    "POIID": "183804",
    "POIName": "吉濱",
    "Telno": "(03)8421400",
    "Address": "花蓮縣吉安鄉南濱路一段651號"
}, {
    "POIID": "968850",
    "POIName": "姐妹",
    "Telno": "(03)8513232",
    "Address": "花蓮縣吉安鄉吉安路5段262之1號1F"
}, {
    "POIID": "900072",
    "POIName": "東海岸",
    "Telno": "(03)8514741",
    "Address": "花蓮縣吉安鄉海岸路252號254號"
}, {
    "POIID": "952637",
    "POIName": "南濱",
    "Telno": "(03)8529949",
    "Address": "花蓮縣吉安鄉南濱路1段116號"
}, {
    "POIID": "967558",
    "POIName": "富翔",
    "Telno": "(03)8523437",
    "Address": "花蓮縣吉安鄉東昌村海岸路77號"
}, {
    "POIID": "912972",
    "POIName": "慈勝",
    "Telno": "(03)8549692",
    "Address": "花蓮縣吉安鄉自強路52號"
}, {
    "POIID": "188289",
    "POIName": "愛田",
    "Telno": "(03)8462405",
    "Address": "花蓮縣吉安鄉建國路一段200號.202號"
}, {
    "POIID": "160269",
    "POIName": "新福興",
    "Telno": "(03)8524398",
    "Address": "花蓮縣吉安鄉福興村吉安路三段80號82號"
}, {
    "POIID": "968551",
    "POIName": "新蓮盈",
    "Telno": "(03)8563823",
    "Address": "花蓮縣吉安鄉建國路2段285號1F"
}, {
    "POIID": "923019",
    "POIName": "稻香",
    "Telno": "(03)8549982",
    "Address": "花蓮縣吉安鄉稻香村吉興路二段46號"
}, {
    "POIID": "866310",
    "POIName": "蓮吉",
    "Telno": "(03)8527701",
    "Address": "花蓮縣吉安鄉中山路3段423號"
}, {
    "POIID": "173748",
    "POIName": "蓮安",
    "Telno": "(03)8528220",
    "Address": "花蓮縣吉安鄉中華路2段5號"
}, {
    "POIID": "151276",
    "POIName": "蓮恆",
    "Telno": "(03)8580885",
    "Address": "花蓮縣吉安鄉北昌村建國路一段51號"
}, {
    "POIID": "151737",
    "POIName": "蓮陽",
    "Telno": "(03)8530422",
    "Address": "花蓮縣吉安鄉吉安村中山路三段2號"
}, ], [{
    "POIID": "126661",
    "POIName": "八悅",
    "Telno": "(03)8664224",
    "Address": "花蓮縣壽豐鄉平和村中華路二段215號"
}, {
    "POIID": "127125",
    "POIName": "大豐田",
    "Telno": "(03)8654091",
    "Address": "花蓮縣壽豐鄉豐山村中山路201號203號1樓"
}, {
    "POIID": "880671",
    "POIName": "志學",
    "Telno": "(03)8661330",
    "Address": "花蓮縣壽豐鄉志學村7鄰中山路3段6號"
}, {
    "POIID": "977924",
    "POIName": "新壽豐",
    "Telno": "(03)8656942",
    "Address": "花蓮縣壽豐鄉中山路5段131號"
}, {
    "POIID": "166821",
    "POIName": "豐坪",
    "Telno": "(03)8653674",
    "Address": "花蓮縣壽豐鄉豐坪村豐坪路二段5之1號1樓"
}, {
    "POIID": "985659",
    "POIName": "豐學",
    "Telno": "(03)8663639",
    "Address": "花蓮縣壽豐鄉平和村大學路2段596號"
}, ], [{
    "POIID": "112824",
    "POIName": "馬太鞍",
    "Telno": "(03)8704315",
    "Address": "花蓮縣光復鄉中山路一段125號"
}, {
    "POIID": "914060",
    "POIName": "蓮富",
    "Telno": "(03)8703949",
    "Address": "花蓮縣光復鄉中山路2段252號"
}, ], [{
    "POIID": "110415",
    "POIName": "豐濱",
    "Telno": "(03)8791893",
    "Address": "花蓮縣豐濱鄉三民村三民路61號1樓"
}, ], [{
    "POIID": "923293",
    "POIName": "瑞繐",
    "Telno": "(03)8876490",
    "Address": "花蓮縣瑞穗鄉中山路1段17號19號"
}, {
    "POIID": "165507",
    "POIName": "瑞權",
    "Telno": "(03)8870277",
    "Address": "花蓮縣瑞穗鄉瑞北路30之2號"
}, ], [{
    "POIID": "943987",
    "POIName": "富鄉",
    "Telno": "(03)8832026",
    "Address": "花蓮縣富里鄉中山路167號"
}, ], [{
    "POIID": "155256",
    "POIName": "天祥",
    "Telno": "(03)8691237",
    "Address": "花蓮縣秀林鄉富世村天祥17之1號"
}, {
    "POIID": "880073",
    "POIName": "太魯閣",
    "Telno": "(03)8611543",
    "Address": "花蓮縣秀林鄉富世村富世路150號152-1號"
}, {
    "POIID": "978260",
    "POIName": "泰雅",
    "Telno": "(03)8681479",
    "Address": "花蓮縣秀林鄉和平村和平街156號"
}, {
    "POIID": "114288",
    "POIName": "崇德盈",
    "Telno": "(03)8621776",
    "Address": "花蓮縣秀林鄉崇德95-6號"
}, ], ], [[{
    "POIID": "181015",
    "POIName": "三越",
    "Telno": "(089)341513",
    "Address": "台東縣台東市中華路一段169.171.173號1樓"
}, {
    "POIID": "160188",
    "POIName": "仁毅",
    "Telno": "(089)239371",
    "Address": "台東縣台東市馬蘭里新生路680號682號684號1樓"
}, {
    "POIID": "179595",
    "POIName": "台東新站",
    "Telno": "(089)235913",
    "Address": "台東市岩灣路101巷598號"
}, {
    "POIID": "132806",
    "POIName": "正東",
    "Telno": "(089)342634",
    "Address": "台東縣台東市中華路一段372號"
}, {
    "POIID": "902296",
    "POIName": "吉川",
    "Telno": "(089)353723",
    "Address": "台東縣台東市豐谷里中華路二段272號"
}, {
    "POIID": "970071",
    "POIName": "成貞",
    "Telno": "(089)236464",
    "Address": "台東縣台東市豐年里中興路三段399號1樓"
}, {
    "POIID": "151232",
    "POIName": "利嘉",
    "Telno": "(089)385164",
    "Address": "台東縣台東市新園里中興路六段667號1樓"
}, {
    "POIID": "143910",
    "POIName": "享溫馨",
    "Telno": "(089)347698",
    "Address": "台東縣台東市中正里中正路308號1樓"
}, {
    "POIID": "174615",
    "POIName": "卑南",
    "Telno": "(089)236153",
    "Address": "台東縣台東市南榮里更生路1267號"
}, {
    "POIID": "143895",
    "POIName": "東大",
    "Telno": "(089)518145",
    "Address": "台東縣台東市大學路二段369號"
}, {
    "POIID": "120685",
    "POIName": "東太陽",
    "Telno": "(089)352313",
    "Address": "台東縣台東市中華路二段753號1樓"
}, {
    "POIID": "180702",
    "POIName": "東安",
    "Telno": "(089)342946",
    "Address": "台東縣台東市杭州街288號1樓"
}, {
    "POIID": "921231",
    "POIName": "東京",
    "Telno": "(089)228238",
    "Address": "台東縣台東市卑南里更生北路198號"
}, {
    "POIID": "110161",
    "POIName": "東佳",
    "Telno": "(089)321888",
    "Address": "台東縣台東市長沙街178號180號182號"
}, {
    "POIID": "914141",
    "POIName": "東定",
    "Telno": "(089)382946",
    "Address": "台東縣台東市豐田里中興路四段406號"
}, {
    "POIID": "160258",
    "POIName": "東昇",
    "Telno": "(089)311100",
    "Address": "台東縣台東市鐵花里中華路一段542號1樓"
}, {
    "POIID": "154585",
    "POIName": "東亮",
    "Telno": "(089)233228",
    "Address": "台東縣台東市連航路88巷31號33號35號1樓"
}, {
    "POIID": "180724",
    "POIName": "東星",
    "Telno": "(089)341581",
    "Address": "台東縣台東市正氣路159.159-1號1樓"
}, {
    "POIID": "872599",
    "POIName": "東航",
    "Telno": "(089)338105",
    "Address": "台東縣台東市民生里更生路270號1F"
}, {
    "POIID": "167053",
    "POIName": "東偕",
    "Telno": "(089)345172",
    "Address": "台東縣台東市長沙街303巷1號"
}, {
    "POIID": "997652",
    "POIName": "東捷",
    "Telno": "(089)326614",
    "Address": "台東縣台東市豐榮里豐盛路1號"
}, {
    "POIID": "873189",
    "POIName": "東盛",
    "Telno": "(089)320745",
    "Address": "台東縣台東市自強里更生路391號"
}, {
    "POIID": "127033",
    "POIName": "東博",
    "Telno": "(089)348476",
    "Address": "台東縣台東市民權里中正路414號418號"
}, {
    "POIID": "155005",
    "POIName": "東喜",
    "Telno": "(089)239543",
    "Address": "台東縣台東市興安路一段197號1樓"
}, {
    "POIID": "888099",
    "POIName": "東漢",
    "Telno": "(089)357252",
    "Address": "台東縣台東市正氣北路182號"
}, {
    "POIID": "131685",
    "POIName": "東廣",
    "Telno": "(089)233676",
    "Address": "台東縣台東市傳廣路496號498號1樓"
}, {
    "POIID": "954574",
    "POIName": "東樂",
    "Telno": "(089)229434",
    "Address": "台東縣台東市山西路一段330號"
}, {
    "POIID": "138077",
    "POIName": "東輝",
    "Telno": "(089)355923",
    "Address": "台東縣台東市正氣北路389號"
}, {
    "POIID": "166382",
    "POIName": "東糖",
    "Telno": "(089)238466",
    "Address": "台東縣台東市中興路二段360號1樓"
}, {
    "POIID": "987736",
    "POIName": "知本",
    "Telno": "(089)516428",
    "Address": "台東縣台東市建興里知本路4段2號"
}, {
    "POIID": "932998",
    "POIName": "冠美",
    "Telno": "(089)342164",
    "Address": "台東縣台東市豐榮里仁昌街148號"
}, {
    "POIID": "991665",
    "POIName": "富岡",
    "Telno": "(089)281726",
    "Address": "台東縣台東市富岡里吉林路2段668號1樓"
}, {
    "POIID": "968078",
    "POIName": "新南王",
    "Telno": "(089)237115",
    "Address": "台東縣台東市更生北路675號677號"
}, {
    "POIID": "990019",
    "POIName": "睿豐",
    "Telno": "(089)510783",
    "Address": "台東縣台東市知本里知本路三段7號1樓"
}, ], [{
    "POIID": "173852",
    "POIName": "欣功",
    "Telno": "(089)854201",
    "Address": "台東縣成功鎮三民里大同路70號"
}, {
    "POIID": "978101",
    "POIName": "欣東旺",
    "Telno": "(089)850230",
    "Address": "台東縣成功鎮忠仁里中華路76號1樓"
}, ], [{
    "POIID": "122957",
    "POIName": "關山",
    "Telno": "(089)812792",
    "Address": "台東縣關山鎮和平路4號4之1號1樓"
}, ], [{
    "POIID": "126476",
    "POIName": "東泉",
    "Telno": "(089)514558",
    "Address": "台東縣卑南鄉溫泉村龍泉路59號"
}, {
    "POIID": "122795",
    "POIName": "東遊季",
    "Telno": "(089)511046",
    "Address": "台東縣卑南鄉溫泉路388號"
}, {
    "POIID": "163958",
    "POIName": "初鹿",
    "Telno": "(089)570709",
    "Address": "台東縣卑南鄉明峰村忠孝路164號166號168號"
}, ], [{
    "POIID": "126339",
    "POIName": "新鹿野",
    "Telno": "(089)550209",
    "Address": "台東縣鹿野鄉鹿野村中華路一段430號"
}, ], [{
    "POIID": "110677",
    "POIName": "池上",
    "Telno": "(089)865774",
    "Address": "台東縣池上鄉大埔村中山路64號1樓"
}, {
    "POIID": "142825",
    "POIName": "東馳",
    "Telno": "(089)862291",
    "Address": "台東縣池上鄉中東三路46號1樓"
}, ], [{
    "POIID": "952833",
    "POIName": "東河",
    "Telno": "(089)896515",
    "Address": "台東縣東河鄉東河村南東河263號1樓"
}, {
    "POIID": "892962",
    "POIName": "都蘭",
    "Telno": "(089)530439",
    "Address": "台東縣東河鄉都蘭村都蘭155號"
}, ], [{
    "POIID": "150826",
    "POIName": "長濱",
    "Telno": "(089)832918",
    "Address": "台東縣長濱鄉長濱村長濱路2-5號"
}, ], [{
    "POIID": "154057",
    "POIName": "東和美",
    "Telno": "(089)512605",
    "Address": "台東縣太麻里鄉三和村大中寮路68之6號"
}, {
    "POIID": "163796",
    "POIName": "金倫",
    "Telno": "(089)771739",
    "Address": "台東縣太麻里鄉金崙村金崙路262號262-1號"
}, {
    "POIID": "130028",
    "POIName": "新太麻里",
    "Telno": "(089)780351",
    "Address": "台東縣太麻里鄉泰和村外環路128號1樓"
}, ], [{
    "POIID": "153928",
    "POIName": "大武",
    "Telno": "(089)792722",
    "Address": "台東縣大武鄉復興路124號126號128號1樓"
}, {
    "POIID": "940472",
    "POIName": "尚武",
    "Telno": "(089)792406",
    "Address": "台東縣大武鄉尚武村環港路3號"
}, ], [{
    "POIID": "942973",
    "POIName": "綠島",
    "Telno": "(089)671387",
    "Address": "台東縣綠島鄉南寮村南寮路139號"
}, ], [{
    "POIID": "120076",
    "POIName": "安朔",
    "Telno": "(08)9702085",
    "Address": "台東縣達仁鄉森永村森永216號"
}, ], [{
    "POIID": "167754",
    "POIName": "東清灣",
    "Telno": "(089)732917",
    "Address": "台東縣蘭嶼鄉東清村東清路7號"
}, {
    "POIID": "142892",
    "POIName": "蘭嶼",
    "Telno": "(089)731061",
    "Address": "台東縣蘭嶼鄉椰油村椰油296之12號"
}, ], ], [[{
    "POIID": "941833",
    "POIName": "井垵",
    "Telno": "(06)9952551",
    "Address": "澎湖縣馬公市井垵里1-18號"
}, {
    "POIID": "892571",
    "POIName": "天人菊",
    "Telno": "(06)9275471",
    "Address": "澎湖縣馬公市中央里仁愛路69號"
}, {
    "POIID": "922201",
    "POIName": "文光",
    "Telno": "(06)9276453",
    "Address": "澎湖縣馬公市光榮里三多路338號"
}, {
    "POIID": "120467",
    "POIName": "文澳",
    "Telno": "(06)9217471",
    "Address": "澎湖縣馬公市文山路53號1樓"
}, {
    "POIID": "909574",
    "POIName": "石泉",
    "Telno": "(06)9219740",
    "Address": "澎湖縣馬公市石泉里1-300號"
}, {
    "POIID": "981750",
    "POIName": "百麗",
    "Telno": "(06)9218974",
    "Address": "澎湖縣馬公市東文里新店路463號1號"
}, {
    "POIID": "900762",
    "POIName": "西衛",
    "Telno": "(06)9276457",
    "Address": "澎湖縣馬公市光榮里光復路297號"
}, {
    "POIID": "113883",
    "POIName": "東衛",
    "Telno": "(06)9217554",
    "Address": "澎湖縣馬公市東衛里19鄰9之2號"
}, {
    "POIID": "987806",
    "POIName": "馬公",
    "Telno": "(06)9267402",
    "Address": "澎湖縣馬公市光復路59號"
}, {
    "POIID": "113506",
    "POIName": "揚光",
    "Telno": "(069)267812",
    "Address": "澎湖縣馬公市陽明里中華路175號1樓"
}, {
    "POIID": "930545",
    "POIName": "新台澎",
    "Telno": "(06)9263856",
    "Address": "澎湖縣馬公市中正路85號"
}, {
    "POIID": "901891",
    "POIName": "新澎湖",
    "Telno": "(06)9260715",
    "Address": "澎湖縣馬公市重慶里民權路98號"
}, {
    "POIID": "153892",
    "POIName": "澎文",
    "Telno": "(06)9211440",
    "Address": "澎湖縣馬公市東文里文山路282號"
}, {
    "POIID": "941202",
    "POIName": "澎技",
    "Telno": "(06)9264367",
    "Address": "澎湖縣馬公市朝陽里三多路45號"
}, {
    "POIID": "142869",
    "POIName": "澎衛",
    "Telno": "(069)264241",
    "Address": "澎湖縣馬公市西衛里光復路408號"
}, {
    "POIID": "166740",
    "POIName": "澎興",
    "Telno": "(06)9218960",
    "Address": "澎湖縣馬公市興仁里雙掛頭1之2號"
}, {
    "POIID": "880590",
    "POIName": "澎灣",
    "Telno": "(06)9275472",
    "Address": "澎湖縣馬公市中華路56號"
}, {
    "POIID": "151391",
    "POIName": "鎖港",
    "Telno": "(06)9953089",
    "Address": "澎湖縣馬公市鎖港里鎖管港段1439號"
}, ], [{
    "POIID": "911083",
    "POIName": "永興順",
    "Telno": "(06)9228176",
    "Address": "澎湖縣湖西鄉隘門34之2號"
}, {
    "POIID": "181750",
    "POIName": "馬航",
    "Telno": "(06)9228847",
    "Address": "澎湖縣湖西鄉隘門村126之5號1樓(馬公航空站一樓航廈)"
}, {
    "POIID": "130095",
    "POIName": "湖西",
    "Telno": "(069)923256",
    "Address": "澎湖縣湖西鄉湖西村湖西140之1號"
}, ], [{
    "POIID": "900795",
    "POIName": "白沙",
    "Telno": "(06)9932930",
    "Address": "澎湖縣白沙鄉赤崁村20鄰大赤崁351號1樓"
}, ], [{
    "POIID": "188201",
    "POIName": "跨海",
    "Telno": "(06)9983218",
    "Address": "澎湖縣西嶼鄉合界村3-1號"
}, {
    "POIID": "951106",
    "POIName": "漁翁",
    "Telno": "(06)9981838",
    "Address": "澎湖縣西嶼鄉外垵村113號"
}, ], [{
    "POIID": "153869",
    "POIName": "七美",
    "Telno": "(069)971382",
    "Address": "澎湖縣七美鄉南港村南滬50號51號"
}, ], ], [[{
    "POIID": "991322",
    "POIName": "中隴",
    "Telno": "(083)623397",
    "Address": "連江縣南竿鄉介壽村3鄰48-2號"
}, {
    "POIID": "950376",
    "POIName": "南竿",
    "Telno": "(083)626711",
    "Address": "連江縣南竿鄉清水村100號"
}, {
    "POIID": "132839",
    "POIName": "馬祖",
    "Telno": "(083)622930",
    "Address": "連江縣南竿鄉介壽村215號1樓"
}, {
    "POIID": "952512",
    "POIName": "馬港",
    "Telno": "(083)625492",
    "Address": "連江縣南竿鄉馬祖村中山路58號60號"
}, {
    "POIID": "126708",
    "POIName": "福澳港",
    "Telno": "(083)623134",
    "Address": "連江縣南竿鄉福澳村129號部份"
}, ], [{
    "POIID": "952523",
    "POIName": "北竿",
    "Telno": "(083)656492",
    "Address": "連江縣北竿鄉塘岐村中山路193號195號"
}, {
    "POIID": "180539",
    "POIName": "坪里",
    "Telno": "(083)656338",
    "Address": "連江縣北竿鄉坂里村42號1樓"
}, ], [{
    "POIID": "123536",
    "POIName": "東引",
    "Telno": "(083)677011",
    "Address": "連江縣東引鄉中柳村85與86號1樓"
}, ], ], [[{
    "POIID": "116206",
    "POIName": "金冠",
    "Telno": "(082)337687",
    "Address": "金門縣金湖鎮環島南路湖前段2號4號"
}, {
    "POIID": "142858",
    "POIName": "風獅爺",
    "Telno": "(082)322424",
    "Address": "金門縣金湖鎮瓊林里中山路8之6號1樓"
}, {
    "POIID": "923651",
    "POIName": "新山外",
    "Telno": "(082)337068",
    "Address": "金門縣金湖鎮山外里復興西路2號"
}, {
    "POIID": "970037",
    "POIName": "新再發",
    "Telno": "(082)334313",
    "Address": "金門縣金湖鎮復興路8號10號"
}, ], [{
    "POIID": "183871",
    "POIName": "中蘭",
    "Telno": "(082)354616",
    "Address": "金門縣金沙鎮環島北路三段482號"
}, {
    "POIID": "970059",
    "POIName": "新沙美",
    "Telno": "(082)355723",
    "Address": "金門縣金沙鎮汶沙里國中路2號"
}, ], [{
    "POIID": "891970",
    "POIName": "金民",
    "Telno": "(082)371207",
    "Address": "金門縣金城鎮民生路6號"
}, {
    "POIID": "186146",
    "POIName": "金生",
    "Telno": "(082)322784",
    "Address": "金門縣金城鎮西門里民生路67.69號"
}, {
    "POIID": "992705",
    "POIName": "金石",
    "Telno": "(082)323642",
    "Address": "金門縣金城鎮民權路192號196號1樓"
}, {
    "POIID": "903130",
    "POIName": "金東",
    "Telno": "(082)372550",
    "Address": "金門縣金城鎮東門里民族路7號"
}, {
    "POIID": "882921",
    "POIName": "金亮",
    "Telno": "(082)371831",
    "Address": "金門縣金城鎮南門里民權路75號"
}, {
    "POIID": "981598",
    "POIName": "金豪",
    "Telno": "(082)322471",
    "Address": "金門縣金城鎮西海路三段1號3號5號1樓"
}, {
    "POIID": "152051",
    "POIName": "金誼",
    "Telno": "(082)373859",
    "Address": "金門縣金城鎮南門里浯江北堤路100號"
}, ], [{
    "POIID": "142087",
    "POIName": "金央",
    "Telno": "(082)321424",
    "Address": "金門縣金寧鄉伯玉路一段222之8號1樓"
}, {
    "POIID": "970820",
    "POIName": "金寧",
    "Telno": "(082)321534",
    "Address": "金門縣金寧鄉環島北路1段711號"
}, ], [{
    "POIID": "173977",
    "POIName": "小金",
    "Telno": "(082)364895",
    "Address": "金門縣烈嶼鄉林湖村東林路156號"
}, ], ], ];


export default {
    area_city,
    area_district,
    area_store
}